const fr: Record<string, string> = {
  "backoffice.content.licence_type": "Type de licence",
  "backoffice.content.ai_reason_placeholder":
    "p. ex. SUP-1182 · la politique du client interdit l’IA",
  "backoffice.content.first_release": "Première version",
  "backoffice.content.coming_soon": "À venir",
  "backoffice.content.reason_change": "Motif du changement (obligatoire)",
  "backoffice.content.saved_audit": "Enregistré et consigné dans le journal d’audit",
  "backoffice.content.no_changes": "Aucun changement récent",
  "backoffice.content.read_error": "Impossible de charger ce contenu.",
  "backoffice.content.read_only": "La modification sera disponible à la phase 6.",
  "backoffice.content.first_name": "Prénom",
  "backoffice.content.last_name": "Nom",
  "backoffice.content.owner_role_note":
    "Cette personne est propriétaire de l’espace de travail; seuls les rôles de niveau Admin peuvent être choisis.",
  "backoffice.content.role_licence": "Type de licence : {licence} (défini par le rôle).",
  "backoffice.content.account_actions": "Actions du compte",
  "backoffice.content.account_actions_note":
    "Utilisez ces actions si le courriel d’invitation ou de confirmation n’arrive pas. Chaque action exige un motif et est consignée dans le journal d’audit.",
  "backoffice.content.deactivate_note":
    "La désactivation libère la place. Le compte pourra être réactivé plus tard.",
  "backoffice.content.no_teams": "Aucune équipe",
  "backoffice.content.no_roles": "Aucun rôle système",
  "backoffice.content.edit_team": "Modifier l’équipe : {name}",
  "backoffice.content.team_name": "Nom de l’équipe",
  "backoffice.content.parent_team": "Équipe parente",
  "backoffice.content.top_level": "Aucune (premier niveau)",
  "backoffice.content.leads": "Responsables d’équipe",
  "backoffice.content.no_lead": "Aucun responsable",
  "backoffice.content.members": "Membres ({count})",
  "backoffice.content.team_lead": "Responsable d’équipe",
  "backoffice.content.team_delete_note":
    "Les équipes peuvent seulement être supprimées dans l’application, où les règles d’équipe principale des projets et demandes s’appliquent.",
  "backoffice.content.system_roles": "Rôles système",
  "backoffice.content.roles_body":
    "Les rôles configurés dans cet espace de travail. Les rôles Cognota par défaut sont verrouillés : dupliquez-en un pour le personnaliser.",
  "backoffice.content.role": "Rôle",
  "backoffice.content.source": "Source",
  "backoffice.content.licence_tier": "Niveau de licence",
  "backoffice.content.edit_role": "Modifier le rôle",
  "backoffice.content.role_name": "Nom du rôle",
  "backoffice.content.managed": "Géré par Cognota",
  "backoffice.content.role_tier_note":
    "Le niveau de licence limite les autorisations du rôle. Admin et Standard utilisent une place.",
  "backoffice.content.group.Requests": "Demandes",
  "backoffice.content.group.Projects & programs": "Projets et programmes",
  "backoffice.content.group.Dashboards": "Tableaux de bord",
  "backoffice.content.group.Workspace settings": "Paramètres de l’espace de travail",
  "backoffice.roles.new": "Nouveau rôle",
  "backoffice.roles.new_title": "Nouveau rôle",
  "backoffice.roles.new_body":
    "Choisissez d’abord le niveau de licence : il est fixé une fois le rôle créé.",
  "backoffice.roles.create_confirm": "Créer le rôle",
  "backoffice.roles.save_confirm": "Enregistrer le rôle",
  "backoffice.roles.duplicate": "Dupliquer",
  "backoffice.roles.duplicate_title": "Dupliquer {name}",
  "backoffice.roles.duplicate_body":
    "Crée une copie personnalisée que vous pouvez modifier. Elle ne compte aucun utilisateur au départ. Le niveau de licence de la copie peut différer, mais elle ne peut alors contenir que les autorisations de ce niveau.",
  "backoffice.roles.duplicate_confirm": "Dupliquer le rôle",
  "backoffice.roles.edit": "Modifier {name}",
  "backoffice.roles.delete": "Supprimer le rôle",
  "backoffice.roles.delete_title": "Supprimer {name}",
  "backoffice.roles.delete_body":
    "Supprime ce rôle personnalisé. Cette action est irréversible et le rôle ne doit avoir aucun utilisateur.",
  "backoffice.roles.delete_confirm": "Supprimer le rôle",
  "backoffice.roles.delete_guard":
    "Un rôle ne peut pas être supprimé tant que des personnes le détiennent : déplacez d’abord ses {count} utilisateurs.",
  "backoffice.roles.audit_note":
    "Les modifications s’appliquent à tous les membres du rôle et sont consignées dans le journal d’audit.",
  "backoffice.roles.tier_fixed": "Le niveau de licence d’un rôle est fixé une fois le rôle créé.",
  "backoffice.roles.needs_tier": "{name} · nécessite le niveau {tier}",
  "backoffice.roles.permissions_error": "Impossible de charger les autorisations.",
  "backoffice.roles.read_only": "Vous pouvez consulter les rôles, mais pas les modifier.",
  "backoffice.roles.locked_note":
    "Les rôles par défaut de Cognota sont verrouillés. Dupliquez-en un pour le personnaliser.",
  "backoffice.content.super_admin": "Super Admin seulement",
  "backoffice.content.current": "Actuel",
  "backoffice.content.change_to": "Changer pour",
  "backoffice.lifecycle.save": "Enregistrer",
  "backoffice.lifecycle.deleted": "Espace de travail supprimé.",
  "backoffice.lifecycle.read_only":
    "Seuls les CS/AM et les super administrateurs peuvent modifier le cycle de vie de l’espace de travail.",
  "backoffice.lifecycle.delete_read_only":
    "Seul un super administrateur peut supprimer un espace de travail.",
  "backoffice.lifecycle.past_expiry":
    "Une date passée est autorisée. La démo sera archivée dans l’heure.",
  "backoffice.lifecycle.new_expiry": "Nouvelle date d’expiration (obligatoire si la démo a expiré)",
  "backoffice.lifecycle.new_expiry_required": "Nouvelle date d’expiration (obligatoire)",
  "backoffice.content.phase7": "Pas encore disponible (phase 7).",
  "backoffice.content.status": "Statut",
  "backoffice.content.suspend": "Suspendre",
  "backoffice.content.archive": "Archiver",
  "backoffice.content.reactivate": "Réactiver",
  "backoffice.content.suspend_body":
    "Personne ne peut se connecter. Toutes les données sont conservées et l’espace de travail peut être réactivé à tout moment.",
  "backoffice.content.archive_body":
    "Masqué pour les membres et exclu du calcul des places. Les données sont conservées.",
  "backoffice.content.reactivate_body":
    "Disponible lorsque l’espace de travail est suspendu ou archivé.",
  "backoffice.content.suspend_action": "Suspendre l’espace de travail",
  "backoffice.content.archive_action": "Archiver l’espace de travail",
  "backoffice.content.demo_expiry": "Expiration de la démo",
  "backoffice.content.demo_body":
    "Seulement pour les espaces Démo (Ventes). Après cette date, la démo est automatiquement archivée.",
  "backoffice.content.expires_on": "Expire le",
  "backoffice.content.delete": "Supprimer l’espace de travail",
  "backoffice.content.delete_body":
    "Supprime définitivement l’espace de travail et toutes ses données. Cette action est irréversible. Saisissez le nom URL {slug} pour confirmer.",
  "backoffice.content.url_name": "Nom URL de l’espace de travail",

  "backoffice.users.cognota_support": "Assistance Cognota",
  // Backoffice workspace tabs (NG-3421)
  "backoffice.workspace.breadcrumb": "Fil d’Ariane",
  "backoffice.workspace.tabs": "Sections de l’espace de travail",
  "backoffice.workspace.region_us": "Région États-Unis",
  "backoffice.workspace.facts": "Détails de l’espace de travail",
  "backoffice.workspace.setup_count": "{count} utilisateurs configurés par Cognota",
  "backoffice.workspace.other_controls": "Autres paramètres de fonctionnalités",
  "backoffice.workspace.phase_two": "Phase 2",
  "backoffice.workspace.other_controls_body":
    "Objectifs · Notifications Microsoft Teams · 360Learning · Partage de tableaux de bord · Importations CSV · Rôles système personnalisés · Webhooks. Ces fonctionnalités sont actuellement activées ou désactivées pour tous les espaces de travail à la fois.",
  "backoffice.workspace.recent_changes": "Modifications récentes",
  "backoffice.workspace.view_audit": "Voir le journal d’audit",
  "backoffice.workspace.audit_search_body":
    "Consultez le journal d’audit filtré pour cet espace de travail.",
  "backoffice.workspace.not_available": "Pas encore disponible",
  "backoffice.workspace.tab.overview": "Vue d’ensemble",
  "backoffice.workspace.tab.features": "Fonctionnalités",
  "backoffice.workspace.tab.users": "Utilisateurs",
  "backoffice.workspace.tab.roles": "Rôles",
  "backoffice.workspace.tab.teams": "Équipes",
  "backoffice.workspace.tab.lifecycle": "Type et cycle de vie",
  "backoffice.workspace.tab.audit": "Audit",
  "backoffice.users.edit": "Modifier l’utilisateur",
  "backoffice.users.edit_for": "Modifier l’utilisateur {email}",
  "backoffice.users.edit_loading": "Chargement de l’utilisateur…",
  "backoffice.users.edit_load_error": "Les détails de l’utilisateur n’ont pas pu être chargés.",
  "backoffice.users.edit_name_note":
    "Le nom appartient au compte de la personne : il est identique dans tous les espaces de travail où elle se trouve.",
  "backoffice.users.edit_name_required": "Saisissez un prénom ou un nom.",
  "backoffice.users.edit_add_team": "Ajouter à une équipe…",
  "backoffice.users.edit_remove_team": "Retirer de {team}",
  "backoffice.users.edit_undo_add_team": "Ne pas ajouter à {team}",
  "backoffice.users.edit_keep_team": "Garder dans {team}",
  "backoffice.users.edit_save": "Enregistrer les modifications",
  "backoffice.users.edit_confirm.title": "Enregistrer les modifications de {email}",
  "backoffice.users.edit_confirm.confirm": "Enregistrer les modifications",
  "backoffice.users.edit_confirm.name": "Modifier le nom",
  "backoffice.users.edit_confirm.role": "Changer le rôle système en {role}",
  "backoffice.users.edit_confirm.added": "Ajouter à {teams}",
  "backoffice.users.edit_confirm.removed": "Retirer de {teams}",
  "backoffice.users.panel_body":
    "Les actions sur le compte nécessitent un motif et sont consignées dans le journal d’audit.",
  "backoffice.users.invitations": "Invitations",
  "backoffice.provision.emails_checked": "Vérification des courriels des administrateurs terminée",
  "backoffice.provision.emails_checking": "Vérification des courriels des administrateurs…",

  // Backoffice provisioning (NG-3422)
  "backoffice.provision.subtitle":
    "Créez un espace de travail pour un client et préparez-le avant sa connexion.",
  "backoffice.provision.steps": "Étapes",
  "backoffice.provision.form": "Formulaire de création d’un espace de travail",
  "backoffice.provision.step_basics": "Compte et renseignements de base",
  "backoffice.provision.step_content": "Contenu initial",
  "backoffice.provision.step_features": "Fonctionnalités",
  "backoffice.provision.step_dates": "Dates",
  "backoffice.provision.step_admins": "Premier administrateur",
  "backoffice.provision.step_review": "Vérification",
  "backoffice.provision.account_mode": "Sélection du compte",
  "backoffice.provision.existing_account": "Compte existant",
  "backoffice.provision.account": "Compte",
  "backoffice.provision.basics": "Renseignements de base",
  "backoffice.provision.name": "Nom de l’espace de travail",
  "backoffice.provision.cs_owner": "Responsable de la réussite client",
  "backoffice.provision.slug": "URL de l’espace de travail",
  "backoffice.provision.pick": "Sélectionner une option",
  "backoffice.provision.slug_warning":
    "L’URL ne peut pas être modifiée après la création. Par convention, les URL des bacs à sable se terminent par -sandbox.",
  "backoffice.provision.slug_checking": "Vérification de la disponibilité de l’URL…",
  "backoffice.provision.slug_available": "L’URL est disponible",
  "backoffice.provision.slug_invalid": "Saisissez un identifiant d’URL valide et non réservé.",
  "backoffice.provision.slug_taken": "Cette URL est déjà utilisée.",
  "backoffice.provision.slug_required":
    "Attendez la confirmation de disponibilité de l’URL avant de continuer.",
  "backoffice.provision.suggest_sandbox": "Utiliser {slug}",
  "backoffice.provision.type": "Type d’espace de travail",
  "backoffice.provision.type_customer_production":
    "L’espace de travail actif du client. Aucun badge dans l’application.",
  "backoffice.provision.type_customer_sandbox":
    "Pour tester la configuration avant le déploiement. Badge : Bac à sable.",
  "backoffice.provision.type_trial":
    "Une évaluation à durée limitée pour un prospect. Badge : Essai.",
  "backoffice.provision.type_demo_sales":
    "Pour les démonstrations de vente. Peut être réinitialisé et redaté, et expire. Badge : Démo.",
  "backoffice.provision.type_internal":
    "Pour les tests et la formation de Cognota. Badge : Interne.",
  "backoffice.provision.seats_counted": "Compte dans les licences utilisées",
  "backoffice.provision.seats_not_counted": "Non comptabilisé",
  "backoffice.provision.region": "Région",
  "backoffice.provision.timezone": "Fuseau horaire",
  "backoffice.provision.content_blank": "Vide",
  "backoffice.provision.content_blank_body":
    "Rôles par défaut et structure seulement. Aucun contenu exemple.",
  "backoffice.provision.content_starter": "Modèle de démarrage Cognota",
  "backoffice.provision.content_starter_body":
    "Formulaires de demande, flux de travail et rôles par défaut.",
  "backoffice.provision.content_sales_demo": "Scénario de démonstration de vente",
  "backoffice.provision.content_sales_demo_body":
    "Le contenu de démonstration est préparé en arrière-plan. Tous les premiers administrateurs conservent leur accès.",
  "backoffice.provision.content_unavailable":
    "Ce contenu initial n’est pas disponible dans cet environnement.",
  "backoffice.provision.content_invalid":
    "Le contenu de démonstration de vente exige le type Démo (Ventes).",
  "backoffice.provision.suppression": "Supprimer les notifications par courriel",
  "backoffice.provision.suppression_body":
    "Activé par défaut pour Production et Bac à sable. Les invitations sont envoyées au moment choisi.",
  "backoffice.provision.from_account": "Du compte",
  "backoffice.provision.overridden": "Remplacé",
  "backoffice.provision.override_start": "Remplacer le début du contrat du compte",
  "backoffice.provision.override_end": "Remplacer la fin du contrat du compte",
  "backoffice.provision.account_date": "Du compte : {date}",
  "backoffice.provision.not_set": "Non défini",
  "backoffice.provision.expiry": "Date d’expiration",
  "backoffice.provision.expiry_required_label": "Date d’expiration (obligatoire pour Démo)",
  "backoffice.provision.admins_body":
    "Les personnes qui administreront cet espace. Chacune reçoit le rôle Administrateur des opérations. La première devient propriétaire de l’espace.",
  "backoffice.provision.admin_number": "Administrateur {number}",
  "backoffice.provision.first_name": "Prénom",
  "backoffice.provision.last_name": "Nom de famille",
  "backoffice.provision.email": "Courriel professionnel",
  "backoffice.provision.password": "Mot de passe temporaire",
  "backoffice.provision.add_admin": "Ajouter un autre administrateur",
  "backoffice.provision.remove_admin": "Retirer l’administrateur",
  "backoffice.provision.existing_email":
    "Cette personne possède déjà un compte. L’option Ne pas envoyer n’est pas disponible; retenir l’invitation ne retarde pas son accès.",
  "backoffice.provision.timing": "Quand envoyer l’invitation ?",
  "backoffice.provision.timing_send_now": "Envoyer maintenant",
  "backoffice.provision.timing_send_now_body":
    "L’administrateur reçoit l’invitation dès la création de l’espace.",
  "backoffice.provision.timing_hold": "Retenir jusqu’à la date de mise en service",
  "backoffice.provision.timing_hold_body":
    "Configurez d’abord l’espace. L’invitation sera envoyée automatiquement à cette date.",
  "backoffice.provision.timing_dont_send": "Ne pas envoyer — configuration par Cognota",
  "backoffice.provision.timing_dont_send_body":
    "Définissez un mot de passe temporaire pour chaque administrateur. Transférez son accès plus tard.",
  "backoffice.provision.go_live": "Date de mise en service",
  "backoffice.provision.hold_warning":
    "Les invitations sont envoyées à 8 h dans le fuseau horaire de l’espace. Les personnes ayant déjà un compte voient l’espace immédiatement.",
  "backoffice.provision.seats": "Licences",
  "backoffice.provision.seat_effect": "Utilisation des licences pour ce type",
  "backoffice.provision.seats_summary": "Partagées avec le compte : {used} / {allocated} utilisées",
  "backoffice.provision.owner_role": "Administrateur des opérations · Propriétaire de l’espace",
  "backoffice.provision.admin_role": "Administrateur des opérations",
  "backoffice.provision.password_set": "Mot de passe temporaire fourni",
  "backoffice.provision.back": "Retour",
  "backoffice.provision.cancel": "Annuler",
  "backoffice.provision.next": "Continuer",
  "backoffice.provision.create": "Créer l’espace de travail",
  "backoffice.provision.creating_short": "Création…",
  "backoffice.provision.creating":
    "Création de l’espace, ajout des administrateurs et préparation du contenu. Cette opération peut prendre quelques secondes…",
  "backoffice.provision.loading": "Chargement…",
  "backoffice.provision.so_far": "Jusqu’à présent",
  "backoffice.provision.on": "Activé",
  "backoffice.provision.off": "Désactivé",
  "backoffice.provision.account_required":
    "Sélectionnez un compte existant ou saisissez un nouveau nom de compte.",
  "backoffice.provision.basics_required":
    "Saisissez le nom, l’URL et le fuseau horaire, puis sélectionnez un type.",
  "backoffice.provision.timezone_invalid":
    "Saisissez un fuseau horaire IANA valide, comme America/New_York.",
  "backoffice.provision.options_required":
    "Attendez le chargement de la région et du répertoire du personnel, ou réessayez la requête échouée.",
  "backoffice.provision.expiry_required": "Le type Démo (Ventes) exige une date d’expiration.",
  "backoffice.provision.dates_invalid":
    "La fin du contrat doit être égale ou postérieure à son début.",
  "backoffice.provision.admins_required":
    "Ajoutez au moins un administrateur avec un prénom, un nom et un courriel professionnel valide.",
  "backoffice.provision.admins_duplicate":
    "Chaque premier administrateur doit avoir une adresse courriel différente.",
  "backoffice.provision.password_rules": "Règles du mot de passe",
  "backoffice.provision.password_check_required":
    "Vérifiez et corrigez le mot de passe de chaque administrateur avant de continuer.",
  "backoffice.provision.password_checking": "Vérification du mot de passe…",
  "backoffice.provision.password_valid": "Le mot de passe respecte les règles de la plateforme",
  "backoffice.provision.password_invalid": "Corrigez les règles indiquées ci-dessus.",
  "backoffice.provision.password_failed": "La vérification a échoué. Réessayez avant de continuer.",
  "backoffice.provision.rule_password_too_short": "Au moins 8 caractères",
  "backoffice.provision.rule_password_entirely_numeric": "Ne contient pas uniquement des chiffres",
  "backoffice.provision.rule_password_too_common": "N’est pas un mot de passe courant",
  "backoffice.provision.rule_password_too_similar": "Différent du nom et de l’adresse courriel",
  "backoffice.provision.rule_password_breached": "Absent des violations de données connues",
  "backoffice.provision.rule_met": "Respectée",
  "backoffice.provision.rule_unmet": "Non respectée",
  "backoffice.provision.rule_pending": "Non vérifiée",
  "backoffice.provision.password_required":
    "Saisissez un mot de passe temporaire pour chaque administrateur avec l’option Ne pas envoyer.",
  "backoffice.provision.go_live_required":
    "Sélectionnez une date de mise en service pour les invitations retenues.",
  "backoffice.provision.reason_required": "Saisissez une raison avant de créer l’espace.",
  "backoffice.provision.email_check_required":
    "Attendez la vérification des courriels des comptes, ou réessayez la requête échouée.",
  "backoffice.provision.email_has_account":
    "L’option Ne pas envoyer ne peut pas être utilisée pour une personne ayant déjà un compte. Choisissez un autre moment d’envoi.",
  "backoffice.provision.outcome": "Résultat de la création",
  "backoffice.provision.created": "Espace de travail créé",
  "backoffice.provision.invites_sent": "Invitations des premiers administrateurs envoyées.",
  "backoffice.provision.invites_held": "Les invitations seront envoyées le {date}.",
  "backoffice.provision.invites_none": "Aucune invitation envoyée — configuration par Cognota.",
  "backoffice.provision.admin_status_set_up_by_cognota": "Configuration par Cognota",
  "backoffice.provision.admin_status_invited": "Invité",
  "backoffice.provision.admin_status_added": "Ajouté",
  "backoffice.provision.admin_status_added_invite_held": "Ajouté · invitation retenue",
  "backoffice.provision.content_status_ready": "Le contenu initial est prêt.",
  "backoffice.provision.content_status_loading":
    "Le contenu de démonstration est en cours de préparation. Actualisez pour vérifier sa progression.",
  "backoffice.provision.content_status_failed":
    "La préparation du contenu de démonstration a échoué. L’espace et les administrateurs ont été créés; réessayez le contenu.",
  "backoffice.provision.refresh": "Actualiser le statut",
  "backoffice.provision.retry_content": "Réessayer le contenu",

  // App
  "app.title": "Cognota Next Gen",

  // Browser tab titles (NG-2759)
  "page_title.programs": "Programmes",
  "page_title.projects": "Projets",
  "page_title.program_fallback": "Programme",
  "page_title.project_fallback": "Projet",

  // Scope picker and workspace MCP access (NG-2585)
  "scope_picker.category.identity": "Identité",
  "scope_picker.category.workspace": "Métadonnées de l'espace de travail",
  "scope_picker.category.work_items": "Éléments de travail",
  "scope_picker.category.projects": "Projets",
  "scope_picker.category.requests": "Demandes",
  "scope_picker.category.programs": "Programmes",
  "scope_picker.category.goals": "Objectifs",
  "scope_picker.category.events": "Événements",
  "scope_picker.category.calendar": "Calendrier",
  "scope_picker.category.users": "Membres",
  "scope_picker.category.teams": "Équipes",
  "scope_picker.category.qualifications": "Qualifications",
  "scope_picker.category.workspace_configuration": "Configuration de l'espace de travail",
  "scope_picker.category.other": "Autre",
  "scope_picker.loading": "Chargement du catalogue de portées…",
  "scope_picker.empty": "Aucune portée disponible.",
  "scope_picker.mcp_warning_title": "L'IA peut se tromper.",
  "scope_picker.mcp_warning_body":
    "Ces portées permettent à un client IA de créer, modifier ou supprimer des données dans cet espace de travail au nom d'un membre. Vérifiez attentivement avant d'enregistrer.",
  "scope_picker.col_scope": "Portée",
  "scope_picker.col_allowed": "Autorisée",
  "scope_picker.col_default": "Par défaut",
  "scope_picker.always_granted": "Toujours accordée",
  "scope_picker.destructive_aria": "Portée destructive",
  "scope_picker.destructive_tooltip":
    "Cette portée permet de créer, modifier ou supprimer des données dans l'espace de travail.",
  "scope_picker.modifies_data": "modifie des données",
  "scope_picker.default_aria": "{name} par défaut",
  "workspace_mcp.loading": "Chargement de l'accès MCP…",
  "workspace_mcp.title": "Accès des clients IA (MCP)",
  "workspace_mcp.description":
    "Permettez aux membres de l'espace de travail de connecter Claude, ChatGPT et d'autres outils d'IA compatibles MCP à cet espace de travail. Les portées autorisées ici sont un plafond : les membres choisissent les mêmes ou moins lorsqu'ils se connectent.",
  "workspace_mcp.status_on": "Activé",
  "workspace_mcp.status_off": "Désactivé",
  "workspace_mcp.configure_scopes": "Configurer les portées",
  "workspace_mcp.disabling": "Désactivation…",
  "workspace_mcp.disable": "Désactiver",
  "workspace_mcp.enable": "Activer l'accès MCP",
  "workspace_mcp.clients_show": "Afficher les clients connectés ({countText})",
  "workspace_mcp.clients_hide": "Masquer les clients connectés ({countText})",
  "workspace_mcp.clients_help":
    "Chaque entrée est une installation de client IA autorisée par un membre de cet espace de travail. La révocation la retire de l'espace de travail jusqu'à un nouveau consentement.",
  "workspace_mcp.load_error": "Impossible de charger l'accès MCP.",
  "workspace_mcp.save_error": "Impossible d'enregistrer l'accès MCP.",
  "workspace_mcp.disable_error": "Impossible de désactiver l'accès MCP.",
  "workspace_mcp.revoke_error": "Impossible de révoquer le client.",
  "workspace_mcp.clients.empty":
    "Aucun client IA n'est encore connecté. Les membres peuvent se connecter en collant l'URL MCP dans Claude, ChatGPT ou un autre client compatible MCP.",
  "workspace_mcp.clients.self_declared": "(auto-déclaré)",
  "workspace_mcp.clients.expired_title":
    "Aucun jeton d'actualisation actif. L'utilisateur doit se reconnecter pour réactiver cette autorisation.",
  "workspace_mcp.clients.expired": "Expiré",
  "workspace_mcp.clients.connected_by": "Connecté par {name}",
  "workspace_mcp.clients.last_used": "dernière utilisation",
  "workspace_mcp.clients.scopes_label": "Portées :",
  "workspace_mcp.clients.revoking": "Révocation…",
  "workspace_mcp.clients.revoke": "Révoquer",
  "workspace_mcp.ceiling.title": "Ce que les clients IA peuvent faire dans cet espace de travail",
  "workspace_mcp.ceiling.description":
    "Ces options seront proposées aux membres lorsqu'ils connecteront leur client IA ; ils pourront choisir les mêmes ou moins.",
  "workspace_mcp.ceiling.confirm_aria": "Confirmer les portées destructives",
  "workspace_mcp.ceiling.confirm_text":
    "Je comprends que ces portées permettent aux clients IA de créer, modifier ou supprimer des données dans cet espace de travail au nom d'un membre.",
  "workspace_mcp.ceiling.saving": "Enregistrement…",

  // Error boundary
  "error_boundary.title": "Une erreur est survenue",
  "error_boundary.description":
    "Veuillez recharger la page. Si le problème persiste, contactez le support.",

  // Auth
  "auth.sign_in": "Se connecter",
  "auth.sign_in_subcopy": "Enter your work email to continue.",
  "auth.workspace_sso.title": "Connectez-vous avec votre compte d'entreprise",
  "auth.workspace_sso.subcopy":
    "Saisissez votre adresse e-mail professionnelle pour continuer vers la page de connexion de votre entreprise.",
  "auth.use_different_email": "Utiliser une autre adresse e-mail",
  "auth.sso_unavailable_title": "L'authentification unique est indisponible",
  "auth.sso_unavailable_message":
    "Le fournisseur d'identité de votre espace de travail est actuellement inaccessible. Contactez votre administrateur ou le support pour vous connecter.",
  "auth.sign_in_another_way": "Se connecter autrement",
  "auth.sso_choice.title": "Choisissez comment vous connecter",
  "auth.sso_required_title": "Vos espaces de travail exigent une connexion avec",
  "auth.sso_required_some_open":
    "Votre connexion a ouvert les espaces de travail qui l’acceptent. Les autres exigent une connexion avec votre fournisseur d’identité.",
  "auth.sso_required_none_open":
    "Votre connexion n’a ouvert aucun de vos espaces de travail. Connectez-vous avec votre fournisseur d’identité pour continuer.",
  "auth.sso_required_sign_in_with": "Se connecter avec {label}",
  "auth.sso_required_no_providers":
    "Aucun de vos fournisseurs d’identité n’est disponible pour le moment. Contactez l’administrateur de votre espace de travail pour vous connecter.",
  "auth.sso_required_continue": "Continuer vers vos espaces de travail",
  "auth.sso_required_password_needed": "{workspace} exige une connexion avec votre mot de passe.",
  "auth.sso_required_sign_in_with_password": "Se connecter avec votre mot de passe",
  "auth.sso_required_load_error":
    "Impossible de vérifier vos espaces de travail. Rechargez la page pour réessayer.",
  "auth.choose_workspace_title": "Choisissez un espace de travail",
  "auth.choose_workspace_hint": "Votre connexion ouvre ces espaces de travail.",
  "auth.choose_workspace_none": "Cette connexion n’ouvre aucun de vos espaces de travail.",
  "auth.choose_workspace_load_error":
    "Impossible de charger vos espaces de travail. Rechargez la page pour réessayer.",
  "auth.sign_up": "Créer un compte",
  "auth.sign_out": "Se déconnecter",
  "auth.session_expired_title": "Session expirée",
  "auth.session_expired_message":
    "Votre session a pris fin. Veuillez vous reconnecter pour continuer.",
  "auth.email": "E-mail",
  "auth.work_email": "E-mail professionnel",
  "auth.work_email_required": "L'e-mail professionnel est requis.",
  "auth.password": "Mot de passe",
  "auth.confirm_password": "Confirmer le mot de passe",
  "auth.continue": "Continuer",
  "auth.checking": "Vérification...",
  "auth.looking_up_account": "Recherche de votre compte…",
  "auth.signing_in": "Connexion...",
  "auth.creating_account": "Création du compte...",
  "auth.forgot_password": "Mot de passe oublié ?",
  "auth.forgot_password_title": "Mot de passe oublié",
  "auth.reset_password": "Réinitialiser le mot de passe",
  "auth.set_password": "Définir un mot de passe",
  "auth.set_password_description": "Définissez un mot de passe pour votre compte.",
  "auth.send_reset_link": "Envoyer le lien",
  "auth.sending": "Envoi...",
  "auth.resetting": "Réinitialisation...",
  "auth.setting_password": "Définition du mot de passe...",
  "auth.current_password": "Mot de passe actuel",
  "auth.new_password": "Nouveau mot de passe",
  "auth.changing_password": "Modification du mot de passe...",
  "auth.change_expired_password_title": "Mettez à jour votre mot de passe",
  "auth.change_expired_password_description":
    "Votre espace de travail exige un nouveau mot de passe avant de continuer.",
  "auth.change_expired_password_submit": "Mettre à jour le mot de passe",
  "auth.check_email": "Vérifiez vos e-mails",
  "auth.check_email_description":
    "Si un compte existe pour {email}, nous avons envoyé un lien de réinitialisation.",
  "auth.back_to_sign_in": "Retour à la connexion",
  "auth.new_here": "Nouveau ici ?",
  "auth.already_have_account": "Vous avez déjà un compte ?",
  "auth.or_continue_with": "Ou continuer avec",
  "auth.magic_code_sent": "Nous avons envoyé un code à {email}. Entrez-le ci-dessous.",
  "auth.code": "Code",
  "auth.verify": "Vérifier",
  "auth.verifying": "Vérification...",
  "auth.resend_code": "Renvoyer le code",
  "auth.resend_code_in": "Renvoyer le code dans {seconds}s",
  "auth.use_magic_code": "Utiliser un code magique",
  "auth.password_min_length": "Le mot de passe doit comporter au moins 8 caractères.",
  "auth.password_entirely_numeric": "Le mot de passe ne peut pas contenir uniquement des chiffres.",
  "auth.passwords_mismatch": "Les mots de passe ne correspondent pas.",
  "auth.invalid_email": "Veuillez saisir une adresse e-mail valide.",
  "auth.enter_code": "Veuillez saisir le code.",
  "auth.generic_error": "Une erreur est survenue. Veuillez réessayer.",
  "auth.sign_in_success": "Connexion réussie",
  "auth.sign_out_success": "Déconnexion réussie",
  "auth.invalid_credentials": "Adresse e-mail ou mot de passe incorrect",
  "auth.connection_failed": "Échec de la connexion",
  "auth.password_show": "Afficher",
  "auth.password_hide": "Masquer",
  "auth.failed_to_send_code": "Échec de l'envoi du code. Veuillez réessayer.",
  // Sign-in and sign-up error banners, by backend error code (NG-2581)
  "auth.error.instance_not_configured.title": "Instance non configurée",
  "auth.error.instance_not_configured.message": "Veuillez contacter votre administrateur.",
  "auth.error.invalid_email.title": "Adresse e-mail invalide",
  "auth.error.invalid_email.message": "Veuillez saisir une adresse e-mail valide.",
  "auth.error.email_required.title": "Adresse e-mail requise",
  "auth.error.email_required.message": "Veuillez saisir votre adresse e-mail.",
  "auth.error.signup_disabled.title": "Inscription désactivée",
  "auth.error.signup_disabled.message":
    "La création de nouveaux comptes est actuellement désactivée.",
  "auth.error.magic_link_disabled.title": "Lien magique désactivé",
  "auth.error.magic_link_disabled.message": "La connexion par lien magique n'est pas disponible.",
  "auth.error.password_login_disabled.title": "Connexion par mot de passe désactivée",
  "auth.error.password_login_disabled.message":
    "La connexion par mot de passe n'est pas disponible.",
  "auth.error.account_deactivated.title": "Compte désactivé",
  "auth.error.account_deactivated.message":
    "Votre compte a été désactivé. Contactez votre administrateur.",
  "auth.error.password_not_accepted.title": "Mot de passe refusé",
  "auth.error.password_not_accepted.message":
    "Ce mot de passe ne respecte pas les exigences. Choisissez-en un autre.",
  "auth.error.smtp_not_configured.title": "E-mail non configuré",
  "auth.error.smtp_not_configured.message":
    "L'envoi d'e-mails n'est pas configuré. Contactez votre administrateur.",
  "auth.error.account_exists.title": "Compte existant",
  "auth.error.account_exists.message":
    "Un compte existe déjà avec cette adresse e-mail. Veuillez vous connecter.",
  "auth.error.sign_up_failed.title": "Échec de l'inscription",
  "auth.error.sign_up_failed.message": "Impossible de créer votre compte. Veuillez réessayer.",
  "auth.error.missing_fields.title": "Champs manquants",
  "auth.error.missing_fields.message": "L'adresse e-mail et le mot de passe sont requis.",
  "auth.error.code_required.title": "Code requis",
  "auth.error.code_required.message": "Veuillez saisir le code envoyé à votre adresse e-mail.",
  "auth.error.account_not_found.title": "Compte introuvable",
  "auth.error.account_not_found.message":
    "Aucun compte n'existe avec cette adresse e-mail. Veuillez vous inscrire.",
  "auth.error.sign_in_failed.title": "Échec de l'authentification",
  "auth.error.sign_in_failed.message": "Adresse e-mail ou mot de passe invalide.",
  "auth.error.invalid_code.title": "Code invalide",
  "auth.error.invalid_code.message": "Le code saisi est incorrect.",
  "auth.error.code_expired.title": "Code expiré",
  "auth.error.code_expired.message": "Votre code a expiré. Veuillez en demander un nouveau.",
  "auth.error.attempts_exhausted.title": "Trop de tentatives",
  "auth.error.attempts_exhausted.message":
    "Vous avez dépassé le nombre maximal de tentatives. Demandez un nouveau code.",
  "auth.error.oauth_not_configured.title": "OAuth non configuré",
  "auth.error.oauth_not_configured.message": "L'authentification OAuth n'est pas disponible.",
  "auth.error.google_not_configured.title": "Google non configuré",
  "auth.error.google_not_configured.message": "L'authentification Google n'est pas disponible.",
  "auth.error.google_error.title": "Erreur Google",
  "auth.error.google_error.message": "Une erreur s'est produite lors de l'authentification Google.",
  "auth.error.invalid_reset_link.title": "Lien de réinitialisation invalide",
  "auth.error.invalid_reset_link.message":
    "Ce lien de réinitialisation du mot de passe n'est pas valide.",
  "auth.error.reset_link_expired.title": "Lien expiré",
  "auth.error.reset_link_expired.message":
    "Ce lien de réinitialisation du mot de passe a expiré. Demandez-en un nouveau.",
  "auth.error.incorrect_password.title": "Mot de passe incorrect",
  "auth.error.incorrect_password.message": "Le mot de passe actuel saisi est incorrect.",
  "auth.error.password_required.title": "Mot de passe requis",
  "auth.error.password_required.message": "Veuillez saisir un mot de passe.",
  "auth.error.invalid_new_password.title": "Mot de passe invalide",
  "auth.error.invalid_new_password.message":
    "Le nouveau mot de passe ne respecte pas les exigences.",
  "auth.error.password_already_set.title": "Mot de passe déjà défini",
  "auth.error.password_already_set.message": "Votre mot de passe a déjà été défini.",
  "auth.error.rate_limited.title": "Trop de requêtes",
  "auth.error.rate_limited.message": "Veuillez patienter un instant et réessayer.",
  "auth.error.account_locked.title": "Compte temporairement verrouillé",
  "auth.error.account_locked.message":
    "Trop de tentatives de connexion échouées. Veuillez patienter quelques minutes et réessayer.",
  "auth.error.unknown.title": "Une erreur s'est produite",
  "auth.error.unknown.message": "Une erreur inattendue s'est produite. Veuillez réessayer.",
  "auth.error.sso_account_not_linked.title": "Compte non lié",
  "auth.error.sso_account_not_linked.message":
    "Ce compte n'est pas lié à l'authentification unique de votre espace de travail. Contactez votre administrateur, ou connectez-vous autrement.",
  "auth.error.sso_not_configured.title": "Authentification unique non configurée",
  "auth.error.sso_not_configured.message":
    "Votre espace de travail n'a pas encore configuré l'authentification unique. Contactez votre administrateur.",
  "auth.error.domain_not_configured.title": "Authentification unique indisponible",
  "auth.error.domain_not_configured.message":
    "L'authentification unique n'est pas activée pour votre domaine de messagerie. Contactez votre administrateur, ou connectez-vous autrement.",
  "auth.error.oidc_provider_error.title": "Échec de la connexion",
  "auth.error.oidc_provider_error.message":
    "Votre fournisseur d'identité n'a pas pu terminer la connexion. Contactez votre administrateur ou réessayez.",
  "auth.error.saml_provider_error.title": "Échec de la connexion",
  "auth.error.saml_provider_error.message":
    "Votre fournisseur d'identité n'a pas pu terminer la connexion. Contactez votre administrateur ou réessayez.",
  "auth.error.sso_sign_in_expired.title": "La connexion a pris trop de temps",
  "auth.error.sso_sign_in_expired.message":
    "La connexion chez votre fournisseur d'identité a pris trop de temps. Recommencez à partir de cette page.",
  "auth.error.sso_use_workspace_link.title":
    "Utilisez le lien de connexion de votre espace de travail",
  "auth.error.sso_use_workspace_link.message":
    "Le domaine de votre adresse e-mail permet de se connecter à plus d'un espace de travail. Demandez à l'administrateur de votre espace de travail son lien de connexion, et utilisez-le pour votre première connexion.",
  "auth.error.sso_email_missing.title": "Aucune adresse courriel sur votre compte",
  "auth.error.sso_email_missing.message":
    "Votre fournisseur d'identité n'a pas transmis d'adresse courriel pour votre compte. Nous ne pouvons donc pas vous connecter. Demandez à votre administrateur d'ajouter une adresse courriel à votre compte, puis réessayez.",
  "auth.error.sso_error.title": "Échec de la connexion",
  "auth.error.sso_error.message":
    "Une erreur s'est produite au démarrage de l'authentification unique. Contactez votre administrateur ou réessayez.",

  // Search
  "search.placeholder": "Rechercher...",

  // Sidebar
  "sidebar.search": "Rechercher",
  "sidebar.my_work": "Mon travail",
  "sidebar.my_teams": "Mes équipes",
  "sidebar.my_space": "Mon espace",
  "sidebar.workspace_views": "Vues",
  "sidebar.dashboards": "Tableaux de bord",
  "sidebar.reports": "Rapports",
  "sidebar.insights": "Insights",
  "sidebar.work": "Travail",
  "sidebar.strategy": "Stratégie",
  "sidebar.goals": "Objectifs",
  "sidebar.programs": "Programmes",
  "sidebar.requests": "Demandes",
  "sidebar.submissions": "Soumissions",

  // Dashboards
  "dashboards.title": "Tableaux de bord",
  "dashboards.preview_empty": "Aucun widget pour l'instant",
  "dashboards.updated_on": "Mis à jour {date}",
  "dashboards.preview_more": "+{count} de plus",
  "reporting_agent.title": "Reporting Teammate",
  "reporting_agent.empty_subtitle":
    "Décrivez le rapport que vous souhaitez créer à partir des données de votre espace de travail.",
  "reporting_agent.composer_placeholder": "Demandez un rapport…",
  "reporting_agent.send": "Envoyer",
  "reporting_agent.answer_placeholder": "Saisissez votre réponse…",
  "reporting_agent.send_answer": "Envoyer la réponse",
  "reporting_agent.working": "En cours de traitement…",
  "reporting_agent.new_chat": "Nouvelle discussion",
  "reporting_agent.history": "Historique",
  "reporting_agent.history_loading": "Chargement…",
  "reporting_agent.history_empty": "Aucune conversation passée",
  "reporting_agent.history_untitled": "Conversation sans titre",
  "reporting_agent.approve": "Approuver",
  "reporting_agent.deny": "Refuser",
  "reporting_agent.approved": "Approuvé",
  "reporting_agent.denied": "Refusé",
  "reporting_agent.view_dashboard": "Voir le rapport",
  "reporting_agent.dashboard_title": "Rapport",
  "reporting_agent.dashboard_load_error":
    "Impossible de charger ce rapport. Essayez de le rouvrir.",
  "reporting_agent.refused.turned_off":
    "Vous avez désactivé votre Reporting Teammate. Réactivez-le dans Profil › Coéquipiers numériques.",
  "reporting_agent.refused.needs_approval":
    "Votre Reporting Teammate a été mis à jour et reste en pause jusqu'à ce qu'un administrateur l'approuve dans Paramètres › Coéquipiers numériques.",
  "reporting_agent.refused.switched_off":
    "Le Reporting Teammate est désactivé dans cet espace de travail.",
  "reporting_agent.refused.generic":
    "Votre Reporting Teammate ne peut pas fonctionner pour vous pour le moment.",
  "reporting_agent.connection_error":
    "La connexion à votre Reporting Teammate a été interrompue. Démarrez une nouvelle discussion pour vous reconnecter.",
  "reporting_agent.suggestion.overdue_work": "Travaux en retard et responsables",
  "reporting_agent.suggestion.team_utilization":
    "Utilisation de l'équipe sur les 8 dernières semaines",
  "reporting_agent.suggestion.request_volume": "Volume de demandes et taux d'acceptation",
  "dashboards.empty": "Aucun tableau de bord pour l'instant",
  "dashboards.failed_to_load": "Échec du chargement des tableaux de bord.",
  "dashboards.browse_denied":
    "Vous n’avez pas l’autorisation de parcourir les tableaux de bord. Communiquez avec l’administrateur de votre espace de travail pour demander l’accès.",
  "dashboards.retry": "Réessayer",
  "dashboards.search_placeholder": "Rechercher des tableaux de bord",
  "dashboards.search_empty": "Aucun tableau de bord ne correspond à « {query} ».",
  "dashboards.shared_label": "Partagé",
  "dashboards.sort_label": "Trier",
  "dashboards.sort_last_viewed": "Dernière consultation",
  "dashboards.sort_alphabetical": "Alphabétique",
  "dashboards.not_found": "Tableau de bord introuvable",
  "dashboards.scope_label": "Portée :",
  "dashboards.scope_all_projects": "Tous les projets de cet espace de travail",
  "dashboards.scope_placeholder": "Sélectionner des projets",
  "dashboards.scope_remove_project": "Retirer {name}",
  "dashboards.scope_subset_projects": "Seulement les projets sélectionnés",
  "dashboards.scope_edit": "Modifier",
  "dashboards.scope_edit_title": "Projets liés",
  "dashboards.scope_edit_help":
    "Les projets liés restreignent les données. Aucun lien = portée complète de l'espace.",
  "dashboards.scope_no_projects_in_workspace": "Aucun projet dans cet espace de travail.",
  "dashboards.scope_no_search_matches": "Aucun projet ne correspond à cette recherche.",
  "dashboards.scope_search_placeholder": "Rechercher des projets…",
  "dashboards.scope_search_label": "Rechercher des projets",
  "dashboards.scope_search_more_hint":
    "Affichage de {shown} sur {total} — saisissez pour rechercher",
  "dashboards.chart.failed_to_render": "Échec du rendu du graphique",
  "dashboards.chart.failed_to_load": "Échec du chargement",
  "dashboards.chart.unsupported": "Type de graphique non encore pris en charge",
  "dashboards.chart.no_data": "Aucune donnée",
  "dashboards.table.search_placeholder": "Filtrer les lignes…",
  "dashboards.table.no_matching": "Aucun élément correspondant.",
  "dashboards.chart.not_specified": "Non spécifié",
  "dashboards.chart.target": "Cible",
  "dashboards.chart.met_sla_counts": "{met} sur {total} ont respecté le SLA",
  // Étiquette de période sous un titre NUMBER_WITH_TREND ; count = points du graphique.
  "dashboards.chart.last_n_weeks":
    "{count, plural, one {# dernière semaine} other {# dernières semaines}}",
  "dashboards.chart.compared_periods": "{current} vs {prior}",
  "dashboards.chart.cost_locked_title": "Données de coût restreintes",
  "dashboards.chart.cost_locked_body": "Vous n'avez pas accès aux données de coût.",
  // Tuile dégradée (GH-3981) — le corps du message provient du `warning` du
  // backend, donc seul le titre est traduit ici.
  "dashboards.chart.degraded_title": "Ce widget ne peut pas être affiché en graphique",
  // Clé distincte de `dashboards.widget_configure` : l'élément du menu s'offre
  // aussi en lecture seule, ce bouton sert à réparer le widget, et un verbe seul
  // sur une tuile ne dit pas sur quoi il agit.
  "dashboards.chart.degraded_edit": "Modifier le widget",
  // NG-1482 — dernière ligne de l'infobulle d'une marque interactive : ce que
  // fait un clic. Voir en.ts pour la règle sur la valeur nommée ou non.
  "dashboards.chart.hint_filter_add": "Cliquer pour filtrer le tableau de bord sur cette valeur",
  "dashboards.chart.hint_filter_remove": "Cliquer pour retirer ce filtre du tableau de bord",
  "dashboards.chart.hint_series_filter_add": "Cliquer pour filtrer le tableau de bord sur {series}",
  "dashboards.chart.hint_series_filter_remove":
    "Cliquer pour retirer le filtre du tableau de bord sur {series}",
  "dashboards.chart.hint_series_filter_any":
    "Cliquer sur un segment pour ajouter ou retirer son filtre du tableau de bord",
  "dashboards.chart.hint_open_project": "Cliquer pour ouvrir ce projet",
  "dashboards.chart.hint_show_breakdown": "Cliquer pour afficher la répartition de capacité",
  "dashboards.chart.hint_hide_breakdown": "Cliquer pour masquer la répartition de capacité",
  // Étiquettes de regroupement de graphiques — fallback en titre quand absent.
  "dashboards.label.lob.sales": "Ventes",
  "dashboards.label.lob.human_resources": "Ressources humaines",
  "dashboards.label.lob.engineering": "Ingénierie",
  "dashboards.label.lob.it": "TI",
  "dashboards.label.lob.information_technology": "Technologies de l'information",
  "dashboards.label.lob.finance": "Finance",
  "dashboards.label.lob.operations": "Opérations",
  "dashboards.label.lob.marketing": "Marketing",
  "dashboards.label.lob.legal": "Juridique",
  "dashboards.label.state_group.new": "Nouveau",
  "dashboards.label.state_group.backlog": "Arriéré",
  "dashboards.label.state_group.unstarted": "Non commencé",
  "dashboards.label.state_group.in_review": "En révision",
  "dashboards.label.state_group.waitlisted": "En liste d'attente",
  "dashboards.label.state_group.started": "En cours",
  "dashboards.label.state_group.on_hold": "En pause",
  "dashboards.label.goal_status.planning": "Planification",
  "dashboards.label.goal_status.active": "Actif",
  "dashboards.label.goal_status.on_hold": "En pause",
  "dashboards.label.goal_status.complete": "Terminé",

  // Goals: shared vocabulary, leads and links sections (NG-2584)
  "goals.value_type.number": "Nombre",
  "goals.value_type.percent": "Pourcentage",
  "goals.value_type.currency": "Devise",
  "goals.value_type.duration": "Durée",
  "goals.leads.title": "Responsables de l'objectif",
  "goals.leads.add_placeholder": "Ajouter un responsable…",
  "goals.leads.empty":
    "Aucun responsable pour le moment. Un responsable d'objectif peut modifier l'objectif, ses indicateurs et ses liens.",
  "goals.leads.remove_aria": "Retirer {name} des responsables de l'objectif",
  "goals.links.project.placeholder": "Lier un projet…",
  "goals.links.project.search": "Rechercher des projets…",
  "goals.links.project.no_options": "Aucun projet à lier",
  "goals.links.project.trigger_aria": "Lier un projet",
  "goals.links.project.none_linked": "Aucun projet n'est lié à cet objectif.",
  "goals.links.program.placeholder": "Lier un programme…",
  "goals.links.program.search": "Rechercher des programmes…",
  "goals.links.program.no_options": "Aucun programme à lier",
  "goals.links.program.trigger_aria": "Lier un programme",
  "goals.links.program.none_linked": "Aucun programme n'est lié à cet objectif.",
  "goals.links.request.placeholder": "Lier une demande…",
  "goals.links.request.search": "Rechercher des demandes…",
  "goals.links.request.no_options": "Aucune demande à lier",
  "goals.links.request.trigger_aria": "Lier une demande",
  "goals.links.request.none_linked": "Aucune demande n'est liée à cet objectif.",
  "goals.links.inactive_hint":
    "Seuls les objectifs actifs acceptent de nouveaux liens : réactivez l'objectif pour lier d'autres travaux. Les liens existants peuvent toujours être retirés.",
  "goals.links.unlink_aria": "Dissocier {name}",
  "goals.metrics.title": "Indicateurs",
  "goals.metrics.add": "Ajouter un indicateur",
  "goals.metrics.empty_read_only": "Cet objectif n'a pas encore d'indicateur.",
  "goals.metrics.empty_editable":
    "Ajoutez un indicateur pour rendre cet objectif mesurable : une valeur de référence et la cible à atteindre.",
  "goals.metrics.name_label": "Nom de l'indicateur *",
  "goals.metrics.name_placeholder": "p. ex. Taux d'achèvement des formations",
  "goals.metrics.view_data_aria": "Voir les données de {name}",
  "goals.metrics.remove_aria": "Retirer l'indicateur",
  "goals.metrics.type_label": "Type",
  "goals.metrics.baseline": "Valeur de référence",
  "goals.metrics.target": "Cible",
  "goals.metrics.no_values":
    "Aucune valeur enregistrée pour le moment : utilisez le bouton du graphique pour ajouter la première.",
  "goals.metrics.latest_summary":
    "Dernière valeur {value} · {date} · {count, plural, one {{countText} valeur} other {{countText} valeurs}}",
  "goals.metrics.progress_to_target": "{percent} % de la cible",
  "goals.data.load_error": "Impossible de charger les données de l'indicateur",
  "goals.data.save_error": "Impossible d'enregistrer la valeur",
  "goals.data.delete_error": "Impossible de supprimer la valeur",
  "goals.data.col_date": "Date",
  "goals.data.col_value": "Valeur",
  "goals.data.col_note": "Note",
  "goals.data.col_recorded_by": "Enregistré par",
  "goals.data.actions_aria": "Actions sur la valeur",
  "goals.data.edit_aria": "Modifier la valeur du {date}",
  "goals.data.delete_aria": "Supprimer la valeur du {date}",
  "goals.data.empty": "Aucune donnée enregistrée pour le moment.",
  "goals.data.note_placeholder": "Contexte facultatif pour ce point",

  "dashboards.label.state_group.accepted": "Accepté",
  "dashboards.label.state_group.delivered": "Livré",
  "dashboards.label.state_group.completed": "Terminé",
  "dashboards.label.state_group.declined": "Refusé",
  "dashboards.label.state_group.cancelled": "Annulé",
  "dashboards.label.disposition.accepted": "Accepté",
  "dashboards.label.disposition.declined": "Refusé",
  "dashboards.label.disposition.covered": "Couvert",
  "dashboards.label.disposition.withdrawn": "Retiré",
  "dashboards.label.disposition.waitlisted": "En liste d'attente",
  "dashboards.label.disposition.pending": "En attente",
  "dashboards.label.work_item_type.task": "Tâche",
  "dashboards.label.work_item_type.event": "Événement",
  "dashboards.label.work_item_type.milestone": "Jalon",
  "dashboards.label.request_type.coaching": "Coaching",
  "dashboards.label.request_type.compliance": "Conformité",
  "dashboards.label.request_type.content_refresh": "Mise à jour de contenu",
  "dashboards.label.request_type.elearning": "Apprentissage en ligne",
  "dashboards.label.request_type.instructor_led_training": "Formation en classe",
  "dashboards.label.request_type.onboarding": "Intégration",
  "dashboards.label.request_type.other": "Autre",
  "dashboards.label.request_type.workshop_event": "Atelier / Événement",
  "dashboards.breakdown_pie.empty": "Aucune donnée de répartition",
  "dashboards.breakdown_pie.project": "Projet",

  // Timeline, gantt, time off, dashboards PoP and program toast copy (NG-2585)
  "dashboards.pop.increased": "En hausse par rapport à la période précédente",
  "dashboards.pop.decreased": "En baisse par rapport à la période précédente",
  "dashboards.pop.unchanged": "Inchangé par rapport à la période précédente",
  "dashboards.pop.vs_prior": "contre {value} pour la période précédente",
  "schedule.gantt.drag_dependency": "Faire glisser pour créer une dépendance",
  "time_off.band_title": "Absence · {label}",
  "time_off.default_title": "Absence",
  "timeline.conflict_time_off": "En conflit avec une absence",
  "timeline.team_members": "{count, plural, one {{countText} membre} other {{countText} membres}}",
  "timeline.project_subtitle": "Projet",
  "workspace_settings.templates.workitem.day_value": "Jour {day}",
  "programs.update_error": "Impossible de mettre à jour le programme",

  "dashboards.breakdown_pie.event": "Événement",
  "dashboards.breakdown_pie.admin": "Administration",
  "dashboards.breakdown_pie.open_capacity_detail": "Ouvrir le détail de capacité",
  "dashboards.coming_soon": "Bientôt disponible",
  "dashboards.a11y.table_label": "Libellé",
  "dashboards.a11y.table_series": "Série",
  "dashboards.a11y.table_value": "Valeur",
  "dashboards.a11y.row_action": "{label}, {value}, {action}",
  "dashboards.a11y.action_filter": "filtrer le tableau de bord sur cette valeur",
  "dashboards.a11y.action_open_project": "ouvrir ce projet",
  "dashboards.a11y.action_remove_filter": "retirer ce filtre du tableau de bord",
  "dashboards.a11y.action_show_breakdown": "afficher la répartition de capacité",
  "dashboards.a11y.action_hide_breakdown": "masquer la répartition de capacité",
  "dashboards.a11y.action_open_capacity": "ouvrir le détail de capacité",
  "dashboards.a11y.kpi_drill": "{value}, {action}",
  "dashboards.a11y.action_open_over_capacity": "ouvrir les personnes en surcapacité",
  "dashboards.a11y.action_open_overdue": "ouvrir les tâches en retard derrière ce nombre",
  "dashboards.widget_untitled": "Widget sans titre",
  "dashboards.widget_actions": "Actions du widget",
  "dashboards.widget_configure": "Configurer",
  "dashboards.widget_delete": "Supprimer",
  "dashboards.widget_delete_error": "Échec de la suppression du widget",
  "dashboards.widget_layout_save_error":
    "Impossible d'enregistrer la modification de la disposition",
  "dashboards.widget_drag_handle": "Glisser pour déplacer le widget",
  "dashboards.configure_widget": "Configurer le widget",
  "dashboards.widget_name": "Nom",
  "dashboards.chart_type": "Type de graphique",
  "dashboards.chart_type.bar": "Barres",
  "dashboards.chart_type.line": "Courbes",
  "dashboards.chart_type.area": "Aires",
  "dashboards.chart_type.pie": "Secteurs",
  "dashboards.chart_type.donut": "Anneau",
  "dashboards.chart_type.number": "Nombre",
  "dashboards.chart_type.comparison_bar": "Barres comparées",
  "dashboards.chart_type.table": "Tableau",
  // En-têtes de colonnes des widgets TABLE (GH-4077).
  "dashboards.table_column.TASK.name": "Nom",
  "dashboards.table_column.TASK.state": "Statut",
  "dashboards.table_column.TASK.owner": "Responsable",
  "dashboards.table_column.TASK.due_date": "Échéance",
  "dashboards.table_column.TASK.days_overdue": "Jours de retard",
  "dashboards.table_column.TASK.project": "Projet",
  "dashboards.table_column.PROJECT.name": "Nom",
  "dashboards.table_column.PROJECT.state": "Statut",
  "dashboards.table_column.PROJECT.lead": "Responsable",
  "dashboards.table_column.PROJECT.target_completion_date": "Achèvement cible",
  "dashboards.table_column.PROJECT.days_overdue": "Jours de retard",
  "dashboards.table_column.PROJECT.project_type": "Type",
  "dashboards.table_column.REQUEST.form": "Formulaire",
  "dashboards.table_column.REQUEST.state": "Statut",
  "dashboards.table_column.REQUEST.submitted_by": "Soumis par",
  "dashboards.table_column.REQUEST.submitted_at": "Soumis le",
  "dashboards.table_column.REQUEST.request_type": "Type",
  "dashboards.table_column.TIME_LOG.logged_at": "Enregistré le",
  "dashboards.table_column.TIME_LOG.duration": "Durée (s)",
  "dashboards.table_column.USER_CAPACITY.user": "Utilisateur",
  "dashboards.table_column.USER_CAPACITY.date": "Date",
  "dashboards.table_column.USER_CAPACITY.planned_task_minutes": "Tâches planifiées (min)",
  "dashboards.table_column.USER_CAPACITY.capacity_minutes": "Capacité (min)",
  "dashboards.table_column.CAPACITY_ALLOCATION.user": "Utilisateur",
  "dashboards.table_column.CAPACITY_ALLOCATION.date": "Date",
  "dashboards.table_column.CAPACITY_ALLOCATION.minutes": "Minutes",
  "dashboards.table_column.CAPACITY_ALLOCATION.work_item": "Élément de travail",
  "dashboards.editor.table_row_filter": "Filtre de lignes",
  "dashboards.editor.table_row_filter_none": "Toutes les lignes",
  "dashboards.editor.table_row_filter_hint": "N'affiche que les lignes comptées par cette mesure.",
  "dashboards.editor.table_columns": "Colonnes",
  "dashboards.editor.table_sort": "Trier par",
  "dashboards.editor.table_sort_none": "Ordre du serveur",
  "dashboards.editor.table_sort_direction": "Sens du tri",
  "dashboards.editor.table_sort_asc": "Croissant",
  "dashboards.editor.table_sort_desc": "Décroissant",
  "dashboards.editor.table_limit": "Nombre de lignes",
  "dashboards.editor.table_limit_hint": "Entre 1 et 500 lignes.",
  "dashboards.editor.read_only_note":
    "Vous pouvez consulter les paramètres de ce widget, mais pas les modifier.",
  "dashboards.editor.no_filters": "Aucun filtre",
  "dashboards.x_axis": "Axe X",
  "dashboards.custom_fields_group": "Champs personnalisés",
  "dashboards.group_by": "Grouper par",
  "dashboards.date_grouping": "Groupement par date",
  "dashboards.date_grouping.day": "Jour",
  "dashboards.date_grouping.week": "Semaine",
  "dashboards.date_grouping.month": "Mois",
  "dashboards.date_grouping.year": "Année",
  "dashboards.metric": "Métrique",
  "dashboards.editor.baseline_metric": "Référence (fond)",
  "dashboards.editor.compare_same_unit":
    "Seules les métriques dans l'unité de la référence (coût ou heures) peuvent être comparées sur un même axe.",
  "dashboards.editor.outcome_metric": "Comparé (barre avant)",
  "dashboards.numerator": "Numérateur",
  "dashboards.denominator": "Dénominateur",
  "dashboards.source": "Source de données",
  "dashboards.source.task": "Éléments de travail",
  "dashboards.source.request": "Demandes",
  "dashboards.source.project": "Projets",
  "dashboards.source.time_log": "Journal de temps",
  "dashboards.source.capacity_allocation": "Allocation de capacité",
  "dashboards.source.user_capacity": "Capacité des utilisateurs",
  "dashboards.source.goal": "Objectifs",
  "dashboards.property.states": "Statut",
  "dashboards.property.state_groups": "Groupe de statuts",
  "dashboards.property.assignees": "Personnes assignées",
  "dashboards.property.estimate_hours": "Heures estimées",
  "dashboards.property.priority": "Priorité",
  "dashboards.property.start_date": "Date de début",
  "dashboards.property.target_date": "Date cible",
  "dashboards.property.created_at": "Date de création",
  "dashboards.property.goal_status": "Statut de l'objectif",
  "dashboards.property.submitted_at": "Date de soumission",
  "dashboards.property.completed_at": "Date d'achèvement",
  "dashboards.property.logged_at": "Enregistré le",
  "dashboards.property.work_item_types": "Type d'élément de travail",
  "dashboards.property.stages": "Étape",
  "dashboards.property.projects": "Projet",
  "dashboards.property.project_type": "Type de projet",
  "dashboards.property.created_by": "Créé par",
  "dashboards.property.epics": "Epic",
  "dashboards.property.disposition": "Décision",
  "dashboards.property.request_type": "Type de demande",
  "dashboards.property.submitted_by": "Soumis par",
  "dashboards.property.decline_reason": "Motif de refus",
  "dashboards.property.waitlist_reason": "Motif de mise en liste d'attente",
  "dashboards.property.cancel_reason": "Motif d'annulation",
  "dashboards.property.project_lead": "Responsable de projet",
  "dashboards.property.delivery_teams": "Équipes de livraison",
  "dashboards.property.home_team": "Équipe principale",
  "dashboards.property.target_completion_date": "Date d'achèvement cible",
  "dashboards.property.actual_completion_date": "Date d'achèvement réelle",
  "dashboards.property.teams": "Équipes",
  "dashboards.property.lob": "Secteur d'activité",
  "dashboards.property.sla": "SLA",
  "dashboards.metric.work_item_count": "Nombre d'éléments de travail",
  "dashboards.metric.estimate_hours_count": "Heures estimées",
  "dashboards.metric.pending_work_item_count": "Éléments en attente",
  "dashboards.metric.completed_work_item_count": "Éléments terminés",
  "dashboards.metric.in_progress_work_item_count": "Éléments en cours",
  "dashboards.metric.cancelled_work_item_count": "Éléments annulés",
  "dashboards.metric.work_item_due_today_count": "À rendre aujourd'hui",
  "dashboards.metric.work_item_due_this_week_count": "À rendre cette semaine",
  "dashboards.metric.avg_estimate_hours": "Heures estimées moyennes",
  "dashboards.metric.overdue_count": "Éléments en retard",
  "dashboards.metric.open_work_item_count": "Éléments ouverts",
  "dashboards.metric.avg_queue_time_seconds": "Temps d'attente moyen",
  "dashboards.metric.avg_time_to_decision_seconds": "Délai de décision moyen",
  "dashboards.metric.avg_build_time_seconds": "Temps de production moyen",
  "dashboards.metric.sla_adherence_percent": "Respect des SLA",
  "dashboards.metric.goal_alignment": "Alignement sur les objectifs",
  "dashboards.metric.goal_count": "Nombre d'objectifs",
  "dashboards.metric.goal_progress": "Progression des objectifs",
  "dashboards.metric.planned_hours": "Heures planifiées",
  "dashboards.metric.capacity_hours": "Heures de capacité",
  "dashboards.metric.planned_minutes": "Minutes planifiées",
  "dashboards.metric.capacity_minutes": "Minutes de capacité",
  "dashboards.metric.over_capacity_member_count": "Membres en surcapacité",
  "dashboards.metric.under_utilized_free_hours": "Heures libres sous-utilisées",
  "dashboards.metric.team_utilization_percent": "Utilisation de l'équipe",
  "dashboards.metric.actual_cost": "Coût réel",
  "dashboards.metric.estimated_cost": "Coût estimé",
  "dashboards.metric.logged_cost": "Coût enregistré",
  "dashboards.metric.logged_hours": "Heures enregistrées",
  "dashboards.metric.actual_hours": "Heures réelles (enregistrées)",
  "dashboards.metric.earned_value": "Valeur acquise",
  "dashboards.metric.cost_variance": "Écart de coût (acquis − réel)",
  "dashboards.metric.estimate_at_completion": "Coût projeté (EAC)",
  "dashboards.metric.projected_weeks_to_clear": "Semaines prévues pour résorber l'arriéré",
  "dashboards.metric.ratio_percent": "Ratio (pourcentage)",
  "dashboards.widget_save_error": "Échec de l'enregistrement du widget",
  "dashboards.widget_save_success": "Widget enregistré",
  "dashboards.widget_download_image": "Télécharger en image",
  "dashboards.widget_download_failed": "Impossible d'exporter l'image du widget.",
  "dashboards.action_refresh": "Actualiser",
  "dashboards.action_export": "Exporter",
  "dashboards.action_share": "Partager",
  "dashboards.action_edit": "Modifier",
  "dashboards.action_more": "Plus d'actions",
  "dashboards.cannot_edit_widgets": "Widgets non modifiables",
  "dashboards.filters_change_your_view":
    "Les filtres et la période ne changent que votre propre affichage.",
  "dashboards.role_cannot_edit_widgets":
    "Votre rôle ne permet pas d’ajouter ni de modifier des widgets.",
  "dashboards.owned_by": "Propriété de {name} ({email})",
  "dashboards.action_delete": "Supprimer le tableau de bord",
  "dashboards.action_duplicate": "Dupliquer",
  "dashboards.duplicate_success": "Tableau de bord dupliqué",
  "dashboards.duplicate_error": "Échec de la duplication du tableau de bord",
  "dashboards.create_widget": "Créer un widget",
  "dashboards.widget_create_error": "Échec de la création du widget",
  "dashboards.delete_confirm_title": "Supprimer le tableau de bord",
  "dashboards.delete_confirm_description": 'Supprimer "{name}" ? Cette action est irréversible.',
  "dashboards.delete_success": "Tableau de bord supprimé",
  "dashboards.delete_error": "Échec de la suppression du tableau de bord",
  "dashboards.no_widgets": "Aucun widget pour l'instant",
  "dashboards.create_title": "Créer un tableau de bord",
  "dashboards.edit_title": "Modifier le tableau de bord",
  "dashboards.name_label": "Nom",
  "dashboards.name_placeholder": "ex. Capacité Q2",
  "dashboards.description_label": "Description",
  "dashboards.create_dashboard": "Créer un tableau de bord",
  "dashboards.save": "Enregistrer",
  "dashboards.create_success": "Tableau de bord créé",
  "dashboards.update_success": "Tableau de bord mis à jour",
  "dashboards.save_error": "Échec de l'enregistrement du tableau de bord",
  // Partage (NG-1115)
  "dashboards.share.action": "Partager",
  "dashboards.share.title": "Partager le tableau de bord",
  "dashboards.share.description": "Donnez accès à « {name} ».",
  "dashboards.share.add_label": "Ajouter des personnes",
  "dashboards.share.add_placeholder": "Rechercher une personne",
  "dashboards.share.add_button": "Partager",
  "dashboards.share.add_success": "Tableau de bord partagé",
  "dashboards.share.add_error": "Échec du partage du tableau de bord",
  "dashboards.share.role_label": "Accès",
  "dashboards.share.new_recipient_role_label": "Rôle du nouveau destinataire",
  "dashboards.share.role_viewer": "Lecteur",
  "dashboards.share.role_owner": "Propriétaire",
  "dashboards.share.role_error": "Échec de la modification de l'accès",
  "dashboards.share.people_label": "Personnes ayant accès",
  "dashboards.share.empty": "Ce tableau de bord n'a encore été partagé avec personne.",
  "dashboards.share.load_error": "Échec du chargement des personnes ayant accès",
  "dashboards.share.remove_label": "Retirer {name}",
  "dashboards.share.remove_title": "Retirer l'accès ?",
  "dashboards.share.remove_description": "{name} ne pourra plus voir ce tableau de bord.",
  "dashboards.share.remove_confirm": "Retirer l'accès",
  "dashboards.share.remove_success": "Accès retiré",
  "dashboards.share.remove_error": "Échec du retrait de l'accès",
  "dashboards.share.last_viewed": "Consulté {date}",
  "dashboards.share.never_viewed": "Jamais consulté",
  "dashboards.share.team_add_label": "Ajouter une équipe",
  "dashboards.share.team_add_placeholder": "Rechercher une équipe",
  "dashboards.share.team_add_button": "Ajouter l'équipe",
  "dashboards.share.team_hint":
    "Les membres de l'équipe et des équipes au-dessus peuvent le consulter.",
  "dashboards.share.teams_label": "Équipes ayant accès",
  "dashboards.share.teams_empty": "Ce tableau de bord n'a encore été partagé avec aucune équipe.",
  "dashboards.share.team_add_success": "Tableau de bord partagé avec l'équipe",
  "dashboards.share.team_add_error": "Échec du partage avec l'équipe",
  "dashboards.share.team_load_error":
    "Échec du chargement des équipes avec qui ce tableau de bord est partagé",
  "dashboards.share.team_remove_label": "Retirer l'équipe {name}",
  "dashboards.share.team_remove_description":
    "Les membres de {name} ne verront plus ce tableau de bord, sauf s'ils y ont accès autrement.",
  "dashboards.share.team_remove_success": "Accès de l'équipe retiré",
  "dashboards.new_dashboard": "Nouveau tableau de bord",
  "dashboards.create_first": "Créer votre premier tableau de bord",
  "dashboards.card_default_description": "Ouvrir le tableau de bord",

  // Reports (Insights → Reports)
  "reports.title": "Rapports",
  "reports.create": "Créer un rapport",
  "reports.teammate_create": "Créer avec le Reporting Teammate",
  "reports.teammate_source": "Reporting Teammate",
  "reports.generated_view_title": "Rapport généré",
  "reports.column.name": "Nom du rapport",
  "reports.column.data_source": "Source de données",
  "reports.column.owner": "Propriétaire",
  "reports.column.last_run": "Dernière exécution",
  "reports.never_run": "Jamais exécuté",
  "reports.owner.unknown": "—",
  "reports.legacy_pill": "Ancien",
  "reports.object_type.request": "Demandes",
  "reports.object_type.program": "Programmes",
  "reports.object_type.project": "Projets",
  "reports.object_type.work_item": "Éléments de travail",
  "reports.object_type.time_log": "Journaux de temps",
  "reports.object_type.time_off": "Congés",
  "reports.object_type.request.singular": "Demande",
  "reports.object_type.program.singular": "Programme",
  "reports.object_type.project.singular": "Projet",
  "reports.object_type.work_item.singular": "Élément de travail",
  "reports.object_type.time_log.singular": "Journal de temps",
  "reports.object_type.time_off.singular": "Congé",
  "reports.empty.title": "Aucun rapport pour le moment",
  "reports.empty.description":
    "Créez et exportez des vues de données personnalisées de votre espace de travail.",
  "reports.empty.create_first": "Créer votre premier rapport",
  "reports.row_actions.menu_aria": "Actions pour {name}",
  "reports.row_actions.open": "Ouvrir",
  "reports.row_actions.edit": "Modifier",
  "reports.row_actions.duplicate": "Dupliquer",
  "reports.row_actions.delete": "Supprimer",
  "reports.duplicate.success": "Rapport dupliqué",
  "reports.duplicate.error": "Impossible de dupliquer le rapport. Veuillez réessayer.",
  "reports.delete.title": "Supprimer le rapport",
  "reports.delete.message": "Supprimer « {name} » ? Cette action est irréversible.",
  "reports.delete.confirm": "Supprimer",
  "reports.delete.success": "Rapport supprimé",
  "reports.delete.error": "Impossible de supprimer le rapport. Veuillez réessayer.",
  "reports.builder.title_create": "Créer un rapport",
  "reports.builder.title_edit": "Modifier le rapport",
  "reports.builder.step.sources": "Type de rapport",
  "reports.builder.step.columns": "Colonnes",
  "reports.builder.step.filters": "Filtres",
  "reports.builder.step.name": "Nom et enregistrement",
  "reports.builder.back": "Précédent",
  "reports.builder.next": "Suivant",
  "reports.builder.save": "Enregistrer",
  "reports.builder.save_and_view": "Enregistrer et afficher",
  "reports.builder.step_sources.heading": "Sur quoi souhaitez-vous créer un rapport ?",
  "reports.builder.step_sources.description":
    "Choisissez le type d'objet sur lequel porte ce rapport. Vous en choisirez les colonnes et les filtres ensuite.",
  "reports.builder.step_sources.hint.request": "Demandes soumises par les parties prenantes.",
  "reports.builder.step_sources.hint.program": "Ensembles stratégiques de travail de formation.",
  "reports.builder.step_sources.hint.project": "Réalisations et livrables au sein des programmes.",
  "reports.builder.step_sources.hint.work_item": "Tâches et événements au sein des projets.",
  "reports.builder.step_sources.hint.time_log":
    "Temps enregistré avec le contexte projet et travail.",
  "reports.builder.step_sources.hint.time_off": "Congés des membres.",
  "reports.builder.step_columns.heading": "Choisir les colonnes",
  "reports.builder.step_columns.description":
    "Sélectionnez les colonnes à afficher, puis glissez-les pour définir leur ordre.",
  "reports.builder.step_columns.search_placeholder": "Rechercher des champs…",
  "reports.builder.step_columns.select_all": "Tout sélectionner",
  "reports.builder.step_columns.section.fields": "Champs",
  "reports.builder.step_columns.section.custom": "Champs personnalisés",
  "reports.builder.step_columns.section_selected_count": "{count} sélectionné(s)",
  "reports.builder.step_columns.no_fields": "Aucun champ ne correspond à votre recherche.",
  "reports.builder.step_columns.selected_heading": "Colonnes sélectionnées",
  "reports.builder.step_columns.clear_all": "Effacer",
  "reports.builder.step_columns.remove_aria": "Retirer {column}",
  "reports.builder.step_columns.reorder_aria": "Réordonner {column}",
  "reports.builder.step_columns.scope.custom": "Personnalisé",
  "reports.builder.step_columns.empty_title": "Aucune colonne",
  "reports.builder.step_columns.empty_description": "Cochez des champs à gauche pour les ajouter.",
  "reports.builder.catalog_error.permission_title":
    "Vous n'avez pas accès aux rapports de cet espace de travail",
  "reports.builder.catalog_error.permission_body":
    "Les rapports nécessitent un accès en lecture à cet espace de travail. Contactez un administrateur si cela vous semble incorrect.",
  "reports.builder.catalog_error.transient_body": "Impossible de charger la liste des champs.",
  "reports.builder.catalog_error.retry": "Réessayer",
  "reports.builder.step_filters.ref_error": "Impossible de charger les options.",
  "reports.builder.step_filters.heading": "Filtres",
  "reports.builder.step_filters.description":
    "Ajoutez des filtres pour restreindre les lignes retournées par le rapport. Chaque filtre doit correspondre.",
  "reports.builder.step_filters.no_columns":
    "Choisissez d'abord des colonnes — les filtres s'appliquent aux colonnes sélectionnées.",
  "reports.builder.step_filters.no_filterable_columns":
    "Aucune des colonnes sélectionnées ne peut être filtrée — les totaux calculés sont en lecture seule. Ajoutez une autre colonne à filtrer.",
  "reports.builder.step_filters.add": "Ajouter un filtre",
  "reports.builder.step_filters.field_placeholder": "Champ",
  "reports.builder.step_filters.operator_placeholder": "Condition",
  "reports.builder.step_filters.value_placeholder": "Valeur",
  "reports.builder.step_filters.value_select_placeholder": "Sélectionner une valeur",
  "reports.builder.step_filters.value_multi_placeholder": "Sélectionner des valeurs",
  "reports.builder.step_filters.value_search_placeholder": "Rechercher des valeurs…",
  "reports.builder.step_filters.value_empty": "Aucune valeur correspondante.",
  "reports.builder.step_filters.value_placeholder_start": "Début",
  "reports.builder.step_filters.value_placeholder_end": "Fin",
  "reports.builder.step_filters.remove_aria": "Retirer le filtre",
  "reports.builder.step_filters.empty":
    "Ajoutez un filtre pour restreindre les lignes retournées par le rapport.",
  "reports.builder.step_filters.required.heading": "Plage de dates (obligatoire)",
  "reports.builder.step_filters.required.hint":
    "Chaque rapport est limité à une plage de dates. Choisissez un préréglage ou une plage personnalisée.",
  "reports.builder.step_filters.required.range_aria": "Plage de dates",
  "reports.builder.step_filters.range_incomplete":
    "Saisissez une date de début et de fin pour la plage personnalisée afin de continuer.",
  "reports.builder.step_filters.optional.heading": "Filtres supplémentaires",
  "reports.builder.step_filters.range.last_7": "7 derniers jours",
  "reports.builder.step_filters.range.last_30": "30 derniers jours",
  "reports.builder.step_filters.range.last_90": "90 derniers jours",
  "reports.builder.step_filters.range.custom": "Personnalisée",
  "reports.filter_range.last_n_days": "{days} derniers jours",
  "reports.filter_operator.equals": "est",
  "reports.filter_operator.not_equals": "n'est pas",
  "reports.filter_operator.contains": "contient",
  "reports.filter_operator.not_contains": "ne contient pas",
  "reports.filter_operator.in": "est l'un de",
  "reports.filter_operator.not_in": "n'est aucun de",
  "reports.filter_operator.on": "le",
  "reports.filter_operator.before": "avant",
  "reports.filter_operator.after": "après",
  "reports.filter_operator.between": "entre",
  "reports.filter_operator.greater_than": "supérieur à",
  "reports.filter_operator.less_than": "inférieur à",
  "reports.filter_operator.is_empty": "est vide",
  "reports.filter_operator.is_not_empty": "n'est pas vide",
  "reports.builder.step_name.heading": "Nommer votre rapport",
  "reports.builder.step_name.description":
    "Les rapports sont privés. Les données affichées reflètent votre niveau d'accès à l'espace de travail.",
  "reports.builder.step_name.name_label": "Nom du rapport",
  "reports.builder.step_name.name_placeholder": "ex. Projets — export T2",
  "reports.builder.summary.report_type": "Type de rapport",
  "reports.builder.summary.columns": "Colonnes",
  "reports.builder.summary.filters": "Filtres",
  "reports.builder.summary.count": "{count}",
  "reports.builder.summary.privacy_note": "Vous seul pouvez voir ce rapport.",
  "reports.privacy.records_note":
    "Vous ne verrez que les enregistrements auxquels vous avez déjà accès.",
  "reports.builder.create.success": "Rapport créé",
  "reports.builder.update.success": "Rapport enregistré",
  "reports.builder.save.error": "Impossible d'enregistrer le rapport. Veuillez réessayer.",
  "reports.builder.cancel_confirm.title": "Abandonner ce rapport ?",
  "reports.builder.cancel_confirm.message":
    "Vos modifications n'ont pas été enregistrées et seront perdues.",
  "reports.builder.cancel_confirm.confirm": "Abandonner",
  "reports.builder.cancel_confirm.title_edit": "Abandonner les modifications ?",
  "reports.builder.cancel_confirm.message_edit":
    "Vos modifications non enregistrées de ce rapport seront perdues.",
  "reports.builder.cancel_confirm.confirm_edit": "Abandonner les modifications",
  "reports.builder.cancel_confirm.keep_editing": "Continuer l'édition",
  "reports.view.reporting_on": "Rapport sur : {objects}",
  "reports.view.edit": "Modifier",
  "reports.view.rerun": "Réexécuter",
  "reports.view.export": "Exporter CSV",
  "reports.view.filters_label": "Filtres",
  "reports.view.filters_aria": "Filtres actifs du rapport",
  "reports.view.filters_none": "Aucun",
  "reports.view.edit_filters": "Modifier les filtres",
  "reports.view.stale_warning":
    "Un ou plusieurs champs ne sont plus disponibles — modifiez le rapport.",
  "reports.view.stale_edit": "Modifier le rapport",
  "reports.view.stale_warning_read_only": "Un ou plusieurs champs ne sont plus disponibles.",
  "reports.view.owner_only_run": "Seul le propriétaire du rapport peut l'exécuter.",
  "reports.view.legacy_banner":
    "Il s'agit d'un ancien rapport multi-types, désormais figé. Vous pouvez le consulter, l'exporter et le supprimer, mais pas le modifier, le réexécuter ni le dupliquer.",
  "reports.view.generating": "Génération du rapport…",
  "reports.view.never_run_title": "Ce rapport n'a pas encore été exécuté",
  "reports.view.never_run_description":
    "Exécutez-le pour générer un instantané des données actuelles.",
  "reports.view.run_prompt": "Exécuter ce rapport",
  "reports.view.failed_title": "L'exécution de ce rapport a échoué",
  "reports.view.failed_description":
    "Une erreur s'est produite lors de la génération de l'instantané. Réexécutez pour réessayer.",
  "reports.view.failed_retry": "Réexécuter le rapport",
  "reports.view.last_run": "Dernière exécution {date} · {count} lignes",
  "reports.view.not_found_title": "Rapport introuvable",
  "reports.view.not_found_description":
    "Ce rapport n'existe pas ou vous n'y avez pas accès. Les rapports sont privés et réservés à la personne qui les a créés.",
  "reports.view.not_found_back": "Retour aux rapports",
  "reports.export.async_queued":
    "L'export est en cours de préparation — nous vous préviendrons dès qu'il sera prêt.",
  "reports.export.async_error": "Impossible de démarrer l'export. Veuillez réessayer.",
  "dashboards.help.target_vs_actual_label": "Comment l'objectif et le réel sont calculés",
  "dashboards.help.target_vs_actual":
    "L'utilisation réelle correspond au travail planifié ÷ la capacité disponible sur la période. La capacité disponible correspond aux heures de travail de chaque personne pondérées par son % de capacité ; l'objectif correspond à cette capacité disponible pondérée par son % d'utilisation cible (la valeur par défaut de l'espace de travail, sauf remplacement individuel).",
  "dashboards.help.fan_out_dimension_label": "Pourquoi ces barres peuvent dépasser le total",
  "dashboards.help.fan_out_dimension":
    "Cet axe ({dimension}) peut contenir plusieurs valeurs par enregistrement. Chaque enregistrement est compté en entier sous chacune de ses valeurs, si bien que la somme des barres peut dépasser le total global.",
  "dashboards.capacity_scope.over_limit": "En surcharge",
  "dashboards.capacity_scope.all": "Tous",
  "dashboards.filters": "Filtres",
  "dashboards.filter.range_label": "Date",
  "dashboards.filter.back_to_filters": "Retour \u00e0 tous les filtres",
  "dashboards.filter.custom_field_fallback": "Champ personnalisé",
  "dashboards.filter.add_filter": "Ajouter un filtre",
  "dashboards.filter.range_all": "Tout",
  "dashboards.filter.range_custom": "Plage personnalisée",
  "dashboards.filter.range_from": "Du",
  "dashboards.filter.range_to": "Au",
  "dashboards.filter.range_last_quarter": "Trimestre dernier",
  "dashboards.filter.range_this_quarter": "Ce trimestre",
  "dashboards.filter.range_7d": "7 derniers jours",
  "dashboards.filter.range_30d": "30 derniers jours",
  "dashboards.filter.range_quarter": "Trimestre",
  "dashboards.filter.range_ytd": "Depuis le début de l'année",
  "dashboards.filter.projects": "Projets",
  "dashboards.filter.status": "Groupe de statuts",
  "dashboards.filter.state_group.new": "Nouveau",
  "dashboards.filter.state_group.backlog": "En attente",
  "dashboards.filter.state_group.unstarted": "Non commencé",
  "dashboards.filter.state_group.in_review": "En révision",
  "dashboards.filter.state_group.waitlisted": "En liste d'attente",
  "dashboards.filter.state_group.started": "En cours",
  "dashboards.filter.state_group.on_hold": "En pause",
  "dashboards.filter.state_group.accepted": "Accepté",
  "dashboards.filter.state_group.delivered": "Livré",
  "dashboards.filter.state_group.completed": "Terminé",
  "dashboards.filter.state_group.declined": "Refusé",
  "dashboards.filter.state_group.cancelled": "Annulé",
  "dashboards.filter.assignee": "Assigné·e",
  "dashboards.filter.lob": "Secteur d'activité",
  "dashboards.filter.request_type": "Type de demande",
  "dashboards.scope_chip_n_projects": "{count} projets",
  "dashboards.filter.clear_one": "Effacer",
  "dashboards.filter.category": "Catégorie",
  "dashboards.filter.request_category": "Catégorie de demande",
  "dashboards.filter.clear_all": "Tout effacer",
  "dashboards.filter.teams": "Équipe",
  "dashboards.filter.home_teams": "Équipe principale",
  "dashboards.filter.goals": "Objectif",
  "dashboards.filter.no_options": "Aucune option disponible.",
  "dashboards.filter.cf.contains": "Contient",
  "dashboards.filter.cf.min": "Min",
  "dashboards.filter.cf.apply": "Appliquer (Entr\u00e9e)",
  "dashboards.filter.cf.enter_number": "Saisir un nombre",
  "dashboards.filter.cf.max": "Max",
  "dashboards.filter.cf.from": "Du",
  "dashboards.filter.cf.to": "Au",
  "dashboards.filter.cf.any": "Tous",
  "dashboards.filter.cf.yes": "Oui",
  "dashboards.filter.cf.no": "Non",

  // Capacity trajectory reporting
  "capacity_trajectory.title": "Trajectoire d'utilisation sur 8 semaines",
  "capacity_trajectory.dashboard_card":
    "Prévision hebdomadaire par membre avec pics de surcharge projetés",
  "capacity_trajectory.eyebrow": "Prévision",
  "capacity_trajectory.subtitle":
    "Petits multiples · axe Y 0-150 % d'utilisation · zone de surcharge · projections depuis le plan actuel et le travail réservé",
  "capacity_trajectory.anchor_label": "Semaine repère",
  "capacity_trajectory.anchor_week_suffix": "semaine repère",
  "capacity_trajectory.projection_note": "Les semaines suivantes sont projetées",
  "capacity_trajectory.loading": "Chargement de la trajectoire d'utilisation...",
  "capacity_trajectory.load_error": "Échec du chargement de la trajectoire d'utilisation.",
  "capacity_trajectory.empty":
    "Aucune utilisation de membre retournée pour cette fenêtre de 8 semaines.",
  "capacity_trajectory.member_label": "Capacité de l'espace de travail",
  "capacity_trajectory.chart_label": "Trajectoire d'utilisation de {member}",
  "capacity_trajectory.anchor_value": "repère {percent} %",
  "capacity_trajectory.peak_value": "pic {week} {percent} %",
  "capacity_trajectory.summary_peak": "Pic {percent} %",
  "capacity_trajectory.summary_overloaded": "{count} en surcharge",
  "capacity_trajectory.load_more": "Charger plus de membres",
  "capacity_trajectory.loading_more": "Chargement...",

  // Capacity reporting
  "capacity_reporting.title": "Rapport de capacité",
  "capacity_reporting.dashboard_card": "Capacité, utilisation, variance et états de disponibilité",
  "capacity_reporting.scope_label": "Portée",
  "capacity_reporting.target_label": "Cible",
  "capacity_reporting.group_label": "Regrouper par",
  "capacity_reporting.refresh": "Actualiser",
  "capacity_reporting.range_separator": "au",
  "capacity_reporting.loading": "Chargement du rapport de capacité...",
  "capacity_reporting.load_error": "Échec du chargement du rapport de capacité.",
  "capacity_reporting.options_error": "Échec du chargement des options du rapport.",
  "capacity_reporting.spread_loading": "Chargement de la répartition d'utilisation...",
  "capacity_reporting.spread_error": "Échec du chargement de la répartition d'utilisation.",
  "capacity_reporting.no_targets": "Aucune cible",
  "capacity_reporting.empty": "Aucune donnée de capacité pour cette période.",
  "capacity_reporting.scope.workspace": "Espace de travail",
  "capacity_reporting.scope.team": "Espace d'équipe",
  "capacity_reporting.scope.project": "Projet",
  "capacity_reporting.scope.program": "Programme",
  "capacity_reporting.scope.member": "Membre",
  "capacity_reporting.metric.capacity": "Capacité",
  "capacity_reporting.metric.planned": "Planifié",
  "capacity_reporting.metric.actual": "Réel",
  "capacity_reporting.metric.remaining": "Restant",
  "capacity_reporting.metric.utilization": "Utilisation",
  "capacity_reporting.metric.variance": "Variance",
  "capacity_reporting.metric.planned_tasks": "Tâches planifiées",
  "capacity_reporting.metric.planned_events": "Événements planifiés",
  "capacity_reporting.metric.actual_tasks": "Tâches réelles",
  "capacity_reporting.metric.actual_events": "Événements réels",
  "capacity_reporting.metric.other_allocation": "Autre allocation",
  "capacity_reporting.metric.actual_utilization": "Utilisation réelle",
  "capacity_reporting.metric.accuracy": "Précision",
  "capacity_reporting.breakdown_title": "Réel vs planifié",
  "capacity_reporting.open_capacity": "Ouvrir la grille de capacité",
  "capacity_reporting.state_mix_title": "États de disponibilité",
  "capacity_reporting.state_mix_empty": "Aucun état de disponibilité retourné.",
  "capacity_reporting.table_label": "Rapport de capacité par période",
  "capacity_reporting.column.period": "Période",
  "capacity_reporting.column.capacity": "Capacité",
  "capacity_reporting.column.planned": "Planifié",
  "capacity_reporting.column.actual": "Réel",
  "capacity_reporting.column.remaining": "Restant",
  "capacity_reporting.column.state": "État",
  "capacity_reporting.column.utilization": "Utilisation",
  "capacity_reporting.column.accuracy": "Précision",
  "sidebar.favorites": "Favoris",
  "sidebar.work_items": "Tâches",
  "sidebar.projects": "Projets",
  "sidebar.intake": "Réception",
  "sidebar.events": "Événements",
  "sidebar.availability": "Disponibilité",
  "sidebar.capacity": "Capacité",
  "sidebar.collapse": "Réduire",
  "sidebar.open_navigation": "Ouvrir la navigation",
  "sidebar.close_navigation": "Fermer la navigation",
  "sidebar.navigation": "Navigation",
  "sidebar.resize": "Redimensionner la barre latérale",
  "sidebar.no_favorites": "Aucun favori",
  "sidebar.no_projects": "Aucun projet",
  "sidebar.project_nav.issues": "Éléments de travail",
  "sidebar.project_nav.views": "Vues",
  "sidebar.project_nav.capacity": "Capacité",
  "sidebar.project_nav.settings": "Paramètres",
  "sidebar.team_nav.projects": "Projets",
  "sidebar.team_nav.no_projects": "Aucun projet pour l'instant",

  // User menu
  "user_menu.my_profile": "Mon profil",
  "user_menu.help_center": "Centre d'aide",
  "user_menu.chat_with_us": "Parlez-nous",
  "user_menu.sign_out": "Se déconnecter",
  "intercom.unavailable_title": "Le chat n'est pas disponible",
  "intercom.unavailable_body":
    "Votre réseau bloque peut-être le chat. Le Centre d'aide répond à la plupart des questions.",

  // User
  "user.welcome": "Bienvenue, {name} !",
  "user.fetch_info": "Récupérer les informations",
  "user.email": "Adresse e-mail",
  "user.role": "Rôle",
  "user.last_login": "Dernière connexion",
  "user.fetch_success": "Informations chargées",
  "user.fetch_error": "Impossible de charger les informations",

  // Workspace
  "workspace.workspace": "Espace de travail",
  "workspace.create": "Créer un espace de travail",
  "workspace.settings": "Paramètres de l'espace",
  "workspace.invitations": "Invitations d'espace de travail",
  "workspace.role.admin": "Administrateur",
  "workspace.role.member": "Membre",
  "workspace.role.guest": "Invité",
  "workspace.member_count": "{count} membres",
  "workspace.suspended_label": "Suspendu",
  "workspace.suspended_title": "Cet espace de travail est suspendu.",
  "workspace.suspended_description": "Contactez l’administrateur de votre espace de travail.",
  "workspace.demo_label": "(Démo)",
  "workspace.email_suppression_banner":
    "Les e-mails de notification sont désactivés pour cet espace de travail.",
  "workspace.type_sandbox": "Bac à sable",
  "workspace.type_trial": "Essai",
  "workspace.type_internal": "Interne",
  "workspace.demo_create_hint": "Cet espace de travail sera créé comme espace de démonstration.",
  "workspace.type_label": "Type d'espace de travail",
  "workspace.create_title": "Créer un nouvel espace de travail",
  "workspace.name_label": "Nom de l'espace de travail",
  "workspace.name_placeholder": "Mon espace de travail",
  "workspace.url_label": "URL de l'espace de travail",
  "workspace.currency_label": "Devise de l'organisation",
  "workspace.slug_checking": "Vérification de la disponibilité...",
  "workspace.slug_available": "Disponible",
  "workspace.slug_taken": "Cette URL est déjà prise",
  "workspace.create_success": "Espace de travail créé avec succès",
  "workspace.create_error": "Échec de la création de l'espace de travail",
  "workspace.creation_disabled":
    "La création d'espaces de travail est désactivée. Contactez votre administrateur.",
  "workspace_settings.tabs.general": "Général",
  "workspace_settings.tabs.teams": "Équipes",
  "workspace_settings.tabs.members": "Membres",
  "workspace_settings.tabs.roles": "Rôles",
  "workspace_settings.tabs.exports": "Exports",
  "workspace_settings.tabs.audit_log": "Journal d'audit",
  "workspace_settings.tabs.automations": "Automatisations",
  "workspace_settings.automations.title": "Automatisations par défaut",
  "workspace_settings.automations.description":
    "Les nouvelles équipes démarrent avec une copie de ces paramètres, que les responsables d'équipe peuvent ensuite modifier. La publication ne modifie jamais les équipes existantes.",
  "workspace_settings.automations.published":
    "Publié · les nouvelles équipes démarreront avec ces paramètres",
  "workspace_settings.automations.published_by":
    "Publié par {name} le {date} · les nouvelles équipes démarreront avec ces paramètres",
  "workspace_settings.automations.publish_success":
    "Automatisations par défaut publiées. Les nouvelles équipes démarreront avec ces paramètres.",
  "workspace_settings.automations.publish_error":
    "Impossible de publier les automatisations par défaut. Veuillez réessayer.",
  "workspace_settings.automations.discard_confirm_description":
    "Les automatisations par défaut reviendront à la dernière version publiée. Cette action est irréversible.",
  "workspace_settings.automations.read_only":
    "Vous pouvez consulter les automatisations par défaut, mais pas les modifier.",
  "workspace_settings.automations.load_error":
    "Impossible de charger les automatisations par défaut.",
  "workspace_settings.automations.apply.title": "Appliquer les valeurs par défaut aux équipes",
  "workspace_settings.automations.apply.replaces":
    "Remplace les automatisations à l'échelle de l'équipe et les valeurs par défaut des projets des équipes sélectionnées par les valeurs par défaut publiées. Les modifications faites par les responsables de projet dans leurs propres projets ne sont pas affectées.",
  "workspace_settings.automations.apply.unpublished":
    "Seules les valeurs par défaut publiées seront appliquées. Vos modifications non publiées ne le seront pas.",
  "workspace_settings.automations.apply.broken_default":
    "« {automation} » utilise un statut supprimé ou déplacé. Corrigez-le et publiez avant d'appliquer.",
  "workspace_settings.automations.apply.search": "Rechercher des équipes",
  "workspace_settings.automations.apply.clear_search": "Effacer la recherche",
  "workspace_settings.automations.apply.select_all": "Sélectionner toutes les équipes",
  "workspace_settings.automations.apply.select_all_matching":
    "Sélectionner toutes les équipes correspondantes",
  "workspace_settings.automations.apply.no_match": "Aucune équipe ne correspond.",
  "workspace_settings.automations.apply.selected_count":
    "{count} équipe(s) sélectionnée(s) sur {total}",
  "workspace_settings.automations.apply.confirm":
    "Appliquer à {count, plural, one {# équipe} other {# équipes}}",
  "workspace_settings.automations.apply.applying": "Application…",
  "workspace_settings.automations.apply.success":
    "Valeurs par défaut appliquées à {count, plural, one {# équipe} other {# équipes}}",
  "workspace_settings.automations.apply.error":
    "Impossible d'appliquer les valeurs par défaut. Réessayez.",
  "workspace_settings.automations.apply.footnote":
    "Prend effet immédiatement sur les projets et demandes ouverts des équipes sélectionnées. Leurs responsables d'équipe sont avertis et la modification est consignée dans le journal d'audit.",
  "workspace_settings.automations.apply.teams_gone": "Ces équipes n'existent plus : {teams}",
  "workspace_settings.automations.apply.open": "Appliquer aux équipes…",
  "automations.page.unpublished_changes": "Modifications non publiées",
  "automations.page.publish": "Publier",
  "automations.page.discard": "Abandonner",
  "automations.page.discard_confirm_title": "Abandonner les modifications non publiées ?",
  "automations.page.discard_confirm": "Abandonner les modifications",
  "automations.page.discard_cancel": "Continuer la modification",
  "automations.page.discard_error":
    "Impossible d'abandonner les modifications. Veuillez réessayer.",
  "automations.page.conflict_title": "Quelqu'un d'autre a modifié ces paramètres",
  "automations.page.conflict_description":
    "Vous voyez maintenant leur dernière version. Refaites votre modification si elle est toujours nécessaire.",
  "automations.scope.team_wide.title": "Toute l’équipe",
  "automations.scope.team_wide.description":
    "Copiées dans chaque équipe. Les responsables d’équipe peuvent les modifier ; les responsables de projet ne le peuvent pas.",
  "automations.scope.project_default.title": "Valeurs par défaut des projets",
  "automations.scope.project_default.description":
    "Copiées dans chaque équipe comme valeurs par défaut de ses projets. Les responsables de projet peuvent les modifier pour leur propre projet.",
  "automations.section.projects.title": "Projets",
  "automations.section.projects.description": "S’applique à chaque projet de l’équipe.",
  "automations.section.requests.title": "Demandes",
  "automations.section.requests.description": "S’applique à chaque demande de l’équipe.",
  "automations.section.archiving.title": "Archivage",
  "automations.section.archiving.description":
    "Les éléments archivés peuvent être restaurés à tout moment.",
  "automations.section.work_items.title": "Éléments de travail",
  "automations.section.work_items.description":
    "S’applique aux éléments de travail de chaque projet de l’équipe, sauf si un responsable de projet le modifie.",
  "automations.team.scope.team_wide.description":
    "S’appliquent à chaque projet et à chaque demande de cette équipe. Les responsables de projet ne peuvent pas les modifier.",
  "automations.team.scope.project_default.description":
    "Paramètres de départ de chaque projet de cette équipe. Les responsables de projet peuvent les modifier pour leur propre projet.",
  "automations.team.section.projects.description":
    "S’applique à chaque projet dont l’équipe d’origine est cette équipe.",
  "automations.team.section.requests.description":
    "S’applique à chaque demande dont l’équipe d’origine est cette équipe.",
  "automations.team.section.archiving.description":
    "Les éléments archivés peuvent être restaurés à tout moment.",
  "automations.project.section.work_items.description":
    "S'applique aux éléments de travail de ce projet.",
  "automations.team.section.work_items.description":
    "S’applique aux éléments de travail de chaque projet de cette équipe, sauf si un responsable de projet le modifie.",
  "automations.rule.close_project_on_last_work_item.title":
    "Clôturer les projets ouverts lorsque leur dernier élément de travail est terminé",
  "automations.rule.close_project_on_last_work_item.description":
    "S’exécute lorsque tous les éléments de travail sont fermés et qu’au moins un est terminé. Si tous ont été annulés, le statut du projet ne change pas.",
  "automations.rule.close_project_on_last_work_item.label_before": "Passer le projet à un statut",
  "automations.rule.cancel_work_items_on_project_cancel.title":
    "Annuler les éléments de travail ouverts lorsque le projet est annulé",
  "automations.rule.cancel_work_items_on_project_cancel.description":
    "S’exécute lorsqu’un projet passe à un statut Annulé. Ses éléments de travail ouverts sont annulés ; les éléments terminés restent inchangés.",
  "automations.rule.cancel_work_items_on_project_cancel.label_before":
    "Passer les éléments de travail ouverts à un statut",
  "automations.rule.mark_request_delivered.title":
    "Marquer les demandes comme livrées lorsque tous les projets liés sont terminés",
  "automations.rule.mark_request_delivered.description":
    "S’exécute lorsqu’une demande est dans un statut Acceptée, que tous les projets liés sont fermés et qu’au moins un est terminé. Si tous les projets liés ont été annulés, le statut de la demande ne change pas.",
  "automations.rule.mark_request_delivered.label_before": "Passer la demande à un statut",
  "automations.rule.archive_closed_work_items.title": "Archiver les éléments de travail fermés",
  "automations.rule.archive_closed_work_items.description":
    "Archive les éléments de travail restés dans un statut Terminé ou Annulé pendant le nombre de jours défini. Le décompte repart si un élément est rouvert.",
  "automations.rule.archive_closed_projects.title": "Archiver les projets fermés",
  "automations.rule.archive_closed_projects.description":
    "Archive les projets restés dans un statut Terminé ou Annulé pendant le nombre de jours défini. Le décompte repart si un projet est rouvert.",
  "automations.rule.archive_accepted_requests.title": "Archiver les demandes acceptées",
  "automations.rule.archive_accepted_requests.description":
    "Archive les demandes restées dans un statut Acceptée pendant le nombre de jours défini. Les demandes archivées peuvent toujours être marquées comme livrées.",
  "automations.rule.archive_closed_requests.title": "Archiver les demandes fermées",
  "automations.rule.archive_closed_requests.description":
    "Archive les demandes restées dans un statut Livrée, Refusée ou Annulée pendant le nombre de jours défini. Le décompte repart si une demande est rouverte.",
  "automations.rule.close_parent_on_last_sub_item.title":
    "Clôturer le parent lorsque son dernier sous-élément est terminé",
  "automations.rule.close_parent_on_last_sub_item.description":
    "S’exécute lorsque tous les sous-éléments sont fermés et qu’au moins un est terminé. Si tous ont été annulés, le statut du parent ne change pas.",
  "automations.rule.close_parent_on_last_sub_item.label_before": "Passer le parent à un statut",
  "automations.rule.complete_sub_items_on_parent_complete.title":
    "Terminer les sous-éléments ouverts lorsque le parent est terminé",
  "automations.rule.complete_sub_items_on_parent_complete.description":
    "S’exécute lorsqu’un élément de travail parent passe à un statut Terminé. Ses sous-éléments ouverts sont terminés ; les sous-éléments annulés restent inchangés.",
  "automations.rule.complete_sub_items_on_parent_complete.label_before":
    "Passer les sous-éléments ouverts à un statut",
  "automations.rule.cancel_sub_items_on_parent_cancel.title":
    "Annuler les sous-éléments ouverts lorsque le parent est annulé",
  "automations.rule.cancel_sub_items_on_parent_cancel.description":
    "S’exécute lorsqu’un élément de travail parent passe à un statut Annulé. Ses sous-éléments ouverts sont annulés ; les sous-éléments terminés restent inchangés.",
  "automations.rule.cancel_sub_items_on_parent_cancel.label_before":
    "Passer les sous-éléments ouverts à un statut",
  "automations.group.completed": "Terminé",
  "automations.group.cancelled": "Annulé",
  "automations.group.delivered": "Livrée",
  "automations.status_suffix": "",
  "automations.status_picker_label": "{labelBefore} {group}",
  "automations.choose_status": "Choisir un statut",
  "automations.days.before": "Archiver après",
  "automations.days.input_label.closed": "{title} : archiver après (jours de fermeture)",
  "automations.days.input_label.accepted": "{title} : archiver après (jours d’acceptation)",
  "automations.days.after.closed": "jours de fermeture",
  "automations.days.after.accepted": "jours d’acceptation",
  "automations.invalid_status":
    "Ce statut a été supprimé ou déplacé dans un autre groupe. Choisissez un autre statut.",
  "automations.no_status":
    "Ajoutez un statut {group} dans Statuts pour utiliser cette automatisation.",
  "workspace_settings.tabs.webhooks": "Webhooks",
  "workspace_settings.tabs.ai_provider": "Fournisseur d'IA",
  "workspace_settings.tabs.digital_teammates": "Coéquipiers numériques",
  "workspace_settings.tabs.integration_library": "Bibliothèque d'intégrations",
  "integration_library.title": "Bibliothèque d'intégrations",
  "integration_library.description":
    "Connectez Cognota aux systèmes où votre formation se déroule déjà.",
  "integration_library.threesixty.name": "360Learning",
  "integration_library.threesixty.description":
    "Synchronisez votre catalogue, vos apprenants et vos résultats de cours 360Learning avec Cognota.",
  "integration_library.threesixty.credentials_gone_hint":
    "Cette société a été déconnectée : plus rien n’en est synchronisé. Ses associations et tout ce qui a déjà été synchronisé sont conservés, et la reconnexion les reprend.",
  // NG-1366 : le catalogue. Les deux intégrations planifiées portent un nom et
  // une catégorie, sans description : la maquette les dessine ainsi, et écrire
  // un texte pour une intégration non cadrée reviendrait à promettre.
  "integration_library.categories.all": "Toutes",
  "integration_library.categories.learning_platform": "Plateformes d'apprentissage",
  "integration_library.categories.communication": "Communication",
  "integration_library.availability.available": "Disponible",
  "integration_library.availability.installed": "Installé",
  "integration_library.availability.planned": "Planifiée",
  "integration_library.availability.planned_hint":
    "Ces intégrations ne sont pas encore disponibles.",
  "integration_library.slack.name": "Slack",
  "integration_library.cornerstone.name": "Cornerstone OnDemand",
  "integration_library.cornerstone.short_name": "Cornerstone",
  // NG-1489 : la page de l'intégration. Le badge de direction dit ce que dit la
  // table de dispatch : cette intégration lit et n'écrit pas.
  "integration_library.connector.direction_in": "Vers Cognota",
  "integration_library.connector.built_by": "Développée par Cognota",
  "integration_library.connector.add_connection": "Ajouter une connexion",
  "integration_library.connector.connections_heading":
    "{count, plural, one {Connexion · #} other {Connexions · #}}",
  "integration_library.connector.connections_hint":
    "Chaque société 360Learning a ses propres identifiants, webhooks, limites de débit et état de connexion. Vous utilisez plusieurs sociétés 360Learning ? Ajoutez une connexion pour chacune.",
  "integration_library.connector.cornerstone.connections_hint":
    "Chaque portail Cornerstone a ses propres identifiants, limites de débit et état de connexion. Vous utilisez plusieurs portails Cornerstone ? Ajoutez une connexion pour chacun.",
  "integration_library.connector.row_actions": "Autres actions pour {name}",
  "integration_library.connector.last_sync_label": "Dernière synchronisation",
  "integration_library.connector.last_test_label": "Dernier test",
  "integration_library.connector.last_test_never": "Pas encore testé",
  "integration_library.connector.direction_out": "Vers Teams",
  "integration_library.connector.msteams.syncs_in":
    "Votre propre adresse e-mail Microsoft, lue une seule fois lorsque vous ajoutez l'application, afin de vous associer à votre utilisateur Cognota. Aucun contenu de message, aucun fichier, aucune synchronisation d'annuaire ni de liste de membres.",
  "integration_library.connector.msteams.syncs_out":
    "Les notifications que vous recevez déjà par e-mail et dans l'application, livrées sous forme de messages Teams.",
  "integration_library.connector.msteams.before_lead":
    "La connexion vous authentifie auprès de Microsoft afin que Cognota sache quelle organisation Microsoft 365 connecter. Elle demande uniquement votre nom, votre e-mail et votre authentification.",
  "integration_library.connector.msteams.before_step_1":
    "Connectez-vous avec un compte Microsoft de l'organisation que vous souhaitez connecter.",
  "integration_library.connector.msteams.before_step_2":
    "Transmettez à votre administrateur Teams le package de l'application et les étapes affichées ici, afin qu'il autorise l'application pour vos équipes.",
  "integration_library.connector.syncs_heading": "Ce qui est synchronisé",
  "integration_library.connector.syncs_in_label": "Ce qui entre",
  "integration_library.connector.syncs_out_label": "Rien ne repart",
  "integration_library.connector.syncs_out_label_sends": "Ce qui sort",
  "integration_library.connector.before_heading": "Avant de connecter",
  "integration_library.connector.permissions_label": "Autorisations requises",
  "integration_library.connector.secret_label": "Stockage du secret",
  "integration_library.connector.secret_value": "Chiffré, jamais réaffiché",
  "integration_library.connector.who_label": "Qui peut connecter",
  "integration_library.connector.who_value":
    "Les membres qui peuvent modifier les paramètres de l'espace de travail",
  "integration_library.connector.unconfirmed_scopes_title":
    "{name} : Cognota n'a pas pu confirmer toutes les autorisations",
  "integration_library.connector.unconfirmed_scopes_body":
    "Ces vérifications n'ont pas abouti : {scopes}. Il s'agit souvent d'une indisponibilité temporaire de {vendor} plutôt que d'une autorisation manquante. Testez de nouveau la connexion ; si cela persiste, demandez à un administrateur de la plateforme {vendor} de les confirmer.",
  "integration_library.connector.missing_scopes_title":
    "{name} ne peut pas tout lire parmi ce que Cognota synchronise",
  "integration_library.connector.missing_scopes_body":
    "Demandez à un administrateur de la plateforme {vendor} d'ajouter {scopes}, puis testez de nouveau la connexion. Le catalogue et les apprenants continuent de se synchroniser.",
  "integration_library.connector.threesixty.syncs_in":
    "Les cours et parcours d'apprentissage, les apprenants et les résultats de cours.",
  "integration_library.connector.threesixty.syncs_out":
    "Cognota ne crée ni ne modifie rien dans 360Learning.",
  "integration_library.connector.threesixty.before_lead":
    "Vous avez besoin d'un identifiant API v2 pour chaque société 360Learning que vous connectez.",
  "integration_library.connector.threesixty.before_step_1":
    "Dans 360Learning, ouvrez Paramètres > API v2 et créez un identifiant.",
  "integration_library.connector.threesixty.before_step_2":
    "Copiez le secret client. 360Learning ne l'affiche qu'une seule fois, à la création, et jamais ensuite.",
  "integration_library.connector.threesixty.before_step_3":
    "Collez l'adresse de la plateforme, l'identifiant client et le secret dans Connecter.",
  // NG-2242 : la page de Cornerstone. Ce qui entre est ce que lit sa
  // synchronisation (employés, catalogue, relevés) ; rien ne repart.
  "integration_library.connector.cornerstone.syncs_in":
    "Les objets d'apprentissage de votre catalogue, les apprenants et leurs relevés de formation.",
  "integration_library.connector.cornerstone.syncs_out":
    "Cognota ne crée ni ne modifie rien dans Cornerstone.",
  "integration_library.connector.cornerstone.before_lead":
    "Vous avez besoin d'une application OAuth 2.0 créée dans Edge API Management de Cornerstone pour chaque portail Cornerstone que vous connectez.",
  "integration_library.connector.cornerstone.before_step_1":
    "Dans Cornerstone, ouvrez Edge API Management et enregistrez une application OAuth 2.0 capable de lire les employés, le catalogue de formation et les relevés de formation.",
  "integration_library.connector.cornerstone.before_step_2":
    "Associez-la à un compte de service dédié disposant d'un accès en lecture, et non au compte d'une personne. Les autorisations de ce compte limitent ce que Cognota peut lire.",
  "integration_library.connector.cornerstone.before_step_3":
    "Collez l'adresse de votre portail, l'identifiant client et le secret dans Connecter.",
  // NG-1490 : les deux onglets.
  "integration_library.tabs_label": "Vues de la bibliothèque d'intégrations",
  "integration_library.installed.tab": "Installées",
  "integration_library.installed.companies": "{count, plural, one {# société} other {# sociétés}}",
  "integration_library.installed.last_sync": "dernière synchro {when}",
  "integration_library.installed.enabled_at": "Activé le {when}",
  "integration_library.installed.no_install_seen": "aucune installation détectée",
  "integration_library.installed.empty_title": "Aucune intégration pour l'instant",
  "integration_library.installed.empty_description":
    "Commencez par la première. Explorer présente tout ce à quoi Cognota se connecte, de votre LMS à votre calendrier.",
  "integration_library.installed.empty_action": "Explorer les intégrations",
  "integration_library.explore.tab": "Explorer",
  "integration_library.explore.search_placeholder": "Rechercher des intégrations",
  "integration_library.explore.search_label": "Rechercher des intégrations",
  "integration_library.explore.categories_label": "Filtrer par catégorie",
  "integration_library.explore.available_heading": "Disponibles · {count}",
  "integration_library.explore.planned_heading": "Planifiées · {count}",
  "integration_library.explore.manage": "Gérer",
  "integration_library.explore.no_results": 'Aucune intégration ne correspond à "{query}".',
  "integration_library.state.active": "Actif",
  "integration_library.state.paused": "En pause",
  "integration_library.state.not_connected": "Non connecté",
  "integration_library.connect.action": "Connecter",
  "integration_library.connect.update_credentials": "Mettre à jour les identifiants",
  "integration_library.connect.reconnect_action": "Reconnecter",
  "integration_library.connect.title": "Connecter {vendor}",
  "integration_library.connect.description":
    "Cognota vérifie l'identifiant auprès de votre plateforme avant de l'enregistrer, ce qui prend quelques secondes.",
  "integration_library.connect.name_label": "Nom de la connexion",
  "integration_library.connect.name_placeholder": "{vendor} - EMEA",
  "integration_library.connect.name_hint":
    "Le nom de cette connexion partout où il faut choisir entre plusieurs, par exemple lors de l'association d'un cours à un projet.",
  "integration_library.connect.platform_url_label": "Adresse de la plateforme",
  "integration_library.connect.client_id_label": "Identifiant client",
  "integration_library.connect.client_secret_label": "Secret client",
  "integration_library.connect.client_secret_hint":
    "360Learning ne l'affiche qu'une seule fois, à la création. Il est stocké chiffré et n'est jamais réaffiché.",
  "integration_library.connect.cornerstone.platform_url_hint":
    "L'adresse de votre portail Cornerstone, par exemple acme.csod.com. Les portails pilote et de préproduction sont acme-pilot.csod.com et acme-stg.csod.com.",
  "integration_library.connect.cornerstone.client_id_hint":
    "L'identifiant client de l'application OAuth 2.0 que vous avez enregistrée dans Edge API Management de Cornerstone.",
  "integration_library.connect.cornerstone.client_secret_hint":
    "Le secret client de cette même application. Il est stocké chiffré et n'est jamais réaffiché.",
  "integration_library.connect.author_email_label": "E-mail de l'auteur des cours (facultatif)",
  "integration_library.connect.author_email_hint":
    "L'utilisateur 360Learning au nom duquel Cognota crée les cours. Inutile pour lire votre catalogue.",
  "integration_library.connect.submit": "Connecter",
  "integration_library.connect.submitting": "Vérification de l'identifiant...",
  "integration_library.connect.success": "{vendor} connecté.",
  "integration_library.connect.missing_scopes":
    "Demandez à un administrateur de la plateforme {vendor} d'ajouter : {scopes}",
  "integration_library.connect.check_platform_url":
    "Vérifiez l'adresse de la plateforme et réessayez.",
  "integration_library.test.action": "Tester la connexion",
  "integration_library.test.running": "Test en cours...",
  "integration_library.test.success":
    "L'identifiant fonctionne et atteint tout ce dont Cognota a besoin.",
  "integration_library.test.incomplete":
    "L'identifiant est valide mais n'atteint pas tout ce dont Cognota a besoin.",
  "integration_library.test.error": "Impossible de tester cette connexion.",
  "integration_library.pause.action": "Mettre en pause",
  "integration_library.pause.resume_action": "Reprendre",
  "integration_library.pause.error": "Impossible de modifier cette connexion.",
  "integration_library.disconnect.action": "Déconnecter",
  "integration_library.disconnect.confirm_title": "Déconnecter {vendor} ?",
  "integration_library.disconnect.confirm_description":
    "La synchronisation s'arrête et l'identifiant stocké est supprimé. Rien de ce qui a déjà été synchronisé n'est supprimé. Pour vous reconnecter, il faudra un nouveau secret client, car 360Learning ne l'affiche qu'une fois.",
  "integration_library.disconnect.cornerstone.confirm_description":
    "La synchronisation s'arrête et l'identifiant stocké est supprimé. Rien de ce qui a déjà été synchronisé n'est supprimé. Pour vous reconnecter, il faudra saisir de nouveau le secret client.",
  "integration_library.disconnect.success": "{vendor} déconnecté.",
  "integration_library.disconnect.error": "Déconnexion impossible. Rien n'a été modifié.",
  "integration_library.facts.never_synced": "Pas encore synchronisé",

  // Canal de notifications Microsoft Teams (plan §5a, NG-1096, épopée NG-886).
  // TEXTE PROVISOIRE : les questions ouvertes OQ2/OQ3/OQ6 du produit ne sont pas
  // tranchées, donc chaque chaîne ci-dessous est claire et exacte plutôt que
  // définitive — une passe de révision est à prévoir.
  "workspace_settings.msteams.name": "Microsoft Teams",
  "workspace_settings.msteams.description":
    "Envoyez les notifications Cognota à votre équipe sous forme de messages Teams, en plus des e-mails et des notifications dans l'application.",
  "workspace_settings.msteams.not_enabled_hint":
    "L'activation vous fait vous connecter avec Microsoft afin que Cognota sache à quelle organisation Microsoft 365 se connecter. Seuls votre nom, votre e-mail et votre connexion sont demandés : Cognota n'obtient aucun accès aux données de votre organisation.",
  "workspace_settings.msteams.state.not_enabled": "Non activé",
  "workspace_settings.msteams.state.pending_tenant_approval": "En attente de l'administrateur",
  "workspace_settings.msteams.state.enabled": "Activé",
  "workspace_settings.msteams.state.disabled": "Désactivé",
  "workspace_settings.msteams.enable_action": "Activer",
  "workspace_settings.msteams.enable_pending": "Ouverture de la connexion Microsoft...",
  "workspace_settings.msteams.enable_success": "Notifications Microsoft Teams réactivées.",
  "workspace_settings.msteams.enable_error":
    "Impossible d'activer Microsoft Teams. Aucune modification n'a été effectuée.",
  "workspace_settings.msteams.signin_error":
    "Impossible de démarrer la connexion Microsoft. Aucune modification n'a été effectuée.",
  "workspace_settings.msteams.signin_not_configured":
    "La connexion Microsoft Teams n'est pas encore configurée dans cet environnement. Aucune modification n'a été effectuée — veuillez contacter le support.",
  "workspace_settings.msteams.disable_action": "Désactiver",
  "workspace_settings.msteams.disable_success":
    "Les notifications Microsoft Teams sont arrêtées. Tout le monde reste connecté, vous pouvez donc les réactiver à tout moment.",
  "workspace_settings.msteams.disable_error":
    "Impossible de désactiver Microsoft Teams. Aucune modification n'a été effectuée.",
  "workspace_settings.msteams.disconnect_action": "Déconnecter",
  "workspace_settings.msteams.disconnect_confirm_title": "Déconnecter Microsoft Teams ?",
  "workspace_settings.msteams.disconnect_confirm_description":
    "Les notifications s'arrêtent et tous les membres de cet espace de travail sont dissociés de leur conversation Teams. Pour vous reconnecter, il faudra vous authentifier de nouveau avec Microsoft, et chaque membre devra rajouter l'application Cognota dans Teams. Les notifications par e-mail et dans l'application ne sont pas affectées.",
  "workspace_settings.msteams.disconnect_success": "Microsoft Teams déconnecté.",
  "workspace_settings.msteams.disconnect_error":
    "Impossible de déconnecter. Aucune modification n'a été effectuée.",
  "workspace_settings.msteams.handoff.title":
    "Votre administrateur Teams doit autoriser l'application",
  "workspace_settings.msteams.handoff.description":
    "Cognota est connecté à votre organisation Microsoft 365, mais personne ne peut ajouter l'application avant qu'un administrateur Teams ne l'ait téléversée. Transmettez-lui le package et ces étapes. Chaque personne commence à recevoir ses notifications Teams une fois qu'elle dispose de l'application.",
  "workspace_settings.msteams.handoff.step_1":
    "Dans le centre d'administration Teams, ouvrez Applications Teams > Stratégies de configuration > Global, puis activez Charger des applications personnalisées.",
  "workspace_settings.msteams.handoff.step_2":
    "Dans Teams, ouvrez Applications > Gérer vos applications > Charger une application personnalisée, puis choisissez le package de l'application Cognota.",
  // NG-1186 : la seule étape qui déploie l'application sans que chacun l'ajoute.
  "workspace_settings.msteams.handoff.step_3":
    "Recommandé : dans le centre d'administration Teams, ouvrez Applications Teams > Stratégies de configuration > Global et ajoutez Cognota sous Applications installées. Tout le monde reçoit alors l'application sans avoir à l'ajouter.",
  "workspace_settings.msteams.handoff.step_4":
    "Si vous ignorez l'étape 3, autorisez l'application pour les personnes qui doivent recevoir les notifications Cognota, puis demandez-leur de l'ajouter depuis Teams > Applications > Conçues pour votre organisation > Cognota.",
  // Affiché uniquement lorsqu'un consentement est en attente depuis 14 jours ou plus
  // (décision produit OQ3).
  "workspace_settings.msteams.handoff.nudge":
    "Toujours en attente ? Votre administrateur Teams n'a pas encore approuvé l'application. Renvoyez-lui les étapes.",
  "workspace_settings.msteams.package_action": "Télécharger le package de l'application",
  "workspace_settings.msteams.package_update_hint":
    "Déjà installée ? Votre administrateur Teams met à jour l'application Cognota existante avec ce package au lieu d'en soumettre une nouvelle — chaque version porte le même identifiant d'application, donc une nouvelle soumission est refusée comme doublon.",
  "workspace_settings.msteams.package_downloading": "Préparation du package...",
  "workspace_settings.msteams.package_error":
    "Impossible de télécharger le package de l'application.",
  "workspace_settings.msteams.package_not_configured":
    "Le package de l'application Microsoft Teams n'est pas encore disponible dans cet environnement. Veuillez contacter le support.",
  "workspace_settings.msteams.linked_members":
    "{count, plural, =0 {Aucun membre associé pour l'instant} one {# membre associé} other {# membres associés}}",
  "workspace_settings.msteams.test_card_action": "M'envoyer une carte de test",
  "workspace_settings.msteams.test_card_pending": "Envoi...",
  "workspace_settings.msteams.test_card_success": "Carte de test envoyée.",
  "workspace_settings.msteams.test_card_failed":
    "Microsoft Teams n'a pas accepté la carte de test.",
  "workspace_settings.msteams.test_card_no_link":
    "Installez d'abord l'application Cognota dans Teams, puis réessayez.",
  "workspace_settings.msteams.test_card_error": "Impossible d'envoyer une carte de test.",
  "workspace_settings.msteams.facts.consented_by": "Activé par",
  "workspace_settings.msteams.facts.consented_at": "Activé le",
  "workspace_settings.msteams.facts.last_test": "Dernier test",
  "workspace_settings.msteams.facts.unknown": "Inconnu",
  "workspace_settings.msteams.redirect_connected":
    "Microsoft Teams connecté. Votre administrateur Teams doit autoriser l'application avant que quiconque puisse l'ajouter.",
  "workspace_settings.msteams.redirect_error_invalid_state":
    "Ce lien de connexion Microsoft n'est plus valide. Aucune modification n'a été effectuée — veuillez réessayer.",
  "workspace_settings.msteams.redirect_error_denied":
    "La connexion Microsoft a été annulée. Aucune modification n'a été effectuée.",
  "workspace_settings.msteams.redirect_error_no_code":
    "Microsoft n'a pas terminé la connexion. Aucune modification n'a été effectuée — veuillez réessayer.",
  "workspace_settings.msteams.redirect_error_forbidden":
    "Vous n'avez plus l'autorisation de modifier les intégrations de cet espace de travail. Aucune modification n'a été effectuée.",
  "workspace_settings.msteams.redirect_error_exchange_failed":
    "Cognota n'a pas pu finaliser la connexion avec Microsoft. Aucune modification n'a été effectuée — veuillez réessayer.",
  "workspace_settings.msteams.redirect_error_already_enabled":
    "Microsoft Teams est déjà activé pour cet espace de travail.",
  "workspace_settings.msteams.redirect_error_not_yet":
    "Cette connexion Microsoft n'est pas encore disponible. Aucune modification n'a été effectuée.",
  // Uniquement atteignable depuis le flux de liaison personnelle (NG-1134), mais le
  // rappel est partagé : cette surface doit pouvoir l'exprimer plutôt que de retomber
  // sur « inconnu ».
  "workspace_settings.msteams.redirect_error_no_enabled_workspace":
    "Ce compte Microsoft n'est associé à aucun de vos espaces de travail Cognota. Aucune modification n'a été effectuée.",
  "workspace_settings.msteams.redirect_error_unknown":
    "La connexion à Microsoft Teams a échoué. Aucune modification n'a été effectuée.",
  "workspace_settings.tabs.sso": "SSO",
  "workspace_settings.tabs.password_policy": "Politique de mot de passe",
  "workspace_settings.tabs.session_timeout": "Expiration de session",
  "workspace_settings.tabs.oauth_apps": "Applications connectées",
  "workspace_settings.tabs.calendars": "Calendriers",
  "workspace_settings.tabs.time_off": "Absences",
  "workspace_settings.tabs.sla": "SLA d'admission",
  "workspace_settings.tabs.request_prioritization": "Priorités",
  "workspace_settings.tabs.skills": "Qualifications",
  "workspace_settings.tabs.forms": "Formulaires",
  "workspace_settings.tabs.intake_workflows": "Flux d'admission",
  "workspace_settings.tabs.templates": "Modèles de projet",
  "workspace_settings.tabs.custom_fields": "Champs globaux",
  "workspace_settings.tabs.statuses": "Statuts",
  "workspace_settings.statuses.title": "Statuts",
  "workspace_settings.statuses.description":
    "Configurez les statuts disponibles pour les éléments de travail, les projets et les demandes.",
  "workspace_settings.statuses.tab.work_items": "Éléments de travail",
  "workspace_settings.statuses.tab.projects": "Projets",
  "workspace_settings.statuses.tab.requests": "Demandes",
  "workspace_settings.tabs.processes": "Processus",
  // Settings shortcut menu on list pages (NG-19): surface-specific labels for
  // the cog dropdown beside the create button.
  "settings_shortcut.label": "Paramètres de l'espace",
  "settings_shortcut.request_statuses": "Statuts des demandes",
  "settings_shortcut.intake_workflows": "Flux d'admission",
  "settings_shortcut.intake_priorities": "Priorités d'admission",
  "settings_shortcut.intake_slas": "SLA d'admission",
  "settings_shortcut.project_statuses": "Statuts des projets",
  "settings_shortcut.project_templates": "Modèles de projet",
  "settings_shortcut.processes": "Processus",
  "settings_shortcut.work_item_statuses": "Statuts des éléments de travail",
  "settings_shortcut.job_roles": "Rôles métier",
  "settings_shortcut.skills": "Qualifications",
  "workspace_settings.templates.form.default_process_label": "Processus par défaut",
  "workspace_settings.templates.form.process_none": "Aucun processus",
  "workspace_settings.templates.form.category_label": "Catégorie par défaut",
  "process.inactive_option": "{name} (inactif)",
  "workspace_settings.processes.title": "Processus",
  "workspace_settings.processes.description":
    "Définissez des processus de livraison (ADDIE, SAM ou personnalisés) et leurs étapes. Associez un processus à un modèle de projet pour suivre les tâches à chaque étape.",
  "workspace_settings.processes.system_badge": "Par défaut",
  "workspace_settings.processes.stage_label": "Étapes",
  "workspace_settings.processes.empty": "Aucun processus défini.",
  "workspace_settings.processes.column.name": "Nom",
  "workspace_settings.processes.column.description": "Description",
  "workspace_settings.processes.column.stages": "Étapes",
  "workspace_settings.processes.column.type": "Type",
  "workspace_settings.processes.type.system": "Par défaut",
  "workspace_settings.processes.type.custom": "Personnalisé",
  "workspace_settings.processes.search_placeholder": "Rechercher des processus…",
  "workspace_settings.processes.edit_action": "Modifier",
  "workspace_settings.processes.delete_action": "Supprimer",
  "workspace_settings.processes.new": "Nouveau processus",
  "workspace_settings.processes.row_actions_label": "Actions pour {name}",
  "workspace_settings.processes.select_all": "Sélectionner tous les processus",
  "workspace_settings.processes.select_one": "Sélectionner {name}",
  // Retrait (NG-635). « Désactiver » est la réponse à une suppression que le
  // garde-fou d'utilisation doit refuser : le texte doit dire clairement ce qui
  // SURVIT, sinon un administrateur le lira comme une suppression douce.
  "workspace_settings.processes.inactive_badge": "Inactif",
  "workspace_settings.processes.column.status": "Statut",
  "workspace_settings.processes.status.active": "Actif",
  "workspace_settings.processes.status.inactive": "Inactif",
  "workspace_settings.processes.deactivate_action": "Désactiver",
  "workspace_settings.processes.reactivate_action": "Réactiver",
  "workspace_settings.processes.deactivate_title": "Désactiver le processus",
  "workspace_settings.processes.deactivate_description":
    "« {name} » ne sera plus proposé lors du choix d'un processus. Les projets et modèles qui l'utilisent déjà le conservent et continuent de fonctionner, et vous pouvez le réactiver à tout moment.",
  "workspace_settings.processes.deactivate_confirm": "Désactiver",
  "workspace_settings.processes.deactivate_success": "Processus désactivé.",
  "workspace_settings.processes.reactivate_success": "Processus réactivé.",
  "workspace_settings.processes.deactivate_error": "Échec de la désactivation du processus.",
  "workspace_settings.processes.reactivate_error": "Échec de la réactivation du processus.",
  "workspace_settings.processes.editor.deactivate_instead": "Désactiver à la place",
  "workspace_settings.processes.editor.inactive_notice":
    "Ce processus est inactif. Il n'est pas proposé pour les nouveaux projets ou modèles, et tout ce qui l'utilise déjà n'est pas affecté.",
  "workspace_settings.processes.editor.stage_inactive_chip": "Inactive",
  "workspace_settings.processes.editor.deactivate_stage": "Désactiver {name}",
  "workspace_settings.processes.editor.reactivate_stage": "Réactiver {name}",
  "workspace_settings.processes.editor.deactivate_stage_title": "Désactiver l'étape",
  "workspace_settings.processes.editor.deactivate_stage_description":
    "« {name} » ne sera plus proposée lors du choix d'une étape. Les tâches qui s'y trouvent déjà y restent et continuent de fonctionner, et vous pouvez la réactiver à tout moment.",
  "workspace_settings.processes.editor.stage_deactivated": "Étape désactivée.",
  "workspace_settings.processes.editor.stage_reactivated": "Étape réactivée.",
  "workspace_settings.processes.editor.move_stage_title": "Déplacer les tâches",
  "workspace_settings.processes.editor.move_stage_description":
    "« {name} » contient {count, plural, one {# tâche} other {# tâches}}. Choisissez l'étape vers laquelle {count, plural, one {la} other {les}} déplacer, puis l'étape sera supprimée.",
  "workspace_settings.processes.editor.move_stage_target_label": "Déplacer vers",
  "workspace_settings.processes.editor.move_stage_target_placeholder": "Choisir une étape",
  "workspace_settings.processes.editor.move_stage_confirm": "Déplacer et supprimer",
  "workspace_settings.processes.editor.move_stage_moving": "Déplacement…",
  "workspace_settings.processes.editor.move_stage_none":
    "C'est la seule étape active restante, il n'y a donc nulle part où déplacer ses tâches. Ajoutez d'abord une autre étape.",
  "workspace_settings.processes.editor.remove_stage_last":
    "Il ne reste aucune étape active vers laquelle déplacer les tâches de cette étape. Ajoutez-en une ou réactivez-en une d'abord.",
  // Éditeur de processus personnalisés (NG-634).
  "workspace_settings.processes.editor.create_title": "Nouveau processus",
  "workspace_settings.processes.editor.create_description":
    "Nommez le processus. Vous ajouterez ses étapes à l'écran suivant.",
  "workspace_settings.processes.editor.create_stages_hint":
    "Les étapes se configurent après la création du processus.",
  "workspace_settings.processes.editor.creating": "Création…",
  "workspace_settings.processes.editor.optional": "(facultatif)",
  "workspace_settings.processes.editor.name_required":
    "Un processus doit avoir un nom pour être enregistré.",
  "workspace_settings.processes.editor.page_subtitle":
    "Le nom et la description s'enregistrent automatiquement. Les modifications d'étapes s'appliquent immédiatement.",
  "workspace_settings.processes.editor.load_error": "Échec du chargement de ce processus.",
  "workspace_settings.processes.editor.not_found":
    "Ce processus n'existe plus. Il a peut-être été supprimé.",
  "workspace_settings.processes.editor.stage_removed": "Étape supprimée.",
  "workspace_settings.processes.editor.stage_save_error": "Échec de l'enregistrement de l'étape.",
  "workspace_settings.processes.editor.stage_delete_blocked":
    "Cette étape contient encore {count, plural, one {# tâche} other {# tâches}}. Déplacez-les vers une autre étape avant de la supprimer.",
  "workspace_settings.processes.editor.name_label": "Nom",
  "workspace_settings.processes.editor.name_placeholder": "ex. Réponse rapide",
  "workspace_settings.processes.editor.description_label": "Description",
  "workspace_settings.processes.editor.description_placeholder":
    "À quoi sert ce processus, et quand le choisir",
  "workspace_settings.processes.column.team_access": "Accès des équipes",
  "workspace_settings.processes.team_access_all_teams": "Toutes les équipes",
  "workspace_settings.processes.team_access_hidden":
    "+{count, plural, one {# équipe privée} other {# équipes privées}}",
  "workspace_settings.processes.form.team_access_label": "Accès des équipes",
  "workspace_settings.processes.form.team_access_placeholder": "Sélectionner des équipes",
  "workspace_settings.processes.form.team_access_all_teams": "Toutes les équipes",
  "workspace_settings.processes.form.team_access_hint":
    "Les équipes sélectionnées, ainsi que toutes les équipes qui leur sont subordonnées dans la hiérarchie, pourront utiliser ce processus sur leurs projets.",
  "workspace_settings.processes.form.team_access_locked_hint":
    "Ce processus sera disponible pour cette équipe et pour toutes les équipes qui lui sont subordonnées.",
  "workspace_settings.processes.editor.stages_label": "Étapes",
  "workspace_settings.processes.editor.stages_hint":
    "Faites glisser une étape par sa poignée pour changer l'ordre suivi par les projets.",
  "workspace_settings.processes.editor.stages_empty": "Aucune étape pour l'instant.",
  "workspace_settings.processes.editor.add_stage": "Ajouter une étape",
  "workspace_settings.processes.editor.stage_name_label": "Nom de l'étape {position}",
  "workspace_settings.processes.editor.stage_name_placeholder": "Nom de l'étape",
  "workspace_settings.processes.editor.stage_name_duplicate":
    "Deux étapes d'un même processus ne peuvent pas porter le même nom.",
  "workspace_settings.processes.editor.unnamed_stage": "cette étape",
  "workspace_settings.processes.editor.drag_handle": "Faire glisser pour réordonner {name}",
  "workspace_settings.processes.editor.remove_stage": "Retirer {name}",
  "workspace_settings.processes.editor.create": "Créer le processus",
  "workspace_settings.processes.editor.create_success": "Processus créé.",
  "workspace_settings.processes.editor.create_error": "Échec de la création du processus.",
  "workspace_settings.processes.editor.update_error": "Échec de l'enregistrement du processus.",
  "workspace_settings.processes.editor.usage_error":
    "Impossible de vérifier ce qui utilise ce processus.",
  "workspace_settings.processes.editor.delete_title": "Supprimer le processus",
  "workspace_settings.processes.editor.delete_description":
    "Supprimer le processus « {name} » ? Cette action est irréversible.",
  "workspace_settings.processes.editor.delete_blocked_both":
    "Utilisé par {projectCount, plural, one {# projet} other {# projets}} et {templateCount, plural, one {# modèle} other {# modèles}}. Déplacez-les vers un autre processus avant de supprimer celui-ci.",
  "workspace_settings.processes.editor.delete_blocked_projects":
    "Utilisé par {projectCount, plural, one {# projet} other {# projets}}. Déplacez-{projectCount, plural, one {le} other {les}} vers un autre processus avant de supprimer celui-ci.",
  "workspace_settings.processes.editor.delete_blocked_templates":
    "Utilisé par {templateCount, plural, one {# modèle} other {# modèles}}. Déplacez-{templateCount, plural, one {le} other {les}} vers un autre processus avant de supprimer celui-ci.",
  "workspace_settings.processes.editor.delete": "Supprimer le processus",
  "workspace_settings.processes.editor.deleting": "Suppression…",
  "workspace_settings.processes.editor.delete_success": "Processus supprimé.",
  "workspace_settings.processes.editor.delete_error": "Échec de la suppression du processus.",
  // Onglets Détails / Utilisation de l'éditeur (NG-723).
  "workspace_settings.processes.editor.tab.details": "Détails",
  "workspace_settings.processes.editor.tab.usage": "Utilisation",
  "workspace_settings.processes.editor.view_usage": "Voir l'utilisation",
  "workspace_settings.processes.editor.usage.loading":
    "Vérification de ce qui utilise ce processus…",
  "workspace_settings.processes.editor.usage.projects_heading": "Projets",
  "workspace_settings.processes.editor.usage.projects_empty":
    "Aucun projet n'utilise encore ce processus.",
  "workspace_settings.processes.editor.usage.projects_truncated":
    "Affichage {shown, plural, one {du # premier projet} other {des # premiers projets}}.",
  "workspace_settings.processes.editor.usage.templates_heading": "Modèles de projet",
  "workspace_settings.processes.editor.usage.templates_empty":
    "Aucun modèle de projet n'utilise encore ce processus.",
  "workspace_settings.processes.editor.usage.templates_truncated":
    "Affichage {shown, plural, one {du # premier modèle} other {des # premiers modèles}}.",
  "workspace_settings.processes.editor.usage.column.project": "Projet",
  "workspace_settings.processes.editor.usage.column.identifier": "ID",
  "workspace_settings.processes.editor.usage.column.current_stage": "Étape actuelle",
  "workspace_settings.processes.editor.usage.column.template": "Modèle",
  "workspace_settings.processes.editor.usage.no_current_stage": "Non démarré",
  "workspace_settings.processes.editor.stages_blocked_hint":
    "{count, plural, one {# étape contient des tâches et n'a aucune étape active vers laquelle les déplacer, elle ne peut donc pas être supprimée.} other {# étapes contiennent des tâches et n'ont aucune étape active vers laquelle les déplacer, elles ne peuvent donc pas être supprimées.}}",
  "workspace_settings.groups.general": "Général",
  "workspace_settings.groups.people": "Personnes et accès",
  "workspace_settings.groups.foundations": "Fondations",
  "workspace_settings.groups.operations": "Opérations",
  "workspace_settings.groups.intelligence": "Intelligence",
  "workspace_settings.groups.integrations": "Intégrations",
  "workspace_settings.request_prioritization.title": "Priorités",
  "workspace_settings.request_prioritization.description":
    "Classez automatiquement les demandes entrantes par priorité selon vos propres critères",
  "workspace_settings.request_prioritization.coming_soon": "La configuration arrive bientôt.",
  "workspace_settings.request_prioritization.publish_success":
    "Modifications publiées — les priorités des demandes sont en cours de recalcul.",
  "workspace_settings.request_prioritization.publish_error":
    "Impossible de publier les modifications. Veuillez réessayer.",
  "workspace_settings.request_prioritization.draft_save_error":
    "Impossible d'enregistrer vos modifications. Veuillez réessayer.",
  "workspace_settings.request_prioritization.scoring_enabled": "Notation activée",
  "workspace_settings.request_prioritization.disable_confirm_title":
    "Désactiver la notation des priorités ?",
  "workspace_settings.request_prioritization.disable_confirm_description":
    "La notation est désactivée immédiatement. Chaque demande conserve son niveau de priorité actuel (les demandes non notées passent à Moyen), et vous pouvez définir les priorités manuellement. Réactiver la notation les recalculera.",
  "workspace_settings.request_prioritization.disable_confirm": "Désactiver la notation",
  "workspace_settings.request_prioritization.disable_cancel": "Garder la notation active",
  "workspace_settings.request_prioritization.scoring_toggle_error":
    "Impossible de modifier la notation. Veuillez réessayer.",
  "workspace_settings.request_prioritization.publish": "Publier les modifications",
  "workspace_settings.request_prioritization.discard": "Annuler les modifications",
  "workspace_settings.request_prioritization.discard_confirm_title": "Annuler les modifications ?",
  "workspace_settings.request_prioritization.discard_confirm_description":
    "Vos modifications non publiées seront réinitialisées à la dernière configuration publiée. Cette action est irréversible.",
  "workspace_settings.request_prioritization.discard_confirm": "Annuler",
  "workspace_settings.request_prioritization.discard_cancel": "Continuer l'édition",
  "workspace_settings.request_prioritization.discard_error":
    "Impossible d'annuler les modifications. Veuillez réessayer.",
  "workspace_settings.request_prioritization.load_error":
    "Échec du chargement de la configuration de priorisation.",
  "workspace_settings.request_prioritization.retry": "Réessayer",
  "workspace_settings.request_prioritization.tiers_heading": "Niveaux de priorité",
  "workspace_settings.request_prioritization.tier.urgent": "Urgent",
  "workspace_settings.request_prioritization.tier.high": "Élevé",
  "workspace_settings.request_prioritization.tier.medium": "Moyen",
  "workspace_settings.request_prioritization.tier.low": "Faible",
  "workspace_settings.request_prioritization.archived_suffix": "{label} (archivé)",
  "workspace_settings.request_prioritization.default_disabled_tier_label":
    "Priorité par défaut lorsque le calcul est désactivé",
  "workspace_settings.request_prioritization.default_disabled_tier_description":
    "Les demandes nouvelles ou non évaluées reçoivent cette priorité lorsque le calcul est désactivé. Les demandes ayant une priorité manuelle la conservent.",
  "workspace_settings.request_prioritization.tier_points": "pts",
  "workspace_settings.request_prioritization.tier_at_least": "au moins",
  "workspace_settings.request_prioritization.tier_name_aria": "Nom du niveau {tier}",
  "workspace_settings.request_prioritization.tier_name_edit": "Renommer le niveau {tier}",
  "workspace_settings.request_prioritization.tiers_not_monotonic":
    "Les seuils doivent décroître : Urgent > Élevé > Moyen > Faible.",
  "workspace_settings.request_prioritization.criteria_heading": "Critères de notation",
  "workspace_settings.request_prioritization.criteria_count": "{count} configuré(s)",
  "workspace_settings.request_prioritization.criteria_empty":
    "Aucun critère de notation. Ajoutez-en un pour commencer à noter les demandes.",
  "workspace_settings.request_prioritization.add_criteria": "Ajouter un critère",
  "workspace_settings.request_prioritization.criterion.requester": "Demandeur",
  "workspace_settings.request_prioritization.criterion.request_category": "Catégorie de demande",
  "workspace_settings.request_prioritization.criterion.linked_program": "Programme lié",
  "workspace_settings.request_prioritization.criterion.linked_goal": "Objectif lié",
  "workspace_settings.request_prioritization.criterion.custom_field": "Champ personnalisé",
  "workspace_settings.request_prioritization.remove_criterion": "Supprimer {name}",
  "workspace_settings.request_prioritization.remove_criterion_confirm_title":
    "Supprimer le critère ?",
  "workspace_settings.request_prioritization.remove_criterion_confirm_description":
    "La suppression de {name} le retire de la liste des critères. Ses pondérations configurées seront définitivement perdues à la publication ; les demandes en cours ne sont pas affectées jusque-là.",
  "workspace_settings.request_prioritization.remove_criterion_confirm": "Supprimer",
  "workspace_settings.request_prioritization.remove_criterion_cancel": "Conserver le critère",
  "workspace_settings.request_prioritization.values_scored": "{count} valeurs notées",
  "workspace_settings.request_prioritization.expand": "Développer",
  "workspace_settings.request_prioritization.collapse": "Réduire",
  "workspace_settings.request_prioritization.not_important": "Peu important",
  "workspace_settings.request_prioritization.very_important": "Très important",
  "workspace_settings.request_prioritization.requester_search_placeholder":
    "Rechercher des membres…",
  "workspace_settings.request_prioritization.requester_no_members": "Aucun membre trouvé.",
  "workspace_settings.request_prioritization.requester_add": "Ajouter un demandeur",
  "workspace_settings.request_prioritization.requester_empty":
    "Aucun demandeur noté pour le moment. Ajoutez un membre pour attribuer des points.",
  "workspace_settings.request_prioritization.remove": "Supprimer",
  "workspace_settings.not_authorized.title": "Accès refusé",
  "workspace_settings.not_authorized.description":
    "Vous n'avez pas les permissions requises pour afficher cette section des paramètres.",

  // Team Lead permissions (NG-3024)
  "workspace_settings.team_setup_areas.title": "Autorisations des chefs d'équipe",
  "workspace_settings.team_setup_areas.description":
    "Choisissez la configuration que les chefs d'équipe gèrent pour leurs équipes et les équipes en dessous. Lorsqu'un domaine est désactivé, seuls les administrateurs peuvent le gérer.",
  "workspace_settings.team_setup_areas.legend": "Les chefs d'équipe peuvent gérer",
  "workspace_settings.team_setup_areas.area.templates": "Modèles",
  "workspace_settings.team_setup_areas.area.processes": "Processus",
  "workspace_settings.team_setup_areas.area.intake_workflows": "Flux de demandes",
  "workspace_settings.team_setup_areas.area.slas": "SLA",
  "workspace_settings.team_setup_areas.area.calendars": "Calendriers",
  "workspace_settings.team_setup_areas.area.capacity": "Capacité",
  "workspace_settings.team_setup_areas.area.automations": "Automatisations",
  "workspace_settings.team_setup_areas.save": "Enregistrer",
  "workspace_settings.team_setup_areas.saving": "Enregistrement…",
  "workspace_settings.team_setup_areas.save_success":
    "Autorisations des chefs d'équipe enregistrées",
  "workspace_settings.team_setup_areas.save_error":
    "Impossible d'enregistrer les autorisations des chefs d'équipe. Réessayez.",
  "workspace_settings.team_setup_areas.load_error":
    "Impossible de charger les autorisations des chefs d'équipe.",
  "workspace_settings.team_setup_areas.retry": "Réessayer",
  "workspace_settings.general.title": "Général",
  "workspace_settings.general.description":
    "Mettez à jour l'identité de l'espace de travail, le fuseau horaire et les informations d'organisation.",
  "workspace_settings.general.name_label": "Nom de l'espace de travail",
  "workspace_settings.general.size_label": "Taille de l'organisation",
  "workspace_settings.general.timezone_label": "Fuseau horaire",
  "workspace_settings.general.currency_label": "Devise de l'organisation",
  "workspace_settings.general.currency_help":
    "Définissez une devise pour le taux horaire et le coût des projets, afin que les données puissent être agrégées à l'échelle de l'espace de travail.",
  "workspace_settings.general.currency_confirm_title": "Modifier la devise de l'organisation ?",
  "workspace_settings.general.currency_confirm_description":
    "La modification de la devise ne change pas les taux historiques. Les taux historiques devront être mis à jour pour tous les utilisateurs et tous les rôles afin de correspondre à la nouvelle devise.",
  "workspace_settings.general.currency_confirm_action": "Modifier la devise",
  "workspace_settings.general.region_help":
    "Les nouveaux membres héritent de ce pays et de cette région afin de ne pas être planifiés pendant leurs jours fériés locaux. Chaque membre peut le modifier dans son profil.",
  "country_region.country_label": "Pays",
  "country_region.country_placeholder": "Sélectionnez un pays",
  "country_region.region_label": "Région",
  "country_region.region_placeholder": "Sélectionnez une région",
  "country_region.region_none": "Aucune région",
  "country_region.country_search_placeholder": "Rechercher des pays",
  "country_region.country_empty": "Aucun pays correspondant",
  "country_region.region_search_placeholder": "Rechercher des régions",
  "country_region.region_empty": "Aucune région correspondante",
  "country_region.help":
    "Renseigner votre pays et votre région garantit que vous ne serez pas planifié pour du travail pendant un jour férié.",
  "workspace_settings.general.url_label": "URL de l'espace de travail",
  "workspace_settings.general.url_copy": "Copier",
  "workspace_settings.general.url_copied": "URL copiée",
  "workspace_settings.general.url_copy_failed": "Échec de la copie de l'URL",
  "workspace_settings.general.save": "Enregistrer",
  "workspace_settings.general.saving": "Enregistrement...",
  "workspace_settings.general.save_success": "Paramètres mis à jour",
  "workspace_settings.general.save_error": "Échec de la mise à jour des paramètres",
  "workspace_settings.general.logo_alt": "Logo {name}",
  "workspace_settings.general.logo_label": "Logo de l'espace de travail",
  "workspace_settings.general.logo_hint": "Chargez une image PNG, JPG, WEBP ou GIF.",
  "workspace_settings.general.logo_hint_max":
    "Chargez une image PNG, JPG, WEBP ou GIF ({limit} max.).",
  "workspace_settings.general.logo_upload": "Charger un logo",
  "workspace_settings.general.logo_change": "Changer le logo",
  "workspace_settings.general.logo_dialog_title": "Charger le logo",
  "workspace_settings.general.logo_dialog_description":
    "Sélectionnez une image pour représenter cet espace de travail.",
  "workspace_settings.general.logo_browse": "Choisir une image",
  "workspace_settings.general.logo_formats":
    "Formats pris en charge : .jpeg, .jpg, .png, .webp, .gif",
  "workspace_settings.general.logo_save": "Charger et enregistrer",
  "workspace_settings.general.logo_uploading": "Chargement...",
  "workspace_settings.general.logo_remove": "Supprimer",
  "workspace_settings.general.logo_removing": "Suppression...",
  "workspace_settings.general.logo_uploaded": "Logo mis à jour",
  "workspace_settings.general.logo_upload_failed": "Échec du chargement du logo",
  "workspace_settings.general.logo_removed": "Logo supprimé",
  "workspace_settings.general.logo_remove_failed": "Échec de la suppression du logo",
  "workspace_settings.general.logo_remove_unsupported":
    "Ce logo ne peut pas être supprimé depuis les paramètres de l'espace de travail.",
  "workspace_settings.general.logo_invalid_type":
    "Type d'image non pris en charge. Utilisez JPG, PNG, WEBP ou GIF.",
  "workspace_settings.general.reset": "Réinitialiser l'espace de travail",
  "workspace_settings.general.reset_section_description":
    "Efface cet espace de travail de démonstration et le reconstruit à partir de son état initial canonique. Tous les projets, demandes, éléments de travail, équipes et autres données de démonstration sont définitivement supprimés puis recréés.",
  "workspace_settings.general.reset_title": "Réinitialiser l'espace de travail ?",
  "workspace_settings.general.reset_description":
    "Cette action efface définitivement toutes les données de démonstration de cet espace de travail et restaure l'état initial canonique. Elle est irréversible.",
  "workspace_settings.general.reset_slug_prompt": "Saisissez {slug} pour confirmer",
  "workspace_settings.general.resetting": "Réinitialisation...",
  "workspace_settings.general.reset_in_progress":
    "Réinitialisation de l'espace de travail… cela peut prendre quelques minutes. Gardez cette fenêtre ouverte.",
  "workspace_settings.general.reset_success":
    "Espace de travail réinitialisé — {count} enregistrements restaurés",
  "workspace_settings.general.reset_error": "Échec de la réinitialisation de l'espace de travail",
  "workspace_settings.general.reset_timeout":
    "La réinitialisation prend plus de temps que prévu. Elle peut se terminer en arrière-plan — actualisez dans un instant.",
  "workspace_settings.general.reset_template_label": "Réinitialiser vers",
  "workspace_settings.general.reset_template_default": "Par défaut (état initial canonique)",
  "workspace_settings.general.reset_template_help":
    "Choisissez le modèle à partir duquel reconstruire cet espace de travail.",
  "workspace_settings.general.reset_version_label": "Version du modèle",
  "workspace_settings.general.reset_version_active": "Version active (la plus récente)",
  "workspace_settings.general.reset_version_option": "Version {version}",
  "workspace_settings.general.reset_version_help":
    "Reconstruisez éventuellement à partir d'une version antérieure de ce modèle plutôt que de sa version active.",

  "workspace_settings.general.danger_zone": "Zone sensible",
  "workspace_settings.general.delete": "Supprimer l'espace de travail",
  "workspace_settings.general.delete_section_description":
    "Supprimez définitivement cet espace de démonstration et tout son contenu. Les espaces de travail clients ne peuvent pas être supprimés ici.",
  "workspace_settings.general.delete_title": "Supprimer l'espace de travail ?",
  "workspace_settings.general.delete_description":
    "Cette action supprime l'espace de démonstration ainsi que tous ses projets, demandes, éléments de travail et équipes. Elle est irréversible.",
  "workspace_settings.general.delete_slug_prompt": "Saisissez {slug} pour confirmer",
  "workspace_settings.general.delete_confirm_action": "Supprimer définitivement",
  "workspace_settings.general.deleting": "Suppression...",
  "workspace_settings.general.delete_success": "Espace de travail supprimé",
  "workspace_settings.general.delete_error": "Échec de la suppression de l'espace de travail",

  "workspace_settings.templates.section_title": "Modèles d'espace de travail",
  "workspace_settings.templates.section_description":
    "Instantanés enregistrés d'un espace de travail vers lesquels vous pouvez réinitialiser. Capturez l'espace de travail actuel comme modèle réutilisable ou supprimez ceux dont vous n'avez plus besoin.",
  "workspace_settings.templates.empty": "Aucun modèle pour le moment.",
  "workspace_settings.templates.load_error": "Échec du chargement des modèles.",
  "workspace_settings.templates.default_badge": "Par défaut",
  "workspace_settings.templates.applied_badge": "Appliqué",
  "workspace_settings.templates.scope_global": "Global",
  "workspace_settings.templates.scope_restricted": "Restreint",
  "workspace_settings.templates.sharing_global": "Partagé avec l'équipe GTM",
  "workspace_settings.templates.sharing_private": "Privé",
  "workspace_settings.templates.created_by": "Créé par {name}",
  "workspace_settings.templates.created_by_system": "Modèle système",
  "workspace_settings.templates.create_action": "Créer un modèle d'espace de travail",
  "workspace_settings.templates.change_template": "Changer de modèle",
  "workspace_settings.templates.refresh_dates": "Actualiser les dates",
  "workspace_settings.templates.refresh_dates_running": "Actualisation des dates…",
  "workspace_settings.templates.refresh_dates_tooltip":
    "Aligner toutes les dates de cet espace de travail sur aujourd’hui, un décalage de {days} jours. Rien n’est supprimé.",
  "workspace_settings.templates.refresh_dates_already_current":
    "Ces dates reflètent déjà la date du jour, il n’y a donc rien à déplacer.",
  "workspace_settings.templates.refresh_dates_confirm":
    "Ces dates ont été définies pour la dernière fois {when} ({date}). Aligner toutes les dates sur aujourd’hui, un décalage de {days} jours, pour que l’espace de travail reflète la date du jour ? Les projets, tâches, événements et tout ce que vous avez ajouté conservent leur contenu et leurs écarts, et rien n’est supprimé.",
  "workspace_settings.templates.refresh_dates_success":
    "{count} enregistrements décalés de {days} jours.",
  "workspace_settings.templates.refresh_dates_error":
    "Impossible d’actualiser les dates. Veuillez réessayer.",
  "workspace_settings.templates.refresh_dates_timeout":
    "L’actualisation des dates prend plus de temps que prévu. Elle peut encore se terminer : rechargez la page dans une minute pour vérifier.",
  "workspace_settings.templates.column_name": "Nom",
  "workspace_settings.templates.column_tags": "Étiquettes",
  "workspace_settings.templates.column_captured_by": "Capturé par",
  "workspace_settings.templates.column_last_applied": "Dernière application",
  "workspace_settings.templates.last_applied_never": "Jamais",
  "workspace_settings.templates.filter_scope": "Portée",
  "workspace_settings.templates.filter_status": "Statut",
  "workspace_settings.templates.filter_search_placeholder": "Filtrer les options…",
  "workspace_settings.templates.filter_no_matches": "Aucune option correspondante.",
  "workspace_settings.templates.delete_action": "Supprimer le modèle",
  "workspace_settings.templates.delete_confirm":
    "Supprimer le modèle « {name} » ? Cette action est irréversible.",
  "workspace_settings.templates.delete_success": "Modèle supprimé",
  "workspace_settings.templates.delete_error": "Échec de la suppression du modèle",
  "workspace_settings.templates.set_default_action":
    "Définir par défaut pour les nouveaux espaces de travail",
  "workspace_settings.templates.set_default_confirm":
    "Définir « {name} » comme modèle par défaut ? Chaque nouvel espace de travail en sera issu. Vous pouvez le modifier à tout moment.",
  "workspace_settings.templates.set_default_success": "Modèle par défaut mis à jour",
  "workspace_settings.templates.set_default_error": "Échec de la définition du modèle par défaut",
  "workspace_settings.templates.create_title": "Enregistrer l'espace de travail comme modèle",
  "workspace_settings.templates.create_description":
    "Capturez l'état actuel de cet espace de travail comme modèle nommé vers lequel vous pourrez réinitialiser plus tard.",
  "workspace_settings.templates.name_label": "Nom du modèle",
  "workspace_settings.templates.name_placeholder": "ex. Démo commerciale",
  "workspace_settings.templates.scope_label": "Visibilité",
  "workspace_settings.templates.scope_global_help":
    "Utilisable par quiconque peut utiliser les modèles.",
  "workspace_settings.templates.scope_restricted_help": "Limité au rôle de cet espace de travail.",
  "workspace_settings.templates.sharing_global_help":
    "Toute l'équipe GTM de Cognota qui utilise les modèles d'espace de travail peut le voir et y réinitialiser un espace de travail.",
  "workspace_settings.templates.sharing_private_help":
    "Vous seul pouvez le voir et y réinitialiser un espace de travail, ainsi que les administrateurs d'instance Cognota. Un modèle privé ne peut pas être le modèle par défaut des nouveaux espaces de travail.",
  "workspace_settings.templates.create_submit": "Enregistrer le modèle",
  "workspace_settings.templates.create_success": "Modèle « {name} » enregistré",
  "workspace_settings.templates.create_error": "Échec de l'enregistrement du modèle",

  "workspace_settings.members.title": "Membres",
  "workspace_settings.members.description":
    "Invitez des membres, examinez les invitations en attente et gérez les accès.",
  "workspace_settings.members.invite_action": "Inviter des membres",
  "workspace_settings.members.import.field_email": "E-mail",
  "workspace_settings.members.import.field_first_name": "Prénom",
  "workspace_settings.members.import.field_last_name": "Nom",
  "workspace_settings.members.import.field_country": "Pays",
  "workspace_settings.members.import.field_region": "Région",
  "workspace_settings.members.import.field_team": "Équipe",
  "workspace_settings.members.import.field_system_role": "Rôle système",
  // La fenêtre d'import d'utilisateurs (NG-1307). Les quatre lignes `notice_*`
  // décrivent ce que l'import fait AUJOURD'HUI, pas l'état final du PRD, et
  // chacune est réécrite par l'histoire qui change le comportement décrit —
  // NG-1297 en a réécrit deux. NG-1299 possède la dernière qui décrit encore une
  // limite : une ligne qui ajoute quelqu'un doit indiquer un rôle système.
  "workspace_settings.members.import.action": "Importer des utilisateurs",
  "workspace_settings.members.import.title": "Importer des utilisateurs",
  "workspace_settings.members.import.notice_title": "Ce que cet import va faire",
  "workspace_settings.members.import.notice_create":
    "Une ligne dont l'e-mail n'existe pas encore dans cet espace de travail crée la personne, avec le rôle système indiqué sur la ligne. Elle peut se voir attribuer du travail immédiatement.",
  "workspace_settings.members.import.notice_invite_choice":
    "Vous choisissez d'envoyer ou non un e-mail de bienvenue à la dernière étape, avant d'importer.",
  "workspace_settings.members.import.notice_invite_off":
    "Aucun e-mail n'est envoyé. Les personnes importées se connecteront plus tard via l'authentification unique ou en utilisant « Mot de passe oublié ».",
  "workspace_settings.members.import.notice_invite_on":
    "Toute personne que cet import ajoute à cet espace de travail reçoit un e-mail avec un lien pour définir un mot de passe. Les personnes déjà membres ne reçoivent aucun e-mail.",
  "workspace_settings.members.import.notice_existing":
    "Une ligne dont l'e-mail appartient déjà à quelqu'un met à jour cette personne au lieu d'en créer une deuxième. Une colonne laissée vide conserve la valeur actuelle.",
  "workspace_settings.members.import.notice_role_required":
    "Une ligne qui laisse le rôle système vide reçoit le rôle par défaut de cet espace de travail. Le rôle indiqué sur la ligne est utilisé à la place, et un nom de rôle inconnu bloque cette ligne. Pour une personne déjà présente, laisser la colonne vide conserve son rôle actuel.",
  "workspace_settings.members.import.notice_column_rules":
    "Le pays, la région, l'équipe et le poste doivent correspondre à un nom qui existe déjà ici, sans tenir compte de la casse. Un nom introuvable est signalé sur sa ligne et laissé vide — la personne est tout de même importée. La capacité doit être un nombre entre 0 et 100 ; toute autre valeur est signalée de la même façon. Le taux horaire n'est importé que par une personne autorisée à définir les taux.",
  "workspace_settings.members.import.withheld_hourly_rate":
    "Ce n’est pas une faute d’orthographe — importer les taux horaires exige l’autorisation de les définir, cette colonne est donc ignorée.",
  "workspace_settings.members.import.error_email_required": "L’e-mail est obligatoire.",
  "workspace_settings.members.import.error_email_invalid":
    "« {email} » n’est pas une adresse e-mail valide.",
  "workspace_settings.members.import.send_welcome_email_label": "Envoyer un e-mail de bienvenue",
  "workspace_settings.members.import.importing": "Import en cours…",
  "workspace_settings.members.import.result_summary":
    "{created} créé(s), {updated} mis à jour, {skipped} ignoré(s), {errors} n'ont pas pu être importé(s).",
  "workspace_settings.members.import.count_created": "{count} créé(s)",
  // Voir en.ts pour le raisonnement : « envoyé » au sens de mis en file d'attente.
  "workspace_settings.members.import.count_emailed": "{count} notifié(s) par e-mail",
  "workspace_settings.members.import.count_emailed_partial":
    "{sent} sur {total} notifié(s) par e-mail",
  "workspace_settings.members.import.email_queued_note":
    "Les e-mails de bienvenue sont envoyés en arrière-plan : la distribution n'est donc pas confirmée ici.",
  "workspace_settings.members.import.email_failed_title":
    "Les e-mails de bienvenue n'ont pas pu être envoyés",
  "workspace_settings.members.import.email_failed_body":
    "Les personnes ajoutées par cet import font partie de l'espace de travail. Certaines n'ont pas été notifiées : elles ne savent donc pas qu'elles ont été ajoutées. Relancer cet import ne les notifiera pas — il n'envoie d'e-mail qu'aux personnes qu'il ajoute, et elles en sont désormais membres.",
  "workspace_settings.members.import.count_updated": "{count} mis à jour",
  "workspace_settings.members.import.count_skipped": "{count} ignoré(s)",
  "workspace_settings.members.import.count_errors":
    "{count, plural, one {# erreur} other {# erreurs}}",
  "workspace_settings.members.import.skipped_heading": "Lignes qui n'ont pas été modifiées",
  "workspace_settings.members.import.partial_heading":
    "Importés, mais certaines valeurs n'ont pas été renseignées",
  "workspace_settings.members.import.row_issue": "Ligne {row} ({email}) : {message}",
  "workspace_settings.members.import.row_issue_no_email": "Ligne {row} : {message}",
  "workspace_settings.members.import.warn_duplicate_emails":
    "{count, plural, one {# adresse e-mail apparaît sur plusieurs lignes} other {# adresses e-mail apparaissent sur plusieurs lignes}}. L'aperçu indiquera ce qu'il advient de chacune.",
  "workspace_settings.members.import.checking": "Vérification de votre fichier…",
  "workspace_settings.members.import.check_failed_title": "Impossible de vérifier votre fichier",
  "workspace_settings.members.import.check_failed_body":
    "Rien n'a été importé. Réessayez, ou revenez en arrière et modifiez l'association des colonnes.",
  "workspace_settings.members.import.check_retry": "Réessayer",
  "workspace_settings.members.import.preview_title": "Avant d'importer",
  "workspace_settings.members.import.preview_summary":
    "{created} seront créés, {updated} seront mis à jour, {skipped} seront ignorés, {errors} ne peuvent pas être importés.",
  "workspace_settings.members.import.preview_count_created": "{count} à créer",
  "workspace_settings.members.import.preview_count_updated": "{count} à mettre à jour",
  "workspace_settings.members.import.preview_count_skipped": "{count} à ignorer",
  "workspace_settings.members.import.preview_count_errors":
    "{count, plural, one {# non importable} other {# non importables}}",
  "workspace_settings.members.import.preview_errors_heading":
    "Lignes qui ne peuvent pas être importées",
  "workspace_settings.members.import.preview_partial_heading":
    "Seront importés, mais certaines valeurs ne seront pas renseignées",
  "workspace_settings.members.import.preview_skipped_heading": "Lignes qui ne seront pas modifiées",
  "workspace_settings.members.import.preview_defaults_line":
    "{count, plural, one {# ligne laisse le rôle système vide et prendra le rôle par défaut de cet espace de travail.} other {# lignes laissent le rôle système vide et prendront le rôle par défaut de cet espace de travail.}}",
  "workspace_settings.members.import.toast_success":
    "{count, plural, one {# utilisateur importé} other {# utilisateurs importés}}",
  "workspace_settings.members.import.toast_error": "L'import a échoué. Veuillez réessayer.",
  "workspace_settings.members.section_title": "Membres",
  "workspace_settings.members.section_description":
    "Modifiez les accès, affectez des rôles personnalisés ou retirez des membres.",
  "workspace_settings.members.no_members": "Aucun membre ne correspond aux filtres.",
  "workspace_settings.members.no_email": "Aucun e-mail",
  "workspace_settings.members.tier_label": "Licence",
  "workspace_settings.members.tier.admin": "Administrateur",
  "workspace_settings.members.tier.standard": "Standard",
  "workspace_settings.members.tier.guest": "Invité",
  "workspace_settings.members.role_label": "Rôle",
  "workspace_settings.members.invite_teams_label": "Équipes",
  "workspace_settings.members.invite_teams_placeholder": "Sélectionner des équipes (facultatif)",
  "workspace_settings.members.invite_teams_hint":
    "Ils rejoignent ces équipes dès qu'ils acceptent. Laissez vide pour les inviter sans équipe.",
  "workspace_settings.members.capacity_label": "Capacité",
  "workspace_settings.members.capacity_invalid": "Entrez une valeur entre 0 et 100",
  "workspace_settings.members.capacity_updated": "Capacité du membre mise à jour",
  "workspace_settings.members.capacity_update_error":
    "Échec de la mise à jour de la capacité du membre",
  "workspace_settings.members.custom_role_label": "Rôle personnalisé",
  "workspace_settings.members.custom_role_none": "Aucun",
  "workspace_settings.members.remove": "Retirer",
  "workspace_settings.members.remove_confirm_title": "Retirer le membre",
  "workspace_settings.members.remove_confirm_description":
    "Retirer {name} de cet espace de travail ? L'accès sera immédiatement révoqué.",
  "workspace_settings.members.remove_success": "Membre retiré",
  "workspace_settings.members.remove_error": "Échec du retrait du membre",
  "workspace_settings.members.role_updated": "Rôle du membre mis à jour",
  "workspace_settings.members.role_update_error": "Échec de la mise à jour du rôle",
  "workspace_settings.members.role_blocked_title":
    "L'utilisateur détient des rôles incompatibles :",
  "workspace_settings.members.role_blocked_dialog.title":
    "Impossible de changer ce rôle pour le moment",
  "workspace_settings.members.role_blocked_dialog.description":
    "{member} ne peut pas devenir {role} tant qu'il détient ces rôles :",
  "workspace_settings.members.custom_role_updated": "Rôle personnalisé mis à jour",
  "workspace_settings.members.custom_role_update_error":
    "Échec de la mise à jour du rôle personnalisé",
  "workspace_settings.members.filters_search_placeholder": "Rechercher un membre par nom ou e-mail",
  "workspace_settings.members.filters_role_all": "Tous les rôles",
  "workspace_settings.members.filters_role_admin": "Administrateurs",
  "workspace_settings.members.filters_role_member": "Membres",
  "workspace_settings.members.filters_role_guest": "Invités",
  "workspace_settings.members.filters_role_custom": "Rôles personnalisés",
  "workspace_settings.members.invitations_role": "Rôle {role}",
  "workspace_settings.members.invitation_revoke": "Révoquer",
  "workspace_settings.members.invitation_revoke_success": "Invitation révoquée",
  "workspace_settings.members.invitation_revoke_error": "Échec de la révocation de l'invitation",
  "workspace_settings.members.invite_dialog_title": "Inviter des membres",
  "workspace_settings.members.invite_dialog_description":
    "Envoyez une ou plusieurs invitations. Séparez les adresses par des virgules ou des retours à la ligne.",
  "workspace_settings.members.invite_emails_label": "Adresses e-mail",
  "workspace_settings.members.invite_emails_placeholder": "alex@example.com, taylor@example.com",
  "workspace_settings.members.invite_send": "Envoyer les invitations",
  "workspace_settings.members.invite_sending": "Envoi...",
  "workspace_settings.members.invite_success": "Invitations envoyées",
  "workspace_settings.members.invite_error": "Échec de l'envoi des invitations",
  "workspace_settings.members.invite_emails_required": "Saisissez au moins une adresse e-mail",
  "workspace_settings.members.invite_existing_member_one":
    "{email} est déjà membre de cet espace de travail. Rien n'a été envoyé.",
  "workspace_settings.members.invite_existing_member_many":
    "{count} de ces adresses appartiennent déjà à des membres de cet espace de travail. Rien n'a été envoyé.",
  "workspace_settings.members.invite_existing_member_role_hint":
    "Pour modifier le rôle d'un membre, utilisez la colonne Rôle système de la page Membres.",
  "workspace_settings.members.invite_existing_member_remove_one": "La retirer de la liste",
  "workspace_settings.members.invite_existing_member_remove_many":
    "Les retirer toutes les {count} de la liste",
  "workspace_settings.members.role.admin": "Administrateur",
  "workspace_settings.members.role.member": "Utilisateur standard",
  "workspace_settings.members.role.guest": "Invité",
  "workspace_settings.members.skills_label": "Qualifications",
  "workspace_settings.members.skills_empty": "Aucune qualification",
  "workspace_settings.members.skills_search_placeholder": "Rechercher des qualifications...",
  "workspace_settings.members.assign_skills_title": "Attribuer des qualifications à {name}",
  "workspace_settings.members.skills_updated": "Qualifications du membre mises à jour",
  "workspace_settings.members.skills_update_error": "Échec de la mise à jour des qualifications",
  "workspace_settings.members.skills_description":
    "Modifier les qualifications attribuées à ce membre.",
  "workspace_settings.members.skills_loading": "Chargement des qualifications...",
  "workspace_settings.members.skills_read_only":
    "Votre rôle ne permet pas de modifier les qualifications des membres.",
  "workspace_settings.members.teams.tab": "Équipes",
  "workspace_settings.members.teams.title": "Équipes",
  "workspace_settings.members.teams.description":
    "Les équipes de ce membre et son rôle dans chacune.",
  "workspace_settings.members.teams.loading": "Chargement des équipes...",
  "workspace_settings.members.teams.load_error": "Échec du chargement des équipes de ce membre",
  "workspace_settings.members.teams.updated": "Équipes du membre mises à jour",
  "workspace_settings.members.teams.update_error":
    "Échec de la mise à jour des équipes de ce membre",
  "workspace_settings.members.teams.empty": "Ce membre ne fait partie d'aucune équipe",
  "workspace_settings.members.teams.placeholder": "Ajouter ou retirer des équipes",
  "workspace_settings.members.teams.column_team": "Équipe",
  "workspace_settings.members.teams.column_role": "Rôle",
  "workspace_settings.members.teams.empty_hint":
    "Les équipes déterminent les projets sur lesquels ce membre peut être planifié. Utilisez le sélecteur ci-dessus pour en ajouter une.",
  "workspace_settings.members.teams.sole_lead_reason":
    "{name} doit avoir au moins un responsable. Nommez d'abord un autre responsable.",
  "workspace_settings.members.teams.no_teams": "Aucune équipe",
  "workspace_settings.members.teams.trigger_label": "Équipes",
  "workspace_settings.members.teams.role_label": "Rôle dans {name}",
  "workspace_settings.members.edit_work_hours": "Modifier les heures de travail",
  "workspace_settings.members.work_hours_dialog_title": "Modifier les heures de travail de {name}",
  "workspace_settings.members.work_hours_loading": "Chargement des heures de travail...",
  "workspace_settings.members.work_hours_load_error": "Échec du chargement des heures de travail",
  "workspace_settings.members.work_hours_save_error":
    "Échec de la sauvegarde des heures de travail",
  "workspace_settings.members.work_hours_updated": "Heures de travail mises à jour",
  "workspace_settings.members.profile_tab": "Profil",
  "workspace_settings.members.access.tab": "Accès",
  "workspace_settings.members.access.title": "Accès",
  "workspace_settings.members.access.description":
    "Gérez le rôle système de ce membre et consultez sa licence.",
  "workspace_settings.members.access.system_role_label": "Rôle système",
  "workspace_settings.members.access.tier_hint": "La licence suit le rôle système.",
  "workspace_settings.members.access.eligibility_title": "Peut être désigné comme",
  "workspace_settings.members.access.eligibility_hint":
    "Par défaut, le rôle système décide. Autorisez ou refusez ici pour cette personne uniquement. La licence s’applique toujours.",
  "workspace_settings.members.access.eligibility_role_yes": "Selon le rôle (oui)",
  "workspace_settings.members.access.eligibility_role_no": "Selon le rôle (non)",
  "workspace_settings.members.access.eligibility_allow": "Autoriser",
  "workspace_settings.members.access.eligibility_deny": "Refuser",
  "workspace_settings.members.access.eligibility_tier_locked": "Leur licence ne le permet pas.",
  "workspace_settings.members.access.eligibility_saving": "Enregistrement…",
  "workspace_settings.members.access.eligibility_saved": "Enregistré",
  "workspace_settings.members.access.eligibility_save_failed":
    "Impossible d’enregistrer ce changement. Il a été annulé.",
  "workspace_settings.members.access.eligibility_load_failed":
    "Impossible de charger ce que cette personne peut être.",
  "workspace_settings.members.eligibility.project.lead": "Responsable de projet",
  "workspace_settings.members.eligibility.program.owner": "Propriétaire de programme",
  "workspace_settings.members.eligibility.goal.lead": "Responsable d’objectif",
  "workspace_settings.members.eligibility.team.lead": "Responsable d’équipe",
  "workspace_settings.members.eligibility.request.owner": "Propriétaire de demande",
  "workspace_settings.members.eligibility.request.reviewer": "Réviseur de demande",
  "workspace_settings.members.eligibility.workitem.assignee": "Responsable de tâche",
  "workspace_settings.members.eligibility.project.member": "Membre de projet",
  "workspace_settings.members.eligibility.team.member": "Membre d’équipe",
  "workspace_settings.members.access.owner_indicator": "Propriétaire de l’espace de travail",
  "workspace_settings.members.access.owner_indicator_hint":
    "Le propriétaire de l’espace de travail peut accéder à toutes les fonctionnalités, y compris les paramètres de l’espace de travail, quel que soit son rôle système.",
  "workspace_settings.members.rates.tab": "Taux",
  "workspace_settings.members.rates.title": "Taux horaire",
  "workspace_settings.members.rates.description":
    "Définissez le taux horaire de ce membre. Les taux sont datés : une modification ajoute une nouvelle entrée, et le coût est calculé à partir du taux en vigueur au moment où le temps a été enregistré.",
  "workspace_settings.members.rates.add_label": "Ajouter un taux",
  "workspace_settings.members.rates.hourly_rate_label": "Taux horaire",
  "workspace_settings.members.rates.add_button": "Ajouter le taux",
  "workspace_settings.members.rates.add_hint":
    "Le nouveau taux prend effet aujourd'hui. Pour définir un taux antérieur, ajoutez-le, puis modifiez la date sur sa ligne ci-dessous.",
  "workspace_settings.members.rates.history_label": "Historique des taux",
  "workspace_settings.members.rates.empty":
    "Aucun taux défini. Le temps de ce membre est comptabilisé à 0 tant qu'aucun taux n'est ajouté.",
  "workspace_settings.members.rates.per_hour": "{amount} / h",
  "workspace_settings.members.rates.delete_aria": "Supprimer le taux en vigueur le {date}",
  "workspace_settings.members.rates.edit_effective_aria":
    "Modifier la date d'effet (actuellement {date})",
  "workspace_settings.members.rates.loading": "Chargement des taux…",
  "workspace_settings.members.rates.load_error": "Impossible de charger les taux.",
  "workspace_settings.members.rates.invalid_rate": "Saisissez un taux de 0 ou plus.",
  "workspace_settings.members.rates.saved": "Taux enregistré",
  "workspace_settings.members.rates.save_error": "Impossible d'enregistrer le taux.",
  "workspace_settings.members.rates.update_error": "Impossible de mettre à jour le taux.",
  "workspace_settings.members.rates.delete_error": "Impossible de supprimer le taux.",
  "workspace_settings.members.profile_title": "Profil",
  "workspace_settings.members.profile_description":
    "Mettre à jour les informations du profil du membre.",
  "workspace_settings.members.profile_save_success": "Profil du membre mis à jour",
  "workspace_settings.members.profile_save_error": "Échec de la mise à jour du profil du membre",
  "workspace_settings.members.profile_load_error": "Échec du chargement du profil du membre",
  "workspace_settings.members.column_member": "Membre",
  "workspace_settings.members.column_actions": "Actions",
  "workspace_settings.members.select_all": "Sélectionner tous les membres",
  "workspace_settings.members.select_one": "Sélectionner {name}",
  "workspace_settings.members.bulk_remove.title": "Retirer {count} membres ?",
  "workspace_settings.members.bulk_remove.description":
    "Cela retire les {count} membres sélectionnés de l'espace de travail.",
  "workspace_settings.members.bulk_remove.success": "{count} membres retirés",
  "workspace_settings.members.remove_owner_confirm_description":
    "{name} est propriétaire de l'espace de travail. Le retirer laisse l'espace sans propriétaire jusqu'à ce que le soutien Cognota en désigne un nouveau. L'accès sera immédiatement révoqué.",
  "workspace_settings.members.bulk_remove.description_with_owner":
    "Cela retire les {count} membres sélectionnés de l'espace de travail, y compris le propriétaire. L'espace n'aura pas de propriétaire jusqu'à ce que le soutien Cognota en désigne un nouveau.",
  "workspace_settings.members.role_owner_locked":
    "Le propriétaire de l'espace de travail doit conserver un rôle de niveau Admin; les niveaux inférieurs ne peuvent pas être choisis.",
  "workspace_settings.members.owner_badge_tooltip":
    "Propriétaire de l'espace de travail : accès complet quel que soit le rôle système.",
  "workspace_settings.members.owner_badge": "Propriétaire",
  "workspace_settings.members.column_email": "Courriel",
  "workspace_settings.members.column_teams": "Équipes",
  "workspace_settings.members.column_team": "Équipe",
  "workspace_settings.members.email_copy": "Copier le courriel",
  "workspace_settings.members.email_copied": "Courriel copié",
  "workspace_settings.members.email_copy_error": "Échec de la copie du courriel",
  "workspace_settings.members.actions_menu_aria": "Actions pour {name}",
  "workspace_settings.members.tabs_label": "Membres et invitations en attente",
  "workspace_settings.members.members_tab": "Membres",
  "workspace_settings.members.pending_invitations_tab": "Invitations en attente",
  "workspace_settings.members.pending_invitations_summary":
    "{count, plural, one {# invitation en attente} other {# invitations en attente}}",
  "workspace_settings.members.pending_invitations_review": "Consulter",
  "workspace_settings.members.pending_invitations_search_placeholder":
    "Rechercher des invitations par courriel",
  "workspace_settings.members.pending_invitations_filter_age_label": "Ancienneté",
  "workspace_settings.members.pending_invitations_filter_age_expiring_soon": "Expire bientôt",
  "workspace_settings.members.pending_invitations_filter_age_expired": "Expirée",
  "workspace_settings.members.column_system_role": "Rôle système",
  "workspace_settings.members.column_invited": "Invité",
  "workspace_settings.members.column_expires": "Expire",
  "workspace_settings.members.expires_never": "Jamais",
  "workspace_settings.members.expires_expired": "Expirée",
  "workspace_settings.members.expires_today": "Aujourd'hui",
  "workspace_settings.members.expires_in_days":
    "{count, plural, one {dans # jour} other {dans # jours}}",
  "workspace_settings.members.invited_days_ago":
    "{count, plural, =0 {Aujourd'hui} one {il y a # jour} other {il y a # jours}}",
  "workspace_settings.members.select_all_invitations": "Sélectionner toutes les invitations",
  "workspace_settings.members.select_one_invitation": "Sélectionner l'invitation pour {email}",
  "workspace_settings.members.invitation_actions_menu_aria": "Actions pour l'invitation à {email}",
  "workspace_settings.members.invitation_resend": "Renvoyer",
  "workspace_settings.members.invitation_resending": "Envoi en cours...",
  "workspace_settings.members.invitation_resend_success": "Invitation renvoyée",
  "workspace_settings.members.invitation_resend_error": "Échec du renvoi de l'invitation",
  "workspace_settings.members.invitation_copy_link": "Copier le lien d'invitation",
  "workspace_settings.members.invitation_copy_link_success": "Lien d'invitation copié",
  "workspace_settings.members.invitation_copy_link_error": "Échec de la copie du lien d'invitation",
  "workspace_settings.members.invitation_edit": "Modifier le rôle/les équipes",
  "workspace_settings.members.edit_invitation_dialog_title": "Modifier l'invitation pour {email}",
  "workspace_settings.members.edit_invitation_dialog_description":
    "Modifiez le rôle ou les équipes que cette invitation accorde à l'acceptation.",
  "workspace_settings.members.edit_invitation_save": "Enregistrer les modifications",
  "workspace_settings.members.edit_invitation_saving": "Enregistrement...",
  "workspace_settings.members.edit_invitation_success": "Invitation mise à jour",
  "workspace_settings.members.edit_invitation_error": "Échec de la mise à jour de l'invitation",
  "workspace_settings.members.bulk_resend.title":
    "{count, plural, one {Renvoyer # invitation ?} other {Renvoyer # invitations ?}}",
  "workspace_settings.members.bulk_resend.description":
    "Le courriel de chaque invitation est renvoyé et son expiration est prolongée.",
  "workspace_settings.members.bulk_resend.success":
    "{count, plural, one {# invitation renvoyée} other {# invitations renvoyées}}",
  "workspace_settings.members.bulk_resend.error": "Échec du renvoi de certaines invitations",
  "workspace_settings.members.bulk_progress": "{done} sur {total}",
  "workspace_settings.members.bulk_revoke.title":
    "{count, plural, one {Révoquer # invitation ?} other {Révoquer # invitations ?}}",
  "workspace_settings.members.bulk_revoke.description":
    "Personne ne pourra plus accepter ces invitations par la suite.",
  "workspace_settings.members.bulk_revoke.success":
    "{count, plural, one {# invitation révoquée} other {# invitations révoquées}}",
  "workspace_settings.members.bulk_revoke.error": "Échec de la révocation de certaines invitations",
  "workspace_settings.members.pending_invitations_empty": "Aucune invitation en attente.",
  "workspace_settings.members.pending_invitations_empty_filtered":
    "Aucune invitation en attente ne correspond aux filtres actuels.",
  "workspace_settings.members.pending_invitations_load_error":
    "Échec du chargement des invitations en attente.",
  "profile_settings.work_hours.hours_value": "{value} h",
  "profile_settings.work_hours.capacity_value": "{value} %",

  "workspace_settings.roles.title": "Rôles",
  "workspace_settings.roles.description":
    "Créez des rôles personnalisés et gérez leurs permissions.",
  "workspace_settings.roles.create_action": "Créer un rôle",
  "workspace_settings.roles.create_by_duplicate":
    "Pour créer un rôle, dupliquez un rôle existant et personnalisez-le.",
  "workspace_settings.roles.search_placeholder": "Rechercher des rôles…",
  "workspace_settings.roles.search_clear": "Effacer la recherche",
  "workspace_settings.roles.column_role": "Rôle",
  "workspace_settings.roles.column_description": "Description",
  "workspace_settings.roles.column_permissions": "Permissions",
  "workspace_settings.roles.column_members": "Membres",
  "workspace_settings.roles.column_actions": "Actions",
  "workspace_settings.roles.permission_count":
    "{count, plural, one {# permission} other {# permissions}}",
  "workspace_settings.roles.member_count": "{count, plural, one {# membre} other {# membres}}",
  "workspace_settings.roles.row_actions_label": "Actions pour {name}",
  "workspace_settings.roles.empty": "Aucun rôle pour le moment.",
  "workspace_settings.roles.section_title": "Rôles personnalisés",
  "workspace_settings.roles.section_description":
    "Créez des préréglages de rôle avec des ensembles de permissions explicites.",
  "workspace_settings.roles.system_badge": "Système",
  "workspace_settings.roles.default_badge": "Par défaut",
  "workspace_settings.roles.no_description": "Aucune description",
  "workspace_settings.roles.summary": "{permissions} permissions • {members} membres",
  "workspace_settings.roles.view_permissions": "Voir les permissions",
  "workspace_settings.roles.edit": "Modifier",
  "workspace_settings.roles.name_edit_hint": "Renommer",
  "workspace_settings.roles.set_default": "Définir par défaut",
  "workspace_settings.roles.name_required": "Un rôle doit avoir un nom.",
  "workspace_settings.roles.delete": "Supprimer",
  "workspace_settings.roles.delete_confirm_title": "Supprimer le rôle",
  "workspace_settings.roles.delete_confirm_description":
    "Supprimer le rôle « {name} » ? Les membres qui en sont titulaires perdront ces permissions.",
  "workspace_settings.roles.delete_success": "Rôle supprimé",
  "workspace_settings.roles.delete_error": "Échec de la suppression du rôle",
  "workspace_settings.roles.column_tier": "Niveau",
  "workspace_settings.roles.duplicate": "Dupliquer",
  "workspace_settings.roles.duplicate_success": "Rôle système dupliqué",
  "workspace_settings.roles.duplicate_error": "Échec de la duplication du rôle système",
  "workspace_settings.roles.editor_create_title": "Créer un rôle",
  "workspace_settings.roles.editor_description_editable":
    "Configurez un rôle personnalisé et choisissez les permissions accordées.",
  "workspace_settings.roles.editor_description_readonly":
    "Les rôles système sont en lecture seule. Consultez les permissions ci-dessous.",
  "workspace_settings.roles.name_label": "Nom",
  "workspace_settings.roles.description_label": "Description",
  "workspace_settings.roles.can_be_assigned": "Peut être affecté à des membres",
  "workspace_settings.roles.is_default": "Rôle par défaut pour les nouveaux membres",
  "workspace_settings.roles.close": "Fermer",
  "workspace_settings.roles.update": "Mettre à jour le rôle",
  "workspace_settings.roles.create": "Créer le rôle",
  "workspace_settings.roles.saving": "Enregistrement...",
  "workspace_settings.roles.update_success": "Rôle mis à jour",
  "workspace_settings.roles.create_success": "Rôle créé",
  "workspace_settings.roles.update_error": "Échec de la mise à jour du rôle",
  "workspace_settings.roles.create_error": "Échec de la création du rôle",

  "workspace_settings.roles.detail.description":
    "Définissez ce que ce rôle peut faire, consultez ce que son niveau verrouille et voyez qui en fait partie.",
  "workspace_settings.roles.detail.name_label": "Nom du rôle",
  "workspace_settings.roles.detail.description_label": "Description",
  "workspace_settings.roles.detail.default_label": "Attribuer ce rôle aux nouveaux membres",
  "workspace_settings.roles.detail.default_set": "Les nouveaux membres recevront ce rôle",
  "workspace_settings.roles.detail.default_error": "Échec de la définition du rôle par défaut",
  "workspace_settings.roles.detail.save_error": "Échec de l'enregistrement du rôle",
  "workspace_settings.roles.detail.load_error":
    "Impossible de charger les modifications non publiées du rôle. Réessayez.",
  "workspace_settings.roles.detail.publish_changes": "Publier les modifications",
  "workspace_settings.roles.detail.discard_changes": "Annuler les modifications",
  "workspace_settings.roles.detail.locked_title":
    "Ce rôle fait partie des rôles par défaut de Cognota",
  "workspace_settings.roles.detail.locked_description":
    "Les rôles par défaut ne peuvent pas être modifiés. Dupliquez-le pour créer un rôle personnalisé que vous pourrez modifier.",
  "workspace_settings.roles.detail.locked_duplicate": "Dupliquer pour personnaliser",
  "workspace_settings.roles.detail.publish_success": "Modifications du rôle publiées",
  "workspace_settings.roles.detail.publish_error":
    "Échec de la publication des modifications du rôle",
  "workspace_settings.roles.detail.discard_success": "Modifications non publiées du rôle annulées",
  "workspace_settings.roles.detail.discard_error":
    "Échec de l'annulation des modifications du rôle",
  "workspace_settings.roles.detail.tab_permissions": "Permissions",
  "workspace_settings.roles.detail.tab_members": "Membres du rôle",
  "workspace_settings.roles.eligibility.title": "Peut être désigné comme",
  "workspace_settings.roles.eligibility.description":
    "Ce ne sont pas des permissions : elles décident de ce que les personnes ayant ce rôle peuvent devenir, par exemple responsable de projet ou personne assignée à une tâche. Une modification est enregistrée aussitôt, sans publication, et ne s'applique qu'aux nouvelles affectations. Les accès et affectations actuels ne changent pas.",
  "workspace_settings.roles.eligibility.project_lead": "Responsable de projet",
  "workspace_settings.roles.eligibility.program_owner": "Propriétaire de programme",
  "workspace_settings.roles.eligibility.goal_lead": "Responsable d'objectif",
  "workspace_settings.roles.eligibility.team_lead": "Chef d'équipe",
  "workspace_settings.roles.eligibility.request_owner": "Propriétaire de demande",
  "workspace_settings.roles.eligibility.request_reviewer": "Réviseur de demande",
  "workspace_settings.roles.eligibility.workitem_assignee": "Personne assignée à une tâche",
  "workspace_settings.roles.eligibility.project_member": "Membre de projet",
  "workspace_settings.roles.eligibility.team_member": "Membre d'équipe",
  "workspace_settings.roles.eligibility.locked_reason":
    "Les rôles par défaut de Cognota sont verrouillés. Dupliquez ce rôle pour le modifier.",
  "workspace_settings.roles.eligibility.tier_reason":
    "Le niveau {tier} ne peut pas être désigné ainsi.",
  "workspace_settings.roles.eligibility.save_error":
    "Échec de l'enregistrement de ce que ce rôle peut devenir",
  "workspace_settings.roles.eligibility.load_error":
    "Impossible de charger ce que ce rôle peut devenir.",
  "workspace_settings.roles.eligibility.loading": "Chargement…",
  "workspace_settings.roles.detail.members_search_placeholder": "Rechercher des membres…",
  "workspace_settings.roles.detail.members_add": "Ajouter des membres",
  "workspace_settings.roles.detail.members_add_title": "Ajouter des membres à ce rôle",
  "workspace_settings.roles.detail.members_add_description":
    "Chaque personne choisie passe au rôle {role} et quitte le rôle système qu’elle a aujourd’hui.",
  "workspace_settings.roles.detail.members_add_label": "Membres",
  "workspace_settings.roles.detail.members_add_placeholder": "Choisir des membres",
  "workspace_settings.roles.detail.members_add_search": "Rechercher des membres",
  "workspace_settings.roles.detail.members_add_empty": "Tout le monde a déjà ce rôle",
  "workspace_settings.roles.detail.members_add_submit": "Ajouter",
  "workspace_settings.roles.detail.members_adding": "Ajout…",
  "workspace_settings.roles.detail.members_added": "Membres ajoutés : {count}",
  "workspace_settings.roles.detail.members_add_refused": "Impossible d’ajouter : {names}",
  "workspace_settings.roles.detail.members_empty_title": "Aucun membre ne détient encore ce rôle.",
  "workspace_settings.roles.detail.members_load_error":
    "Les membres de ce rôle n'ont pas pu être chargés.",

  "workspace_settings.roles.permissions.available_title": "Permissions disponibles",
  "workspace_settings.roles.permissions.available_description":
    "Activez-les ou désactivez-les pour ce rôle.",
  "workspace_settings.roles.permissions.locked_title": "Verrouillées par ce niveau",
  "workspace_settings.roles.permissions.locked_description":
    "Fixées par le niveau de ce rôle. Le niveau ne peut pas être modifié pour le moment.",

  // Permission categories, role presets and team-projects cell names (NG-2585)
  "workspace_settings.roles.permission_category.workspace": "Espace de travail",
  "workspace_settings.roles.permission_category.project": "Projets",
  "workspace_settings.roles.permission_category.workitem": "Éléments de travail",
  "workspace_settings.roles.permission_category.team": "Équipes",
  "workspace_settings.roles.permission_category.request": "Demandes",
  "workspace_settings.roles.permission_category.events": "Événements",
  "workspace_settings.roles.permission_category.calendar": "Calendriers",
  "workspace_settings.roles.permission_category.capacities": "Capacité",
  "workspace_settings.roles.permission_category.dashboard": "Tableaux de bord",
  "workspace_settings.roles.permission_category.goal": "Objectifs",
  "workspace_settings.roles.permission_category.process": "Processus",
  "workspace_settings.roles.permission_category.financialData": "Données financières",
  "workspace_settings.roles.preset.admin": "Partir du rôle Administrateur",
  "workspace_settings.roles.preset.standard_user": "Partir du rôle Utilisateur standard",
  "workspace_settings.roles.preset.guest": "Partir du rôle Invité",
  "workspace_settings.roles.preset.empty": "Aucune autorisation",
  "team_projects.cell_aria.delivery_teams": "Équipes de livraison · {name}",
  "team_projects.cell_aria.client_teams": "Équipes clientes · {name}",
  "team_projects.cell_aria.start_date": "Date de début · {name}",
  "team_projects.cell_aria.target_completion": "Achèvement prévu · {name}",
  "team_projects.cell_aria.actual_completion": "Achèvement réel · {name}",
  "team_projects.cell_aria.target_launch": "Lancement prévu · {name}",
  "team_projects.cell_aria.goals": "Objectifs · {name}",
  "team_projects.cell_aria.programs": "Programmes · {name}",

  "workspace_settings.roles.permissions.view_locked":
    "« Voir » reste activée tant qu'une autre permission ici l'est, car le reste n'a aucun sens sans elle.",
  "workspace_settings.roles.permissions.dependency_locked":
    "« {name} » a besoin que ceci soit activé, donc cela le reste jusqu'à ce que « {name} » soit désactivée.",
  "workspace_settings.roles.permissions.area_toggle_label": "Tout",
  "workspace_settings.roles.permissions.area_toggle_aria": "Toutes les permissions de {area}",
  "workspace_settings.roles.permissions.search_placeholder": "Rechercher des permissions…",
  "workspace_settings.roles.permissions.search_clear": "Effacer la recherche de permissions",
  "workspace_settings.roles.permissions.show_label": "Afficher",
  "workspace_settings.roles.permissions.show_all": "Toutes les permissions",
  "workspace_settings.roles.permissions.show_on": "Activées",
  "workspace_settings.roles.permissions.show_off": "Désactivées",
  "workspace_settings.roles.permissions.hidden_turned_on":
    "{count, plural, one {# permission masquée a aussi été activée} other {# permissions masquées ont aussi été activées}}.",
  "workspace_settings.roles.permissions.hidden_turned_off":
    "{count, plural, one {# permission masquée a aussi été désactivée} other {# permissions masquées ont aussi été désactivées}}.",
  "workspace_settings.roles.permissions.no_match": "Aucune permission ne correspond",
  "workspace_settings.roles.permissions.clear_filters": "Effacer la recherche et le filtre",
  "workspace_settings.roles.permissions.loading": "Chargement des permissions…",
  "workspace_settings.roles.permissions.load_error": "Impossible de charger les permissions.",

  "workspace_settings.ai_provider.title": "Fournisseur d'IA",
  "workspace_settings.digital_teammates.title": "Coéquipiers numériques",
  "workspace_settings.digital_teammates.description":
    "Choisissez les coéquipiers numériques que les membres de cet espace de travail peuvent utiliser. Chaque personne active toujours le sien elle-même.",
  "workspace_settings.digital_teammates.load_error":
    "Impossible de charger les coéquipiers numériques.",
  "workspace_settings.digital_teammates.ai_off_title":
    "Les fonctionnalités d'IA sont désactivées pour cet espace de travail.",
  "workspace_settings.digital_teammates.ai_off_description": "Contactez l'assistance Cognota.",
  "workspace_settings.digital_teammates.empty_title": "Aucun coéquipier numérique pour l'instant",
  "workspace_settings.digital_teammates.empty_description":
    "Lorsqu'un coéquipier numérique est disponible pour cet espace de travail, il apparaît ici.",
  "workspace_settings.digital_teammates.switch_aria": "Utiliser {name} dans cet espace de travail",
  "workspace_settings.digital_teammates.needs_approval": "Votre approbation est requise",
  "workspace_settings.digital_teammates.needs_approval_note":
    "{name} a été mis à jour. Il reste arrêté tant que vous n'avez pas approuvé la dernière version.",
  "workspace_settings.digital_teammates.approve": "Approuver",
  "workspace_settings.digital_teammates.turn_off_title": "Désactiver {name} ?",
  "workspace_settings.digital_teammates.turn_off_description":
    "Il cesse de fonctionner pour tout le monde dans cet espace de travail jusqu'à ce que vous le réactiviez.",
  "workspace_settings.digital_teammates.turn_off_confirm": "Désactiver",
  "workspace_settings.digital_teammates.save_error":
    "Impossible de mettre à jour {name}. Votre modification a été annulée.",
  "workspace_settings.digital_teammates.ai_off_error":
    "Les fonctionnalités d'IA sont désactivées pour cet espace de travail, {name} ne peut donc pas être activé.",
  "digital_teammates.view_permissions": "Voir toutes les autorisations",
  "digital_teammates.permissions.title": "Autorisations de {name}",
  "digital_teammates.permissions.description":
    "Tout ce que {name} peut faire dans cet espace de travail.",
  "digital_teammates.permissions.required_note":
    "Les autorisations marquées Toujours accordée sont indispensables au fonctionnement de ce coéquipier.",
  "workspace_settings.ai_provider.description":
    "Choisissez le fournisseur d'IA qui exécute l'agent de rapports pour cet espace de travail et fournissez ses identifiants. Cognota sélectionne les modèles.",
  "workspace_settings.ai_provider.mode_label": "Fournisseur",
  "workspace_settings.ai_provider.mode_managed": "Géré par Cognota",
  "workspace_settings.ai_provider.mode_managed_help":
    "Le compte d'IA de Cognota exécute l'agent. Rien à configurer.",
  "workspace_settings.ai_provider.mode_custom": "Votre propre fournisseur",
  "workspace_settings.ai_provider.mode_custom_help":
    "Le compte de votre organisation ; l'utilisation vous est facturée.",
  "workspace_settings.ai_provider.provider_label": "Fournisseur",
  "workspace_settings.ai_provider.runs_line":
    "Utilise {agent} pour les conversations et les tableaux de bord, et {fast} pour les tâches rapides.",
  "workspace_settings.ai_provider.docs_link": "Documentation {provider}",
  "workspace_settings.ai_provider.credential_stored": "Clé enregistrée {hint}",
  "workspace_settings.ai_provider.credential_replace": "Remplacer la clé",
  "workspace_settings.ai_provider.per_role_field_label": "{title} pour {model}",
  "workspace_settings.ai_provider.test_action": "Tester la connexion",
  "workspace_settings.ai_provider.testing": "Test de la connexion…",
  "workspace_settings.ai_provider.test_help":
    "Le test envoie une requête à chaque modèle avec cette clé. Il prend quelques secondes et est facturé par le fournisseur.",
  "workspace_settings.ai_provider.progress_help":
    "Des requêtes réelles sont envoyées au fournisseur ; cela peut prendre plusieurs secondes.",
  "workspace_settings.ai_provider.test_passed": "Test de connexion réussi",
  "workspace_settings.ai_provider.test_failed": "Échec du test de connexion",
  "workspace_settings.ai_provider.test_error": "Impossible d'exécuter le test de connexion.",
  "workspace_settings.ai_provider.role_agent": "Modèle agent",
  "workspace_settings.ai_provider.role_fast": "Modèle rapide",
  "workspace_settings.ai_provider.save": "Enregistrer",
  "workspace_settings.ai_provider.saving": "Enregistrement…",
  "workspace_settings.ai_provider.save_requires_test": "Testez la connexion avant d'enregistrer.",
  "workspace_settings.ai_provider.save_success": "Fournisseur d'IA enregistré.",
  "workspace_settings.ai_provider.save_refused":
    "Le test de connexion a échoué ; rien n'a été enregistré.",
  "workspace_settings.ai_provider.save_error": "Impossible d'enregistrer le fournisseur d'IA.",
  "workspace_settings.ai_provider.credential_changed":
    "La clé enregistrée a changé pendant le test. Veuillez réessayer.",
  "workspace_settings.ai_provider.resetting": "Retour à la gestion par Cognota…",
  "workspace_settings.ai_provider.resetting_help":
    "Le fournisseur et la clé enregistrés sont en cours de suppression.",
  "workspace_settings.ai_provider.reset_confirm_title": "Revenir à la gestion par Cognota ?",
  "workspace_settings.ai_provider.reset_confirm_description":
    "Le fournisseur et la clé enregistrés sont supprimés, et l'agent s'exécute de nouveau sur le compte de Cognota.",
  "workspace_settings.ai_provider.reset_confirm": "Revenir",
  "workspace_settings.ai_provider.reset_success": "Retour à la gestion par Cognota.",
  "workspace_settings.ai_provider.reset_error": "Impossible de revenir à la gestion par Cognota.",
  "workspace_settings.ai_provider.last_verified": "Dernière vérification : {date}",
  "workspace_settings.ai_provider.last_error": "Dernière erreur : {error}",
  "workspace_settings.ai_provider.load_error":
    "Impossible de charger le paramètre du fournisseur d'IA.",
  "workspace_settings.ai_provider.retry": "Réessayer",
  "workspace_settings.webhooks.title": "Webhooks",
  "workspace_settings.webhooks.description":
    "Créez, modifiez et inspectez les webhooks de l'espace de travail.",
  "workspace_settings.webhooks.create_action": "Créer un webhook",
  "workspace_settings.webhooks.empty_title": "Aucun webhook",
  "workspace_settings.webhooks.empty_description":
    "Créez un webhook pour envoyer les événements de l'espace de travail vers vos systèmes externes.",
  "workspace_settings.webhooks.active": "Actif",
  "workspace_settings.webhooks.disabled": "Désactivé",
  "workspace_settings.webhooks.updated_at": "Mis à jour le {date}",
  "workspace_settings.webhooks.quick_edit": "Édition rapide",
  "workspace_settings.webhooks.open_detail": "Ouvrir le détail",
  "workspace_settings.webhooks.dialog_create_title": "Créer un webhook",
  "workspace_settings.webhooks.dialog_edit_title": "Modifier le webhook",
  "workspace_settings.webhooks.dialog_description":
    "Configurez l'URL de rappel et choisissez les événements qui déclencheront ce webhook.",
  "workspace_settings.webhooks.url_label": "URL de rappel",
  "workspace_settings.webhooks.is_active": "Webhook actif",
  "workspace_settings.webhooks.event_scope": "Événements ciblés",
  "workspace_settings.webhooks.event_scope_all": "Tous les événements pris en charge",
  "workspace_settings.webhooks.event_scope_individual": "Choisir des groupes d'événements",
  "workspace_settings.webhooks.event.project": "Projets",
  "workspace_settings.webhooks.event.cycle": "Cycles",
  "workspace_settings.webhooks.event.module": "Modules",
  "workspace_settings.webhooks.event.issue": "Tickets",
  "workspace_settings.webhooks.event.issue_comment": "Commentaires",
  "workspace_settings.webhooks.saving": "Enregistrement...",
  "workspace_settings.webhooks.update": "Mettre à jour",
  "workspace_settings.webhooks.create": "Créer le webhook",
  "workspace_settings.webhooks.update_success": "Webhook mis à jour",
  "workspace_settings.webhooks.create_success": "Webhook créé",
  "workspace_settings.webhooks.update_error": "Échec de la mise à jour du webhook",
  "workspace_settings.webhooks.create_error": "Échec de la création du webhook",
  "workspace_settings.webhooks.secret_notice_title": "Sauvegardez ce secret maintenant",
  "workspace_settings.webhooks.secret_notice_description":
    "Ce secret ne sera affiché qu'une seule fois. Copiez-le avant de fermer cette fenêtre.",
  "workspace_settings.webhooks.secret_copy": "Copier le secret",
  "workspace_settings.webhooks.secret_copied": "Secret copié",
  "workspace_settings.webhooks.secret_copy_error": "Échec de la copie du secret",
  "workspace_settings.webhooks.secret_done": "Je l'ai enregistré",
  "workspace_settings.webhooks.detail_title": "Détail du webhook",
  "workspace_settings.webhooks.detail_description":
    "Inspectez la configuration du webhook, régénérez les secrets et examinez l'activité.",
  "workspace_settings.webhooks.detail_panel_title": "Détail du webhook",
  "workspace_settings.webhooks.detail_url": "URL",
  "workspace_settings.webhooks.detail_status": "Statut",
  "workspace_settings.webhooks.detail_edit": "Modifier le webhook",
  "workspace_settings.webhooks.detail_regenerate": "Régénérer le secret",
  "workspace_settings.webhooks.detail_load_logs": "Charger les journaux",
  "workspace_settings.webhooks.detail_delete": "Supprimer le webhook",
  "workspace_settings.webhooks.detail_regenerate_success": "Secret du webhook régénéré",
  "workspace_settings.webhooks.detail_regenerate_error":
    "Échec de la régénération du secret du webhook",
  "workspace_settings.webhooks.detail_delete_confirm_title": "Supprimer le webhook",
  "workspace_settings.webhooks.detail_delete_confirm_description":
    "Supprimer ce webhook ? L'URL cessera immédiatement de recevoir des événements.",
  "workspace_settings.webhooks.detail_delete_success": "Webhook supprimé",
  "workspace_settings.webhooks.detail_delete_error": "Échec de la suppression du webhook",
  "workspace_settings.webhooks.detail_logs_error": "Échec du chargement des journaux",
  "workspace_settings.webhooks.detail_secret_label": "Dernier secret généré",
  "workspace_settings.webhooks.detail_deliveries": "Livraisons récentes",
  "workspace_settings.webhooks.detail_deliveries_empty": "Aucune livraison pour l'instant",
  "workspace_settings.webhooks.detail_event_unknown": "Événement inconnu",

  "workspace_settings.sso.title": "SSO",
  "workspace_settings.sso.description":
    "Configurez les domaines SSO SAML et les paramètres du fournisseur d'identité.",
  "workspace_settings.sso.domains_title": "Domaines autorisés",
  "workspace_settings.sso.domains_description":
    "Limitez l'accès SSO à un ou plusieurs domaines e-mail.",
  "workspace_settings.sso.domains_placeholder": "example.com",
  "workspace_settings.sso.domains_add": "Ajouter un domaine",
  "workspace_settings.sso.domains_add_suggested": "Ajouter {domain}",
  "workspace_settings.sso.domains_remove": "Supprimer",
  "workspace_settings.sso.domains_empty": "Aucun domaine SSO configuré.",
  "workspace_settings.sso.domains_added": "Domaine ajouté",
  "workspace_settings.sso.domains_add_error": "Échec de l'ajout du domaine",
  "workspace_settings.sso.domains_removed": "Domaine supprimé",
  "workspace_settings.sso.domains_remove_error": "Échec de la suppression du domaine",
  "workspace_settings.sso.domain_sso_toggle": "SSO",
  "workspace_settings.sso.domain_sso_enabled": "SSO activé pour ce domaine",
  "workspace_settings.sso.domain_sso_disabled":
    "SSO désactivé — les utilisateurs de ce domaine se connecteront par mot de passe",
  "workspace_settings.sso.domain_sso_toggle_error": "Échec de la mise à jour du paramètre SSO",
  "workspace_settings.sso.domain_verified_badge": "Vérifié",
  "workspace_settings.sso.domain_pending_badge": "Vérification en attente",
  "workspace_settings.sso.domain_verify_token_label": "Valeur de l'enregistrement DNS TXT",
  "workspace_settings.sso.domain_verify_description":
    "Ajoutez cette valeur comme enregistrement DNS TXT pour {domain}, puis cliquez sur Vérifier. La connexion SSO reste désactivée pour ce domaine tant qu'il n'est pas vérifié.",
  "workspace_settings.sso.domain_verify_token_missing":
    "Ce domaine n'a pas de valeur de vérification. Supprimez ce domaine, puis ajoutez-le de nouveau.",
  "workspace_settings.sso.domain_verify_copy": "Copier",
  "workspace_settings.sso.domain_verify_copied": "Jeton de vérification copié",
  "workspace_settings.sso.domain_verify_copy_error": "Échec de la copie du jeton de vérification",
  "workspace_settings.sso.domain_verify_button": "Vérifier",
  "workspace_settings.sso.domain_verified_toast": "Domaine vérifié",
  "workspace_settings.sso.domain_verify_failed": "Échec de la vérification. Réessayez.",
  "workspace_settings.sso.provider_title": "Fournisseur d'identité",
  "workspace_settings.sso.provider_description":
    "Configurez les métadonnées du fournisseur SAML utilisé pour la connexion.",
  "workspace_settings.sso.provider_enabled": "Fournisseur activé",
  "workspace_settings.sso.provider_entity_id": "Entity ID",
  "workspace_settings.sso.provider_sso_url": "URL SSO",
  "workspace_settings.sso.provider_slo_url": "URL SLO",
  "workspace_settings.sso.provider_slo_url_hint":
    "Point de terminaison Single Logout de votre fournisseur d'identité. Lorsqu'il est défini — et que les clés de signature SAML de Cognota sont configurées — la déconnexion de Cognota déconnecte aussi l'utilisateur chez le fournisseur d'identité (SAML Single Logout) pour les sessions ouvertes après l'activation, puis le ramène à l'écran de connexion Cognota. Prévaut sur l'URL de déconnexion ci-dessous lorsqu'il s'exécute.",
  "workspace_settings.sso.provider_certificate": "Certificat",
  "workspace_settings.sso.provider_logout_url": "URL de déconnexion",
  "workspace_settings.sso.provider_logout_url_hint":
    "Où l'utilisateur est redirigé après sa déconnexion. Laissez ce champ vide pour le renvoyer vers l'écran de connexion Cognota.",
  "workspace_settings.sso.provider_logout_url_hint_slo":
    "Où l'utilisateur est redirigé après sa déconnexion — une simple redirection, sans déconnexion chez le fournisseur d'identité. Utilisée chaque fois que le Single Logout ne s'exécute pas : aucune URL SLO définie, ou session sans SLO possible. Laissez ce champ vide pour le renvoyer vers l'écran de connexion Cognota.",
  "workspace_settings.sso.provider_post_logout_redirect_enabled":
    "Rediriger les utilisateurs vers cette URL après leur déconnexion",
  "workspace_settings.sso.provider_validation_invalid_url": "Saisissez une URL http(s) valide.",
  "workspace_settings.sso.provider_saving": "Enregistrement...",
  "workspace_settings.sso.provider_update": "Mettre à jour le fournisseur",
  "workspace_settings.sso.provider_create": "Créer le fournisseur",
  "workspace_settings.sso.provider_delete": "Supprimer le fournisseur",
  "workspace_settings.sso.provider_delete_confirm_title": "Supprimer le fournisseur SSO",
  "workspace_settings.sso.provider_delete_confirm_description":
    "Supprimer ce fournisseur SSO ? La connexion SAML sera désactivée pour cet espace de travail.",
  "workspace_settings.sso.provider_saved": "Enregistré",
  "workspace_settings.sso.provider_update_success": "Fournisseur SSO mis à jour",
  "workspace_settings.sso.provider_create_success": "Fournisseur SSO créé",
  "workspace_settings.sso.provider_update_error": "Échec de la mise à jour du fournisseur SSO",
  "workspace_settings.sso.provider_create_error": "Échec de la création du fournisseur SSO",
  "workspace_settings.sso.single_active_provider_error":
    "Un autre fournisseur d'identité est déjà actif pour cet espace de travail. Désactivez-le avant d'en activer un autre.",
  "workspace_settings.sso.provider_delete_success": "Fournisseur SSO supprimé",
  "workspace_settings.sso.provider_delete_error": "Échec de la suppression du fournisseur SSO",
  "workspace_settings.sso.metadata_fill.title": "Remplir à partir des métadonnées",
  "workspace_settings.sso.metadata_fill.saml_description":
    "Collez, téléversez ou indiquez l'adresse des métadonnées SAML de votre fournisseur d'identité pour remplir les champs ci-dessous. Vérifiez-les, puis enregistrez. Vous pouvez toujours saisir chaque champ vous-même.",
  "workspace_settings.sso.metadata_fill.oidc_description":
    "Entrez l'émetteur de votre fournisseur d'identité pour remplir les points de terminaison ci-dessous à partir de son document de découverte. Vérifiez-les, ajoutez l'ID client et le secret, puis enregistrez. Vous pouvez toujours saisir chaque champ vous-même.",
  "workspace_settings.sso.metadata_fill.source_paste": "Coller le XML",
  "workspace_settings.sso.metadata_fill.source_upload": "Téléverser un fichier",
  "workspace_settings.sso.metadata_fill.source_url": "À partir d'une URL",
  "workspace_settings.sso.metadata_fill.xml_label": "XML des métadonnées",
  "workspace_settings.sso.metadata_fill.file_label": "Fichier de métadonnées",
  "workspace_settings.sso.metadata_fill.file_ready": "Prêt à lire {name}.",
  "workspace_settings.sso.metadata_fill.url_label": "URL des métadonnées",
  "workspace_settings.sso.metadata_fill.issuer_label": "URL de l'émetteur",
  "workspace_settings.sso.metadata_fill.tenant_label":
    "ID du répertoire (locataire) ou domaine principal",
  "workspace_settings.sso.metadata_fill.tenant_hint":
    "Il s'agit de l'émetteur multilocataire de Microsoft Entra ID. Entrez votre locataire, par exemple contoso.onmicrosoft.com, pour que la connexion n'accepte que votre locataire.",
  "workspace_settings.sso.metadata_fill.fill": "Remplir les champs",
  "workspace_settings.sso.metadata_fill.reading": "Lecture des métadonnées…",
  "workspace_settings.sso.metadata_fill.saml_filled":
    "L'Entity ID, l'URL SSO et le certificat ont été remplis. Vérifiez-les, puis enregistrez.",
  "workspace_settings.sso.metadata_fill.saml_filled_with_slo":
    "L'Entity ID, l'URL SSO, l'URL SLO et le certificat ont été remplis. Vérifiez-les, puis enregistrez.",
  "workspace_settings.sso.metadata_fill.saml_certificate":
    "Certificat : {subject}, valide jusqu'au {date}.",
  "workspace_settings.sso.metadata_fill.oidc_filled":
    "Les URL d'autorisation, de jeton et d'informations utilisateur ont été remplies. Vérifiez-les, ajoutez l'ID client et le secret, puis enregistrez.",
  "workspace_settings.sso.metadata_fill.oidc_filled_with_logout":
    "Les URL d'autorisation, de jeton, d'informations utilisateur et de déconnexion ont été remplies. Vérifiez-les, ajoutez l'ID client et le secret, puis enregistrez.",
  "workspace_settings.sso.metadata_fill.failed_title":
    "Impossible de remplir à partir des métadonnées",
  "workspace_settings.sso.metadata_fill.error_generic":
    "Un problème est survenu lors de la lecture de ces métadonnées. Réessayez ou saisissez les champs ci-dessous.",
  "workspace_settings.sso.metadata_fill.error_bad_url": "Cette adresse Web n'est pas valide.",
  "workspace_settings.sso.metadata_fill.error_not_https": "Utilisez une adresse https://.",
  "workspace_settings.sso.metadata_fill.error_unresolvable":
    "Nous n'avons pas trouvé cet hôte. Vérifiez l'adresse.",
  "workspace_settings.sso.metadata_fill.error_not_public":
    "Cette adresse n'est pas sur l'Internet public. Nous ne la consulterons donc pas.",
  "workspace_settings.sso.metadata_fill.error_unreachable":
    "Nous n'avons pas pu joindre cette adresse. Vérifiez-la et réessayez.",
  "workspace_settings.sso.metadata_fill.error_timeout":
    "Cette adresse a mis trop de temps à répondre. Réessayez.",
  "workspace_settings.sso.metadata_fill.error_status":
    "Cette adresse a répondu par une erreur ({status}).",
  "workspace_settings.sso.metadata_fill.error_too_large":
    "Ces métadonnées dépassent la limite de 1 Mo.",
  "workspace_settings.sso.metadata_fill.error_too_many_redirects":
    "Cette adresse a effectué trop de redirections.",
  "workspace_settings.sso.metadata_fill.error_dtd":
    "Les métadonnées SAML ne peuvent pas contenir de DTD ni de déclarations d'entités. Nous ne lirons donc pas ce fichier.",
  "workspace_settings.sso.metadata_fill.error_not_xml":
    "Il ne s'agit pas de métadonnées SAML : le XML est mal formé.",
  "workspace_settings.sso.metadata_fill.error_no_idp":
    "Ces métadonnées ne décrivent aucun fournisseur d'identité : elles n'ont pas d'IDPSSODescriptor.",
  "workspace_settings.sso.metadata_fill.error_no_entity_id":
    "Le fournisseur d'identité de ces métadonnées n'a pas d'entityID.",
  "workspace_settings.sso.metadata_fill.error_no_redirect_sso":
    "Ces métadonnées n'ont pas d'URL de connexion HTTP-Redirect, la liaison qu'utilise Cognota.",
  "workspace_settings.sso.metadata_fill.error_no_certificate":
    "Ces métadonnées n'ont pas de certificat de signature.",
  "workspace_settings.sso.metadata_fill.error_certificate_expired":
    "Tous les certificats de signature de ces métadonnées ont expiré.",
  "workspace_settings.sso.metadata_fill.error_certificate_unusable":
    "Aucun des certificats de signature de ces métadonnées n'est valide actuellement.",
  "workspace_settings.sso.metadata_fill.error_not_json":
    "Le document de découverte de cet émetteur n'est pas du JSON.",
  "workspace_settings.sso.metadata_fill.error_missing_endpoint":
    "Il manque au document de découverte de cet émetteur un point de terminaison dont la connexion a besoin.",
  "workspace_settings.sso.metadata_fill.error_insecure_endpoint":
    "Le document de découverte de cet émetteur indique un point de terminaison qui n'est pas une adresse https://.",
  "workspace_settings.sso.metadata_fill.error_issuer_mismatch":
    "Le document de découverte de cet émetteur indique un autre émetteur.",
  "workspace_settings.sso.metadata_fill.error_tenant_required":
    "Il s'agit de l'émetteur multilocataire de Microsoft Entra ID. Entrez l'ID de votre répertoire (locataire) ou votre domaine principal, puis remplissez de nouveau.",
  "workspace_settings.sso.metadata_fill.error_bad_tenant":
    "Entrez l'ID du répertoire (locataire) ou le domaine principal du locataire, par exemple contoso.onmicrosoft.com.",
  "workspace_settings.sso.metadata_fill.error_throttled":
    "Vous avez tenté de remplir à partir des métadonnées trop de fois. Attendez une minute, puis réessayez.",
  "workspace_settings.sso.metadata_title": "Métadonnées du fournisseur de service",
  "workspace_settings.sso.metadata_description":
    "Utilisez ces valeurs lors de la configuration de votre fournisseur SAML.",
  "workspace_settings.sso.metadata_description_connection":
    "Enregistrez ces valeurs une seule fois chez votre fournisseur d'identité. Elles servent à tous les espaces de travail qui utilisent cette connexion.",
  "workspace_settings.sso.metadata_description_unsaved_connection":
    "Enregistrez cette connexion pour obtenir les valeurs à inscrire chez votre fournisseur d'identité. Vous pouvez l'enregistrer désactivée, avant d'avoir les renseignements du fournisseur.",
  "workspace_settings.sso.metadata_entity_id": "Entity ID",
  "workspace_settings.sso.metadata_acs_url": "URL ACS",
  "workspace_settings.sso.metadata_slo_url": "URL SLO",
  "workspace_settings.sso.metadata_copy": "Copier",
  "workspace_settings.sso.metadata_copied": "Métadonnées copiées",
  "workspace_settings.sso.metadata_copy_error": "Échec de la copie des métadonnées",
  "workspace_settings.sso.sign_in_links.title": "Lien de connexion",
  "workspace_settings.sso.sign_in_links.description":
    "Envoyez ce lien aux personnes qui rejoignent cet espace de travail. Il les connecte par votre fournisseur d'identité, dans cet espace de travail.",
  "workspace_settings.sso.sign_in_links.workspace_label":
    "Lien de connexion de l'espace de travail",
  "workspace_settings.sso.sign_in_links.provider_label": "Lien de connexion pour ce fournisseur",
  "workspace_settings.sso.sign_in_links.provider_hint":
    "Évite le choix du fournisseur : après leur courriel, les personnes vont directement à celui-ci.",
  "workspace_settings.sso.sign_in_links.copy": "Copier",
  "workspace_settings.sso.sign_in_links.copied": "Lien de connexion copié",
  "workspace_settings.sso.sign_in_links.copy_error": "Impossible de copier le lien de connexion",
  "workspace_settings.sso.tabs.saml": "SAML",
  "workspace_settings.sso.tabs.oidc": "OIDC",
  "workspace_settings.sso.oidc.title": "Fournisseur d'identité OIDC",
  "workspace_settings.sso.oidc.description":
    "Configurez le client OIDC utilisé pour la connexion à l'espace de travail.",
  "workspace_settings.sso.oidc.enabled": "Fournisseur activé",
  "workspace_settings.sso.oidc.client_id": "Client ID",
  "workspace_settings.sso.oidc.client_secret": "Secret client",
  "workspace_settings.sso.oidc.authorize_url": "URL d'autorisation",
  "workspace_settings.sso.oidc.token_url": "URL du jeton",
  "workspace_settings.sso.oidc.userinfo_url": "URL userinfo",
  "workspace_settings.sso.oidc.logout_url": "URL de déconnexion",
  "workspace_settings.sso.oidc.logout_url_hint":
    "Où l'utilisateur est redirigé après sa déconnexion. Laissez ce champ vide pour le renvoyer vers l'écran de connexion Cognota.",
  "workspace_settings.sso.oidc.post_logout_redirect_enabled":
    "Rediriger les utilisateurs vers cette URL après leur déconnexion",
  "workspace_settings.sso.oidc.saving": "Enregistrement...",
  "workspace_settings.sso.oidc.update": "Mettre à jour le fournisseur",
  "workspace_settings.sso.oidc.create": "Créer le fournisseur",
  "workspace_settings.sso.oidc.delete": "Supprimer le fournisseur",
  "workspace_settings.sso.oidc.delete_confirm_title": "Supprimer le fournisseur OIDC",
  "workspace_settings.sso.oidc.delete_confirm_description":
    "Supprimer ce fournisseur OIDC ? La connexion OIDC sera désactivée pour cet espace de travail.",
  "workspace_settings.sso.oidc.update_success": "Fournisseur OIDC mis à jour",
  "workspace_settings.sso.oidc.create_success": "Fournisseur OIDC créé",
  "workspace_settings.sso.oidc.update_error": "Échec de la mise à jour du fournisseur OIDC",
  "workspace_settings.sso.oidc.create_error": "Échec de la création du fournisseur OIDC",
  "workspace_settings.sso.oidc.delete_success": "Fournisseur OIDC supprimé",
  "workspace_settings.sso.oidc.delete_error": "Échec de la suppression du fournisseur OIDC",
  "workspace_settings.sso.oidc.redirect_uri_title": "URI de redirection",
  "workspace_settings.sso.oidc.redirect_uri_description":
    "Collez cette URI de redirection dans les URI autorisées de votre fournisseur OIDC.",
  "workspace_settings.sso.oidc.redirect_uri_description_connection":
    "Enregistrez cette URI de redirection une seule fois chez votre fournisseur OIDC. Elle sert à tous les espaces de travail qui utilisent cette connexion.",
  "workspace_settings.sso.oidc.redirect_uri_description_unsaved_connection":
    "Enregistrez cette connexion pour obtenir l'URI de redirection à inscrire chez votre fournisseur OIDC. Vous pouvez l'enregistrer désactivée, avant d'avoir les renseignements du fournisseur.",
  "workspace_settings.sso.oidc.redirect_uri_label": "URI de redirection",
  "workspace_settings.sso.oidc.redirect_uri_copy": "Copier",
  "workspace_settings.sso.oidc.redirect_uri_copied": "URI de redirection copiée",
  "workspace_settings.sso.oidc.redirect_uri_copy_error":
    "Échec de la copie de l'URI de redirection",
  "workspace_settings.sso.oidc.validation_missing_fields":
    "Remplissez tous les champs OIDC requis avant d'enregistrer.",
  "workspace_settings.sso.oidc.validation_invalid_url":
    "Les URL d'autorisation, de jeton, userinfo et de déconnexion doivent être des URL valides.",
  "workspace_settings.sso.oidc.secret_show": "Afficher le secret",
  "workspace_settings.sso.oidc.secret_hide": "Masquer le secret",
  "workspace_settings.sso.oidc.secret_placeholder": "••••••••",

  "workspace_settings.sso.override_title": "Contournement de la connexion par mot de passe",
  "workspace_settings.sso.override_description":
    "Autorisez temporairement la connexion et la réinitialisation par mot de passe pour cet espace de travail, même si le SSO est appliqué. Utilisez ceci pour tester un nouveau fournisseur d'identité ou pour récupérer l'accès s'il cesse de fonctionner. Désactivez-le une fois terminé.",
  "workspace_settings.sso.override_label": "Autoriser la connexion par mot de passe",
  "workspace_settings.sso.override_active_notice":
    "La connexion par mot de passe est actuellement autorisée pour cet espace de travail, en contournement de l'application du SSO.",
  "workspace_settings.sso.override_enable_confirm_title":
    "Autoriser la connexion par mot de passe ?",
  "workspace_settings.sso.override_enable_confirm_description":
    "Cela suspend l'application du SSO pour tout l'espace de travail — n'importe qui peut se connecter ou réinitialiser son mot de passe sans passer par votre fournisseur d'identité jusqu'à ce que vous désactiviez cette option.",
  "workspace_settings.sso.override_enable_confirm": "Autoriser la connexion par mot de passe",
  "workspace_settings.sso.override_enabled_success": "Contournement de connexion activé",
  "workspace_settings.sso.override_disabled_success": "Contournement de connexion désactivé",
  "workspace_settings.sso.override_toggle_error":
    "Échec de la mise à jour du contournement de connexion",
  "workspace_settings.sso.sharing.used_by_title": "Utilisé par",
  "workspace_settings.sso.sharing.this_workspace": "Cet espace de travail",
  "workspace_settings.sso.sharing.read_only_title":
    "Aussi utilisé par des espaces de travail dont vous n'êtes pas administrateur",
  "workspace_settings.sso.sharing.read_only_description":
    "Seul un administrateur de chaque espace de travail qui utilise ce fournisseur d'identité peut le modifier ou le supprimer.",
  "workspace_settings.sso.sharing.delete_shared_warning":
    "Il est aussi utilisé par {workspaces}, et le supprimer y arrête aussi la connexion par son intermédiaire. Les membres d'un espace de travail qui exige le SSO pourraient perdre l'accès, à moins que son administrateur n'active Autoriser la connexion par mot de passe.",
  "workspace_settings.sso.sharing.link_open": "Lier à un autre espace de travail",
  "workspace_settings.sso.sharing.link_title": "Lier à un autre espace de travail",
  "workspace_settings.sso.sharing.link_description":
    "Les membres de l'espace de travail choisi pourront aussi se connecter par ce fournisseur d'identité. Ensuite, seul un administrateur de chaque espace de travail qui l'utilise pourra le modifier ou le supprimer.",
  "workspace_settings.sso.sharing.link_target_label": "Espace de travail",
  "workspace_settings.sso.sharing.link_target_placeholder": "Choisir un espace de travail",
  "workspace_settings.sso.sharing.link_targets_empty":
    "Aucun des autres espaces de travail dont vous êtes administrateur ne peut l'utiliser.",
  "workspace_settings.sso.sharing.link_targets_error":
    "Impossible de charger vos espaces de travail. Fermez cette fenêtre et réessayez.",
  "workspace_settings.sso.sharing.link_cancel": "Annuler",
  "workspace_settings.sso.sharing.link_confirm": "Lier",
  "workspace_settings.sso.sharing.link_saving": "Liaison...",
  "workspace_settings.sso.sharing.link_success": "Lié à {workspace}",
  "workspace_settings.sso.sharing.link_error": "Échec de la liaison du fournisseur d'identité",
  "workspace_settings.sso.sharing.link_error_already_linked":
    "Cet espace de travail utilise déjà ce fournisseur d'identité.",
  "workspace_settings.sso.sharing.link_error_target_has_one":
    "Cet espace de travail utilise déjà un fournisseur d'identité.",
  "workspace_settings.sso.sharing.link_error_target_not_ready":
    "Cet espace de travail ne peut pas encore utiliser un fournisseur d'identité d'un autre espace de travail.",
  "workspace_settings.sso.sharing.link_error_not_allowed":
    "Vous devez être administrateur de chaque espace de travail qui l'utilise, et de celui que vous liez.",
  "workspace_settings.sso.sharing.stop_open": "Cesser d'utiliser dans {workspace}",
  "workspace_settings.sso.sharing.stop_confirm_title":
    "Cesser d'utiliser ce fournisseur d'identité dans {workspace} ?",
  "workspace_settings.sso.sharing.stop_confirm_description":
    "Les membres de {workspace} ne se connecteront plus par son intermédiaire. Il reste configuré pour les autres espaces de travail qui l'utilisent.",
  "workspace_settings.sso.sharing.stop_confirm_lockout":
    "C'est le seul fournisseur d'identité de {workspace}, et {workspace} exige le SSO : ses membres pourraient perdre l'accès. Activez d'abord Autoriser la connexion par mot de passe s'ils doivent encore se connecter.",
  "workspace_settings.sso.sharing.stop_confirm": "Cesser d'utiliser",
  "workspace_settings.sso.sharing.stop_success":
    "{workspace} n'utilise plus ce fournisseur d'identité",
  "workspace_settings.sso.sharing.stop_error":
    "Échec de l'arrêt de l'utilisation du fournisseur d'identité",
  "workspace_settings.sso.sharing.name_label": "Nom",
  "workspace_settings.sso.sharing.name_hint":
    "Un nom qui distingue ce fournisseur d'identité des autres qui partagent un domaine.",
  "workspace_settings.sso.sharing.shared_domain_hint":
    "Les personnes de {domain} verront plus d'une façon de se connecter. Nommez cette connexion pour qu'elles puissent choisir la bonne.",

  "workspace_settings.sso.sign_up_title": "Nouvelles personnes via le SSO",
  "workspace_settings.sso.sign_up_description":
    "Le rôle et les équipes attribués à une personne lors de sa première connexion par SSO, quel que soit son fournisseur d'identité. Les personnes que vous invitez reçoivent plutôt le rôle et les équipes de leur invitation.",
  "workspace_settings.sso.sign_up_role_label": "Rôle",
  "workspace_settings.sso.sign_up_role_default": "Rôle par défaut de l'espace de travail ({role})",
  "workspace_settings.sso.sign_up_teams_label": "Équipes",
  "workspace_settings.sso.sign_up_teams_placeholder": "Aucune équipe",
  "workspace_settings.sso.sign_up_saving": "Enregistrement…",
  "workspace_settings.sso.sign_up_saved":
    "Rôle et équipes des nouvelles personnes via le SSO enregistrés",
  "workspace_settings.sso.sign_up_save_error":
    "Échec de l'enregistrement du rôle et des équipes des nouvelles personnes via le SSO",
  "workspace_settings.sso.sign_up_load_error":
    "Impossible de charger le rôle et les équipes des nouvelles personnes via le SSO. Rechargez la page pour réessayer.",

  "workspace_settings.password_policy.title": "Politique de mot de passe",
  "workspace_settings.password_policy.description":
    "Renforcez les exigences de mot de passe de cet espace de travail au-delà du minimum de la plateforme. Chaque paramètre ne peut être que plus strict, jamais plus faible — et si le même compte appartient à plusieurs espaces de travail avec connexion par mot de passe, la valeur la plus stricte de chaque paramètre s'applique à leur mot de passe partagé.",
  "workspace_settings.password_policy.min_length_label": "Longueur minimale",
  "workspace_settings.password_policy.min_length_help":
    "Laissez vide pour utiliser le minimum de la plateforme de {min} caractères.",
  "workspace_settings.password_policy.variety_label": "Exiger un mélange de types de caractères",
  "workspace_settings.password_policy.variety_help":
    "Au moins 3 parmi : majuscules, minuscules, chiffres, symboles.",
  "workspace_settings.password_policy.expiration_label":
    "Exiger des changements de mot de passe périodiques",
  "workspace_settings.password_policy.expiration_days_label":
    "Jours avant l'expiration d'un mot de passe",
  "workspace_settings.password_policy.reuse_label":
    "Bloquer la réutilisation des mots de passe récents",
  "workspace_settings.password_policy.reuse_help":
    "Bloque la réutilisation des 5 derniers mots de passe.",
  "workspace_settings.password_policy.save": "Enregistrer les modifications",
  "workspace_settings.password_policy.saving": "Enregistrement...",
  "workspace_settings.password_policy.save_success": "Politique de mot de passe mise à jour",
  "workspace_settings.password_policy.save_error":
    "Échec de la mise à jour de la politique de mot de passe",

  "workspace_settings.session_timeout.title": "Expiration de session",
  "workspace_settings.session_timeout.description":
    "Renforcez la durée d'inactivité autorisée pour une session et la limite absolue de sa durée. Chaque paramètre ne peut être que plus strict, jamais plus faible — et si le même compte appartient à plusieurs espaces de travail, la valeur la plus stricte de chaque paramètre s'applique à leur session partagée.",
  "workspace_settings.session_timeout.idle_label":
    "Terminer une session après une période d'inactivité",
  "workspace_settings.session_timeout.idle_help": "Minimum {min} minutes. Désactivé par défaut.",
  "workspace_settings.session_timeout.absolute_label": "Réduire la limite absolue de session",
  "workspace_settings.session_timeout.absolute_help":
    "Laissez décoché pour utiliser le défaut de la plateforme de {days} jours.",
  "workspace_settings.session_timeout.unit_minutes": "Minutes",
  "workspace_settings.session_timeout.unit_hours": "Heures",
  "workspace_settings.session_timeout.unit_days": "Jours",
  "workspace_settings.session_timeout.idle_unit_label": "Unité du délai d'inactivité",
  "workspace_settings.session_timeout.absolute_unit_label": "Unité de la limite absolue de session",
  "workspace_settings.session_timeout.save": "Enregistrer les modifications",
  "workspace_settings.session_timeout.saving": "Enregistrement...",
  "workspace_settings.session_timeout.save_success":
    "Paramètres d'expiration de session mis à jour",
  "workspace_settings.session_timeout.save_error":
    "Échec de la mise à jour des paramètres d'expiration de session",
  "workspace_settings.session_timeout.load_error":
    "Impossible de charger la politique d'expiration de session actuelle.",
  "workspace_settings.session_timeout.retry": "Réessayer",

  "workspace_settings.exports.title": "Exports",
  "workspace_settings.exports.description":
    "Déclenchez des exports de tickets et suivez les exports récents.",
  "workspace_settings.exports.run_title": "Lancer un export",
  "workspace_settings.exports.run_description":
    "Exportez les tickets de l'espace de travail au format CSV, Excel ou JSON.",
  "workspace_settings.exports.format_label": "Format",
  "workspace_settings.exports.format_csv": "CSV",
  "workspace_settings.exports.format_xlsx": "Excel (.xlsx)",
  "workspace_settings.exports.format_json": "JSON",
  "workspace_settings.exports.projects_title": "Projets",
  "workspace_settings.exports.projects_hint":
    "Laissez vide pour exporter tous les projets accessibles.",
  "workspace_settings.exports.submit": "Lancer l'export",
  "workspace_settings.exports.submitting": "Lancement...",
  "workspace_settings.exports.submit_success": "Export lancé",
  "workspace_settings.exports.submit_error": "Échec du lancement de l'export",
  "workspace_settings.exports.history_title": "Exports précédents",
  "workspace_settings.exports.history_description":
    "Exports de tickets récents et liens de téléchargement.",
  "workspace_settings.exports.history_refresh": "Actualiser",
  "workspace_settings.exports.history_empty": "Aucun export demandé pour l'instant.",
  "workspace_settings.exports.history_previous": "Précédent",
  "workspace_settings.exports.history_next": "Suivant",
  "workspace_settings.exports.row_label": "Export {provider}",
  "workspace_settings.exports.row_download": "Télécharger",

  "workspace_settings.calendars.title": "Calendriers",
  "workspace_settings.calendars.description":
    "Gérez les calendriers de jours fériés, les connexions OAuth utilisateur et les intégrations à l'échelle du domaine.",
  "workspace_settings.calendars.user_title": "Connexions de calendrier utilisateur",
  "workspace_settings.calendars.user_description":
    "Autoriser les connexions Google et Outlook scopées à l'utilisateur depuis les paramètres de l'espace de travail.",
  "workspace_settings.calendars.user_connect_google": "Connecter Google Calendar",
  "workspace_settings.calendars.user_connect_outlook": "Connecter Outlook Calendar",
  "workspace_settings.calendars.user_connect_disabled_domain_wide":
    "La synchronisation de domaine est active pour cet espace de travail — votre calendrier est déjà synchronisé.",
  "workspace_settings.calendars.user_source_superseded":
    "Remplacé par la synchronisation de domaine",
  "workspace_settings.calendars.redirect_connected": "Calendrier connecté",
  "workspace_settings.calendars.redirect_error_denied": "Connexion au calendrier annulée",
  "workspace_settings.calendars.redirect_error_no_code":
    "Échec de la connexion au calendrier — le fournisseur n'a pas retourné de code d'autorisation.",
  "workspace_settings.calendars.redirect_error_invalid_state":
    "Échec de la connexion au calendrier — état de session invalide.",
  "workspace_settings.calendars.redirect_error_exchange_failed":
    "Échec de la connexion au calendrier — impossible d'échanger le code d'autorisation.",
  "workspace_settings.calendars.redirect_error_domain_wide_active":
    "La synchronisation de domaine est active pour cet espace de travail — une connexion personnelle n'est pas nécessaire.",
  "workspace_settings.calendars.redirect_error_unknown": "Échec de la connexion au calendrier.",
  "workspace_settings.calendars.user_connect_error_google": "Échec de la connexion Google Calendar",
  "workspace_settings.calendars.user_connect_error_outlook":
    "Échec de la connexion Outlook Calendar",
  "workspace_settings.calendars.user_sync": "Synchroniser",
  "workspace_settings.calendars.user_sync_success": "Synchronisation lancée",
  "workspace_settings.calendars.user_sync_error": "Échec du lancement de la synchronisation",
  "workspace_settings.calendars.user_disconnect": "Déconnecter",
  "workspace_settings.calendars.user_delete": "Supprimer",
  "workspace_settings.calendars.user_disconnect_success": "Connexion retirée",
  "workspace_settings.calendars.user_disconnect_error": "Échec du retrait de la connexion",
  "workspace_settings.calendars.user_never_synced": "Jamais synchronisé",
  "workspace_settings.calendars.user_empty": "Aucune connexion de calendrier utilisateur.",
  "workspace_settings.calendars.user_events": "{count} événements",
  "workspace_settings.calendars.sync_status_never": "Jamais synchronisé",
  "workspace_settings.calendars.sync_status_pending": "Synchronisation",
  "workspace_settings.calendars.sync_status_success": "Sain",
  "workspace_settings.calendars.sync_status_failed": "Échec",
  "workspace_settings.calendars.sync_status_skipped": "Ignoré",
  "workspace_settings.calendars.sync_last_success": "Dernier succès {date}",
  "workspace_settings.calendars.sync_last_started": "Dernier démarrage {date}",
  "workspace_settings.calendars.sync_never": "Jamais synchronisé",
  "workspace_settings.calendars.sync_last_event_count": "{count} dernière sync",
  "workspace_settings.calendars.holidays_title": "Jours fériés",
  "workspace_settings.calendars.holidays_description":
    "Sélectionnez votre pays ou région pour générer des jours fériés qui réduisent votre capacité.",
  "workspace_settings.calendars.holidays_country_label": "Pays",
  "workspace_settings.calendars.holidays_region_label": "Région",
  "workspace_settings.calendars.holidays_national": "Jours fériés nationaux seulement",
  "workspace_settings.calendars.holidays_empty": "Aucun calendrier de jours fériés généré.",
  "workspace_settings.calendars.holidays_current":
    "Les jours fériés {region} sont actifs avec {count} événements.",
  "workspace_settings.calendars.holidays_save": "Générer les jours fériés",
  "workspace_settings.calendars.holidays_saving": "Génération...",
  "workspace_settings.calendars.holidays_remove": "Supprimer",
  "workspace_settings.calendars.holidays_save_success": "Jours fériés mis à jour",
  "workspace_settings.calendars.holidays_save_error": "Échec de la mise à jour des jours fériés",
  "workspace_settings.calendars.holidays_remove_success": "Jours fériés supprimés",
  "workspace_settings.calendars.holidays_remove_error": "Échec de la suppression",
  "workspace_settings.calendars.google_title": "Synchronisation Google Workspace",
  "workspace_settings.calendars.google_description":
    "Configurez une intégration à base de compte de service qui synchronise les calendriers des membres correspondants.",
  "workspace_settings.calendars.google_field_domain": "Domaine Google Workspace",
  "workspace_settings.calendars.google_field_key": "JSON du compte de service",
  "workspace_settings.calendars.outlook_title": "Synchronisation Outlook",
  "workspace_settings.calendars.outlook_description":
    "Configurez l'accès de planification à l'échelle du domaine Microsoft 365 pour les membres correspondants.",
  "workspace_settings.calendars.outlook_field_tenant": "Tenant ID",
  "workspace_settings.calendars.outlook_field_client_id": "Client ID",
  "workspace_settings.calendars.outlook_field_client_secret": "Client secret",
  "workspace_settings.calendars.outlook_field_domain": "Domaine Microsoft 365",
  "workspace_settings.calendars.config_enabled": "Activé",
  "workspace_settings.calendars.config_disabled": "Désactivé",
  "workspace_settings.calendars.config_matched_members": "{count} membres correspondants",
  "workspace_settings.calendars.config_failed_members": "{count} en échec",
  "workspace_settings.calendars.config_last_dispatch": "Dernier lancement {date}",
  "workspace_settings.calendars.config_test_placeholder": "user@example.com",
  "workspace_settings.calendars.config_test": "Tester",
  "workspace_settings.calendars.config_sync": "Synchroniser",
  "workspace_settings.calendars.config_enable": "Activer",
  "workspace_settings.calendars.config_disable": "Désactiver",
  "workspace_settings.calendars.config_connect": "Connecter",
  "workspace_settings.calendars.config_saving": "Enregistrement...",
  "workspace_settings.calendars.config_remove": "Retirer l'intégration",
  "workspace_settings.calendars.config_test_failed": "Échec du test de connexion",
  "workspace_settings.calendars.members_empty": "Aucun membre correspondant.",
  "workspace_settings.calendars.members_never_synced": "Jamais synchronisé",
  "workspace_settings.calendars.members_events": "{count} événements",
  "workspace_settings.calendars.members_showing": "Affichage de {shown} sur {total}",
  "workspace_settings.calendars.members_load_more": "Charger plus",
  "workspace_settings.calendars.members_loading": "Chargement...",

  "workspace_settings.calendars.holiday_calendars.title": "Calendriers personnalisés et de congés",
  "workspace_settings.calendars.holiday_calendars.description":
    "Calendriers de congés gérés par l'organisation. Les personnes sont associées automatiquement selon leur équipe ou leur pays et région.",
  "workspace_settings.calendars.holiday_calendars.new": "Nouveau calendrier",
  "workspace_settings.calendars.holiday_calendars.empty":
    "Aucun calendrier de congés pour l'instant.",
  "workspace_settings.calendars.holiday_calendars.column_name": "Nom",
  "workspace_settings.calendars.holiday_calendars.column_applies_to": "S'applique à",
  "workspace_settings.calendars.holiday_calendars.column_status": "Statut",
  "workspace_settings.calendars.holiday_calendars.column_actions": "Actions",
  "workspace_settings.calendars.holiday_calendars.row_actions_label": "Actions pour {name}",
  "workspace_settings.calendars.holiday_calendars.name_label": "Nom",
  "workspace_settings.calendars.holiday_calendars.name_placeholder":
    "ex. Jours fériés de l'entreprise",
  "workspace_settings.calendars.holiday_calendars.name_edit_hint": "Renommer le calendrier",
  "workspace_settings.calendars.holiday_calendars.view_only_badge": "Lecture seule",
  "workspace_settings.calendars.holiday_calendars.view_only_banner":
    "Ce calendrier appartient à une autre équipe : vous pouvez le consulter mais pas le modifier.",
  "workspace_settings.calendars.holiday_calendars.locked_to_team_help":
    "Ce calendrier s'applique aux personnes de cette équipe.",
  "workspace_settings.calendars.holiday_calendars.applies_to_label": "S'applique à",
  "workspace_settings.calendars.holiday_calendars.applies_to_everyone": "Tout le monde",
  "workspace_settings.calendars.holiday_calendars.applies_to_specific": "Personnes spécifiques",
  "workspace_settings.calendars.holiday_calendars.applies_to_team_unset":
    "Aucune équipe sélectionnée",
  "workspace_settings.calendars.holiday_calendars.applies_to_region_unset":
    "Aucune région sélectionnée",
  "workspace_settings.calendars.holiday_calendars.match_by_label": "Associer par",
  "workspace_settings.calendars.holiday_calendars.match_by_country_region": "Pays et région",
  "workspace_settings.calendars.holiday_calendars.match_by_team": "Équipe",
  "workspace_settings.calendars.holiday_calendars.team_label": "Équipe",
  "workspace_settings.calendars.holiday_calendars.team_placeholder": "Sélectionner une équipe",
  "workspace_settings.calendars.holiday_calendars.team_search_placeholder":
    "Rechercher des équipes…",
  "workspace_settings.calendars.holiday_calendars.team_empty": "Aucune équipe trouvée",
  "workspace_settings.calendars.holiday_calendars.status_draft": "Brouillon",
  "workspace_settings.calendars.holiday_calendars.status_active": "Actif",
  "workspace_settings.calendars.holiday_calendars.status_inactive": "Inactif",
  "workspace_settings.calendars.holiday_calendars.new_title": "Nouveau calendrier de congés",
  "workspace_settings.calendars.holiday_calendars.new_description":
    "Nommez le calendrier et choisissez qui il couvre. Vous pourrez ajouter ses dates ensuite.",
  "workspace_settings.calendars.holiday_calendars.cancel": "Annuler",
  "workspace_settings.calendars.holiday_calendars.create": "Créer",
  "workspace_settings.calendars.holiday_calendars.creating": "Création…",
  "workspace_settings.calendars.holiday_calendars.create_success": "Calendrier de congés créé.",
  "workspace_settings.calendars.holiday_calendars.create_error":
    "Impossible de créer le calendrier.",
  "workspace_settings.calendars.holiday_calendars.update_success": "Modifications enregistrées.",
  "workspace_settings.calendars.holiday_calendars.update_error":
    "Impossible d'enregistrer vos modifications.",
  "workspace_settings.calendars.holiday_calendars.edit": "Modifier",
  "workspace_settings.calendars.holiday_calendars.delete": "Supprimer",
  "workspace_settings.calendars.holiday_calendars.delete_confirm_title":
    "Supprimer ce calendrier ?",
  "workspace_settings.calendars.holiday_calendars.delete_confirm_description":
    "« {name} » couvre {count} personnes. Le supprimer retire ses dates et tout impact sur la capacité. Action irréversible.",
  "workspace_settings.calendars.holiday_calendars.delete_success": "Calendrier de congés supprimé.",
  "workspace_settings.calendars.holiday_calendars.delete_error":
    "Impossible de supprimer le calendrier.",
  "workspace_settings.calendars.holiday_calendars.suggestions.title": "Calendriers suggérés",
  "workspace_settings.calendars.holiday_calendars.suggestions.description":
    "Aucun calendrier ne couvre ces personnes, elles n'ont donc aucun jour férié.",
  "workspace_settings.calendars.holiday_calendars.suggestions.covers_region":
    "Un calendrier pour {name}",
  "workspace_settings.calendars.holiday_calendars.suggestions.covers_team":
    "Un calendrier pour l'équipe {name}",
  "workspace_settings.calendars.holiday_calendars.suggestions.affected_one":
    "1 utilisateur n'est couvert par aucun calendrier.",
  "workspace_settings.calendars.holiday_calendars.suggestions.affected_other":
    "{count} utilisateurs ne sont couverts par aucun calendrier.",
  "workspace_settings.calendars.holiday_calendars.suggestions.create": "Créer",
  "workspace_settings.calendars.holiday_calendars.suggestions.dismiss": "Ignorer {name}",
  "workspace_settings.calendars.holiday_calendars.suggestions.dismiss_error":
    "Impossible d'ignorer la suggestion.",
  "workspace_settings.calendars.holiday_calendars.suggestions.suggested_name":
    "Jours fériés – {name}",
  "workspace_settings.calendars.holiday_calendars.publish": "Publier",
  "workspace_settings.calendars.holiday_calendars.publish_success": "Calendrier publié.",
  "workspace_settings.calendars.holiday_calendars.publish_error":
    "Impossible de publier le calendrier.",
  "workspace_settings.calendars.holiday_calendars.deactivate": "Désactiver",
  "workspace_settings.calendars.holiday_calendars.deactivate_confirm_title":
    "Désactiver ce calendrier ?",
  "workspace_settings.calendars.holiday_calendars.deactivate_confirm_description":
    "« {name} » cessera d'affecter la capacité des personnes couvertes, y compris les dates passées. Vous pourrez le réactiver plus tard.",
  "workspace_settings.calendars.holiday_calendars.toggle_active_label":
    "Activer/désactiver pour {name}",
  "workspace_settings.calendars.holiday_calendars.back_to_calendars": "Retour aux calendriers",
  "workspace_settings.calendars.holiday_calendars.coverage_title": "Couverture",
  "workspace_settings.calendars.holiday_calendars.coverage_description":
    "Les personnes couvertes par ce calendrier. Les changements de portée réassocient les personnes immédiatement.",
  "workspace_settings.calendars.holiday_calendars.inert_title":
    "Ces dates ne réduisent encore la capacité de personne",
  "workspace_settings.calendars.holiday_calendars.inert_reason_inactive":
    "Ce calendrier est désactivé — activez-le pour appliquer ses dates.",
  "workspace_settings.calendars.holiday_calendars.inert_reason_never_published":
    "Ce calendrier n'a jamais été publié — publiez-le pour appliquer ses dates.",
  "workspace_settings.calendars.holiday_calendars.inert_reason_matches_nobody":
    "Aucun profil ne porte ce pays et cette r\u00e9gion, le calendrier ne correspond donc \u00e0 personne \u2014 renseignez le pays et la r\u00e9gion sur les profils, ou modifiez la port\u00e9e de ce calendrier.",
  "workspace_settings.calendars.holiday_calendars.people_title": "Personnes sur ce calendrier",
  "workspace_settings.calendars.holiday_calendars.people_count": "{count} personnes",
  "workspace_settings.calendars.holiday_calendars.people_column_name": "Nom",
  "workspace_settings.calendars.holiday_calendars.people_column_team": "Équipe",
  "workspace_settings.calendars.holiday_calendars.people_column_country": "Pays",
  "workspace_settings.calendars.holiday_calendars.people_column_region": "Région",
  "workspace_settings.calendars.holiday_calendars.people_loading": "Chargement…",
  "workspace_settings.calendars.holiday_calendars.people_search": "Rechercher des personnes",
  "workspace_settings.calendars.holiday_calendars.people_search_clear":
    "Effacer la recherche de personnes",
  "workspace_settings.calendars.holiday_calendars.people_no_matches":
    "Aucune personne de ce calendrier ne correspond à cette recherche.",
  "workspace_settings.calendars.holiday_calendars.people_truncated":
    "Affichage de {shown} sur {total}. Recherchez pour trouver une personne précise.",
  "workspace_settings.calendars.holiday_calendars.team_required":
    "Choisissez une équipe : sans équipe, ce calendrier ne couvre personne.",
  "workspace_settings.calendars.holiday_calendars.country_required":
    "Choisissez un pays : sans pays, ce calendrier ne couvre personne.",
  "workspace_settings.calendars.holiday_calendars.people_empty":
    "Personne n'est actuellement couvert par ce calendrier.",
  "workspace_settings.calendars.holiday_calendars.not_found": "Ce calendrier est introuvable.",
  "workspace_settings.calendars.holiday_calendars.discard": "Abandonner",
  "workspace_settings.calendars.holiday_calendars.discard_confirm_title":
    "Abandonner les dates non publiées ?",
  "workspace_settings.calendars.holiday_calendars.discard_confirm_description":
    "Toutes les dates ajoutées depuis la dernière publication de ce calendrier seront supprimées. Les dates déjà publiées sont conservées et la couverture n'est pas affectée.",
  "workspace_settings.calendars.holiday_calendars.discard_success":
    "Dates non publiées abandonnées.",
  "workspace_settings.calendars.holiday_calendars.discard_error":
    "Impossible d'abandonner les dates.",
  "workspace_settings.calendars.holiday_calendars.dates.title": "Dates",
  "workspace_settings.calendars.holiday_calendars.dates.description":
    "Les jours chômés de ce calendrier. Les personnes couvertes sont en congé à chacun d'eux.",
  "workspace_settings.calendars.holiday_calendars.dates.column_date": "Date",
  "workspace_settings.calendars.holiday_calendars.dates.column_name": "Congé",
  "workspace_settings.calendars.holiday_calendars.dates.column_source": "Source",
  "workspace_settings.calendars.holiday_calendars.dates.scope_this_year": "Cette année",
  "workspace_settings.calendars.holiday_calendars.dates.scope_future": "À venir",
  "workspace_settings.calendars.holiday_calendars.dates.scope_all": "Toutes",
  "workspace_settings.calendars.holiday_calendars.dates.search_placeholder":
    "Rechercher des congés",
  "workspace_settings.calendars.holiday_calendars.dates.search_clear": "Effacer la recherche",
  "workspace_settings.calendars.holiday_calendars.dates.add": "Ajouter une date",
  "workspace_settings.calendars.holiday_calendars.dates.add_title":
    "Ajouter une date personnalisée",
  "workspace_settings.calendars.holiday_calendars.dates.add_description":
    "Ajoutez un jour chômé à ce calendrier. Indiquez une date de fin s'il dure plus d'un jour.",
  "workspace_settings.calendars.holiday_calendars.dates.end_date_label": "Date de fin (facultatif)",
  "workspace_settings.calendars.holiday_calendars.dates.end_before_start":
    "La date de fin ne peut pas précéder la date de début.",
  "workspace_settings.calendars.holiday_calendars.dates.edit_dates": "Modifier les dates",
  "workspace_settings.calendars.holiday_calendars.dates.edit_title":
    "Modifier les dates du jour férié",
  "workspace_settings.calendars.holiday_calendars.dates.edit_description":
    "Changez la date du jour férié ou le nombre de jours qu'il couvre.",
  "workspace_settings.calendars.holiday_calendars.dates.edit_submit": "Enregistrer les dates",
  "workspace_settings.calendars.holiday_calendars.dates.edit_success":
    "Dates du jour férié mises à jour",
  "workspace_settings.calendars.holiday_calendars.dates.edit_error":
    "Échec de la mise à jour des dates du jour férié",
  "workspace_settings.calendars.holiday_calendars.dates.add_submit": "Ajouter la date",
  "workspace_settings.calendars.holiday_calendars.dates.name_label": "Congé",
  "workspace_settings.calendars.holiday_calendars.dates.name_placeholder": "Journée d'équipe",
  "workspace_settings.calendars.holiday_calendars.dates.date_label": "Date",
  "workspace_settings.calendars.holiday_calendars.dates.add_success": "Date ajoutée.",
  "workspace_settings.calendars.holiday_calendars.dates.add_error": "Impossible d'ajouter la date.",
  "workspace_settings.calendars.holiday_calendars.dates.load_error":
    "Impossible de charger les dates.",
  "workspace_settings.calendars.holiday_calendars.dates.row_actions_label": "Actions sur la date",
  "workspace_settings.calendars.holiday_calendars.dates.delete": "Supprimer",
  "workspace_settings.calendars.holiday_calendars.dates.delete_confirm_title":
    "Supprimer cette date ?",
  "workspace_settings.calendars.holiday_calendars.dates.delete_confirm_description":
    "« {name} » sera retirée de ce calendrier et cessera de s'appliquer immédiatement.",
  "workspace_settings.calendars.holiday_calendars.dates.delete_error":
    "Impossible de supprimer la date.",
  "workspace_settings.calendars.holiday_calendars.dates.select_all":
    "Sélectionner toutes les dates",
  "workspace_settings.calendars.holiday_calendars.dates.select_one": "Sélectionner {name}",
  "workspace_settings.calendars.holiday_calendars.dates.bulk_delete_confirm_title":
    "{count, plural, one {Supprimer # date ?} other {Supprimer # dates ?}}",
  "workspace_settings.calendars.holiday_calendars.dates.bulk_delete_confirm_description":
    "{count, plural, one {La date sera retirée de ce calendrier. Les personnes concernées récupèrent la journée.} other {# dates seront retirées de ce calendrier. Les personnes concernées récupèrent ces journées.}}",
  "workspace_settings.calendars.holiday_calendars.dates.bulk_delete_success":
    "{count, plural, one {# date supprimée.} other {# dates supprimées.}}",
  "workspace_settings.calendars.holiday_calendars.dates.bulk_delete_error":
    "Impossible de supprimer les dates sélectionnées.",
  "workspace_settings.calendars.holiday_calendars.dates.empty_title": "Aucune date",
  "workspace_settings.calendars.holiday_calendars.dates.empty_description":
    "Ajoutez une date personnalisée pour commencer à remplir ce calendrier.",
  "workspace_settings.calendars.holiday_calendars.dates.import": "Importer un .ics",
  "workspace_settings.calendars.holiday_calendars.dates.import_title":
    "Importer des dates depuis un fichier",
  "workspace_settings.calendars.holiday_calendars.dates.import_description":
    "Téléversez un fichier de calendrier .ics. Ses dates sont ajoutées à ce calendrier comme des dates personnalisées que vous pouvez modifier ou supprimer.",
  "workspace_settings.calendars.holiday_calendars.dates.import_file_label":
    "Fichier de calendrier (.ics)",
  "workspace_settings.calendars.holiday_calendars.dates.import_drop_hint":
    "Glissez un fichier .ics ici, ou choisissez-en un ci-dessous",
  "workspace_settings.calendars.holiday_calendars.dates.import_wrong_type":
    "Ce fichier n'est pas un calendrier .ics.",
  "workspace_settings.calendars.holiday_calendars.dates.import_submit": "Importer les dates",
  "workspace_settings.calendars.holiday_calendars.dates.import_submitting": "Importation…",
  "workspace_settings.calendars.holiday_calendars.dates.import_success":
    "{created} dates importées. Publiez le calendrier pour les appliquer.",
  "workspace_settings.calendars.holiday_calendars.dates.import_success_with_skipped":
    "{created} dates importées, {skipped} déjà présentes dans ce calendrier. Publiez le calendrier pour les appliquer.",
  "workspace_settings.calendars.holiday_calendars.dates.import_error":
    "Impossible d'importer ce fichier.",
  "workspace_settings.calendars.holiday_calendars.dates.rename": "Renommer",
  "workspace_settings.calendars.holiday_calendars.dates.name_edit_hint": "Renommer cette date",
  "workspace_settings.calendars.holiday_calendars.dates.name_required": "Donnez un nom à la date.",
  "workspace_settings.calendars.holiday_calendars.dates.rename_error":
    "Impossible de renommer la date.",
  "workspace_settings.calendars.holiday_calendars.dates.row_actions": "Actions pour {name}",
  "workspace_settings.calendars.holiday_calendars.dates.not_published": "Non publiée",
  "workspace_settings.calendars.holiday_calendars.dates.not_published_hint":
    "Cette date n'affecte la capacité de personne tant que le calendrier n'est pas publié.",
  "workspace_settings.calendars.holiday_calendars.dates.excluded": "Exclue",
  "workspace_settings.calendars.holiday_calendars.dates.exclude": "Exclure",
  "workspace_settings.calendars.holiday_calendars.dates.include": "Inclure de nouveau",
  "workspace_settings.calendars.holiday_calendars.dates.exclude_error":
    "Impossible d'exclure la date.",
  "workspace_settings.calendars.holiday_calendars.dates.include_error":
    "Impossible d'inclure la date de nouveau.",

  "workspace_settings.calendars.holiday_calendars.feed.title": "Flux de calendrier",
  "workspace_settings.calendars.holiday_calendars.feed.description":
    "Abonnez-vous à un calendrier .ics publié et ses dates restent à jour, actualisées chaque jour. Les dates synchronisées s'appliquent sans publication.",
  "workspace_settings.calendars.holiday_calendars.feed.empty":
    "Aucun flux connecté. Les dates de ce calendrier sont celles que vous ajoutez ou importez.",
  "workspace_settings.calendars.holiday_calendars.feed.connect": "Connecter un flux",
  "workspace_settings.calendars.holiday_calendars.feed.connect_title":
    "Connecter un flux de calendrier",
  "workspace_settings.calendars.holiday_calendars.feed.connect_description":
    "Collez l'adresse d'un calendrier .ics publié. Nous le lisons maintenant, puis une fois par jour.",
  "workspace_settings.calendars.holiday_calendars.feed.url_label": "Adresse du flux",
  "workspace_settings.calendars.holiday_calendars.feed.url_help":
    "Un lien https:// ou webcal:// vers un fichier .ics. Un seul flux par calendrier.",
  "workspace_settings.calendars.holiday_calendars.feed.connect_submit": "Connecter",
  "workspace_settings.calendars.holiday_calendars.feed.connecting": "Connexion…",
  "workspace_settings.calendars.holiday_calendars.feed.connect_success":
    "Flux connecté. {count} dates synchronisées.",
  "workspace_settings.calendars.holiday_calendars.feed.connect_error":
    "Impossible de connecter ce flux.",
  "workspace_settings.calendars.holiday_calendars.feed.unnamed": "Flux de calendrier",
  "workspace_settings.calendars.holiday_calendars.feed.dates_count": "{count} dates dans le flux",
  "workspace_settings.calendars.holiday_calendars.feed.sync": "Synchroniser",
  "workspace_settings.calendars.holiday_calendars.feed.syncing": "Synchronisation…",
  "workspace_settings.calendars.holiday_calendars.feed.sync_success":
    "Flux synchronisé : {created} ajoutées, {updated} mises à jour, {removed} supprimées.",
  "workspace_settings.calendars.holiday_calendars.feed.sync_error":
    "Impossible de synchroniser ce flux.",
  "workspace_settings.calendars.holiday_calendars.feed.disconnect": "Déconnecter",
  "workspace_settings.calendars.holiday_calendars.feed.disconnect_confirm_title":
    "Déconnecter ce flux ?",
  "workspace_settings.calendars.holiday_calendars.feed.disconnect_confirm_description":
    "Les dates importées restent sur ce calendrier comme dates manuelles et cessent d'être actualisées. Vous pourrez les supprimer une par une ensuite.",
  "workspace_settings.calendars.holiday_calendars.feed.disconnect_success":
    "Flux déconnecté. {count} dates conservées.",
  "workspace_settings.calendars.holiday_calendars.feed.disconnect_error":
    "Impossible de déconnecter ce flux.",

  "workspace_settings.time_off.title": "Absences",
  "workspace_settings.time_off.select_all": "Sélectionner toutes les absences",
  "workspace_settings.time_off.select_one": "Sélectionner l'absence de {name}",
  "workspace_settings.time_off.description":
    "Gérez les absences qui réduisent la capacité des membres dans les vues de capacité et de planification.",
  "workspace_settings.time_off.add": "Ajouter une absence",
  "workspace_settings.time_off.entries_title": "Entrées",
  "workspace_settings.time_off.entries_description":
    "Les absences manuelles s'appliquent à la capacité disponible du membre sélectionné.",
  "workspace_settings.time_off.filter_member": "Membre",
  "workspace_settings.time_off.filter_all": "Tous les membres",
  "workspace_settings.time_off.empty_title": "Aucune absence",
  "workspace_settings.time_off.empty_description":
    "Ajoutez une absence pour bloquer la capacité d'un membre.",
  "workspace_settings.time_off.add_title": "Ajouter une absence",
  "workspace_settings.time_off.edit_title": "Modifier l'absence",
  "workspace_settings.time_off.dialog_description":
    "Les entrées d'une journée complète bloquent la capacité de travail du membre pour chaque jour sélectionné.",
  "workspace_settings.time_off.member_label": "Membre",
  "workspace_settings.time_off.members_loading": "Chargement des membres…",
  "workspace_settings.time_off.reason_label": "Raison",
  "workspace_settings.time_off.reason_placeholder": "Vacances, rendez-vous, congé",
  "workspace_settings.time_off.dates_edit_aria": "Modifier les dates",
  "workspace_settings.time_off.dates_save": "Enregistrer",
  "workspace_settings.time_off.dates_invalid_range":
    "La date de fin doit être identique ou postérieure à la date de début.",
  "workspace_settings.time_off.start_label": "Date de début",
  "workspace_settings.time_off.end_label": "Date de fin",
  "workspace_settings.time_off.full_day_label": "Journée complète",
  "workspace_settings.time_off.hours_label": "Heures par jour",
  "workspace_settings.time_off.full_day": "Journée complète",
  "workspace_settings.time_off.hours_per_day": "{hours} h/jour",
  "workspace_settings.time_off.saving": "Enregistrement...",
  "workspace_settings.time_off.create_success": "Absence ajoutée",
  "workspace_settings.time_off.create_error": "Échec de l'ajout de l'absence",
  "workspace_settings.time_off.update_success": "Absence mise à jour",
  "workspace_settings.time_off.update_error": "Échec de la mise à jour de l'absence",
  "workspace_settings.time_off.delete": "Supprimer",
  "workspace_settings.time_off.edit": "Modifier",
  "workspace_settings.time_off.delete_confirm_title": "Supprimer l'absence ?",
  "workspace_settings.time_off.delete_confirm_description":
    "Cela supprimera l'absence de {name} et rétablira cette capacité.",
  "workspace_settings.time_off.delete_success": "Absence supprimée",
  "workspace_settings.time_off.delete_error": "Échec de la suppression de l'absence",
  "workspace_settings.time_off.validation_error": "Vérifiez le membre, les dates et les heures.",
  "workspace_settings.time_off.col_dates": "Dates",
  "workspace_settings.time_off.col_duration": "Durée",
  "workspace_settings.time_off.col_actions": "Actions",
  "workspace_settings.time_off.search_placeholder": "Rechercher par membre ou motif…",
  "workspace_settings.time_off.import.action": "Importer des congés",
  "workspace_settings.time_off.import.title": "Importer des congés",
  "workspace_settings.time_off.import.importing": "Importation…",
  "workspace_settings.time_off.import.checking": "Vérification de votre fichier…",
  "workspace_settings.time_off.import.check_failed_title": "Impossible de vérifier votre fichier",
  "workspace_settings.time_off.import.check_failed_body":
    "Une erreur est survenue lors de la vérification de ce fichier. Rien n'a été importé.",
  "workspace_settings.time_off.import.check_retry": "Réessayer",
  "workspace_settings.time_off.import.notice_title": "Ce que cet import va faire",
  "workspace_settings.time_off.import.notice_create":
    "Chaque ligne ajoute un congé pour un membre existant de l'espace de travail, identifié par son courriel.",
  "workspace_settings.time_off.import.notice_skip_past":
    "Les lignes dont les dates sont déjà passées sont ignorées, pas importées.",
  "workspace_settings.time_off.import.notice_duration":
    "Laissez Durée vide (ou « Full day ») pour une journée complète, ou indiquez des heures par jour, par exemple 4,75.",
  "workspace_settings.time_off.import.notice_classic":
    "Vous importez un export Classic « Time off by user » ? Associez sa colonne Day à Date de début et Time off type à Motif, et laissez sa colonne Duration non associée — chaque entrée Classic est une journée complète.",
  "workspace_settings.time_off.import.field_email": "Courriel du membre",
  "workspace_settings.time_off.import.field_start_date": "Date de début",
  "workspace_settings.time_off.import.field_end_date": "Date de fin",
  "workspace_settings.time_off.import.field_duration": "Durée par jour",
  "workspace_settings.time_off.import.field_reason": "Motif",
  "workspace_settings.time_off.import.error_email_required": "Le courriel est requis.",
  "workspace_settings.time_off.import.error_email_invalid":
    "« {email} » n'est pas une adresse courriel valide.",
  "workspace_settings.time_off.import.error_start_date_required": "La date de début est requise.",
  "workspace_settings.time_off.import.row_issue": "Ligne {row} ({email}) : {message}",
  "workspace_settings.time_off.import.row_issue_no_email": "Ligne {row} : {message}",
  "workspace_settings.time_off.import.preview_title": "Avant d'importer",
  "workspace_settings.time_off.import.preview_summary":
    "{created} seront importés, {skipped} seront ignorés, {errors} ne peuvent pas être importés.",
  "workspace_settings.time_off.import.preview_count_created": "{count} à importer",
  "workspace_settings.time_off.import.preview_count_skipped": "{count} à ignorer",
  "workspace_settings.time_off.import.preview_count_errors": "{count} en erreur",
  "workspace_settings.time_off.import.preview_errors_heading":
    "Lignes qui ne peuvent pas être importées",
  "workspace_settings.time_off.import.preview_skipped_heading":
    "Lignes qui seront ignorées (déjà passées)",
  "workspace_settings.time_off.import.result_summary":
    "{created} importés, {skipped} ignorés, {errors} n'ont pas pu être importés.",
  "workspace_settings.time_off.import.count_created": "{count} importés",
  "workspace_settings.time_off.import.count_skipped": "{count} ignorés",
  "workspace_settings.time_off.import.count_errors": "{count} en erreur",
  "workspace_settings.time_off.import.errors_heading": "Lignes qui n'ont pas pu être importées",
  "workspace_settings.time_off.import.skipped_heading": "Lignes ignorées (déjà passées)",
  "workspace_settings.time_off.import.toast_success": "{count} congés importés",
  "workspace_settings.time_off.import.toast_error": "L'importation a échoué. Veuillez réessayer.",

  "workspace_settings.sla.title": "Accords de niveau de service d'admission (SLA)",
  "workspace_settings.sla.description":
    "Définissez des objectifs de délai de décision pour les demandes et suivez leur respect.",
  "workspace_settings.sla.search_placeholder": "Rechercher des SLA…",
  "workspace_settings.sla.create": "Créer un SLA",
  "workspace_settings.sla.col_name": "Nom",
  "workspace_settings.sla.col_conditions": "Conditions",
  "workspace_settings.sla.col_rule": "Règle",
  "workspace_settings.sla.col_target": "Objectif",
  "workspace_settings.sla.col_adherence": "Respect",
  "workspace_settings.sla.col_status": "Statut",
  "workspace_settings.sla.col_actions": "Actions",
  "workspace_settings.sla.catch_all_pill": "Toutes les demandes",
  "workspace_settings.sla.rule_label": "Délai de décision",
  "workspace_settings.sla.target_days": "{count} jours",
  "workspace_settings.sla.status_active": "Actif",
  "workspace_settings.sla.status_inactive": "Inactif",
  "workspace_settings.sla.edit": "Modifier",
  "workspace_settings.sla.delete": "Supprimer",
  "workspace_settings.sla.delete_confirm_title": "Supprimer le SLA",
  "workspace_settings.sla.delete_confirm_description":
    "Supprimer « {name} » ? Cette action est irréversible.",
  "workspace_settings.sla.delete_success": "SLA supprimé",
  "workspace_settings.sla.delete_error": "Échec de la suppression du SLA",
  "workspace_settings.sla.empty_title": "Aucun SLA d'admission pour l'instant",
  "workspace_settings.sla.empty_description":
    "Créez un SLA pour définir des objectifs de délai de décision et suivre leur respect.",
  "workspace_settings.sla.details_title": "Détails du SLA",
  "workspace_settings.sla.new_title": "Nouveau SLA",
  "workspace_settings.sla.breadcrumb_root": "SLA d'admission",
  "workspace_settings.sla.breadcrumb_details": "Détails du SLA",
  "workspace_settings.sla.breadcrumb_new": "Nouveau SLA",
  "workspace_settings.sla.active_label": "Actif",
  "workspace_settings.sla.delete_aria": "Supprimer le SLA",
  "workspace_settings.sla.activate_error": "Échec de la mise à jour du statut du SLA",
  "workspace_settings.sla.history_aria": "Voir l’historique du SLA",
  "workspace_settings.sla.history_title": "Activité",
  "workspace_settings.sla.history_empty": "Aucune activité pour le moment.",
  "workspace_settings.sla.history_error": "Impossible de charger l’activité.",
  "workspace_settings.sla.name_label": "Nom",
  "workspace_settings.sla.name_placeholder": "ex. SLA nouvelle conception",
  "workspace_settings.sla.name_required": "Le nom est requis.",
  "workspace_settings.sla.description_label": "Description",
  "workspace_settings.sla.description_placeholder": "Que mesure ce SLA ?",
  "workspace_settings.sla.condition_heading": "Condition",
  "workspace_settings.sla.condition_all_label": "Appliquer à toutes les demandes",
  "workspace_settings.sla.condition_all_description":
    "Ce SLA est universel et s'applique à toutes les demandes.",
  "workspace_settings.sla.condition_specific_label":
    "Appliquer aux demandes issues de flux de travail spécifiques",
  "workspace_settings.sla.condition_specific_description":
    "Seules les demandes soumises via les flux de travail sélectionnés utiliseront ce SLA.",
  "workspace_settings.sla.condition_group_label": "Condition",
  "workspace_settings.sla.workflows_label": "Flux de travail",
  "workspace_settings.sla.workflows_placeholder": "Sélectionner des flux de travail",
  "workspace_settings.sla.workflows_search_placeholder": "Rechercher des flux de travail…",
  "workspace_settings.sla.workflows_empty": "Aucun flux de travail actif trouvé.",
  "workspace_settings.sla.workflows_loading": "Chargement des flux de travail…",
  "workspace_settings.sla.workflows_required": "Sélectionnez au moins un flux de travail.",
  "workspace_settings.sla.workflows_hint":
    "Seuls les flux de travail actifs peuvent être ajoutés. Un flux de travail déjà associé à ce SLA y reste après sa désactivation, jusqu'à ce que vous le retiriez.",
  "workspace_settings.sla.workflow_deactivated": "{name} (désactivé)",
  "workspace_settings.sla.workflow_claimed":
    "Déjà couvert par « {name} ». Un flux appartient à un seul SLA.",
  "workspace_settings.sla.workflow_not_selectable":
    "Le flux de travail d'où vous venez n'est pas actif ; il ne peut donc pas être ajouté à un SLA. Activez-le d'abord ou choisissez un autre flux de travail.",
  "workspace_settings.sla.condition_team_scoped_hint":
    "Ce SLA s'applique aux demandes provenant des flux de travail sélectionnés ci-dessous. Seuls les flux de travail gérés par cette équipe sont disponibles — un SLA de portée plus large doit être créé dans les paramètres de l'espace de travail.",
  "workspace_settings.sla.expectation_heading": "Attente",
  "workspace_settings.sla.rule_field_label": "Règle",
  "workspace_settings.sla.rule_locked_tooltip":
    "La version 1 prend en charge une seule règle : le délai de décision (date de clôture moins date de soumission).",
  "workspace_settings.sla.rule_coming_soon": "D'autres règles arrivent bientôt.",
  "workspace_settings.sla.pause_heading": "Suspendre le compteur",
  "workspace_settings.sla.pause_section_description":
    "C'est ainsi que vous suspendez le compteur pour que les demandes ne soient pas pénalisées en attendant une partie prenante ou lorsqu'elles sont soumises le week-end.",
  "workspace_settings.sla.pause_label": "Suspendre lorsque le statut est",
  "workspace_settings.sla.pause_placeholder": "Sélectionner des statuts",
  "workspace_settings.sla.pause_search_placeholder": "Rechercher des statuts…",
  "workspace_settings.sla.pause_empty": "Aucun statut trouvé.",
  "workspace_settings.sla.weekends_label": "Week-ends",
  "workspace_settings.sla.target_label": "Objectif",
  "workspace_settings.sla.target_unit_days": "jours",
  "workspace_settings.sla.target_required": "L'objectif doit être d'au moins 1 jour.",
  "workspace_settings.sla.skip_weekends_label": "Ignorer les week-ends",
  "workspace_settings.sla.notifications_heading": "Notifications",
  "workspace_settings.sla.notifications_not_configurable": "Pas encore configurable",
  "workspace_settings.sla.notifications_description":
    "Ce SLA envoie automatiquement un e-mail au propriétaire de la demande selon ce calendrier fixe.",
  "workspace_settings.sla.notifications_3_days": "3 jours avant la date de dépassement",
  "workspace_settings.sla.notifications_1_day": "1 jour avant la date de dépassement",
  "workspace_settings.sla.notifications_on_breach": "À la date de dépassement",
  "workspace_settings.sla.save": "Enregistrer",
  "workspace_settings.sla.saving": "Enregistrement…",
  "workspace_settings.sla.create_success": "SLA créé",
  "workspace_settings.sla.create_error": "Échec de la création du SLA",
  "workspace_settings.sla.update_success": "SLA mis à jour",
  "workspace_settings.sla.update_error": "Échec de la mise à jour du SLA",
  "workspace_settings.sla.not_found": "SLA introuvable.",

  "workspace_settings.audit_log.title": "Journal d'audit",
  "workspace_settings.audit_log.description":
    "Un enregistrement des modifications effectuées dans cet espace de travail — qui a fait quoi, sur quel élément et quand.",
  "workspace_settings.audit_log.column.when": "Quand",
  "workspace_settings.audit_log.select_all": "Sélectionner tous les événements",
  "workspace_settings.audit_log.select_one": "Sélectionner {action}",
  "workspace_settings.audit_log.column.actor": "Auteur",
  "workspace_settings.audit_log.column.action": "Action",
  "workspace_settings.audit_log.column.target": "Cible",
  "workspace_settings.audit_log.column.source": "Source",
  "workspace_settings.audit_log.empty_title": "Aucune activité pour le moment",
  "workspace_settings.audit_log.empty_description":
    "Les modifications dans l'espace de travail apparaîtront ici au fur et à mesure.",
  "workspace_settings.audit_log.export": "Exporter en CSV",
  "workspace_settings.audit_log.export_error":
    "Impossible d'exporter le journal d'audit. Veuillez réessayer.",
  "workspace_settings.audit_log.detail.title": "Détails de l'événement",
  "workspace_settings.audit_log.detail.error": "Impossible de charger cet événement.",
  "workspace_settings.audit_log.detail.changes": "Modifications",
  "workspace_settings.audit_log.detail.no_changes":
    "Cet événement n'a enregistré aucune modification de champ.",
  "workspace_settings.audit_log.detail.no_changes_created":
    "Cet élément a été créé — il n'y a aucune valeur antérieure à comparer.",
  "workspace_settings.audit_log.detail.no_changes_deleted": "Cet élément a été supprimé.",
  "workspace_settings.audit_log.detail.no_changes_archived": "Cet élément a été archivé.",
  "workspace_settings.skills.title": "Qualifications",
  "workspace_settings.skills.description":
    "Définissez les qualifications disponibles dans cet espace afin que les membres puissent se positionner et être affectés en fonction de leurs forces.",
  "workspace_settings.skills.add_action": "Ajouter une qualification",
  "workspace_settings.skills.import.action": "Importer",
  "workspace_settings.skills.import.title": "Importer des qualifications",
  "workspace_settings.skills.import.field_name": "Nom de la qualification",
  "workspace_settings.skills.import.field_name_hint":
    "Le nom de la qualification. Une qualification existante portant le même nom est réutilisée, non dupliquée.",
  "workspace_settings.skills.import.error_name_required":
    "Le nom de la qualification est obligatoire.",
  "workspace_settings.skills.import.field_assignees": "Personnes assignées",
  "workspace_settings.skills.import.field_assignees_hint":
    "E-mails des membres de l'espace de travail à qui attribuer cette qualification, séparés par des virgules ou des points-virgules. Facultatif.",
  "workspace_settings.skills.import.warn_assignee_not_member":
    "{email} n'est pas un membre actif de cet espace de travail et sera ignoré.",
  "workspace_settings.skills.import.warn_duplicate_names":
    "{count, plural, one {# nom de qualification apparaît} other {# noms de qualification apparaissent}} plusieurs fois dans ce fichier ; les doublons réutilisent la même qualification.",
  "workspace_settings.skills.import.importing": "Importation…",
  "workspace_settings.skills.import.result_summary":
    "{created} créées, {reused} réutilisées, {assigned} attribuées.",
  "workspace_settings.skills.import.count_created": "{count} créées",
  "workspace_settings.skills.import.count_reused": "{count} réutilisées",
  "workspace_settings.skills.import.count_errors":
    "{count, plural, one {# erreur} other {# erreurs}}",
  "workspace_settings.skills.import.count_skipped":
    "{count, plural, one {# personne ignorée} other {# personnes ignorées}}",
  "workspace_settings.skills.import.error_row": "Ligne {row} ({name}) : {message}",
  "workspace_settings.skills.import.unnamed_row": "sans nom",
  "workspace_settings.skills.import.skipped_heading":
    "Personnes ignorées (non membres de l'espace de travail)",
  "workspace_settings.skills.import.skipped_row": "Ligne {row} : {email}",
  "workspace_settings.skills.import.toast_success":
    "{count, plural, one {# qualification importée} other {# qualifications importées}}",
  "workspace_settings.skills.import.toast_error": "Échec de l'importation. Veuillez réessayer.",
  // Recommended content at intake (use case #18, NG-676)
  "intake.recommended_content.title": "Contenu existant",
  "intake.recommended_content.expand": "Déplier le contenu existant",
  "intake.recommended_content.collapse": "Replier le contenu existant",
  "intake.recommended_content.may_cover_one": "1 pourrait y répondre",
  "intake.recommended_content.may_cover_many": "{count} pourraient y répondre",
  "intake.recommended_content.subtitle":
    "Issu de votre catalogue {vendor}. Le contenu retenu suit le projet.",
  "intake.recommended_content.subtitle_any_lms":
    "Issu du catalogue de votre LMS. Le contenu retenu suit le projet.",
  "intake.recommended_content.kept_courses_one": "1 cours retenu",
  "intake.recommended_content.kept_courses_many": "{count} cours retenus",
  "intake.recommended_content.kept_paths_one": "1 parcours de formation retenu",
  "intake.recommended_content.kept_paths_many": "{count} parcours de formation retenus",
  "intake.recommended_content.kept_both": "{courses} et {paths}",
  "intake.recommended_content.kept_note_one": "{items} sera joint à la Diffusion du projet",
  "intake.recommended_content.kept_note_many": "{items} seront joints à la Diffusion du projet",
  "intake.recommended_content.empty_title": "Aucun contenu correspondant",
  "intake.recommended_content.empty_description":
    "Aucun élément du catalogue connecté ne partage de mot avec le titre de cette demande.",
  "intake.recommended_content.load_failed": "Impossible de charger les suggestions.",
  "intake.recommended_content.accepted": "Retenu",
  "intake.recommended_content.accept": "Retenir",
  "intake.recommended_content.accept_label": "Retenir {name} pour cette demande",
  "intake.recommended_content.dismiss_label": "Ignorer {name}",
  "intake.recommended_content.requester_notice_title_course":
    "{count, plural, one {Un cours existant couvre peut-être déjà cette demande} other {# cours existants couvrent peut-être déjà cette demande}}",
  "intake.recommended_content.requester_notice_title_path":
    "{count, plural, one {Un parcours d’apprentissage existant couvre peut-être déjà cette demande} other {# parcours d’apprentissage existants couvrent peut-être déjà cette demande}}",
  "intake.recommended_content.requester_notice_title_mixed":
    "{count, plural, one {Un contenu existant couvre peut-être déjà cette demande} other {# contenus existants couvrent peut-être déjà cette demande}}",
  "intake.recommended_content.requester_notice_description":
    "{names}, issus de votre catalogue {vendor}. {count, plural, one {S’il convient} other {Si l’un d’eux convient}}, vous n’aurez peut-être pas besoin d’attendre cette demande.",
  "intake.recommended_content.requester_notice_description_any_lms":
    "{names}, issus du catalogue de votre LMS. {count, plural, one {S’il convient} other {Si l’un d’eux convient}}, vous n’aurez peut-être pas besoin d’attendre cette demande.",
  "intake.recommended_content.requester_notice_more": "+{count} autres",
  "intake.recommended_content.requester_notice_preview": "Aperçu",
  "intake.recommended_content.review_all": "Tout examiner",
  "intake.recommended_content.review_all_title":
    "Contenu existant qui pourrait répondre à cette demande",
  "intake.recommended_content.review_all_description":
    "Retenez ce qui convient pour qu'il suive le projet, ignorez le reste, ou clôturez la demande si le catalogue y répond déjà.",
  "intake.recommended_content.review_all_tally": "Retenus : {kept} · En attente : {open}",
  "intake.recommended_content.shares": "En commun",
  "intake.recommended_content.preview": "Aperçu",
  "intake.recommended_content.resolve_covered": "Marquer comme couvert",
  "intake.recommended_content.resolve_covered_existing":
    "Marquer comme couvert par un contenu existant",
  "intake.recommended_content.resolve_covered_hint":
    "Clôture cette demande en {status}. Aucun projet n'est créé, et vous pouvez revenir en arrière.",
  "intake.recommended_content.resolve_covered_success": "Demande marquée comme {status}",
  "intake.recommended_content.resolve_covered_error":
    "Impossible de marquer la demande. Rien n'a été modifié.",

  "intake.import.action": "Importer des demandes",
  "intake.import.title": "Importer des demandes",
  "intake.import.pick_form_hint":
    "Choisissez le formulaire dans lequel importer les demandes. Ses questions deviennent les colonnes importables.",
  "intake.import.target_form": "Formulaire cible",
  "intake.import.target_form_placeholder": "Sélectionner un formulaire",
  "intake.import.no_active_forms_title": "Aucun formulaire disponible",
  "intake.import.no_active_forms":
    "Aucun formulaire actif dans lequel importer. Publiez d'abord un formulaire.",
  "intake.import.field_request_name": "Nom de la demande",
  "intake.import.example_request_name": "Nouveau portable pour une recrue",
  "intake.import.field_request_name_hint": "Le titre de chaque demande.",
  "intake.import.field_requester": "Demandeur",
  "intake.import.field_requester_hint":
    "E-mail de la personne à l'origine de la demande. Vous par défaut si vide.",
  "intake.import.field_owners": "Responsables",
  "intake.import.field_owners_hint":
    "E-mails des responsables, séparés par des virgules ou des points-virgules.",
  "intake.import.field_status": "Statut",
  "intake.import.field_status_hint":
    "Statut de la demande par nom. Statut par défaut de l'espace de travail si vide.",
  "intake.import.error_required": "{field} est requis.",
  "intake.import.warn_unknown_option": "{field} : « {value} » n'est pas une option connue.",
  "intake.import.warn_ambiguous_option":
    "{field} : « {value} » correspond à plusieurs options ; associez-la à celle que vous visez.",
  "intake.import.conditional_hint":
    "Conditionnel — s'applique uniquement aux lignes qui remplissent sa condition.",
  "intake.import.warn_dropped_conditional":
    "{field} ne sera pas importé pour cette ligne — il ne s'applique pas aux réponses fournies.",
  "intake.import.importing": "Importation…",
  "intake.import.result_summary":
    "{created, plural, one {# demande créée} other {# demandes créées}} sur {total}.",
  "intake.import.count_created": "{count} créées",
  "intake.import.count_errors": "{count, plural, one {# erreur} other {# erreurs}}",
  "intake.import.download_failed": "Télécharger les lignes en échec",
  "intake.import.failed_reason_header": "Erreur d'importation",
  "intake.import.toast_success":
    "{count, plural, one {# demande importée} other {# demandes importées}}",
  "intake.import.toast_error": "Échec de l'importation. Veuillez réessayer.",
  "intake.import.toast_forms_error": "Impossible de charger les formulaires. Veuillez réessayer.",
  "intake.import.toast_definition_error":
    "Impossible de charger les champs de ce formulaire. Veuillez réessayer.",
  "intake.import.loading_form": "Chargement des champs du formulaire…",
  "workspace_settings.skills.search_placeholder": "Rechercher une qualification",
  "workspace_settings.skills.empty_title": "Aucune qualification",
  "workspace_settings.skills.empty_description":
    "Créez la première qualification de l'espace pour que les membres puissent s'identifier.",
  "workspace_settings.skills.list_empty_search":
    "Aucune qualification ne correspond à votre recherche.",
  "workspace_settings.skills.rename": "Renommer",
  "workspace_settings.skills.rename_save": "Enregistrer",
  "workspace_settings.skills.rename_cancel": "Annuler",
  "workspace_settings.skills.delete": "Supprimer",
  "workspace_settings.skills.delete_confirm_title": "Supprimer la qualification",
  "workspace_settings.skills.delete_confirm_description":
    "Supprimer {name} ? Les membres associés à cette qualification la perdront.",
  "workspace_settings.skills.delete_success": "Qualification supprimée",
  "workspace_settings.skills.delete_error": "Échec de la suppression",
  "workspace_settings.skills.create_success": "Qualification créée",
  "workspace_settings.skills.create_error": "Échec de la création",
  "workspace_settings.skills.update_success": "Qualification mise à jour",
  "workspace_settings.skills.update_error": "Échec du renommage",
  "workspace_settings.skills.load_error": "Échec du chargement des qualifications",
  "workspace_settings.skills.modal_title": "Ajouter une qualification",
  "workspace_settings.skills.modal_description":
    "Les administrateurs gèrent la liste. Les membres la consultent depuis leur profil.",
  "workspace_settings.skills.modal_name_label": "Nom de la qualification",
  "workspace_settings.skills.name_edit_hint": "Cliquer pour modifier",
  "workspace_settings.skills.modal_name_placeholder": "ex. Conception pédagogique",
  "workspace_settings.skills.modal_submit": "Ajouter",
  "workspace_settings.skills.modal_submitting": "Enregistrement...",
  "workspace_settings.skills.archive": "Désactiver",
  "workspace_settings.skills.unarchive": "Activer",
  "workspace_settings.skills.archive_success": "Qualification désactivée",
  "workspace_settings.skills.archive_error": "Échec de la désactivation",
  "workspace_settings.skills.unarchive_success": "Qualification activée",
  "workspace_settings.skills.unarchive_error": "Échec de l'activation",
  "workspace_settings.skills.deactivate_success": "Qualification désactivée",
  "workspace_settings.skills.activate_success": "Qualification activée",
  "workspace_settings.skills.active_toggle_aria": "Activer ou désactiver {name}",
  "workspace_settings.skills.actions_menu_aria": "Actions pour {name}",
  "workspace_settings.skills.select_all": "Sélectionner toutes les qualifications",
  "workspace_settings.skills.select_one": "Sélectionner {name}",
  "workspace_settings.skills.column.name": "Qualification",
  "workspace_settings.skills.column.users": "Membres",
  "workspace_settings.skills.column.status": "Statut",
  "workspace_settings.skills.column.actions": "Actions",
  "workspace_settings.skills.status.active": "Active",
  "workspace_settings.skills.status.deactivated": "Désactivée",
  "workspace_settings.skills.filter.active": "Actives",
  "workspace_settings.skills.filter.deactivated": "Désactivées",
  "workspace_settings.skills.users_empty": "Aucun membre",
  "workspace_settings.skills.users_count": "{count, plural, one {# membre} other {# membres}}",
  "workspace_settings.skills.users_search_placeholder": "Rechercher un membre",
  "workspace_settings.skills.users_loading": "Chargement des membres…",
  "workspace_settings.skills.users_list_empty": "Aucun membre trouvé",
  "workspace_settings.skills.assign_users_title": "Attribuer des membres à {name}",
  "workspace_settings.skills.assign_users_success": "Membres de la qualification mis à jour",
  "workspace_settings.skills.assign_users_error": "Échec de la mise à jour des membres",
  "workspace_settings.skills.range_summary": "Affichage de {from}–{to} sur {total}",
  "workspace_settings.skills.pagination.prev": "Page précédente",
  "workspace_settings.skills.pagination.next": "Page suivante",

  // Profile
  "profile.skills.title": "Mes qualifications",
  "profile.digital_teammates.title": "Coéquipiers numériques",
  "profile.digital_teammates.description":
    "Les coéquipiers numériques agissent en votre nom. Activez-en un pour qu'il travaille pour vous, et désactivez-le pour l'arrêter.",
  "profile.digital_teammates.load_error": "Impossible de charger vos coéquipiers numériques.",
  "profile.digital_teammates.empty_title": "Aucun coéquipier numérique",
  "profile.digital_teammates.empty_description":
    "Aucun coéquipier numérique ne vous est proposé dans cet espace de travail.",
  "profile.digital_teammates.ai_off":
    "Les fonctionnalités d'IA sont désactivées pour cet espace de travail.",
  "profile.digital_teammates.no_workspace":
    "Ouvrez un espace de travail pour voir ses coéquipiers numériques.",
  "profile.digital_teammates.state.active": "Activé",
  "profile.digital_teammates.state.not_activated": "Pas encore activé",
  "profile.digital_teammates.state.paused": "Désactivé",
  "profile.digital_teammates.state.needs_consent": "Votre consentement est requis",
  "profile.digital_teammates.state.waiting_for_admin": "En attente d'un administrateur",
  "profile.digital_teammates.turn_on": "Activer",
  "profile.digital_teammates.turn_off": "Désactiver",
  "profile.digital_teammates.waiting_note":
    "Un administrateur doit d'abord approuver la dernière version.",
  "profile.digital_teammates.consent.title": "Activer {name} ?",
  "profile.digital_teammates.consent.body": "{name} agira en votre nom. {summary}",
  "profile.digital_teammates.version_changed":
    "{name} a changé pendant que cette page était ouverte. Vérifiez-le et réessayez.",
  "profile.digital_teammates.save_error": "Impossible de mettre à jour {name}. Réessayez.",
  "profile.skills.description":
    "Sélectionnez les qualifications que vous apportez à cet espace. Les administrateurs les consultent sur la page de disponibilité de l'équipe.",
  "profile.skills.no_workspace": "Sélectionnez un espace de travail pour gérer vos qualifications.",
  "profile.skills.empty": "Aucune qualification n'a encore été définie dans cet espace.",
  "profile.skills.placeholder": "Sélectionner des qualifications...",
  "profile.skills.search_placeholder": "Rechercher des qualifications...",
  "profile.skills.empty_search": "Aucune qualification trouvée",
  "profile.skills.save_success": "Qualifications mises à jour",
  "profile.skills.save_error": "Échec de l'enregistrement",
  "profile.skills.load_error": "Échec du chargement de vos qualifications",
  "profile.skills.permission_denied":
    "Vous n'avez pas la permission de modifier vos qualifications dans cet espace.",

  // Profil — onglets
  "profile_settings.tabs.general": "Profil",
  "profile_settings.tabs.preferences": "Préférences",
  "profile_settings.tabs.notifications": "Notifications",
  "profile_settings.tabs.security": "Sécurité",
  "profile_settings.tabs.work_hours": "Heures de travail",
  "profile_settings.tabs.skills": "Qualifications",
  "profile_settings.tabs.connected_apps": "Applications connectées",
  "profile_settings.tabs.digital_teammates": "Coéquipiers numériques",

  // Login footer, connected apps and instance OAuth apps (NG-2585)
  "login_footer.contact_support": "Contacter le support",
  "login_footer.privacy": "Confidentialité",
  "login_footer.terms": "Conditions",
  "profile_settings.connected_apps.loading": "Chargement…",
  "profile_settings.connected_apps.empty":
    "Vous n'avez encore connecté aucune application. Lorsque vous vous connecterez à une application tierce avec votre compte Cognota, elle apparaîtra ici.",
  "profile_settings.connected_apps.intro":
    "Ces applications peuvent agir en votre nom dans les espaces de travail ci-dessous. Révoquez celles auxquelles vous ne faites plus confiance.",
  "profile_settings.connected_apps.expired_title":
    "Cette connexion ne peut plus être actualisée. Reconnectez-vous depuis l'application pour continuer à l'utiliser.",
  "profile_settings.connected_apps.expired": "Expirée",
  "profile_settings.connected_apps.granted": "Accordée le",
  "profile_settings.connected_apps.last_used": "dernière utilisation",
  "profile_settings.connected_apps.revoke": "Révoquer l'accès",
  "profile_settings.connected_apps.load_error": "Impossible de charger vos applications.",
  "profile_settings.connected_apps.revoke_error": "Impossible de révoquer l'accès.",
  "instance_admin.oauth_apps.loading": "Chargement…",
  "instance_admin.oauth_apps.title": "Applications connectées",
  "instance_admin.oauth_apps.forbidden":
    "Vous n'avez pas l'autorisation de gérer les applications connectées de l'instance.",
  "instance_admin.oauth_apps.page_title": "Applications connectées (instance)",
  "instance_admin.oauth_apps.page_description":
    "Applications vérifiées par Cognota, disponibles pour chaque espace de travail de cette instance (le serveur MCP de Cognota, les intégrations partenaires, etc.).",
  "instance_admin.oauth_apps.new_app": "Nouvelle application",
  "instance_admin.oauth_apps.register_title": "Enregistrer une application OAuth d'instance",
  "instance_admin.oauth_apps.delete_confirm":
    "Supprimer {name} ? Les jetons existants échoueront à l'introspection.",
  "instance_admin.oauth_apps.load_error": "Impossible de charger les applications.",

  "profile_settings.title": "Paramètres du profil",

  // Profil — général
  "profile_settings.general.title": "Général",
  "profile_settings.general.description":
    "Mettez à jour votre nom, votre fuseau horaire et vos images de profil.",
  "profile_settings.general.first_name_label": "Prénom",
  "profile_settings.general.last_name_label": "Nom",
  "profile_settings.general.display_name_label": "Nom affiché",
  "profile_settings.general.display_name_hint":
    "Nom visible par les autres membres dans l'application.",
  "profile_settings.general.mobile_label": "Numéro de téléphone",
  "profile_settings.general.mobile_placeholder": "+33 6 12 34 56 78",
  "profile_settings.general.email_label": "E-mail",
  "profile_settings.general.email_change": "Modifier l'e-mail",
  "profile_settings.general.save": "Enregistrer",
  "profile_settings.general.saving": "Enregistrement...",
  "profile_settings.general.save_success": "Profil mis à jour",
  "profile_settings.general.save_error": "Impossible de mettre à jour le profil",
  "profile_settings.general.avatar_label": "Photo de profil",
  "profile_settings.general.avatar_hint": "Une photo aide vos coéquipiers à vous reconnaître.",
  "profile_settings.general.avatar_alt": "Avatar de {name}",
  "profile_settings.general.avatar_upload": "Ajouter",
  "profile_settings.general.avatar_change": "Changer",
  "profile_settings.general.avatar_remove": "Retirer",
  "profile_settings.general.avatar_uploading": "Téléversement...",
  "profile_settings.general.avatar_removing": "Suppression...",
  "profile_settings.general.avatar_upload_success": "Avatar mis à jour",
  "profile_settings.general.avatar_upload_error": "Échec du téléversement",
  "profile_settings.general.avatar_remove_success": "Avatar retiré",
  "profile_settings.general.avatar_remove_error": "Impossible de retirer l'avatar",
  "profile_settings.general.avatar_invalid_type":
    "Seules les images JPEG, PNG, WEBP ou GIF sont acceptées",

  // Modification d'e-mail
  "profile_settings.email_change.title": "Modifier l'e-mail",
  "profile_settings.email_change.step1_title": "Saisissez votre nouvelle adresse",
  "profile_settings.email_change.step1_description":
    "Nous vous enverrons un code de vérification pour confirmer.",
  "profile_settings.email_change.step2_title": "Saisissez le code de vérification",
  "profile_settings.email_change.step2_description":
    "Nous avons envoyé un code à 6 chiffres à {email}. Collez-le pour confirmer.",
  "profile_settings.email_change.new_email_label": "Nouvel e-mail",
  "profile_settings.email_change.code_label": "Code de vérification",
  "profile_settings.email_change.send_code": "Envoyer le code",
  "profile_settings.email_change.sending": "Envoi...",
  "profile_settings.email_change.verify": "Modifier l'e-mail",
  "profile_settings.email_change.verifying": "Vérification...",
  "profile_settings.email_change.code_sent": "Code envoyé — vérifiez votre boîte",
  "profile_settings.email_change.success": "E-mail mis à jour",
  "profile_settings.email_change.send_error": "Échec de l'envoi du code",
  "profile_settings.email_change.email_taken": "Cette adresse e-mail est déjà utilisée.",
  "profile_settings.email_change.attempts_exceeded":
    "Trop de codes erronés. Demandez un nouveau code.",
  "profile_settings.email_change.code_expired": "Ce code a expiré. Demandez un nouveau code.",
  "profile_settings.email_change.verify_error": "Code invalide ou expiré",
  "profile_settings.email_change.invalid_email": "Veuillez saisir une adresse e-mail valide",

  // Profile settings — préférences
  "profile_settings.preferences.title": "Préférences",
  "profile_settings.preferences.description": "Choisissez votre thème et votre langue.",
  "profile_settings.preferences.description_job_role":
    "Choisissez votre thème, votre langue et votre rôle métier.",
  "profile_settings.preferences.description_start_of_week":
    "Choisissez votre thème, votre langue et le début de la semaine.",
  "profile_settings.preferences.description_start_of_week_job_role":
    "Choisissez votre thème, votre langue, le début de la semaine et votre rôle métier.",
  "profile_settings.preferences.theme_label": "Thème",
  "profile_settings.preferences.theme_hint": "Système suit le réglage de votre appareil.",
  "profile_settings.preferences.theme_light": "Clair",
  "profile_settings.preferences.theme_dark": "Sombre",
  "profile_settings.preferences.theme_system": "Système",
  "profile_settings.preferences.language_label": "Langue",
  "profile_settings.preferences.start_of_week_label": "Début de la semaine",
  "profile_settings.preferences.start_of_week_sunday": "Dimanche",
  "profile_settings.preferences.start_of_week_monday": "Lundi",
  "profile_settings.preferences.save_success": "Préférences mises à jour",
  "profile_settings.preferences.save_error": "Impossible d'enregistrer les préférences",

  // Profile settings — notifications
  "profile_settings.notifications.title": "Notifications",
  "profile_settings.notifications.description":
    "Choisissez les événements qui déclenchent une notification dans l'application.",
  "profile_settings.notifications.property_change": "Modifications de propriétés",
  "profile_settings.notifications.property_change_hint":
    "Quand quelqu'un modifie une propriété d'un ticket que vous suivez.",
  "profile_settings.notifications.status_change": "Changements de statut",
  "profile_settings.notifications.status_change_hint":
    "Quand un ticket que vous suivez passe à un nouveau statut.",
  "profile_settings.notifications.comment": "Commentaires",
  "profile_settings.notifications.comment_hint":
    "Quand quelqu'un ajoute un commentaire sur un ticket que vous suivez.",
  "profile_settings.notifications.mention": "Mentions",
  "profile_settings.notifications.mention_hint":
    "Quand quelqu'un vous mentionne avec @ dans l'espace de travail.",
  "profile_settings.notifications.field_change": "Modifications de champ",
  "profile_settings.notifications.field_change_hint":
    "Quand des champs d'une demande, d'un projet ou d'une tâche qui vous concerne changent.",
  "profile_settings.notifications.deletion": "Suppressions",
  "profile_settings.notifications.deletion_hint":
    "Quand une demande, un projet ou une tâche qui vous concerne est supprimé.",
  "profile_settings.notifications.assignment": "Affectations",
  "profile_settings.notifications.assignment_hint":
    "Quand une nouvelle demande ou tâche est créée et vous est affectée.",
  "profile_settings.notifications.collaboration": "Collaboration",
  "profile_settings.notifications.collaboration_hint":
    "Affectations d'équipe et approbations qui requièrent votre attention.",
  "profile_settings.notifications.account": "Compte et équipe",
  "profile_settings.notifications.account_hint":
    "Quand votre rôle change, ou que vous êtes ajouté à un espace de travail ou une équipe.",
  "profile_settings.notifications.sla": "Alertes de SLA",
  "profile_settings.notifications.sla_hint":
    "Quand un SLA sur une demande que vous possédez approche de son échéance ou a été dépassé.",
  "profile_settings.notifications.time_off_conflict": "Conflits de congés",
  "profile_settings.notifications.time_off_conflict_hint":
    "Quand de nouveaux congés mettent en conflit du travail déjà planifié dans un projet que vous dirigez.",
  "profile_settings.notifications.shared_dashboard": "Tableaux de bord partagés",
  "profile_settings.notifications.shared_dashboard_hint":
    "Quand quelqu'un partage un tableau de bord avec vous, ou modifie votre accès à celui-ci.",
  // Teams-only (NG-1641) : diffusé comme carte Teams et rien d'autre, donc sa ligne
  // n'a pas de bascule dans l'app et n'apparaît pas sans lien Teams.
  "profile_settings.notifications.weekly_summary": "Résumé du lundi",
  "profile_settings.notifications.weekly_summary_hint":
    "Un message Teams le lundi matin listant votre travail en retard et à venir.",
  "profile_settings.notifications.section_updates": "Mises à jour",
  "profile_settings.notifications.section_collaboration": "Collaboration",
  "profile_settings.notifications.section_proactive": "Proactif",
  "profile_settings.notifications.section_account": "Compte",
  "profile_settings.notifications.section_other": "Autre",
  // Nommé d'après le canal plutôt que « Autre », qui signifie « un code dont ce
  // formulaire n'a pas la copie » — l'inverse d'une catégorie réservée à Teams.
  "profile_settings.notifications.section_teams_only": "Microsoft Teams uniquement",
  "profile_settings.notifications.load_error":
    "Impossible de charger les préférences de notification",
  "profile_settings.notifications.save_error":
    "Impossible d'enregistrer les pr\u00e9f\u00e9rences de notification",

  // Les deux colonnes de bascules (NG-1187). Affichées uniquement pour une
  // personne dont le compte Microsoft est lié : sinon il n'y a qu'une bascule par
  // ligne et nommer sa colonne répondrait à une question que personne ne se pose.
  "profile_settings.notifications.column_inapp": "Dans l'app et e-mail",
  "profile_settings.notifications.column_teams": "Teams",
  // Le nom accessible de la bascule Teams. Il ne doit pas simplement contenir le
  // nom de la catégorie, sinon chaque `getByRole("switch", { name: /comments/i })`
  // correspond à deux éléments — une ambiguïté pour un lecteur d'écran autant
  // que pour un test (NG-847).
  "profile_settings.notifications.teams_switch_aria": "{label} dans Teams",

  // « Envoyer mon résumé du lundi maintenant » (NG-1641) — une commodité de démo
  // demandée par le produit, sur la ligne réservée à Teams uniquement. Le libellé
  // est aussi le nom accessible du bouton : il doit donc être une phrase entière et
  // non « Envoyer », car il voisine une bascule nommée « Résumé du lundi dans
  // Teams ».
  "profile_settings.notifications.send_summary_now": "Envoyer mon résumé du lundi maintenant",
  // Les totaux sont l'essentiel : « Envoyé » seul ne dit pas si la carte vaut la
  // peine d'être ouverte.
  "profile_settings.notifications.send_summary_sent":
    "Envoyé dans Teams — {overdue} en retard, {upcoming} pour cette semaine",
  // Un 200, pas un échec : rien n'était dû, donc rien à envoyer.
  "profile_settings.notifications.send_summary_nothing_due":
    "Rien à signaler — aucun résumé à envoyer",
  // Le message de repli pour une raison que nous ne pouvons pas nommer : une panne
  // réseau, un 500, ou un code que cette version ne connaît pas.
  "profile_settings.notifications.send_summary_error":
    "Impossible d'envoyer votre résumé du lundi. Réessayez.",
  // Une phrase par code de refus, chacune nommant ce qu'il faut aller faire.
  "profile_settings.notifications.send_summary_refused.no_workspace":
    "Ouvrez d'abord un espace de travail — un résumé porte sur un seul espace.",
  "profile_settings.notifications.send_summary_refused.not_member":
    "Vous n'êtes plus membre de cet espace de travail.",
  "profile_settings.notifications.send_summary_refused.no_connection":
    "Microsoft Teams n'est pas configuré dans cet espace de travail.",
  "profile_settings.notifications.send_summary_refused.paused":
    "Un administrateur a suspendu les notifications Teams dans cet espace de travail.",
  "profile_settings.notifications.send_summary_refused.no_link":
    "Connectez d'abord votre compte Microsoft.",
  "profile_settings.notifications.send_summary_refused.not_installed":
    "Ajoutez d'abord l'application Cognota dans Microsoft Teams.",
  "profile_settings.notifications.send_summary_refused.not_receiving":
    "Un problème avec votre lien Teams — veuillez contacter l'assistance.",
  "profile_settings.notifications.send_summary_refused.deactivated":
    "Votre compte Cognota est désactivé. Demandez à un administrateur de le réactiver.",
  "profile_settings.notifications.send_summary_refused.switch_off":
    "Activez d'abord la bascule du résumé du lundi.",
  "profile_settings.notifications.send_summary_refused.already_sent":
    "Celui-ci a déjà été envoyé — réessayez.",
  "profile_settings.notifications.send_summary_refused.too_many_manual_sends":
    "Il ne reste aucun jour libre pour envoyer un résumé. Réessayez dans quelques jours.",

  // Microsoft Teams comme canal de diffusion de VOS notifications (plan §5a
  // FR5-FR7, NG-1134, épique NG-886). Placé avec les préférences de notification
  // plutôt que sous Applications connectées : cela décide OÙ vont vos
  // notifications, pas ce qu'un tiers peut faire en votre nom.
  // COPIE PROVISOIRE : les questions ouvertes OQ2 et OQ6 du produit ne sont pas
  // tranchées, donc chaque chaîne ci-dessous vise la clarté plutôt que la
  // version finale \u2014 une passe de révision est à prévoir.
  "profile_settings.msteams.title": "Microsoft Teams",
  "profile_settings.msteams.description":
    "Recevez aussi les notifications activées ci-dessous sous forme de messages Teams, en plus des e-mails et de Cognota.",
  "profile_settings.msteams.state_receiving": "Activé",
  // Distinct de `state_receiving` et de `state_not_connected` : le compte Microsoft
  // est lié mais l'application Teams n'est pas installée, donc rien n'arrive encore.
  "profile_settings.msteams.state_connected": "Connecté",
  "profile_settings.msteams.state_not_connected": "Non connecté",
  "profile_settings.msteams.state_not_set_up": "Non configuré",
  "profile_settings.msteams.workspace_not_set_up":
    "Les notifications Teams ne sont pas configurées dans cet espace de travail ; rien n'est envoyé d'ici.",
  "profile_settings.msteams.workspace_paused":
    "Votre espace de travail a suspendu les notifications Teams : rien n'est envoyé d'ici pour le moment.",
  "profile_settings.msteams.reason_none":
    "Connectez votre compte Microsoft pour recevoir ces notifications dans Teams.",
  "profile_settings.msteams.reason_not_installed":
    "Votre compte Microsoft est connecté. Ajoutez l'application Cognota dans Teams pour commencer à recevoir les messages.",
  "profile_settings.msteams.reason_unmatched":
    "Quelqu'un a ajouté l'application Cognota dans Teams, mais nous ne pouvons pas confirmer qu'il s'agit de vous. Connectez votre compte Microsoft pour la revendiquer.",
  "profile_settings.msteams.reason_unlinked":
    "Vous avez désactivé les notifications Teams. Reconnectez-vous quand vous le souhaitez.",
  "profile_settings.msteams.reason_uninstalled":
    "L'application Cognota a été retirée de votre Teams. Ajoutez-la de nouveau pour recevoir les messages.",
  "profile_settings.msteams.reason_blocked":
    "Microsoft Teams refuse les messages vers votre conversation. Retirer puis réinstaller l'application Cognota résout généralement le problème.",
  "profile_settings.msteams.other_workspaces":
    "{count, plural, one {Également connecté dans # autre espace de travail} other {Également connecté dans # autres espaces de travail}}",
  "profile_settings.msteams.connect_action": "Connecter le compte Microsoft",
  "profile_settings.msteams.connect_scope_hint":
    "Une seule connexion couvre tous vos espaces de travail.",
  "profile_settings.msteams.connect_pending": "Ouverture de la connexion Microsoft...",
  "profile_settings.msteams.connect_error":
    "Impossible de démarrer la connexion Microsoft. Aucune modification n'a été effectuée.",
  "profile_settings.msteams.connect_not_configured":
    "La connexion Microsoft Teams n'est pas encore configurée pour cet environnement. Aucune modification n'a été effectuée \u2014 veuillez contacter le support.",
  // Étapes plutôt qu'un lien profond (NG-1186) : `teams.microsoft.com/l/app/<id>` ne
  // fonctionne que pour une application chargée en local, et l'identifiant du catalogue
  // d'un client ne nous est pas accessible.
  "profile_settings.msteams.install_steps":
    "Pour l'ajouter : dans Teams, ouvrez Applications > Conçues pour votre organisation > Cognota, puis choisissez Ajouter.",
  "profile_settings.msteams.disconnect_action": "Désactiver les notifications Teams",
  "profile_settings.msteams.disconnect_pending": "Désactivation...",
  "profile_settings.msteams.disconnect_confirm_title": "Désactiver les notifications Teams ?",
  "profile_settings.msteams.disconnect_confirm_description":
    "Cognota cesse de vous envoyer des messages Teams dans tous les espaces de travail, et tout message en attente est abandonné. Vos notifications par e-mail et dans l'application ne sont pas affectées, et vous pouvez vous reconnecter à tout moment.",
  "profile_settings.msteams.disconnect_success":
    "Les notifications Teams sont désactivées. Les notifications par e-mail et dans l'application ne sont pas affectées.",
  "profile_settings.msteams.disconnect_error":
    "Impossible de désactiver les notifications Teams. Aucune modification n'a été effectuée.",
  "profile_settings.msteams.redirect_connected":
    "Compte Microsoft connecté. Ajoutez l'application Cognota dans Teams si ce n'est pas déjà fait.",
  "profile_settings.msteams.redirect_error_invalid_state":
    "Ce lien de connexion Microsoft n'est plus valide. Aucune modification n'a été effectuée \u2014 veuillez réessayer.",
  "profile_settings.msteams.redirect_error_denied":
    "La connexion Microsoft a été annulée. Aucune modification n'a été effectuée.",
  "profile_settings.msteams.redirect_error_no_code":
    "Microsoft n'a pas terminé la connexion. Aucune modification n'a été effectuée \u2014 veuillez réessayer.",
  "profile_settings.msteams.redirect_error_forbidden":
    "Vous n'avez plus accès à cet espace de travail. Aucune modification n'a été effectuée.",
  "profile_settings.msteams.redirect_error_exchange_failed":
    "Cognota n'a pas pu finaliser la connexion avec Microsoft. Aucune modification n'a été effectuée \u2014 veuillez réessayer.",
  "profile_settings.msteams.redirect_error_already_enabled":
    "Ce compte Microsoft est déjà connecté.",
  "profile_settings.msteams.redirect_error_not_yet":
    "Cette connexion Microsoft n'est pas encore disponible. Aucune modification n'a été effectuée.",
  "profile_settings.msteams.redirect_error_no_enabled_workspace":
    "Ce compte Microsoft n'est associé à aucun de vos espaces de travail Cognota. Connectez-vous avec le compte Microsoft utilisé par votre espace de travail ; rien d'autre n'a besoin de changer.",
  "profile_settings.msteams.redirect_error_unknown":
    "La connexion de votre compte Microsoft a \u00e9chou\u00e9. Aucune modification n'a \u00e9t\u00e9 effectu\u00e9e.",

  // Rappel pour les membres non li\u00e9s (OQ2, NG-1134). Ni une cha\u00eene des
  // param\u00e8tres d'espace de travail ni du profil : elle s'affiche dans la cloche
  // de notifications, l\u00e0 o\u00f9 regarde une personne qui ignore l'existence du
  // canal Teams.
  "msteams.nudge.body_one":
    "Les notifications Microsoft Teams sont activ\u00e9es pour {workspace}. Connectez votre compte Microsoft pour les recevoir l\u00e0-bas.",
  "msteams.nudge.body_many":
    "Les notifications Microsoft Teams sont activ\u00e9es pour {workspace} et {count, plural, one {# autre espace de travail} other {# autres espaces de travail}}. Connectez votre compte Microsoft pour les recevoir l\u00e0-bas.",
  "msteams.nudge.action": "Connecter",
  "msteams.nudge.pending": "Ouverture de la connexion Microsoft...",
  "msteams.nudge.dismiss": "Masquer le rappel Microsoft Teams",

  // Profile settings — sécurité
  "profile_settings.security.title": "Sécurité",
  "profile_settings.security.description": "Modifiez le mot de passe de votre compte.",
  "profile_settings.security.current_password_label": "Mot de passe actuel",
  "profile_settings.security.new_password_label": "Nouveau mot de passe",
  "profile_settings.security.confirm_password_label": "Confirmer le nouveau mot de passe",
  "profile_settings.security.save": "Mettre à jour le mot de passe",
  "profile_settings.security.saving": "Mise à jour...",
  "profile_settings.security.save_success": "Mot de passe mis à jour",
  "profile_settings.security.save_error": "Impossible de mettre à jour le mot de passe",
  "profile_settings.security.autoset_hint":
    "Votre compte utilise les liens magiques — définissez un mot de passe ci-dessous pour vous connecter aussi avec.",
  "profile_settings.security.current_required": "Saisissez votre mot de passe actuel",
  "profile_settings.security.weak_password":
    "Choisissez un mot de passe plus fort (mélange de majuscules, minuscules, chiffres et symboles).",
  "profile_settings.security.strength_label": "Force du mot de passe",
  "profile_settings.security.strength_0": "Trop court",
  "profile_settings.security.strength_1": "Faible",
  "profile_settings.security.strength_2": "Correct",
  "profile_settings.security.strength_3": "Bon",
  "profile_settings.security.strength_4": "Fort",

  // Profile settings — Work hours
  "profile_settings.work_hours.title": "Horaires de travail",
  "profile_settings.work_hours.description":
    "Configurez vos horaires de travail et votre calendrier pour aider le planificateur à organiser votre disponibilité.",
  "profile_settings.work_hours.capacity_section_label": "Capacité",
  "profile_settings.work_hours.capacity_label": "Capacité globale",
  "profile_settings.work_hours.daily_hours_label": "Heures quotidiennes",
  "profile_settings.work_hours.work_schedule_label": "Horaire de travail",
  "profile_settings.work_hours.day_monday": "Lundi",
  "profile_settings.work_hours.day_tuesday": "Mardi",
  "profile_settings.work_hours.day_wednesday": "Mercredi",
  "profile_settings.work_hours.day_thursday": "Jeudi",
  "profile_settings.work_hours.day_friday": "Vendredi",
  "profile_settings.work_hours.day_saturday": "Samedi",
  "profile_settings.work_hours.day_sunday": "Dimanche",
  "profile_settings.work_hours.start_time_label": "Heure de début",
  "profile_settings.work_hours.end_time_label": "Heure de fin",
  "profile_settings.work_hours.timezone_label": "Fuseau horaire",
  "profile_settings.work_hours.invalid_hours": "Entrez une valeur entre 0 et 24",
  "profile_settings.work_hours.invalid_capacity": "Entrez une valeur entre 0 et 100",
  "profile_settings.work_hours.end_before_start": "L'heure de fin doit être après l'heure de début",
  "profile_settings.work_hours.load_error": "Impossible de charger les horaires de travail",
  "profile_settings.work_hours.save_error": "Impossible d'enregistrer les horaires de travail",

  // Workspace settings — Templates
  "workspace_settings.templates.list_title": "Modèles de projet",
  "workspace_settings.templates.list_description":
    "Créez des modèles de projet réutilisables pour démarrer rapidement avec une structure commune.",
  "workspace_settings.templates.new": "Créer un modèle",
  "workspace_settings.templates.column.name": "Titre",
  "workspace_settings.templates.column.privacy": "Confidentialité",
  "workspace_settings.templates.column.created": "Créé le",
  "workspace_settings.templates.column.updated": "Dernière modification",
  "workspace_settings.templates.search_placeholder": "Rechercher des modèles…",
  "workspace_settings.templates.name_edit_hint": "Cliquer pour modifier",
  "workspace_settings.templates.update_name_error": "Impossible de mettre à jour le nom du modèle",
  "workspace_settings.templates.update_privacy_error":
    "Impossible de mettre à jour la confidentialité du modèle",
  "workspace_settings.templates.edit_aria": "Modifier le modèle",
  "workspace_settings.templates.delete_aria": "Supprimer le modèle",
  "workspace_settings.templates.actions_menu_aria": "Actions pour {name}",
  "workspace_settings.templates.select_all": "Sélectionner tous les modèles",
  "workspace_settings.templates.select_one": "Sélectionner {name}",
  "workspace_settings.templates.bulk_delete.title": "Supprimer {count} modèles ?",
  "workspace_settings.templates.bulk_delete.description":
    "Cela supprime définitivement les {count} modèles sélectionnés. Cette action est irréversible.",
  "workspace_settings.templates.bulk_delete.success": "{count} modèles supprimés",
  "workspace_settings.templates.empty_state":
    "Aucun modèle pour l'instant. Créez-en un pour commencer.",
  "workspace_settings.templates.list_error": "Impossible de charger les modèles",
  "workspace_settings.templates.menu.edit": "Modifier",
  "workspace_settings.templates.menu.delete": "Supprimer",
  "workspace_settings.templates.delete.title": "Supprimer le modèle",
  "workspace_settings.templates.delete.message":
    "Êtes-vous sûr de vouloir supprimer {name} ? Cette action est irréversible.",
  "workspace_settings.templates.delete.confirm": "Supprimer",
  "workspace_settings.templates.delete.success": "Modèle supprimé",
  "workspace_settings.templates.delete.error": "Impossible de supprimer le modèle",
  "workspace_settings.templates.view_only_badge": "Lecture seule",
  "workspace_settings.templates.view_only_banner.title": "Ce modèle est en lecture seule",
  "workspace_settings.templates.view_only_banner.description":
    "Il est partagé avec votre équipe sans lui appartenir : seules les équipes auxquelles il est rattaché peuvent le modifier.",
  "workspace_settings.templates.duplicate.action": "Dupliquer",
  "workspace_settings.templates.duplicate.success": "{name} créé",
  "workspace_settings.templates.duplicate.error": "Impossible de dupliquer le modèle",
  "workspace_settings.templates.overview.template_details_heading": "Détails du modèle",
  "workspace_settings.templates.overview.project_overview_heading": "Aperçu du projet",
  "workspace_settings.templates.system_fields.heading": "Champs système",
  "workspace_settings.templates.system_fields.description":
    "Inclus automatiquement dans chaque projet — inutile de créer des champs personnalisés pour ceux-ci.",
  "workspace_settings.templates.system_fields.status": "Statut",
  "workspace_settings.templates.system_fields.start_date": "Date de début",
  "workspace_settings.templates.system_fields.end_date": "Date de fin",
  "workspace_settings.templates.system_fields.launch_date": "Date de lancement",
  "workspace_settings.templates.system_fields.completed_date": "Date d'achèvement",
  "workspace_settings.templates.system_fields.client_teams": "Équipes clientes",
  "workspace_settings.templates.system_fields.delivery_teams": "Équipes de livraison",
  "workspace_settings.templates.system_fields.client_teams_input_label":
    "Libellé des équipes clientes",
  "workspace_settings.templates.system_fields.delivery_teams_input_label":
    "Libellé des équipes de livraison",
  "workspace_settings.templates.system_fields.type_status": "Statut",
  "workspace_settings.templates.system_fields.type_date": "Date",
  "workspace_settings.templates.system_fields.type_teams": "Équipes",
  "workspace_settings.templates.panel.sub_workitems_heading": "Sous-tâches",
  "workspace_settings.templates.panel.no_sub_workitems": "Aucune sous-tâche pour l’instant.",
  "workspace_settings.templates.panel.dependencies_heading": "Dépendances",
  "workspace_settings.templates.panel.no_dependencies": "Aucune dépendance pour l’instant.",
  "workspace_settings.templates.panel.attachments_heading": "Pièces jointes",
  "workspace_settings.templates.panel.no_attachments": "Aucune pièce jointe pour l’instant.",
  "workspace_settings.templates.panel.attachment_upload": "Téléverser un fichier",
  "workspace_settings.templates.panel.attachment_delete": "Supprimer la pièce jointe",
  "workspace_settings.templates.panel.attachments_save_first":
    "Enregistrez le modèle pour ajouter des pièces jointes à cet élément.",
  "workspace_settings.templates.panel.no_custom_fields": "Aucun champ global sur cette tâche.",
  "workspace_settings.templates.form.new_title": "Nouveau modèle",
  "workspace_settings.templates.form.name_label": "Nom du modèle",
  "workspace_settings.templates.form.description_label": "Description du modèle",
  "workspace_settings.templates.form.team_access_label": "Accès des équipes",
  "workspace_settings.templates.form.team_access_placeholder": "Sélectionner des équipes",
  "workspace_settings.templates.form.team_access_all_teams": "Toutes les équipes",
  "workspace_settings.templates.form.team_access_hint":
    "Les équipes sélectionnées, ainsi que toutes les équipes qui leur sont subordonnées dans la hiérarchie, pourront utiliser ce modèle lors de la création de projets.",
  "workspace_settings.templates.form.team_access_locked_hint":
    "Ce modèle sera disponible pour cette équipe et pour toutes les équipes qui lui sont subordonnées.",
  "workspace_settings.templates.form.project_description_label": "Description du projet",
  "workspace_settings.templates.form.visibility_label": "Visibilité par défaut",
  "workspace_settings.templates.form.privacy_public": "Public",
  "workspace_settings.templates.form.privacy_private": "Privé",
  "workspace_settings.templates.form.lead_label": "Responsable(s) du projet par défaut",
  "workspace_settings.templates.form.lead_remove": "Retirer le responsable",
  "workspace_settings.templates.form.lead_placeholder": "Aucun",
  "workspace_settings.templates.form.members_label": "Membres",
  "workspace_settings.templates.form.skip_weekends_label": "Ignorer les week-ends",
  "workspace_settings.templates.form.skip_weekends_description":
    "Lorsqu'activé, les dates d'échéance des tâches tombant un samedi ou un dimanche seront automatiquement décalées au lundi suivant.",
  "workspace_settings.templates.form.workitems_title": "Tâches",
  "workspace_settings.templates.form.add_workitem": "Ajouter une tâche",
  "workspace_settings.templates.form.create_workitem": "Créer une tâche",
  "workspace_settings.templates.form.import_workitems": "Importer des tâches",
  "workspace_settings.templates.form.add_sub_workitem": "Ajouter une sous-tâche",
  "workspace_settings.templates.form.no_workitems": "Aucune tâche pour l'instant",
  "workspace_settings.templates.form.no_workitem_matches":
    "Aucune tâche ne correspond à votre recherche.",
  "workspace_settings.templates.form.search_workitems_placeholder": "Rechercher une tâche…",
  "workspace_settings.templates.form.workitem_col_name": "Nom",
  "workspace_settings.templates.form.workitem_col_type": "Type",
  "workspace_settings.templates.form.workitem_col_priority": "Priorité",
  "workspace_settings.templates.form.workitem_col_estimate": "Estimation",
  "workspace_settings.templates.form.workitem_col_start_day": "Jour de début",
  "workspace_settings.templates.form.workitem_col_end_date": "Date de fin",
  "workspace_settings.templates.form.workitem_col_end_day": "Jour de fin",
  "workspace_settings.templates.form.workitem_col_stage": "Étape",
  "workspace_settings.templates.form.workitem_col_job_role": "Rôle métier",
  "workspace_settings.templates.form.workitem_col_category": "Catégorie",
  "workspace_settings.templates.form.workitem_col_custom_fields": "Champs personnalisés",
  "workspace_settings.templates.form.workitem_col_dependencies": "Dépendances",
  "workspace_settings.templates.form.select_all_workitems": "Sélectionner toutes les tâches",
  "workspace_settings.templates.form.select_workitem": "Sélectionner {name}",
  "workspace_settings.templates.form.bulk_assign_job_role": "Attribuer un rôle métier",
  "workspace_settings.templates.form.bulk_job_role_assigned":
    "{count, plural, one {Rôle métier défini sur # tâche} other {Rôle métier défini sur # tâches}}",
  "workspace_settings.templates.form.move_up": "Monter",
  "workspace_settings.templates.form.move_down": "Descendre",
  "workspace_settings.templates.form.reorder_handle": "Glisser pour réordonner",
  "workspace_settings.templates.form.save": "Enregistrer",
  "workspace_settings.templates.form.save_success": "Modèle enregistré",
  "workspace_settings.templates.form.save_error": "Impossible d'enregistrer le modèle",
  "workspace_settings.templates.form.missing_template_name": "Le nom du modèle est requis.",
  "workspace_settings.templates.custom_fields.section_title": "Champs personnalisés",
  "workspace_settings.templates.custom_fields.empty_state":
    "Aucun champ personnalisé. Ajoutez des champs depuis la banque de votre espace de travail.",
  "workspace_settings.templates.custom_fields.empty_state_link": "Gérer la banque →",
  "workspace_settings.templates.custom_fields.add_field": "Ajouter un champ",
  "workspace_settings.templates.custom_fields.picker.title": "Ajouter un champ personnalisé",
  "workspace_settings.templates.custom_fields.picker.search_placeholder": "Rechercher…",
  "workspace_settings.templates.custom_fields.picker.no_matches": "Aucun champ correspondant.",
  "workspace_settings.templates.custom_fields.picker.empty":
    "Aucun champ disponible. Définissez-en dans les paramètres de l'espace de travail",
  "workspace_settings.templates.custom_fields.row.required": "Obligatoire",
  "workspace_settings.templates.custom_fields.row.default_value": "Valeur par défaut",
  "workspace_settings.templates.custom_fields.row.remove": "Supprimer",
  "workspace_settings.templates.custom_fields.row.archived_badge": "Archivé",
  "workspace_settings.templates.global_fields.section_heading": "Champs personnalisés",
  "workspace_settings.templates.global_fields.add_button": "Ajouter des champs",
  "workspace_settings.templates.global_fields.empty_no_fields":
    "Aucun champ personnalisé dans cet espace de travail.",
  "workspace_settings.templates.global_fields.empty_no_fields_link": "Gérer la banque →",
  "workspace_settings.templates.global_fields.required_label": "Obligatoire",
  "workspace_settings.templates.global_fields.options_locked_hint":
    "Les options sont gérées dans la bibliothèque de champs globaux",
  "workspace_settings.templates.global_fields.options_empty": "Aucune option définie sur ce champ.",
  "workspace_settings.templates.global_fields.drag_handle": "Glisser pour réorganiser",
  "workspace_settings.templates.workitem.name_label": "Nom",
  "workspace_settings.templates.workitem.description_label": "Description",
  "workspace_settings.templates.workitem.type_task": "Tâche",
  "workspace_settings.templates.workitem.type_event": "Événement",
  "workspace_settings.templates.workitem.type_milestone": "Jalon",
  "workspace_settings.templates.workitem.milestone_due_day_label":
    "Jour d'échéance (le jour 1 est le début du projet)",
  "workspace_settings.templates.workitem.cf_true": "Oui",
  "workspace_settings.templates.workitem.duration_days":
    "{count, plural, one {# jour} other {# jours}}",
  "workspace_settings.templates.workitem.priority_label": "Priorité",
  "workspace_settings.templates.workitem.priority_urgent": "Urgent",
  "workspace_settings.templates.workitem.priority_high": "Élevée",
  "workspace_settings.templates.workitem.priority_medium": "Moyenne",
  "workspace_settings.templates.workitem.priority_low": "Faible",
  "workspace_settings.templates.workitem.priority_none": "Aucune",
  "workspace_settings.templates.workitem.utilization_hours_label": "Heures d'utilisation",
  "workspace_settings.templates.workitem.estimate_label": "Estimation (heures)",
  "workspace_settings.templates.workitem.relative_start_day_label":
    "Jour de début (le jour 1 est le début du projet)",
  "workspace_settings.templates.workitem.due_offset_days_label": "Durée (jours)",
  "workspace_settings.templates.workitem.event_start_day_label": "Jour de début",
  "workspace_settings.templates.workitem.event_due_day_label": "Jour d'échéance",
  "workspace_settings.templates.workitem.event_start_day_time_label": "Jour / heure de début",
  "workspace_settings.templates.workitem.event_due_day_time_label": "Jour / heure d'échéance",
  "workspace_settings.templates.workitem.event_fields_required":
    "Les événements nécessitent un jour de début, un jour d'échéance et des heures (ou Toute la journée).",
  "workspace_settings.templates.workitem.stage_label": "Étape",
  "workspace_settings.templates.workitem.category_label": "Catégorie",
  "workspace_settings.templates.workitem.skills_label": "Qualifications",
  "workspace_settings.templates.workitem.skills_placeholder": "Sélectionner des qualifications",
  "workspace_settings.templates.workitem.skills_select_aria": "Sélectionner des qualifications",
  "workspace_settings.templates.workitem.add_title": "Créer une tâche",
  "workspace_settings.templates.workitem.edit_title": "Modifier la tâche",
  "workspace_settings.templates.workitem.end_day_label": "Jour de fin",
  "workspace_settings.templates.workitem.name_required": "Le nom de la tâche est requis",
  "workspace_settings.templates.workitem.rename_aria": "Renommer {name}",
  "workspace_settings.templates.workitem.start_day_edit_aria":
    "Modifier le jour de début pour {name}",
  "workspace_settings.templates.workitem.end_day_edit_aria": "Modifier le jour de fin pour {name}",
  "workspace_settings.templates.workitem.priority_edit_aria": "Modifier la priorité pour {name}",
  "workspace_settings.templates.workitem.estimate_edit_aria": "Modifier l'estimation pour {name}",
  "workspace_settings.templates.workitem.estimate_invalid":
    "Saisissez un nombre d'heures (0 ou plus)",
  "workspace_settings.templates.workitem.day_offset_invalid":
    "Saisissez un numéro de jour entier (1 ou plus)",
  "workspace_settings.templates.workitem.end_day_before_start":
    "Le jour de fin ne peut pas précéder le jour de début",
  "workspace_settings.templates.workitem.skills_edit_aria":
    "Modifier les qualifications pour {name}",
  "workspace_settings.templates.workitem.skills_search_placeholder":
    "Rechercher des qualifications",
  "workspace_settings.templates.workitem.skills_empty": "Aucune qualification trouvée",
  "workspace_settings.templates.workitem.custom_fields_button": "Champs personnalisés",
  "workspace_settings.templates.workitem.custom_fields_button_with_count":
    "Champs personnalisés ({count})",
  "workspace_settings.templates.workitem.custom_fields_title":
    "Champs personnalisés globaux — {name}",
  "workspace_settings.templates.workitem.dependencies_button": "Dépendances",
  "workspace_settings.templates.workitem.dependencies_button_with_count": "Dépendances ({count})",
  "workspace_settings.templates.workitem.dependencies_title": "Dépendances — {name}",
  "workspace_settings.templates.workitem.no_dependencies": "Aucune dépendance pour l'instant.",
  "workspace_settings.templates.workitem.no_dependency_candidates":
    "Ajoutez un autre élément de travail au modèle pour créer une dépendance.",
  "workspace_settings.templates.workitem.dependency_type_label": "Type",
  "workspace_settings.templates.workitem.dependency_workitem_label": "Élément de travail",
  "workspace_settings.templates.workitem.select_workitem": "Sélectionner un élément de travail",
  "workspace_settings.templates.workitem.select_workitem_search":
    "Rechercher des éléments de travail",
  "workspace_settings.templates.workitem.select_workitem_empty": "Aucun élément de travail trouvé",
  "workspace_settings.templates.workitem.add_dependency": "Ajouter",
  "workspace_settings.templates.workitem.remove_dependency": "Retirer la dépendance",
  "workspace_settings.templates.workitem.dependency_unknown_workitem": "Élément de travail inconnu",
  "workspace_settings.templates.workitem.dependency_blocks": "Bloque",
  "workspace_settings.templates.workitem.dependency_blocked_by": "Bloqué par",
  "workspace_settings.templates.workitem.dependency_relates_to": "Lié à",

  // Workspace settings — template detail and connected apps (NG-2578)
  "workspace_settings.templates.detail.tab_overview": "Vue d'ensemble",
  "workspace_settings.templates.detail.tab_table": "Tableau",
  "workspace_settings.templates.detail.tab_workflow": "Flux de travail",
  "workspace_settings.templates.detail.sections_aria": "Sections du modèle",
  "workspace_settings.templates.detail.name_aria": "Nom du modèle",
  "workspace_settings.templates.detail.delete_aria": "Supprimer le modèle",
  "workspace_settings.templates.detail.delete_title": "Supprimer le modèle",
  "workspace_settings.templates.detail.delete_description":
    "Supprimer « {name} » ? Cette action est irréversible.",
  "workspace_settings.templates.detail.delete_fallback_name": "ce modèle",
  "workspace_settings.templates.detail.delete_confirm": "Supprimer",
  "workspace_settings.templates.detail.deleted": "Modèle supprimé",
  "workspace_settings.templates.detail.delete_error": "Échec de la suppression du modèle",
  "workspace_settings.templates.detail.rename_error": "Échec du renommage du modèle",
  "workspace_settings.templates.detail.loading": "Chargement…",
  "workspace_settings.templates.detail.work_items_save_error":
    "Échec de l'enregistrement des éléments de travail",
  "workspace_settings.oauth_apps.title": "Applications connectées",
  "workspace_settings.oauth_apps.description":
    "Enregistrez des applications tierces qui peuvent authentifier les utilisateurs de cet espace de travail via OAuth.",
  "workspace_settings.oauth_apps.new_app": "Nouvelle application",
  "workspace_settings.oauth_apps.loading": "Chargement…",
  "workspace_settings.oauth_apps.load_error": "Échec du chargement des applications.",
  "workspace_settings.oauth_apps.delete_confirm":
    "Supprimer {name} ? Les jetons existants échoueront à l'introspection.",

  // Workspace settings — standard fields
  "workspace_settings.standard_fields.empty_state": "Aucun champ standard configuré.",
  "workspace_settings.standard_fields.editor.default_badge": "Par défaut",
  "workspace_settings.standard_fields.editor.quick_add_placeholder": "Ajouter une option…",
  "workspace_settings.standard_fields.editor.add_value": "Ajouter une option",
  "workspace_settings.standard_fields.editor.toast_added": "Option ajoutée",
  "workspace_settings.standard_fields.editor.toast_renamed": "Option mise à jour",
  "workspace_settings.standard_fields.editor.toast_activated": "Option réactivée",
  "workspace_settings.standard_fields.editor.toast_deactivated": "Option désactivée",
  "workspace_settings.standard_fields.editor.last_active_tooltip":
    "Au moins une option active doit subsister.",
  "workspace_settings.standard_fields.editor.duplicate_error":
    "Une option portant ce nom existe déjà.",
  "workspace_settings.standard_fields.editor.save_error":
    "Impossible d'enregistrer la modification. Réessayez.",
  "workspace_settings.standard_fields.editor.inactive_heading": "Options inactives",
  "workspace_settings.standard_fields.editor.drag_handle": "Glisser pour réorganiser",
  "workspace_settings.standard_fields.editor.deactivate": "Désactiver l'option",
  "workspace_settings.standard_fields.editor.reactivate": "Réactiver l'option",
  "workspace_settings.standard_fields.editor.delete": "Supprimer l'option",
  "workspace_settings.standard_fields.editor.toast_deleted": "Option supprimée",
  "workspace_settings.standard_fields.editor.delete_error":
    "Impossible de supprimer l'option. Réessayez.",
  "workspace_settings.standard_fields.editor.delete_confirm_title": "Supprimer l'option ?",
  "workspace_settings.standard_fields.editor.delete_confirm_body":
    "Supprimer définitivement « {label} ». Cette action est irréversible. Si l'option est encore référencée quelque part, la suppression sera bloquée jusqu'à la suppression de ces références.",
  "workspace_settings.standard_fields.editor.delete_confirm_action": "Supprimer",
  "workspace_settings.standard_fields.editor.delete_blocked_default":
    "Ceci est l'option par défaut et ne peut pas être supprimée. Choisissez d'abord une autre valeur par défaut.",
  "workspace_settings.standard_fields.editor.delete_blocked_active":
    "Désactivez cette option avant de la supprimer.",
  "workspace_settings.standard_fields.editor.delete_blocked_usage_title": "Option encore utilisée",
  "workspace_settings.standard_fields.editor.delete_blocked_usage_body":
    "« {label} » ne peut pas être supprimée car elle est encore référencée par ces enregistrements. Supprimez d'abord ces références, puis réessayez.",
  "workspace_settings.standard_fields.editor.usage_projects": "Projets",
  "workspace_settings.standard_fields.editor.usage_tasks": "Tâches",
  "workspace_settings.standard_fields.editor.usage_events": "Événements",
  "workspace_settings.standard_fields.editor.usage_milestones": "Jalons",
  "workspace_settings.standard_fields.editor.usage_intake_submissions": "Soumissions d'admission",
  "workspace_settings.standard_fields.editor.usage_intake_forms": "Formulaires d'admission",
  "workspace_settings.standard_fields.editor.values_heading": "Options de réponse",
  "workspace_settings.standard_fields.editor.values_help":
    "Les options peuvent être désactivées, et supprimées une fois inactives et inutilisées — les enregistrements ayant capturé une option désactivée restent intacts.",
  "workspace_settings.standard_fields.editor.search_placeholder": "Rechercher des options",
  "workspace_settings.standard_fields.editor.search_clear": "Effacer la recherche",
  "workspace_settings.standard_fields.editor.no_matches":
    "Aucune option ne correspond à votre recherche.",
  "standard_fields.category_select.placeholder": "Sélectionner une catégorie",
  "standard_fields.category_select.search": "Rechercher des catégories…",
  "standard_fields.category_select.empty": "Aucune catégorie",
  "standard_fields.category_select.inactive": "{label} (inactif)",
  "standard_fields.category_select.none": "Aucune catégorie",
  "standard_fields.category_select.aria": "Catégorie",

  // Workspace settings — custom fields
  "workspace_settings.custom_fields.list_title": "Champs globaux",
  "workspace_settings.custom_fields.list_description":
    "Définissez des champs réutilisables utilisables dans tout Cognota",
  "workspace_settings.custom_fields.new": "Créer un champ personnalisé",
  "workspace_settings.custom_fields.empty_state":
    "Aucun champ personnalisé pour le moment. Créez-en un pour commencer à les utiliser sur les modèles et les formulaires d'admission.",
  "workspace_settings.custom_fields.empty_state.no_matches":
    "Aucun champ ne correspond aux filtres actuels.",
  "workspace_settings.custom_fields.search_placeholder": "Rechercher par nom de champ",
  "workspace_settings.custom_fields.select_all": "Sélectionner tous les champs personnalisés",
  "workspace_settings.custom_fields.select_one": "Sélectionner {name}",
  "workspace_settings.custom_fields.show_archived": "Afficher les archivés",
  "workspace_settings.custom_fields.filter.kind": "Type de champ",
  "workspace_settings.custom_fields.filter.kind_search": "Rechercher des types de champ…",
  "workspace_settings.custom_fields.filter.project_templates": "Modèle de projet",
  "workspace_settings.custom_fields.filter.project_templates_search": "Rechercher des modèles…",
  "workspace_settings.custom_fields.filter.intake_forms": "Formulaire d'admission",
  "workspace_settings.custom_fields.filter.intake_forms_search": "Rechercher des formulaires…",
  "workspace_settings.custom_fields.filter.empty": "Aucun résultat.",
  "workspace_settings.custom_fields.filter.clear": "Effacer les filtres",
  "workspace_settings.custom_fields.column.name": "Nom du champ",
  "workspace_settings.custom_fields.column.id": "ID",
  "workspace_settings.custom_fields.column.kind": "Type",
  "workspace_settings.custom_fields.column.category": "Catégorie",
  "workspace_settings.custom_fields.column.updated": "Mis à jour",
  "workspace_settings.custom_fields.column.config": "Configuration",
  "workspace_settings.custom_fields.column.actions": "Actions",
  "workspace_settings.custom_fields.count_summary": "Affichage de {count} sur {total}",
  "workspace_settings.custom_fields.range_summary": "Affichage de {from}–{to} sur {total}",
  "workspace_settings.custom_fields.pagination.prev": "Page précédente",
  "workspace_settings.custom_fields.pagination.next": "Page suivante",
  "workspace_settings.custom_fields.action.edit": "Modifier",
  "workspace_settings.custom_fields.action.more": "Autres actions",
  "workspace_settings.custom_fields.action.archive": "Archiver",
  "workspace_settings.custom_fields.action.restore": "Restaurer",
  "workspace_settings.custom_fields.action.delete": "Supprimer définitivement",
  "workspace_settings.custom_fields.action.duplicate": "Dupliquer",
  "workspace_settings.custom_fields.toast.duplicated": "Dupliqué en « {name} »",
  "workspace_settings.custom_fields.toast.error_duplicate": "Impossible de dupliquer le champ.",
  "workspace_settings.custom_fields.usage.heading": "Utilisé par",
  "workspace_settings.custom_fields.usage.project_templates": "Modèles de projet",
  "workspace_settings.custom_fields.usage.intake_forms": "Formulaires d'admission",
  "workspace_settings.custom_fields.usage.empty":
    "Ce champ n'est utilisé par aucun modèle de projet ni formulaire d'admission actif.",
  "workspace_settings.custom_fields.usage.none": "Aucun",
  "workspace_settings.custom_fields.usage.loading": "Chargement de l'utilisation…",
  "workspace_settings.custom_fields.usage.error": "Impossible de charger l'utilisation.",
  "workspace_settings.custom_fields.editor.title.create": "Nouveau champ personnalisé",
  "workspace_settings.custom_fields.editor.title.edit": "Modifier le champ personnalisé",
  "workspace_settings.custom_fields.editor.field.name": "Nom",
  "workspace_settings.custom_fields.editor.field.description": "Description",
  "workspace_settings.custom_fields.editor.field.kind": "Type",
  "workspace_settings.custom_fields.editor.field.options": "Options",
  "workspace_settings.custom_fields.editor.kind.text": "Texte sur une ligne",
  "workspace_settings.custom_fields.editor.kind.paragraph": "Paragraphe",
  "workspace_settings.custom_fields.editor.kind.number": "Nombre",
  "workspace_settings.custom_fields.editor.kind.boolean": "Vrai / Faux",
  "workspace_settings.custom_fields.editor.kind.date": "Date / Heure",
  "workspace_settings.custom_fields.editor.kind.select": "Sélection unique",
  "workspace_settings.custom_fields.editor.kind.multiselect": "Sélection multiple",
  "workspace_settings.custom_fields.editor.kind.email": "Adresse e-mail",
  "workspace_settings.custom_fields.editor.kind.phone": "Numéro de téléphone",
  "workspace_settings.custom_fields.editor.kind.currency": "Devise",
  "workspace_settings.custom_fields.editor.kind.user_list": "Liste d'utilisateurs",
  "workspace_settings.custom_fields.editor.kind.locked":
    "Le type ne peut pas être modifié une fois le champ utilisé.",
  "workspace_settings.custom_fields.editor.display.label": "Afficher comme",
  "workspace_settings.custom_fields.editor.display.dropdown": "Liste déroulante",
  "workspace_settings.custom_fields.editor.display.radio": "Boutons radio",
  "workspace_settings.custom_fields.editor.display.checkboxes": "Cases à cocher",
  "workspace_settings.custom_fields.editor.select_type.current_label": "Type de sélection",
  "workspace_settings.custom_fields.editor.select_type.single": "Sélection unique",
  "workspace_settings.custom_fields.editor.select_type.multi": "Sélection multiple",
  "workspace_settings.custom_fields.editor.select_type.convert_action":
    "Convertir en sélection multiple",
  "workspace_settings.custom_fields.editor.select_type.not_reversible_tooltip":
    "Un champ à sélection multiple ne peut pas être reconverti en sélection unique.",
  "workspace_settings.custom_fields.editor.select_type.convert_error":
    "Impossible de convertir en sélection multiple. Veuillez réessayer.",
  "workspace_settings.custom_fields.editor.select_type.convert_confirm_title":
    "Convertir en sélection multiple ?",
  "workspace_settings.custom_fields.editor.select_type.convert_confirm_body":
    "Convertir « {name} » en champ à sélection multiple. Cette action est irréversible — un champ à sélection multiple ne peut pas être reconverti en sélection unique.",
  "workspace_settings.custom_fields.editor.option.label": "Étiquette",
  "workspace_settings.custom_fields.editor.option.drag_handle": "Glisser pour réorganiser",
  "workspace_settings.custom_fields.editor.option.add": "Ajouter une option",
  "workspace_settings.custom_fields.editor.option.remove": "Supprimer",
  "workspace_settings.custom_fields.editor.option.archive": "Archiver l'option",
  "workspace_settings.custom_fields.editor.option.unarchive": "Désarchiver l'option",
  "workspace_settings.custom_fields.editor.option.archived_heading": "Options archivées",
  "workspace_settings.custom_fields.editor.option.search_placeholder": "Rechercher des options",
  "workspace_settings.custom_fields.editor.option.search_clear": "Effacer la recherche",
  "workspace_settings.custom_fields.editor.option.empty":
    "Aucune option de réponse pour le moment.",
  "workspace_settings.custom_fields.editor.option.no_matches":
    "Aucune option ne correspond à votre recherche.",
  "workspace_settings.custom_fields.editor.option.page_indicator": "Page {page} sur {total}",
  "workspace_settings.custom_fields.editor.option.page_prev": "Page précédente",
  "workspace_settings.custom_fields.editor.option.page_next": "Page suivante",
  "workspace_settings.custom_fields.editor.option.archive_confirm.title": "Archiver cette option ?",
  "workspace_settings.custom_fields.editor.option.archive_confirm.body":
    "{label} restera visible sur les enregistrements existants mais ne pourra pas être sélectionné sur de nouvelles soumissions. Vous pouvez la désarchiver à tout moment.",
  "workspace_settings.custom_fields.editor.option.archive_confirm.confirm": "Archiver",
  "workspace_settings.custom_fields.editor.option.archive_confirm.cancel": "Annuler",
  "workspace_settings.custom_fields.editor.option.archive_confirm.checking":
    "Vérification des dépendances de logique conditionnelle…",
  "workspace_settings.custom_fields.editor.option.archive_confirm.precheck_error":
    "Impossible de vérifier les dépendances de cette option. Réessayez.",
  "workspace_settings.custom_fields.editor.option.archive_confirm.blocked_intro":
    "La logique conditionnelle sur des formulaires actifs dépend de la valeur de cette option. L'archivage est bloqué jusqu'à la résolution de ces dépendances.",
  "workspace_settings.custom_fields.editor.option.archive_confirm.blocked_forms_heading":
    "Questions dépendantes",
  "workspace_settings.custom_fields.editor.option.archive_confirm.blocked_retry_hint":
    "Ouvrez chaque formulaire dans un nouvel onglet, retirez la dépendance, puis cliquez sur Réessayer.",
  "workspace_settings.custom_fields.editor.option.archive_confirm.retry": "Réessayer l'archivage",
  "workspace_settings.custom_fields.editor.cancel": "Annuler",
  "workspace_settings.custom_fields.editor.save": "Enregistrer",
  "workspace_settings.custom_fields.archive_dialog.consequences_heading":
    "Ce champ est actuellement utilisé dans :",
  "workspace_settings.custom_fields.archive_dialog.consequences_templates":
    "{count, plural, one {# modèle de projet} other {# modèles de projet}}",
  "workspace_settings.custom_fields.archive_dialog.consequences_forms":
    "{count, plural, one {# formulaire d'admission} other {# formulaires d'admission}}",
  "workspace_settings.custom_fields.archive_dialog.title": "Archiver {name} ?",
  "workspace_settings.custom_fields.archive_dialog.body":
    "Les champs archivés sont masqués des nouveaux modèles, formulaires d'admission et sélecteurs de projet. Les utilisations existantes continueront à s'afficher.",
  "workspace_settings.custom_fields.archive_dialog.confirm": "Archiver",
  "workspace_settings.custom_fields.archive_dialog.cancel": "Annuler",
  "workspace_settings.custom_fields.archive_dialog.checking":
    "Vérification des dépendances de logique conditionnelle…",
  "workspace_settings.custom_fields.archive_dialog.precheck_error":
    "Impossible de vérifier les dépendances de ce champ. Réessayez.",
  "workspace_settings.custom_fields.archive_dialog.blocked_intro":
    "La logique conditionnelle sur des formulaires actifs dépend de ce champ. L'archivage est bloqué jusqu'à la résolution de ces dépendances.",
  "workspace_settings.custom_fields.archive_dialog.blocked_forms_heading": "Questions dépendantes",
  "workspace_settings.custom_fields.archive_dialog.blocked_retry_hint":
    "Ouvrez chaque formulaire dans un nouvel onglet, retirez la dépendance, puis cliquez sur Réessayer.",
  "workspace_settings.custom_fields.archive_dialog.retry": "Réessayer l'archivage",
  "workspace_settings.custom_fields.duplicate_dialog.title": "Dupliquer {name} ?",
  "workspace_settings.custom_fields.duplicate_dialog.body":
    "Une copie sera créée avec la même configuration, la même description et les mêmes options de réponse. Le duplicata reçoit un nouvel identifiant unique et ne sera assigné à aucun formulaire ou modèle de projet.",
  "workspace_settings.custom_fields.duplicate_dialog.confirm": "Dupliquer",
  "workspace_settings.custom_fields.duplicate_dialog.cancel": "Annuler",
  "workspace_settings.custom_fields.delete_dialog.title": "Supprimer {name} définitivement ?",
  "workspace_settings.custom_fields.delete_dialog.checking":
    "Vérification des emplacements où ce champ est utilisé…",
  "workspace_settings.custom_fields.delete_dialog.precheck_error":
    "Impossible de vérifier l'utilisation de ce champ. Réessayez.",
  "workspace_settings.custom_fields.delete_dialog.blocked_active_data":
    "Des projets ou des demandes actifs contiennent des données pour ce champ. Il ne peut pas être supprimé tant que ces données sont utilisées — archivez le champ à la place.",
  "workspace_settings.custom_fields.delete_dialog.blocked_active_usage":
    "Ce champ est actuellement utilisé par des formulaires ou des modèles de projet actifs. Retirez-le de chacun, ou archivez le champ, avant de le supprimer.",
  "workspace_settings.custom_fields.delete_dialog.warn_permanent":
    "Cette action est définitive et irréversible.",
  "workspace_settings.custom_fields.delete_dialog.warn_inactive_removed":
    "Le champ sera retiré définitivement de tous les formulaires et modèles inactifs qui l'utilisent.",
  "workspace_settings.custom_fields.delete_dialog.warn_broken_logic":
    "Toute logique conditionnelle dépendante de ce champ sera rompue et ne pourra pas être récupérée.",
  "workspace_settings.custom_fields.delete_dialog.warn_inactive_manual":
    "Si un formulaire ou un modèle inactif est réactivé plus tard, il devra être mis à jour manuellement.",
  "workspace_settings.custom_fields.delete_dialog.archive_recommend":
    "L'archivage est recommandé si vous pourriez avoir besoin du champ à nouveau.",
  "workspace_settings.custom_fields.delete_dialog.usage_templates_heading":
    "Modèles de projet concernés",
  "workspace_settings.custom_fields.delete_dialog.usage_workitem_templates_heading":
    "Tâches de modèle concernées",
  "workspace_settings.custom_fields.delete_dialog.usage_forms_heading":
    "Formulaires d'admission concernés",
  "workspace_settings.custom_fields.delete_dialog.usage_projects_heading":
    "Projets utilisant ce champ",
  "workspace_settings.custom_fields.delete_dialog.usage_work_items_heading":
    "Tâches utilisant ce champ",
  "workspace_settings.custom_fields.delete_dialog.archive_instead": "Archiver à la place",
  "workspace_settings.custom_fields.delete_dialog.confirm": "Supprimer définitivement",
  "workspace_settings.custom_fields.delete_dialog.cancel": "Annuler",
  "workspace_settings.custom_fields.toast.deleted": "« {name} » supprimé",
  "workspace_settings.custom_fields.toast.error_delete": "Impossible de supprimer le champ.",
  "workspace_settings.custom_fields.archived_badge": "Archivé",
  "workspace_settings.custom_fields.default_badge": "Par défaut",
  // Les badges de la colonne Catégorie et les options de son filtre (NG-854).
  "workspace_settings.custom_fields.category.system": "Champ système",
  "workspace_settings.custom_fields.category.default": "Par défaut",
  "workspace_settings.custom_fields.category.custom": "Personnalisé",
  "workspace_settings.custom_fields.export_no_bank_fields":
    "Rien \u00e0 exporter \u2014 l\u2019export ne couvre que les champs de l\u2019espace de travail, et les champs syst\u00e8me n\u2019en font pas partie.",
  "workspace_settings.custom_fields.config_preview.options_count":
    "{count, plural, one {# option} other {# options}}",
  "workspace_settings.custom_fields.config_preview.none": "—",
  "workspace_settings.custom_fields.editor.number.min": "Min.",
  "workspace_settings.custom_fields.editor.number.max": "Max.",
  "workspace_settings.custom_fields.editor.number.step": "Pas",
  "workspace_settings.custom_fields.editor.number.unit": "Unité",
  "workspace_settings.custom_fields.toast.created": "Champ personnalisé créé.",
  "workspace_settings.custom_fields.toast.updated": "Champ personnalisé mis à jour.",
  "workspace_settings.custom_fields.toast.archived": "{name} archivé.",
  "workspace_settings.custom_fields.toast.restored": "{name} restauré.",
  "workspace_settings.custom_fields.toast.error_save":
    "Échec de l'enregistrement du champ. Veuillez réessayer.",
  "workspace_settings.custom_fields.toast.error_archive": "Échec de l'archivage du champ.",
  "workspace_settings.custom_fields.toast.error_restore": "Échec de la restauration du champ.",
  "workspace_settings.custom_fields.edit_page.loading": "Chargement…",
  "workspace_settings.custom_fields.edit_page.not_found":
    "Ce champ n'existe pas ou a été supprimé.",
  "workspace_settings.custom_fields.edit_page.updated_meta": "Mis à jour le {date}",
  "workspace_settings.custom_fields.edit_page.delete_locked":
    "Archivez ce champ avant de le supprimer.",
  "workspace_settings.custom_fields.edit_page.tab.details": "Détails",
  "workspace_settings.custom_fields.edit_page.tab.usage": "Utilisation",
  "workspace_settings.custom_fields.edit_page.details_heading": "Détails du champ",
  "workspace_settings.custom_fields.edit_page.autosave_help":
    "Les modifications sont enregistrées automatiquement. Le type et l'identifiant ne peuvent pas être modifiés après la création.",
  "workspace_settings.custom_fields.edit_page.options_heading": "Options de réponse",
  "workspace_settings.custom_fields.edit_page.options_help":
    "Les options peuvent être archivées mais pas supprimées — les enregistrements existants restent intacts.",
  "workspace_settings.custom_fields.edit_page.usage_column.name": "Nom",
  "workspace_settings.custom_fields.edit_page.usage_column.kind": "Type",
  "workspace_settings.custom_fields.edit_page.usage_kind.form": "Formulaire d'admission",
  "workspace_settings.custom_fields.edit_page.usage_kind.template": "Modèle de projet",
  "workspace_settings.custom_fields.create_modal.title_step_1": "Créer un champ personnalisé",
  "workspace_settings.custom_fields.create_modal.subtitle_step_1":
    "Choisissez le type de champ qui correspond aux données à collecter. Le type ne peut pas être modifié après la création.",
  "workspace_settings.custom_fields.create_modal.title_step_2": "Nouveau champ {kind}",
  "workspace_settings.custom_fields.create_modal.subtitle_step_2":
    "Donnez un nom clair à votre champ. Vous pourrez le réutiliser sur n'importe quel formulaire ou modèle de projet.",
  "workspace_settings.custom_fields.create_modal.name_placeholder": "ex. Lieu de livraison",
  "workspace_settings.custom_fields.create_modal.description_placeholder":
    "Expliquez à quoi sert ce champ. Visible uniquement aux administrateurs.",
  "workspace_settings.custom_fields.create_modal.optional": "(optionnel)",
  "workspace_settings.custom_fields.create_modal.options_followup":
    "Vous pourrez ajouter des options de réponse après la création.",
  "workspace_settings.custom_fields.create_modal.continue": "Continuer",
  "workspace_settings.custom_fields.create_modal.back": "Retour",
  "workspace_settings.custom_fields.create_modal.submit": "Créer le champ",
  "workspace_settings.custom_fields.create_modal.kind_desc.text": "Texte court libre",
  "workspace_settings.custom_fields.create_modal.kind_desc.paragraph": "Texte multi-lignes",
  "workspace_settings.custom_fields.create_modal.kind_desc.number":
    "Un nombre, avec min, max, pas ou unité optionnels",
  "workspace_settings.custom_fields.create_modal.kind_desc.boolean": "Un seul bouton vrai / faux",
  "workspace_settings.custom_fields.create_modal.kind_desc.date":
    "Une date, avec heure optionnelle",
  "workspace_settings.custom_fields.create_modal.kind_desc.select":
    "Choisir une ou plusieurs options dans une liste définie",
  "workspace_settings.custom_fields.create_modal.kind_desc.multiselect":
    "Choisir plusieurs options (cases à cocher ou liste déroulante)",
  "workspace_settings.custom_fields.create_modal.select_tile": "Sélection",
  "workspace_settings.custom_fields.create_modal.select_type_label": "Type de sélection",
  "workspace_settings.custom_fields.create_modal.kind_desc.email": "Une adresse e-mail",
  "workspace_settings.custom_fields.create_modal.kind_desc.phone": "Un numéro de téléphone",
  "workspace_settings.custom_fields.create_modal.kind_desc.currency":
    "Un montant monétaire dans une devise choisie. Les champs de devise personnalisés ne sont pas inclus dans les métriques de coût de Cognota.",
  "workspace_settings.custom_fields.create_modal.kind_desc.user_list":
    "Sélectionnez un ou plusieurs membres de l'espace de travail",
  "custom_fields.user_list.placeholder": "Sélectionner des membres",
  "custom_fields.user_list.search_placeholder": "Rechercher des membres",
  "custom_fields.user_list.empty": "Aucun membre trouvé",
  "custom_fields.multiselect.placeholder": "Sélectionner des options",
  "custom_fields.multiselect.search_placeholder": "Rechercher des options",
  "custom_fields.multiselect.empty": "Aucune option trouvée",
  "workspace_settings.custom_fields.editor.currency.label": "Code de devise",
  "workspace_settings.custom_fields.editor.currency.placeholder": "USD",
  "workspace_settings.custom_fields.editor.currency.help":
    "Code de devise ISO 4217 (par ex. USD, EUR, CAD).",
  "workspace_settings.custom_fields.cost_field.actual_cost": "Coût réel",
  "workspace_settings.custom_fields.cost_field.estimated_cost": "Coût estimé",
  "workspace_settings.custom_fields.cost_field.actual_cost_help":
    "Cognota utilise ce champ pour calculer le coût réel du travail en multipliant les heures réelles de l'élément de travail par le taux horaire de l'utilisateur. Seuls les utilisateurs disposant de l'autorisation Données financières peuvent voir ce champ.",
  "workspace_settings.custom_fields.cost_field.estimated_cost_help":
    "Cognota utilise ce champ pour calculer le coût estimé du travail en multipliant les heures estimées de l'élément de travail par le taux horaire de l'utilisateur. Seuls les utilisateurs disposant de l'autorisation Données financières peuvent voir ce champ.",
  "workspace_settings.custom_fields.system_field.target_launch_date": "Date de lancement cible",
  "workspace_settings.custom_fields.system_field.target_launch_date_help":
    "La date de lancement cible d'une demande. Ajoutez-la \u00e0 un flux de travail d'admission depuis le panneau Champs globaux du cr\u00e9ateur de formulaire\u00a0; une demande ne la recueille que sur les flux qui l'incluent, et la conversion de la demande reporte la date sur le nouveau projet.",
  "workspace_settings.custom_fields.editor.currency.metrics_banner":
    "Les champs de devise personnalisés ne sont pas inclus dans les métriques de coût de Cognota. Utilisez le coût estimé et le coût réel pour tirer parti des métriques de coût de Cognota.",
  "workspace_settings.custom_fields.editor.currency.invalid":
    "Entrez un code de devise ISO de 3 lettres (par ex. USD).",
  "workspace_settings.custom_fields.editor.precision.label": "Décimales",

  // Workspace settings — states
  "workspace_settings.states.title": "Statuts des tâches",
  "workspace_settings.states.description":
    "Configurez les statuts utilisés par les tâches de cet espace de travail.",
  "workspace_settings.states.group.backlog": "En attente",
  "workspace_settings.states.group.unstarted": "Non démarré",
  "workspace_settings.states.group.started": "Démarré",
  "workspace_settings.states.group.on_hold": "En pause",
  "workspace_settings.states.group.completed": "Terminé",
  "workspace_settings.states.group.cancelled": "Annulé",
  "workspace_settings.states.add_state": "Ajouter un statut",
  "workspace_settings.states.create": "Créer le statut",
  "workspace_settings.states.save": "Enregistrer",
  "workspace_settings.states.edit": "Modifier le statut",
  "workspace_settings.states.delete": "Supprimer le statut",
  "workspace_settings.states.deleting": "Suppression…",
  "workspace_settings.states.mark_default": "Définir par défaut",
  "workspace_settings.states.default_badge": "Par défaut",
  "workspace_settings.states.empty_group": "Aucun statut dans ce groupe.",
  "workspace_settings.states.drag_handle": "Glisser pour réordonner",
  "workspace_settings.states.cannot_delete_default":
    "Le statut par défaut ne peut pas être supprimé. Définissez d'abord un autre statut par défaut.",
  "workspace_settings.states.create_success": "Statut créé.",
  "workspace_settings.states.create_error": "Échec de la création du statut.",
  "workspace_settings.states.update_success": "Statut mis à jour.",
  "workspace_settings.states.update_error": "Échec de la mise à jour du statut.",
  "workspace_settings.states.delete_success": "Statut supprimé.",
  "workspace_settings.states.delete_error": "Échec de la suppression du statut.",
  "workspace_settings.states.mark_default_success": "Statut par défaut mis à jour.",
  "workspace_settings.states.mark_default_error": "Échec de la définition du statut par défaut.",
  "workspace_settings.states.reorder_error": "Échec du réordonnancement des statuts.",
  "workspace_settings.states.delete_title": "Supprimer le statut",
  "workspace_settings.states.delete_description":
    "Supprimer le statut « {name} » ? Les tâches qui l'utilisent devront être réaffectées.",
  "workspace_settings.states.form.name_label": "Nom",
  "workspace_settings.states.form.name_placeholder": "par ex. En relecture",
  "workspace_settings.states.form.group_label": "Groupe",
  "workspace_settings.states.form.color_label": "Couleur",

  // Workspace settings — project states
  "workspace_settings.project_states.title": "Statuts des projets",
  "workspace_settings.project_states.description":
    "Configurez les statuts utilisés par les projets dans cet espace de travail.",
  "workspace_settings.project_states.group.backlog": "En attente",
  "workspace_settings.project_states.group.unstarted": "Non démarré",
  "workspace_settings.project_states.group.started": "Démarré",
  "workspace_settings.project_states.group.completed": "Terminé",
  "workspace_settings.project_states.group.cancelled": "Annulé",
  "workspace_settings.project_states.add_state": "Ajouter un statut",
  "workspace_settings.project_states.create": "Créer le statut",
  "workspace_settings.project_states.save": "Enregistrer",
  "workspace_settings.project_states.edit": "Modifier le statut",
  "workspace_settings.project_states.delete": "Supprimer le statut",
  "workspace_settings.project_states.deleting": "Suppression…",
  "workspace_settings.project_states.mark_default": "Marquer comme défaut",
  "workspace_settings.project_states.default_badge": "Par défaut",
  "workspace_settings.project_states.empty_group": "Aucun statut dans ce groupe.",
  "workspace_settings.project_states.drag_handle": "Glisser pour réordonner",
  "workspace_settings.project_states.cannot_delete_default":
    "Le statut par défaut ne peut pas être supprimé. Marquez d'abord un autre statut comme défaut.",
  "workspace_settings.project_states.create_success": "Statut créé.",
  "workspace_settings.project_states.create_error": "Échec de la création du statut.",
  "workspace_settings.project_states.update_success": "Statut mis à jour.",
  "workspace_settings.project_states.update_error": "Échec de la mise à jour du statut.",
  "workspace_settings.project_states.delete_success": "Statut supprimé.",
  "workspace_settings.project_states.delete_error": "Échec de la suppression du statut.",
  "workspace_settings.project_states.mark_default_success": "Statut par défaut mis à jour.",
  "workspace_settings.project_states.mark_default_error": "Échec du marquage comme défaut.",
  "workspace_settings.project_states.reorder_error": "Échec du réordonnancement des statuts.",
  "workspace_settings.project_states.delete_title": "Supprimer le statut",
  "workspace_settings.project_states.delete_description":
    "Supprimer le statut « {name} » ? Les projets assignés devront peut-être être réassignés.",
  "workspace_settings.project_states.delete_usage_warning":
    "Utilisé par {templateCount, plural, one {# modèle} other {# modèles}} et {workflowCount, plural, one {# flux de projet} other {# flux de projet}}. La suppression le retire de leurs flux.",
  "workspace_settings.project_states.form.name_label": "Nom",
  "workspace_settings.project_states.form.name_placeholder": "par ex. En relecture",
  "workspace_settings.project_states.form.group_label": "Groupe",
  "workspace_settings.project_states.form.color_label": "Couleur",

  // Request states
  "workspace_settings.request_statuses.title": "Statuts des demandes",
  "workspace_settings.request_statuses.description":
    "Configurez les statuts utilisés par les demandes dans cet espace de travail.",
  "workspace_settings.request_statuses.group.new": "Nouveau",
  "workspace_settings.request_statuses.group.in_review": "En révision",
  "workspace_settings.request_statuses.group.waitlisted": "En liste d'attente",
  "workspace_settings.request_statuses.group.accepted": "Accepté",
  "workspace_settings.request_statuses.group.delivered": "Livré",
  "workspace_settings.request_statuses.group.declined": "Refusé",
  "workspace_settings.request_statuses.group.cancelled": "Annulé",
  "workspace_settings.request_statuses.group.covered": "Couvert",
  "workspace_settings.request_statuses.add_state": "Ajouter un statut",
  "workspace_settings.request_statuses.create": "Créer le statut",
  "workspace_settings.request_statuses.save": "Enregistrer",
  "workspace_settings.request_statuses.edit": "Modifier le statut",
  "workspace_settings.request_statuses.delete": "Supprimer le statut",
  "workspace_settings.request_statuses.deleting": "Suppression…",
  "workspace_settings.request_statuses.mark_default": "Définir par défaut",
  "workspace_settings.request_statuses.default_badge": "Par défaut",
  "workspace_settings.request_statuses.empty_group": "Aucun statut dans ce groupe.",
  "workspace_settings.request_statuses.drag_handle": "Glisser pour réordonner",
  "workspace_settings.request_statuses.cannot_delete_default":
    "Le statut par défaut ne peut pas être supprimé. Définissez un autre statut par défaut d'abord.",
  "workspace_settings.request_statuses.create_success": "Statut créé.",
  "workspace_settings.request_statuses.create_error": "Échec de la création du statut.",
  "workspace_settings.request_statuses.update_success": "Statut mis à jour.",
  "workspace_settings.request_statuses.update_error": "Échec de la mise à jour du statut.",
  "workspace_settings.request_statuses.delete_success": "Statut supprimé.",
  "workspace_settings.request_statuses.delete_error": "Échec de la suppression du statut.",
  "workspace_settings.request_statuses.mark_default_success": "Statut par défaut mis à jour.",
  "workspace_settings.request_statuses.mark_default_error": "Échec du marquage comme défaut.",
  "workspace_settings.request_statuses.reorder_error": "Échec du réordonnancement des statuts.",
  "workspace_settings.request_statuses.delete_title": "Supprimer le statut",
  "workspace_settings.request_statuses.delete_description":
    "Supprimer le statut « {name} » ? Les demandes assignées devront peut-être être réassignées.",
  "workspace_settings.request_statuses.form.name_label": "Nom",
  "workspace_settings.request_statuses.form.name_placeholder": "par ex. En révision",
  "workspace_settings.request_statuses.form.group_label": "Groupe",
  "workspace_settings.request_statuses.form.color_label": "Couleur",

  // Motifs de disposition des demandes
  "workspace_settings.request_reasons.section_heading": "Motifs",
  "workspace_settings.request_reasons.count": "{count} motifs",
  "workspace_settings.request_reasons.add_value": "Ajouter un motif",
  "workspace_settings.request_reasons.add_label.declined": "Nouveau motif de refus",
  "workspace_settings.request_reasons.add_label.waitlisted": "Nouveau motif de liste d'attente",
  "workspace_settings.request_reasons.add_label.cancelled": "Nouveau motif d'annulation",
  "workspace_settings.request_reasons.add_placeholder.declined": "ex. Disponibilité budgétaire",
  "workspace_settings.request_reasons.add_placeholder.waitlisted": "ex. Contraintes de ressources",
  "workspace_settings.request_reasons.add_placeholder.cancelled": "ex. Conflit de calendrier",
  "workspace_settings.request_reasons.inactive_heading": "Retirés",
  "workspace_settings.request_reasons.drag_handle": "Réorganiser le motif",
  "workspace_settings.request_reasons.deactivate": "Retirer le motif",
  "workspace_settings.request_reasons.reactivate": "Rétablir le motif",
  "workspace_settings.request_reasons.delete": "Supprimer le motif",
  "workspace_settings.request_reasons.last_active_tooltip.declined":
    "C'est le seul motif de refus restant. Un relecteur ne peut pas refuser une demande sans motif : ajoutez-en un autre avant de retirer celui-ci.",
  "workspace_settings.request_reasons.last_active_tooltip.waitlisted":
    "C'est le seul motif de liste d'attente restant. Un relecteur ne peut pas mettre une demande en liste d'attente sans motif : ajoutez-en un autre avant de retirer celui-ci.",
  "workspace_settings.request_reasons.last_active_tooltip.cancelled":
    "C'est le seul motif d'annulation restant. Un relecteur ne peut pas annuler une demande sans motif : ajoutez-en un autre avant de retirer celui-ci.",
  "workspace_settings.request_reasons.duplicate_error.declined":
    "Un motif de refus portant ce nom existe déjà.",
  "workspace_settings.request_reasons.duplicate_error.waitlisted":
    "Un motif de liste d'attente portant ce nom existe déjà.",
  "workspace_settings.request_reasons.duplicate_error.cancelled":
    "Un motif d'annulation portant ce nom existe déjà.",
  "workspace_settings.request_reasons.save_error": "Impossible d'enregistrer cette modification.",
  "workspace_settings.request_reasons.reorder_error": "Impossible d'enregistrer le nouvel ordre.",
  "workspace_settings.request_reasons.delete_error": "Impossible de supprimer ce motif.",
  "workspace_settings.request_reasons.toast_added": "Motif ajouté",
  "workspace_settings.request_reasons.toast_renamed": "Motif renommé",
  "workspace_settings.request_reasons.toast_activated": "Motif rétabli",
  "workspace_settings.request_reasons.toast_deactivated": "Motif retiré",
  "workspace_settings.request_reasons.toast_deleted": "Motif supprimé",
  "workspace_settings.request_reasons.delete_confirm_title": "Supprimer ce motif ?",
  "workspace_settings.request_reasons.delete_confirm_body.declined":
    'Les demandes déjà refusées pour "{label}" conserveront la note du relecteur mais perdront le motif. Le retirer préserve l’historique.',
  "workspace_settings.request_reasons.delete_confirm_body.waitlisted":
    'Les demandes déjà en liste d\'attente pour "{label}" conserveront la note du relecteur mais perdront le motif. Le retirer préserve l’historique.',
  "workspace_settings.request_reasons.delete_confirm_body.cancelled":
    'Les demandes déjà annulées pour "{label}" conserveront la note du relecteur mais perdront le motif. Le retirer préserve l’historique.',
  "workspace_settings.request_reasons.delete_confirm_action": "Supprimer",

  // Project creation — template select
  "projects.estimate_summary.title": "Estimé vs réel",
  "projects.estimate_summary.actual_label": "Coût réel",
  "projects.estimate_summary.estimated_label": "Coût estimé",
  "projects.estimate_summary.variance_label": "Écart",
  "projects.estimate_summary.over_estimate": "Au-dessus de l'estimation",
  "projects.estimate_summary.under_estimate": "En dessous de l'estimation",
  "projects.estimate_summary.on_estimate": "Conforme à l'estimation",
  "projects.import.action": "Importer des projets",
  "projects.export.action": "Exporter les projets",
  "projects.import.title": "Importer des projets",
  "projects.import.loading_definition": "Chargement des champs d'importation…",
  "projects.import.toast_definition_error":
    "Impossible de charger les champs d'importation. Réessayez.",
  "projects.import.definition_error_title": "Champs d'importation indisponibles",
  "projects.import.definition_error":
    "Les champs importables n'ont pas pu être chargés, le fichier ne peut donc pas être mappé. Fermez cette boîte de dialogue et réessayez.",
  "projects.import.error_required": "{field} est requis.",
  "projects.import.error_invalid_date":
    "{field} : ''{value}'' n'est pas une date valide. Utilisez AAAA-MM-JJ, p. ex. 2026-01-15.",
  "projects.import.error_invalid_date_suggest":
    "{field} : ''{value}'' n'est pas une date valide. Utilisez AAAA-MM-JJ, p. ex. 2026-01-15. Vouliez-vous dire {suggestion} ?",
  // Indice de format affiché en regard d'une colonne de date à l'étape Associer les colonnes.
  "projects.import.map_date_hint": "Format : AAAA-MM-JJ",
  // Texte d'aide de l'étape de téléversement : la règle de date, et la mise en garde Excel.
  "projects.import.date_format_note":
    "Les dates doivent être au format AAAA-MM-JJ (p. ex. 2026-01-15).",
  "projects.import.excel_date_note":
    "L'enregistrement depuis Excel peut modifier le format des dates. Vérifiez que vos dates sont au format AAAA-MM-JJ avant de téléverser.",
  "projects.import.checking": "Vérification de votre fichier…",
  "projects.import.importing": "Importation en cours…",
  "projects.import.check_failed_title": "Impossible de vérifier ce fichier",
  "projects.import.check_failed_body":
    "Une erreur s'est produite lors de la vérification de votre fichier pour cet espace de travail. Réessayez.",
  "projects.import.check_retry": "Réessayer",
  "projects.import.toast_success":
    "{count, plural, one {# projet importé} other {# projets importés}}.",
  "projects.import.toast_commit_error":
    "Une erreur s'est produite lors de l'importation. Réessayez.",
  "projects.import.preview_title": "Aperçu de l'importation",
  "projects.import.preview_summary":
    "{valid, plural, one {# projet sera créé} other {# projets seront créés}}. {invalid, plural, one {# ligne ne peut pas être importée} other {# lignes ne peuvent pas être importées}}.",
  "projects.import.preview_count_valid":
    "{count, plural, one {# sera créé} other {# seront créés}}",
  "projects.import.preview_count_invalid":
    "{count, plural, one {# ne peut pas être importée} other {# ne peuvent pas être importées}}",
  "projects.import.preview_errors_heading": "Lignes qui ne seront pas importées",
  // États de la bannière unique de l'étape Vérifier redessinée (NG-2348).
  "projects.import.preview_title_ready": "{valid} lignes sur {total} sont prêtes à importer",
  "projects.import.preview_title_none": "Aucune des {total} lignes ne peut encore être importée",
  "projects.import.preview_summary_all": "Toutes les lignes sont prêtes à importer.",
  "projects.import.preview_summary_some":
    "{invalid, plural, one {# ligne a} other {# lignes ont}} des problèmes et seront ignorées. Corrigez-les ci-dessous, ou importez les {valid} lignes prêtes maintenant.",
  "projects.import.preview_summary_none":
    "Corrigez les problèmes ci-dessous, puis téléversez de nouveau le fichier.",
  "projects.import.preview_count_issues":
    "{count, plural, one {# a des problèmes} other {# ont des problèmes}}",
  "projects.import.issues_to_fix_heading":
    "{count, plural, one {# problème à corriger} other {# problèmes à corriger}}",
  "projects.import.issue_problem_line":
    "{message} ({count, plural, one {# ligne} other {# lignes}})",
  "projects.import.issue_unknown": "Cette ligne ne peut pas être importée.",
  "projects.import.fields_unset_heading":
    "Projets importés avec certains champs personnalisés laissés vides",
  "projects.import.unset_field_detail": "{field} : {reason}",
  "projects.import.count_created": "{count, plural, one {# créé} other {# créés}}",
  "projects.import.count_errors": "{count, plural, one {# en erreur} other {# en erreur}}",
  "projects.import.result_summary":
    "{created, plural, one {# projet créé} other {# projets créés}}. {errors, plural, one {# ligne en erreur} other {# lignes en erreur}}.",
  "projects.import.download_failed": "Télécharger les lignes en erreur",
  "projects.import.failed_reason_header": "Erreur d'importation",
  "projects.import.example_name": "Refonte de l'intégration",
  "projects.import.example_start_date": "2026-01-15",
  "projects.import.example_description":
    "Moderniser le parcours d'intégration des nouveaux employés.",
  "projects.import.example_due_date": "2026-03-31",
  "projects.import.example_launch_date": "2026-04-15",
  "projects.import.warn_unknown_option": "{field} : « {value} » n’est pas une option connue.",
  "projects.import.warn_ambiguous_option":
    "{field} : « {value} » correspond à plusieurs options ; associez-la à celle voulue.",
  "projects.import.error_date_order": "{field} ne peut pas être antérieure à la date de début.",
  "projects.import.field_due_date": "Date d’échéance",
  "projects.import.field_launch_date": "Date de lancement",
  // Assistant d'importation CSV/XLSX des éléments de travail (NG-3504) — reprend
  // projects.import.* sans le niveau « champs personnalisés laissés vides » (hors
  // périmètre), avec des puces de totaux par type.
  "work_items.import.title": "Importer des éléments de travail",
  "work_items.import.loading_definition": "Chargement des champs d'importation…",
  "work_items.import.toast_definition_error":
    "Impossible de charger les champs d'importation. Réessayez.",
  "work_items.import.definition_error_title": "Champs d'importation indisponibles",
  "work_items.import.definition_error":
    "Les champs importables n'ont pas pu être chargés, aucun fichier ne peut donc être associé. Fermez cette fenêtre et réessayez.",
  "work_items.import.error_required": "{field} est obligatoire.",
  "work_items.import.warn_unknown_option": "{field} : « {value} » n’est pas une option connue.",
  "work_items.import.warn_ambiguous_option":
    "{field} : « {value} » correspond à plusieurs options ; associez-la à celle voulue.",
  "work_items.import.checking": "Vérification de votre fichier…",
  "work_items.import.importing": "Importation…",
  "work_items.import.check_failed_title": "Impossible de vérifier ce fichier",
  "work_items.import.check_failed_body":
    "Un problème est survenu lors de la vérification de votre fichier dans cet espace de travail. Réessayez.",
  "work_items.import.check_retry": "Réessayer",
  "work_items.import.toast_success":
    "{count, plural, one {# élément de travail importé} other {# éléments de travail importés}}.",
  "work_items.import.toast_commit_error":
    "Un problème est survenu lors de l'importation de votre fichier. Réessayez.",
  "work_items.import.preview_title_ready": "{valid} lignes sur {total} sont prêtes à importer",
  "work_items.import.preview_title_none": "Aucune des {total} lignes ne peut encore être importée",
  "work_items.import.preview_summary_all": "Toutes les lignes sont prêtes à importer.",
  "work_items.import.preview_summary_some":
    "{invalid, plural, one {# ligne a} other {# lignes ont}} des problèmes et seront ignorées. Corrigez-les ci-dessous, ou importez les {valid} lignes prêtes maintenant.",
  "work_items.import.preview_summary_none":
    "Corrigez les problèmes ci-dessous, puis téléversez de nouveau le fichier.",
  "work_items.import.preview_count_valid":
    "{count, plural, one {# sera créé} other {# seront créés}}",
  "work_items.import.preview_count_issues":
    "{count, plural, one {# a des problèmes} other {# ont des problèmes}}",
  "work_items.import.count_type_task": "{count, plural, one {# tâche} other {# tâches}}",
  "work_items.import.count_type_event": "{count, plural, one {# événement} other {# événements}}",
  "work_items.import.count_type_milestone": "{count, plural, one {# jalon} other {# jalons}}",
  "work_items.import.issues_to_fix_heading":
    "{count, plural, one {# problème à corriger} other {# problèmes à corriger}}",
  "work_items.import.issue_problem_line":
    "{message} ({count, plural, one {# ligne} other {# lignes}})",
  "work_items.import.issue_unknown": "Cette ligne ne peut pas être importée.",
  "work_items.import.count_created": "{count, plural, one {# créé} other {# créés}}",
  "work_items.import.count_errors": "{count, plural, one {# en erreur} other {# en erreur}}",
  "work_items.import.result_summary":
    "{created, plural, one {# élément de travail créé} other {# éléments de travail créés}}. {errors, plural, one {# ligne en erreur} other {# lignes en erreur}}.",
  "work_items.import.download_failed": "Télécharger les lignes en erreur",
  "work_items.import.failed_reason_header": "Erreur d'importation",
  "projects.layout_paging.loading": "Chargement des projets… {loaded} sur {total}",
  "projects.layout_paging.showing": "{loaded} projets affichés sur {total}",
  "projects.layout_paging.capped_description":
    "Affinez la liste avec la recherche ou les filtres, ou chargez le lot suivant.",
  "projects.layout_paging.failed_title": "Impossible de charger tous les projets",
  "projects.cost.title": "Coût",
  "projects.cost.estimated_label": "Estimé",
  "projects.cost.actual_label": "Réel",
  "projects.cost.variance_over": "{amount} au-dessus de l'estimation",
  "projects.cost.variance_under": "{amount} en dessous de l'estimation",
  "projects.cost.variance_on": "Conforme à l'estimation",
  "projects.cost.by_task": "Par tâche",
  "projects.cost.by_person": "Par personne",
  "projects.cost.task_col": "Tâche",
  "projects.cost.person_col": "Personne",
  "projects.cost.hours_col": "Heures",
  "projects.cost.no_tasks": "Aucune tâche avec un coût pour le moment.",
  "projects.cost.no_people": "Aucun temps enregistré pour le moment.",
  "projects.cost.untitled": "Sans titre",
  "projects.cost.load_error": "Indisponible",
  "projects.cost.hint":
    "L'estimé correspond à la portée (heures estimées × taux) ; le réel au temps enregistré × taux. Le temps des personnes sans taux est comptabilisé à 0.",
  "projects.create.template_select.placeholder": "Utiliser un modèle",
  "projects.create.template_select.none": "Aucun modèle",
  "projects.create.template_select.search": "Rechercher des modèles",
  "projects.create.template_select.clear": "Retirer le modèle",
  "projects.create.template_select.admin_add": "Ajouter un nouveau modèle",
  "projects.create.template_select.no_results": "Aucun modèle trouvé",
  "projects.create.template_label": "Modèle",
  "project_create.custom_fields.title": "Champs personnalisés",
  "project_create.custom_fields.required_error": "Ce champ est obligatoire.",

  // Common
  "common.add": "Ajouter",
  "common.cancel": "Annuler",
  "common.confirm": "Confirmer",
  "common.delete": "Supprimer",
  "common.download": "Télécharger",
  "common.not_authorized_title": "Accès restreint",
  "common.not_authorized_description":
    "Vous n'avez pas l'autorisation de voir cette page. Contactez l'administrateur de votre espace de travail pour y accéder.",
  "common.coming_soon": "Bientôt disponible",
  "common.load_more": "Charger plus",
  "common.loading": "Chargement...",
  "common.loading_more": "Chargement…",
  "common.more": "Plus",
  "common.less": "Moins",
  "comments.mention.empty": "Aucune personne correspondante",
  "comments.reply": "Répondre",
  "comments.reply_placeholder": "Répondre…",
  "comments.author_fallback": "Quelqu'un",
  "comments.link.aria": "Lien vers {url}",
  "comments.link.options": "Options du lien {url}",
  "comments.link.edit": "Modifier le lien",
  "comments.link.show_plain": "Afficher l'URL complète",
  "comments.link.remove": "Retirer le lien",
  "comments.link.url_label": "URL",
  "comments.link.url_invalid": "Saisissez un lien qui commence par http:// ou https://",
  "comments.link.copy": "Copier le lien",
  "comments.link.copied": "Lien copié",
  "comments.link.copy_error": "Impossible de copier le lien",
  "comments.link.open": "Ouvrir",
  "comments.link.preview_label": "Aperçu du lien",
  "comments.link.preview_loading": "Chargement de l'aperçu",
  "comments.link.no_preview": "Aucun aperçu disponible",
  "comments.link.no_preview_body":
    "Ce lien demande peut-être une connexion, son titre ne peut donc pas être affiché. Ouvrez-le pour le consulter.",
  "common.untitled": "Sans titre",
  "common.remove": "Retirer",
  "common.retry": "Réessayer",
  "common.save": "Enregistrer",
  "common.search": "Rechercher",
  "common.empty_placeholder": "—",
  "common.not_found": "Page introuvable",
  "common.not_found_description": "La page que vous recherchez n'existe pas.",
  "common.go_home": "Retour à l'accueil",

  // Shared — Timezone select
  "shared.timezone.placeholder": "Sélectionner un fuseau horaire",
  "shared.timezone.search_placeholder": "Rechercher par ville ou fuseau horaire...",
  "shared.timezone.no_matches": "Aucun fuseau horaire trouvé",
  "shared.timezone.more_results":
    "{count, plural, one {# autre résultat. Continuez à taper pour affiner.} other {# autres résultats. Continuez à taper pour affiner.}}",

  "shared.currency.placeholder": "Sélectionner une devise",
  "shared.currency.search_placeholder": "Rechercher par nom ou code...",
  "shared.currency.no_matches": "Aucune devise trouvée",

  // Global field picker — shared by the template form and the
  // intake form builder (NG-689).
  "shared.global_field_picker.title": "Champs globaux",
  "shared.global_field_picker.message":
    "Ces champs sont gérés de manière centralisée par votre administrateur et restent synchronisés partout où ils sont utilisés. Cochez un champ pour l'ajouter, décochez-le pour le retirer.",
  "shared.global_field_picker.search_placeholder": "Rechercher par nom ou identifiant…",
  "shared.global_field_picker.col_name": "Nom",
  "shared.global_field_picker.col_description": "Description",
  "shared.global_field_picker.col_identifier": "Identifiant",
  "shared.global_field_picker.col_type": "Type",
  "shared.global_field_picker.col_updated": "Dernière mise à jour",
  "shared.global_field_picker.cancel": "Annuler",
  "shared.global_field_picker.save": "Enregistrer",
  "shared.global_field_picker.create": "Créer un champ global",

  // Connected apps: the OAuth app detail page (NG-2581)
  "oauth_apps.detail.loading": "Chargement…",
  "oauth_apps.detail.load_error": "Échec du chargement de l'application.",
  "oauth_apps.detail.save_error": "Échec de l'enregistrement.",
  "oauth_apps.detail.delete_confirm":
    "Supprimer {name} ? Les jetons existants échoueront à l'introspection.",
  "oauth_apps.detail.back": "← Retour aux applications connectées",
  "oauth_apps.detail.owner_instance": "Propriété de l'instance (vérifiée par Cognota)",
  "oauth_apps.detail.owner_workspace": "Propriété de l'espace de travail · {workspace}",
  "oauth_apps.detail.enabled": "Activée",
  "oauth_apps.detail.disable_note":
    "La désactivation bloque l'émission de nouveaux jetons et l'introspection. Les jetons déjà émis restent valides jusqu'à leur expiration ; pour les révoquer immédiatement, l'utilisateur (ou vous, en son nom) doit révoquer chaque autorisation de consentement.",
  "oauth_apps.detail.section_basic": "Informations de base",
  "oauth_apps.detail.field_name": "Nom",
  "oauth_apps.detail.field_description": "Description",
  "oauth_apps.detail.field_homepage": "URL de la page d'accueil",
  "oauth_apps.detail.field_logo": "URL du logo",
  "oauth_apps.detail.section_credentials": "Identifiants",
  "oauth_apps.detail.field_client_id": "ID client",
  "oauth_apps.detail.field_client_type": "Type de client",
  "oauth_apps.detail.rotate_secret": "Renouveler le secret client",
  "oauth_apps.detail.public_client_note":
    "Les clients publics n'ont pas de secret. PKCE les protège au point de terminaison des jetons.",
  "oauth_apps.detail.section_redirect_uris": "URI de redirection",
  "oauth_apps.detail.section_scopes": "Portées",
  "oauth_apps.detail.scopes_note":
    "Retirer une portée ici ne restreint pas les jetons déjà émis : ils conservent les portées qui leur ont été accordées. La modification ne s'applique qu'aux futurs jetons.",
  "oauth_apps.detail.section_auto_trust": "Confiance automatique",
  "oauth_apps.detail.auto_trust_label":
    "Ignorer l'écran de consentement de l'utilisateur à la première utilisation.",
  "oauth_apps.detail.auto_trust_note":
    "À utiliser avec parcimonie : uniquement pour les applications exploitées par Cognota, lorsque la décision de consentement découle implicitement de l'adoption de l'intégration par l'utilisateur.",
  "oauth_apps.detail.section_danger": "Zone de danger",
  "oauth_apps.detail.delete_app": "Supprimer l'application",
  "oauth_apps.detail.destructive_confirm_aria": "Confirmer les portées destructrices",
  "oauth_apps.detail.destructive_confirm":
    "Je comprends que ces portées peuvent créer, modifier ou supprimer des données.",
  "oauth_apps.detail.discard": "Abandonner",
  "oauth_apps.detail.saving": "Enregistrement…",
  "oauth_apps.detail.save": "Enregistrer les modifications",

  // Onboarding
  "onboarding.title": "Intégration",
  "onboarding.complete_profile": "Complétez votre profil",
  "onboarding.display_name": "Nom d'affichage",
  "onboarding.get_started": "Commencer",
  "onboarding.create_workspace": "Créer un espace de travail",
  "onboarding.join_workspace": "Rejoindre avec une invitation",
  "onboarding.workspace_name": "Nom de l'espace de travail",
  "onboarding.workspace_slug": "URL de l'espace de travail",

  // Errors
  "error.instance_not_configured": "Instance non configurée",
  "error.instance_not_configured_desc": "Veuillez contacter votre administrateur.",
  "error.bootstrap_failed": "Une erreur est survenue lors du chargement. Veuillez réessayer.",
  "error.instance_setup_incomplete":
    "La configuration de l'instance n'est pas terminée. Contactez votre administrateur.",

  // Invitations
  "invitation.dashboard_title": "Vos invitations d'espace de travail",
  "invitation.accept_join": "Accepter et rejoindre ({count})",
  "invitation.accept_join_single": "Accepter et rejoindre",
  "invitation.accept_success": "Invitations acceptées avec succès",
  "invitation.accept_error": "Échec de l'acceptation des invitations",
  "invitation.back_to_home": "Retour à l'accueil",
  "invitation.empty_title": "Aucune invitation en attente",
  "invitation.empty_description":
    "Vous n'avez aucune invitation d'espace de travail pour le moment.",
  "invitation.error_title": "Impossible de charger vos invitations",
  "invitation.error_description":
    "Une erreur s'est produite lors du chargement de vos invitations. Cela ne signifie pas que vous n'en avez aucune — réessayez dans un instant.",
  "invitation.invited_to_join": "Vous avez été invité à rejoindre",
  "invitation.role_label": "Rôle",
  "invitation.role.admin": "Administrateur",
  "invitation.role.member": "Utilisateur standard",
  "invitation.role.guest": "Invité",
  "invitation.ignore": "Ignorer",
  "invitation.joined_success": "Vous avez rejoint l'espace de travail",
  "invitation.ignored": "Invitation ignorée",
  // Page d'atterrissage publique des invitations
  "invitation.first_name": "Prénom",
  "invitation.last_name": "Nom de famille",
  "invitation.first_name_required": "Veuillez saisir votre prénom.",
  "invitation.last_name_required": "Veuillez saisir votre nom de famille.",
  "invitation.create_account_join": "Créer un compte et rejoindre",
  "invitation.password_requirements":
    "Au moins 8 caractères. Évitez les mots de passe courants, ceux qui ont fuité lors d'une violation de données et tout ce qui ressemble à votre nom ou à votre adresse e-mail.",
  "invitation.password_too_common": "Ce mot de passe est trop courant.",
  "invitation.password_too_similar":
    "Ce mot de passe ressemble trop à votre nom ou à votre adresse e-mail.",
  "invitation.password_breached": "Ce mot de passe a fuité lors d'une violation de données.",
  "invitation.password_refused": "Ce mot de passe ne peut pas être utilisé.",
  "invitation.password_choose_another": "Choisissez-en un autre.",
  "invitation.already_have_account":
    "Vous avez déjà un compte. Connectez-vous pour rejoindre cet espace de travail.",
  "invitation.set_password_description":
    "Choisissez un mot de passe pour votre compte. Vous l'utiliserez ensuite pour vous connecter.",
  "invitation.set_password_submit": "Définir le mot de passe",
  "invitation.set_password_failed":
    "Nous n'avons pas pu définir votre mot de passe. Réessayez, ou demandez à votre administrateur de renvoyer l'invitation.",
  "invitation.log_in_to_join": "Se connecter",
  "invitation.invalid_title": "Cette invitation n'est plus valide",
  "invitation.wrong_account_title": "Vous êtes connecté avec un autre compte",
  "invitation.wrong_account_description":
    "Cette invitation est destinée à {invited}, mais vous êtes connecté en tant que {current}. Ouvrez le lien dans une fenêtre de navigation privée, ou déconnectez-vous et suivez-le à nouveau.",
  "invitation.wrong_account_sign_out": "Se déconnecter",
  "invitation.invalid_description":
    "Elle a peut-être expiré, déjà été utilisée ou été révoquée par l'administrateur de l'espace de travail. Contactez l'administrateur de votre espace de travail pour obtenir une nouvelle invitation.",
  "invitation.retry_title": "Une erreur s'est produite lors du chargement de cette invitation",
  "invitation.retry_description":
    "Le problème est peut-être temporaire — votre invitation est très probablement toujours valide. Réessayez dans un instant et contactez l'administrateur de votre espace de travail si l'erreur persiste.",
  "invitation.respond_error": "Échec de la réponse à l'invitation",
  "invitation.not_found": "Invitation introuvable",
  "invitation.already_responded": "Cette invitation a déjà reçu une réponse",
  "invitation.already_member": "Vous êtes déjà membre de cet espace de travail",

  // Project
  "project.tabs.costs": "Coûts",
  "project.tabs.resources": "Ressources",
  // Delivery et Results sont devenus des onglets de projet (NG-1557).
  "project.tabs.delivery": "Diffusion",
  "project.tabs.results": "Résultats",

  // Project tabs layout and overview route (NG-2583)
  "project.tabs.overview": "Vue d'ensemble",
  "project.tabs.work_items": "Éléments de travail",
  "project.tabs.files": "Fichiers",
  "project.tabs.aria": "Sections du projet",
  "project_overview.requests_heading": "Demandes",
  "project_overview.link_request": "Lier une demande",
  "project_overview.close_comments": "Fermer les commentaires",

  // Project › Files
  "project.files.upload": "Téléverser un fichier",
  "project.files.uploading": "Téléversement…",
  "project.files.loading": "Chargement des fichiers…",
  "project.files.load_failed": "Impossible de charger les fichiers du projet.",
  "project.files.empty_title": "Aucun fichier n’est encore joint à ce projet.",
  "project.files.empty_hint":
    "Téléversez un fichier ou convertissez une demande avec des pièces jointes pour alimenter cette liste.",
  "project.files.link": "Lien",
  "project.files.from_request": "De la demande « {label} »",
  "project.files.from_work_item": "De l’élément de travail « {label} »",
  "project.files.remove_label": "Retirer {name}",
  "project.files.uploaded_toast": "« {name} » téléversé.",
  "project.files.upload_failed_toast": "Échec du téléversement de « {name} ».",
  "project.files.removed_toast": "« {name} » retiré.",
  "project.files.remove_failed_toast": "Échec du retrait de « {name} ».",
  "project.create_title": "Nouveau projet",
  "project.no_access_title": "Aucun accès",
  "project.name_label": "Nom",
  "project.name_placeholder": "Mon projet",
  "project.identifier_label": "Identifiant",
  "project.identifier_checking": "Vérification...",
  "project.identifier_taken": "Cet identifiant est déjà utilisé",
  "project.identifier_available": "Identifiant disponible",
  "project.description_label": "Description",
  "project.description_placeholder": "De quoi traite ce projet ?",
  "project.description_save_error": "Échec de la sauvegarde de la description du projet",
  "project.process_label": "Processus",
  "project.process_none": "Aucun processus",
  "project.stage_label": "Étape",
  "project.stage_derived_hint": "Déduit de l'achèvement des tâches",
  "project.stage.pinned_aria": "Étape épinglée",
  "project.stage.pinned_hint": "Épinglée manuellement",
  "project.stage.edit_aria": "Modifier l'étape",
  "project.stage.revert_to_auto": "Revenir au mode automatique",
  "project.stage.pin_success": "Étape épinglée.",
  "project.stage.revert_success": "Étape revenue au mode automatique.",
  "project.stage.override_error": "Impossible de mettre à jour l'étape. Veuillez réessayer.",
  "project.statuses_loading": "Chargement des statuts...",
  "project.processes_loading": "Chargement des processus...",
  "project.category_label": "Catégorie",
  "project.project_type_label": "Type de projet",
  "project.project_type_placeholder": "Développement de cours, Intégration, …",
  "project.start_date_label": "Date de début",
  "project.due_date_label": "Date d'échéance",
  "project.client_teams_label": "Équipes clientes",
  "project.client_teams_placeholder": "Sélectionner les équipes clientes…",
  "project.delivery_teams_label": "Équipes de livraison",
  "project.delivery_teams_placeholder": "Sélectionner les équipes de livraison…",
  "project.delivery_teams_loading": "Chargement des équipes…",
  "project.delivery_teams_min_one": "Un projet doit être livré par au moins une équipe.",
  "project.teams_label": "Équipes",
  "project.teams_placeholder": "Sélectionner des équipes...",
  "project.current_team_not_selected_warning":
    "L'équipe actuelle n'est pas incluse dans la sélection",
  "project.no_teams": "Aucun espace d'équipe dans cet espace de travail.",
  "project.team_select_placeholder": "Sélectionner les espaces d'équipe…",
  "project.team_search_placeholder": "Rechercher des espaces d'équipe…",
  "project.programs_label": "Programmes",
  "project.programs_placeholder": "Sélectionner les programmes…",
  "project.programs_search_placeholder": "Rechercher des programmes…",
  "project.no_programs": "Aucun programme disponible",
  "project.programs_trigger_aria_label": "Sélectionner les programmes",
  "project.goals_label": "Objectifs",
  "project.goals_placeholder": "Sélectionner les objectifs…",
  "project.goals_search_placeholder": "Rechercher des objectifs…",
  "project.no_goals": "Aucun objectif disponible",
  "project.goals_trigger_aria_label": "Sélectionner les objectifs",

  // Project properties panel (NG-2583)
  "project.status_label": "Statut",
  "project.panel_start_date": "Date de début",
  "project.panel_due_date": "Date d'échéance",
  "project.panel_completion_date": "Date d'achèvement",
  "project.panel_launch_date": "Date de lancement",
  "project.processes_search_placeholder": "Rechercher des processus...",
  "project.no_processes": "Aucun processus disponible",
  "project.change_process_title": "Changer de processus ?",
  "project.change_process_description":
    "Changer de processus efface l'étape assignée à chaque élément de travail de ce projet. Les éléments de travail conservent leurs autres champs.",
  "project.change_process_confirm": "Changer de processus",
  "project.panel_programs_search_placeholder": "Rechercher des programmes...",
  "project.program_remove_aria": "Retirer de {name}",
  "project.program_added": "Projet ajouté au programme",
  "project.program_add_error": "Impossible d'ajouter le projet au programme",
  "project.program_removed": "Projet retiré du programme",
  "project.program_remove_error": "Impossible de retirer le projet du programme",
  "project.custom_fields_search_placeholder": "Rechercher des champs...",
  "project.no_custom_fields_available": "Aucun champ disponible",
  "project.custom_fields_empty": "Aucun champ global pour le moment.",
  "project.custom_field_remove_aria": "Retirer {name}",
  "project.field_edit_aria": "Modifier {name} : {value}",
  "project.custom_field_remove_title": "Retirer « {name} » ?",
  "project.custom_field_remove_body":
    "Le champ sera retiré de ce projet. Les valeurs enregistrées seront perdues.",
  "project.custom_field_save_error": "Impossible d'enregistrer le champ personnalisé",
  "project.custom_field_add_error": "Impossible d'ajouter le champ personnalisé",
  "project.custom_field_remove_error": "Impossible de retirer le champ personnalisé",

  "project.visibility_label": "Visibilité",
  "project.visibility.workspace": "Espace de travail",
  "project.visibility.team_restricted": "Réservé aux équipes",
  "project.restrict_warning_title": "Réserver ce projet à ses équipes ?",
  "project.restrict_warning_all": "{names} perdra l'accès à ce projet.",
  "project.restrict_warning_some": "{names} et {count} autres perdront l'accès à ce projet.",
  "project.restrict_warning_generic":
    "Les membres qui ne sont pas liés à ce projet en perdront l'accès.",
  "project.restrict_warning_confirm": "Restreindre",
  "project.lead_label": "Responsables du projet",
  "project.select_lead": "Sélectionner des responsables...",
  "project.no_lead": "Aucun responsable",
  "project.member_select.clear": "Effacer",
  "project.leads_selected_count": "{count} responsables sélectionnés",
  "project.lead_not_connected_warning":
    "Un responsable n'est pas rattaché à ce projet : {names}. Il reste responsable jusqu'à ce que quelqu'un le change.",
  "project.lead_not_in_team_warning":
    "Un responsable sélectionné n'est pas membre de l'équipe actuelle",
  "project.create_project": "Créer le projet",
  "project.create": "Créer",
  "project.create_and_open": "Créer et ouvrir",
  "project.create_success": "Projet créé avec succès",
  "project.create_error": "Échec de la création du projet",
  "project.linked_requests.link_error": "Échec de la liaison de la demande",

  // Project overview cards and dialogs (NG-2583)
  "project.team_required": "Choisissez au moins une équipe.",
  "project.name_required": "Saisissez un nom pour le projet.",
  "project.leads_required": "Choisissez au moins un responsable du projet.",
  "project.start_date_required": "Choisissez une date de début.",
  "project.category_required": "Choisissez une catégorie.",
  "project.template_required": "Choisissez un modèle.",
  "team_projects.layout_aria": "Disposition des projets",
  "project_overview.activity_archived_sub_items":
    "{count, plural, one {Sa sous-tâche a été archivée avec lui.} other {Ses # sous-tâches ont été archivées avec lui.}}",
  "project_overview.activity_no_match": "Aucune activité correspondante.",
  "project.linked_requests.dialog_title": "Lier une demande",
  "project.linked_requests.search_placeholder": "Rechercher des demandes…",
  "project.linked_requests.loading": "Chargement des demandes…",
  "project.linked_requests.no_match": "Aucune demande ne correspond à votre recherche.",
  "project.linked_requests.none_available": "Aucune demande disponible à lier.",
  "project.linked_requests.fallback_name": "Demande",
  "project.linked_requests.origin": "Origine",
  "project.linked_requests.origin_title": "Ce projet a été créé à partir de cette demande",
  "project.linked_requests.unlink_aria": "Dissocier la demande",
  "project.linked_requests.empty": "Aucune demande liée pour le moment.",

  "project.page_title": "Projets",
  "project.create_new": "Nouveau projet",
  "project.search_placeholder": "Rechercher des projets...",
  "team_projects.summary": "{count} projets · {in_progress} en cours",
  "team_projects.view.no_status": "Sans statut",
  "team_projects.board.collapse_column": "Réduire {name}",
  "team_projects.board.expand_column": "Développer {name}",
  "board.viewing_prefix": "Affichage :",
  "team_projects.board.no_process": "Sans processus",
  "team_projects.board.no_process_selected": "Choisissez un processus pour voir ses étapes.",
  "team_projects.board.no_processes_hint": "Ajoutez un processus dans Paramètres › Processus",
  "team_projects.board.other_processes": "{count} masqué(s) sur d'autres processus",
  "team_projects.board.move_failed": "Échec du déplacement",
  "team_projects.view.column_empty": "Aucun projet",
  "team_projects.view.calendar_empty": "Aucun projet planifié ce mois-ci",
  "team_projects.view.calendar_more": "+{count} de plus",
  "team_projects.group_by.none": "Aucun regroupement",
  "team_projects.group_by.status": "Statut",
  "team_projects.group_by.category": "Catégorie",
  "team_projects.group_by.lead": "Responsable",
  "team_projects.group_by.delivery_teams": "Équipes",
  "team_projects.group_by.programs": "Programme",
  "team_projects.group_by.none_status": "Sans statut",
  "team_projects.group_by.none_category": "Sans catégorie",
  "team_projects.group_by.none_lead": "Sans responsable",
  "team_projects.group_by.none_team": "Sans équipe",
  "team_projects.group_by.none_program": "Sans programme",
  "team_projects.view.timeline_empty": "Aucun projet à afficher",
  "team_projects.view.no_dates": "Aucune date",
  "programs.view.timeline_empty": "Aucun programme à afficher",
  "programs.view.no_dates": "Aucune date",
  "programs.view.board_column_empty": "Aucun programme",
  "programs.toast.archive_failed": "Impossible d'archiver {name}",
  "programs.toast.delete_failed": "Impossible de supprimer {name}",
  // Programs list table: columns, cells and row actions (NG-2579)
  "programs.status.planning": "Planification",
  "programs.status.active": "Actif",
  "programs.status.on_hold": "En pause",
  "programs.status.complete": "Terminé",
  "programs.columns.select_all": "Sélectionner tous les programmes",
  "programs.columns.select_one": "Sélectionner {name}",
  "programs.columns.name": "Nom",
  "programs.columns.status": "Statut",
  "programs.columns.owner": "Propriétaire",
  "programs.columns.progress": "Progression",
  "programs.columns.health": "Santé",
  "programs.columns.effort": "Effort",
  "programs.columns.start_date": "Date de début",
  "programs.columns.end_date": "Date de fin",
  "programs.columns.created": "Créé",
  "programs.columns.goals": "Objectifs",
  "programs.columns.home_team": "Équipe principale",
  "programs.columns.delivery_teams": "Équipes de livraison",
  "programs.columns.actions": "Actions",
  "programs.columns.archived_badge": "Archivé",
  "programs.columns.name_aria": "Nom du programme",
  "programs.columns.rename": "Renommer le programme",
  "programs.columns.status_aria": "Statut : {status}",
  "programs.columns.status_search": "Rechercher des statuts",
  "programs.columns.status_empty": "Aucun statut",
  "programs.columns.owner_aria": "Propriétaire : {owner}",
  "programs.columns.owner_aria_none": "Propriétaire : aucun",
  "programs.columns.owner_search": "Rechercher des membres",
  "programs.columns.owner_empty": "Aucun membre",
  "programs.columns.owner_unset": "Aucun propriétaire",
  "programs.columns.start_date_aria": "Date de début : {date}",
  "programs.columns.end_date_aria": "Date de fin : {date}",
  "programs.columns.clear_date": "Effacer la date",
  "programs.columns.effort_estimated": "/ {hours} h est.",
  "programs.columns.options_aria": "Options du programme",
  "programs.columns.edit": "Modifier",
  "programs.columns.archive": "Archiver",
  "programs.columns.unarchive": "Restaurer",
  "team_projects.view.day": "Jour",
  "team_projects.view.week": "Semaine",
  "team_projects.view.month": "Mois",
  "team_projects.view.prev_period": "Période précédente",
  "team_projects.view.next_period": "Période suivante",
  "team_projects.select_all": "Sélectionner tous les projets",
  "team_projects.select_project": "Sélectionner {name}",
  "data_table.cell.unassigned": "Non assigné",
  "data_table.cell.no_tasks": "Aucune tâche",
  "data_table.cell.overdue": "Date cible dépassée",
  "data_table.cell.set_date": "Définir une date",
  "data_table.cell.clear_date": "Effacer la date",
  "overdue.label": "En retard",
  "overdue.days_late": "{count, plural, one {# jour de retard} other {# jours de retard}}",
  "overdue.aria":
    "{count, plural, =0 {Date cible dépassée} one {Date cible dépassée, # jour de retard} other {Date cible dépassée, # jours de retard}}",
  "overdue.filter": "En retard uniquement",
  "overdue.filter_group": "Échéance",
  "programs.export.label": "Exporter les programmes",
  // Programs list page and its create / edit dialog (NG-2578)
  "programs.list.title": "Programmes",
  "programs.list.new_program": "Nouveau programme",
  "programs.list.export": "Exporter",
  "programs.list.export_preparing": "Préparation de votre export…",
  "programs.list.export_failed": "Échec de l'export",
  "programs.list.empty": "Aucun programme pour l'instant. Créez votre premier programme.",
  "programs.list.search": "Rechercher des programmes",
  "programs.list.layout_aria": "Disposition des programmes",
  "programs.list.layout_table": "Table",
  "programs.list.layout_board": "Tableau",
  "programs.list.layout_timeline": "Chronologie",
  "programs.list.display": "Affichage",
  "programs.list.group": "Regrouper",
  "programs.list.group_none": "Aucun regroupement",
  "programs.list.group_status": "Statut",
  "programs.list.show_archived": "Afficher les archivés",
  "programs.list.table_options": "Options du tableau",
  "programs.list.updated": "Programme mis à jour",
  "programs.list.update_error": "Échec de la mise à jour du programme",
  "programs.list.archive_title": "Archiver le programme",
  "programs.list.archive_description":
    "Archiver « {name} » ? Les programmes archivés n'apparaîtront plus dans les listes mais resteront disponibles pour les rapports.",
  "programs.list.archive_confirm": "Archiver",
  "programs.list.archived": "Programme archivé",
  "programs.list.unarchived": "Programme restauré",
  "programs.list.unarchive_error": "Échec de la restauration du programme",
  "programs.dialog.edit_title": "Modifier le programme",
  "programs.dialog.new_title": "Nouveau programme",
  "programs.dialog.name_label": "Nom *",
  "programs.dialog.name_placeholder": "Nom du programme",
  "programs.dialog.description_label": "Description",
  "programs.dialog.description_placeholder": "Description facultative",
  "programs.dialog.owner_label": "Propriétaire",
  "programs.dialog.owner_placeholder": "Aucun propriétaire",
  "programs.dialog.owner_empty": "Aucun membre trouvé",
  "programs.dialog.owner_select_team_first": "Sélectionnez d'abord une équipe de livraison.",
  "programs.dialog.owner_not_on_teams":
    "Le propriétaire doit faire partie de l'une des équipes de livraison sélectionnées. Choisissez un nouveau propriétaire.",
  "programs.dialog.status_label": "Statut",
  "programs.dialog.start_date_label": "Date de début",
  "programs.dialog.end_date_label": "Date de fin",
  "programs.end_before_start":
    "La date de fin doit être identique ou postérieure à la date de début.",
  "programs.dialog.delivery_teams_label": "Équipes de livraison *",
  "programs.dialog.teams_placeholder": "Sélectionner des équipes",
  "programs.dialog.teams_empty": "Aucune équipe disponible",
  "programs.dialog.delivery_teams_help":
    "Choisissez les équipes qui réalisent ce programme. Les membres de ces équipes et des équipes au-dessus d'elles peuvent le voir, tout comme son responsable de programme, ses membres directs et les administrateurs. Vous ne pouvez choisir que les équipes auxquelles vous avez accès.",
  "programs.dialog.team_access_required": "Choisissez au moins une équipe.",
  "programs.dialog.name_required": "Saisissez un nom pour le programme.",
  "programs.dialog.create": "Créer",
  "programs.dialog.created": "Programme créé",
  "programs.dialog.updated": "Programme mis à jour",
  "programs.dialog.create_error": "Échec de la création du programme",
  "programs.dialog.update_error": "Échec de la mise à jour du programme",
  "data_table.import.label": "Importer",
  "data_table.export.label": "Exporter",
  "data_table.export.preparing": "Préparation de votre export…",
  "data_table.export.ready": "Votre export est prêt — le téléchargement va commencer.",
  "data_table.export.failed": "Échec de l’export. Veuillez réessayer.",
  "data_table.filter.clear": "Effacer",
  "data_table.filter.contains": "Contient le texte…",
  "data_table.filter.search_options": "Rechercher des options",
  "data_table.filter.no_options": "Aucune option",
  "data_table.filter.loading_options": "Chargement des options…",
  "data_table.filter.min": "Min",
  "data_table.filter.max": "Max",
  "data_table.filter.from": "Du",
  "data_table.filter.to": "Au",
  "data_table.filter.column_aria": "Filtrer {column}",
  "data_table.date.type_a_date": "Saisir une date",
  "data_table.date.type_a_date_placeholder": "AAAA-MM-JJ",
  "data_table.columns.label": "Colonnes",
  "data_table.columns.toggle_aria": "Afficher ou masquer les colonnes",
  "data_table.columns.heading": "Colonnes visibles",
  "data_table.columns.show_all": "Tout afficher",
  "data_table.columns.reorder_aria": "Réordonner {column} (position {position} sur {total})",
  "data_table.columns.reorder_hint":
    "Glissez pour réordonner, ou placez le focus sur une poignée et utilisez les flèches.",
  "data_table.columns.reordered": "{column} déplacée à la position {position} sur {total}.",
  "data_table.columns.pinned_section": "Épinglé à gauche",
  "data_table.columns.scroll_section": "Défilement",
  "data_table.columns.pinned_hint": "Reste visible pendant le défilement.",
  "data_table.columns.scroll_hint": "Défile horizontalement avec le tableau.",
  "data_table.columns.visible_count": "{visible} sur {total} visibles",
  "data_table.columns.reset_default": "Réinitialiser",
  "data_table.toolbar.clear_selection": "Effacer la sélection",
  "data_table.toolbar.active_filters": "Filtres actifs",
  "data_table.state.no_results_title": "Aucun résultat correspondant",
  "data_table.state.no_results_description": "Aucune ligne ne correspond à vos filtres actuels.",
  "data_table.state.clear_filters": "Effacer les filtres",

  // Data table, progress bar and placeholder copy (NG-2585)
  "data_table.row.collapse": "Réduire la ligne",
  "data_table.row.expand": "Développer la ligne",
  "data_table.group.collapse": "Réduire le groupe",
  "data_table.group.expand": "Développer le groupe",
  "data_table.columns.resize_aria": "Redimensionner {column}",
  "data_table.columns.drag_to_reorder": "Faire glisser pour réorganiser",
  "data_table.filter_chip.clear_one": "Effacer le filtre sur {label}",
  "data_table.filter_chip.clear_all": "Effacer tous les filtres",
  "common.loading_aria": "Chargement",

  "data_table.state.load_failed_title": "Impossible de charger cette liste",
  "data_table.state.try_again": "Réessayer",
  "data_table.state.load_more_failed": "Impossible de charger davantage.",
  "data_table.state.retry": "Réessayer",
  "data_table.footer.showing": "Affichage de {loaded} sur {total}",
  "data_table.footer.loading_more": "Chargement…",
  "data_table.pagination.showing_range": "Affichage de {from} à {to} sur {total}",
  "data_table.pagination.previous": "Précédent",
  "data_table.pagination.next": "Suivant",
  "data_table.toolbar.selected_count":
    "{count, plural, one {# sélectionné} other {# sélectionnés}}",
  "data_table.toolbar.selection_region": "Lignes sélectionnées",
  "data_table.bulk.delete": "Supprimer",
  "data_table.bulk.delete_confirm_title":
    "{count, plural, one {Supprimer # élément ?} other {Supprimer # éléments ?}}",
  "data_table.bulk.delete_confirm_body":
    "{count, plural, one {L’élément sélectionné sera supprimé.} other {Les # éléments sélectionnés seront supprimés.}}",
  "data_table.bulk.delete_confirm_body_with_sub_items":
    "{count, plural, one {L’élément sélectionné et {subItems, plural, one {sa # sous-tâche} other {ses # sous-tâches}} seront supprimés.} other {Les # éléments sélectionnés et {subItems, plural, one {leur # sous-tâche} other {leurs # sous-tâches}} seront supprimés.}}",
  "data_table.bulk.delete_confirm_body_sub_items_unknown":
    "{count, plural, one {L’élément sélectionné et ses éventuelles sous-tâches seront supprimés.} other {Les # éléments sélectionnés et leurs éventuelles sous-tâches seront supprimés.}}",
  "data_table.bulk.delete_failed":
    "Impossible de supprimer les éléments sélectionnés. Vous n’avez peut-être pas l’autorisation d’en supprimer certains.",
  "data_table.bulk.deleted":
    "{count, plural, one {# élément supprimé.} other {# éléments supprimés.}}",
  "data_table.bulk.deleted_none":
    "{count, plural, one {Impossible de supprimer l’élément sélectionné.} other {Impossible de supprimer les # éléments sélectionnés.}}",
  "data_table.bulk.deleted_with_skipped":
    "{deleted} supprimé(s) ; {skipped} ignoré(s), faute d’autorisation.",
  "data_table.bulk.deleting": "Suppression…",
  "data_table.bulk.deleting_progress": "Suppression… {processed} sur {total}",
  "data_table.bulk.deleted_then_cancelled":
    "{count, plural, one {Annulé après la suppression de # élément.} other {Annulé après la suppression de # éléments.}}",
  "data_table.bulk.select_all_matching": "Tout sélectionner ({count})",
  "data_table.bulk.cancel": "Annuler",
  "data_table.bulk.cancelling": "Annulation…",
  "data_table.bulk.cancel_delete_note": "Les éléments déjà supprimés ne seront pas restaurés.",
  "data_table.bulk.cancel_archive_note": "Les éléments déjà archivés restent archivés.",
  "data_table.bulk.cancel_status_note":
    "Les éléments déjà mis à jour conservent leur nouveau statut.",
  "data_table.bulk.cancel_assignees_note":
    "Les modifications d’assignés déjà appliquées restent appliquées.",
  "data_table.bulk.eta_seconds":
    "{seconds, plural, one {~# seconde restante} other {~# secondes restantes}}",
  "data_table.bulk.set_status": "Définir le statut",
  "data_table.bulk.assign_leads": "Attribuer des responsables",
  "data_table.bulk.archive": "Archiver",
  "data_table.bulk.edit_blocked_all": "Vous ne pouvez pas modifier les éléments sélectionnés.",
  "data_table.bulk.edit_blocked_some":
    "{count, plural, one {Vous ne pouvez pas modifier # des éléments sélectionnés. Désélectionnez-le pour modifier les autres.} other {Vous ne pouvez pas modifier # des éléments sélectionnés. Désélectionnez-les pour modifier les autres.}}",
  "data_table.bulk.archive_confirm_title":
    "{count, plural, one {Archiver # élément ?} other {Archiver # éléments ?}}",
  "data_table.bulk.archive_confirm_body":
    "{count, plural, one {L’élément sélectionné quittera la liste active. Vous pourrez le restaurer depuis la vue archivée.} other {Les # éléments sélectionnés quitteront la liste active. Vous pourrez les restaurer depuis la vue archivée.}}",
  "data_table.bulk.archive_failed":
    "Impossible d’archiver les éléments sélectionnés. Vous n’avez peut-être pas l’autorisation d’en archiver certains.",
  "data_table.bulk.archived":
    "{count, plural, one {# élément archivé.} other {# éléments archivés.}}",
  "data_table.bulk.archived_with_skipped":
    "{archived} archivé(s) ; {skipped} ignoré(s), faute d’autorisation.",
  "data_table.bulk.archived_none":
    "{count, plural, one {Impossible d’archiver l’élément sélectionné.} other {Impossible d’archiver les # éléments sélectionnés.}}",
  "data_table.bulk.archiving": "Archivage…",
  "data_table.bulk.archiving_progress": "Archivage… {processed} sur {total}",
  "data_table.bulk.archived_then_cancelled":
    "{count, plural, one {Annulé après l’archivage de # élément.} other {Annulé après l’archivage de # éléments.}}",
  "data_table.bulk.status_updated":
    "{count, plural, one {Statut de # élément mis à jour.} other {Statut de # éléments mis à jour.}}",
  "data_table.bulk.status_updated_none":
    "{count, plural, one {Impossible de mettre à jour l’élément sélectionné.} other {Impossible de mettre à jour les # éléments sélectionnés.}}",
  "data_table.bulk.status_updated_with_skipped":
    "{updated} mis à jour ; {skipped} ignoré(s), faute d’autorisation.",
  "data_table.bulk.status_update_failed":
    "Impossible de mettre à jour le statut des éléments sélectionnés. Vous n’avez peut-être pas l’autorisation d’en modifier certains.",
  "data_table.bulk.setting_status": "Mise à jour du statut…",
  "data_table.bulk.setting_status_progress": "Mise à jour du statut… {processed} sur {total}",
  "data_table.bulk.status_updated_then_cancelled":
    "{count, plural, one {Annulé après la mise à jour de # élément.} other {Annulé après la mise à jour de # éléments.}}",
  "data_table.bulk.set_assignees": "Assignés",
  "data_table.bulk.assignees_capacity_loading": "Vérification des disponibilités…",
  "data_table.bulk.assignees_updated":
    "{count, plural, one {Assignés mis à jour sur # élément.} other {Assignés mis à jour sur # éléments.}}",
  "data_table.bulk.assignees_updated_none":
    "{count, plural, one {Impossible de mettre à jour l’élément sélectionné.} other {Impossible de mettre à jour les # éléments sélectionnés.}}",
  "data_table.bulk.assignees_updated_with_skipped":
    "{updated} mis à jour ; {skipped} ignoré(s), faute d’autorisation.",
  "data_table.bulk.assignees_update_failed":
    "Impossible de mettre à jour les assignés des éléments sélectionnés. Vous n’avez peut-être pas l’autorisation d’en modifier certains.",
  "data_table.bulk.setting_assignees": "Mise à jour des assignés…",
  "data_table.bulk.setting_assignees_progress": "Mise à jour des assignés… {processed} sur {total}",
  "data_table.bulk.assignees_updated_then_cancelled":
    "{count, plural, one {Annulé après la mise à jour de # élément.} other {Annulé après la mise à jour de # éléments.}}",
  "data_table.bulk.set_stage": "Définir l’étape",
  "data_table.bulk.no_stage": "Aucune étape",
  "data_table.bulk.stage_search_placeholder": "Rechercher des étapes…",
  "data_table.bulk.stage_search_empty": "Aucune étape trouvée",
  "data_table.bulk.stage_updated":
    "{count, plural, one {Étape de # élément mise à jour.} other {Étape de # éléments mise à jour.}}",
  "data_table.bulk.stage_updated_none":
    "{count, plural, one {Impossible de mettre à jour l’élément sélectionné.} other {Impossible de mettre à jour les # éléments sélectionnés.}}",
  "data_table.bulk.stage_updated_with_skipped":
    "{updated} mis à jour ; {skipped} ignoré(s), car impossibles à modifier.",
  "data_table.bulk.stage_update_failed":
    "Impossible de mettre à jour l’étape des éléments sélectionnés. Vous n’avez peut-être pas l’autorisation d’en modifier certains.",
  "data_table.bulk.setting_stage": "Mise à jour de l’étape…",
  "data_table.bulk.setting_stage_progress": "Mise à jour de l’étape… {processed} sur {total}",
  "data_table.bulk.cancel_stage_note":
    "Les éléments déjà mis à jour conservent leur nouvelle étape.",
  "data_table.bulk.stage_updated_then_cancelled":
    "{count, plural, one {Annulé après la mise à jour de # élément.} other {Annulé après la mise à jour de # éléments.}}",
  "data_table.bulk.add_qualifications": "Ajouter des qualifications",
  "data_table.bulk.add_qualifications_apply": "Ajouter",
  "data_table.bulk.qualifications_loading": "Chargement des qualifications…",
  "data_table.bulk.qualifications_added":
    "{count, plural, one {Qualifications ajoutées à # élément.} other {Qualifications ajoutées à # éléments.}}",
  "data_table.bulk.qualifications_added_none":
    "{count, plural, one {Impossible de mettre à jour l’élément sélectionné.} other {Impossible de mettre à jour les # éléments sélectionnés.}}",
  "data_table.bulk.qualifications_added_with_skipped":
    "{updated} mis à jour ; {skipped} ignoré(s), car impossibles à modifier.",
  "data_table.bulk.qualifications_add_failed":
    "Impossible d’ajouter des qualifications aux éléments sélectionnés. Vous n’avez peut-être pas l’autorisation d’en modifier certains.",
  "data_table.bulk.adding_qualifications": "Ajout des qualifications…",
  "data_table.bulk.adding_qualifications_progress":
    "Ajout des qualifications… {processed} sur {total}",
  "data_table.bulk.cancel_qualifications_note":
    "Les éléments déjà mis à jour conservent les qualifications ajoutées.",
  "data_table.bulk.qualifications_added_then_cancelled":
    "{count, plural, one {Annulé après la mise à jour de # élément.} other {Annulé après la mise à jour de # éléments.}}",
  "data_table.bulk.export": "Exporter",
  "data_table.bulk.exportComingSoon": "L’export CSV arrive bientôt.",
  "data_table.search.clear": "Effacer la recherche",
  "data_table.search.count_results": "{count, plural, one {# résultat} other {# résultats}}",
  "data_view.previous": "Précédent",
  "data_view.next": "Suivant",
  "data_view.today": "Aujourd’hui",
  "data_view.show_archived": "Afficher les archivés",
  "data_view.view_weekends": "Afficher les week-ends",
  "data_view.hours": "Heures",
  "data_view.hours_from": "Première heure affichée",
  "data_view.hours_to": "Dernière heure affichée",
  "data_view.hide_archived": "Masquer les archivés",
  "data_view.filter": "Filtrer",
  "data_view.filter_ellipsis": "Filtrer…",
  "data_view.search_options": "Rechercher des options",
  "data_view.sort_by": "Trier",
  "data_view.display": "Affichage",
  "data_view.filters_applied": "{count} filtres appliqués",
  "data_view.clear_all": "Tout effacer",
  "data_view.operator.is": "est",
  "data_view.operator.before": "avant",
  "data_view.operator.after": "après",
  "data_view.operator.between": "entre",
  "data_view.pick_a_date": "Choisir une date",
  "data_view.start_date": "Date de début",
  "data_view.end_date": "Date de fin",
  "data_view.to": "à",
  "data_view.overdue": "En retard",
  "data_view.over_capacity": "Surcapacité",
  "data_view.overdue_yes": "oui",
  "issue.overdue_filter.apply": "Afficher uniquement le travail en retard",
  "issue.allocation_filter.apply":
    "Afficher uniquement les {count} éléments dont la personne assignée est en surcapacité",
  "issue.allocation_filter.clear": "Ne plus filtrer par surcapacité",
  "issue.overdue_filter.clear": "Ne plus filtrer par retard",
  "data_view.operator.is_any_of": "est l'un de",
  "data_view.remove_filter": "Retirer le filtre {field}",
  "data_view.reset": "Réinitialiser",
  "data_view.sort_ascending": "Trier par ordre croissant",
  "data_view.sort_descending": "Trier par ordre décroissant",
  "data_view.group_by": "Grouper",
  "data_view.color_code": "Code couleur",
  "data_view.color_code.status": "Par statut",
  "data_view.color_code.custom": "Personnalisé",
  "data_view.clear_filters": "Effacer les filtres",
  "data_view.loading_filters": "Chargement des filtres…",
  "data_view.filter_search_placeholder": "Rechercher des filtres...",
  "data_view.no_matches": "Aucun résultat.",
  "team_projects.count_noun": "{count, plural, one {projet} other {projets}}",
  "team_projects.no_matches": "Aucun projet ne correspond aux filtres.",
  "team_projects.column.check": "",
  "team_projects.column.name": "Nom",
  "team_projects.column.identifier": "ID du projet",
  "team_projects.column.status": "Statut",
  "team_projects.column.stage": "Étape",
  "team_projects.column.process": "Processus",
  "team_projects.column.category": "Catégorie",
  "team_projects.column.lead": "Responsable",
  "team_projects.column.progress": "Progression",
  "team_projects.column.deliveryTeams": "Équipes de livraison",
  "team_projects.column.homeTeam": "Équipe principale",
  "team_projects.column.clientTeams": "Équipes client",
  "team_projects.column.openTasks": "Tâches ouvertes",
  "team_projects.column.startDate": "Début",
  "team_projects.column.targetCompletion": "Cible (fin)",
  "team_projects.column.actualCompletion": "Fin réelle",
  "team_projects.column.targetLaunch": "Cible (lancement)",
  "team_projects.column.programs": "Programmes",
  "team_projects.column.goals": "Objectifs",
  "team_projects.column.sourceTemplate": "Modèle",
  "team_projects.column.lastActivity": "Dernière activité",
  "team_projects.column.actions": "",
  "team_projects.filter.search_placeholder": "Rechercher projets, responsables, identifiants…",
  "team_projects.filter.clear_all": "Effacer les filtres",
  "team_projects.actions.menu": "Actions pour {name}",
  "team_projects.actions.archive": "Archiver",
  "team_projects.actions.restore": "Restaurer",
  "team_projects.actions.duplicate": "Dupliquer",
  "team_projects.actions.delete": "Supprimer",
  "team_projects.confirm.archive_title": "Archiver le projet ?",
  "team_projects.confirm.archive_description":
    "Archiver {name} ? Vous pourrez le restaurer plus tard.",
  "team_projects.confirm.restore_title": "Restaurer le projet ?",
  "team_projects.confirm.restore_description": "Restaurer {name} parmi les projets actifs ?",
  "team_projects.confirm.archive_impact":
    "{count, plural, one {Cela archivera aussi # élément de travail.} other {Cela archivera aussi # éléments de travail.}}",
  "team_projects.confirm.restore_impact":
    "{count, plural, one {Cela restaurera aussi # élément de travail, y compris ceux archivés auparavant.} other {Cela restaurera aussi # éléments de travail, y compris ceux archivés auparavant.}}",
  "team_projects.confirm.delete_title": "Supprimer le projet ?",
  "team_projects.confirm.delete_description":
    "Supprimer définitivement {name} ? Cette action est irréversible.",
  "team_projects.toast.archived": "Projet archivé",
  "team_projects.toast.restored": "Projet restauré",
  "team_projects.toast.duplicating": "Duplication du projet…",
  "team_projects.toast.duplicated": "Projet dupliqué",
  "team_projects.toast.duplicate_failed": "Impossible de dupliquer le projet",
  "team_projects.toast.deleted": "Projet supprimé",
  "team_projects.toast.archive_failed": "Impossible d'archiver {name}",
  "team_projects.toast.restore_failed": "Impossible de restaurer {name}",
  "team_projects.toast.delete_failed": "Impossible de supprimer {name}",
  "team_projects.confirm.bulk_delete_title": "Supprimer {count} projets ?",
  "team_projects.confirm.bulk_delete_description":
    "{count} projets seront supprimés définitivement. Cette action est irréversible.",
  "team_projects.confirm.bulk_archive_title":
    "{count, plural, one {Archiver # projet ?} other {Archiver # projets ?}}",
  "team_projects.confirm.bulk_archive_description":
    "{count, plural, one {Le projet sélectionné sera archivé. Vous pourrez le restaurer plus tard.} other {Les # projets sélectionnés seront archivés. Vous pourrez les restaurer plus tard.}}",
  "team_projects.bulk_status.updated":
    "{count, plural, one {# projet mis à jour.} other {# projets mis à jour.}}",
  "team_projects.bulk_status.updated_with_skipped":
    "{updated} mis à jour ; {skipped} ignoré(s) — bloqué par le workflow, approbation requise, autorisation manquante, ou erreur inattendue.",
  "team_projects.bulk_status.failed":
    "Impossible de mettre à jour le statut des projets sélectionnés.",
  "team_projects.bulk_leads.search_placeholder": "Rechercher des membres...",
  "team_projects.bulk_leads.search_empty": "Aucun membre trouvé",
  "team_projects.bulk_leads.skipped":
    "Impossible d’attribuer cette personne comme responsable — elle n’est peut-être pas éligible au rôle project.lead.",
  "team_projects.bulk_leads.failed":
    "Impossible de mettre à jour les responsables des projets sélectionnés.",
  "team_projects.toast.update_failed": "Impossible d'enregistrer la modification",
  "team_projects.edit.name_aria": "Modifier le nom de {name}",
  "team_projects.edit.lead_aria": "Responsable : {leads}",
  "team_projects.edit.leads_aria": "Responsables : {leads}",
  "team_projects.edit.lead_search": "Rechercher des personnes…",
  "team_projects.edit.no_members": "Aucun membre",
  "team_projects.edit.leads_load_failed":
    "Impossible de charger qui peut diriger ce projet. Fermez et réessayez.",
  "team_projects.edit.no_options": "Aucune option",
  "team_projects.edit.clear_date": "Effacer la date",
  "team_projects.edit.name_required": "Le nom ne peut pas être vide",
  "team_projects.edit.rename": "Renommer",
  "team_projects.edit.home_team_locked": "Équipe principale",
  "team_projects.edit.home_team_aria": "Modifier l’équipe principale de {name}",
  "team_projects.edit.saving": "Enregistrement…",
  "team_projects.side_panel.title": "Détails du projet",
  "team_projects.side_panel.description": "Résumé en lecture seule des champs du projet.",
  "team_projects.side_panel.close": "Fermer",
  "team_projects.side_panel.view_project": "Ouvrir le projet",
  "team_projects.side_panel.open_task_count": "{count} tâches ouvertes",
  "team_projects.side_panel.section.people": "Équipes",
  "team_projects.side_panel.section.dates": "Dates",
  "team_projects.side_panel.section.alignment": "Alignement",
  "team_projects.side_panel.section.recent_activity": "Activité récente",
  "team_projects.side_panel.activity.empty": "Pas encore d'activité",
  "team_projects.side_panel.activity.system_actor": "Cognota",
  "team_projects.side_panel.activity.verb.archived": "a archivé ce projet",
  "team_projects.side_panel.activity.verb.unarchived": "a restauré ce projet",
  "team_projects.side_panel.activity.verb.duplicated": "a dupliqué ce projet",
  "team_projects.side_panel.activity.verb.created": "a créé ce projet",
  "team_projects.side_panel.activity.verb.state_changed": "a mis à jour le statut",
  "team_projects.side_panel.activity.verb.process_changed": "a changé le processus",
  "team_projects.side_panel.activity.verb.work_item_archived": "a archivé l’élément « {name} »",
  "team_projects.side_panel.activity.verb.field_changed": "a mis à jour {field}",
  "team_projects.side_panel.activity.field.description": "la description",
  "team_projects.side_panel.activity.field.project_type": "le type de projet",
  "team_projects.side_panel.activity.field.delivery_type": "le type de livraison",
  "team_projects.side_panel.activity.field.process": "le processus",
  "team_projects.side_panel.activity.field.auto_advance_stages":
    "l'avancement automatique des étapes",
  "team_projects.side_panel.activity.field.archive_on_completion_days": "l'archivage automatique",
  "team_projects.table.estimated_cost": "Coût estimé",
  "team_projects.table.actual_cost": "Coût réel",
  "project.filter_privacy": "Confidentialité",
  "project.sort_by": "Trier par",
  "project.privacy.all": "Tous",
  "project.sort.manual": "Ordre manuel",
  "project.sort.name": "Nom",
  "project.sort.updated": "Dernière mise à jour",
  "project.sort.created": "Date de création",
  "project.join": "Rejoindre",
  "project.state.no_state": "Aucun statut",
  "project.state.update_success": "Statut du projet mis à jour.",
  "project.state.update_error": "Échec de la mise à jour du statut du projet.",
  "project.state.search_placeholder": "Rechercher des statuts...",
  "project.state.search_empty": "Aucun statut trouvé",
  "project.workflow.transition_blocked_title": "Transition non autorisée",
  "project.workflow.transition_blocked_description":
    "Ce projet ne peut pas passer de « {from} » à « {to} ».",
  "project.workflow.allowed_transitions": "Transitions autorisées :",
  "project.workflow.requires_approval": "Approbation requise",
  "project.workflow.contact_admin":
    "Contactez un administrateur de projet pour modifier les règles du workflow.",
  "project.leave": "Quitter",
  "project.left": "Projet quitté",
  "project.settings": "Paramètres",
  "project.copy_link": "Copier le lien",
  "project.status_band.due": "Échéance {date}",
  "project.status_band.overdue": "{count} en retard",
  "project.status_band.over_capacity": "{count} en surcapacité",
  "project.source_template.label": "Modèle :",
  "project.source_template.deleted_name": "{name} (supprimé)",
  "project.status_band.tooltip.focus_label": "{fact}. Placez le focus pour obtenir des détails.",
  "project.status_band.tooltip.state_fact": "Statut du projet : {state}",
  "project.status_band.tooltip.state":
    "Il s’agit du statut actuel du processus de travail, défini sur le projet. Il est distinct des statuts des éléments de travail.",
  "project.status_band.tooltip.process_fact": "Processus {process}",
  "project.status_band.tooltip.process_stage_fact": "Processus {process}, étape {stage}",
  "project.status_band.tooltip.process":
    "Il s’agit du processus de formation et de développement du projet.",
  "project.status_band.tooltip.process_stage":
    "Il s’agit du processus de formation et de développement du projet. L’étape est dérivée : c’est la première étape active du processus dont les éléments de travail ne sont pas tous terminés ou annulés ; les étapes désactivées ou sans travail actif sont ignorées.",
  "project.status_band.tooltip.due":
    "Il s’agit de la date d’achèvement prévue du projet, définie sur le projet. Elle marque également la fin de la période de planification utilisée pour calculer la santé du projet.",
  "common.identifier_copy": "Cliquer pour copier",
  "common.identifier_copied": "Identifiant copié dans le presse-papiers",
  "common.identifier_copy_error": "Impossible de copier l'identifiant",
  "project.link_copied": "Lien copié dans le presse-papiers",
  "project.archive": "Archiver",
  "project.archived": "Projet archivé",
  "project.archive_error": "Impossible d'archiver le projet",
  "project.restore": "Restaurer",
  "project.restored": "Projet restauré",
  "project.restore_error": "Impossible de restaurer le projet",
  "project.restore_confirm_title": "Restaurer le projet ?",
  "project.restore_confirm_description": "Restaurer {name} parmi les projets actifs ?",
  "project.update_error": "Impossible de mettre à jour le projet",
  "project.archive_confirm_title": "Archiver le projet ?",
  "project.archive_confirm_description":
    "Archiver {name} ? Vous pourrez le restaurer depuis les archives.",
  "project.delete": "Supprimer",
  "project.deleted": "Projet supprimé",
  "project.delete_error": "Impossible de supprimer le projet",
  "project.delete_confirm_title": "Supprimer le projet ?",
  "project.delete_confirm_description": "Supprimer {name} ? Cette action est irréversible.",
  "project.duplicate": "Dupliquer",
  "project.duplicated": "Projet dupliqué",
  "project.duplicate_error": "Impossible de dupliquer le projet",
  "project.duplicate_confirm_title": "Dupliquer le projet ?",
  "project.duplicate_confirm_description":
    "Une copie de {name} sera créée avec les mêmes champs et éléments de travail. Tous les statuts seront réinitialisés à la valeur par défaut.",
  "project.add_favorite": "Ajouter aux favoris",
  "project.remove_favorite": "Retirer des favoris",
  "project.empty_title": "Aucun projet",
  "project.empty_description": "Créez votre premier projet pour commencer.",
  "project.empty_filtered": "Aucun projet ne correspond à vos filtres",

  // Issues / Work Items
  "issue.page_title": "Éléments de travail",
  "issue.page_description": "Suivez, organisez et mettez à jour le travail du projet.",
  "issue.search_placeholder": "Rechercher des éléments de travail...",
  "issue.create": "Créer un élément de travail",
  "issue.create_work_item": "Créer un élément de travail",
  "issue.import_work_items": "Importer des éléments de travail",
  "issue.move_failed": "Impossible de déplacer l'élément. Veuillez réessayer.",
  "issue.name": "Nom",
  "issue.created_at": "Créé le",
  "issue.kind": "Type",
  "issue.name_placeholder": "Que faut-il faire ?",
  "issue.description": "Description",
  "issue.description_placeholder": "Ajoutez plus de contexte pour cet élément de travail...",
  "issue.description_loading": "Chargement de la description",
  "issue.description_load_failed":
    "Impossible de charger la description. Fermez puis rouvrez ce panneau pour réessayer.",
  "issue.none": "Aucun",
  "issue.priority": "Priorité",
  "issue.project": "Projet",
  "issue.project_placeholder": "Sélectionner un projet",
  "issue.project_search_placeholder": "Rechercher des projets…",
  "issue.project_empty": "Aucun projet trouvé",
  "issue.project_none": "Aucun projet",
  "issue.status": "Statut",
  "issue.priority.none": "Aucune priorité",
  "issue.priority.low": "Faible",
  "issue.priority.medium": "Moyenne",
  "issue.priority.high": "Élevée",
  "issue.priority.urgent": "Urgente",
  "issue.state.none": "Aucun état",
  "issue.state.search_placeholder": "Rechercher des états...",
  "issue.state.search_empty": "Aucun état trouvé",
  "issue.display_options": "Options d’affichage",
  "issue.display.show_identifier": "Afficher l’identifiant",
  "issue.display.show_state": "Afficher l’état",
  "issue.display.show_assignee": "Afficher l’assigné",
  "issue.display.show_priority": "Afficher la priorité",
  "issue.display.show_target_date": "Afficher les dates",
  "issue.display.columns": "Colonnes",
  "issue.display.show_archived": "Afficher les archivés",
  "issue.display.layout_options": "Options — {layout}",
  "issue.display.set_default_for_everyone": "Définir par défaut pour tous",
  "issue.display.no_workspace_default":
    "L'enregistrement d'une valeur par défaut n'est pas encore branché",
  "issue.table.name": "Nom",
  "issue.display.show_predecessors": "Afficher les dépendances",
  "issue.layout.change": "Changer la disposition",
  "issue.layout.list": "Table",
  "issue.layout.board": "Tableau",
  "issue.layout.spreadsheet": "Tableur",
  "issue.layout.calendar": "Calendrier",
  "issue.layout.gantt": "Gantt",
  "issue.layout.timeline": "Chronologie",
  "issue.layout.truncated_notice":
    "Affichage des {count} premiers éléments de travail. Affinez la liste pour voir le reste.",
  "issue.filter.button": "Filtres",
  "issue.filter.clear_all": "Tout effacer",
  "issue.filter.state": "État",
  "issue.filter.assigneeUnassigned": "Non attribué",
  "issue.filter.assignee": "Assigné",
  "issue.filter.unassigned": "Non assigné",
  "issue.filter.project": "Projet",
  "issue.filter.project_status": "Statut du projet",
  "issue.filter.home_team": "Équipe principale",
  "issue.filter.delivery_team": "Équipe de livraison",
  "issue.filter.all_priorities": "Toutes les priorités",
  "issue.filter.all_states": "Tous les états",
  "issue.filter.all_assignees": "Tous les assignés",
  "issue.filter.all_labels": "Toutes les étiquettes",
  "issue.group_by": "Grouper par",
  "issue.group_by.none": "Aucun",
  "issue.group_by.count_partial": "{count}+",
  "issue.group_by.process_stage": "Étape du processus",
  "issue.group_by.no_stage": "Aucune étape",
  "issue.group_by.no_category_value": "Aucune catégorie",
  "issue.group_by.no_process": "Définissez un processus sur ce projet pour grouper par étape",
  "issue.board.group_by": "Afficher par",
  "issue.board.no_process_title": "Ajouter un processus",
  "issue.board.no_process_description":
    "Choisissez un processus depuis la page d’aperçu du projet pour afficher le travail par étape de processus.",
  "issue.stage.label": "Étape",
  "issue.stage.add_process": "Ajouter un processus au projet",
  "issue.stage.no_process": "Aucun processus sélectionné",
  "issue.sort_by": "Trier par",
  "issue.sort.-created_at": "Création la plus récente",
  "issue.sort.created_at": "Création la plus ancienne",
  "issue.sort.-updated_at": "Mise à jour récente",
  "issue.sort.updated_at": "Mise à jour la moins récente",
  "issue.sort.sequence_id": "ID croissant",
  "issue.sort.-sequence_id": "ID décroissant",
  "issue.sort.name": "Nom A-Z",
  "issue.sort.-name": "Nom Z-A",
  "issue.assignees": "Assignés",
  "issue.outside_assignee_notice":
    "{name} ne fait partie d'aucune équipe de ce projet. Cette personne verra le nom du projet et cette tâche uniquement.",
  "issue.add_assignee": "Ajouter un assigné",
  "issue.no_assignees": "Aucun assigné",
  "issue.no_assignees_available": "Aucun assigné disponible",
  "issue.search_assignees": "Rechercher des personnes",
  "issue.no_assignees_match": "Aucun résultat",

  // Work item tables and pickers (NG-2582)
  "issue.sub_task_create_error": "Impossible de créer la sous-tâche",
  "issue.layout_event_aria": "Disposition des événements",
  "issue.layout_task_aria": "Disposition des tâches",

  "issue.assignee_unnamed": "Utilisateur sans nom",
  "issue.assignee_suggested": "Suggéré",
  "issue.assignee_picker.assigned": "Assignés",
  "issue.assignee_picker.show_more": "Afficher plus",
  "issue.assignee_picker.candidates": "Candidats à l'affectation",
  "issue.assignee_picker.placeholder": "Sélectionner des assignés",
  "issue.assignee_picker.selected_count": "{count} sélectionné(s)",
  "issue.assignee_picker.best_match": "Meilleure correspondance",
  "issue.assignee_picker.over_capacity_title": "{name} sera en surcapacité",
  "issue.assignee_picker.over_capacity_description":
    "{hours} de dépassement après affectation, pour les dates de cette tâche. Assigner quand même ?",
  "issue.assignee_capacity.remaining": "{hours} restant",
  "issue.assignee_capacity.over_by": "{hours} en dépassement",
  "issue.assignee_capacity.after_task": "{hours} disponibles après affectation",
  "issue.assignee_capacity.after_task_over_by": "{hours} de dépassement après affectation",
  "issue.assignee_capacity.hours_not_set": "Heures non définies",
  "issue.assignee_capacity.skill_match": "Qualifié à {percent} %",
  "issue.assignee_capacity.risk_title": "Risque de capacité de l'assigné",
  "issue.assignee_capacity.risk_description":
    "Les assignés sélectionnés dépassent leur capacité ou sont indisponibles pour la plage de dates de cette tâche.",
  "issue.assignee_capacity.risk_item_over_by": "{name} dépasse de {hours}",
  "issue.assignee_capacity.risk_item_unavailable": "{name} n'a aucune capacité disponible",
  "issue.assignee_capacity.replacements_title": "Candidats de remplacement",
  "issue.assignee_capacity.replacements_description":
    "Choisissez un membre du projet pour remplacer uniquement l'assigné sélectionné.",
  "issue.assignee_capacity.replace_for": "Remplacer {name}",
  "issue.assignee_capacity.replacement_skill_match": "{percent} % de correspondance",
  "issue.assignee_capacity.replacement_remaining": "{hours} restant",
  "issue.assignee_capacity.replacement_capacity_gap": "{hours} de capacité manquante",
  "issue.assignee_capacity.replace_button": "Remplacer",
  "issue.assignee_capacity.replace_button_label": "Remplacer {from} par {to}",
  "issue.assignee_capacity.replacements_empty": "Aucun candidat de remplacement disponible.",
  "issue.allocation_warning.banner":
    "{count, plural, one {# tâche présente un problème d'allocation} other {# tâches présentent des problèmes d'allocation}} — une personne assignée dépasse sa capacité pour les dates de la tâche.",
  "issue.allocation_warning.icon_label": "Problème d'allocation",
  "issue.allocation_warning.icon_tooltip":
    "Une personne assignée dépasse sa capacité pour les dates de cette tâche.",
  "issue.allocation_warning.label": "Surcapacité",
  "issue.blocked.count": "{count, plural, one {# élément bloquant} other {# éléments bloquants}}",
  "issue.dependent_shift.title.successors":
    "{count, plural, one {Déplacer la tâche qui attend celle-ci ?} other {Déplacer les tâches qui attendent celle-ci ?}}",
  "issue.dependent_shift.title.predecessors":
    "{count, plural, one {Déplacer la tâche dont celle-ci dépend ?} other {Déplacer les tâches dont celle-ci dépend ?}}",
  "issue.dependent_shift.moved.earlier":
    "Vous avez avancé {name} de {days, plural, one {# jour ouvré} other {# jours ouvrés}}.",
  "issue.dependent_shift.moved.later":
    "Vous avez reporté {name} de {days, plural, one {# jour ouvré} other {# jours ouvrés}}.",
  "issue.dependent_shift.count.successors":
    "{count, plural, one {1 tâche attend celle-ci :} other {# tâches attendent celle-ci, directement ou plus loin dans la chaîne :}}",
  "issue.dependent_shift.count.predecessors":
    "{count, plural, one {Elle dépend d'1 tâche :} other {Elle dépend de # tâches, directement ou plus haut dans la chaîne :}}",
  "issue.dependent_shift.waits_on": "attend {name}",
  "issue.dependent_shift.waited_on_by": "{name} attend celle-ci",
  "issue.dependent_shift.cannot_edit":
    "Garde ses dates ({dates}). Vous ne pouvez pas modifier cette tâche.",
  "issue.dependent_shift.outside_parent":
    "Garde ses dates ({dates}). La déplacer la sortirait des dates de sa tâche parente.",
  "issue.dependent_shift.cannot_open": "Une tâche que vous ne pouvez pas ouvrir",
  "issue.dependent_shift.cannot_open_stays": "Elle reste à sa place.",
  "issue.dependent_shift.already_saved": "Votre modification de {name} est déjà enregistrée.",
  "issue.dependent_shift.keep": "Garder leurs dates",
  "issue.dependent_shift.move": "{count, plural, one {Déplacer 1 tâche} other {Déplacer # tâches}}",
  "issue.dependent_shift.moving": "Déplacement…",
  "issue.dependent_shift.moved_toast":
    "{count, plural, one {1 tâche déplacée} other {# tâches déplacées}}",
  "issue.dependent_shift.moved_toast_one": "{name} est désormais prévue {dates}.",
  "issue.dependent_shift.move_failed":
    "Impossible de déplacer les tâches. Votre modification reste enregistrée.",
  "issue.blocked.jump": "Aller aux dépendances",
  "issue.blocked.label":
    "{count, plural, one {Bloqué par # élément} other {Bloqué par # éléments}}",
  "issue.blocked.complete_title": "Terminer cet élément alors qu'il est encore bloqué ?",
  "issue.blocked.complete_description":
    "{count, plural, one {Il attend un élément non terminé} other {Il attend des éléments non terminés}} : {blockers}. Vous pouvez tout de même le terminer.",
  "issue.blocked.complete_confirm": "Terminer quand même",
  "issue.remove_assignee": "Retirer {name}",
  "issue.estimate_hours": "Heures estimées",
  "issue.target_date": "Date cible",
  "issue.start_date": "Date de début",
  "issue.completed_at": "Date de complétion",
  "issue.empty.title": "Aucun élément de travail",
  "issue.empty.description": "Créez le premier élément de travail de ce projet pour commencer.",
  "issue.empty.filtered_title": "Aucun élément de travail ne correspond à vos filtres",
  "issue.empty.filtered_description":
    "Essayez d’ajuster les filtres ou créez un nouvel élément de travail.",
  "issue.bulk.selected_count": "{count} sélectionné(s)",
  "issue.bulk.clear": "Effacer",
  "issue.bulk.delete": "Supprimer la sélection",
  "issue.bulk.select_all_aria": "Tout sélectionner",
  "issue.bulk.select_one": "Sélectionner {name}",
  "issue.load_more": "Charger plus d’éléments de travail",
  "issue.loading_more": "Chargement...",
  "issue.rename_aria": "Renommer {name}",
  "issue.rename": "Renommer",
  "issue.name_required": "Le nom ne peut pas être vide",
  "issue.rename_failed": "Échec du renommage de l’élément de travail",
  "issue.quick_actions": "Ouvrir les actions",
  "issue.archive": "Archiver",
  "issue.restore": "Restaurer",
  "issue.delete": "Supprimer",
  "issue.name_label": "Nom de la tâche",
  "issue.more_actions": "Plus d’actions",
  "issue.delete_archived_success": "Élément de travail supprimé",
  "issue.delete_archived_error": "Échec de la suppression de l’élément de travail",
  "issue.archive_title": "Archiver l’élément de travail",
  "issue.archive_description": "Archiver « {name} » ? Vous pourrez le restaurer plus tard.",
  "issue.archive_success": "Élément de travail archivé",
  "issue.archive_error": "Échec de l’archivage de l’élément de travail",
  "issue.promote_to_work_item": "Promouvoir en élément de travail",
  "issue.promote_success": "Promu en élément de travail",
  "issue.promote_error": "Échec de la promotion du sous-élément",
  "issue.promote_confirm_title": "Promouvoir en élément de travail ?",
  "issue.promote_confirm_body":
    "« {name} » deviendra un élément de travail de premier niveau de ce projet, affiché sous son parent actuel. Ses propres sous-tâches restent avec lui.",
  "issue.promote_session_confirm_body":
    "« {name} » deviendra un événement à part entière, hors de son événement actuel. Son horaire reste le même.",
  "issue.promote_confirm": "Promouvoir",
  "issue.restore_title": "Restaurer l’élément de travail",
  "issue.restore_description": "Restaurer « {name} » dans la liste active ?",
  "issue.restore_success": "Élément de travail restauré",
  "issue.restore_error": "Échec de la restauration de l’élément de travail",
  "issue.update_error": "Échec de la mise à jour de l’élément de travail",
  "issue.delete_archived_title": "Supprimer l’élément de travail",
  "issue.delete_archived_description":
    "Supprimer définitivement « {name} » ? Cette action est irréversible.",
  "issue.delete_archived_description_with_sub_items":
    "{subItems, plural, one {Supprimer définitivement « {name} » et sa # sous-tâche ? Cette action est irréversible.} other {Supprimer définitivement « {name} » et ses # sous-tâches ? Cette action est irréversible.}}",
  "issue.delete_archived_description_sub_items_unknown":
    "Supprimer définitivement « {name} » et ses éventuelles sous-tâches ? Cette action est irréversible.",
  "issue.delete_checking_sub_items": "Vérification des sous-tâches…",
  "issue.delete_refused_sub_items":
    "Suppression impossible : vous n’êtes pas autorisé à supprimer toutes ses sous-tâches.",
  "issue.delete_refused_cross_project":
    "Une sous-tâche appartient à un autre projet. Déplacez-la avant de supprimer l’élément.",
  "issue.properties": "Propriétés",
  // Views
  "view.page_title": "Vues",
  "view.page_description":
    "Enregistrez des sous-ensembles ciblés du projet et rouvrez-les quand vous en avez besoin.",
  "view.create": "Créer une vue",
  "view.create_title": "Créer une vue",
  "view.create_submit": "Créer",
  "view.create_error": "Impossible de créer la vue",
  "view.created": "Vue créée",
  "view.edit_title": "Modifier la vue",
  "view.edit": "Modifier",
  "view.updated": "Vue mise à jour",
  "view.update_error": "Impossible de mettre à jour la vue",
  "view.delete": "Supprimer",
  "view.deleted": "Vue supprimée",
  "view.delete_error": "Impossible de supprimer la vue",
  "view.delete_confirm_title": "Supprimer la vue",
  "view.delete_confirm_description": "Supprimer « {name} » ? Cette action est irréversible.",
  "view.share": "Partager",
  "view.access.shared": "Partagée",
  "view.workspace.shared_with_me": "Partagées avec moi",
  "view.workspace.shared_with_me_description":
    "Les vues que d’autres personnes ont partagées avec vous ou avec l’une de vos équipes.",
  "view.share_dialog.title": "Partager la vue",
  "view.share_dialog.description":
    "Les personnes et les équipes avec qui vous partagez « {name} » peuvent l’ouvrir. Chacune ne voit que le travail auquel elle a déjà accès.",
  "view.share_dialog.people_label": "Personnes",
  "view.share_dialog.people_placeholder": "Choisir des personnes",
  "view.share_dialog.people_search": "Rechercher des personnes",
  "view.share_dialog.people_empty": "Personne d’autre dans cet espace de travail",
  "view.share_dialog.teams_label": "Équipes",
  "view.share_dialog.teams_placeholder": "Choisir des équipes",
  "view.share_dialog.teams_search": "Rechercher des équipes",
  "view.share_dialog.teams_empty": "Aucune équipe",
  "view.share_dialog.teams_hint":
    "Les membres d’une équipe, et de chaque équipe au-dessus, peuvent ouvrir la vue.",
  "view.share_dialog.entire_workspace_label": "Partager avec tout l’espace de travail",
  "view.share_dialog.entire_workspace_hint":
    "Tout le monde dans l’espace de travail peut l’ouvrir, et elle figure sous Tout l’espace de travail. Chacun ne voit que le travail qu’il peut déjà voir.",
  "view.share_dialog.access_save_error":
    "Impossible de modifier l’accès de tout l’espace de travail à cette vue",
  "view.share_dialog.save": "Enregistrer",
  "view.share_dialog.saving": "Enregistrement…",
  "view.share_dialog.saved": "Partage enregistré",
  "view.share_dialog.save_error": "Impossible d’enregistrer avec qui cette vue est partagée",
  "view.share_dialog.load_error": "Impossible de charger avec qui cette vue est partagée",
  "view.actions": "Actions de la vue",
  "view.open": "Ouvrir",
  "view.name_label": "Nom",
  "view.name_placeholder": "Triage du backlog",
  "view.description_label": "Description",
  "view.description_placeholder": "Résumez l’objectif de cette vue",
  "view.save_changes": "Enregistrer les modifications",
  "view.search_placeholder": "Rechercher des vues...",
  "view.sort.default": "Par défaut",
  "view.sort.name": "Nom",
  "view.sort.created": "Création",
  "view.sort.updated": "Mise à jour",
  "view.filter.favorites": "Favoris",
  "view.access.entire_workspace": "Tout l'espace de travail",
  "view.access.private": "Privée",
  "view.no_description": "Aucune description fournie.",
  "view.fetch_error": "Impossible de charger les vues",
  "view.favorite_error": "Impossible de mettre à jour le favori",
  "view.empty.title": "Aucune vue",
  "view.empty.description":
    "Créez une vue enregistrée pour le triage, la planification ou les revues récurrentes.",
  "view.empty.filtered_title": "Aucune vue ne correspond à vos filtres",
  "view.empty.filtered_description": "Essayez une autre recherche ou effacez les filtres actuels.",
  "view.clear_filters": "Effacer les filtres",
  "view.disabled_title": "Les vues sont désactivées pour ce projet",
  "view.disabled_description":
    "Ce projet n’expose pas actuellement les vues enregistrées. Réactivez la fonctionnalité pour les gérer ici.",
  "view.error_title": "Impossible de charger les vues",
  "view.error_description": "Réessayez ou revenez dans un instant.",
  "view.read_denied_title": "Vous n’avez pas l’autorisation de voir les vues enregistrées",
  "view.read_denied_description":
    "Contactez l’administrateur de votre espace de travail pour demander l’accès.",
  "view.updated_on": "Mis à jour le {date}",
  "view.add_favorite_named": "Ajouter {name} aux favoris",
  "view.remove_favorite_named": "Retirer {name} des favoris",
  "view.back_to_list": "Retour aux vues",
  "view.kind.work_item": "Éléments de travail",
  "view.kind.request": "Demandes",
  "view.kind.project": "Projets",
  "view.kind.field_label": "Contenu de la vue",
  "view.kind.field_hint":
    "Une vue porte sur un seul type d'enregistrement, et ce choix est définitif.",
  "view.kind.filter_label": "Type",
  "view.kind.all": "Tous les types",
  "view.locked": "Verrouillée",
  "view.save_as": "Enregistrer sous",
  "view.save_as_hint": "Enregistrez les filtres actuels comme vue distincte.",
  "view.reset": "Réinitialiser",
  "view.update_current": "Mettre à jour la vue",
  "view.unsaved_changes": "Vous avez des modifications non enregistrées.",
  "view.detail.not_found_title": "Vue introuvable",
  "view.detail.work_items_denied_title": "Vous ne pouvez pas voir les éléments de travail ici",
  "view.detail.work_items_denied_description":
    "Demandez à un administrateur de l’espace l’autorisation de consulter les éléments de travail.",
  "view.detail.not_found_description": "Cette vue enregistrée n’a pas pu être chargée.",
  "view.detail.placeholder_description":
    "Le détail complet de la vue enregistrée sera étendu à la prochaine phase.",
  "view.detail.placeholder_body":
    "Cette route est câblée pour que les flux de création et d’ouverture fonctionnent dès maintenant. L’expérience complète des éléments de travail arrive à la prochaine phase.",
  "view.workspace.page_title": "Vues",
  "view.workspace.my_views": "Mes vues",
  "view.workspace.my_views_description": "Les vues que vous avez créées.",
  "view.workspace.entire_workspace_views": "Tout l’espace de travail",
  "view.workspace.entire_workspace_views_description":
    "Les vues partagées avec tout le monde dans cet espace de travail.",
  "view.workspace.empty_title": "Aucune vue d’espace ne correspond pour le moment",
  "view.workspace.empty_description":
    "Commencez par une vue rapide ou créez une vue d’espace personnalisée pour le travail multi-projets.",
  "view.workspace.table_title": "Éléments multi-projets",
  "view.workspace.table_description":
    "Les vues d’espace restent axées sur le tableau dans A3 afin de parcourir le travail entre projets sans changer de disposition.",
  "view.workspace.assignee_count": "{count} assignés",
  "view.workspace.unknown_assignee": "Assigné inconnu",
  "view.workspace.static.all-issues.title": "Tout le travail",
  "view.workspace.static.all-issues.description":
    "Tout le travail de l’espace, avec des filtres locaux superposés pour cette session.",
  "view.workspace.static.assigned.title": "Assignés à moi",
  "view.workspace.static.assigned.description":
    "Les éléments qui vous sont assignés dans tous les projets de l’espace.",
  "view.workspace.static.created.title": "Créés par moi",
  "view.workspace.static.created.description":
    "Le travail multi-projets que vous avez ouvert, prêt pour le suivi ou le transfert.",
  "view.workspace.static.subscribed.title": "Abonnements",
  "view.workspace.static.subscribed.description":
    "Les éléments que vous suivez pour vérifier l’avancement sans fouiller chaque projet.",
  "issue.comments": "Commentaires",
  "issue.comments_empty": "Aucun commentaire pour le moment.",
  "issue.comments_placeholder": "Ajouter un commentaire",
  "issue.comment_submit": "Publier le commentaire",
  "issue.add_reaction": "Ajouter une réaction",
  "issue.activity": "Activité",
  "issue.activity_empty": "Aucune activité pour le moment",
  "issue.activity_fetch_error": "Impossible de charger l'activité. Veuillez réessayer.",
  "issue.attachments": "Pièces jointes",
  "issue.attachments_empty": "Aucune pièce jointe pour le moment",
  "issue.attachments_error": "Impossible de charger les pièces jointes",
  "issue.attachments_forbidden": "Vous n'avez pas accès aux pièces jointes de cet élément",
  "issue.worklog_unknown_user": "Utilisateur inconnu",
  "issue.attachments_upload": "Téléverser",
  "issue.attachments_uploading": "Téléversement…",
  "issue.attachments_upload_error": "Impossible de téléverser la pièce jointe",
  "issue.attachments_delete": "Supprimer la pièce jointe",

  // Work item overview and sub-tasks (NG-2582)
  "issue.overview.id_subtitle": "ID : {id}",
  "issue.overview.close_comments": "Fermer les commentaires",
  "issue.subtasks.click_to_edit": "Cliquer pour modifier",
  "issue.subtasks.back": "Retour",
  "issue.subtasks.open_page": "Ouvrir la page",
  "issue.subtasks.none": "Aucune sous-tâche",
  "issue.subtasks.time_logs": "Temps consigné",
  "issue.subtasks.collapse": "Réduire",
  "issue.subtasks.expand": "Développer",
  "issue.subtasks.complete": "terminées",
  "issue.subtasks.loading": "Chargement des sous-tâches…",
  "issue.subtasks.forbidden": "Vous n'avez pas accès aux sous-tâches de cet élément.",
  "issue.subtasks.load_error": "Impossible de charger les sous-tâches. Veuillez réessayer.",
  "issue.subtasks.col_due": "Échéance",
  "issue.subtasks.empty": "Aucune sous-tâche pour le moment.",

  "issue.relations": "Relations",
  "issue.dependencies": "Dépendances",
  "issue.relations_empty": "Aucun travail lié pour le moment",
  "issue.add_dependency": "Ajouter une dépendance",
  "issue.dependency_type_label": "Type de dépendance",
  "issue.dependency_relation.blocked_by": "Bloqué par",
  "issue.dependency_relation.blocks": "Bloquant",
  "issue.dependency_relation.relates_to": "Lié à",
  "issue.task_or_event_label": "Tâche ou événement",
  "issue.select_task_or_event": "Sélectionner une tâche ou un événement",
  "issue.search_tasks_and_events": "Rechercher des tâches et événements",
  "issue.add_relation": "Ajouter une relation",
  "issue.no_access": "Accès refusé",
  "issue.no_access_count": "{count} sans accès",
  "issue.remove_relation": "Supprimer la relation",
  "issue.relation_remove_error": "Impossible de supprimer la relation",
  "issue.relation_type_label": "Type de relation",
  "issue.relation_type.blocked_by": "Bloqué par",
  "issue.relation_type.blocks": "Bloque",
  "issue.relation_type.relates_to": "En lien avec",
  "issue.dependency_subtype_label": "Type de dépendance",
  "issue.dependency_subtype.finish_to_start": "Fin à début (FS)",
  "issue.dependency_subtype.start_to_start": "Début à début (SS)",
  "issue.dependency_subtype.finish_to_finish": "Fin à fin (FF)",
  "issue.dependency_subtype.start_to_finish": "Début à fin (SF)",
  "issue.relation_search_placeholder": "Rechercher des éléments de travail...",
  "issue.relation_add_error": "Impossible d'ajouter la relation",
  "issue.dependency_refused.cross_project":
    "Une dépendance ne peut relier que des éléments de travail du même projet.",
  "issue.dependency_refused.closed":
    "Un élément terminé ou annulé ne peut pas faire partie d'une nouvelle dépendance.",
  "issue.relation_fetch_error": "Impossible de charger les relations. Veuillez réessayer.",
  "issue.relation_forbidden": "Vous n'avez pas accès aux dépendances de cet élément",
  "issue.relation_group.blocked_by": "Bloqué par",
  "issue.relation_group.blocks": "Bloque",
  "issue.relation_group.relates_to": "En lien avec",
  "issue.links": "Liens",
  "issue.links_empty": "Aucun lien pour le moment",
  "issue.add_link": "Ajouter un lien",
  "issue.remove_link": "Supprimer le lien",
  "issue.link_add_error": "Impossible d'ajouter le lien",
  "issue.link_remove_error": "Impossible de supprimer le lien",
  "issue.link_invalid_url": "Saisissez une URL valide (ex. https://example.com)",
  "issue.link_url_placeholder": "https://...",
  "issue.link_title_placeholder": "Titre (optionnel)",
  "issue.sub_issues": "Sous-éléments de travail",
  "issue.sub_issues_empty": "Aucun sous-élément de travail pour le moment",
  "issue.expand_sub_issues": "Développer les sous-éléments",
  "issue.collapse_sub_issues": "Réduire les sous-éléments",
  "issue.create_sub_work_item": "Créer une sous-tâche",
  "issue.create_sub_work_item_title": "Créer un sous-élément",
  "issue.search_work_items": "Rechercher des éléments de travail",
  "issue.no_work_item_matches": "Aucun élément de travail correspondant",
  "issue.sub_work_item_create_error": "Impossible de créer le sous-élément de travail",
  "issue.show_panel": "Afficher",
  "issue.hide_panel": "Masquer",
  "issue.subscribe": "S’abonner",
  "issue.unsubscribe": "Se désabonner",
  "issue.open_detail": "Ouvrir la page détaillée",
  "issue.saving": "Enregistrement...",
  "issue.not_found": "Élément de travail introuvable",
  "issue.not_found_description":
    "Cet élément de travail n’a pas pu être résolu à partir de ce lien. Revenez à la page des éléments de travail du projet.",
  "issue.load_error": "Impossible de charger l’élément de travail",
  "issue.load_error_description":
    "Une erreur réseau s’est produite lors du chargement de cet élément de travail. Vérifiez votre connexion et réessayez.",
  "issue.back_to_project": "Retour aux éléments de travail du projet",
  "issue.create_error": "Impossible de créer l'élément de travail. Veuillez réessayer.",
  "issue.activity_error": "Impossible de charger l'activité",
  "issue.relations_error": "Impossible de charger les relations",
  "issue.table.id": "ID",
  "issue.table.start": "Début",
  "issue.table.target": "Cible",
  "issue.table.predecessors": "Dépendances",
  "issue.table.created": "Créé le",
  "issue.table.completed": "Date d'achèvement",
  "issue.table.estimated_cost": "Coût est.",
  "issue.table.actual_cost": "Coût réel",
  "issue.table.estimated_hours": "Heures estimées",
  "issue.table.actual_hours": "Heures réelles",
  "issue.table.home_team": "Équipe principale",
  "issue.table.delivery_teams": "Équipes de livraison",
  "issue.table.estimate_edit_aria": "Heures estimées pour {name}",
  "issue.table.estimate_invalid":
    "Saisissez les heures sous forme de nombre supérieur ou égal à 0.",
  "issue.table.estimate_save_failed": "Échec de la mise à jour des heures estimées",
  "issue.add_row.placeholder": "Ajouter un élément de travail…",
  "issue.table.expand_all": "Tout développer",
  "issue.table.collapse_all": "Tout réduire",
  "issue.add_row.aria": "Nom du nouvel élément de travail",
  "issue.add_row.subtask_placeholder": "Nom de la sous-tâche…",
  "issue.add_row.subtask_aria": "Nom de la sous-tâche",
  "issue.add_row.creating": "Ajout…",
  "issue.add_row.failed": "Impossible de créer l’élément de travail",
  "issue.predecessors.placeholder": "Ajouter…",
  "issue.predecessors.aria": "Dépendances de {name}",
  "issue.predecessors.edit_aria": "Modifier les dépendances de {name}",
  "issue.predecessors.invalid": "Entrez des identifiants séparés par des virgules (ex. : 3, W-42).",
  "issue.predecessors.update_error": "Impossible de mettre à jour les dépendances.",
  "issue.category": "Catégorie",
  "issue.category.task": "Tâche",
  "issue.category.event": "Événement",
  "issue.category.milestone": "Jalon",
  "milestones.section.title": "Jalons du projet",
  "milestones.section.hide": "Masquer",
  "milestones.section.show": "Afficher",
  "milestones.timeline.today": "Aujourd'hui",
  "milestones.list.no_status": "Aucun statut",
  "milestones.list.no_due_date": "Aucune échéance",
  "milestones.list.due_date": "Date d'échéance",
  "milestones.list.completed_date": "Date d'achèvement",
  "milestones.list.completed_on": "Terminé le {date}",
  "milestones.list.unassigned": "Non attribué",
  "milestones.empty.title": "Aucun jalon pour le moment",
  "milestones.empty.description":
    "Ajoutez un jalon pour suivre votre progression par rapport aux livrables clés, aux points de contrôle ou aux événements.",
  "issue.archived_toggle.active": "Actifs",
  "issue.archived_toggle.archived": "Archivés",
  "issue.sub_task": "Sous-tâche",
  "issue.session": "Session",
  "issue.convert_type": "Convertir le type",
  "issue.convert_to_task": "Convertir en tâche",
  "issue.convert_to_event": "Convertir en événement",
  "issue.convert_to_milestone": "Convertir en jalon",
  "issue.convert_milestone_confirm_title": "Convertir en jalon ?",
  "issue.convert_milestone_confirm_body":
    "Les jalons ne suivent pas les heures estimées ou enregistrées. La conversion effacera les heures de cet élément de travail, sans possibilité de récupération.",
  "issue.convert_error": "Échec de la conversion du type d'élément de travail.",
  "issue.skills_label": "Qualifications",
  "issue.skills_search_placeholder": "Rechercher des qualifications…",
  "issue.skills_empty": "Aucune qualification trouvée",
  "issue.skills_update_error": "Échec de la mise à jour des qualifications de l'élément de travail",
  "issue.skills_saving": "Enregistrement…",
  "issue.type": "Type",
  "issue.category_value": "Catégorie",
  "issue.task_category": "Catégorie de tâche",
  "issue.event_category": "Catégorie d'événement",
  "issue.milestone_category": "Catégorie de jalon",
  "issue.choose_category_placeholder": "Choisir une catégorie",
  "issue.create_description_placeholder": "Décrivez le travail",
  "issue.estimate_placeholder": "Saisir les heures estimées",
  "issue.event_start": "Début",
  "issue.event_end": "Fin",
  "issue.event_time": "Heure de l'événement",
  "issue.event_start_date": "Date de début",
  "issue.event_end_date": "Date de fin",
  "issue.event_start_time": "Heure de début",
  "issue.event_end_time": "Heure de fin",
  "issue.event_all_day": "Événement toute la journée",
  "issue.event_all_day_short": "Toute la journée",
  "issue.event_due_date": "Date d'échéance",
  "issue.event_start_date_time": "Date / heure de début",
  "issue.event_due_date_time": "Date / heure d'échéance",
  "issue.event_timezone": "Fuseau horaire",
  "issue.event_dates_required": "Les événements nécessitent des dates de début et de fin.",
  "issue.event_dates_order_error": "La fin de l'événement doit être après le début.",
  "issue.parent_bounds_hint":
    "Les dates doivent se situer dans la période du parent : {start} – {end}.",
  "issue.parent_bounds_hint_after": "Les dates doivent commencer le {start} ou après.",
  "issue.parent_bounds_hint_before": "Les dates doivent se terminer le {end} ou avant.",
  "issue.parent_bounds_out_of_range": "Ces dates sont en dehors de la période du parent.",
  "issue.estimate_hours_negative": "Les heures estimées ne peuvent pas être négatives.",
  "issue.event_time_update_error": "Impossible de mettre à jour l'heure de l'événement.",
  "issue.save_event_time": "Enregistrer l'heure",
  "project_overview.title": "Aperçu du projet",
  "project_overview.subtitle": "Santé, heures et progression des étapes en un coup d'œil.",
  "project_overview.custom_fields.title": "Champs personnalisés",
  "project_overview.global_fields.title": "Champs globaux",
  "project_overview.custom_fields.empty_value": "—",
  "project_overview.custom_fields.archived": "archivé",
  "project_overview.custom_fields.required_error": "Ce champ est obligatoire.",
  "project_overview.custom_fields.required_marker": "obligatoire",
  "project_overview.custom_fields.row.edit": "Modifier {name}",
  "project_overview.custom_fields.row.save": "Enregistrer",
  "project_overview.custom_fields.row.cancel": "Annuler",
  // PRD §7 — gestion administrateur des champs personnalisés globaux sur les éléments de travail.
  "work_item_overview.custom_fields.title": "Champs globaux",
  "work_item_overview.custom_fields.archived": "archivé",
  "work_item_overview.custom_fields.empty_state": "Aucun champ global sur cet élément de travail.",
  "work_item_overview.custom_fields.manage_button": "Gérer les champs",
  "work_item_overview.custom_fields.required_badge": "Requis",
  "work_item_overview.custom_fields.row.required": "Requis",
  "work_item_overview.custom_fields.row.required_toggle": "Basculer requis pour {name}",
  "work_item_overview.custom_fields.row.remove": "Retirer {name}",
  "work_item_overview.custom_fields.row.edit": "Modifier {name}",
  "work_item_overview.custom_fields.row.edit_value": "Modifier la valeur",
  "work_item_overview.custom_fields.row.save": "Enregistrer",
  "work_item_overview.custom_fields.row.cancel": "Annuler",
  "work_item_overview.custom_fields.empty_value": "—",
  "work_item_overview.custom_fields.picker.title": "Ajouter un champ global",
  "work_item_overview.custom_fields.picker.search_placeholder": "Rechercher les champs globaux…",
  "work_item_overview.custom_fields.picker.empty": "Aucun champ global disponible.",
  "work_item_overview.custom_fields.picker.empty_link": "Gérer les champs",
  "work_item_overview.custom_fields.picker.no_matches": "Aucun résultat.",
  "work_item_overview.custom_fields.picker.already_added": "Déjà ajouté",
  "work_item_overview.custom_fields.remove_confirm.title":
    "Retirer « {name} » de cet élément de travail ?",
  "work_item_overview.custom_fields.remove_confirm.body":
    "Êtes-vous sûr de vouloir retirer ce champ de cet élément de travail ? Les valeurs saisies pour ce champ seront conservées sur cet élément mais le champ ne sera plus visible.",
  "work_item_overview.custom_fields.remove_confirm.cancel": "Annuler",
  "work_item_overview.custom_fields.remove_confirm.confirm": "Retirer",
  "project_overview.health": "Santé",
  "project_overview.health.not_started": "Non démarré",
  "project_overview.health.on_track": "En bonne voie",
  "project_overview.health.at_risk": "À risque",
  "project_overview.health.off_track": "Hors piste",
  "project_overview.health.completed": "Terminé",
  "project_overview.health_fallback_warning":
    "La précision de la santé est limitée, car aucun élément de travail n’a d’heures estimées. Cette indication utilise donc plutôt le pourcentage d’achèvement.",
  "project.health_tooltip.accessible_label":
    "Santé du projet : {health}. Placez le focus pour obtenir des détails.",
  "project.health_tooltip.not_started":
    "Non démarré signifie que le projet n’a pas encore atteint sa date de début prévue. Aucun progrès n’est donc attendu pour le moment.",
  "project.health_tooltip.on_track":
    "En bonne voie signifie que les heures saisies suivent le rythme de la période planifiée déjà écoulée.",
  "project.health_tooltip.at_risk":
    "À risque signifie que les heures saisies sont légèrement en retard par rapport à la période planifiée déjà écoulée.",
  "project.health_tooltip.off_track":
    "Hors piste signifie que les heures saisies sont nettement en retard par rapport à la période planifiée déjà écoulée.",
  "project.health_tooltip.completed":
    "Terminé signifie qu’une date d’achèvement est enregistrée pour le projet.",
  "project.health_tooltip.recalculated": "Dernier calcul : {when}.",
  "project.health_tooltip.recalculation_trigger":
    "Cette indication est mise à jour après une modification du projet, de ses éléments de travail ou des heures qui y sont consignées.",
  "project_overview.hours_summary": "Heures",
  "project_overview.hours_estimated": "Estimées",
  "project_overview.hours_actual": "Enregistrées",
  "project_overview.hours_remaining": "Restantes",
  "project_overview.stage_progress": "Progression des étapes",
  "project_overview.stage_current": "En cours",
  "project_overview.stage_done": "Terminé",
  "project_overview.no_process": "Aucun processus sélectionné.",
  "project_overview.flags": "Signalements",
  "project_overview.no_flags": "Aucun signalement actif.",
  "project_overview.flags_overdue": "{count} élément(s) de travail en retard",
  "project_overview.flags_hours_overrun": "{count} élément(s) de travail dépassant leur estimation",
  "project_overview.tab_overview": "Vue d'ensemble",
  "project_overview.tab_activity": "Activité",
  "project_overview.tab_comments": "Commentaires",
  "project_overview.comments": "Commentaires",
  "project_overview.comments_empty": "Aucun commentaire pour le moment.",
  "project_overview.comments_placeholder": "Ajouter un commentaire",
  "project_overview.comment_submit": "Publier le commentaire",
  // Program overview page, its edit dialog and the program settings page (NG-2579)
  "program_overview.page.add_projects": "Ajouter des projets",
  "program_overview.page.add_projects_search": "Rechercher des projets...",
  "program_overview.page.add_projects_empty": "Aucun projet à ajouter",
  "program_overview.page.add_projects_selected":
    "{count, plural, one {{countText} sélectionné} other {{countText} sélectionnés}}",
  "program_overview.page.add_projects_confirm": "Ajouter",
  "program_overview.page.projects_added": "Projets ajoutés",
  "program_overview.page.projects_add_error": "Échec de l'ajout des projets",
  "program_overview.page.project_removed": "Projet retiré",
  "program_overview.page.project_remove_error": "Échec du retrait du projet",
  "program_overview.page.load_failed_title": "Impossible de charger ce programme",
  "program_overview.page.no_projects":
    "Aucun projet lié pour l'instant. Cliquez sur « Ajouter des projets » pour lier des projets à ce programme.",
  "program_overview.page.no_projects_read_only": "Aucun projet lié pour l'instant.",
  "program_overview.page.identifier": "ID : {identifier}",
  "program_overview.page.no_owner": "Aucun propriétaire",
  "program_overview.page.details": "Détails",
  "program_overview.page.settings_aria": "Paramètres du programme",
  "program_overview.page.activity_aria": "Activité",
  "program_overview.page.comments_aria": "Commentaires",
  "program_overview.page.more_options_aria": "Plus d'options",
  "program_overview.page.edit": "Modifier",
  "program_overview.page.restore": "Restaurer",
  "program_overview.page.archive": "Archiver",
  "program_overview.page.delete": "Supprimer",
  "program_overview.page.comments_title": "Commentaires",
  "program_overview.page.close_comments": "Fermer les commentaires",
  "program_overview.page.update_error": "Échec de la mise à jour du programme",
  "program_overview.page.archive_title": "Archiver le programme",
  "program_overview.page.archive_description":
    "Archiver « {name} » ? Les programmes archivés n'apparaîtront plus dans les listes mais resteront disponibles pour les rapports.",
  "program_overview.page.archive_confirm": "Archiver",
  "program_overview.page.archived": "Programme archivé",
  "program_overview.page.unarchived": "Programme restauré",
  "program_overview.page.unarchive_error": "Échec de la restauration du programme",
  "program_overview.page.delete_title": "Supprimer le programme",
  "program_overview.page.delete_description":
    "Supprimer « {name} » ? Cette action est irréversible.",
  "program_overview.page.delete_confirm": "Supprimer",
  "program_overview.page.deleted": "Programme supprimé",
  "program_overview.health.title": "Santé",
  "program_overview.health.on_track": "En bonne voie",
  "program_overview.health.at_risk": "À risque",
  "program_overview.health.off_track": "Hors piste",
  "program_overview.health.not_started": "Non démarré",
  "program_overview.health.completed": "Terminé",
  "program_overview.edit_dialog.title": "Modifier le programme",
  "program_overview.edit_dialog.name_label": "Nom *",
  "program_overview.edit_dialog.name_placeholder": "Nom du programme",
  "program_overview.edit_dialog.owner_label": "Propriétaire",
  "program_overview.edit_dialog.owner_placeholder": "Aucun propriétaire",
  "program_overview.edit_dialog.owner_empty": "Aucun membre trouvé",
  "program_overview.edit_dialog.updated": "Programme mis à jour",
  "program_overview.edit_dialog.update_error": "Échec de la mise à jour du programme",
  "program_settings.title": "Paramètres",
  "program_settings.denied_title": "Vous ne pouvez pas modifier ce programme",
  "program_settings.denied_description":
    "La modification d'un programme est réservée à son propriétaire, aux responsables des équipes avec lesquelles il est partagé et aux administrateurs de l'espace de travail. Vous pouvez toujours consulter le programme.",
  "program_settings.back": "Retour au programme",
  "program_overview.kpis.title": "Livraison",
  "program_overview.kpis.last_calculated": "Dernier calcul : {when}",
  "program_overview.kpis.last_calculated_help":
    "Recalculé uniquement lorsqu’un élément du programme change ; un programme inactif paraît donc plus ancien qu’il ne l’est.",
  "program_overview.kpis.pipeline_last_run":
    "Le pipeline de métriques s’est exécuté pour la dernière fois {when}.",
  "program_overview.kpis.not_computed":
    "Pas encore calculé — ces chiffres apparaissent quelques minutes après la première modification du programme.",
  "program_overview.kpis.progress": "Progression du programme",
  "program_overview.kpis.progress_sub": "D’après les tâches terminées dans les projets liés",
  "program_overview.kpis.hours_logged": "Heures saisies",
  "program_overview.kpis.hours_of_estimate": "/ {estimated} est.",
  "program_overview.kpis.hours_sub": "{cost} de coût de main-d’œuvre",
  "program_overview.kpis.hours_window": "Saisies à ce jour",
  "program_overview.kpis.projects": "Projets",
  "program_overview.kpis.overdue": "Projets en retard",
  "program_overview.kpis.overdue_of": "sur {total}",
  "program_overview.kpis.overdue_sub": "{name} — {days} jours de retard",
  "program_overview.kpis.overdue_none": "Aucun projet ne dépasse sa date d’échéance",
  "program_overview.kpis.content_delivery": "Diffusion des contenus",
  "program_overview.kpis.content_delivery_sub":
    "{count, plural, one {Au niveau du cours, d’après # projet lié : couvre tous les apprenants que le LMS affiche sur ce contenu, pas uniquement le public du projet} other {Au niveau du cours, d’après # projets liés : couvre tous les apprenants que le LMS affiche sur leurs contenus, pas uniquement le public des projets}}",
  "program_overview.kpis.content_delivery_none": "Aucun projet lié n’a encore de résultats LMS",
  // Program overview: linked projects and requests tables (NG-2579)
  "program_overview.linked_projects.column_project": "Projet",
  "program_overview.linked_projects.column_identifier": "Identifiant",
  "program_overview.linked_projects.column_owner": "Propriétaire",
  "program_overview.linked_projects.column_status": "Statut",
  "program_overview.linked_projects.column_health": "Santé",
  "program_overview.linked_projects.column_goals": "Objectifs",
  "program_overview.linked_projects.column_progress": "Progression",
  "program_overview.linked_projects.column_effort_share": "Effort %",
  "program_overview.linked_projects.column_due_date": "Échéance",
  "program_overview.linked_projects.goals_aria": "Objectifs · {name}",
  "program_overview.linked_projects.goals_search": "Rechercher des objectifs…",
  "program_overview.linked_projects.actions_aria": "Actions pour {name}",
  "program_overview.linked_projects.remove": "Retirer",
  "program_overview.linked_requests.column_request": "Demande",
  "program_overview.linked_requests.column_status": "Statut",
  "program_overview.linked_requests.column_requested_by": "Demandé par",
  "program_overview.linked_requests.column_submitted": "Soumis le",
  "program_overview.linked_requests.column_form": "Formulaire",
  "program_overview.linked_requests.untitled": "Demande",
  "program_overview.linked_requests.actions_aria": "Actions pour {name}",
  "program_overview.linked_requests.actions_fallback_name": "la demande",
  "program_overview.linked_requests.remove": "Retirer",
  "program_overview.goals_update_failed": "Impossible de mettre à jour les objectifs du projet",
  "program_overview.alignment.aligned": "Alignés sur des objectifs",
  "program_overview.alignment.unaligned": "Non alignés",
  "program_overview.alignment.aligned_sub": "{count} sur {total} liés à au moins un objectif",
  "program_overview.alignment.unaligned_sub": "{count} sur {total} liés à aucun objectif",
  "program_overview.alignment.unaligned_button": "{count} non alignés",
  "program_overview.alignment.no_projects": "Aucun projet dans ce programme pour l’instant",
  "program_overview.kpis.projects_by_status": "Projets par statut",
  "program_overview.kpis.projects_by_health": "Projets par état de santé",
  "program_overview.kpis.projects_by_effort": "Projets par effort",
  "program_overview.kpis.no_status": "Sans statut",
  "program_overview.name_label": "Nom du programme",
  "program_overview.kpis.more_slices": "+{count} de plus",
  "program_overview.filtered_notice": "{count} projets affichés sur {total}",
  "program_overview.clear_filter": "Effacer le filtre",
  "program_overview.linked_requests.heading": "Demandes liées",
  "program_overview.linked_requests.count": "{count, plural, one {# demande} other {# demandes}}",
  "program_overview.linked_requests.empty":
    "Aucune demande n'est encore liée à ce programme. Ajoutez-en ici, ou choisissez ce programme dans le formulaire d'une demande.",
  "program_overview.linked_requests.empty_read_only":
    "Aucune demande n'est encore liée à ce programme. Une demande est liée lorsque ce programme est choisi dans son formulaire.",
  "program_overview.linked_requests.remove_error": "Échec du retrait de la demande de ce programme",
  "program_overview.linked_requests.added":
    "{count, plural, one {# demande ajoutée} other {# demandes ajoutées}}",
  "program_overview.linked_requests.add_failed":
    "{count, plural, one {# demande n'a pas pu être ajoutée} other {# demandes n'ont pas pu être ajoutées}}",
  "program_overview.add_requests.button": "Ajouter des demandes",
  "program_overview.add_requests.title": "Ajouter des demandes à {program}",
  "program_overview.add_requests.description":
    "Choisissez les demandes auxquelles ce programme répond. La réponse Programme de chaque demande est mise à jour en conséquence.",
  "program_overview.add_requests.search_label": "Rechercher des demandes",
  "program_overview.add_requests.search_placeholder":
    "Rechercher par nom, formulaire ou identifiant (R-284)",
  "program_overview.add_requests.clear_search": "Effacer la recherche",
  "program_overview.add_requests.results_label": "Demandes",
  "program_overview.add_requests.already_linked": "Déjà liée",
  "program_overview.add_requests.selected_count": "{count} sélectionnée(s)",
  "program_overview.add_requests.more_results":
    "Affichage des {shown} correspondances les plus récentes. Affinez avec la recherche.",
  "program_overview.add_requests.submit":
    "{count, plural, =0 {Ajouter des demandes} one {Ajouter # demande} other {Ajouter # demandes}}",
  "program_overview.add_requests.no_matches_title": "Aucune demande ne correspond à « {query} »",
  "program_overview.add_requests.no_matches_description":
    "Essayez un nom de demande, un formulaire ou un identifiant comme R-284.",
  "program_overview.add_requests.none_title": "Aucune demande pour l'instant",
  "program_overview.add_requests.none_description":
    "Les demandes apparaissent ici dès que quelqu'un en soumet une.",
  "program_overview.add_requests.load_error_title": "Impossible de charger les demandes",
  "program_overview.add_requests.load_error_description":
    "Une erreur est survenue lors du chargement de la liste. Votre sélection est conservée.",
  "program_overview.add_requests.retry": "Réessayer",
  "program_overview.comments_empty": "Aucun commentaire pour le moment.",
  "program_overview.comments_placeholder": "Ajouter un commentaire",
  "program_overview.comment_submit": "Publier le commentaire",
  // Program properties panel, description and details sheet (NG-2579)
  "program_overview.properties.owner": "Propriétaire",
  "program_overview.restricted_warning_title":
    "Ce programme contient un projet réservé à ses équipes",
  "program_overview.restricted_warning":
    "Ce programme contient un projet réservé à ses équipes. Les membres qui n'ont pas accès à ce projet n'en verront pas les détails.",
  "program_overview.restricted_warning_confirm": "Continuer",
  "program_overview.properties.owner_placeholder": "Aucun propriétaire",
  "program_overview.properties.owner_empty": "Aucun membre trouvé",
  "program_overview.properties.owner_for_new_teams_title":
    "Choisissez un nouveau propriétaire pour enregistrer le changement d'équipes",
  "program_overview.properties.owner_for_new_teams_description":
    "Le propriétaire actuel ne fait partie d'aucune des nouvelles équipes. Choisissez un propriétaire qui en fait partie, ou conservez les équipes actuelles.",
  "program_overview.properties.keep_current_teams": "Conserver les équipes actuelles",
  "program_overview.properties.owner_disconnected_title":
    "Le responsable du programme ne fait pas partie de ses équipes",
  "program_overview.properties.owner_disconnected_description":
    "Il ne fait plus partie de ses équipes principales ou de livraison, ni des équipes au-dessus. Réintégrez-le, ou choisissez un responsable qui en fait partie.",
  "program_overview.properties.status": "Statut",
  "program_overview.properties.status_aria": "Statut",
  "program_overview.properties.start_date": "Date de début",
  "program_overview.properties.start_date_placeholder": "Définir la date de début",
  "program_overview.properties.end_date": "Date de fin",
  "program_overview.properties.end_date_placeholder": "Définir la date de fin",
  "program_overview.properties.set_date": "Définir la date",
  "program_overview.properties.delivery_teams": "Équipes de livraison",
  "program_overview.properties.delivery_teams_about": "À propos des équipes de livraison",
  "program_overview.properties.delivery_teams_tooltip":
    "Les membres des équipes sélectionnées et des équipes au-dessus d'elles peuvent voir ce programme, tout comme son responsable de programme, ses membres directs et les administrateurs.",
  "program_overview.properties.teams_placeholder": "Sélectionner des équipes",
  "program_overview.properties.teams_empty": "Aucune équipe disponible",
  "program_overview.properties.goals": "Objectifs",
  "program_overview.properties.goals_placeholder": "Sélectionner des objectifs…",
  "program_overview.properties.goals_search": "Rechercher des objectifs…",
  "program_overview.properties.goals_empty": "Aucun objectif disponible",
  "program_overview.properties.goals_aria": "Sélectionner des objectifs",
  "program_overview.properties.created": "Créé",
  "program_overview.description.heading": "Description",
  "program_overview.description.empty": "Aucune description",
  "program_overview.description.aria": "Description du programme",
  "program_overview.description.save_error": "Échec de l'enregistrement de la description",
  "program_overview.details.title": "Détails",
  "program_overview.details.close": "Fermer les détails",
  "program_overview.activity.no_match": "Aucune activité correspondante.",

  // Locale
  "locale.en": "EN",
  "locale.fr": "FR",

  // Favorites
  "favorite.add": "Ajouter aux favoris",
  "favorite.add_error": "Impossible d'ajouter le favori",
  "favorite.expand_folder": "Développer {name}",
  "favorite.collapse_folder": "Replier {name}",
  "favorite.folder_name_placeholder": "Nom du nouveau dossier",
  "favorite.folder_create_error": "Échec de la création du dossier",
  "favorite.rename_folder": "Renommer",
  "favorite.delete_folder": "Supprimer le dossier",
  "favorite.remove": "Retirer des favoris",
  "favorite.remove_error": "Échec de la suppression du favori",
  "favorite.move_to_root": "Déplacer à la racine",
  "favorite.move_error": "Échec du déplacement du favori",
  "favorite.item_actions": "Actions pour {name}",
  "favorite.rename_error": "Échec du renommage du dossier",
  "favorite.rename_folder_input": "Renommer {name}",

  // Greeting (My Work landing page) + relative-time strings (team activity feed)
  "home.good_morning": "Bonjour, {name}",
  "home.good_afternoon": "Bon après-midi, {name}",
  "home.good_evening": "Bonsoir, {name}",
  "home.recents.just_now": "À l'instant",
  "home.recents.minutes_ago": "il y a {count}m",
  "home.recents.hours_ago": "il y a {count}h",
  "home.recents.days_ago": "il y a {count}j",

  // Accessibility
  "project.more_options": "Plus d'options",
  "common.close": "Fermer",
  "common.unsaved_changes.title": "Abandonner les modifications ?",
  "common.unsaved_changes.description":
    "Ce que vous avez saisi ici n'a pas été enregistré et sera perdu.",
  "common.unsaved_changes.discard": "Abandonner les modifications",
  "common.unsaved_changes.keep_editing": "Continuer l'édition",

  // Les dix pastilles, nommées. Un code hexadécimal ne se lit pas à voix haute,
  // et c'est ce qu'un lecteur d'écran annonce sans ces libellés (NG-1594).
  "common.color.gray": "Gris",
  "common.color.blue": "Bleu",
  "common.color.green": "Vert",
  "common.color.yellow": "Jaune",
  "common.color.orange": "Orange",
  "common.color.red": "Rouge",
  "common.color.purple": "Violet",
  "common.color.pink": "Rose",
  "common.color.sky": "Ciel",
  "common.color.teal": "Sarcelle",
  "common.color.set_to": "Définir la couleur sur {color}",
  "common.color.selected": "Couleur : {color}",
  "common.color.choose": "Choisir une couleur",
  "common.color.custom": "Personnalisé",

  // Command Palette
  "command.palette_title": "Palette de commandes",
  "command.palette_description": "Rechercher une commande à exécuter...",
  "command.palette_empty": "Aucune commande correspondante",
  "command.quick_actions": "Actions rapides",
  "command.group_projects": "Projets",
  "command.group_issues": "Éléments de travail",
  "command.group_workspaces": "Espaces de travail",
  "command.nav_your_work": "Aller à Mon travail",
  "command.nav_browse": "Parcourir tous les éléments",
  "command.nav_projects": "Parcourir les projets",
  "command.nav_notifications": "Ouvrir les notifications",
  "command.create_project": "Créer un projet",
  "command.create_work_item": "Créer un élément de travail",
  "command.toggle_theme": "Basculer le thème clair/sombre",
  "command.toggle_language": "Changer de langue (EN / FR)",
  "command.sign_out": "Se déconnecter",
  "command.searching": "Recherche…",
  "command.search_error": "Échec de la recherche",

  // My Work & Browse
  "my_work.title": "Mon travail",
  "my_work.tab_assigned": "Qui me sont assignés",
  "my_work.tab_created": "Créés par moi",
  "my_work.tab_subscribed": "Suivis",
  "my_work.time_off.title": "Absences à venir",
  "my_work.time_off.today": "Aujourd'hui",
  "my_work.time_off.tomorrow": "Demain",
  "my_work.time_off.in_days": "{days, plural, one {Dans # jour} other {Dans # jours}}",
  "my_work.time_off.day_count": "{days, plural, one {# jour} other {# jours}}",
  "my_work.time_off.empty_title": "Aucune absence à venir",
  "my_work.time_off.description":
    "Ajoutez des absences qui réduisent votre capacité disponible dans les vues de capacité et de planification.",
  "my_work.time_off.empty_description":
    "Ajoutez une absence pour bloquer votre capacité disponible. Les jours fériés d'un calendrier qui vous couvre apparaissent ici automatiquement.",
  "my_work.time_off.holiday_badge": "Jour férié",
  "my_work.cards.assigned": "Travail en cours",
  "my_work.cards.availability": "Utilisation",
  "my_work.assigned.overdue": "en retard",
  "my_work.assigned.days_late":
    "{days, plural, one {jusqu'à # jour de retard} other {jusqu'à # jours de retard}}",
  "my_work.assigned.need_review": "à examiner",
  "my_work.assigned.due_this_week": "à rendre cette semaine",
  "my_work.assigned.due_later": "à rendre après cette semaine",
  "my_work.assigned.no_due_date": "sans échéance",
  "my_work.assigned.empty_title": "Vous êtes à jour.",
  "my_work.assigned.empty_sub": "Vos tâches, événements et demandes en cours apparaîtront ici.",
  "my_work.cards.availability_left": "{hours} h restantes",
  "my_work.cards.availability_sub": "{percent} % utilisé cette semaine",
  "my_work.cards.availability_sub_next": "{percent} % utilisé la semaine prochaine",
  "my_work.availability.empty": "Aucune heure de travail définie pour cette semaine.",
  "my_work.availability.empty_cta": "Définir mes heures de travail",
  "my_work.availability.error": "Impossible de charger la disponibilité.",
  "my_work.table.title": "Votre travail",
  "my_work.table.placeholder": "Vos tâches, événements et demandes apparaîtront ici.",
  "my_work.mentions.title": "Mentions",
  "my_work.mentions.unread_title": "Mentions non lues",
  "my_work.mentions.empty_title": "Aucune mention pour l'instant.",
  "my_work.mentions.no_unread_title": "Aucune mention non lue.",
  "my_work.mentions.no_unread_body":
    "Les nouvelles mentions vous concernant apparaissent ici. Utilisez « Voir tout » pour les précédentes.",
  "my_work.mentions.placeholder": "Les mentions vous concernant apparaîtront ici.",
  "my_work.mentions.view_all": "Voir tout",
  "my_work.mentions.unread": "Non lue",
  "my_work.time_off.view": "Voir les absences",
  "my_work.col.name": "Nom",
  "my_work.col.project": "Projet",
  "my_work.col.type": "Type",
  "my_work.col.status": "Statut",
  "my_work.col.priority": "Priorité",
  "my_work.col.due_date": "Échéance",
  "my_work.col.actual_hours": "Heures réelles",
  "my_work.col.blocked_by": "Bloqué par",
  "my_work.type.task": "Tâche",
  "my_work.type.event": "Événement",
  "my_work.type.request": "Demande",
  "my_work.group_by.label": "Grouper par",
  "my_work.group_by.none": "Aucun",
  "my_work.group_by.type": "Type",
  "my_work.group_by.project": "Projet",
  "my_work.group_by.no_project": "Aucun projet",
  "my_work.group_by.toggle": "Basculer {label}",
  "my_work.search.placeholder": "Rechercher dans votre travail…",
  "work_items.title": "Tâches",
  "work_items.description": "Tous les éléments de travail des projets",
  "work_items.create": "Créer une tâche",
  "work_items.export": "Exporter les tâches",

  // Goals list, create dialog and Edit Goal page (NG-2578)
  "goals.list.title": "Objectifs",
  "goals.list.count_noun": "objectifs",
  "goals.list.new_goal": "Nouvel objectif",
  "goals.list.column_name": "Nom",
  "goals.list.column_status": "Statut",
  "goals.list.column_metrics": "Indicateurs",
  "goals.list.column_progress": "Progression",
  "goals.list.empty_title": "Aucun objectif pour l'instant",
  "goals.list.empty_description":
    "Les objectifs relient le travail de votre équipe à des résultats mesurables. Créez-en un pour commencer à suivre les indicateurs clés qui comptent.",
  "goals.create.title": "Nouvel objectif",
  "goals.create.name_label": "Nom *",
  "goals.create.name_placeholder": "p. ex. Augmenter le taux d'achèvement des cours",
  "goals.create.description_label": "Description",
  "goals.create.description_placeholder": "À quoi ressemble la réussite ?",
  "goals.create.submit": "Créer",
  "goals.create.created": "Objectif créé",
  "goals.create.error": "Échec de la création de l'objectif",
  "goals.detail.back_aria": "Retour aux objectifs",
  "goals.detail.back_link": "Objectifs",
  "goals.detail.name_aria": "Nom de l'objectif",
  "goals.detail.status_aria": "Statut",
  "goals.detail.delete_aria": "Supprimer l'objectif",
  "goals.detail.description_label": "Description",
  "goals.detail.description_placeholder": "À quoi ressemble la réussite ?",
  "goals.detail.linked_projects": "Projets liés",
  "goals.detail.linked_programs": "Programmes liés",
  "goals.detail.linked_requests": "Demandes liées",
  "goals.detail.updated": "Objectif mis à jour",
  "goals.detail.update_error": "Échec de la mise à jour de l'objectif",
  "goals.detail.delete_title": "Supprimer « {name} » ?",
  "goals.detail.delete_description":
    "L'objectif, ses indicateurs et leurs valeurs enregistrées, ainsi que ses liens vers des projets et des programmes, seront supprimés partout. Cette action est irréversible.",
  "goals.detail.delete_confirm": "Supprimer l'objectif",
  "goals.detail.deleted": "Objectif supprimé",
  "goals.detail.delete_error": "Échec de la suppression de l'objectif",
  "goals.detail.add_lead_error": "Échec de l'ajout du responsable de l'objectif",
  "goals.detail.remove_lead_error": "Échec du retrait du responsable de l'objectif",
  "goals.detail.link_error.project": "Échec de la liaison du projet",
  "goals.detail.link_error.program": "Échec de la liaison du programme",
  "goals.detail.link_error.request": "Échec de la liaison de la demande",
  "goals.detail.unlink_error.project": "Échec de la suppression du lien avec le projet",
  "goals.detail.unlink_error.program": "Échec de la suppression du lien avec le programme",
  "goals.detail.unlink_error.request": "Échec de la suppression du lien avec la demande",

  // Modules
  // Archives
  "archives.tabs.work_items": "Éléments de travail",
  "archives.archived_on": "Archivé le {date}",
  "archives.issues.title": "Éléments de travail archivés",
  "archives.issues.subtitle":
    "Consultez, restaurez ou supprimez définitivement les éléments de travail archivés.",
  "archives.issues.empty_title": "Aucun élément de travail archivé",
  "archives.issues.empty_description": "Archivez un élément de travail pour le retrouver ici.",
  "archives.issues.empty_filtered_title":
    "Aucun élément de travail archivé ne correspond à vos filtres",
  "archives.issues.empty_filtered_description":
    "Ajustez les filtres ou effacez la recherche pour voir tous les éléments archivés.",
  "archives.issues.bulk.restore": "Restaurer la sélection",
  "archives.issues.bulk.delete": "Supprimer la sélection",
  "archives.issues.bulk.restore_success": "{count} élément(s) restauré(s)",
  "archives.issues.bulk.delete_success": "{count} élément(s) supprimé(s)",
  "archives.issues.bulk.restore_partial":
    "{succeeded} élément(s) sur {total} restauré(s) ; {failed} n’ont pas pu être restauré(s)",
  "archives.issues.bulk.archive_partial":
    "{succeeded} élément(s) sur {total} archivé(s) ; {failed} n’ont pas pu être archivé(s)",

  // Notifications
  "notifications.title": "Notifications",
  "notifications.tab.all": "Toutes",
  "notifications.tab.mentions": "Mentions",
  "notifications.action.refresh": "Actualiser",
  "notifications.action.mark_all_read": "Tout marquer comme lu",
  "notifications.action.mark_read": "Marquer comme lu",
  "notifications.action.mark_unread": "Marquer comme non lu",
  "notifications.action.more_aria": "Plus d'actions pour {title}",
  "notifications.action.archive": "Archiver",
  "notifications.action.unarchive": "Restaurer",
  "notifications.action.snooze": "Reporter",
  "notifications.action.unsnooze": "Annuler le report",
  "notifications.action.load_more": "Charger plus",
  "notifications.bell.open": "Ouvrir les notifications",
  "notifications.bell.empty": "Aucune notification.",
  "notifications.bell.loading": "Chargement des notifications...",
  "notifications.bell.view_all": "Voir toutes les notifications",
  "notifications.row.unknown_user": "Quelqu'un",
  "notifications.row.unread": "Non lue",
  "notifications.group.today": "Aujourd'hui",
  "notifications.group.yesterday": "Hier",
  "notifications.summary.fields_updated":
    "{actor} a mis à jour {count, plural, =1 {{first}} =2 {{first} et {second}} other {{first}, {second} et {extra} de plus}}",
  "notifications.summary.untitled_field": "Champ sans titre",
  "notifications.entity.project": "Projet",
  "notifications.entity.program": "Programme",
  "notifications.entity.goal": "Objectif",
  "notifications.entity.work_item": "Élément de travail",
  "notifications.entity.request": "Demande",
  "notifications.entity.report": "Rapport",
  "notifications.account.type.profile": "Profil mis à jour",
  "notifications.account.type.time_off": "Congé planifié",
  "notifications.account.type.role": "Rôle mis à jour",
  "notifications.account.type.workspace": "Accès à l'espace de travail",
  "notifications.account.type.team_member": "Appartenance à l'équipe",
  "notifications.account.type.team_automations": "Automatisations de l'équipe",
  "notifications.account.type.update": "Mise à jour",
  "notifications.account.type.team_deleted": "Équipe supprimée",
  "notifications.account.cta.teams": "Aller aux équipes",
  "notifications.account.cta.reassign": "Ouvrir la réattribution",
  "notifications.account.cta.automations": "Ouvrir les automatisations",
  "notifications.account.type.automation_stopped": "Automatisation arrêtée",
  "notifications.account.field.dates": "Dates",
  "notifications.account.field.role": "Rôle",
  "notifications.filter.title": "Filtres",
  "notifications.filter.view.active": "Actives",
  "notifications.filter.view.archived": "Archivées",
  "notifications.filter.view.snoozed": "Reportées",
  "notifications.filter.unread_only": "Non lues uniquement",
  "notifications.filter.clear": "Effacer les filtres",
  "notifications.empty.active": "Tout est à jour.",
  "notifications.empty.mentions": "Aucune mention pour le moment.",
  "notifications.empty.archived": "Aucune notification archivée.",
  "notifications.empty.snoozed": "Aucune notification reportée.",
  "notifications.empty.filtered": "Aucune notification ne correspond à vos filtres.",
  "notifications.detail.placeholder.title": "Sélectionnez une notification",
  "notifications.detail.placeholder.description":
    "Choisissez une notification dans la liste pour voir ses détails.",
  "notifications.detail.error.title": "Impossible de charger cette notification.",
  "notifications.detail.error.description": "Essayez d'actualiser ou de choisir une autre ligne.",
  "notifications.detail.inbox.title": "Élément de réception",
  "notifications.detail.inbox.description":
    "Cette notification concerne une demande de réception. Ouvrez-la pour continuer.",
  "notifications.detail.inbox.cta": "Ouvrir l'élément",
  "notifications.request.type.status": "Statut de la demande",
  "notifications.request.type.updated": "Demande mise à jour",
  "notifications.request.type.commented": "Nouveau commentaire",
  "notifications.request.type.page_ready": "Votre contribution est requise",
  "notifications.request.type.review_requested": "Révision requise",
  "notifications.request.field.status": "Statut",
  "notifications.request.field.comment": "Commentaire",
  "notifications.request.field.step": "Étape",
  "notifications.request.field.message": "Message",
  "notifications.request.cta.view": "Voir la demande",
  "notifications.project.type.status": "Statut du projet",
  "notifications.project.type.updated": "Projet mis à jour",
  "notifications.project.type.deleted": "Projet supprimé",
  "notifications.project.field.status": "Statut",
  "notifications.project.cta.view": "Voir le projet",
  "notifications.program.type.status": "Statut du programme",
  "notifications.program.type.updated": "Programme mis à jour",
  "notifications.program.field.status": "Statut",
  "notifications.program.cta.view": "Voir le programme",
  "notifications.goal.type.status": "Statut de l'objectif",
  "notifications.goal.type.updated": "Objectif mis à jour",
  "notifications.goal.type.lead": "Responsable de l'objectif",
  "notifications.goal.field.status": "Statut",
  "notifications.goal.cta.view": "Voir l'objectif",
  "notifications.work_item.type.status": "Statut de la tâche",
  "notifications.work_item.type.updated": "Tâche mise à jour",
  "notifications.work_item.type.deleted": "Tâche supprimée",
  "notifications.work_item.type.due": "Date d'échéance",
  "notifications.work_item.field.status": "Statut",
  "notifications.work_item.field.due": "Date d'échéance",
  "notifications.work_item.cta.view": "Voir la tâche",
  "notifications.report.type.complete": "Rapport prêt",
  "notifications.report.type.failed": "Échec du rapport",
  "notifications.report.type.updated": "Rapport mis à jour",
  "notifications.report.type.export_ready": "Export prêt",
  "notifications.report.cta.view": "Voir le rapport",
  "notifications.report.export_ready.cta": "Télécharger le CSV",
  "notifications.error.load": "Impossible de charger vos notifications.",
  "notifications.error.retry": "Réessayer",
  "notifications.error.mutation": "Cette action a échoué. Veuillez réessayer.",
  "notifications.toast.archived": "Notification archivée",
  "notifications.toast.unarchived": "Notification restaurée",
  "notifications.toast.snoozed": "Notification reportée",
  "notifications.toast.unsnoozed": "Report annulé",
  "notifications.toast.all_read": "Toutes les notifications marquées comme lues",
  "notifications.snooze.title": "Reporter la notification",
  "notifications.snooze.preset.one_hour": "1 heure",
  "notifications.snooze.preset.tomorrow": "Demain",
  "notifications.snooze.preset.next_week": "La semaine prochaine",
  "notifications.snooze.custom": "Personnalisé...",
  "notifications.snooze.confirm": "Reporter",
  "notifications.snooze.cancel": "Annuler",
  "notifications.mobile.back": "Retour aux notifications",

  // Events
  "events.schedule.title": "Horaire",
  "events.schedule.start": "Début",
  "events.schedule.due": "Échéance",
  "events.status.draft": "Brouillon",
  "events.status.past": "Passé",
  "events.status.upcoming": "À venir",

  "events.list.title": "Événements",
  "events.list.new": "Nouvel événement",
  "events.list.create": "Créer un événement",
  "events.list.export": "Exporter les événements",
  "events.list.count_one": "{count} événement",
  "events.list.count_other": "{count} événements",
  "events.list.not_scheduled": "Non planifié",
  "events.list.ends": "se termine {date}",
  "events.list.sessions.expand": "Afficher les sessions de {name}",
  "events.list.sessions.collapse": "Masquer les sessions de {name}",
  "events.view.list": "Liste",
  "events.view.timeline": "Chronologie",
  "events.filter.all": "Tous",
  "events.filter.upcoming": "À venir",
  "events.filter.past": "Passés",
  "events.list.empty.title_all": "Aucun événement",
  "events.list.empty.title_upcoming": "Aucun événement à venir",
  "events.list.empty.title_past": "Aucun événement passé",
  "events.list.empty.description_all": "Créez votre premier événement pour commencer.",
  "events.list.empty.description_filtered": "Modifiez le filtre pour voir davantage d'événements.",
  "events.duration.custom": "Personnalisé",
  "events.duration.minutes_short": "min",

  "events.create.discard": "Annuler",
  "events.create.submit": "Créer l'événement",
  "events.create.title_placeholder": "Titre de l'événement",
  "events.create.description_placeholder": "Ajouter une description...",
  "events.create.reschedule_label": "Choisir un autre créneau",
  "events.create.attendees_changed_warning":
    "Les personnes assignées ont changé — il peut y avoir des conflits de planification.",
  "events.create.recheck_availability": "Revérifier la disponibilité",
  "events.create.duration_adjusted":
    "L'heure de fin de l'événement a été ajustée pour la nouvelle durée. Vérifiez les conflits.",
  "events.create.created_success": "Événement créé",
  "events.create.create_failed": "Impossible de créer l'événement",
  "events.create.create_work_item": "Créer un élément de travail",
  "events.create.project": "Projet",
  "events.create.project_placeholder": "Sélectionner un projet",
  "events.create.project_required": "Sélectionnez d'abord un projet",

  "events.project.label": "Projet",
  "events.project.placeholder": "Sélectionner un projet",
  "events.project.none": "Aucun projet",
  "events.project.unknown": "Un projet que vous ne voyez pas",
  "events.home_team.label": "Équipe principale",
  "events.home_team.description":
    "Chaque événement appartient à une équipe principale — par son projet, ou définie directement s'il n'a pas de projet.",
  "events.home_team.group_aria": "Comment cet événement obtient son équipe principale",
  "events.home_team.link_project": "Lier à un projet",
  "events.home_team.link_project_hint":
    "Utilise l'équipe principale du projet et la suit si elle change.",
  "events.home_team.set_team": "Définir une équipe principale",
  "events.home_team.set_team_hint": "Pour un événement autonome sans projet.",
  "events.home_team.inherited": "Héritée du projet",
  "events.home_team.any_level":
    "Toute équipe, à n'importe quel niveau, peut être une équipe principale.",
  "events.home_team.pending_team":
    "Choisissez une équipe principale pour terminer. L'événement sera détaché de {project}. D'ici là, il garde son équipe principale actuelle.",
  "events.home_team.pending_team_unnamed":
    "Choisissez une équipe principale pour terminer. L'événement sera détaché de son projet. D'ici là, il garde son équipe principale actuelle.",
  "events.home_team.pending_project":
    "Choisissez un projet pour terminer. Son équipe principale remplacera {team}. D'ici là, rien ne change.",
  "events.home_team.pending_project_unnamed":
    "Choisissez un projet pour terminer. Son équipe principale deviendra celle de l'événement. D'ici là, rien ne change.",
  "events.home_team.keep_current": "Garder l'actuelle",
  "events.home_team.denied":
    "Vous avez besoin de la permission event.edit pour changer l'équipe principale de cet événement.",
  "events.home_team.standalone_denied":
    "Vous avez besoin de la permission event.create pour créer un événement sans projet.",
  "events.home_team.unknown_team": "Une équipe que vous ne voyez pas",
  "events.home_team.update_failed": "Impossible de changer l'équipe principale de l'événement.",
  "home_team_select.placeholder": "Sélectionner une équipe…",
  "home_team_select.search_placeholder": "Rechercher des équipes",
  "home_team_select.empty": "Aucune équipe trouvée",
  "events.status.default_placeholder": "Valeur par défaut de l'espace de travail",
  "issue.parent.label": "Parent",
  "issue.parent.none": "Aucun parent",
  "events.timezone.label": "Fuseau horaire",
  "events.utilization.title": "Utilisation",
  "events.utilization.hours_label": "Heures",
  "events.utilization.per_assignee": "par personne assignée",
  "events.utilization.all_day_placeholder": "la journée de travail de chaque personne assignée",
  "events.utilization.reset_to": "Rétablir à {hours} h",
  "events.utilization.reset_to_default": "Rétablir la valeur par défaut",
  "events.utilization.invalid": "Les heures doivent être de 0 ou plus.",
  "events.utilization.save_failed": "Impossible d'enregistrer les heures.",
  "events.timezone.unresolved":
    "Impossible de lire le fuseau horaire de l'événement ; l'horaire n'a pas été enregistré. Choisissez un fuseau horaire sur l'événement, puis réessayez.",
  "issue.parent.current": "parent actuel",
  "issue.parent.clear": "Effacer le parent",
  "issue.parent.search_placeholder": "Rechercher des éléments de travail...",
  "issue.parent.no_matches": "Aucun élément de travail trouvé",
  // Convertir en sous-tâche depuis la page d’un élément de premier niveau (NG-3472)
  "issue.convert_to_sub_item.action": "Convertir en sous-tâche",
  "issue.convert_to_sub_item.title": "Convertir en sous-tâche",
  "issue.convert_to_sub_item.description":
    "« {name} » deviendra une sous-tâche de l’élément de travail choisi et conservera toutes ses données.",
  "issue.convert_to_sub_item.checking": "Vérification de ce qui sera déplacé…",
  "issue.convert_to_sub_item.moves_to_parent":
    "{count, plural, one {# sous-tâche sera déplacée} other {# sous-tâches seront déplacées}} vers {parent}.",
  "issue.convert_to_sub_item.moves_under_event":
    "{count, plural, one {# élément situé} other {# éléments situés}} sous ses sessions {count, plural, one {remontera} other {remonteront}} directement sous lui.",
  "issue.convert_to_sub_item.in_background_note":
    "Cette conversion déplace beaucoup d’éléments de travail ; elle se terminera en arrière-plan.",
  "issue.convert_to_sub_item.blocked.other_project":
    "{count, plural, one {# sous-tâche est} other {# sous-tâches sont}} dans un autre projet.",
  "issue.convert_to_sub_item.blocked.too_deep":
    "{count, plural, one {# sous-tâche se retrouverait} other {# sous-tâches se retrouveraient}} à plus de deux niveaux de profondeur.",
  "issue.convert_to_sub_item.blocked.not_editable":
    "Vous n’avez pas l’autorisation de modifier {count} de ses sous-tâches.",
  "issue.convert_to_sub_item.blocked.parent_not_editable":
    "Vous n’avez pas l’autorisation de modifier la session dont {count, plural, one {# sous-tâche dépend} other {# sous-tâches dépendent}}.",
  "issue.convert_to_sub_item.check_failed":
    "Impossible de vérifier ce qui sera déplacé. Réessayez.",
  "issue.convert_to_sub_item.confirm": "Convertir",
  "issue.convert_to_sub_item.converting": "Conversion…",
  "issue.convert_to_sub_item.in_background": "Conversion de « {name} » en sous-tâche…",
  "issue.convert_to_sub_item.success": "« {name} » est maintenant une sous-tâche de {parent}.",
  "issue.convert_to_sub_item.error": "Impossible de convertir en sous-tâche.",
  "events.sessions.title": "Sessions",
  "events.sessions.add": "Ajouter une session",
  "events.sessions.name_placeholder": "Nom de la session",
  "events.sessions.empty": "Aucune session pour le moment.",
  "events.sessions.edit": "Modifier la session",
  "events.sessions.create_failed": "Impossible de créer la session",
  "events.sessions.update_failed": "Impossible de mettre à jour la session",
  "events.sessions.load_failed": "Impossible de charger les sessions",
  "events.sessions.bounds_hint": "Doit se situer dans l'événement : {start} – {end}.",
  "events.sessions.out_of_range":
    "Choisissez un début égal ou postérieur au début de l'événement et une fin égale ou antérieure à sa fin.",
  "events.sessions.start_label": "Début de la session",
  "events.sessions.end_label": "Fin de la session",
  "events.sessions.timezone_hint":
    "Les heures sont dans le fuseau horaire de l'événement ({timezone}).",
  "events.sessions.invalid_schedule": "Saisissez une heure de début et de fin valide.",
  "events.sessions.col_session": "Session",
  "events.sessions.col_start": "Début",
  "events.detail.category_update_failed": "Échec de la mise à jour de la catégorie",
  "events.detail.status_update_failed": "Échec de la mise à jour du statut",
  "events.detail.priority_update_failed": "Échec de la mise à jour de la priorité",
  "events.detail.stage_update_failed": "Échec de la mise à jour de l'étape",
  "events.detail.stage_needs_project": "Associez un projet pour définir une étape",
  "events.detail.dependencies_need_project": "Associez un projet pour ajouter des dépendances",
  "events.detail.qualifications_placeholder": "Ajouter des qualifications",
  "events.detail.qualifications_update_failed":
    "Échec de la mise à jour des qualifications de l'événement",
  "events.detail.color_update_failed": "Impossible de mettre à jour la couleur",
  "events.detail.parent_update_failed": "Impossible de mettre à jour le parent",
  "events.detail.timezone_update_failed": "Impossible de mettre à jour le fuseau horaire",
  "events.detail.assignee_update_failed": "Impossible de mettre à jour les personnes assignées",

  "events.detail.tabs_label": "Vues de l'événement",
  "events.detail.tab_overview": "Aperçu",
  "events.detail.tab_timeline": "Chronologie",
  "events.detail.name_label": "Nom de l'événement",
  "events.detail.more_actions": "Plus d'actions",
  "events.detail.activity": "Activité",
  "events.detail.delete": "Supprimer l'événement",
  "events.recurrence.recurring_event": "Événement récurrent",
  "events.recurrence.delete_series_title": "Supprimer l'événement récurrent",
  "events.recurrence.delete_series_description":
    "« {name} » est récurrent. Le supprimer retire toute la série et toutes ses occurrences. Cette action est irréversible.",
  "events.recurrence.make_recurring": "Rendre récurrent",
  "events.recurrence.make_recurring_title": "Rendre cet événement récurrent",
  "events.recurrence.make_recurring_description":
    "Choisissez un rythme de répétition. Cet événement devient la première occurrence de la série.",
  "events.recurrence.make_recurring_confirm": "Rendre récurrent",
  "events.recurrence.make_recurring_cancel": "Annuler",
  "events.recurrence.make_recurring_success": "L'événement est désormais récurrent",
  "events.recurrence.make_recurring_error": "Échec de la mise en récurrence de l'événement",

  // Recurrence editor, badge and scope dialog (NG-2584)
  "events.recurrence.frequency.daily": "Tous les jours",
  "events.recurrence.frequency.weekly": "Toutes les semaines",
  "events.recurrence.frequency.monthly": "Tous les mois",
  "events.recurrence.frequency.yearly": "Tous les ans",
  "events.recurrence.unit.daily": "{count, plural, one {jour} other {jours}}",
  "events.recurrence.unit.weekly": "{count, plural, one {semaine} other {semaines}}",
  "events.recurrence.unit.monthly": "{count, plural, one {mois} other {mois}}",
  "events.recurrence.unit.yearly": "{count, plural, one {an} other {ans}}",
  "events.recurrence.repeat_label": "Répétition",
  "events.recurrence.does_not_repeat": "Ne se répète pas",
  "events.recurrence.repeat_every": "Répéter, intervalle de",
  "events.recurrence.interval_aria": "Intervalle",
  "events.recurrence.on_these_days": "Les jours suivants",
  "events.recurrence.days_of_week_aria": "Jours de la semaine",
  "events.recurrence.on_day": "Le jour",
  "events.recurrence.day_of_month_aria": "Jour du mois",
  "events.recurrence.month_day_skip_hint": "Ignoré les mois qui n'ont pas ce jour.",
  "events.recurrence.ends": "Fin",
  "events.recurrence.ends_on": "Le",
  "events.recurrence.end_date_aria": "Date de fin",
  "events.recurrence.ends_default_hint": "Par défaut, la date de fin du projet.",
  "events.recurrence.ends_after": "Après",
  "events.recurrence.occurrence_count_aria": "Nombre d'occurrences",
  "events.recurrence.occurrences": "occurrences",
  "events.recurrence.recurring": "Récurrent",
  "events.recurrence.edited_occurrence": "Occurrence modifiée d'un événement récurrent",
  "events.recurrence.scope.this": "Cet événement",
  "events.recurrence.scope.this_and_following": "Cet événement et les suivants",
  "events.recurrence.scope.all": "Tous les événements",
  "events.recurrence.scope.edit_title": "Modifier l'événement récurrent",
  "events.detail.id_subtitle": "ID : {id}",
  "events.recurrence.summary.every.daily":
    "{interval, plural, one {tous les jours} other {tous les {intervalText} jours}}",
  "events.recurrence.summary.every.weekly":
    "{interval, plural, one {toutes les semaines} other {toutes les {intervalText} semaines}}",
  "events.recurrence.summary.every.monthly":
    "{interval, plural, one {tous les mois} other {tous les {intervalText} mois}}",
  "events.recurrence.summary.every.yearly":
    "{interval, plural, one {tous les ans} other {tous les {intervalText} ans}}",
  "events.recurrence.summary.every_weekday": "Se répète chaque jour de semaine",
  "events.recurrence.summary.weekly_on": "Se répète {every} : {days}",
  "events.recurrence.summary.monthly_on_day": "Se répète {every}, le {day}",
  "events.recurrence.summary.plain": "Se répète {every}",
  "events.recurrence.summary.until": "jusqu'au {date}",
  "events.recurrence.summary.for_count": "pour {countText} occurrences",
  "events.recurrence.weekday.SU": "dimanche",
  "events.recurrence.weekday.MO": "lundi",
  "events.recurrence.weekday.TU": "mardi",
  "events.recurrence.weekday.WE": "mercredi",
  "events.recurrence.weekday.TH": "jeudi",
  "events.recurrence.weekday.FR": "vendredi",
  "events.recurrence.weekday.SA": "samedi",
  "events.recurrence.weekday_short.SU": "D",
  "events.recurrence.weekday_short.MO": "L",
  "events.recurrence.weekday_short.TU": "M",
  "events.recurrence.weekday_short.WE": "M",
  "events.recurrence.weekday_short.TH": "J",
  "events.recurrence.weekday_short.FR": "V",
  "events.recurrence.weekday_short.SA": "S",

  "events.recurrence.already_recurring": "Cet événement est déjà récurrent",
  "events.recurrence.edit": "Modifier la récurrence",
  "events.recurrence.edit_title": "Modifier la récurrence",
  "events.recurrence.edit_description":
    "Modifiez la façon dont cet événement se répète. Cela met à jour toute la série.",
  "events.recurrence.edit_confirm": "Enregistrer",
  "events.recurrence.edit_apply_anyway": "Appliquer quand même",
  "events.recurrence.edit_cancel": "Annuler",
  "events.recurrence.edit_success": "Récurrence mise à jour",
  "events.recurrence.edit_error": "Échec de la mise à jour de la récurrence",
  "events.recurrence.edit_orphan_warning":
    "Cette modification supprime {count, plural, one {# occurrence personnalisée ou annulée} other {# occurrences personnalisées ou annulées}}, qui ne s'appliqueront plus.",
  "events.detail.delete_confirm_title": "Supprimer l'événement",
  "events.detail.delete_confirm_description":
    "Supprimer « {name} » ? Cette action est irréversible.",
  "events.detail.delete_confirm_description_with_sub_items":
    "{subItems, plural, one {Supprimer « {name} » et sa # sous-tâche ? Cette action est irréversible.} other {Supprimer « {name} » et ses # sous-tâches ? Cette action est irréversible.}}",
  "events.detail.delete_confirm_description_sub_items_unknown":
    "Supprimer « {name} » et ses éventuelles sous-tâches ? Cette action est irréversible.",
  "events.detail.delete_success": "Événement supprimé",
  "events.detail.delete_failed": "Impossible de supprimer l'événement",
  "events.detail.rename_failed": "Impossible de renommer l'événement",
  "events.detail.not_found": "Événement introuvable.",
  "events.detail.load_failed": "Impossible de charger l'événement",
  "events.detail.comment_failed": "Impossible de publier le commentaire",
  "events.detail.duration_update_failed": "Impossible de mettre à jour la durée",
  "events.detail.work_item_update_failed": "Impossible de mettre à jour l'élément de travail",
  "events.detail.schedule_button": "Planifier l'événement",
  "events.detail.find_new_time": "Trouver un nouveau créneau",
  "events.detail.relationships": "Relations",
  "events.detail.description_placeholder": "Ajouter une description...",
  "events.detail.description_empty": "Ajouter une description...",
  "events.detail.description_save_error": "Échec de la sauvegarde de la description",

  "events.properties.event_time": "Heure de l'événement",
  "events.timezone.your_time": "Votre heure locale : {time}",
  "events.properties.date": "Date",
  "events.properties.not_scheduled": "Non planifié",
  "events.properties.work_item": "Élément de travail",
  "events.properties.no_work_item": "Aucun élément de travail",
  "events.properties.link_work_item": "Lier un élément de travail",
  "events.properties.unlink_work_item": "Délier l'élément de travail",
  "events.properties.search_work_items": "Rechercher des éléments de travail...",
  "events.properties.no_work_items": "Aucun élément de travail trouvé",
  "events.properties.loading_work_items": "Chargement des éléments de travail...",
  "events.properties.duration": "Durée",
  "events.properties.repeats": "Récurrence",
  "events.properties.attendees": "Personnes assignées",
  "events.properties.no_members_available": "Aucun membre disponible",
  "events.properties.add_attendee": "Ajouter une personne assignée",
  "events.properties.find_a_time": "Trouver un créneau",
  "events.properties.reschedule": "Reporter",

  "events.find_a_time.title": "Trouver un créneau",
  "events.find_a_time.back": "Retour",
  "events.find_a_time.today": "Aujourd'hui",
  "events.find_a_time.previous_week": "Semaine précédente",
  "events.find_a_time.next_week": "Semaine suivante",
  "events.find_a_time.event_label": "Événement",
  "events.find_a_time.event_title_placeholder": "Titre de l'événement",
  "events.find_a_time.duration_label": "Durée",
  "events.find_a_time.attendees_label": "Participants ({count})",
  "events.find_a_time.add_attendee": "+ Ajouter un participant",
  "events.find_a_time.selected_time": "Créneau sélectionné",
  "events.find_a_time.no_attendees": "Pas encore de participants — tous les créneaux sont libres.",
  "events.find_a_time.cancel": "Annuler",
  "events.find_a_time.confirm_time": "Confirmer le créneau",
  "events.find_a_time.reschedule_action": "Reporter",
  "events.find_a_time.fetch_failed": "Impossible de récupérer les disponibilités",
  "events.find_a_time.reschedule_success": "Événement reporté",
  "events.find_a_time.reschedule_failed": "Impossible de reporter",
  "events.find_a_time.timezone_note": "Horaires affichés en {timezone}",

  "events.suggested_times.title": "Créneaux suggérés",
  "events.suggested_times.empty": "Aucun créneau disponible cette semaine.",
  "events.suggested_times.next_week": "Voir la semaine prochaine",

  // Calendar layout
  "calendar.previous_month": "Mois précédent",
  "calendar.next_month": "Mois suivant",
  "calendar.today": "Aujourd'hui",
  "calendar.more": "+{count} de plus",
  "calendar.show_less": "Afficher moins",
  "calendar.reschedule_failed": "Impossible de replanifier la tâche",

  // Connected apps: the create dialog, the apps table and the redirect URI list (NG-2581)
  "oauth_apps.create.title": "Enregistrer une application OAuth",
  "oauth_apps.create.name": "Nom",
  "oauth_apps.create.redirect_uris": "URI de redirection (une par ligne)",
  "oauth_apps.create.redirect_uris_hint":
    "Une correspondance exacte est requise à la connexion. Vous pourrez en ajouter d'autres après la création.",
  "oauth_apps.create.client_type": "Type de client",
  "oauth_apps.create.client_confidential": "Confidentiel (côté serveur, avec un secret)",
  "oauth_apps.create.client_public": "Public (application native ou SPA, sans secret)",
  "oauth_apps.create.auto_trust":
    "Faire confiance automatiquement à cette application : ignorer l'écran de consentement de l'utilisateur à la première utilisation.",
  "oauth_apps.create.scopes": "Portées",
  "oauth_apps.create.destructive_confirm_aria": "Confirmer les portées destructrices",
  "oauth_apps.create.destructive_confirm":
    "Je comprends que ces portées peuvent créer, modifier ou supprimer des données dans l'espace de travail.",
  "oauth_apps.create.creating": "Création…",
  "oauth_apps.create.submit": "Créer",
  "oauth_apps.create.error": "Échec de la création de l'application.",
  "oauth_apps.list.column_name": "Nom",
  "oauth_apps.list.column_client_id": "ID client",
  "oauth_apps.list.column_type": "Type",
  "oauth_apps.list.column_scopes": "Portées",
  "oauth_apps.list.column_enabled": "Activée",
  "oauth_apps.list.enabled_yes": "oui",
  "oauth_apps.list.enabled_no": "non",
  "oauth_apps.list.actions_aria": "Actions pour {name}",
  "oauth_apps.list.delete": "Supprimer",
  "oauth_apps.list.empty":
    "Aucune application connectée pour l'instant. Cliquez sur « Nouvelle application » pour en enregistrer une.",
  "oauth_apps.redirect_uris.note":
    "Cognota refuse d'envoyer le code d'autorisation à toute URI absente de cette liste. La correspondance est exacte : les paramètres de requête et les barres obliques finales comptent.",
  "oauth_apps.redirect_uris.empty": "Aucune URI de redirection pour l'instant.",
  "oauth_apps.redirect_uris.remove": "Retirer",
  "oauth_apps.redirect_uris.adding": "Ajout…",
  "oauth_apps.redirect_uris.add": "Ajouter",
  "oauth_apps.redirect_uris.error_empty": "L'URI ne peut pas être vide.",
  "oauth_apps.redirect_uris.error_fragment":
    "Les URI de redirection ne peuvent pas contenir de fragment.",
  "oauth_apps.redirect_uris.error_scheme":
    "L'URI de redirection doit commencer par http:// ou https://.",
  "oauth_apps.redirect_uris.error_add": "Échec de l'ajout de l'URI.",

  // Theme
  "theme.toggle": "Changer de thème",
  "theme.use_light": "Passer en mode clair",
  "theme.use_dark": "Passer en mode sombre",

  // Team availability
  "availability.title": "Disponibilité de l'équipe",
  "availability.description":
    "Capacité de l'équipe et blocs de calendrier. Glissez pour faire défiler ; survolez une cellule pour voir le détail.",
  "availability.date_from": "Du",
  "availability.date_to": "Au",
  "availability.date_invalid": "Veuillez saisir une date valide.",
  "availability.date_end_before_start": "La date de fin doit être postérieure à la date de début.",
  "availability.date_range_too_long": "Veuillez sélectionner une plage de 90 jours ou moins.",
  "availability.filter_placeholder": "Filtrer par qualifications",
  "availability.filter_clear": "Effacer les filtres",
  "availability.filter_count": "{count} sélectionnée(s)",
  "availability.empty_filtered": "Aucun membre ne correspond aux filtres sélectionnés.",
  "availability.loading": "Chargement de la disponibilité...",
  "availability.load_error": "Impossible de charger la disponibilité de l'équipe.",
  "availability.not_authorized":
    "Vous n'avez pas la permission de consulter la disponibilité de l'équipe dans cet espace.",
  "availability.legend.high": "≥ 75 % disponible",
  "availability.legend.mid": "25–75 %",
  "availability.legend.low": "< 25 %",
  "availability.legend.none": "Week-end / sans capacité",
  "availability.tooltip.capacity": "Capacité",
  "availability.tooltip.committed": "Engagé",
  "availability.tooltip.blocked": "Bloqué (calendrier)",
  "availability.tooltip.available": "Disponible",
  "availability.tooltip.status": "État",
  "availability.weekday.sun": "Dim",
  "availability.weekday.mon": "Lun",
  "availability.weekday.tue": "Mar",
  "availability.weekday.wed": "Mer",
  "availability.weekday.thu": "Jeu",
  "availability.weekday.fri": "Ven",
  "availability.weekday.sat": "Sam",

  // Capacity
  "capacity.title": "Capacité",
  "capacity.no_permission": "Vous n'avez pas l'autorisation de voir la capacité.",
  "capacity.error.fetch_failed": "Impossible de charger les données de capacité.",
  "capacity.date_from": "Du",
  "capacity.date_to": "Au",
  "capacity.date_week": "Semaine",
  "capacity.date_month": "Mois",
  "capacity.range_separator": "à",
  "capacity.view.label": "Vue de capacité",
  "capacity.view.table": "Vue tableau",
  "capacity.view.triage": "Tableau de triage",
  "capacity.display.label": "Affichage de la capacité",
  "capacity.display.hours": "Heures",
  "capacity.display.percent": "Pourcentage",
  "capacity.tweaks.open": "Configurations",
  "capacity.tweaks.title": "Configurations de capacité",
  "capacity.tweaks.view.label": "Vue par défaut",
  "capacity.tweaks.view.heatmap": "Carte",
  "capacity.tweaks.view.timeline": "Chronologie",
  "capacity.tweaks.unit.label": "Unité",
  "capacity.tweaks.granularity.label": "Granularité",
  "capacity.tweaks.group_rows.label": "Regrouper par",
  "capacity.tweaks.density.label": "Densité",
  "capacity.tweaks.density.compact": "Compact",
  "capacity.tweaks.density.standard": "Standard",
  "capacity.tweaks.over_threshold": "Seuil supérieur",
  "capacity.tweaks.under_threshold": "Seuil inférieur",
  "capacity.tweaks.show_weekends": "Afficher les fins de semaine",
  "capacity.tweaks.reset": "Réinitialiser",
  "capacity.availability_state.available": "Disponible",
  "capacity.availability_state.fully_utilized": "Utilisation complète",
  "capacity.availability_state.over_capacity": "Surcapacité",
  "capacity.availability_state.no_configured_capacity": "Aucune capacité configurée",
  "capacity.availability_state.non_working_day": "Jour non travaillé",
  "capacity.availability_state.time_off": "Congé",
  "capacity.availability_state.holiday": "Jour férié",
  "capacity.availability_state.calendar_blocked": "Bloqué par calendrier",
  "capacity.availability_state.not_in_scope": "Hors portée",
  "capacity.availability_state.short.available": "OK",
  "capacity.availability_state.short.fully_utilized": "100%",
  "capacity.availability_state.short.over_capacity": "SUR",
  "capacity.availability_state.short.no_configured_capacity": "N/D",
  "capacity.availability_state.short.non_working_day": "OFF",
  "capacity.availability_state.short.time_off": "ABS",
  "capacity.availability_state.short.holiday": "FÉR",
  "capacity.availability_state.short.calendar_blocked": "CAL",
  "capacity.availability_state.short.not_in_scope": "H/P",
  "capacity.availability_reduction.time_off": "Congé",
  "capacity.availability_reduction.holiday": "Jour férié",
  "capacity.availability_reduction.external_calendar": "Calendrier externe",
  "capacity.availability_reduction.app_event": "Événement de calendrier",
  "capacity.availability_reduction.other": "Autre réduction",
  "capacity.group.label": "Regroupement de capacité",
  "capacity.group.day": "Jour",
  "capacity.group.week": "Semaine",
  "capacity.group.month": "Mois",
  "capacity.row_group.label": "Lignes de capacité",
  "capacity.row_group.member": "Membres",
  "capacity.row_group.team": "Équipes",
  "capacity.row_group.project": "Projets",
  "capacity.date_invalid": "Veuillez saisir une date valide.",
  "capacity.date_end_before_start": "La date de fin doit être postérieure à la date de début.",
  "capacity.date_range_too_long": "Veuillez sélectionner une plage de 90 jours ou moins.",
  "capacity.loading": "Chargement de la capacité...",
  "capacity.load_error": "Impossible de charger la capacité.",
  "capacity.not_authorized":
    "Vous n'avez pas la permission de consulter la capacité dans cet espace.",
  "capacity.empty": "Aucun membre trouvé dans l'espace.",
  "capacity.metric.capacity": "Capacité",
  "capacity.metric.available": "Disponible",
  "capacity.metric.planned": "Demande planifiée",
  "capacity.metric.estimated": "Allocation estimée",
  "capacity.metric.actual": "Temps réel consigné",
  "capacity.metric.remaining": "Restant",
  "capacity.metric.utilization": "Utilisation",
  "capacity.metric.overallocated": "Suralloué",
  "capacity.metric.underutilized": "Sous-utilisé",
  "capacity.metric.of_capacity": "de la capacité",
  "capacity.summary.members": "membres",
  "capacity.summary.teams": "équipes",
  "capacity.summary.projects": "projets",
  "capacity.summary.periods": "périodes",
  "capacity.summary.people": "personnes",
  "capacity.problem.overallocated": "Les plus suralloués",
  "capacity.problem.slack": "Le plus de marge",
  "capacity.problem.no_overallocated": "Aucun membre suralloué pour cette période.",
  "capacity.problem.no_slack": "Aucun membre sous-utilisé pour cette période.",
  "capacity.problem.of": "sur",
  "capacity.problem.over": "en trop",
  "capacity.problem.available": "disponible",
  "capacity.triage.label": "Tableau de triage de capacité",
  "capacity.triage.title": "Triage",
  "capacity.triage.overallocated": "Suralloué",
  "capacity.triage.on_target": "Cible",
  "capacity.triage.underutilized": "Sous-utilisé",
  "capacity.triage.overcommitted": "en trop",
  "capacity.triage.planned": "planifié",
  "capacity.triage.available": "disponible",
  "capacity.triage.empty": "Aucun membre dans cet état.",
  "capacity.triage.action.review_overload": "Examiner la surcharge",
  "capacity.triage.action.view": "Voir",
  "capacity.triage.action.review_availability": "Examiner la disponibilité",
  "capacity.table.daily_totals": "Totaux quotidiens",
  "capacity.legend.under": "<65% sous-réservé",
  "capacity.legend.healthy": "65-115% cible",
  "capacity.legend.warning": "115-125% au-dessus",
  "capacity.legend.over": ">125% très élevé",
  "capacity.legend.under_label": "sous-réservé",
  "capacity.legend.healthy_label": "cible",
  "capacity.legend.warning_label": "au-dessus",
  "capacity.legend.over_label": "très élevé",
  "capacity.group_rows.empty_teams": "Aucune équipe trouvée.",
  "capacity.group_rows.empty_projects": "Aucun projet trouvé.",
  "capacity.group_rows.load_error": "Impossible de charger la capacité groupée.",
  "capacity.table_label": "Capacité de l'espace",
  "capacity.column.member": "Membre",
  "capacity.column.team": "Équipe",
  "capacity.column.project": "Projet",
  "capacity.column.total": "Total de la plage",
  "capacity.column.slack_debt": "Marge / dette",
  "capacity.timeline.slack": "marge",
  "capacity.timeline.over": "en trop",
  "capacity.workspace_total": "Total de l'espace",
  "capacity.cell.planned": "Plan",
  "capacity.cell.estimated": "Est.",
  "capacity.cell.actual": "Réel",
  "capacity.cell.capacity": "Capacité",
  "capacity.cell.available": "Disponibilité",
  "capacity.actual_tbd": "À confirmer",
  "capacity.close": "Fermer",
  "capacity.calculation.title": "Mode de calcul des chiffres",
  "capacity.calculation.summary":
    "Les vues Heures et Pourcentage utilisent les mêmes entrées; le pourcentage convertit la demande planifiée ou réelle en utilisation de la capacité.",
  "capacity.calculation.capacity_label": "Capacité",
  "capacity.calculation.capacity":
    "Heures de travail configurées moins les congés, jours fériés et blocages de calendrier, ajustées par le pourcentage de capacité.",
  "capacity.calculation.planned_label": "Planifié",
  "capacity.calculation.planned":
    "Demande estimée des tâches et événements allouée au jour, à la semaine ou au mois sélectionné.",
  "capacity.calculation.actual_label": "Réel",
  "capacity.calculation.actual":
    "Temps consigné sur les tâches et événements lorsque les journaux de travail sont disponibles.",
  "capacity.calculation.remaining_label": "Restant",
  "capacity.calculation.remaining":
    "La disponibilité restante correspond à la capacité moins la demande planifiée et les autres allocations.",
  "capacity.beeswarm.eyebrow": "Distribution",
  "capacity.beeswarm.title": "Répartition de l'utilisation",
  "capacity.beeswarm.subtitle": "{range} · chaque point = 1 {entity}",
  "capacity.beeswarm.view_label": "Regroupement de la distribution",
  "capacity.beeswarm.by_member": "Par membre",
  "capacity.beeswarm.by_team": "Par équipe",
  "capacity.beeswarm.by_project": "Par projet",
  "capacity.beeswarm.category.under": "Sous-utilisés",
  "capacity.beeswarm.category.target": "Dans la cible",
  "capacity.beeswarm.category.over": "Au-dessus de la capacité",
  "capacity.beeswarm.category.severe": "Critiques",
  "capacity.beeswarm.range.under": "< {percent} %",
  "capacity.beeswarm.range.between": "{start}-{end} %",
  "capacity.beeswarm.range.over": "> {percent} %",
  "capacity.beeswarm.marker.under": "Moins de {percent} %",
  "capacity.beeswarm.marker.capacity": "Capacité 100 %",
  "capacity.beeswarm.empty": "Aucune donnée d'utilisation pour cette sélection",
  "capacity.beeswarm.helper":
    "Les points à gauche du repère de sous-utilisation indiquent de la capacité disponible. Les points à droite de 100 % indiquent une demande supérieure à la capacité.",
  "capacity.beeswarm.tooltip": "{label}: {utilization} % · {planned} sur {capacity}",
  "capacity.beeswarm.tooltip_detail": "{utilization} % · {planned} sur {capacity}",
  "capacity.beeswarm.entity.member": "membre",
  "capacity.beeswarm.entity.team": "équipe",
  "capacity.beeswarm.entity.project": "projet",
  "capacity.details.title": "Détails de capacité",
  "capacity.details.calculation_title": "Mode de calcul",
  "capacity.details.calculation_capacity_label": "Capacité",
  "capacity.details.calculation_capacity":
    "Heures de travail configurées moins les congés, jours fériés et blocages de calendrier, ajustées par le pourcentage de capacité.",
  "capacity.details.calculation_planned_label": "Planifié",
  "capacity.details.calculation_planned":
    "Demande estimée des tâches et événements allouée à cette période.",
  "capacity.details.calculation_actual_label": "Réel",
  "capacity.details.calculation_actual":
    "Temps consigné sur les tâches et événements lorsque les journaux de travail sont disponibles.",
  "capacity.details.calculation_remaining_label": "Restant",
  "capacity.details.calculation_remaining":
    "Restant = capacité - demande planifiée - autres allocations.",
  "capacity.details.planned": "Planifié",
  "capacity.details.estimated": "Estimé",
  "capacity.details.actual": "Réel",
  "capacity.details.capacity": "Capacité",
  "capacity.details.available": "Disponible",
  "capacity.details.remaining": "Restant",
  "capacity.details.model_summary": "Planifié et réel",
  "capacity.details.planned_task": "Tâches planifiées",
  "capacity.details.planned_event": "Événements planifiés",
  "capacity.details.planned_utilization": "Utilisation planifiée",
  "capacity.details.actual_task": "Tâches réelles",
  "capacity.details.actual_event": "Événements réels",
  "capacity.details.actual_utilization": "Utilisation réelle",
  "capacity.details.variance": "Écart",
  "capacity.details.accuracy": "Exactitude",
  "capacity.details.calendar_blocked": "Bloqué par calendrier",
  "capacity.details.availability_status": "État de disponibilité",
  "capacity.details.availability_reductions": "Réductions de disponibilité",
  "capacity.details.availability_reductions_description":
    "Les événements de calendrier réduisent la capacité disponible sans être comptés comme allocations de tâches.",
  "capacity.details.no_calendar_events":
    "Aucun événement de calendrier renvoyé pour cette période.",
  "capacity.details.full_day": "Journée complète",
  "capacity.details.tasks": "Événements et tâches qui affectent cet élément",
  "capacity.details.allocations": "Événements et tâches qui affectent cet élément",
  "capacity.details.empty": "Aucune allocation d'événement ou de tâche pour cette période.",
  "capacity.details.empty_allocations":
    "Aucune allocation d'événement ou de tâche pour cette période.",
  "capacity.details.task": "Tâche",
  "capacity.details.event": "Événement",
  "capacity.details.project": "Projet",
  "capacity.details.no_project": "Aucun projet",
  "capacity.details.private_project": "Projet privé",
  "capacity.details.private_task": "Tâche privée",
  "capacity.details.private_event": "Événement privé",
  "capacity.details.items": "Éléments",
  "capacity.details.member": "Membre",
  "capacity.details.over_capacity": "Surcapacité",
  "capacity.details.over_capacity_description":
    "Ces éléments dépassent la limite de l'élément sélectionné.",
  "capacity.details.over_by": "Dépassement de",
  "capacity.details.running_total": "Total cumulatif",
  "capacity.details.unassign_task": "Désassigner",
  "capacity.details.unassign_task_label": "Désassigner {task} de {member}",
  "capacity.details.reassign_task": "Assigner quelqu'un d'autre",
  "capacity.details.reassign_task_label": "Assigner quelqu'un d'autre à {task}",
  "capacity.details.reassignment_candidates": "Candidats de remplacement",
  "capacity.details.reassignment_candidates_description":
    "Choisissez un membre du projet qui a de la place pour cette tâche.",
  "capacity.details.reassignment_loading": "Recherche de remplaçants...",
  "capacity.details.reassignment_candidates_empty": "Aucun candidat de remplacement trouvé.",
  "capacity.details.reassignment_candidates_error":
    "Impossible de charger les candidats de remplacement.",
  "capacity.details.reassign_to_label": "Assigner à {member}",
  "capacity.details.reassignment_remaining": "{hours} restant",
  "capacity.details.reassignment_capacity_gap": "{hours} de capacité manquante",
  "capacity.details.assignment_update_success": "Assignation de la tâche mise à jour.",
  "capacity.details.assignment_update_error": "Impossible de mettre à jour l'assignation.",
  "capacity.details.load_more": "Charger plus",
  "capacity.details.showing_count": "{shown} sur {total} affichés",
  "capacity.filter.all_members": "Tous les membres",
  "capacity.filter.no_members": "Aucun membre",
  "capacity.filter.members": "Membres",
  "capacity.filter.all": "Tous",
  "capacity.filter.none": "Aucun",
  "capacity.filter.empty_selection": "Aucun membre sélectionné.",
  "capacity.matching.open": "Correspondance des tâches",
  "capacity.matching.title": "Correspondance des tâches",
  "capacity.matching.tab_tasks": "Tâches par membre",
  "capacity.matching.tab_users": "Membres par tâche",
  "capacity.matching.member": "Membre",
  "capacity.matching.no_members": "Aucun membre",
  "capacity.matching.include_assigned": "Inclure les tâches assignées",
  "capacity.matching.member_results": "Tâches correspondantes pour {member}",
  "capacity.matching.loading": "Chargement des correspondances...",
  "capacity.matching.load_error": "Impossible de charger les correspondances de tâches.",
  "capacity.matching.empty_tasks": "Aucune tâche correspondante trouvée.",
  "capacity.matching.fits_capacity": "Respecte la capacité",
  "capacity.matching.capacity_gap": "Écart de {hours}",
  "capacity.matching.score": "Score {score}",
  "capacity.matching.skills_percent": "Qualifications {percent} %",
  "capacity.matching.remaining": "{hours} restantes",
  "capacity.matching.matched_skills": "Correspondantes : {skills}",
  "capacity.matching.missing_skills": "Manquantes : {skills}",
  "capacity.matching.no_required_skills": "Aucune qualification requise",
  "capacity.matching.assigned_count": "{count} assignée(s)",
  "capacity.matching.open_task": "Ouvrir la tâche",
  "capacity.matching.find_users": "Trouver des membres",
  "capacity.matching.task": "Tâche",
  "capacity.matching.task_placeholder": "Nom, ID ou numéro de tâche",
  "capacity.matching.search": "Rechercher",
  "capacity.matching.empty_users": "Aucun membre correspondant trouvé.",

  // Project capacity
  "project_capacity.title": "Capacité du projet",
  "project_capacity.unknown_project": "Projet",
  "project_capacity.range_separator": "au",
  "project_capacity.date_from": "Du",
  "project_capacity.date_to": "Au",
  "project_capacity.date_invalid": "Veuillez saisir une date valide.",
  "project_capacity.date_end_before_start":
    "La date de fin doit être postérieure à la date de début.",
  "project_capacity.loading": "Chargement de la capacité du projet...",
  "project_capacity.load_error": "Impossible de charger la capacité du projet.",
  "project_capacity.not_authorized":
    "Vous n'avez pas l'autorisation de voir la capacité du projet.",
  "project_capacity.empty": "Aucun membre trouvé dans le projet.",
  "project_capacity.metric.members": "Membres",
  "project_capacity.metric.available": "Capacité",
  "project_capacity.metric.allocated": "Demande planifiée",
  "project_capacity.metric.other_allocation": "Autre allocation",
  "project_capacity.metric.actual": "Temps réel consigné",
  "project_capacity.metric.remaining": "Restant",
  "project_capacity.metric.utilization": "Utilisation",
  "project_capacity.timeline.title": "Capacité par période",
  "project_capacity.timeline.label": "Capacité du projet par période",
  "project_capacity.timeline.available": "Capacité",
  "project_capacity.timeline.estimated": "Planifié",
  "project_capacity.timeline.actual": "Réel",
  "project_capacity.table_label": "Capacité des membres du projet",
  "project_capacity.column.member": "Membre",
  "project_capacity.column.total": "Total",
  "project_capacity.column.available": "Capacité",
  "project_capacity.column.allocated": "Planifié",
  "project_capacity.column.other": "Autre",
  "project_capacity.column.actual": "Réel",
  "project_capacity.column.calendar_blocked": "Bloqué par calendrier",
  "project_capacity.column.remaining": "Restant",
  "project_capacity.column.utilization": "Utilisation",
  "project_capacity.total": "Total du projet",

  // Team capacity
  "team_capacity.title": "Capacité de l'équipe",
  "team_capacity.breadcrumb": "Capacité",
  "team_capacity.unknown_team": "Équipe",
  "team_capacity.range_separator": "au",
  "team_capacity.date_from": "Du",
  "team_capacity.date_to": "Au",
  "team_capacity.date_invalid": "Veuillez saisir une date valide.",
  "team_capacity.date_end_before_start": "La date de fin doit être postérieure à la date de début.",
  "team_capacity.loading": "Chargement de la capacité de l'équipe...",
  "team_capacity.load_error": "Impossible de charger la capacité de l'équipe.",
  "team_capacity.team_load_error": "Impossible de charger l'équipe.",
  "team_capacity.back_to_team": "Retour à l'équipe",
  "team_capacity.empty": "Aucun membre trouvé dans l'équipe.",
  "team_capacity.metric.members": "Membres",
  "team_capacity.metric.projects": "Projets",
  "team_capacity.metric.available": "Capacité",
  "team_capacity.metric.estimated": "Demande planifiée",
  "team_capacity.metric.other_allocation": "Autre allocation",
  "team_capacity.metric.actual": "Temps réel consigné",
  "team_capacity.metric.remaining": "Restant",
  "team_capacity.metric.utilization": "Utilisation",
  "team_capacity.timeline.title": "Capacité par période",
  "team_capacity.timeline.label": "Capacité de l'équipe par période",
  "team_capacity.timeline.available": "Capacité",
  "team_capacity.timeline.estimated": "Planifié",
  "team_capacity.timeline.actual": "Réel",
  "team_capacity.table_label": "Capacité des membres de l'équipe",
  "team_capacity.column.member": "Membre",
  "team_capacity.column.total": "Total",
  "team_capacity.column.available": "Capacité",
  "team_capacity.column.estimated": "Planifié",
  "team_capacity.column.other": "Autre",
  "team_capacity.column.actual": "Réel",
  "team_capacity.column.calendar_blocked": "Bloqué par calendrier",
  "team_capacity.column.remaining": "Restant",
  "team_capacity.column.utilization": "Utilisation",
  "team_capacity.total": "Total de l'équipe",

  // Worklog / time tracking
  "worklog.title": "Temps consigné",
  "worklog.property_label": "Temps consigné",
  "worklog.empty": "Aucun temps consigné pour l'instant.",
  "worklog.loading": "Chargement des entrées de temps...",
  "worklog.load_error": "Impossible de charger les entrées de temps.",
  "worklog.show": "Afficher",
  "worklog.hide": "Masquer",
  "worklog.summary_count": "{count} · {total}",
  "worklog.log_action": "Enregistrer du temps",
  "worklog.edit_action": "Modifier",
  "worklog.delete_action": "Supprimer",
  "worklog.delete_confirm_title": "Supprimer l'entrée de temps",
  "worklog.delete_confirm_description": "Cette entrée de temps sera supprimée définitivement.",
  "worklog.delete_success": "Entrée de temps supprimée",
  "worklog.delete_error": "Impossible de supprimer l'entrée de temps",
  "worklog.save_success": "Entrée de temps enregistrée",
  "worklog.save_error": "Impossible d'enregistrer l'entrée de temps",
  "worklog.modal.create_title": "Enregistrer du temps",
  "worklog.modal.edit_title": "Modifier l'entrée de temps",
  "worklog.modal.date_label": "Date",
  "worklog.modal.hours_part_label": "Heures",
  "worklog.modal.minutes_part_label": "Minutes",
  "worklog.modal.duration_preview": "Durée : {duration}",
  "worklog.modal.description_label": "Description",
  "worklog.modal.description_placeholder": "Sur quoi avez-vous travaillé ?",
  "worklog.modal.submit": "Enregistrer",
  "worklog.modal.submitting": "Enregistrement...",
  "worklog.modal.cancel": "Annuler",
  "worklog.modal.duration_required_hm": "Choisissez une date et saisissez le temps travaillé.",
  "worklog.entry.logged_by": "Consigné par {name}",
  "worklog.entry.logged_relative": "consigné {relative}",
  "worklog.column_title": "Temps consigné",
  "worklog.table.person": "Personne",
  "worklog.table.hours": "Heures",
  "worklog.table.note": "Note",
  "worklog.table.date": "Date",
  "worklog.cell.log_action_aria": "Saisir du temps sur cet élément de travail",
  "worklog.cell.log_with_total_aria":
    "Saisir du temps — {total} enregistré sur cet élément de travail",
  "worklog.summary.aria_label": "{total} consigné sur cette tâche",

  // Work item detail panel (NG-2582)
  "issue.properties_overview": "Vue d'ensemble",
  "issue.properties_actual_hours": "Heures réelles",
  "issue.activity_no_match": "Aucune activité correspondante",
  "issue.attachments_download": "Télécharger",
  "issue.attachments_drop_hint": "Déposez des fichiers ici ou cliquez pour les téléverser",
  "worklog.filter_aria": "Filtrer le temps consigné",
  "worklog.total_logged": "Consigné sur cette tâche",
  "worklog.estimate_remaining": "Estimation restante",
  "worklog.logged_by": "Consigné par",

  // Project settings
  "project_settings.tabs.general": "Général",
  "project_settings.tabs.members": "Membres",
  "project_settings.nav_label": "Paramètres du projet",
  "project_settings.tabs.automations": "Automatisations",
  "project_settings.tabs.states": "Statuts",
  "project_settings.tabs.workflow": "Flux de travail",

  // Project delivery: what an LMS delivers this project (NG-770)
  "project_settings.delivery.title": "Diffusion",
  "project_settings.delivery.description":
    "Associez ce projet au cours ou au parcours qui le diffuse, afin que les résultats reviennent attribués au travail qui les a produits.",
  "project_delivery.title": "Diffusé par",
  "project_delivery.description":
    "Un cours ou un parcours par LMS connecté. Les résultats qui en proviennent sont attribués à ce projet.",
  "project_delivery.empty_title": "Aucune association",
  "project_delivery.empty_description":
    "Associez un cours ou un parcours {vendor} et Cognota pourra attribuer ses résultats à ce projet.",
  "project_delivery.empty_description_any_lms":
    "Associez un cours ou un parcours de votre LMS et Cognota pourra attribuer ses résultats à ce projet.",
  "project_delivery.empty_description_read_only":
    "Personne n'a encore associé de cours ou de parcours à ce projet. Une personne autorisée à modifier le projet peut en ajouter un.",
  "project_delivery.kind.course": "Cours",
  "project_delivery.kind.path": "Parcours",
  "project_delivery.kind.course_plural": "Cours",
  "project_delivery.kind.path_plural": "Parcours",
  "project_delivery.withdrawn_from_catalog": "Ne figure plus au catalogue du LMS",
  "project_delivery.inert.title": "Cette association ne se synchronise pas",
  "project_delivery.inert.description":
    "Sa connexion est en pause ou déconnectée : aucun nouveau résultat n'arrivera avant qu'un administrateur de l'espace de travail la réactive dans la bibliothèque d'intégrations. L'association et tout ce qui est déjà synchronisé sont conservés.",
  "project_delivery.link.action": "Associer du contenu",
  "project_delivery.link.success": "Association créée.",
  "project_delivery.link.error": "Impossible d'associer ce contenu. Rien n'a été modifié.",
  "project_delivery.preview.action": "Aperçu",
  "project_delivery.synced_at": "Synchronisé {when}",
  "project_delivery.unlink.action": "Dissocier",
  "project_delivery.unlink.confirm_title": "Dissocier ce contenu ?",
  "project_delivery.unlink.confirm_description":
    "Ce projet cesse de lui être attribué. Rien de ce qui est déjà synchronisé n'est supprimé, et vous pourrez l'associer de nouveau plus tard.",
  "project_delivery.unlink.success": "Association supprimée.",
  "project_delivery.unlink.error": "Impossible de dissocier. Rien n'a été modifié.",
  "project_delivery.picker.title": "Associer du contenu LMS",
  "project_delivery.picker.description":
    "Cours et parcours que Cognota a récupérés depuis votre LMS connecté. Un projet en associe un seul par connexion.",
  "project_delivery.picker.description_has_link":
    "Ce projet associe déjà du contenu sur une connexion : ses entrées sont donc indisponibles ci-dessous. Dissociez d’abord l’association existante pour la remplacer.",
  "project_delivery.picker.search_label": "Rechercher dans le catalogue",
  "project_delivery.picker.search_placeholder": "Rechercher par nom ou ID...",
  "project_delivery.picker.clear_search": "Effacer la recherche",
  "project_delivery.picker.kind_label": "Filtrer par type",
  "project_delivery.picker.kind_all": "Tous les types",
  "project_delivery.picker.linked_elsewhere": "Un autre projet l'associe également",
  "project_delivery.picker.blocked_by_existing_link":
    "Ce projet associe déjà du contenu sur cette connexion",
  "project_delivery.picker.more_results":
    "Premiers résultats affichés sur {count}. Affinez la recherche.",
  "project_delivery.picker.empty_title": "Aucun résultat",
  "project_delivery.picker.empty_description":
    "Essayez un autre nom ou ID, ou retirez le filtre de type. Le catalogue est actualisé plusieurs fois par jour, donc un cours créé à l'instant dans le LMS peut ne pas encore figurer ici.",
  "project_delivery.picker.not_connected_title": "Aucun LMS n'est connecté",
  "project_delivery.picker.not_connected_description":
    "Un administrateur de l'espace de travail connecte {vendor} dans la bibliothèque d'intégrations. D'ici là, il n'y a pas de catalogue à parcourir.",
  "project_delivery.picker.not_connected_description_any_lms":
    "Un administrateur de l'espace de travail connecte votre LMS dans la bibliothèque d'intégrations. D'ici là, il n'y a pas de catalogue à parcourir.",
  "project_delivery.picker.link_action": "Associer",
  "project_delivery.picker.link_label": "Associer {name}",
  "project_delivery.picker.preview_action": "Aperçu",
  "project_delivery.picker.preview_label": "Aperçu dans {vendor} : {name}",

  // Résultats du projet : ce que le contenu LMS lié a produit (NG-775)
  "project_settings.results.title": "Résultats",
  "project_settings.results.description":
    "Ce que le cours ou le parcours lié a produit, calculé à partir de l'activité des apprenants que le LMS nous a déjà transmise.",
  "lms_preview.eyebrow": "Contenu LMS",
  "lms_preview.suggestion_eyebrow": "Contenu recommandé",
  "lms_preview.position": "{position} sur {total}",
  "lms_preview.previous": "Suggestion précédente",
  "lms_preview.next": "Suggestion suivante",
  "lms_preview.why_suggested": "Pourquoi ce contenu est suggéré",
  "lms_preview.shares": "Partage",
  "lms_preview.with_request_title": "avec le titre de la demande",
  "lms_preview.fact.type": "Type",
  "lms_preview.fact.duration": "Durée",
  "lms_preview.fact.duration_minutes": "{count} min",
  "lms_preview.fact.languages": "Langues",
  "lms_preview.fact.author": "Auteur",
  "lms_preview.fact.modified": "Dernière modification",
  "lms_preview.fact.version": "Version",
  "lms_preview.fact.steps": "Étapes",
  "lms_preview.content_type.native": "Cours natif",
  "lms_preview.content_type.scorm": "Paquet SCORM",
  "lms_preview.step_not_cached": "Absent du catalogue synchronisé ({id})",
  "lms_preview.results.title": "Résultats des apprenants",
  "lms_preview.results.completion": "Achèvement",
  "lms_preview.results.learners": "Apprenants",
  "lms_preview.results.avg_score": "Score moyen",
  "lms_preview.results.avg_time": "Temps moyen",
  "lms_preview.results.provenance":
    "Issu du lien sur {project} · au {time}. Chiffres au niveau du cours.",
  "lms_preview.catalog.title": "Dans le catalogue",
  "lms_preview.catalog.status": "Statut dans {vendor}",
  "lms_preview.catalog.last_synced": "Dernière synchronisation",
  "lms_preview.catalog.delivers": "Livre",
  "lms_preview.link.eyebrow": "Livré par",
  "lms_preview.link.title": "Ce lien",
  "lms_preview.link.linked_by": "Lié par",
  "lms_preview.link.linked_on": "Lié le",
  "lms_preview.link.from_request": "Issu de la demande",
  "lms_preview.view_results": "Voir les résultats",
  "lms_preview.status.published": "Publié",
  "lms_preview.status.draft": "Brouillon",
  "lms_preview.limit_course":
    "360Learning n'expose pas les activités d'un cours via son API, la liste des modules n'existe donc que dans 360Learning.",
  "lms_preview.limit_path":
    "Les étapes du parcours sont listées ci-dessus. Les activités de chaque étape restent dans 360Learning, qui ne les expose pas via son API.",
  "lms_preview.cornerstone.limit_course":
    "Cognota ne lit pas les activités d'un cours dans Cornerstone, la liste des modules n'existe donc que dans Cornerstone.",
  "lms_preview.cornerstone.limit_path":
    "Les étapes du parcours sont listées ci-dessus. Les activités de chaque étape restent dans Cornerstone, et Cognota ne les lit pas.",
  "lms_preview.open_label": "Aperçu de {name}",
  "lms_preview.open_in_vendor": "Ouvrir dans {vendor}",

  // The shared LMS content row vocabulary (NG-1158)
  "lms_content.type.course": "Cours",
  "lms_content.type.path": "Parcours de formation",
  "lms_content.steps_one": "1 étape",
  "lms_content.steps_many": "{count} étapes",
  "lms_content.duration_minutes": "{count} min",
  "lms_content.duration_hours": "{hours} h",
  "lms_content.duration_hours_minutes": "{hours} h {minutes} min",

  // Kept on the request (NG-1157)
  "project_kept_content.title": "Retenu sur la demande",
  "project_kept_content.description_one_request":
    "Contenu retenu par le responsable de la demande {request}. Choisissez celui qui réalise ce projet ; les autres restent ici à titre de référence.",
  "project_kept_content.description_many_requests":
    "Contenu retenu sur les {count} demandes à l'origine de ce projet. Choisissez celui qui le réalise ; les autres restent ici à titre de référence.",
  "project_kept_content.kept_by": "retenu par {name}",
  "project_kept_content.is_delivered_by": "Réalisé par",
  "project_kept_content.conflict":
    "Indisponible tant que ce projet est réalisé par un autre contenu. Dissociez d'abord celui-ci sous Réalisé par, puis utilisez ce contenu à la place.",
  "project_kept_content.use.action": "Utiliser comme contenu de réalisation",
  "project_kept_content.preview_label": "Aperçu du contenu retenu {name}",
  "project_kept_content.dismiss.label": "Écarter {name} de ce projet",
  "project_kept_content.dismiss.success": "Écarté de ce projet. La demande le conserve toujours.",
  "project_kept_content.dismiss.error": "Impossible de l'écarter. Il est de nouveau dans la liste.",
  "project_results.title": "Résultats des apprenants",
  "project_results.description":
    "Les chiffres proviennent des lignes d'apprenants déjà transmises par le LMS. Recalculer les reconstruit à partir de cette activité déjà enregistrée, sans rien récupérer de nouveau depuis le LMS.",
  "project_results.refresh.action": "Recalculer",
  "project_results.refresh.in_progress": "Recalcul en cours…",
  "project_results.refresh.success": "Recalculé à partir de l'activité déjà enregistrée.",
  "project_results.refresh.error": "Recalcul impossible. Les chiffres affichés sont inchangés.",
  "project_results.empty_title": "Aucun contenu lié",
  "project_results.empty_description":
    "Liez un cours ou un parcours dans l'onglet Diffusion, et ses résultats apparaîtront ici.",
  "project_results.empty_description_read_only":
    "Personne n'a encore lié de cours ni de parcours à ce projet, il n'y a donc aucun résultat à afficher. Une personne pouvant modifier le projet peut en ajouter un.",
  "project_results.cost_per_completion.title": "Coût par achèvement",
  "project_results.cost_per_completion.description":
    "Coût de main-d'œuvre issu des temps enregistrés sur ce projet, divisé par le nombre d'achèvements. Les coûts de contenu fournisseur et de plateforme ne sont pas encore inclus.",
  "project_results.cost_per_completion.suffix": "par achèvement · main-d'œuvre uniquement",
  "project_results.cost_per_completion.labour_only": "Main-d'œuvre uniquement",
  "project_results.cost_per_completion.labour_cost": "Coût de main-d'œuvre à ce jour",
  "project_results.cost_per_completion.completions": "Achèvements",
  "project_results.cost_per_completion.hours_logged": "Heures enregistrées",
  "project_results.cost_per_completion.hours_value":
    "{hours, number} h sur {people, plural, one {# personne} other {# personnes}}",
  "project_results.cost_per_completion.footnote":
    "Visible par les personnes ayant accès aux données financières. Baisse à mesure que les achèvements augmentent ; une ligne de contenu fournisseur le modifiera sensiblement une fois que les coûts en comporteront une.",
  "project_results.cost_per_completion.no_completions":
    "Personne n'a encore terminé ce contenu, il n'y a donc rien pour diviser le temps enregistré. Il ne s'agit pas d'un coût nul.",
  "project_results.cost_per_completion.load_error":
    "Impossible de charger le temps enregistré pour ce projet, le coût par achèvement est donc indisponible. Les résultats ci-dessus ne sont pas affectés.",
  "project_results.load_error.title": "Impossible de charger les résultats",
  "project_results.load_error.description":
    "Rien n'a été perdu. Ces chiffres sont enregistrés dans Cognota, vous pouvez réessayer sans risque.",
  "project_results.load_error.retry": "Réessayer",
  "project_results.load_error.retry_failed": "Le chargement des résultats a encore échoué.",
  "project_results.no_data.title": "Aucune donnée d'apprenant",
  "project_results.no_data.description_never":
    "Rien n'a encore été récupéré du LMS pour ce contenu. L'activité des apprenants est vérifiée toutes les heures, donc un cours tout juste lié affiche ses données en une heure environ.",
  "project_results.no_data.description_empty":
    "Le LMS ne contient encore aucune activité pour ce contenu. Il n'enregistre un apprenant qu'à partir du moment où celui-ci commence, donc cette section reste vide jusque-là.",
  "project_results.stat.completion_rate": "Achèvement",
  "project_results.stat.completion_rate_sub":
    "{completed} apprenants sur {total} ayant une activité",
  "project_results.stat.learners": "Apprenants",
  "project_results.stat.learners_sub": "ayant une activité · inscriptions non synchronisées",
  "project_results.stat.started": "Commencé",
  "project_results.stat.started_sub": "{rate} des apprenants",
  "project_results.stat.completed": "Terminé",
  "project_results.stat.completed_sub": "{count} en cours",
  "project_results.stat.avg_time_to_complete": "Temps moyen pour terminer",
  "project_results.stat.avg_time_to_complete_sub": "apprenants ayant terminé uniquement",
  "project_results.stat.avg_time_all_attempts": "Temps moyen, toutes tentatives",
  "project_results.stat.avg_time_all_attempts_sub": "toutes les tentatives, terminées ou non",
  "project_results.stat.cornerstone_no_time_spent": "Cornerstone ne transmet pas le temps passé",
  "project_results.stat.avg_score": "Score moyen",
  "project_results.stat.avg_score_sub": "sur 100",
  "project_results.stat.attempts": "Tentatives",
  "project_results.stat.attempts_sub":
    "{count, plural, one {# tentative répétée} other {# tentatives répétées}}",
  "project_results.shared_link.note":
    "Ces chiffres portent sur le cours : {count} projets lient ce contenu, ils couvrent donc tous ses apprenants et pas uniquement ceux de ce projet.",
  "project_results.course_level.cornerstone_note":
    "Ces chiffres portent sur le cours : ils couvrent tous les apprenants que Cornerstone affiche sur ce contenu, pas uniquement le public de ce projet.",
  "project_results.timestamps.recalculated": "Recalculé {when}",
  "project_results.timestamps.just_now": "à l'instant",
  "project_results.timestamps.never_computed": "Jamais recalculé",
  "project_results.timestamps.lms_data_as_of": "données LMS au {date}",
  "project_results.timestamps.never_pulled": "aucune donnée LMS récupérée",
  "project_results.breakdown.title": "Achèvement par rôle",
  "project_results.breakdown.column.job_role": "Rôle",
  "project_results.breakdown.column.learners": "Apprenants",
  "project_results.breakdown.column.completed": "Terminé",
  "project_results.breakdown.column.completion": "Achèvement",
  "project_results.breakdown.no_job_role": "Aucun rôle",
  "project_results.breakdown.empty":
    "Aucune répartition par rôle pour le moment. Un apprenant y apparaît dès que son compte LMS est associé à un utilisateur Cognota.",
  "project_results.breakdown.empty_all_removed":
    "Aucune répartition par rôle. Tous les apprenants ayant une activité ici ont été supprimés du LMS, aucun ne peut donc être associé à un utilisateur Cognota. Ce qu'ils ont terminé reste compté dans les totaux ci-dessus.",
  "project_results.coverage.note":
    "Calculé sur {attributed} apprenants sur {total} dont le compte LMS est associé à un utilisateur Cognota, soit {coverage} de ceux ayant une activité.",
  "project_results.coverage.none":
    "Aucun apprenant ayant une activité n'est associé à un utilisateur Cognota, il n'y a donc rien à répartir par rôle.",
  "project_results.coverage.unmatched":
    "{count, plural, one {# est compté dans les totaux ci-dessus mais dans aucune ligne ici, car son compte LMS n'est pas encore associé} other {# sont comptés dans les totaux ci-dessus mais dans aucune ligne ici, car leur compte LMS n'est pas encore associé}} à un utilisateur Cognota.",
  "project_results.coverage.removed_in_lms":
    "{count, plural, one {# a été supprimé du LMS, aucune association n'arrivera donc pour lui. Ce qu'il a terminé} other {# ont été supprimés du LMS, aucune association n'arrivera donc pour eux. Ce qu'ils ont terminé}} reste compté dans les totaux ci-dessus.",
  "project_settings.not_authorized.title": "Accès refusé",
  "project_settings.not_authorized.description":
    "Vous n'avez pas les droits pour consulter cette section des paramètres du projet.",
  "project_settings.general.title": "Général",
  "project_settings.general.description":
    "Mettez à jour l'identité du projet, le responsable, le destinataire par défaut et les contrôles du cycle de vie.",
  "project_settings.general.description_simplified":
    "Mettez à jour l'identité du projet et les contrôles du cycle de vie.",
  "project_settings.general.name_label": "Nom du projet",
  "project_settings.general.identifier_label": "Identifiant",
  "project_settings.general.identifier_checking": "Vérification de la disponibilité…",
  "project_settings.general.identifier_taken": "Cet identifiant est déjà utilisé.",
  "project_settings.general.identifier_hint":
    "Jusqu'à 10 lettres ou chiffres. Utilisé comme préfixe des identifiants d'élément.",
  "project_settings.general.description_label": "Description",
  "project_settings.general.privacy_label": "Confidentialité",
  "project_settings.general.privacy_public": "Public",
  "project_settings.general.privacy_private": "Privé",
  "project_settings.general.timezone_label": "Fuseau horaire",
  "project_settings.general.project_type_label": "Type de projet",
  "project_settings.general.start_date_label": "Date de début",
  "project_settings.general.target_completion_date_label": "Date de fin cible",
  "project_settings.general.target_launch_date_label": "Date de lancement cible",
  "project_settings.general.actual_completion_date_label": "Date de fin réelle",
  "project_settings.general.client_teams_label": "Équipes clientes",
  "project_settings.general.delivery_teams_label": "Équipes de livraison",
  "project_settings.general.programs_label": "Programmes",
  "project_settings.general.goals_label": "Objectifs",
  "project_settings.general.save": "Enregistrer",
  "project_settings.general.saving": "Enregistrement…",
  "project_settings.general.save_success": "Projet mis à jour.",
  "project_settings.general.save_error": "Échec de la mise à jour du projet.",
  "project_settings.custom_fields.title": "Champs personnalisés",
  "project_settings.custom_fields.save": "Enregistrer",
  "project_settings.custom_fields.saving": "Enregistrement…",
  "project_settings.custom_fields.archived": "archivé",
  "project_settings.custom_fields.toast.saved": "Champs personnalisés enregistrés.",
  "project_settings.custom_fields.toast.error_save":
    "Impossible d'enregistrer les champs personnalisés.",
  "project_settings.general.defaults_title": "Valeurs par défaut des membres",
  "project_settings.general.defaults_description":
    "Choisissez qui dirige le projet et qui reçoit par défaut les nouveaux éléments.",
  "project_settings.general.defaults_save_success": "Valeurs par défaut mises à jour.",
  "project_settings.general.defaults_save_error": "Échec de la mise à jour des valeurs par défaut.",
  "project_settings.general.project_lead_label": "Responsable du projet",
  "project_settings.general.project_lead_placeholder": "Sélectionnez un responsable",
  "project_settings.general.project_lead_none": "Aucun responsable",
  "project_settings.general.default_assignee_label": "Destinataire par défaut",
  "project_settings.general.default_assignee_placeholder": "Sélectionnez un destinataire",
  "project_settings.general.default_assignee_none": "Non attribué",
  "project_settings.general.guest_view_all_label":
    "Les invités peuvent voir toutes les fonctionnalités",
  "project_settings.general.guest_view_all_description":
    "Autoriser les invités à consulter les cycles, modules, pages et vues de ce projet.",
  "project_settings.general.member_select_placeholder": "Sélectionnez un membre",
  "project_settings.general.member_select_none": "Aucun",
  "project_settings.general.archive": "Archiver le projet",
  "project_settings.general.archive_title": "Archiver le projet",
  "project_settings.general.archive_description":
    "L'archivage de {name} le masquera de la navigation. Vous pouvez le restaurer à tout moment.",
  "project_settings.general.archive_section_description":
    "L'archivage retire ce projet des barres latérales et tableaux de bord. Vous pourrez le restaurer plus tard.",
  "project_settings.general.archive_success": "Projet archivé.",
  "project_settings.general.archive_error": "Échec de l'archivage du projet.",
  "project_settings.general.restore": "Restaurer le projet",
  "project_settings.general.restore_title": "Restaurer le projet",
  "project_settings.general.restore_description":
    "Restaurer {name} pour le faire réapparaître dans la navigation.",
  "project_settings.general.restore_section_description":
    "Ce projet est archivé. Restaurez-le pour le rendre de nouveau accessible.",
  "project_settings.general.restore_success": "Projet restauré.",
  "project_settings.general.restore_error": "Échec de la restauration du projet.",
  "project_settings.general.duplicate": "Dupliquer le projet",
  "project_settings.general.duplicate_section_description":
    "Crée une copie de ce projet avec les mêmes champs et éléments de travail. Le nouveau projet démarre avec le statut par défaut.",
  "project_settings.general.duplicate_success": "Projet dupliqué.",
  "project_settings.general.duplicate_error": "Échec de la duplication du projet.",
  "project_settings.general.delete": "Supprimer le projet",
  "project_settings.general.delete_title": "Supprimer le projet",
  "project_settings.general.delete_description":
    "La suppression de {name} retire définitivement tous les éléments, membres et données. Cette action est irréversible.",
  "project_settings.general.delete_section_description":
    "Toutes les données de ce projet seront définitivement supprimées. Cette action est irréversible.",
  "project_settings.general.delete_name_prompt":
    "Saisissez le nom du projet ({name}) pour continuer.",
  "project_settings.general.delete_confirm_prompt": "Saisissez {phrase} ci-dessous pour confirmer.",
  "project_settings.general.delete_confirm_phrase": "supprimer mon projet",
  "project_settings.general.delete_success": "Projet supprimé.",
  "project_settings.general.delete_error": "Échec de la suppression du projet.",
  "project_settings.general.deleting": "Suppression…",
  "project_settings.automations.title": "Automatisations",
  "project_settings.automations.description":
    "Les automatisations des éléments de travail reprennent les valeurs par défaut de votre équipe et peuvent être modifiées ici pour ce projet.",
  "project_settings.automations.read_only":
    "Vous pouvez consulter les automatisations de ce projet, mais pas les modifier.",
  "project_settings.automations.conflict_title": "Quelqu'un d'autre a modifié ces automatisations",
  "project_settings.automations.conflict_description":
    "Vous voyez maintenant sa version. Refaites votre modification si elle est toujours nécessaire.",
  "project_settings.automations.load_error":
    "Impossible de charger les automatisations de ce projet.",
  "project_settings.automations.set_by_team": "Définies par votre équipe",
  "project_settings.automations.set_by_workspace": "Définies par votre espace de travail",
  "project_settings.automations.edit_in_team_settings": "Modifier dans les paramètres de l'équipe",
  "project_settings.automations.edit_in_workspace_settings":
    "Modifier dans les paramètres de l'espace de travail",
  "project_settings.automations.only_team_leads":
    "Seuls les responsables de l'équipe {team} peuvent les modifier",
  "project_settings.automations.only_admins":
    "Seuls les administrateurs de l'espace de travail peuvent les modifier",
  "project_settings.automations.on": "Activée",
  "project_settings.automations.off": "Désactivée",
  "project_settings.automations.moves_project_to": "Passe le projet à {status}",
  "project_settings.automations.moves_work_items_to":
    "Passe les éléments de travail ouverts à {status}",
  "project_settings.automations.after_days_closed_one": "Après 1 jour fermé",
  "project_settings.automations.after_days_closed_many": "Après {count} jours fermés",
  "project_settings.members.title": "Membres",
  "project_settings.members.description":
    "Gérez les membres du projet, invitez des collaborateurs et mettez à jour les rôles.",
  "project_settings.members.invite_action": "Inviter des membres",
  "project_settings.members.section_title": "Membres actifs",
  "project_settings.members.section_description":
    "Les membres du projet peuvent accéder aux tâches, cycles et modules de ce projet.",
  "project_settings.members.no_members": "Aucun membre ne correspond à ces filtres.",
  "project_settings.members.no_email": "Aucun e-mail",
  "project_settings.members.unknown_user": "Utilisateur inconnu",
  "project_settings.members.role_label": "Rôle",
  "project_settings.members.role.project_lead": "Responsable du projet",
  "project_settings.members.role.member": "Membre",
  "project_settings.members.role.guest": "Invité",
  "project_settings.members.role_updated": "Rôle mis à jour.",
  "project_settings.members.role_update_error": "Échec de la mise à jour du rôle.",
  "project_settings.members.remove": "Retirer",
  "project_settings.members.remove_confirm_title": "Retirer ce membre",
  "project_settings.members.remove_confirm_description":
    "Retirer {name} de ce projet ? L'accès sera révoqué immédiatement.",
  "project_settings.members.remove_success": "Membre retiré.",
  "project_settings.members.remove_error": "Échec du retrait du membre.",
  "project_settings.members.filters_search_placeholder": "Rechercher par nom ou e-mail",
  "project_settings.members.filters_role_all": "Tous les rôles",
  "project_settings.members.filters_role_project_lead": "Responsables du projet",
  "project_settings.members.filters_role_member": "Membres",
  "project_settings.members.filters_role_guest": "Invités",
  "project_settings.members.invite_dialog_title": "Inviter au projet",
  "project_settings.members.add_existing_dialog_description":
    "Ajoutez des membres existants de l'espace de travail à ce projet.",
  "project_settings.members.invite_sending": "Envoi…",
  "project_settings.members.add_existing_submit": "Ajouter au projet",
  "project_settings.members.add_existing_required": "Sélectionnez au moins un membre.",
  "project_settings.members.add_existing_success": "Membres ajoutés.",
  "project_settings.members.add_existing_error": "Échec de l'ajout des membres.",
  "project_settings.members.add_existing_empty":
    "Tous les membres de l'espace sont déjà sur ce projet.",
  "project_settings.members.add_existing_search_placeholder":
    "Rechercher par nom, e-mail, équipe ou rôle professionnel",
  "project_settings.members.add_existing_no_match": "Aucun membre correspondant",
  "project_settings.states.title": "Statuts",
  "project_settings.states.description":
    "Configurez les statuts utilisés par les tâches de ce projet.",
  "project_settings.states.group.backlog": "En attente",
  "project_settings.states.group.unstarted": "Non démarré",
  "project_settings.states.group.started": "Démarré",
  "project_settings.states.group.completed": "Terminé",
  "project_settings.states.group.cancelled": "Annulé",
  "project_settings.states.add_state": "Ajouter un statut",
  "project_settings.states.create": "Créer le statut",
  "project_settings.states.save": "Enregistrer",
  "project_settings.states.edit": "Modifier le statut",
  "project_settings.states.delete": "Supprimer le statut",
  "project_settings.states.deleting": "Suppression…",
  "project_settings.states.mark_default": "Définir par défaut",
  "project_settings.states.default_badge": "Par défaut",
  "project_settings.states.empty_group": "Aucun statut dans ce groupe.",
  "project_settings.states.drag_handle": "Glisser pour réordonner",
  "project_settings.states.cannot_delete_default":
    "Le statut par défaut ne peut pas être supprimé. Définissez d'abord un autre statut par défaut.",
  "project_settings.states.create_success": "Statut créé.",
  "project_settings.states.create_error": "Échec de la création du statut.",
  "project_settings.states.update_success": "Statut mis à jour.",
  "project_settings.states.update_error": "Échec de la mise à jour du statut.",
  "project_settings.states.delete_success": "Statut supprimé.",
  "project_settings.states.delete_error": "Échec de la suppression du statut.",
  "project_settings.states.mark_default_success": "Statut par défaut mis à jour.",
  "project_settings.states.mark_default_error": "Échec de la définition du statut par défaut.",
  "project_settings.states.reorder_error": "Échec du réordonnancement des statuts.",
  "project_settings.states.delete_title": "Supprimer le statut",
  "project_settings.states.delete_description":
    "Supprimer le statut « {name} » ? Les tâches qui l'utilisent devront être réaffectées.",
  "project_settings.states.form.name_label": "Nom",
  "project_settings.states.form.name_placeholder": "par ex. En relecture",
  "project_settings.states.form.group_label": "Groupe",
  "project_settings.states.form.color_label": "Couleur",

  // Project settings — workflow
  "project_settings.workflow.title": "Flux de travail",
  "project_settings.workflow.description":
    "Définissez les transitions de statut autorisées et qui peut les effectuer. Les statuts sans règles permettent toutes les transitions.",
  "project_settings.workflow.reset_to_defaults": "Réinitialiser par défaut",
  "project_settings.workflow.reset_confirm_title": "Réinitialiser le flux de travail ?",
  "project_settings.workflow.reset_confirm_description":
    "Cela supprimera toutes les règles de transition personnalisées et les approbateurs. Toutes les transitions de statut deviendront sans restriction.",
  "project_settings.workflow.reset_success": "Flux de travail réinitialisé.",
  "project_settings.workflow.reset_error": "Échec de la réinitialisation du flux de travail.",
  "project_settings.workflow.fetch_error":
    "Échec du chargement de la configuration du flux de travail.",
  "project_settings.workflow.create_allowed": "Autorisé",
  "project_settings.workflow.create_blocked": "Bloqué",
  "project_settings.workflow.create_label": "Création :",
  "project_settings.workflow.no_rules":
    "Aucune règle configurée — toutes les transitions sont autorisées",
  "project_settings.workflow.movers_label": "Déplacé par :",
  "project_settings.workflow.movers_everyone": "Tout le monde",
  "project_settings.workflow.mover_search_placeholder": "Rechercher des membres…",
  "project_settings.workflow.require_approval_label": "Exiger une approbation",
  "project_settings.workflow.approvers_label": "Approbateurs :",
  "project_settings.workflow.approvers_none": "Aucun (tout le monde)",
  "project_settings.workflow.approvers_count": "{count} utilisateurs configurés",
  "project_settings.workflow.required_approvals": "Requis : {count} sur {total}",
  "project_settings.workflow.rejection_state": "Rejet :",
  "project_settings.workflow.configure": "Configurer",
  "project_settings.workflow.configure_title": "Configurer : {state}",
  "project_settings.workflow.configure_description":
    "Définissez les statuts vers lesquels ce statut peut transiter et configurez les exigences d'approbation.",
  "project_settings.workflow.allow_creation": "Autoriser la création de projet dans ce statut",
  "project_settings.workflow.allow_creation_hint":
    "Lorsque activé, de nouveaux projets peuvent être créés directement dans ce statut.",
  "project_settings.workflow.allowed_transitions": "Transitions autorisées",
  "project_settings.workflow.transition_added": "Transition ajoutée.",
  "project_settings.workflow.transition_removed": "Transition supprimée.",
  "project_settings.workflow.transition_update_error": "Échec de la mise à jour de la transition.",
  "project_settings.workflow.update_success": "Flux de travail mis à jour.",
  "project_settings.workflow.update_error": "Échec de la mise à jour du flux de travail.",
  "project_settings.workflow.required_approvals_label": "Approbations requises :",
  "project_settings.workflow.approvals_all": "Toutes",
  "project_settings.workflow.rejection_state_label": "En cas de rejet :",
  "project_settings.workflow.rejection_none": "Aucun",
  "project_settings.workflow.approver_search_placeholder": "Rechercher des membres…",
  "project_settings.workflow.approver_no_members": "Aucun membre trouvé",
  "project_settings.workflow.approver_unknown": "Utilisateur inconnu",
  "project_settings.workflow.add_mover": "Ajouter qui peut déplacer",
  "project_settings.workflow.add_approver": "Ajouter un approbateur",
  "project_settings.workflow.remove_member": "Retirer {name}",

  // Project workflow — approval request dialog
  "project.workflow.approval_required_title": "Approbation requise",
  "project.workflow.approval_required_description":
    "Le passage de ce projet de « {from} » à « {to} » nécessite une approbation.",
  "project.workflow.approval_request_to": "Une demande d'approbation sera envoyée à :",
  "project.workflow.required_approvals_count": "Approbations requises : {count} sur {total}",
  "project.workflow.required_approvals_all": "Approbations requises : Toutes sur {total}",
  "project.workflow.request_approval_button": "Demander l'approbation",
  "project.workflow.approval_request_sent": "Demande d'approbation envoyée",
  "project.workflow.approval_request_error": "Impossible d'envoyer la demande d'approbation",
  "project.workflow.pending_approval": "Approbation en attente",
  "project.workflow.review_required": "Révision requise",
  "project.workflow.pending_approval_title": "Approbation en attente",
  "project.workflow.approval_requested_title": "Approbation demandée",
  "project.workflow.current_approvals":
    "Approbations actuelles : {current} sur {required} requises",
  "project.workflow.approver_status_pending": "En attente",
  "project.workflow.approver_status_approved": "Approuvé",
  "project.workflow.approver_status_rejected": "Rejeté",
  "project.workflow.already_voted": "Vous avez déjà {action} cette transition.",
  "project.workflow.comment_optional": "Commentaire (optionnel)",
  "project.workflow.approve_button": "Approuver",
  "project.workflow.reject_button": "Rejeter",
  "project.workflow.approval_success": "Approbation soumise",
  "project.workflow.rejection_success": "Rejet soumis",
  "project.workflow.approval_error": "Échec de la soumission de l'approbation",
  "project.workflow.rejection_error": "Échec de la soumission du rejet",
  "project.workflow.dismiss": "Fermer",
  "project.workflow.you": "vous",

  // Project workflow — activity log
  "project_settings.workflow.activity_title": "Activité du workflow",
  "project_settings.workflow.activity_empty": "Aucune activité pour le moment",
  "project_settings.workflow.activity_created_transition":
    '{actor} a ajouté une transition vers "{state}"',
  "project_settings.workflow.activity_removed_transition":
    '{actor} a supprimé la transition vers "{state}"',
  "project_settings.workflow.activity_updated_creation": "{actor} a {action} la création de projet",
  "project_settings.workflow.activity_updated_approvers": "{actor} a mis à jour les approbateurs",
  "project_settings.workflow.activity_reset": "{actor} a réinitialisé le workflow",
  "project_settings.workflow.activity_enabled": "activé",
  "project_settings.workflow.activity_disabled": "désactivé",
  "project_settings.workflow.activity_unknown_actor": "Utilisateur inconnu",
  "project_settings.workflow.activity_updated_transition": "{actor} a mis à jour la transition",
  "project_settings.workflow.activity_generic": "{actor} {verb} {field}",
  "project_settings.workflow.unknown_state": "Statut inconnu",

  // Teams
  "teams.page_title": "Équipes",
  "teams.my_teams_title": "Mes équipes",
  "teams.manage_teams": "Gérer les équipes",
  "teams.count_noun": "équipes",
  "teams.count_noun_one": "équipe",
  "teams.count_noun_found": "équipes trouvées",
  "teams.count_noun_found_one": "équipe trouvée",
  "teams.create": "Créer une équipe",
  "teams.search_placeholder": "Rechercher une équipe",
  "teams.expand_all": "Tout développer",
  "teams.collapse_all": "Tout réduire",
  "teams.tabs.rates": "Taux",
  "teams.tabs.members": "Membres",
  "teams.members.col_member": "Membre",
  "teams.members.col_email": "E-mail",
  "teams.members.col_location": "Emplacement",
  "teams.members.col_status": "Statut du compte",
  "teams.members.col_actions": "Actions",
  "teams.members.status_active": "Actif",
  "teams.members.status_inactive": "Inactif",
  "teams.members.edit_profile": "Modifier le profil de l'utilisateur",
  "teams.members.add_time_off": "Ajouter une absence",
  "teams.members.remove_from_team": "Retirer de l'équipe",
  "teams.members.actions_menu_aria": "Actions pour {name}",
  "teams.detail.goal_alignment":
    "{percent} % des projets alignés sur des objectifs ({aligned} sur {total})",
  "teams.detail.edit_team": "Modifier l'équipe",
  "teams.rate.title": "Taux horaire de l'équipe",
  "teams.rate.total_label": "Taux combiné",
  "teams.rate.per_hour": "{amount}/h",
  "teams.rate.member_col": "Membre",
  "teams.rate.rate_col": "Taux",
  "teams.rate.no_members": "Aucun membre avec un taux pour l'instant.",
  "teams.rate.untitled": "Sans nom",
  "teams.rate.load_error": "Indisponible",
  "teams.rate.hint":
    "La somme des taux horaires actuels des membres de l'équipe. Visible uniquement par les administrateurs.",
  "teams.detail.delete_team": "Supprimer l'équipe",
  "teams.column_name": "Nom",
  "teams.column_members": "Membres",
  "teams.column_lead": "Responsable",
  "teams.column_projects": "Projets",
  "teams.column_automations": "Automatisations",
  "teams.column_actions": "Actions",
  "teams.rename_hint": "Renommer l'équipe",
  "teams.lead_edit_aria": "Modifier les responsables",
  "teams.lead_more": "+{count}",
  "teams.empty_title": "Aucune équipe pour l'instant",
  "teams.empty_description": "Organisez vos équipes en groupes virtuels.",
  "teams.empty_cta": "Créez votre première équipe",
  "teams.empty_filtered": "Aucune équipe ne correspond à votre recherche.",
  "teams.empty_mine_title": "Vous ne faites partie d'aucune équipe",
  "teams.empty_mine_cta": "Créer une équipe",
  "teams.empty_mine_description":
    "Les équipes dont vous êtes membre ou responsable apparaissent ici, avec leurs sous-équipes.",
  "teams.dialog.create_title": "Créer une équipe",
  "teams.dialog.create_description": "Regroupez membres et projets dans un espace partagé.",
  "teams.fields.name": "Nom",
  "teams.fields.description": "Description",
  "teams.fields.logo": "Logo",
  "teams.fields.lead": "Responsable",
  "teams.fields.lead_search": "Rechercher des membres",
  "teams.fields.lead_empty": "Aucun membre trouvé",
  "teams.fields.members": "Membres",
  "teams.fields.members_placeholder": "Ajouter des membres",
  "teams.fields.members_count": "{count} sélectionné(s)",
  "teams.fields.members_search": "Rechercher un membre",
  "teams.fields.members_empty": "Aucun membre trouvé",
  "teams.fields.members_remove": "Retirer {name}",
  "teams.fields.projects_search": "Rechercher un projet",
  "teams.fields.projects_remove": "Retirer {name}",
  "teams.actions.create": "Créer",
  "teams.actions.cancel": "Annuler",
  "teams.actions.delete": "Supprimer",
  "teams.delete.home.title": "Supprimer {name} ?",
  "teams.delete.home.root_title": "Supprimer {name}",
  "teams.delete.home.confirm": "Supprimer l'équipe",
  "teams.delete.home.loading": "Vérification des éléments dont {name} est l'équipe principale…",
  "teams.delete.home.preflight_failed":
    "Impossible de vérifier les éléments dont {name} est l'équipe principale : elle ne peut pas encore être supprimée. Fermez cette fenêtre et réessayez.",
  "teams.delete.home.plain_body":
    "{name} n'est l'équipe principale d'aucun projet, programme ou événement. Rien ne doit être déplacé.",
  "teams.delete.home.plain_children":
    "Ses sous-équipes ({children}) deviennent des équipes de premier niveau.",
  "teams.delete.home.sub_body_one":
    "{name} est l'équipe principale d'un élément. Lors de sa suppression, il est automatiquement déplacé vers son équipe parente, {parent}.",
  "teams.delete.home.sub_body_many":
    "{name} est l'équipe principale de {count} éléments. Lors de sa suppression, ils sont automatiquement déplacés vers son équipe parente, {parent}.",
  "teams.delete.home.sub_children_one":
    "Sa sous-équipe {children} devient une équipe de premier niveau. Elle conserve ses propres projets, programmes et événements.",
  "teams.delete.home.sub_children_many":
    "Ses sous-équipes ({children}) deviennent des équipes de premier niveau. Elles conservent leurs propres projets, programmes et événements.",
  "teams.delete.home.root_body_one":
    "{name} est l'équipe principale d'un élément. C'est une équipe de premier niveau : il n'y a pas d'équipe parente vers laquelle le déplacer.",
  "teams.delete.home.root_body_many":
    "{name} est l'équipe principale de {count} éléments. C'est une équipe de premier niveau : il n'y a pas d'équipe parente vers laquelle les déplacer.",
  "teams.delete.home.root_hint": "Réattribuez-les à une autre équipe avant de supprimer.",
  "teams.delete.home.meta_project": "{identifier} · Projet",
  "teams.delete.home.meta_project_on_roster":
    "{identifier} · Projet · parent déjà dans les équipes de livraison",
  "teams.delete.home.meta_program": "Programme",
  "teams.delete.home.meta_event": "{identifier} · Événement",
  "teams.delete.home.meta_event_no_identifier": "Événement",
  "teams.delete.home.meta_request": "{identifier} · Demande",
  "teams.delete.home.meta_request_no_identifier": "Demande",
  "teams.delete.home.meta_program_on_delivery":
    "Programme · parent déjà dans les équipes de livraison",
  "teams.delete.home.added_delivery": "Ajoutée aux équipes de livraison",
  "teams.delete.home.moves_to": "Déplacé vers {parent}",
  "teams.delete.home.more": "Et {count} de plus",
  "teams.reassign_home.title": "Supprimer {name}",
  "teams.reassign_home.intro":
    "{name} est l'équipe principale de {records}. C'est une équipe de premier niveau, il n'y a donc pas de parent vers lequel les déplacer. Attribuez une nouvelle équipe principale à chaque élément, puis supprimez. Vos choix sont enregistrés au fur et à mesure : vous pouvez partir et revenir.",
  "teams.reassign_home.intro_records_one": "{count} élément",
  "teams.reassign_home.intro_records_many": "{count} éléments",
  "teams.reassign_home.lock_note":
    "Seul un administrateur de l'espace de travail peut supprimer une équipe de premier niveau qui est une équipe principale. Demandez à un administrateur de la supprimer et de réattribuer ses éléments.",
  "teams.reassign_home.load_failed":
    "Impossible de charger les éléments dont {name} est l'équipe principale. Rechargez la page pour réessayer.",
  "teams.reassign_home.job_title_one": "Réattribution de {total} élément…",
  "teams.reassign_home.job_title_many": "Réattribution de {total} éléments…",
  "teams.reassign_home.job_done": "{done} sur {total} terminés",
  "teams.reassign_home.job_body":
    "Cette opération s'exécute en arrière-plan. Vous pouvez quitter cette page. Nous vous préviendrons lorsque {name} sera supprimée. Si un élément échoue, l'équipe n'est pas supprimée et les éléments en échec restent listés ici.",
  "teams.reassign_home.job_back": "Retour aux équipes",
  "teams.reassign_home.bulk_label": "Tout réattribuer à",
  "teams.reassign_home.bulk_aria": "Équipe de remplacement pour tous les éléments",
  "teams.reassign_home.bulk_placeholder": "Choisir une équipe…",
  "teams.reassign_home.apply_all": "Appliquer aux {total}",
  "teams.reassign_home.bulk_hint": "puis modifiez les exceptions ci-dessous",
  "teams.reassign_home.download": "Exporter la liste (CSV)",
  "teams.reassign_home.download_failed": "Impossible de télécharger la liste. Réessayez.",
  "teams.reassign_home.tabs_aria": "Type d'élément",
  "teams.reassign_home.tab_all": "Tous",
  "teams.reassign_home.tab_projects": "Projets",
  "teams.reassign_home.tab_programs": "Programmes",
  "teams.reassign_home.tab_events": "Événements",
  "teams.reassign_home.tab_requests": "Demandes",
  "teams.reassign_home.search": "Rechercher des éléments",
  "teams.reassign_home.needs_team": "Sans équipe ({remaining})",
  "teams.reassign_home.selected": "{count} sélectionnés",
  "teams.reassign_home.selected_aria": "Équipe pour les éléments sélectionnés",
  "teams.reassign_home.selected_placeholder": "Attribuer la sélection à…",
  "teams.reassign_home.assign": "Attribuer",
  "teams.reassign_home.clear": "Effacer",
  "teams.reassign_home.select_page": "Tout sélectionner sur cette page",
  "teams.reassign_home.select_row": "Sélectionner {name}",
  "teams.reassign_home.col_record": "Élément",
  "teams.reassign_home.col_type": "Type",
  "teams.reassign_home.col_roster": "Équipes actuelles",
  "teams.reassign_home.col_new_home": "Nouvelle équipe principale",
  "teams.reassign_home.type_project": "Projet",
  "teams.reassign_home.type_program": "Programme",
  "teams.reassign_home.type_event": "Événement",
  "teams.reassign_home.type_request": "Demande",
  "teams.reassign_home.empty": "Aucun élément ne correspond.",
  "teams.reassign_home.row_aria": "Nouvelle équipe principale pour {name}",
  "teams.reassign_home.row_placeholder": "Choisir la nouvelle équipe principale…",
  "teams.reassign_home.page_of": "Page {page} sur {count}",
  "teams.reassign_home.footnote_delivery":
    "La nouvelle équipe principale est ajoutée aux équipes de livraison de chaque projet ou programme si elle n'y figure pas déjà. Les événements liés à un projet suivent l'équipe principale de ce projet ; ils ne sont donc pas listés.",
  "teams.reassign_home.progress_pending":
    "{done} sur {total} réattribués — la suppression se débloque quand chaque élément a une nouvelle équipe principale",
  "teams.reassign_home.progress_ready": "{done} sur {total} réattribués — prêt à supprimer",
  "teams.reassign_home.progress_admins": "Administrateurs de l'espace de travail uniquement",
  "teams.reassign_home.cancel": "Annuler",
  "teams.reassign_home.confirm": "Réattribuer et supprimer",
  "teams.reassign_home.deleted_toast_one":
    "{name} supprimée · {total} élément a une nouvelle équipe principale",
  "teams.reassign_home.deleted_toast_many":
    "{name} supprimée · {total} éléments ont une nouvelle équipe principale",
  "teams.reassign_home.partial_failed_one":
    "{failed} élément n'a pas pu être réattribué, donc {name} n'a pas été supprimée. Il reste listé ci-dessous.",
  "teams.reassign_home.partial_failed_many":
    "{failed} éléments n'ont pas pu être réattribués, donc {name} n'a pas été supprimée. Ils restent listés ci-dessous.",
  "teams.reassign_home.save_failed":
    "Impossible d'enregistrer la nouvelle équipe principale. Réessayez.",
  "teams.reassign_home.reassign_failed": "Impossible de réattribuer les éléments. Réessayez.",
  "teams.reassign_home.picker_search": "Rechercher des équipes",
  "teams.reassign_home.picker_empty": "Aucune équipe ne correspond.",
  "teams.reassign_home.clear_search": "Effacer la recherche",
  "teams.reassign_home.job_not_deleted":
    "{name} n'a pas été supprimée : certains éléments n'ont pas pu être réattribués. Ils restent listés ci-dessous.",
  "teams.reassign_home.csv_filename": "{name} éléments à réattribuer.csv",
  "teams.reassign_home.row_done": "A une nouvelle équipe principale",
  "teams.reassign_home.row_todo": "Sans nouvelle équipe principale",
  "teams.list_item.lead_label": "Responsable : {name}",
  "teams.list_item.member_count": "{count} membres",
  "teams.list_item.project_count": "{count} projets",
  "teams.list_item.automations_on": "{on} sur {total} actives",
  "teams.list_item.automations_none": "Aucune active",
  "teams.list_item.automations_link_aria": "Automatisations de {name} : {count}",
  "teams.list_item.menu_view": "Afficher",
  "teams.list_item.menu_edit": "Modifier",
  "teams.list_item.menu_delete": "Supprimer",
  "teams.list_item.row_actions_aria": "Actions pour {name}",
  "teams.toast.created": "Équipe créée",
  "teams.toast.create_failed": "Échec de la création",
  "teams.toast.deleted": "Équipe supprimée",
  "teams.toast.delete_failed": "Échec de la suppression",
  "teams.toast.updated": "Équipe mise à jour",
  "teams.toast.update_failed": "Échec de la mise à jour",
  "teams.toast.member_added": "Membre ajouté",
  "teams.toast.member_removed": "Membre retiré",
  "teams.toast.member_failed": "Échec de la mise à jour des membres",
  "teams.toast.project_added": "Projet ajouté",
  "teams.toast.project_removed": "Projet retiré",
  "teams.toast.project_failed": "Échec de la mise à jour des projets",
  "teams.detail.capacity": "Capacité",
  "teams.detail.members_heading": "Membres",
  "teams.detail.members_empty": "Aucun membre",
  "teams.detail.members_add": "Ajouter un membre",
  "teams.detail.projects_heading": "Projets",
  "teams.detail.projects_empty": "Aucun projet lié",
  "teams.detail.projects_add": "Ajouter un projet",
  "teams.detail.description_placeholder": "Ajouter une description",
  "teams.detail.lead_placeholder": "Choisir un responsable",
  "teams.detail.name_edit_hint": "Entrée pour enregistrer, Échap pour annuler",
  "teams.detail.not_found": "Équipe introuvable",
  "teams.detail.load_failed": "Impossible de charger l'équipe. Veuillez réessayer.",
  "teams.detail.last_member_cannot_remove": "Une équipe doit avoir au moins un membre.",
  "teams.detail.lead_cannot_remove": "Impossible de retirer le dernier responsable.",
  "teams.detail.add_members_title": "Ajouter des membres",
  "teams.detail.add_projects_title": "Ajouter des projets",
  "teams.detail.add_projects_empty": "Tous les projets sont liés",
  "teams.detail.no_subteams": "Aucune sous-équipe pour le moment",
  "teams.tabs.subteams": "Sous-équipes",
  "teams.tabs.team_capacity": "Capacité de l'équipe",
  "teams.tabs.aria_label": "Sections de l'équipe",
  "teams.actions.create_subteam": "Créer une sous-équipe",
  "teams.dialog.create_subteam_title": "Créer une sous-équipe",
  "teams.fields.parent_team": "Équipe parente",
  "teams.fields.parent_placeholder": "Sélectionner une équipe parente",
  "teams.fields.parent_search": "Rechercher des équipes",
  "teams.fields.parent_empty": "Aucune équipe trouvée",
  "teams.fields.no_parent": "Aucune (équipe racine)",
  "teams.fields.parent_root_option": "Aucun parent (équipe racine)",
  "teams.fields.parent_admin_only": "Seuls les administrateurs peuvent modifier l'équipe parente.",
  "teams.fields.parent_note_self": "cette équipe",
  "teams.fields.parent_note_descendant": "sous-équipe",
  "teams.fields.parent_confirm": "Confirmer le changement",
  "teams.fields.parent_change_title": "Remplacer le parent de {team} par {parent} ?",
  "teams.fields.parent_change_description":
    "{team} héritera désormais des flux de travail, modèles, SLA et autres ressources attribués à {parent} (le cas échéant), et {parent} pourra voir les données de {team} dans les rapports. Les membres de l'équipe et les regroupements de rapports sont mis à jour immédiatement.",
  "teams.fields.parent_remove_title": "Supprimer le parent de {team} ?",
  "teams.fields.parent_remove_description":
    "{team} deviendra une équipe racine. Elle n'héritera plus des ressources de {parent}, et {parent} ne verra plus les données de {team} dans les rapports.",
  "teams.fields.parent_remove_description_unnamed":
    "{team} deviendra une équipe racine. Elle n'héritera plus des ressources de son parent actuel, et cette équipe ne verra plus les données de {team} dans les rapports.",
  "teams.fields.parent_children_note": "Les sous-équipes de {team} sont déplacées avec elle.",

  // Team settings
  "team_settings.tabs.general": "Général",
  "team_settings.tabs.members": "Membres",
  "team_settings.tabs.templates": "Modèles de projet",
  "team_settings.tabs.intake_workflows": "Flux de demandes",
  "team_settings.tabs.calendars": "Calendriers",
  "team_settings.tabs.sla": "SLA",
  "team_settings.tabs.automations": "Automatisations",
  "team_settings.automations.title": "Automatisations",
  "team_settings.automations.description":
    "S'applique à chaque projet et à chaque demande dont l'équipe d'origine est {team}. Les modifications sont enregistrées comme brouillon et prennent effet sur les projets et demandes ouverts lors de la publication. Les responsables d'équipe et les administrateurs peuvent les modifier.",
  "team_settings.automations.published":
    "Publié · appliqué aux projets et demandes ouverts de l'équipe",
  "team_settings.automations.published_by":
    "Publié par {name} le {date} · appliqué aux projets et demandes ouverts de l'équipe",
  "team_settings.automations.publish_success":
    "Automatisations publiées. Elles s'appliquent désormais aux projets et demandes ouverts de l'équipe.",
  "team_settings.automations.publish_error":
    "Impossible de publier les automatisations. Veuillez réessayer.",
  "team_settings.automations.discard_confirm_description":
    "Les automatisations de l'équipe reviendront à la dernière version publiée. Cette action est irréversible.",
  "team_settings.automations.read_only":
    "Vous pouvez consulter les automatisations de cette équipe, mais pas les modifier.",
  "team_settings.automations.load_error": "Impossible de charger les automatisations de l'équipe.",
  "team_settings.templates.list_description":
    "Modèles de projet auxquels cette équipe a accès. Les modèles rattachés à une équipe parente, ou à tout l'espace de travail, sont en lecture seule.",
  "team_settings.templates.empty_state":
    "Aucun modèle de projet n'est encore disponible pour cette équipe.",
  "team_settings.intake_workflows.list_description":
    "Les flux de demandes gérés par cette équipe. Les flux gérés par une équipe parente sont en lecture seule.",
  "team_settings.intake_workflows.empty_state":
    "Cette équipe ne gère aucun flux de demandes pour le moment.",
  "team_settings.sla.title": "SLA",
  "team_settings.sla.description":
    "Les accords de niveau de service qui régissent les demandes de cette équipe.",
  "team_settings.sla.group_manages_title": "Gérés par cette équipe",
  "team_settings.sla.group_manages_description":
    "Limités aux flux de travail de cette équipe. Modifiables sauf si le SLA couvre aussi un flux de travail appartenant à une équipe que vous ne gérez pas.",
  "team_settings.sla.group_inherited_title": "Hérités d'une autre équipe",
  "team_settings.sla.group_inherited_description":
    "Gérés ailleurs dans la hiérarchie des équipes et appliqués aux demandes de cette équipe. Lecture seule.",
  "team_settings.sla.group_residual_title": "SLA général de l'espace de travail",
  "team_settings.sla.group_residual_description":
    "S'applique aux demandes de cette équipe provenant de flux de travail sans SLA propre. Géré dans les paramètres de l'espace de travail.",
  "team_settings.sla.row_editable": "Modifier",
  "team_settings.sla.row_view_only": "Lecture seule",
  "team_settings.sla.empty_title": "Aucun SLA ne s'applique encore à cette équipe",
  "team_settings.sla.empty_description":
    "Dès qu'un SLA couvre un des flux de travail de cette équipe, il apparaît ici.",
  "team_settings.sla.load_error_title": "Impossible de charger les SLA de cette équipe",
  "team_settings.sla.load_error_description":
    "Une erreur s'est produite lors de la récupération de la liste.",
  "team_settings.sla.view_only_banner_unnamed_team": "une autre équipe",
  "team_settings.sla.view_only_banner_other_team_title": "Géré par une autre équipe",
  "team_settings.sla.view_only_banner_other_team_description":
    "Ce SLA couvre également des flux de travail appartenant à {teams} ; seule une personne qui les gère tous peut le modifier.",
  "team_settings.sla.view_only_banner_inherited_title": "Géré par {teams}",
  "team_settings.sla.view_only_banner_inherited_description":
    "Une autre équipe possède ce SLA. Il s'applique aux demandes de votre équipe, mais seule cette équipe peut le modifier.",
  "team_settings.sla.view_only_banner_residual_title":
    "Il s'agit du SLA général de l'espace de travail",
  "team_settings.sla.view_only_banner_residual_description":
    "Il couvre les demandes provenant de flux de travail sans SLA propre et se gère dans les paramètres de l'espace de travail.",
  "team_settings.general.title": "Général",
  "team_settings.general.description": "Gérez les informations de base de votre équipe.",
  "team_settings.general.logo_label": "Logo",
  "team_settings.general.name_label": "Nom de l'équipe",
  "team_settings.general.description_label": "Description",
  "team_settings.general.name_required": "Le nom de l'équipe est requis.",
  "team_settings.general.save": "Enregistrer les modifications",
  "team_settings.general.saving": "Enregistrement…",
  "team_settings.members.title": "Membres",
  "team_settings.members.description": "Gérez les membres de cette équipe et leurs rôles.",
  "team_settings.members.add_action": "Ajouter des membres",
  "team_settings.members.add_dialog_title": "Ajouter des membres",
  "team_settings.members.add_dialog_description":
    "Sélectionnez des membres de l'espace de travail à ajouter à cette équipe.",
  "team_settings.members.child_access_lead":
    "Ces membres auront également accès à {count, plural, one {# sous-équipe} other {# sous-équipes}} :",
  "team_settings.members.add_placeholder": "Sélectionner des utilisateurs...",
  "team_settings.members.search": "Rechercher des membres...",
  "team_settings.members.no_results": "Aucun utilisateur trouvé.",
  "team_settings.members.current_heading": "Membres actuels",
  "team_settings.members.current_description":
    "Modifiez les rôles ou retirez des membres de cette équipe.",
  "team_settings.members.no_members": "Aucun membre pour le moment.",
  "team_settings.members.role_label": "Rôle",
  "team_settings.members.role.lead": "Responsable",
  "team_settings.members.role.member": "Membre",
  "team_settings.members.remove": "Retirer",
  "team_settings.members.remove_confirm_title": "Retirer le membre",
  "team_settings.members.remove_confirm_description":
    "Voulez-vous vraiment retirer {name} de cette équipe ?",

  // Connected apps: the rotate-secret and revoke modals and the one-time secret banner (NG-2581)
  "oauth_apps.rotate.title": "Renouveler le secret client",
  "oauth_apps.rotate.description_before": "Un nouveau secret sera généré pour",
  "oauth_apps.rotate.description_after":
    ". Le secret actuel cesse de fonctionner immédiatement : toute intégration déployée qui utilise l'ancien secret échouera jusqu'à sa mise à jour.",
  "oauth_apps.rotate.rotating": "Renouvellement…",
  "oauth_apps.rotate.confirm": "Renouveler le secret",
  "oauth_apps.rotate.error": "Échec du renouvellement du secret.",
  "oauth_apps.secret.title": "Secret client de {name}",
  "oauth_apps.secret.note":
    "Il n'est affiché qu'une seule fois. Enregistrez-le maintenant : vous ne pourrez plus le voir. Si vous le perdez, renouvelez le secret pour en émettre un nouveau.",
  "oauth_apps.secret.copied": "Copié",
  "oauth_apps.secret.copy": "Copier",
  "oauth_apps.secret.copy_first": "Copiez d'abord le secret",
  "oauth_apps.secret.dismiss": "Je l'ai copié",
  "oauth_apps.revoke.title": "Révoquer l'accès ?",
  "oauth_apps.revoke.description_after":
    "ne pourra plus agir en votre nom. Pour utiliser à nouveau cette application, vous devrez lui accorder l'accès de zéro.",
  "oauth_apps.revoke.revoking": "Révocation…",
  "oauth_apps.revoke.confirm": "Révoquer l'accès",

  // Logo picker
  "logo_picker.emoji_tab": "Émoji",
  "logo_picker.icon_tab": "Icône",
  "logo_picker.search_emoji": "Rechercher un émoji",
  "logo_picker.search_icon": "Rechercher une icône",
  "logo_picker.remove": "Retirer le logo",

  // Shared activity, picker and label components (NG-2585)
  "activity.filter.all": "Toute l'activité",
  "activity.filter.comments": "Commentaires",
  "activity.filter.changes": "Modifications",
  "activity.filter.system": "Système",
  "activity.filter.aria": "Filtrer l'activité",
  "activity.time.just_now": "À l'instant",
  "activity.time.minutes_ago": "Il y a {count} minutes",
  "activity.time.hours_ago": "{count, plural, one {Il y a # heure} other {Il y a # heures}}",
  "activity.time.yesterday": "Hier",
  "activity.time.yesterday_at": "Hier · {time}",
  "activity.sheet.title": "Activité",
  "activity.sheet.close_aria": "Fermer l'activité",
  "activity.timeline.automation_actor": "Automatisation",
  "activity.timeline.hide_earlier": "Masquer les événements antérieurs",
  "activity.timeline.show_earlier":
    "{count, plural, one {Afficher {countText} événement antérieur} other {Afficher {countText} événements antérieurs}}",
  "custom_field_input.archived_option": "{value} (option archivée)",
  "logo_picker.skin_tone": "Teint de peau",
  "logo_picker.loading": "Chargement…",
  "logo_picker.no_emoji": "Aucun emoji trouvé",
  "project.state_label.aria": "Statut {name}",

  // Schedule (Gantt)
  "schedule.title": "Calendrier",
  "schedule.subtitle_count": "{count} éléments de travail",
  "schedule.time_off_conflict": "En conflit avec une absence",
  "schedule.today": "Aujourd’hui",
  "schedule.fullscreen_enter": "Plein écran",
  "schedule.fullscreen_exit": "Quitter le plein écran",
  "schedule.peek_title": "Élément de travail",
  "schedule.peek_description": "Consulter et modifier les détails de cet élément de travail.",

  // Quick view panel — lightweight read-only summary opened from a name click.
  "quick_view.title": "Aperçu rapide",
  "quick_view.description": "Un résumé de cet élément de travail.",
  "quick_view.open_full_view": "Ouvrir la vue complète",
  "quick_view.tabs_label": "Sections de l'aperçu rapide",
  "quick_view.tab_details": "Détails",
  "quick_view.tab_comments": "Commentaires",
  "quick_view.group.overview": "Aperçu",
  "quick_view.group.sub_tasks": "Sous-tâches",
  "quick_view.group.dependencies": "Dépendances",
  "quick_view.group.time_logs": "Temps consigné",
  "quick_view.group.attachments": "Pièces jointes",
  "quick_view.stage": "Étape",
  "quick_view.skills": "Qualifications",
  "quick_view.skills_search": "Rechercher des qualifications…",
  "quick_view.skills_empty": "Aucune qualification trouvée",
  "quick_view.skills_saving": "Enregistrement…",
  "quick_view.actual_hours": "Heures réelles",
  "quick_view.not_completed": "Non terminé",
  "quick_view.all_day_yes": "Oui",
  "quick_view.all_day_no_timezone": "Aucun fuseau horaire. Mêmes dates pour tout le monde.",
  "quick_view.unassigned": "Non assigné",
  "quick_view.col.name": "Nom",
  "quick_view.col.assignee": "Responsable",
  "quick_view.col.status": "Statut",
  "quick_view.col.relation": "Relation",
  "quick_view.col.id": "ID",
  "quick_view.col.title": "Titre",
  "quick_view.col.file": "Fichier",
  "quick_view.col.size": "Taille",
  "quick_view.add_sub_task": "Ajouter une sous-tâche",
  "quick_view.add_dependency": "Ajouter une dépendance",
  "quick_view.add_time_log": "Consigner du temps",
  "quick_view.add_attachment": "Ajouter une pièce jointe",
  "schedule.block_reschedule_failed": "Échec de la replanification. Veuillez réessayer.",
  "schedule.empty_title": "Rien de planifié",
  "schedule.empty_description":
    "Définissez des dates de début et cibles sur les éléments pour les voir ici.",
  "schedule.quick_add_tooltip": "Double-cliquez sur une ligne vide pour ajouter un élément",
  "schedule.missing_dates_hint": "Non planifié",
  "schedule.column.name": "Nom",
  "schedule.column.duration": "Durée",
  "schedule.column.dates": "Dates",
  "schedule.cycle_rejected": "Cela créerait un cycle de dépendances.",
  "schedule.delete_dependency_title": "Supprimer la dépendance",
  "schedule.delete_dependency_description":
    "Supprimer cette relation entre les deux éléments de travail ? Elle pourra être recréée plus tard.",
  "schedule.delete_dependency_confirm": "Supprimer la dépendance",
  "schedule.delete_dependency_failed":
    "Échec de la suppression de la dépendance. Veuillez réessayer.",
  "schedule.create_dependency_failed": "Échec de la création de la dépendance. Veuillez réessayer.",
  "schedule.clear_filters": "Effacer les filtres",
  "schedule.empty_filtered_title": "Aucun résultat",
  "schedule.empty_filtered_description": "Aucun élément ne correspond aux filtres actuels.",
  "schedule.loading": "Chargement du planning",
  "schedule.aria_label": "{name}, planifié du {start} au {end}",
  "schedule.aria_label_unscheduled": "{name}, non planifié",

  // Intake
  "intake.nav.forms": "Formulaires",
  "intake.nav.intakeWorkflows": "Flux d'admission",
  "intake.nav.submissions": "Demandes",
  "intake.nav.requests": "Demandes",
  "intake.nav.reviews": "Mes révisions",
  "intake.noAccess": "Vous n'avez pas accès à la section intake.",
  "intake.project.disabled.title": "Intake désactivé",
  "intake.project.disabled.description":
    "Activez l'intake pour ce projet dans les paramètres avant que les demandeurs puissent l'utiliser.",
  "intake.project.disabled.enable": "Activer l'intake",
  "intake.project.enabled.title": "L'intake est géré au niveau de l'espace de travail",
  "intake.project.enabled.description":
    "Créez, modifiez et examinez les formulaires de demande depuis la section intake de l'espace de travail.",
  "intake.project.enabled.goToWorkspace": "Aller à l'intake de l'espace",
  "intake.builder.title": "Démo d'intake V3",
  "intake.builder.fileMultiple": "Autoriser plusieurs fichiers",
  "intake.builder.fileMaxSizeMb": "Taille maximale par fichier (Mo)",
  "intake.builder.fileMaxSizeMbHint":
    "Laissez vide pour utiliser la limite de l'espace de travail.",
  "intake.builder.fileAcceptedMimeTypes": "Types de fichiers acceptés",
  "intake.builder.fileAcceptedMimeTypesHint":
    "Types MIME séparés par des virgules. Utilisez des motifs comme image/* ou laissez vide pour tout accepter.",
  "intake.builder.badge": "Backend indépendant du fournisseur",
  "intake.builder.description":
    "Un formulaire de demande de contenu rendu à partir d'un schéma Cognota, avec libellés EN/FR, pages conditionnelles et filtrage des champs internes.",
  "intake.builder.localeLabel": "Langue du formulaire de démo",
  "intake.builder.english": "English",
  "intake.builder.french": "Français",
  "intake.builder.submit": "Soumettre la demande",
  "intake.builder.submitting": "Soumission…",
  "intake.builder.submitSuccess": "Demande de démo soumise.",
  "intake.builder.submitError": "Échec de la soumission de la demande de démo.",
  "intake.builder.loadError": "Échec du chargement du formulaire.",
  "intake.builder.errorTitle": "Démo non disponible",
  "intake.builder.errorRetry": "Réessayer",
  "intake.builder.debugTitle": "Limite du schéma",
  "intake.builder.debugClose": "Fermer la limite du schéma",
  "intake.builder.debugDescription":
    "Le backend stocke du JSON Cognota. Le JSON SurveyJS est généré à la frontière frontend.",
  "intake.builder.agnosticJson": "Définition agnostique Cognota",
  "intake.builder.surveyJson": "JSON SurveyJS généré",
  "intake.builder.tabs.requester": "Demandeur",
  "intake.builder.tabs.author": "Auteur",
  "intake.builder.formDetails": "Détails du formulaire",
  "intake.builder.workflowDetails": "Détails du flux",
  "intake.builder.formBuilder": "Constructeur de formulaire",
  "intake.builder.formWorkflow": "Flux",
  "intake.builder.active": "Actif",
  "intake.builder.inactive": "Désactivé",
  "intake.builder.activeToggle": "Bascule actif/inactif",
  "intake.builder.activateBlocked":
    "Impossible d'activer ce formulaire. Corrigez d'abord ces champs. Chacun utilise un champ personnalisé archivé ou dépend d'un champ qui n'existe plus : {fields}",
  "intake.builder.activeToggleError":
    "Impossible de changer l'état actif de ce formulaire. Réessayez.",
  "intake.builder.formName": "Nom du flux",
  "intake.builder.formDescription": "Description",
  // L'axe AUDIENCE du flux (#3144) — renommé depuis « Équipes » maintenant que
  // la propriété a son propre champ (Équipe responsable).
  "intake.builder.teams": "Équipes soumettrices",
  "intake.builder.teamsEntireWorkspace": "Tout l'espace de travail",
  // L'axe PROPRIÉTÉ du flux (#3144) — sélection unique, requise à la publication.
  "intake.builder.homeTeam": "Équipe principale",
  "intake.builder.managingTeamPlaceholder": "Sélectionner une équipe",
  "intake.builder.managingTeamSearchPlaceholder": "Rechercher des équipes",
  "intake.builder.homeTeamVisibilityHint":
    "L'équipe sélectionnée et toutes les équipes situées au-dessus d'elle dans la hiérarchie pourront voir les demandes soumises au moyen de ce flux.",
  "intake.builder.managingTeamLockedHint":
    "Définie sur l'équipe à partir de laquelle ce flux est créé.",
  "intake.builder.viewOnlyBanner.title": "Ce flux est en lecture seule",
  "intake.builder.viewOnlyBanner.description":
    "Il est géré par une autre équipe : seules cette équipe et les équipes situées au-dessus d'elle peuvent le modifier.",
  "intake.builder.emptyReadOnly.title": "Ce flux n'a pas encore été construit",
  "intake.builder.emptyReadOnly.description":
    "Il est géré par une autre équipe et ne contient aucune étape à consulter. Les étapes apparaîtront ici dès que cette équipe les aura ajoutées.",
  "intake.builder.canEditError":
    "Impossible de vérifier si vous pouvez modifier ce flux : il est ouvert en lecture seule. Rechargez la page pour réessayer.",
  "intake.builder.loadErrorBanner.title": "Impossible de charger ce flux",
  "intake.builder.loadErrorBanner.description":
    "Une erreur s'est produite lors de sa récupération. Rechargez la page pour réessayer.",
  "intake.builder.loadErrorBanner.descriptionWithStatus":
    "Le serveur a répondu {status}. Rechargez la page pour réessayer — si le problème persiste, vous n'avez peut-être pas accès à ce flux.",
  "intake.builder.requestType": "Type de demande par défaut",
  "intake.builder.requestCategory": "Catégorie de demande par défaut",
  "intake.builder.defaultRequestOwner": "Propriétaire par défaut",
  "intake.builder.teamsPlaceholder": "Sélectionner des équipes",
  "intake.builder.requestTypePlaceholder": "Sélectionner un type de demande",
  "intake.builder.requestCategoryPlaceholder": "Sélectionner une catégorie de demande",
  "intake.builder.defaultRequestOwnerPlaceholder": "Sélectionner un propriétaire par défaut",
  "intake.builder.teamsHint":
    "Les équipes sélectionnées et toutes les équipes situées sous elles dans la hiérarchie pourront utiliser ce flux pour créer des demandes.",
  "intake.builder.defaultRequestOwnerSearchPlaceholder": "Rechercher des propriétaires par défaut",
  "intake.builder.noTeams": "Aucune équipe active disponible.",
  "intake.builder.noOwners": "Aucun membre actif disponible.",
  "intake.builder.slas": "SLA",
  "intake.builder.slasPlaceholder": "Sélectionner des SLA",
  "intake.builder.slasSearchPlaceholder": "Rechercher des SLA",
  "intake.builder.noSlas": "Aucun SLA disponible.",
  "intake.builder.slasHint":
    "Les demandes issues de ce flux de travail sont mesurées selon ces SLA. Laissez vide pour utiliser le SLA universel de l'espace de travail.",
  "intake.builder.slasCreate": "Créer un SLA",
  "intake.builder.slasError": "Impossible de mettre à jour les SLA de ce flux de travail.",
  "intake.builder.slasCatchAllDisabled":
    "Le SLA universel couvre déjà tous les flux de travail qui n'ont pas leur propre SLA ; il ne peut donc pas être associé directement à l'un d'eux.",
  "intake.builder.slasOnePerWorkflow":
    "Un flux de travail appartient à un seul SLA. Retirez le SLA actuel pour en choisir un autre.",
  "intake.builder.slasInactiveHeld": "{name} (inactif)",
  "intake.builder.save": "Enregistrer",
  "intake.builder.saving": "Enregistrement…",
  "intake.builder.discard": "Annuler les modifications",
  // Pastille d'état d'auto-enregistrement partagée — utilisée par le
  // générateur de formulaires et les onglets de modèles de projet.
  "autosave.saving": "Enregistrement…",
  "autosave.saved_at": "Enregistré {time}",
  "autosave.saved": "Enregistré",
  "autosave.idle": "Pas encore enregistré",
  "autosave.up_to_date": "À jour",
  "autosave.pending": "Modifications non publiées",
  "autosave.pending_changes": "Modifications en attente",
  "autosave.save_failed_pill": "Échec de l'enregistrement",
  // Intake uniquement : libellé de l'infobulle des champs modifiés.
  "intake.builder.autosavePendingFormContent": "Contenu du formulaire",
  "intake.builder.formDetails.fieldName": "Nom du formulaire",
  "intake.builder.formDetails.fieldDescription": "Description",
  "intake.builder.formDetails.fieldRequestType": "Type de demande",
  "intake.builder.formDetails.fieldRequestCategory": "Catégorie de demande",
  "intake.builder.formDetails.fieldTeams": "Équipes soumettrices",
  "intake.builder.publish": "Publier les modifications",
  "intake.builder.publishing": "Publication…",
  "intake.builder.publishSuccess": "Modifications publiées. Les demandeurs les verront maintenant.",
  "intake.builder.publishError": "Impossible de publier les modifications. Réessayez.",
  "intake.builder.publishBlocked": "Publication impossible pour l'instant :",
  "intake.builder.publishDisabledNoChanges": "Aucune modification non publiée à publier.",
  "intake.builder.publishDisabledInactive":
    "Le formulaire doit être Actif avant que les modifications puissent être publiées.",
  "intake.builder.publishMissingFields":
    "Publication impossible — requis avant de publier : {fields}. Renseignez-les dans les détails du formulaire.",
  "intake.builder.publishInvalidDraft":
    "Publication impossible — {count} champ(s) du constructeur comportent des erreurs de validation. Corrigez les champs surlignés et réessayez.",
  "intake.builder.requiredField.name": "nom du formulaire",
  "intake.builder.requiredField.requestType": "type de demande",
  "intake.builder.requiredField.requestCategory": "catégorie de demande",
  "intake.builder.autosaveError":
    "Vos dernières modifications n'ont pas pu être enregistrées. Corrigez les erreurs surlignées — modifier à nouveau relancera l'enregistrement.",
  "intake.builder.moreActions": "Plus d'actions",
  "intake.builder.discardConfirmTitle": "Annuler les modifications non publiées ?",
  "intake.builder.discardConfirmBody":
    "Votre formulaire reviendra à la version publiée pour la dernière fois {publishedAt}. Toute modification de nom, description, type de demande, équipe ou contenu enregistrée depuis sera perdue. Cette action est irréversible.",
  "intake.builder.discardConfirmNeverPublished": "(jamais publié)",
  "intake.builder.discardCancel": "Conserver les modifications",
  "intake.builder.discardConfirm": "Annuler les modifications",
  "intake.builder.discardSuccess": "Modifications annulées.",
  "intake.builder.discardError": "Impossible d'annuler les modifications. Réessayez.",
  "intake.builder.discardNeverPublished":
    "Ce workflow n'a jamais été publié : il n'existe aucune version antérieure à restaurer.",
  "intake.builder.reset": "Réinitialiser le workflow",
  "intake.builder.resetConfirmTitle": "Réinitialiser ce workflow ?",
  "intake.builder.resetConfirmBody":
    "Toutes les étapes, pages et champs que vous avez créés seront supprimés et le workflow repartira d'une première page vide. Ce workflow n'a jamais été publié : il n'existe aucune version antérieure sur laquelle se replier. Cette action est irréversible.",
  "intake.builder.resetCancel": "Continuer la création",
  "intake.builder.resetConfirm": "Réinitialiser le workflow",
  "intake.builder.resetSuccess": "Workflow réinitialisé.",
  "intake.builder.resetError": "Impossible de réinitialiser le workflow. Réessayez.",
  "intake.builder.discardFormOnlyNeverPublished":
    "Détails du formulaire rétablis. Le workflow lui-même a été laissé tel quel : il n'a jamais été publié, il n'existe donc aucune version antérieure à restaurer.",
  "intake.builder.saveSuccess": "Formulaire enregistré.",
  "intake.builder.saveError": "Échec de l'enregistrement du formulaire.",
  "intake.builder.saveDisabledInvalid":
    "Remplissez toutes les étiquettes et valeurs d'options obligatoires avant d'enregistrer.",
  "intake.builder.errorBanner": "Certaines modifications n'ont pas pu être enregistrées",
  "intake.builder.collapseProperties": "Réduire le panneau de propriétés",
  "intake.builder.expandProperties": "Développer le panneau de propriétés",
  "intake.builder.backToList": "Formulaires de demande",
  "intake.builder.untitled": "Formulaire sans titre",
  "intake.builder.statusActive": "Actif",
  "intake.builder.statusInactive": "Désactivé",
  "intake.builder.lastSaved": "Dernier enregistrement {time}",
  "intake.builder.preview": "Aperçu du formulaire",
  "intake.builder.delete": "Supprimer le formulaire",
  "intake.builder.previewDialogDescription": "Voici comment les demandeurs verront le formulaire.",
  "intake.builder.previewPartial":
    "À partir de cette page — les décisions de branchement et de révision précédentes n’ont pas été évaluées.",
  "intake.builder.previewLoading": "Chargement de l’aperçu…",
  "intake.builder.previewEmpty":
    "Ajoutez des champs à la première page pour prévisualiser le formulaire du demandeur.",
  "intake.builder.previewError": "Impossible de charger l’aperçu. Réessayez.",
  "intake.builder.previewContinue": "Continuer",
  "intake.builder.previewReviewChoicePrompt":
    "L’aperçu ne peut pas savoir comment cette révision serait décidée — choisissez un résultat pour continuer.",
  "intake.builder.previewReachedEnd": "Vous avez atteint la fin de ce flux de travail.",
  "intake.builder.previewIncomplete":
    "Ce chemin n’a pas encore été terminé, l’aperçu ne peut donc pas continuer.",
  "intake.builder.previewRestart": "Recommencer l’aperçu",
  "intake.builder.previewAdvanceError": "Impossible de continuer l’aperçu. Réessayez.",
  "intake.builder.previewPartialRecourse":
    "Recommencez l\u2019aper\u00e7u depuis la premi\u00e8re page pour les \u00e9valuer r\u00e9ellement.",
  "intake.builder.previewEndAuto":
    "Le workflow termine automatiquement la demande ici et cr\u00e9e son projet.",
  "intake.builder.previewEndManual":
    "La demande attend ici d\u2019\u00eatre termin\u00e9e manuellement.",
  "intake.builder.previewIncompleteRecourse":
    "Terminez ce chemin sur le canevas, puis relancez l\u2019aper\u00e7u.",
  "intake.builder.previewOwnerHeading": "Responsable de la demande",
  "intake.builder.previewOwnerNone":
    "Aucun responsable \u2014 rien sur ce chemin n\u2019en a attribu\u00e9.",
  "intake.builder.previewTrail.heading": "Chemin parcouru",
  "intake.builder.previewTrail.description":
    "Ce que cet aper\u00e7u a travers\u00e9 pour atteindre l\u2019\u00e9tape ci-dessus. Les demandeurs ne voient pas ceci.",
  "intake.builder.previewTrail.current": "Vous \u00eates ici",
  "intake.builder.previewTrail.branchTrue": "Condition remplie \u2014 chemin \u00ab oui \u00bb",
  "intake.builder.previewTrail.branchFalse":
    "Condition non remplie \u2014 chemin \u00ab non \u00bb",
  "intake.builder.previewTrail.decidedAutomatically": "D\u00e9cid\u00e9 automatiquement : {option}",
  "intake.builder.previewTrail.decidedByYou": "Vous avez choisi : {option}",
  "intake.builder.previewTrail.pageSkipped":
    "Ignor\u00e9e \u2014 masqu\u00e9e par sa r\u00e8gle d\u2019affichage",
  "intake.builder.previewTrail.pageBlank": "Ignor\u00e9e \u2014 cette page est vide",
  "intake.builder.previewTrail.ownerAdded": "Responsable ajout\u00e9 : {names}",
  "intake.builder.previewTrail.ownerReplaced": "Responsable remplac\u00e9 par {names}",
  "intake.builder.previewTrail.ownerNoRule":
    "Aucune r\u00e8gle ne correspond \u00e0 cette r\u00e9ponse \u2014 le responsable resterait inchang\u00e9",
  "intake.builder.previewTrail.ownerNobody":
    "R\u00e8gle correspondante sans destinataire \u2014 le responsable resterait inchang\u00e9",
  "intake.builder.previewTrail.awaitingDecision": "En attente d\u2019une d\u00e9cision de revue",
  "intake.builder.previewTrail.laneUnwired": "Ce chemin n\u2019est pas encore termin\u00e9",
  "intake.builder.previewTrail.unnamedPage": "Page",
  "intake.builder.previewTrail.unnamedReview": "Revue",
  "intake.builder.previewTrail.unnamedEnd": "Fin",
  "intake.builder.previewTrail.unnamedStep": "\u00c9tape",
  "intake.builder.deleteConfirmTitle": "Supprimer « {name} » ?",
  "intake.builder.deleteConfirmBody":
    "Ce formulaire et son historique de soumissions seront archivés. Les nouvelles soumissions seront bloquées.",
  "intake.builder.deleteCancel": "Annuler",
  "intake.builder.deleteConfirm": "Supprimer",
  "intake.builder.deleteSuccess": "Formulaire supprimé.",
  "intake.builder.deleteError": "Échec de la suppression du formulaire.",
  "intake.builder.discardDialogTitle": "Abandonner les modifications non enregistrées ?",
  "intake.builder.discardDialogDescription":
    "Vous avez des modifications non enregistrées. Quitter maintenant les supprimera.",
  "intake.builder.discardDialogConfirm": "Abandonner les modifications",
  "intake.builder.discardDialogCancel": "Continuer l'édition",
  "intake.builder.pages": "Pages",
  "intake.builder.addPage": "Ajouter une page",
  "intake.builder.removePage": "Supprimer la page",
  "intake.builder.pageName": "Nom de page",
  "intake.builder.localeTab.label": "Langue d'édition",
  "intake.builder.localeTab.en": "English",
  "intake.builder.localeTab.fr": "Français",
  "intake.builder.pageInternal": "Page interne (masquée aux demandeurs)",
  "intake.builder.elements": "Éléments",
  "intake.builder.addElement": "Ajouter un élément",
  "intake.builder.addRadio": "Boutons radio",
  "intake.builder.addNumber": "Nombre",
  "intake.builder.removeElement": "Supprimer l'élément",
  // Intake builder: field preview placeholders, info text and the URL input (NG-2580)
  "intake.builder.fieldPreview.addOptions": "Ajoutez des options dans l'onglet Données",
  "intake.builder.fieldPreview.dropFiles": "Glissez-déposez des fichiers ici",
  "intake.builder.fieldPreview.calculated": "Calculé · {name}",
  "intake.builder.infoTextPlaceholder": "Texte informatif",
  "intake.builder.urlSchemeAria": "Schéma d'URL",
  "intake.builder.elementName": "Nom du champ",
  "intake.builder.elementLabel": "Libellé",
  "intake.builder.tooltip": "Info-bulle",
  "intake.builder.fieldDescription": "Description",
  "intake.builder.placeholder": "Texte indicatif",
  "intake.builder.showCharCounter": "Afficher le compteur de caractères",
  "intake.builder.prefix": "Préfixe",
  "intake.builder.suffix": "Suffixe",
  "intake.builder.inlineLayout": "Disposition en ligne",
  "intake.builder.inputMask": "Masque de saisie",
  "intake.builder.dateFormat": "Format",
  "intake.builder.defaultValue": "Valeur par défaut",
  "intake.builder.defaultChecked": "Coché par défaut",
  "intake.builder.thousandsSeparator": "Utiliser le séparateur des milliers",
  "intake.builder.decimalPlaces": "Nombre de décimales",
  "intake.builder.requireDecimal": "Exiger une décimale",
  "intake.builder.enableTime": "Inclure le sélecteur d'heure",
  "intake.builder.enableDate": "Activer la saisie de date",
  "intake.builder.disableWeekends": "Désactiver les week-ends",
  "intake.builder.disableWeekdays": "Désactiver les jours de semaine",
  "intake.builder.twelveHour": "Format 12 h (AM/PM)",
  "intake.builder.currencyCode": "Code de devise",
  "intake.builder.allowMultipleUrls": "Autoriser plusieurs URL",
  "intake.builder.multiselect": "Autoriser plusieurs sélections",
  "intake.builder.defaultValues": "Valeurs par défaut",
  "intake.builder.defaultValuesPlaceholder": "Sélectionner les options par défaut",
  "intake.builder.defaultValuesSearch": "Rechercher des options",
  "intake.builder.defaultValuesEmpty": "Aucune option trouvée",
  "intake.builder.defaultValuePlaceholder": "Sélectionner une option par défaut",
  "intake.builder.defaultValueNone": "Aucune valeur par défaut",
  "intake.builder.minLength": "Longueur min.",
  "intake.builder.maxLength": "Longueur max.",
  "intake.builder.minValue": "Valeur min.",
  "intake.builder.maxValue": "Valeur max.",
  "intake.builder.minChecked": "Min. cochés",
  "intake.builder.maxChecked": "Max. cochés",
  "intake.builder.required": "Requis",
  "intake.builder.internal": "Interne",
  "intake.builder.replaceCurrentOwner": "Remplacer le responsable actuel",
  "intake.builder.replaceCurrentOwnerTooltip":
    "Activé : remplace tous les responsables existants par l'utilisateur sélectionné. Désactivé : l'ajoute comme responsable supplémentaire.",
  "intake.builder.options": "Options",
  "intake.builder.addOption": "Ajouter une option",
  "intake.builder.removeOption": "Supprimer l'option",
  "intake.builder.optionLabelEn": "Libellé (EN)",
  "intake.builder.optionLabelFr": "Libellé (FR)",
  "intake.builder.optionLabelsShowBoth": "Afficher les deux langues",
  "intake.builder.visibleIfTitle": "Visibilité",
  "intake.builder.visibleIfField": "Quand le champ",
  "intake.builder.visibleIfValue": "Égale",
  "intake.builder.visibleIfClear": "Effacer la condition",
  "intake.builder.visibleIfAdd": "Afficher quand…",
  "intake.builder.visibleIfStale": "Le champ « {field} » n'est plus défini.",
  "intake.builder.booleanTrue": "Vrai",
  "intake.builder.booleanFalse": "Faux",
  "intake.builder.optionPlaceholder": "Sélectionner une option…",
  "intake.builder.visibleIfNone": "Toujours visible",
  "intake.builder.systemFieldNotice":
    "Champ système — vous pouvez renommer son libellé ; le champ lui-même ne peut pas être supprimé.",
  "intake.builder.requestTitleNotice":
    "Titre de la demande — toujours obligatoire et sur la première page. Vous pouvez modifier son libellé, son espace réservé et son texte d'aide, mais il ne peut pas être supprimé, rendu interne ou affiché sous condition.",
  "intake.builder.kindLabel": "Type",
  "intake.builder.dragHandle": "Glisser pour réorganiser",
  "intake.builder.invalidNamePattern":
    "Utilisez des lettres minuscules, chiffres et soulignements ; doit commencer par une lettre.",
  "intake.builder.paletteTitle": "Composants",
  "intake.builder.paletteGroupRecommended": "Recommandé",
  "intake.builder.paletteRecommendedHint":
    "Les champs globaux restent synchronisés dans tout l'espace de travail et sont repris dans le projet.",
  "intake.builder.paletteGroupFormOnly": "Composants propres au formulaire",
  "intake.builder.paletteHint":
    "Glissez un composant dans une page. Ils restent sur ce formulaire.",
  "intake.builder.paletteGroupBasic": "Base",
  "intake.builder.paletteGroupChoice": "Choix",
  "intake.builder.paletteGroupAdvanced": "Avancé",
  "intake.builder.addGlobalField": "Ajouter un champ global",
  "intake.builder.addGlobalFieldTo": "Ajouter un champ global à {destination}",
  "intake.builder.globalFieldModal.type_program": "Programme",
  "intake.builder.globalFieldModal.type_goal": "Objectif",
  "intake.builder.globalFieldModal.type_request_category": "Catégorie de demande",
  "intake.builder.globalFieldModal.type_date": "Date",
  "intake.builder.palette.empty_no_fields":
    "Aucun champ personnalisé global pour le moment. Demandez à un administrateur d'en créer un dans la",
  "intake.builder.palette.empty_no_fields_link": "bibliothèque de champs personnalisés",
  "intake.builder.bank_linked_banner": "Lié au champ de banque « {name} ».",
  "intake.builder.bank_linked_manage": "Gérer dans les paramètres →",
  "intake.builder.bank_linked_options_note":
    "Les options sont gérées dans les paramètres de l'espace de travail.",
  "intake.builder.global_marker_label": "Global",
  "intake.builder.global_marker_tooltip": "Géré dans les champs personnalisés globaux",
  "intake.builder.system_marker_label": "Système",
  "intake.builder.system_marker_tooltip": "Champ système — sa valeur est gérée par Cognota",
  "intake.builder.conditional_marker_label": "Afficher quand",
  "intake.builder.internal_marker_tooltip": "Interne — masqué pour les demandeurs",
  "intake.builder.conditional_marker_tooltip":
    "Conditionnel — affiché uniquement si sa règle est remplie",
  "intake.builder.hide_option_from_requesters": "Masquer aux demandeurs",
  "intake.builder.show_option_to_requesters": "Afficher aux demandeurs",
  "intake.builder.duplicate_action_label": "Dupliquer en champ propre au formulaire",
  "intake.builder.duplicate_confirm_title": "Dupliquer en champ propre au formulaire?",
  "intake.builder.duplicate_confirm_body":
    "Ceci crée une copie propre au formulaire qui ne sera plus synchronisée avec la bibliothèque globale. Les modifications futures du champ global n'affecteront pas cette copie.",
  "intake.builder.duplicate_confirm_cta": "Dupliquer",
  "intake.builder.copy_suffix": "(Copie)",
  "intake.builder.addText": "Ligne unique",
  "intake.builder.addTextarea": "Paragraphe",
  "intake.builder.addCheckbox": "Vrai / Faux",
  "intake.builder.addCheckboxes": "Cases à cocher",
  "intake.builder.addSelect": "Liste déroulante",
  "intake.builder.addEmail": "Courriel",
  "intake.builder.addUrl": "URL",
  "intake.builder.addPhone": "Téléphone",
  "intake.builder.addDatetime": "Date / Heure",
  "intake.builder.addCurrency": "Devise",
  "intake.builder.addFile": "Téléversement de fichier",
  "intake.builder.dropZoneEmpty": "Glissez-déposez un composant de formulaire",
  "intake.builder.dropZoneActive": "Relâchez pour ajouter",
  "intake.builder.dropZoneTail": "Déposez ici pour ajouter à la fin",
  "intake.builder.matchAll": "Toutes les conditions",
  "intake.builder.matchAny": "Au moins une condition",
  "intake.builder.removeClause": "Supprimer la condition",
  "intake.builder.addClause": "Ajouter une condition",
  "intake.builder.opEq": "égale",
  "intake.builder.opNeq": "n'égale pas",
  "intake.builder.opGt": "est supérieur à",
  "intake.builder.opGte": "est au moins",
  "intake.builder.opLt": "est inférieur à",
  "intake.builder.opLte": "est au plus",
  "intake.builder.opContains": "contient",
  "intake.builder.opIsEmpty": "est vide",
  "intake.builder.opIsNotEmpty": "n'est pas vide",
  "intake.builder.addExpression": "Calcul",
  "intake.builder.addInfoText": "Texte informatif",
  "intake.builder.addRichText": "Texte enrichi",
  "intake.builder.addDivider": "Séparateur",
  "intake.builder.addFieldGroup": "Groupe",
  "intake.builder.addColumns": "Colonnes",
  "intake.builder.addProgram": "Programme",
  "intake.builder.addGoal": "Objectif",
  "intake.builder.addRequestCategory": "Catégorie de demande",
  "intake.builder.addTargetLaunchDate": "Date de lancement cible",
  "intake.builder.addRequestOwner": "Responsable de la demande",
  "intake.builder.addUserList": "Liste d'utilisateurs",
  "intake.builder.paletteGroupLayout": "Mise en page",
  "intake.builder.container.untitled": "Groupe sans titre",
  "intake.builder.container.expand": "Déplier le groupe",
  "intake.builder.container.collapse": "Replier le groupe",
  "intake.builder.container.columnsTitle": "Colonnes ({count})",
  "intake.builder.container.dropHere": "Déposez ici",
  "intake.builder.container.dropHereColumn": "Déposez ici",
  "intake.builder.container.dropTail": "Déposez ici pour ajouter à la fin",
  "intake.builder.container.columnLabel": "colonne {index}",
  "intake.builder.pane.container.group.title": "Groupe",
  "intake.builder.pane.container.group.collapsed": "Replié par défaut",
  "intake.builder.pane.container.group.internal": "Groupe interne (masqué aux demandeurs)",
  "intake.builder.pane.container.columns.title": "Colonnes",
  "intake.builder.pane.container.columns.count": "Nombre de colonnes",
  "intake.builder.pane.container.columns.hint":
    "Réduire le nombre fusionne les colonnes restantes dans la colonne précédente.",
  "intake.builder.pane.container.info.title": "Texte informatif",
  "intake.builder.pane.container.info.content": "Contenu",
  "intake.builder.pane.container.richText.title": "Texte enrichi",
  "intake.builder.pane.container.richText.content": "Contenu",
  "intake.builder.richText.bold": "Gras",
  "intake.builder.richText.italic": "Italique",
  "intake.builder.richText.bulletList": "Liste à puces",
  "intake.builder.richText.orderedList": "Liste numérotée",
  "intake.builder.richText.link": "Lien",
  "intake.builder.richText.linkTextLabel": "Texte à afficher",
  "intake.builder.richText.linkUrlLabel": "URL du lien",
  "intake.builder.richText.linkUrlPlaceholder": "https://exemple.com",
  "intake.builder.richText.linkApply": "Appliquer",
  "intake.builder.richText.linkRemove": "Supprimer",
  "intake.builder.richText.addImage": "Ajouter une image",
  "intake.builder.richText.addImageFailed": "Impossible d'ajouter l'image. Réessayez.",
  "intake.file_upload_failed": "Impossible de téléverser le fichier. Réessayez.",
  "intake.builder.richText.embedMedia": "Intégrer un média",
  "intake.builder.richText.embedUrlLabel": "URL de la vidéo",
  "intake.builder.richText.embedUrlPlaceholder": "https://youtube.com/watch?v=...",
  "intake.builder.richText.embedUrlHint":
    "YouTube, Vimeo, Loom, Wistia, Microsoft Stream ou Google Drive.",
  "intake.builder.richText.embedUrlError":
    "Saisissez une URL de vidéo valide d'un fournisseur pris en charge.",
  "intake.builder.richText.embedApply": "Intégrer",
  "intake.builder.pane.container.divider.title": "Séparateur",
  "intake.builder.pane.container.divider.hint": "Le séparateur n'a aucune propriété modifiable.",
  "intake.builder.expressionTitle": "Expression",
  "intake.builder.expressionHelp":
    "Calcule une valeur à partir des autres champs numériques du formulaire. Choisissez un agrégat (somme, min, max, moyenne) et les champs à combiner, ou construisez une formule avec des opérations mathématiques.",
  "intake.builder.expressionHelpAria": "À propos des champs calculés",
  "intake.builder.exprNodeLiteral": "Nombre",
  "intake.builder.exprNodeRef": "Champ",
  "intake.builder.exprNodeBinary": "Opération",
  "intake.builder.exprNodeAggregate": "Agrégat",
  "intake.builder.exprBinaryAdd": "+",
  "intake.builder.exprBinarySub": "−",
  "intake.builder.exprBinaryMul": "×",
  "intake.builder.exprBinaryDiv": "÷",
  "intake.builder.exprBinaryLeft": "Gauche",
  "intake.builder.exprBinaryRight": "Droite",
  "intake.builder.exprAggSum": "Somme",
  "intake.builder.exprAggMin": "Min",
  "intake.builder.exprAggMax": "Max",
  "intake.builder.exprAggAvg": "Moyenne",
  "intake.builder.exprAddArg": "Ajouter un opérande",
  "intake.builder.exprNoNumericFields": "Définissez d'abord un champ Nombre",
  "intake.builder.formsTitle": "Formulaires",
  "intake.builder.formsCreate": "Nouveau formulaire",
  "intake.builder.formsEmpty": "Aucun formulaire pour l'instant.",
  "intake.builder.formsCreatePlaceholder": "Formulaire sans titre",
  "intake.builder.formsCreateError": "Échec de la création du formulaire.",
  "intake.builder.pane.empty.title": "Aucun champ sélectionné",
  "intake.builder.pane.empty.description":
    "Cliquez sur un champ du canevas pour modifier ses propriétés.",
  "intake.builder.pane.pageSettings.title": "Paramètres de page",
  // #3311 : le panneau de paramètres de page regroupe ses contrôles sous deux
  // titres de section — Aperçu (nom de page + statut) et Accès (interne + qui
  // remplit + notification) — pour correspondre à la maquette Workflow Polish 2.
  "intake.builder.pane.pageSettings.overview": "Aperçu",
  "intake.builder.pane.pageSettings.access": "Accès",
  "intake.builder.pane.systemField.title": "Champ système",
  "intake.builder.pane.fieldProperties.title": "Propriétés du champ",
  "intake.builder.pane.tab.display": "Affichage",
  "intake.builder.pane.tab.data": "Données",
  "intake.builder.pane.section.date": "Date",
  "intake.builder.pane.section.time": "Heure",
  "intake.builder.pane.tab.validation": "Validation",
  "intake.builder.pane.tab.conditional": "Conditionnel",
  "intake.builder.pane.data.empty":
    "Aucune propriété de données pour l'instant — texte indicatif, valeur par défaut et options similaires arriveront dans une prochaine version.",
  "intake.builder.pane.validation.empty":
    "D'autres options de validation arriveront dans une prochaine version. La case Requis se trouve dans l'en-tête ci-dessus.",
  "intake.builder.row.duplicate": "Dupliquer le champ",
  "intake.builder.row.requiredAria": "Basculer requis",
  "intake.builder.row.moreActions": "Plus d'actions",
  "intake.builder.moveToPage": "Déplacer vers la page…",
  "intake.builder.duplicateToPage": "Dupliquer vers la page…",
  "intake.builder.movedToPageToast": "Déplacé vers {page}",
  "intake.builder.duplicatedToPageToast": "Dupliqué vers {page}",
  "intake.builder.moveToPageError": "Impossible de déplacer le champ. Veuillez réessayer.",
  "intake.builder.moveToPageOrderError":
    "Impossible de déplacer le champ ici — un champ doit précéder tout champ dont la visibilité en dépend.",
  "intake.builder.duplicateToPageError": "Impossible de dupliquer le champ. Veuillez réessayer.",
  "intake.builder.targetPage": "Page cible",

  "intake.builder.pageFallback": "Page {index}",
  "intake.builder.kindLabel.text": "Ligne unique",
  "intake.builder.kindLabel.textarea": "Paragraphe",
  "intake.builder.kindLabel.number": "Nombre",
  "intake.builder.kindLabel.checkbox": "Vrai / Faux",
  "intake.builder.kindLabel.checkboxes": "Cases à cocher",
  "intake.builder.kindLabel.program": "Programme",
  "intake.builder.kindLabel.goal": "Objectif",
  "intake.builder.kindLabel.request_category": "Catégorie de demande",
  "intake.builder.kindLabel.select": "Liste déroulante",
  "intake.builder.kindLabel.radio": "Boutons radio",
  "intake.builder.kindLabel.email": "Courriel",
  "intake.builder.kindLabel.url": "URL",
  "intake.builder.kindLabel.phone": "Téléphone",
  "intake.builder.kindLabel.datetime": "Date / Heure",
  "intake.builder.kindLabel.currency": "Devise",
  "intake.builder.kindLabel.user_list": "Liste d'utilisateurs",
  "intake.builder.kindLabel.file": "Téléversement de fichier",
  "intake.builder.kindLabel.expression": "Calcul",

  "intake.formCrumbs.new": "Nouveau formulaire",
  "intake.formCrumbs.untitled": "Formulaire sans titre",

  "intake.formsList.title": "Formulaires d'intake",
  "intake.formsList.description":
    "Gérer les formulaires d'intake disponibles dans cet espace de travail.",
  "intake.formsList.newForm": "Créer un formulaire",
  "intake.formsList.colName": "Nom",
  "intake.formsList.colHomeTeams": "Équipes principales",
  "intake.formsList.colSubmittingTeams": "Équipes soumettrices",
  "intake.formsList.colUpdatedAt": "Dernière mise à jour",
  "intake.formsList.managingTeamWorkspace": "Espace de travail",
  "intake.formsList.colActive": "Actif",
  "intake.formsList.colActions": "Actions",
  "intake.formsList.viewOnlyBadge": "Lecture seule",
  "intake.formsList.deleteAction": "Supprimer le formulaire",
  "intake.formsList.duplicateAction": "Dupliquer le formulaire",
  "intake.formsList.duplicateSuccess": "« {name} » dupliqué.",
  "intake.formsList.duplicateError": "Impossible de dupliquer le formulaire.",
  "intake.formsList.toggleError": "Impossible de mettre à jour le statut du formulaire.",
  "intake.formsList.activatedToast": "Formulaire activé.",
  "intake.formsList.deactivatedToast": "Formulaire désactivé.",
  "intake.formsList.deleteTitle": "Supprimer le formulaire",
  "intake.formsList.deleteConfirm":
    "Supprimer « {name} » ? Cela supprime définitivement le formulaire et ses soumissions.",
  "intake.formsList.delete": "Supprimer",
  "intake.formsList.deleting": "Suppression…",
  "intake.formsList.cancel": "Annuler",
  "intake.formsList.deleteSuccess": "Formulaire supprimé.",
  "intake.formsList.deleteError": "Échec de la suppression du formulaire.",
  "intake.formsList.emptyTitle": "Aucun formulaire pour l'instant",
  "intake.formsList.emptyDescription": "Créez votre premier formulaire d'intake pour commencer.",
  "intake.formsList.searchPlaceholder": "Rechercher un formulaire…",
  "intake.formsList.selectAll": "Sélectionner tous les formulaires",
  "intake.formsList.selectOne": "Sélectionner {name}",
  "intake.formsList.noMatches": "Aucun formulaire ne correspond à cette recherche.",
  "intake.formsList.rangeSummary": "Affichage de {from} à {to} sur {total}",
  "intake.formsList.paginationPrev": "Page précédente",
  "intake.formsList.paginationNext": "Page suivante",

  // Libellés destinés aux administrateurs pour la page de liste des paramètres
  // (le générateur de flux d'admission est réservé aux administrateurs).
  // Parallèles à intake.formsList.* — sélectionnés au point de rendu pour qu'un
  // non-administrateur conserve le nommage « Forms ».
  "intake.intakeWorkflowsList.title": "Flux d'admission",
  "intake.intakeWorkflowsList.description":
    "Gérer les flux d'admission disponibles dans cet espace de travail.",
  "intake.intakeWorkflowsList.newForm": "Créer un flux d'admission",
  "intake.intakeWorkflowsList.deleteAction": "Supprimer le flux d'admission",
  "intake.intakeWorkflowsList.duplicateAction": "Dupliquer le flux d'admission",
  "intake.intakeWorkflowsList.duplicateSuccess": "« {name} » dupliqué.",
  "intake.intakeWorkflowsList.duplicateError": "Impossible de dupliquer le flux d'admission.",
  "intake.intakeWorkflowsList.toggleError":
    "Impossible de mettre à jour le statut du flux d'admission.",
  "intake.intakeWorkflowsList.activatedToast": "Flux d'admission activé.",
  "intake.intakeWorkflowsList.deactivatedToast": "Flux d'admission désactivé.",
  "intake.intakeWorkflowsList.deleteTitle": "Supprimer le flux d'admission",
  "intake.intakeWorkflowsList.deleteConfirm":
    "Supprimer « {name} » ? Cela supprime définitivement le flux d'admission et ses soumissions.",
  "intake.intakeWorkflowsList.deleteSuccess": "Flux d'admission supprimé.",
  "intake.intakeWorkflowsList.deleteError": "Échec de la suppression du flux d'admission.",
  "intake.intakeWorkflowsList.emptyTitle": "Aucun flux d'admission pour l'instant",
  "intake.intakeWorkflowsList.emptyDescription":
    "Créez votre premier flux d'admission pour commencer.",
  "intake.intakeWorkflowsList.searchPlaceholder": "Rechercher un flux d'admission…",
  "intake.intakeWorkflowsList.selectAll": "Sélectionner tous les flux d'admission",
  "intake.intakeWorkflowsList.noMatches": "Aucun flux d'admission ne correspond à cette recherche.",

  "intake.reactivation.blocked_title": "Impossible d'activer ce formulaire",
  "intake.reactivation.blocked_body":
    "L'activation est bloquée car le formulaire référence des champs personnalisés globaux archivés, ou contient des règles de visibilité qui ne se résolvent plus. Ouvrez le formulaire pour corriger chaque problème listé ci-dessous, puis réessayez d'activer.",
  "intake.reactivation.issue.archived_global_field":
    "{element} est lié à un champ global qui a été archivé.",
  "intake.reactivation.issue.archived_global_field_dep":
    "{element} a une règle de visibilité dépendant de « {reference} », dont le champ global a été archivé.",
  "intake.reactivation.issue.missing_dep":
    "{element} a une règle de visibilité référençant « {reference} », qui n'existe plus dans ce formulaire.",
  "intake.reactivation.open_form_cta": "Ouvrir le formulaire pour corriger",
  "intake.reactivation.close_cta": "Fermer",

  "intake.convert.title": "Convertir la demande en projet",
  "intake.convert.loading": "Chargement du plan de report…",
  "intake.convert.template_label": "Modèle de projet",
  "intake.convert.template_placeholder": "Choisir un modèle pour commencer",
  "intake.convert.template_hint":
    "Ce choix détermine quelles réponses de la demande sont reportées.",
  "intake.convert.shared_heading": "Reportés automatiquement",
  "intake.convert.shared_empty":
    "Aucun champ du modèle ne correspond aux réponses — choisissez ci-dessous ce qui doit être reporté.",
  "intake.convert.programs_heading": "Programmes",
  "intake.convert.goals_heading": "Objectifs",
  "intake.convert.programs_hint":
    "Les programmes liés à la demande sont pré-remplis. Ajoutez ou retirez-en avant de créer le projet.",
  "intake.convert.goals_hint":
    "Les objectifs liés à la demande sont pré-remplis. Ajoutez-en ou retirez-en avant de créer le projet.",
  "intake.convert.extras_heading": "Champs supplémentaires",
  "intake.convert.extras_hint":
    "Ces champs ont été renseignés mais ne sont pas dans le modèle. Cochez ceux à ajouter au nouveau projet.",
  "intake.convert.extras_empty": "Aucun champ supplémentaire à reporter.",
  "intake.convert.template_only_heading": "Champs du modèle",
  "intake.convert.template_only_hint":
    "Ajoutez des valeurs pour les champs du modèle de projet qui n'étaient pas sur la demande.",
  "intake.convert.archived_heading":
    "Impossible à reporter — archivés dans votre bibliothèque globale",
  "intake.convert.archived_field": "{field} est archivé et ne sera pas reporté.",
  "intake.convert.archived_option": "{field} : l'option « {option} » est archivée et sera ignorée.",
  "intake.convert.value_empty": "Pas de réponse",
  "intake.convert.confirm_cta": "Créer",
  "intake.convert.confirm_open_cta": "Créer et ouvrir",
  "intake.convert.cancel_cta": "Annuler",
  "intake.convert.process_from_template": "Utiliser le processus du modèle",
  "intake.convert.created": "Projet créé.",
  "intake.convert.error": "Impossible de charger le plan de report. Réessayez.",
  "intake.convert.project_details_heading": "Détails du projet",
  "intake.convert.project_details_hint":
    "Remplacez les valeurs par défaut du modèle pour le nouveau projet. Laissez un champ vide pour conserver la valeur du modèle.",
  "intake.convert.project_name_label": "Nom du projet",
  "intake.convert.project_description_label": "Description",
  "intake.convert.project_lead_label": "Responsable du projet",
  "intake.convert.project_start_date_label": "Date de début",
  "intake.convert.project_end_date_label": "Date d'achèvement cible",
  "intake.convert.subtitle":
    "Les détails du projet ont été pré-remplis à partir de la demande. Vérifiez et modifiez avant de créer.",

  // File d'attente « en attente de mon approbation » du moteur de flux de
  // travail de formulaire (épopée #2166, ticket #2176).
  "intake.reviewerQueue.title": "Mes révisions",
  "intake.reviewerQueue.countNoun": "en attente de votre révision",
  "intake.reviewerQueue.awaitingYourReview": "En attente de votre révision",
  "intake.reviewerQueue.submittedBy": "Soumis par {name}",
  "intake.reviewerQueue.emptyTitle": "Vous êtes à jour",
  "intake.reviewerQueue.emptyDescription": "Aucune demande n'attend votre révision pour le moment.",
  "intake.reviewerQueue.errorTitle": "Impossible de charger vos révisions",
  "intake.reviewerQueue.retry": "Réessayer",

  // Form Workflow runtime reviewing & decision surface (issue #2255; BE #2254).
  "intake.reviewDecision.submittedBy": "Soumis par {name}",
  "intake.pendingPage.title": "Étape suivante",
  "intake.pendingPage.prompt": "Cette demande attend une page que vous pouvez remplir.",
  "intake.pendingPage.promptNamed": "Cette demande attend « {page} ».",
  "intake.pendingPage.submit": "Soumettre la page",
  "intake.pendingPage.submitting": "Soumission en cours…",
  "intake.pendingPage.submitError": "Impossible de soumettre cette page. Veuillez réessayer.",
  "intake.pendingPage.complete": "Terminer cette étape",
  "intake.pendingPage.completing": "Finalisation en cours…",
  "intake.pendingPage.completeBlocked":
    "Renseignez ces champs obligatoires avant de terminer cette étape :",
  "intake.pendingPage.completeError": "Impossible de terminer cette étape. Veuillez réessayer.",
  "intake.pendingPage.completeNeedsSubmit":
    "Cette page comporte des champs obligatoires. Remplissez-les, puis utilisez « Soumettre la page ».",
  "intake.reviewInline.title": "Nouvelle révision",
  "intake.reviewInline.defaultPrompt":
    "Veuillez examiner cette demande et déterminer si elle doit être ajoutée au backlog du projet.",
  "intake.reviewInline.selectDecision": "Sélectionner une décision",
  "intake.reviewInline.submit": "Soumettre",
  "intake.reviewDecision.instructionsLabel": "Directives du réviseur",
  "intake.reviewDecision.decidePrompt": "Choisissez une issue",
  "intake.reviewDecision.declineIntro":
    "Vous allez {option} cette demande. Indiquez au demandeur pourquoi — il le verra.",
  "intake.reviewDecision.declineReasonLabel": "Motif",
  "intake.reviewDecision.declineReasonPlaceholder": "Choisissez un motif",
  "intake.reviewDecision.declineReasonsUnavailable":
    "Aucun motif de refus n'est encore configuré pour cet espace de travail. Un administrateur peut les ajouter dans les paramètres.",
  "intake.reviewDecision.declineNoteLabel": "Note (facultatif)",
  "intake.reviewDecision.declineNotePlaceholder": "Ajoutez tout détail utile pour le demandeur",
  "intake.reviewDecision.declineNoteHelp":
    "Le motif regroupe ce refus pour les rapports ; la note l'explique avec vos propres mots.",
  "intake.reviewDecision.declineBack": "Retour",
  "intake.reviewDecision.declineConfirm": "{option} la demande",
  "intake.reviewDecision.reasonIntro.declined":
    "Vous allez {option} cette demande. Indiquez au demandeur pourquoi ; il le verra.",
  "intake.reviewDecision.reasonIntro.waitlisted":
    "Vous allez {option} cette demande. Choisissez au moins un motif de liste d'attente ; le demandeur le verra.",
  "intake.reviewDecision.reasonIntro.cancelled":
    "Vous allez {option} cette demande. Indiquez au demandeur pourquoi elle a été annulée ; il le verra.",
  "intake.reviewDecision.reasonBack": "Retour",
  "intake.reviewDecision.reasonConfirm.declined": "{option} la demande",
  "intake.reviewDecision.reasonConfirm.waitlisted": "{option} la demande",
  "intake.reviewDecision.reasonConfirm.cancelled": "{option} la demande",
  "intake.statusReason.declined.reasonLabel": "Motif",
  "intake.statusReason.declined.reasonPlaceholder": "Choisissez un motif",
  "intake.statusReason.declined.reasonsUnavailable":
    "Aucun motif de refus n'est encore configuré pour cet espace de travail. Un administrateur peut les ajouter dans les paramètres.",
  "intake.statusReason.declined.noteLabel": "Note (facultatif)",
  "intake.statusReason.declined.notePlaceholder": "Ajoutez tout détail utile pour le demandeur",
  "intake.statusReason.declined.noteHelp":
    "Le motif regroupe ce refus pour les rapports ; la note l'explique avec vos propres mots.",
  "intake.statusReason.waitlisted.reasonLabel": "Motifs",
  "intake.statusReason.waitlisted.reasonPlaceholder": "Choisissez des motifs",
  "intake.statusReason.waitlisted.selectedCount": "{count} sélectionnés",
  "intake.statusReason.waitlisted.reasonsUnavailable":
    "Aucun motif de liste d'attente n'est encore configuré pour cet espace de travail. Un administrateur peut les ajouter dans les paramètres.",
  "intake.statusReason.waitlisted.noteLabel": "Note (facultatif)",
  "intake.statusReason.waitlisted.notePlaceholder": "Ajoutez tout détail utile pour le demandeur",
  "intake.statusReason.waitlisted.noteHelp":
    "Les motifs regroupent cette mise en liste d'attente pour les rapports ; la note l'explique avec vos propres mots.",
  "intake.statusReason.cancelled.reasonLabel": "Motif",
  "intake.statusReason.cancelled.reasonPlaceholder": "Choisissez un motif",
  "intake.statusReason.cancelled.reasonsUnavailable":
    "Aucun motif d'annulation n'est encore configuré pour cet espace de travail. Un administrateur peut les ajouter dans les paramètres.",
  "intake.statusReason.cancelled.noteLabel": "Note (facultatif)",
  "intake.statusReason.cancelled.notePlaceholder": "Ajoutez tout détail utile pour le demandeur",
  "intake.statusReason.cancelled.noteHelp":
    "Le motif regroupe cette annulation pour les rapports ; la note l'explique avec vos propres mots.",
  "intake.reviewDecision.retry": "Réessayer",
  "intake.reviewDecision.loadError": "Impossible de charger cette révision. Veuillez réessayer.",
  "intake.reviewDecision.alreadyResolved":
    "Cette demande a déjà avancé — elle n'attend plus votre décision.",
  "intake.reviewDecision.cannotDecide":
    "Vous n'êtes pas un réviseur assigné à l'étape actuelle de cette demande.",
  "intake.reviewDecision.decisionSuccess": "Décision enregistrée.",
  "intake.reviewDecision.decisionError":
    "Impossible d'enregistrer votre décision. Veuillez réessayer.",
  "intake.reviewDecision.raceResolved": "Un autre réviseur a déjà traité cette demande.",

  "intake.submissionsList.title": "Demandes",
  "intake.submissionsList.selectAll": "Sélectionner toutes les lignes",
  "intake.submissionsList.countNoun": "demandes",
  "intake.submissionsList.createRequest": "Créer une demande",
  "intake.submissionsList.searchPlaceholder": "Rechercher des demandes…",
  "intake.submissionsList.layoutTabsAria": "Vues des demandes",
  "intake.submissionsList.showArchived": "Afficher les archivées",
  "intake.submissionsList.filter.label": "Filtrer",
  "intake.submissionsList.filter.anyPlaceholder": "Toutes",
  "intake.submissionsList.sort.label": "Trier",
  "intake.submissionsList.sort.default": "Par défaut",
  "intake.submissionsList.sort.created": "Création",
  "intake.submissionsList.sort.lastUpdated": "Dernière modification",
  "intake.submissionsList.sort.status": "Statut",
  "intake.submissionsList.sort.requestedBy": "Demandé par",
  "intake.submissionsList.sort.form": "Formulaire",
  "intake.submissionsList.sort.sla": "SLA",
  "intake.submissionsList.sort.priority": "Priorité",
  "intake.submissionsList.sort.requestCategory": "Catégorie de demande",
  "intake.submissionsList.groupBy.label": "Grouper par",
  "intake.submissionsList.groupBy.none": "Aucun",
  "intake.submissionsList.groupBy.status": "Statut",
  "intake.submissionsList.groupBy.form": "Formulaire",
  "intake.submissionsList.groupBy.category": "Catégorie de demande",
  "intake.submissionsList.groupBy.noneStatus": "Sans statut",
  "intake.submissionsList.groupBy.noneCategory": "Sans catégorie",
  "intake.submissionsList.colRequestName": "Nom de la demande",
  "intake.submissionsList.colStatus": "Statut",
  "intake.submissionsList.colRequestedBy": "Demandé par",
  "intake.submissionsList.colOwner": "Responsable",
  "intake.submissionsList.colLinkedProjects": "Projets liés",
  "intake.submissionsList.colPrograms": "Programmes",
  "intake.submissionsList.colHomeTeam": "Équipe principale",
  "intake.submissionsList.colFormUsed": "Formulaire utilisé",
  "intake.submissionsList.colRequestCategory": "Catégorie de demande",
  "intake.submissionsList.colCreated": "Créé le",
  "intake.submissionsList.colSubmitted": "Soumis le",
  "intake.submissionsList.colLastUpdated": "Dernière mise à jour",
  "intake.submissionsList.colSla": "SLA",
  "intake.submissionsList.slaStateWithin": "Dans les délais",
  "intake.submissionsList.slaStatePaused": "En pause",
  "intake.submissionsList.slaStateBreached": "Dépassé",
  "intake.submissionsList.slaStateMet": "Respecté",
  "intake.submissionsList.ownerUnassigned": "Non attribué",
  "intake.submissionsList.slaDaysLeft": "{count} j restants",
  "intake.submissionsList.slaDaysOverdue": "{count} j de retard",
  "intake.submissionsList.slaDueToday": "Échéance aujourd'hui",
  "intake.submissionsList.slaDueYesterday": "Échéance hier",
  "intake.submissionsList.slaDaysElapsed": "{count} j",
  "intake.submissionsList.colPriority": "Priorité",
  "intake.submissionsList.priorityTierUrgent": "Urgent",
  "intake.submissionsList.priorityTierHigh": "Élevée",
  "intake.submissionsList.priorityTierMedium": "Moyenne",
  "intake.submissionsList.priorityTierLow": "Faible",
  "intake.submissionsList.editPriorityAria": "Modifier la priorité",
  "intake.submissionsList.editStatusAria": "Modifier le statut",
  "intake.submissionsList.priorityPinnedAria": "Priorité définie manuellement",
  "intake.submissionsList.priorityLockedAria": "Priorité verrouillée",
  "intake.submissionsList.priorityLockedTooltip":
    "La priorité est verrouillée lorsque la demande est terminée ou annulée.",
  "intake.submissionsList.priorityRevertToAuto": "Rétablir l'automatique",
  "intake.submissionsList.priorityOverrideSuccess": "Priorité épinglée.",
  "intake.submissionsList.priorityRevertSuccess": "Priorité rétablie à l'automatique.",
  "intake.submissionsList.priorityOverrideError": "Échec de la mise à jour de la priorité.",
  "intake.submissionsList.colForm": "Formulaire",
  "intake.submissionsList.colSubmitter": "Auteur",
  "intake.submissionsList.colSubmittedAt": "Soumis le",
  "intake.submissionsList.filterFormPlaceholder": "Filtrer par formulaire",
  "intake.submissionsList.filterFormAll": "Tous les formulaires",
  "intake.submissionsList.colState": "Statut",
  "intake.submissionsList.stateNone": "Aucun statut",
  "intake.submissionsList.editNameAria": "Modifier le nom de la demande",
  "intake.submissionsList.rename": "Renommer",
  "intake.submissionsList.editOwnerAria": "Modifier les responsables de la demande",
  "intake.submissionsList.editOwnerSearch": "Rechercher des personnes…",
  "intake.submissionsList.editNoMembers": "Aucun membre",
  "intake.submissionsList.loadingStates": "Chargement des options…",
  "intake.submissionsList.statesLoadError": "Impossible de charger les options",
  "intake.submissionsList.statesLoadRetry": "Réessayer",
  "intake.submissionsList.loadingMore": "Chargement d'autres demandes…",
  "intake.submissionsList.statusUpdateSuccess": "Statut de la demande mis à jour.",
  "intake.submissionsList.statusUpdateError": "Échec de la mise à jour du statut de la demande.",
  "intake.submissionsList.declineStatusTitle": "Refuser la demande",
  "intake.submissionsList.declineStatusDescription":
    "Choisissez un motif avant de déplacer cette demande vers {status}.",
  "intake.submissionsList.declineStatusConfirm": "Refuser la demande",
  "intake.submissionsList.statusReasonTitle.declined": "Refuser la demande",
  "intake.submissionsList.statusReasonTitle.waitlisted": "Mettre en liste d'attente",
  "intake.submissionsList.statusReasonTitle.cancelled": "Annuler la demande",
  "intake.submissionsList.statusReasonDescription.declined":
    "Choisissez un motif avant de déplacer cette demande vers {status}.",
  "intake.submissionsList.statusReasonDescription.waitlisted":
    "Choisissez au moins un motif avant de déplacer cette demande vers {status}.",
  "intake.submissionsList.statusReasonDescription.cancelled":
    "Choisissez un motif avant de déplacer cette demande vers {status}.",
  "intake.submissionsList.statusReasonConfirm.declined": "Refuser la demande",
  "intake.submissionsList.statusReasonConfirm.waitlisted": "Mettre en liste d'attente",
  "intake.submissionsList.statusReasonConfirm.cancelled": "Annuler la demande",
  "intake.submissionsList.empty": "Aucune demande ne correspond à ces filtres.",
  "intake.submissionsList.emptyUnfiltered": "Vous n'avez encore aucune demande.",
  "intake.submissionsList.accessDeniedTitle": "Vous n'avez pas accès aux demandes",
  "intake.submissionsList.accessDeniedDescription":
    "Votre rôle ne permet pas de consulter les demandes. Demandez à un administrateur de l'espace de travail si vous en avez besoin.",
  "intake.submissionsList.actionsMenu": "Actions pour {name}",
  "intake.submissionsList.delete": "Supprimer",
  "intake.submissionsList.confirmDeleteTitle": "Supprimer la demande ?",
  "intake.submissionsList.confirmDeleteDescription":
    "« {name} » sera supprimée définitivement. Cette action est irréversible.",
  "intake.submissionsList.deleteSuccess": "Demande supprimée.",
  "intake.submissionsList.bulkDeleteTitle": "Supprimer {count} demandes ?",
  "intake.submissionsList.bulkDeleteDescription":
    "{count} demandes seront supprimées définitivement. Cette action est irréversible.",
  "intake.submissionsList.bulkDeleteSuccess": "{count} demandes supprimées.",
  "intake.submissionsList.layout.list": "Tableau",
  "intake.submissionsList.layout.board": "Tableau",

  // Intake — vue tableau
  "intake.board.loadFailed": "Impossible de charger les statuts des demandes",
  "intake.board.retry": "Réessayer",
  "intake.board.moveFailed": "Impossible de déplacer la demande",
  "intake.board.loadingMore": "Chargement…",
  "intake.board.statusReasonTitle.declined": "Refuser la demande",
  "intake.board.statusReasonTitle.waitlisted": "Mettre en liste d'attente",
  "intake.board.statusReasonTitle.cancelled": "Annuler la demande",
  "intake.board.statusReasonDescription.declined":
    "Choisissez un motif avant de déplacer cette carte vers {status}.",
  "intake.board.statusReasonDescription.waitlisted":
    "Choisissez au moins un motif avant de déplacer cette carte vers {status}.",
  "intake.board.statusReasonDescription.cancelled":
    "Choisissez un motif avant de déplacer cette carte vers {status}.",
  "intake.board.statusReasonConfirm.declined": "Déplacer vers Refusée",
  "intake.board.statusReasonConfirm.waitlisted": "Déplacer vers Liste d'attente",
  "intake.board.statusReasonConfirm.cancelled": "Déplacer vers Annulée",

  // Intake — éditeur de workflow
  "intake.workflow.tab": "Workflow",
  "intake.workflow.builder.stepNavLabel": "Étapes du flux",
  "intake.workflow.builder.node.page": "Page",
  "intake.workflow.builder.node.review": "Révision",
  "intake.workflow.builder.node.branch": "Branche",
  "intake.workflow.builder.node.changeOwner": "Changer de responsable",
  "intake.workflow.builder.node.end": "Fin",
  "intake.workflow.builder.node.selectReviewers": "Sélectionner les réviseurs",
  "intake.workflow.builder.node.selectStatus": "Sélectionner le statut",
  // Placeholder in the Branch card body when no condition is authored yet (#2419).
  "intake.workflow.builder.node.setCondition": "Définir une condition",
  // One row of a Branch card's condition summary (NG-1056), derived from the
  // persisted conditions. Names the FIELD the branch turns on, not the operator
  // or the answer: the panel shows those in full, and the wire cannot even name
  // the answer for a Request Category / Program / Goal condition, which stores an
  // entity id. The first row is labelled; each later one carries the Branch's own
  // combinator. Whole-row templates, so a locale can reorder the parts.
  "intake.workflow.builder.node.branchClause.first": "Condition sur {field}",
  "intake.workflow.builder.node.branchClause.and": "et {field}",
  "intake.workflow.builder.node.branchClause.or": "ou {field}",
  // A condition whose source field cannot be named: a legacy bank-field condition
  // references no Page element, so the row still says a condition is set.
  "intake.workflow.builder.node.branchClause.unnamedField": "un champ",
  "intake.workflow.builder.node.setOwnerRouting": "Définir le responsable",
  "intake.workflow.builder.node.changeOwnerSummary.rules_one": "{count} règle",
  "intake.workflow.builder.node.changeOwnerSummary.rules_other": "{count} règles",
  "intake.workflow.builder.node.changeOwnerSummary.owners_one": "{count} responsable",
  "intake.workflow.builder.node.changeOwnerSummary.owners_other": "{count} responsables",
  "intake.workflow.builder.node.renameLabel": "Nom de l'étape",
  "intake.workflow.builder.node.rename": "Renommer {name}",
  "intake.workflow.builder.node.actions": "Actions de l'étape",
  "intake.workflow.builder.node.previewFromHere": "Aperçu à partir d'ici",
  "intake.workflow.builder.node.delete": "Supprimer l'étape",
  "intake.workflow.builder.node.dragHandle": "Glisser pour réordonner l'étape",
  "intake.workflow.builder.node.moveTo": "Déplacer vers",
  "intake.workflow.builder.node.moveToMainPath": "Chemin principal",
  "intake.workflow.builder.node.newPage": "Nouvelle page",
  "intake.workflow.builder.node.newReview": "Nouvelle révision",
  "intake.workflow.builder.node.newBranch": "Nouvelle branche",
  "intake.workflow.builder.node.newChangeOwner": "Nouveau Changer de responsable",
  "intake.workflow.builder.node.newEnd": "Fin",
  // Removing a Review decision option whose path has steps (NG-2649): move them to
  // another option's path, or delete them with the option.
  "intake.workflow.builder.removeOption.title": "Retirer « {name} » ?",
  "intake.workflow.builder.removeOption.body":
    "Les demandes qui reçoivent cette décision suivent son parcours. Retirer l’option supprime les étapes de ce parcours.",
  "intake.workflow.builder.removeOption.intro":
    "Les demandes qui reçoivent cette décision suivent son parcours, qui compte {count, plural, one {# étape} other {# étapes}}. Vous pouvez {count, plural, one {déplacer cette étape} other {déplacer ces étapes}} vers un autre parcours avant de retirer l’option.",
  "intake.workflow.builder.removeOption.choiceLegend": "Que faire des étapes de ce parcours ?",
  "intake.workflow.builder.removeOption.moveTo": "Déplacer les étapes vers « {path} »",
  "intake.workflow.builder.removeOption.moveToHint":
    "{count, plural, one {# étape est déplacée} other {# étapes sont déplacées}} à la fin du parcours « {path} ». Les demandes qui reçoivent cette décision {count, plural, one {la suivent} other {les suivent}} ensuite.",
  "intake.workflow.builder.removeOption.deleteAll": "Les supprimer avec l’option",
  "intake.workflow.builder.removeOption.deleteAllHint":
    "{count, plural, one {L’étape de ce parcours est aussi supprimée.} other {Les # étapes de ce parcours sont aussi supprimées.}}",
  "intake.workflow.builder.removeOption.choosePrompt":
    "Choisissez une option ci-dessus pour voir où va chaque étape.",
  "intake.workflow.builder.removeOption.stayingAfter": "Reste (après « {path} »)",
  "intake.workflow.builder.removeOption.thisOption": "La décision « {name} »",
  "intake.workflow.builder.removeOption.confirmMove":
    "Retirer l’option, déplacer {count, plural, one {# étape} other {# étapes}}",
  "intake.workflow.builder.removeOption.confirm":
    "Retirer l’option et {count, plural, one {# étape} other {# étapes}}",
  // Deleting a step (NG-2511): keep one Review/Branch path, or confirm a linear step.
  "intake.workflow.builder.deleteStep.title": "Supprimer « {name} » ?",
  "intake.workflow.builder.deleteStep.body.page":
    "Cela supprime la page et tout son contenu. Les étapes avant et après restent et se rejoignent.",
  "intake.workflow.builder.deleteStep.body.changeOwner":
    "Cela supprime l’étape et ses paramètres de responsable. Les étapes avant et après restent et se rejoignent.",
  "intake.workflow.builder.deleteStep.body.empty":
    "Aucune étape ne la suit, donc rien d’autre n’est supprimé.",
  "intake.workflow.builder.deleteStep.intro.review":
    "Cette revue envoie chaque demande sur l’un de {count} chemins, selon la décision. Vous pouvez garder les étapes d’un chemin : elles prennent la place de la revue.",
  "intake.workflow.builder.deleteStep.intro.branch":
    "Cet embranchement vérifie une condition et envoie chaque demande sur l’un de {count} chemins. Vous pouvez garder les étapes d’un chemin : elles prennent la place de l’embranchement.",
  "intake.workflow.builder.deleteStep.choiceLegend": "Que doit-il arriver aux étapes qui suivent ?",
  "intake.workflow.builder.deleteStep.keepLane": "Garder les étapes après « {path} »",
  "intake.workflow.builder.deleteStep.keepLaneHint.review":
    "{count, plural, one {# étape remonte} other {# étapes remontent}} à la place de cette revue. Les demandes n’attendent plus d’approbation.",
  "intake.workflow.builder.deleteStep.keepLaneHint.branch":
    "{count, plural, one {# étape remonte} other {# étapes remontent}} à la place de cet embranchement. Chaque demande y passe, que la condition soit remplie ou non.",
  "intake.workflow.builder.deleteStep.deleteAll": "Tout supprimer après elle",
  "intake.workflow.builder.deleteStep.deleteAllHint":
    "{count, plural, one {L’étape qui suit est aussi supprimée.} other {Les # étapes qui suivent sont aussi supprimées.}}",
  "intake.workflow.builder.deleteStep.choosePrompt":
    "Choisissez une option ci-dessus pour voir ce qui reste et ce qui est supprimé.",
  "intake.workflow.builder.deleteStep.staying": "Reste",
  "intake.workflow.builder.deleteStep.removing": "Supprimé",
  "intake.workflow.builder.deleteStep.nothing": "Rien",
  "intake.workflow.builder.deleteStep.this.review": "{name} (cette revue)",
  "intake.workflow.builder.deleteStep.this.branch": "{name} (cet embranchement)",
  "intake.workflow.builder.deleteStep.dragTip":
    "Besoin d’étapes de plusieurs chemins ? Annulez, sortez-les du chemin en les faisant glisser (ou avec Déplacer vers), puis supprimez.",
  "intake.workflow.builder.deleteStep.discardHint":
    "Supprimé par erreur ? Annuler les modifications, dans le menu Plus d’actions du formulaire, rétablit votre dernier workflow publié, tant que vous ne publiez pas à nouveau.",
  "intake.workflow.builder.deleteStep.confirmKeep.review":
    "Supprimer la revue, garder {count, plural, one {# étape} other {# étapes}}",
  "intake.workflow.builder.deleteStep.confirmKeep.branch":
    "Supprimer l’embranchement, garder {count, plural, one {# étape} other {# étapes}}",
  "intake.workflow.builder.deleteStep.confirmAll":
    "Supprimer {count, plural, one {# étape} other {# étapes}}",
  "intake.workflow.builder.deleteStep.confirmPending": "Supprimer",
  "intake.workflow.builder.deleteStep.confirmPage": "Supprimer la page",
  "intake.workflow.builder.deleteStep.confirmStep": "Supprimer l’étape",
  "intake.workflow.builder.addPicker.pageDesc": "Saisir des informations",
  "intake.workflow.builder.addPicker.reviewDesc": "Exiger une approbation",
  "intake.workflow.builder.addPicker.branchDesc": "Division conditionnelle",
  "intake.workflow.builder.addPicker.changeOwnerDesc": "Acheminer vers un responsable",
  "intake.workflow.builder.changeOwner.newWorkflowOnly":
    "Changer de responsable fonctionne uniquement dans les nouveaux flux créés avec le nouveau générateur de formulaires.",
  "intake.workflow.builder.config.changeOwner.modeLabel": "Attribuer le responsable",
  "intake.workflow.builder.config.changeOwner.modeSearch": "Rechercher",
  "intake.workflow.builder.config.changeOwner.modeEmpty": "Aucune option",
  "intake.workflow.builder.config.changeOwner.modeStatic": "À des responsables précis",
  "intake.workflow.builder.config.changeOwner.modeFromField": "D'après la réponse à un champ",
  "intake.workflow.builder.config.changeOwner.sourceLabel": "Champ source",
  "intake.workflow.builder.config.changeOwner.sourceHint":
    "La réponse à ce champ détermine à qui la demande est attribuée.",
  "intake.workflow.builder.config.changeOwner.sourcePlaceholder": "Sélectionner un champ",
  "intake.workflow.builder.config.changeOwner.sourceSearch": "Rechercher des champs",
  "intake.workflow.builder.config.changeOwner.sourceEmpty": "Aucun champ sur les pages précédentes",
  "intake.workflow.builder.config.changeOwner.rulesLabel": "Règles d'acheminement",
  "intake.workflow.builder.config.changeOwner.rulesHint": "La première correspondance l'emporte",
  "intake.workflow.builder.config.changeOwner.rulesEmpty":
    "Choisissez un champ source pour définir les règles d'acheminement",
  "intake.workflow.builder.config.changeOwner.equalsLabel": "Égale",
  "intake.workflow.builder.config.changeOwner.containsLabel": "Contient",
  "intake.workflow.builder.config.changeOwner.assignLabel": "Attribuer à",
  "intake.workflow.builder.config.changeOwner.ownersLabel": "Responsables",
  "intake.workflow.builder.config.changeOwner.valueLabel": "Valeur de la réponse",
  "intake.workflow.builder.config.changeOwner.valuePlaceholder": "Valeur de la réponse",
  "intake.workflow.builder.config.changeOwner.addRule": "Ajouter une règle",
  "intake.workflow.builder.config.changeOwner.removeRule": "Supprimer la règle",
  "intake.workflow.builder.config.changeOwner.usersLabel": "Personnes",
  "intake.workflow.builder.config.changeOwner.usersPlaceholder": "Sélectionner des personnes",
  "intake.workflow.builder.config.changeOwner.usersSearch": "Rechercher des personnes",
  "intake.workflow.builder.config.changeOwner.usersEmpty": "Aucune personne trouvée",
  "intake.workflow.builder.config.changeOwner.replaceLabel": "Responsables actuels",
  "intake.workflow.builder.config.changeOwner.replaceHint":
    "Remplacer les responsables actuels au lieu de les compléter",
  "intake.workflow.builder.addPicker.endDesc": "Terminer le flux",
  "intake.workflow.builder.page.noTeam": "Aucune équipe assignée",
  "intake.workflow.builder.page.selectFormUsers": "Sélectionner les utilisateurs du formulaire",
  // Forme courte de ``config.page.firstPageAssigneeHelper`` (NG-1056) : la ligne
  // « qui remplit » de la première page énonce la règle au lieu de la demander,
  // et doit tenir dans une carte de 320 px.
  "intake.workflow.builder.page.firstPageFormUsers": "Défini par les équipes du workflow",
  // Une page interne 2+ sans personne désignée énonce la règle des remplisseurs
  // par défaut au lieu de demander « Sélectionner les utilisateurs du
  // formulaire » (NG-2617) : ``_default_page_fillers(..., internal=True)``
  // laisse les responsables de la demande, leurs chefs d'équipe et les
  // administrateurs la remplir — le demandeur reste exclu. Règle énoncée comme
  // ``firstPageFormUsers``, pas une invite : laisser la page sans désignation
  // est un choix valide. Forme courte pour tenir dans une carte de 320 px.
  "intake.workflow.builder.page.internalPageFormUsers":
    "Responsables de la demande, leurs chefs d'équipe et administrateurs",
  "intake.workflow.builder.page.assigneeRole.owner": "Responsable de la demande",
  "intake.workflow.builder.page.assigneeRole.requester": "Demandeur",
  "intake.workflow.builder.page.assigneeRole.reviewer": "Réviseur",
  "intake.workflow.builder.page.editTitle": "Modifier la page",
  "intake.workflow.builder.page.editModalDescription":
    "Modifiez les champs et la configuration de cette page du flux.",
  "intake.workflow.builder.page.editModalLoading": "Chargement de la page…",
  "intake.workflow.builder.page.editModalSaving": "Enregistrement…",
  "intake.workflow.builder.page.editModalMissing": "Cette page n'est plus disponible.",
  "intake.workflow.builder.page.blankOptionLabel.bannerLabel": "Étiquette d'option vide",
  "intake.workflow.builder.page.blankOptionLabel.bannerTitle":
    "Ajoutez une étiquette à chaque option avant de fermer cette page.",
  "intake.workflow.builder.page.blankOptionLabel.locate": "Aller à l'option {number}",
  "intake.workflow.builder.page.settings.deletePage": "Supprimer la page",
  "intake.workflow.builder.page.saveBlockedToast":
    "Certains composants n'ont pas pu être enregistrés : {names}. Retirez-les ou ajustez-les, puis réessayez.",
  "intake.workflow.builder.canvas.label": "Canevas du flux",
  "intake.workflow.builder.canvas.zoomIn": "Zoom avant",
  "intake.workflow.builder.canvas.zoomOut": "Zoom arrière",
  "intake.workflow.builder.canvas.fitView": "Ajuster à l'écran",
  "intake.workflow.builder.canvas.addStage": "Ajouter une étape",
  "intake.workflow.builder.canvas.addStepAtEnd": "Ajouter une étape à la fin",
  "intake.workflow.builder.canvas.ifTrue": "Si vrai",
  "intake.workflow.builder.canvas.ifFalse": "Si faux",
  "intake.workflow.builder.seed.status.underReview": "En révision",
  "intake.workflow.builder.seed.requestDetails": "Détails de la demande",
  "intake.workflow.builder.seed.ldReview": "Révision F&D",
  "intake.workflow.builder.seed.end": "Fin",
  "intake.workflow.builder.seed.field.requestName": "Nom de la demande",
  "intake.workflow.builder.seed.field.requester": "Demandeur",
  "intake.workflow.builder.seed.field.requestOwner": "Responsable de la demande",
  "intake.workflow.builder.seed.field.lineOfBusiness": "Secteur d'activité",
  "intake.workflow.builder.seed.decision.accept": "Accepter",
  "intake.workflow.builder.seed.decision.changes": "Modifications demandées",
  "intake.workflow.builder.seed.decision.deny": "Refuser",
  "intake.workflow.builder.condition.logicLabel": "Correspondre à",
  "intake.workflow.builder.condition.logicAnd": "Toutes",
  "intake.workflow.builder.condition.logicOr": "Au moins une",
  "intake.workflow.builder.condition.fieldPlaceholder": "Sélectionner un champ",
  "intake.workflow.builder.condition.valuePlaceholder": "Valeur",
  "intake.workflow.builder.condition.boolPlaceholder": "Sélectionner…",
  "intake.workflow.builder.condition.boolTrue": "Vrai",
  "intake.workflow.builder.condition.boolFalse": "Faux",
  "intake.workflow.builder.condition.invalidOptionValue":
    "Cette valeur ne fait pas partie des options du champ. Sélectionnez de nouveau une option.",
  "intake.workflow.builder.condition.add": "Ajouter une condition",
  "intake.workflow.builder.condition.remove": "Supprimer la condition",
  "intake.workflow.builder.condition.noFields":
    "Ajoutez des champs à une page précédente pour créer des conditions.",
  "intake.workflow.builder.condition.op.equals": "est égal à",
  "intake.workflow.builder.condition.op.notEquals": "n'est pas égal à",
  "intake.workflow.builder.condition.op.contains": "contient",
  "intake.workflow.builder.condition.op.gt": "supérieur à",
  "intake.workflow.builder.condition.op.lt": "inférieur à",
  "intake.workflow.builder.condition.op.gte": "supérieur ou égal à",
  "intake.workflow.builder.condition.op.lte": "inférieur ou égal à",
  // Publish validation (#2204): surfaced by the route-header "Publish changes"
  // control when the workflow publish returns a 422 incomplete-node report.
  "intake.workflow.builder.publish.error": "Impossible de publier le flux. Veuillez réessayer.",
  "intake.workflow.builder.publish.blocked":
    "Ce flux ne peut pas encore être publié — certains chemins sont incomplets.",
  "intake.workflow.builder.publish.banner.label": "Erreurs de validation à la publication",
  "intake.workflow.builder.publish.banner.title":
    "Ce flux comporte des erreurs de validation et ne peut pas être publié. Corrigez les éléments ci-dessous, puis réessayez.",
  // NG-859 : au passé, une fois le graphe modifié sous le rapport.
  "intake.workflow.builder.publish.banner.titleStale":
    "Ces erreurs de validation proviennent de votre dernière tentative de publication.",
  "intake.workflow.builder.publish.banner.staleHint":
    "Vous avez modifié le workflow depuis \u2014 publiez à nouveau pour revérifier.",
  "intake.workflow.builder.publish.banner.dismiss": "Ignorer",
  "intake.workflow.builder.publish.banner.itemWithPath": "{name} — chemin {path}",
  // NG-859 : un message par code de champ requis manquant, nommant le champ avec
  // le libellé affiché par son panneau de configuration.
  "intake.workflow.builder.publish.banner.itemIncompletePathMain":
    "{name} \u2014 le chemin principal doit \u00eatre compl\u00e9t\u00e9 par une \u00e9tape suivante",
  "intake.workflow.builder.publish.banner.itemIncompletePathTrue":
    "{name} \u2014 le chemin Vrai doit \u00eatre compl\u00e9t\u00e9 par une \u00e9tape suivante",
  "intake.workflow.builder.publish.banner.itemIncompletePathFalse":
    "{name} \u2014 le chemin Faux doit \u00eatre compl\u00e9t\u00e9 par une \u00e9tape suivante",
  "intake.workflow.builder.publish.banner.itemIncompletePathLane":
    "{name} \u2014 le chemin \u00ab\u00a0{path}\u00a0\u00bb doit \u00eatre compl\u00e9t\u00e9 par une \u00e9tape suivante",
  "intake.workflow.builder.publish.banner.itemReviewNoDecisionOptions":
    "{name} \u2014 ajoutez au moins une option de d\u00e9cision",
  "intake.workflow.builder.publish.banner.itemMissingReviewer":
    "{name} — « Réviseurs » doit compter au moins une personne",
  "intake.workflow.builder.publish.banner.itemDecisionOptionMissingStatus":
    "{name} — renseignez « Change le statut en » pour la décision {path}",
  "intake.workflow.builder.publish.banner.itemMissingTrueStatus":
    "{name} — choisissez « Statut si vrai »",
  "intake.workflow.builder.publish.banner.itemMissingFalseStatus":
    "{name} — choisissez « Statut si faux »",
  "intake.workflow.builder.publish.banner.itemMissingPathStatusNoPath":
    "{name} — un chemin de branche n'a pas de statut",
  "intake.workflow.builder.publish.banner.itemChangeOwnerMissingSource":
    "{name} — choisissez un « Champ source »",
  "intake.workflow.builder.publish.banner.itemChangeOwnerInvalidReference":
    "{name} — son « Champ source » doit précéder cette étape",
  "intake.workflow.builder.publish.banner.itemChangeOwnerNoRules":
    "{name} — ajoutez au moins une règle d'acheminement",
  "intake.workflow.builder.publish.banner.itemChangeOwnerRuleNoTargets":
    "{name} — la règle « {path} » doit compter au moins un responsable",
  "intake.workflow.builder.publish.banner.itemChangeOwnerRuleNoTargetsUnnamed":
    "{name} — une règle d'acheminement doit compter au moins un responsable",
  "intake.workflow.builder.publish.banner.itemBranchNoConditions":
    "{name} \u2014 ajoutez au moins une condition, sinon le chemin Faux est toujours pris",
  "intake.workflow.builder.publish.banner.itemBranchConditionBlankValue":
    "{name} \u2014 {path} doit avoir une valeur de comparaison",
  "intake.workflow.builder.publish.banner.itemInvalidReopenDest":
    "{name} — « Si rouverte, revenir à » ne peut pas pointer vers une autre étape Fin",
  // #4154.
  "intake.workflow.builder.publish.banner.itemMissingProjectTemplate":
    "{name} — choisissez un modèle de projet pour la création automatique",
  "intake.workflow.builder.publish.banner.itemChangeOwnerRuleBlankValue":
    "{name} — {path} doit avoir une valeur de réponse",
  "intake.workflow.builder.publish.banner.itemChangeOwnerRuleInvalidOption":
    "{name} — {path} utilise {value}, qui ne fait pas partie des options du champ source",
  "intake.workflow.builder.publish.banner.itemVisibleIfMissingController":
    "{name} — « {path} » a une condition de visibilité qui pointe vers un champ qui n'existe plus ou qui n'est pas encore rempli",
  "intake.workflow.builder.publish.banner.itemVisibleIfInvalidReference":
    "{name} — « {path} » s'affiche selon « {controller} », qui doit le précéder",
  "intake.workflow.builder.publish.banner.locate": "Afficher {name} sur le canevas",
  // Config panel (M3 #2091).
  "intake.workflow.builder.config.paneLabel": "Paramètres de l'étape",
  "intake.workflow.builder.config.openLabel": "Ouvrir les paramètres de {name}",
  "intake.workflow.builder.config.close": "Fermer",
  "intake.workflow.builder.config.delete": "Supprimer l'étape",
  // Clear row on the optional Status pickers (Page, End) — NG-1017.
  "intake.workflow.builder.config.statusClear": "Aucun statut",
  "intake.workflow.builder.config.stepName": "Nom de l'étape",
  "intake.workflow.builder.config.stubBody": "Les paramètres de cette étape arrivent bientôt.",
  "intake.workflow.builder.config.page.whoFills": "Qui remplit cette page",
  "intake.workflow.builder.config.page.assigneeTypeLabel": "Type d'assigné",
  "intake.workflow.builder.config.page.assigneeTypePlaceholder":
    "Sélectionnez qui remplit cette page",
  "intake.workflow.builder.config.page.assigneeType.team": "Équipe",
  "intake.workflow.builder.config.page.assigneeType.role": "Rôle",
  "intake.workflow.builder.config.page.assigneeType.user": "Utilisateur",
  "intake.workflow.builder.config.page.assignment": "Affectation",
  "intake.workflow.builder.config.page.assigneeRoleAria": "Rôle de l'assigné",
  "intake.workflow.builder.config.page.assigneeRolePlaceholder": "Sélectionnez un rôle",
  "intake.workflow.builder.config.page.teamPlaceholder": "Sélectionnez une équipe",
  "intake.workflow.builder.config.page.teamSearch": "Rechercher des équipes",
  "intake.workflow.builder.config.page.teamEmpty": "Aucune équipe trouvée",
  "intake.workflow.builder.config.page.teamAria": "Affecter à une équipe",
  "intake.workflow.builder.config.page.userPlaceholder": "Sélectionnez un utilisateur",
  "intake.workflow.builder.config.page.userSearch": "Rechercher des utilisateurs",
  "intake.workflow.builder.config.page.userEmpty": "Aucun utilisateur trouvé",
  "intake.workflow.builder.config.page.userAria": "Affecter à un utilisateur",
  // #2696 : « Qui remplit cette page » devient deux listes à sélection multiple
  // indépendantes (équipes disponibles + utilisateurs disponibles), affichées
  // ensemble sur les pages 2 et suivantes. La première page fixe n'affiche aucun
  // sélecteur — l'accès y est déterminé par les équipes du workflow.
  // #3311 : libellés « Équipes » / « Utilisateurs » (la section « Accès » indique
  // déjà qu'il s'agit des personnes qui remplissent la page), selon la maquette.
  "intake.workflow.builder.config.page.availableTeamsLabel": "Équipes",
  "intake.workflow.builder.config.page.availableUsersLabel": "Utilisateurs",
  "intake.workflow.builder.config.page.availableTeamsPlaceholder": "Sélectionner des équipes",
  "intake.workflow.builder.config.page.availableUsersPlaceholder": "Sélectionner des utilisateurs",
  "intake.workflow.builder.config.page.availableTeamsHelper":
    "Sélectionner une équipe limite la modification aux membres de cette équipe et avertit le chef d'équipe lorsqu'une demande atteint cette page.",
  "intake.workflow.builder.config.page.availableUsersHelper":
    "Sélectionner des utilisateurs précis limite la modification à ces seuls utilisateurs, qui sont avertis lorsqu'une demande atteint cette page.",
  "intake.workflow.builder.config.page.firstPageAssigneeHelper":
    "L'accès à la première page est déterminé par les équipes du workflow.",
  "intake.workflow.builder.config.page.statusSection": "Statut",
  "intake.workflow.builder.config.page.statusLabel": "Statut",
  "intake.workflow.builder.config.page.statusPlaceholder": "Sélectionnez un statut",
  "intake.workflow.builder.config.page.statusSearch": "Rechercher des statuts",
  "intake.workflow.builder.config.page.statusEmpty": "Aucun statut trouvé",
  "intake.workflow.builder.config.page.statusAria": "Statut",
  // #3311 : texte d'aide toujours affiché sous le contrôle Statut (une page
  // initiale / dérivée affiche plutôt son propre texte d'aide ci-dessous).
  "intake.workflow.builder.config.page.statusHelper":
    "Il s'agit du statut qui sera attribué à la demande pendant cette étape.",
  "intake.workflow.builder.config.page.firstPageStatusHelper":
    "Le statut est appliqué lorsque l'étape suivante est atteinte.",
  "intake.workflow.builder.config.page.reviewBranchStatusHelper":
    "Le statut est défini par la décision de révision « {option} » et ne peut pas être modifié ici.",
  "intake.workflow.builder.config.page.notifyLabel": "Notifier les utilisateurs",
  "intake.workflow.builder.config.page.notifyHelper":
    "Avertir les personnes responsables de cette page quand une demande y arrive.",
  "intake.workflow.builder.config.page.notifyRecipientsOwners":
    "Avertit les propriétaires de la demande.",
  "intake.workflow.builder.config.page.notifyRecipientsUsers": "Avertit {names}.",
  "intake.workflow.builder.config.page.notifyRecipientsTeams":
    "Avertit {count, plural, one {le responsable} other {les responsables}} de {names}.",
  "intake.workflow.builder.config.page.notifyRecipientsBoth":
    "Avertit {users}, et {count, plural, one {le responsable} other {les responsables}} de {teams}.",
  "intake.workflow.builder.config.page.notifyRecipientsNone":
    "Les personnes ou équipes sélectionnées ci-dessus ne sont plus disponibles, donc personne ne sera averti.",
  "intake.workflow.builder.config.page.notificationLabel": "Message de notification",
  "intake.workflow.builder.config.page.notificationPlaceholder":
    "Définir un message personnalisé pour les utilisateurs notifiés",
  "intake.workflow.builder.config.page.fieldsSection": "Champs de cette page",
  "intake.workflow.builder.config.page.noFields": "Aucun champ pour le moment",
  "intake.workflow.builder.config.page.noFieldsHint":
    "Ouvrez Modifier la page pour ajouter des champs à cette page.",
  "intake.workflow.builder.config.page.editPage": "Modifier la page",
  "intake.workflow.builder.config.page.removeField": "Supprimer {name}",
  "intake.workflow.builder.config.page.unknownField": "Champ inconnu",
  // Panneau de configuration Révision (M3 #2091, PRD v2 §6.4.3).
  "intake.workflow.builder.config.review.statusLabel": "Statut (facultatif)",
  "intake.workflow.builder.config.review.statusPlaceholder": "Laisser inchangé",
  "intake.workflow.builder.config.review.statusSearch": "Rechercher des statuts…",
  "intake.workflow.builder.config.review.statusEmpty": "Aucun statut",
  "intake.workflow.builder.config.review.statusAria": "Statut de la révision",
  // #2956 : une révision qui ouvre une voie d'option de décision hérite du statut
  // de cette option ; le contrôle est pré-rempli et en lecture seule.
  "intake.workflow.builder.config.review.reviewBranchStatusHelper":
    "Le statut est défini par la décision de révision « {option} » et ne peut pas être modifié ici.",
  "intake.workflow.builder.config.review.reviewersLabel": "Réviseurs",
  "intake.workflow.builder.config.review.reviewersPlaceholder": "Sélectionner des réviseurs",
  "intake.workflow.builder.config.review.reviewersSearch": "Rechercher des personnes…",
  "intake.workflow.builder.config.review.reviewersEmpty": "Aucune personne",
  "intake.workflow.builder.config.review.reviewersRequired": "Sélectionnez au moins un réviseur.",
  "intake.workflow.builder.config.review.decisionsLabel": "Options de décision",
  "intake.workflow.builder.config.review.decisionsHelper":
    "Chaque décision devient une branche sous cette étape.",
  "intake.workflow.builder.config.review.decisionNameAria": "Nom de l'option de décision",
  "intake.workflow.builder.config.review.decisionStatusLabel": "Change le statut en",
  "intake.workflow.builder.config.review.decisionStatusAria": "Change le statut en ({name})",
  "intake.workflow.builder.config.review.decisionStatusPlaceholder": "Choisir un statut",
  "intake.workflow.builder.config.review.decisionStatusRequired": "Sélectionnez un statut.",
  "intake.workflow.builder.config.review.removeDecision": "Supprimer l'option de décision ({name})",
  "intake.workflow.builder.config.review.addDecision": "Ajouter une option de décision",
  "intake.workflow.builder.config.review.newDecisionName": "Option {n}",
  "intake.workflow.builder.config.review.notificationLabel": "Message de notification",
  "intake.workflow.builder.config.review.notificationPlaceholder":
    "Message envoyé aux réviseurs lorsque cette étape est atteinte.",
  // End config panel (M3 #2091, §6.4.5).
  "intake.workflow.builder.config.end.statusTitle": "Statut",
  "intake.workflow.builder.config.end.statusLabel": "Statut à la fin",
  "intake.workflow.builder.config.end.statusHelper":
    "Le statut attribué à une demande lorsqu'elle se termine à cette étape.",
  // #2956 : une fin qui ouvre une voie d'option de décision hérite du statut de
  // cette option ; le contrôle est pré-rempli et en lecture seule.
  "intake.workflow.builder.config.end.reviewBranchStatusHelper":
    "Le statut est défini par la décision de révision « {option} » et ne peut pas être modifié ici.",
  "intake.workflow.builder.config.end.statusPlaceholder": "Sélectionner un statut",
  "intake.workflow.builder.config.end.statusSearch": "Rechercher des statuts…",
  "intake.workflow.builder.config.end.statusEmpty": "Aucun statut",
  "intake.workflow.builder.config.end.completionTitle": "À la complétion",
  "intake.workflow.builder.config.end.completionLabel": "Lorsque cette étape est atteinte",
  "intake.workflow.builder.config.end.completionHelper":
    "Choisissez si un projet est créé automatiquement ou par un administrateur.",
  "intake.workflow.builder.config.end.completionAuto": "Créer le projet automatiquement",
  "intake.workflow.builder.config.end.completionManual": "Manuel — créé par un administrateur",
  // Modèle de projet pour la création automatique (#4154).
  "intake.workflow.builder.config.end.projectTemplateLabel": "Modèle de projet",
  "intake.workflow.builder.config.end.projectTemplateHelper":
    "Le projet créé est basé sur ce modèle, avec les réponses de la demande reportées dedans.",
  "intake.workflow.builder.config.end.projectTemplateRequired":
    "Choisissez un modèle de projet. Ce flux ne peut pas être publié tant que ce n'est pas fait.",
  "intake.workflow.builder.config.end.projectTemplatePlaceholder":
    "Sélectionner un modèle de projet",
  "intake.workflow.builder.config.end.projectTemplateSearch": "Rechercher des modèles de projet…",
  "intake.workflow.builder.config.end.projectTemplateEmpty": "Aucun modèle de projet trouvé.",
  "intake.workflow.builder.config.end.reopenTitle": "Réouverture",
  "intake.workflow.builder.config.end.reopenLabel": "Si rouverte, revenir à",
  "intake.workflow.builder.config.end.reopenHelper":
    "L'étape vers laquelle revient une demande rouverte. Laissez vide pour aucune destination.",
  "intake.workflow.builder.config.end.reopenPlaceholder": "Sélectionner une étape",
  "intake.workflow.builder.config.end.reopenSearchPlaceholder": "Rechercher des étapes...",
  "intake.workflow.builder.config.end.reopenEmpty": "Aucune étape trouvée.",
  "intake.workflow.builder.config.branch.trueStatus": "Statut si vrai",
  "intake.workflow.builder.config.branch.falseStatus": "Statut si faux",
  "intake.workflow.builder.config.branch.statusPlaceholder": "Sélectionner un statut",
  "intake.workflow.builder.config.branch.statusSearch": "Rechercher des statuts",
  "intake.workflow.builder.config.branch.statusEmpty": "Aucun statut trouvé",
  "intake.workflow.builder.config.branch.statusRequired": "Un statut est requis.",
  "intake.workflow.builder.config.branch.conditionsTitle": "Conditions",
  "intake.workflow.title": "Workflow",
  "intake.workflow.description":
    "Définissez les transitions de statut autorisées et qui peut les effectuer. Les statuts sans règles autorisent toutes les transitions.",
  "intake.workflow.reset_to_defaults": "Réinitialiser par défaut",
  "intake.workflow.reset_confirm_title": "Réinitialiser le workflow ?",
  "intake.workflow.reset_confirm_description":
    "Toutes les règles de transition et les approbateurs personnalisés seront supprimés. Toutes les transitions de statut deviendront libres.",
  "intake.workflow.reset_success": "Workflow réinitialisé par défaut.",
  "intake.workflow.reset_error": "Échec de la réinitialisation du workflow.",
  "intake.workflow.fetch_error": "Échec du chargement de la configuration du workflow.",
  "intake.workflow.statuses_fetch_error": "Échec du chargement des statuts du workflow.",
  "intake.workflow.create_allowed": "Autorisé",
  "intake.workflow.create_blocked": "Bloqué",
  "intake.workflow.create_label": "Création :",
  "intake.workflow.no_rules": "Aucune règle configurée — toutes les transitions autorisées",
  "intake.workflow.movers_label": "Déplacé par :",
  "intake.workflow.movers_everyone": "Tout le monde",
  "intake.workflow.mover_search_placeholder": "Rechercher des membres…",
  "intake.workflow.require_approval_label": "Approbation requise",
  "intake.workflow.approvers_label": "Approbateurs :",
  "intake.workflow.approvers_none": "Aucun (tout le monde)",
  "intake.workflow.approvers_count": "{count} utilisateurs configurés",
  "intake.workflow.required_approvals": "Requis : {count} sur {total}",
  "intake.workflow.rejection_state": "Rejet :",
  "intake.workflow.configure": "Configurer",
  "intake.workflow.configure_title": "Configurer : {state}",
  "intake.workflow.configure_description":
    "Définissez les statuts vers lesquels ce statut peut transitionner et configurez les exigences d'approbation.",
  "intake.workflow.allow_creation": "Autoriser la création de projet dans ce statut",
  "intake.workflow.allow_creation_hint":
    "Lorsque activé, de nouveaux projets peuvent être créés directement dans ce statut.",
  "intake.workflow.transition_added": "Transition ajoutée.",
  "intake.workflow.transition_removed": "Transition supprimée.",
  "intake.workflow.transition_update_error": "Échec de la mise à jour de la transition.",
  "intake.workflow.update_success": "Workflow mis à jour.",
  "intake.workflow.update_error": "Échec de la mise à jour du workflow.",
  "intake.workflow.required_approvals_label": "Approbations requises :",
  "intake.workflow.approvals_all": "Toutes",
  "intake.workflow.approval_state_label": "En cas d'approbation :",
  "intake.workflow.approval_none": "Statut cible de la transition",
  "intake.workflow.rejection_state_label": "En cas de rejet :",
  "intake.workflow.rejection_none": "Aucun",
  "intake.workflow.approver_search_placeholder": "Rechercher des membres…",
  "intake.workflow.approver_no_members": "Aucun membre trouvé",
  "intake.workflow.approver_unknown": "Utilisateur inconnu",
  "intake.workflow.unknown_state": "Statut inconnu",
  "intake.workflow.activity_title": "Activité du workflow",
  "intake.workflow.activity_empty": "Aucune activité pour le moment",
  "intake.workflow.activity_created_transition": "{actor} a ajouté une transition vers « {state} »",
  "intake.workflow.activity_removed_transition":
    "{actor} a supprimé la transition vers « {state} »",
  "intake.workflow.activity_updated_creation": "{actor} a {action} la création de projet",
  "intake.workflow.activity_updated_approvers": "{actor} a mis à jour les approbateurs",
  "intake.workflow.activity_reset": "{actor} a réinitialisé le workflow par défaut",
  "intake.workflow.activity_enabled": "activé",
  "intake.workflow.activity_disabled": "désactivé",
  "intake.workflow.activity_unknown_actor": "Utilisateur inconnu",
  "intake.workflow.activity_updated_transition": "{actor} a mis à jour la transition",
  "intake.workflow.activity_generic": "{actor} {verb} {field}",

  // Intake — workflow runtime (côté demandeur)
  "intake.workflow.transition_blocked_title": "Transition non autorisée",
  "intake.workflow.transition_blocked_description":
    "La transition de {from} vers {to} n'est pas autorisée par les règles de workflow actuelles.",
  "intake.workflow.allowed_transitions": "Transitions autorisées :",
  "intake.workflow.contact_admin":
    "Contactez un administrateur de l'espace de travail pour modifier les règles de workflow.",
  "intake.workflow.approval_required_title": "Approbation requise",
  "intake.workflow.approval_required_description":
    "Le passage de {from} à {to} nécessite une approbation avant que la transition puisse se faire.",
  "intake.workflow.approval_request_to": "Cela enverra une demande d'approbation à :",
  "intake.workflow.required_approvals_count": "Approbations requises : {count} sur {total}",
  "intake.workflow.required_approvals_all": "Approbations requises : toutes sur {total}",
  "intake.workflow.request_approval_button": "Demander l'approbation",
  "intake.workflow.approval_request_sent": "Demande d'approbation envoyée",
  "intake.workflow.approval_request_error": "Échec de l'envoi de la demande d'approbation",
  "intake.workflow.pending_approval": "En attente d'approbation",
  "intake.workflow.review_required": "Approbation requise",
  "intake.reviewPending.pending": "Révision en attente",
  "intake.reviewPending.awaitingYou": "En attente de votre révision",
  "intake.reviewPending.reviewersTitle": "En attente de révision",
  "intake.reviewPending.reviewersDescription":
    "N'importe lequel de ces réviseurs peut décider de cette demande.",
  "intake.reviewPending.reviewStep": "Étape de révision : {name}",
  "intake.reviewPending.noReviewers": "Aucun réviseur n'est affecté à cette révision.",
  "intake.reviewPending.reviewersLabel": "Réviseurs",
  "intake.reviewPending.reviewerNotMember": "N'est pas membre de cet espace de travail",
  "intake.reviewPending.reviewerUnavailable": "Nom du réviseur indisponible",
  "intake.workflow.pending_approval_title": "En attente d'approbation",
  "intake.workflow.approval_requested_title": "Approbation demandée",
  "intake.workflow.current_approvals": "Approbations actuelles : {current} sur {required} requises",
  "intake.workflow.approver_status_pending": "En attente",
  "intake.workflow.approver_status_approved": "Approuvé",
  "intake.workflow.approver_status_rejected": "Rejeté",
  "intake.workflow.already_voted": "Vous avez déjà {action} cette transition.",
  "intake.workflow.comment_optional": "Commentaire (facultatif)",
  "intake.workflow.approve_button": "Approuver",
  "intake.workflow.reject_button": "Rejeter",
  "intake.workflow.approval_success": "Approbation soumise",
  "intake.workflow.rejection_success": "Rejet soumis",
  "intake.workflow.approval_error": "Échec de la soumission de l'approbation",
  "intake.workflow.rejection_error": "Échec de la soumission du rejet",
  "intake.workflow.dismiss": "Fermer",
  "intake.workflow.you": "vous",

  // Plan work: field editors and the cost breakdown sheet (NG-2580)
  "intake.planWork.editors.switch_template": "Changer de modèle",
  "intake.planWork.editors.no_templates": "Aucun modèle disponible",
  "intake.planWork.editors.no_estimate": "Aucune estimation",
  "intake.planWork.editors.avg_hours": "Moy. {hours} h",
  "intake.planWork.editors.date_not_set": "Non défini",
  "intake.planWork.editors.edit_target_date": "Modifier la date de lancement cible",
  "intake.planWork.editors.edit_end_date": "Modifier la date de fin",
  "intake.planWork.editors.edit_start_date": "Modifier la date de début",
  "intake.planWork.costBreakdown.title": "Détail du coût estimé",
  "intake.planWork.costBreakdown.description":
    "Les heures prévues de chaque rôle, valorisées au taux qui s'y applique : le taux propre d'un membre affecté lorsqu'une personne est assignée, sinon le taux du rôle.",
  "intake.planWork.costBreakdown.by_role": "Par rôle",
  "intake.planWork.costBreakdown.column_role": "Rôle",
  "intake.planWork.costBreakdown.column_hours": "Heures",
  "intake.planWork.costBreakdown.column_rate": "Taux",
  "intake.planWork.costBreakdown.column_cost": "Coût",
  "intake.planWork.costBreakdown.empty": "Aucun travail valorisé dans ce modèle pour l'instant.",
  "intake.planWork.costBreakdown.no_role": "Aucun rôle défini",
  "intake.planWork.costBreakdown.per_hour": "{rate}/h",
  "intake.planWork.costBreakdown.total": "Total ({hours} h)",
  "intake.planWork.costBreakdown.basis_member_average":
    "Moyenne des taux de {count} membres affectés",
  "intake.planWork.costBreakdown.basis_member": "Taux du membre affecté",
  "intake.planWork.costBreakdown.basis_role": "Taux du rôle — personne n'est encore affecté",
  "intake.planWork.costBreakdown.basis_unpriced": "Aucun rôle métier défini sur ces éléments",
  "intake.planWork.costBreakdown.hours_scaled":
    "Les heures correspondent à votre effort prévu, réparti entre les rôles du modèle sélectionné en conservant leur proportion.",
  "intake.planWork.costBreakdown.hours_from_template":
    "Les heures proviennent des éléments de travail du modèle de projet sélectionné.",

  "intake.planWork.gantt.search_placeholder": "Rechercher des projets…",
  "intake.planWork.gantt.this_project": "Ce projet",
  "intake.planWork.gantt.launch_marker": "Lancement {date}",
  "intake.planWork.gantt.this_over_duration": "Plus long que la durée de {days} jours du modèle",
  "intake.planWork.gantt.priority_tooltip": "{tier} · {points} pts",
  "intake.planWork.gantt.priority_unranked": "Non classé",
  "intake.planWork.gantt.priority_loading": "Chargement du détail du score…",
  "intake.planWork.gantt.priority_off":
    "La notation des priorités est désactivée pour cet espace de travail : il n’y a aucun score à expliquer.",
  "intake.planWork.gantt.priority_failed": "Impossible de charger le détail du score",
  "intake.planWork.gantt.open_project": "Ouvrir le projet",
  "intake.planWork.gantt.empty": "Aucun projet actif n'est encore planifié.",
  "intake.planWork.gantt.empty_search": "Aucun projet ne correspond à votre recherche.",
  "intake.planWork.gantt.empty_period": "Aucun projet actif n'est planifié sur cette période.",
  "intake.planWork.gantt.restricted_project": "Projet restreint",
  // Plan work: the page's loading, error and create states, and the accept dialog (NG-2580)
  "intake.planWork.page.loading": "Chargement des données de planification…",
  "intake.planWork.page.loading_aria": "Chargement des données de planification",
  "intake.planWork.page.denied_title":
    "Vous n'avez pas l'autorisation de planifier le travail pour cette demande.",
  "intake.planWork.page.error_title": "Impossible de charger les données de planification",
  "intake.planWork.page.denied_description":
    "Contactez l'administrateur de votre espace de travail si vous avez besoin d'un accès.",
  "intake.planWork.page.error_description": "Veuillez réessayer.",
  "intake.planWork.page.retry": "Réessayer",
  "intake.planWork.page.accept_and_create": "Accepter et créer le projet",
  "intake.planWork.page.create": "Créer le projet",
  "intake.planWork.page.create_blocked_rejected":
    "Impossible de créer un projet à partir d'une demande rejetée.",
  "intake.planWork.page.create_blocked_unaccepted":
    "Impossible de créer un projet tant que la demande n'est pas acceptée.",
  "intake.planWork.page.create_blocked_unreachable":
    "Le flux de travail de cette demande ne permet pas de passer à un statut accepté depuis son statut actuel.",
  "intake.planWork.page.accept_error":
    "Impossible d'accepter la demande : vérifiez que le flux de travail autorise ce statut.",
  "intake.planWork.acceptDialog.title": "Accepter la demande",
  "intake.planWork.acceptDialog.description":
    "Choisissez le statut vers lequel la demande passe ; le projet est créé juste après.",
  "intake.planWork.acceptDialog.status_aria": "Statut accepté",
  "intake.planWork.acceptDialog.accepting": "Acceptation…",
  "intake.planWork.acceptDialog.confirm": "Accepter et créer le projet",
  "intake.planWork.acceptDialog.needs_approval": "Approbation requise",
  "intake.planWork.acceptDialog.request_approval": "Demander l'approbation",
  "intake.planWork.gantt.empty_filtered": "Aucun projet ne correspond à vos filtres.",
  "intake.planWork.gantt.filters_heading": "Filtres",
  "intake.planWork.gantt.filter_team": "Équipe",
  "intake.planWork.gantt.filter_project_lead": "Responsable de projet",
  "intake.planWork.gantt.project_category": "Catégorie de projet",
  "intake.planWork.gantt.filter_project_status": "Statut du projet",
  "intake.planWork.gantt.filter_no_matches": "Aucun résultat.",
  "intake.planWork.gantt.group_by": "Grouper",
  "intake.planWork.gantt.group_none": "Aucun regroupement",
  // Plan work: the "Plan your project" card (NG-2580)
  "intake.planWork.card.title": "Planifier votre projet",
  "intake.planWork.requiredTemplate.label": "Modèle de projet (obligatoire)",
  "intake.planWork.requiredTemplate.select": "Sélectionnez un modèle de projet",
  "intake.planWork.requiredTemplate.unavailable":
    "Le modèle de projet enregistré n’est plus disponible. Sélectionnez un autre modèle.",
  "intake.planWork.card.status_on_track": "En bonne voie",
  "intake.planWork.card.status_no_end_date": "Aucune date de fin",
  "intake.planWork.card.status_no_target_date": "Aucune date de lancement cible",
  "intake.planWork.card.status_will_miss": "Échéance manquée",
  "intake.planWork.card.status_at_risk": "À risque",
  "intake.planWork.card.required_roles": "Rôles requis",
  "intake.planWork.card.roles_none": "Ce modèle ne définit aucun rôle requis",
  "intake.planWork.card.role_at_risk_aria": "{role} : aucune capacité disponible aux dates prévues",
  "intake.planWork.card.role_at_risk_teams":
    "Personne ayant ce rôle dans {count, plural, one {l'équipe de livraison sélectionnée} other {les équipes de livraison sélectionnées}} n'a de capacité entre les dates de début et de fin prévues.",
  "intake.planWork.card.role_at_risk":
    "Personne ayant ce rôle n'a de capacité entre les dates de début et de fin prévues.",
  "intake.planWork.card.role_hours_aria": "Modifier les heures de {role}",
  "intake.planWork.card.delivery_team": "Équipe de livraison",
  "intake.planWork.card.delivery_team_placeholder": "Sélectionner une équipe",
  "intake.planWork.card.project_lead": "Responsable du projet",
  "intake.planWork.card.project_lead_placeholder": "Non défini",
  "intake.planWork.card.estimated_duration": "Durée estimée",
  "intake.planWork.card.duration_unscheduled": "Aucun élément de travail planifié dans ce modèle",
  "intake.planWork.card.duration_days": "jours",
  "intake.planWork.card.duration_source_hint":
    "Cette durée provient du modèle de projet sélectionné.",
  "intake.planWork.card.target_launch_date": "Date de lancement cible",
  "intake.planWork.card.project_dates": "Dates du projet",
  "intake.planWork.card.weeks_total":
    "{weeks, plural, one {{weeksText} semaine} other {{weeksText} semaines}} au total",
  "intake.planWork.card.estimated_effort": "Effort estimé",
  "intake.planWork.card.edit_effort_aria": "Modifier l'effort estimé",
  "intake.planWork.card.estimated_cost": "Coût estimé",
  "intake.planWork.card.cost_basis_member": "Selon les taux des membres sélectionnés",
  "intake.planWork.card.cost_basis_role":
    "Selon les taux des rôles — aucun membre sélectionné pour l'instant",

  "intake.submissionDetail.errorTitle": "Soumission indisponible",
  "intake.submissionDetail.movedOutOfReachTitle": "Vous avez déplacé cette demande vers {team}",
  "intake.submissionDetail.movedOutOfReachTitleNoTeam":
    "Vous avez déplacé cette demande vers une autre équipe",
  "intake.submissionDetail.movedOutOfReachDescription":
    "Vous n’y avez plus accès, car vous n’êtes pas lié à sa nouvelle équipe principale.",
  "intake.submissionDetail.noAccessTitle": "Accès refusé",
  "intake.submissionDetail.noAccessDescription":
    "Vous n’avez pas accès à cette demande, ou elle n’existe plus. Demandez à un administrateur si vous pensez devoir y avoir accès.",
  "intake.submissionDetail.noAccessBack": "Retour aux demandes",
  "intake.submissionDetail.loadError": "Échec du chargement de la soumission.",
  "intake.submissionDetail.definitionUnavailableTitle":
    "Le formulaire de cette demande ne peut pas être affiché",
  "intake.submissionDetail.definitionUnavailableDescription":
    "Nous n'avons pas pu lire le formulaire utilisé pour cette demande, ses réponses ne peuvent donc pas être affichées. Rechargez la page; si le problème persiste, contactez le support.",
  "intake.submissionDetail.priorityScoreHeading": "Score de priorité",
  "intake.submissionDetail.priorityScorePoints": "{count} pts",
  "intake.submissionDetail.priorityScoreLinePoints": "+{count} pts",
  "intake.submissionDetail.priorityScoreTotal": "Total",
  "intake.submissionDetail.tabRequestDetails": "Détails",
  "intake.submissionDetail.tabPlanWork": "Planifier le travail",
  "intake.submissionDetail.tabLinkedProjects": "Projets liés",
  "intake.submissionDetail.tabsAria": "Sections de la demande",
  "intake.submissionDetail.pageNav.pillsLabel": "Pages du formulaire",
  "intake.submissionDetail.pageNav.pageFallback": "Page {index}",
  "intake.submissionDetail.pageNav.back": "Précédent",
  "intake.submissionDetail.pageNav.next": "Suivant",
  "intake.submissionDetail.pageNav.noPages": "Cette demande n'a aucune page à afficher.",
  "intake.submissionDetail.saveError": "Impossible d'enregistrer la modification. Réessayez.",
  "intake.submissionDetail.saveSuccess": "Enregistré",
  "intake.submissionDetail.comments.title": "Commentaires",
  "intake.submissionDetail.comments.button": "Commentaires",
  "intake.submissionDetail.comments.empty": "Aucun commentaire pour le moment.",
  "intake.submissionDetail.comments.placeholder": "Ajouter un commentaire",
  "intake.submissionDetail.comments.submit": "Publier le commentaire",
  "intake.submissionDetail.activity.title": "Activité",
  "intake.submissionDetail.activity.button": "Activité",
  "intake.submissionDetail.activity.empty": "Aucune activité pour le moment.",
  "intake.submissionDetail.activity.declinedDetails": "Refusée : {details}",
  "intake.submissionDetail.activity.waitlistedDetails": "En liste d'attente : {details}",
  "intake.submissionDetail.activity.cancelledDetails": "Annulée : {details}",

  // Pourquoi une demande a été refusée, affiché au demandeur (#4197).
  "intake.submissionDetail.decline.title": "Refusée — {reason}",
  "intake.submissionDetail.decline.titleNoReason": "Refusée",
  "intake.submissionDetail.outcome.declined.title": "Refusée : {reason}",
  "intake.submissionDetail.outcome.declined.titleNoReason": "Refusée",
  "intake.submissionDetail.outcome.waitlisted.title": "En liste d'attente : {reasons}",
  "intake.submissionDetail.outcome.waitlisted.titleNoReason": "En liste d'attente",
  "intake.submissionDetail.outcome.cancelled.title": "Annulée : {reason}",
  "intake.submissionDetail.outcome.cancelled.titleNoReason": "Annulée",

  "intake.submissionDetail.actions.menu": "Plus d'actions",
  "intake.submissionDetail.delete.action": "Supprimer la demande",
  "intake.submissionDetail.delete.title": "Supprimer cette demande ?",
  "intake.submissionDetail.delete.description":
    "Cela supprimera la demande et ses données. Les projets liés ne sont pas supprimés.",
  "intake.submissionDetail.delete.confirm": "Supprimer la demande",
  "intake.submissionDetail.delete.success": "Demande supprimée.",
  "intake.submissionDetail.delete.error": "Impossible de supprimer la demande. Réessayez.",
  "intake.submissionDetail.archive.archiveAction": "Archiver la demande",
  "intake.submissionDetail.archive.unarchiveAction": "Désarchiver la demande",
  "intake.submissionDetail.archive.archived": "Demande archivée.",
  "intake.submissionDetail.archive.unarchived": "Demande désarchivée.",
  "intake.submissionDetail.archive.error": "Impossible de mettre à jour la demande. Réessayez.",
  "intake.submissionDetail.headerMeta": "Formulaire utilisé : {form} · Soumis par {name} le {date}",
  "intake.submissionDetail.people.requester": "Demandeur",
  "intake.submissionDetail.people.requesterPlaceholder": "Sélectionner le demandeur",
  "intake.submissionDetail.people.owners": "Responsables de la demande",
  "intake.submissionDetail.people.ownersPlaceholder": "Sélectionner les responsables",
  "intake.submissionDetail.people.ownersMinOne": "Une demande doit avoir au moins un responsable.",
  "intake.submissionDetail.people.searchMembers": "Rechercher des membres…",
  "intake.submissionDetail.people.noMembers": "Aucun membre trouvé.",
  "intake.submissionDetail.people.unassigned": "Non attribué",
  "intake.submissionDetail.people.homeTeam": "Équipe principale",
  "intake.submissionDetail.people.homeTeamNone": "Aucune équipe principale",
  "intake.submissionDetail.people.homeTeamMoved": "Demande déplacée vers {team}",
  "intake.submissionDetail.archive.badge": "Archivée",
  "intake.submissionDetail.reviewLock.title": "Cette demande est en attente de révision",
  "intake.submissionDetail.reviewLock.description":
    "Seul son statut peut être modifié jusqu'à la décision du réviseur. Les commentaires restent ouverts.",
  "intake.submissionDetail.slaWithinDue": "Dans les délais du SLA · Échéance {date}",
  "intake.submissionDetail.slaWithin": "Dans les délais du SLA",
  "intake.submissionDetail.slaBreachedDue": "SLA dépassé · Échéance {date}",
  "intake.submissionDetail.slaBreached": "SLA dépassé",
  "intake.submissionDetail.slaPaused": "SLA en pause",
  "intake.submissionDetail.slaNameTooltip": "SLA : {name}",

  "intake.requesterFlow.formsTitle": "Formulaires",
  "intake.requesterFlow.submitDeniedTitle": "Vous ne pouvez pas soumettre de demandes",
  "intake.requesterFlow.submitDeniedDescription":
    "Demandez à un administrateur de l’espace l’autorisation de soumettre des demandes.",
  "intake.requesterFlow.selectTypeTitle": "Démarrer une demande",
  "intake.requesterFlow.selectTypeDescription":
    "Choisissez le formulaire qui correspond à votre besoin. Votre demande n’est créée que lorsque vous la soumettez.",
  "intake.requesterFlow.startRequest": "Démarrer la demande",
  "intake.requesterFlow.submitRequest": "Soumettre la demande",
  "intake.requesterFlow.formsAvailable": "{count} formulaires disponibles",
  "intake.requesterFlow.formsEmpty": "Aucun formulaire disponible.",
  "intake.requesterFlow.formsEmptyForQuery": "Aucun formulaire ne correspond à cette recherche.",
  "intake.requesterFlow.pickDate": "Choisir une date",
  "intake.requesterFlow.pickTime": "Choisir une heure",
  "intake.requesterFlow.pickDateFor": "Choisir une date — {field}",
  "intake.requesterFlow.pickTimeFor": "Choisir une heure — {field}",
  "intake.requesterFlow.chooseMonth": "Choisir le mois",
  "intake.requesterFlow.chooseYear": "Choisir l'année",
  "intake.requesterFlow.nextMonth": "Aller au mois suivant",
  "intake.requesterFlow.previousMonth": "Aller au mois précédent",
  "intake.requesterFlow.formsSearchPlaceholder": "Rechercher des formulaires",
  "intake.requesterFlow.formsSearchClear": "Effacer la recherche de formulaires",
  "intake.requesterFlow.formsLoadMore": "Charger plus",
  "intake.requesterFlow.formsLoadingMore": "Chargement…",
  "intake.requesterFlow.selectFormTitle": "Sélectionnez un formulaire",
  "intake.requesterFlow.selectFormDescription":
    "Choisissez un formulaire dans la barre latérale pour soumettre une demande.",
  "intake.requesterFlow.submit": "Soumettre la demande",
  "intake.requesterFlow.submitting": "Soumission…",
  "intake.requesterFlow.submitSuccess": "Demande soumise.",
  "intake.requesterFlow.submitError": "Échec de la soumission.",
  "intake.requesterFlow.noFieldsTitle": "Ce formulaire ne contient aucun champ à remplir",
  "intake.requesterFlow.noFieldsDescription":
    "Il n'y a aucune question à remplir, ce formulaire ne peut donc pas être soumis. Choisissez un autre formulaire ou demandez à votre administrateur de terminer sa configuration.",
  "intake.validation.url": "Saisissez une URL valide. Nous ajouterons https:// si vous l'omettez.",
  "intake.validation.phone": "Saisissez un numéro de téléphone valide d'au moins 7 chiffres.",
  "intake.requesterFlow.submittedTitle": "Demande soumise",
  "intake.requesterFlow.submittedDescription": "Votre demande est en attente de validation.",
  "intake.requesterFlow.submitAnother": "Soumettre une autre demande",
  "intake.requesterFlow.backToRequests": "Retour aux demandes",
  "intake.requesterFlow.backToForms": "Retour aux formulaires",
  "intake.requesterFlow.requiredQuestionsLeft":
    "{count, plural, one {# question obligatoire restante} other {# questions obligatoires restantes}}",
  "intake.requesterFlow.reviewersTitle":
    "{count, plural, one {Cette demande est révisée par # réviseur} other {Cette demande est révisée par # réviseurs}}",
  "intake.requesterFlow.exit": "Quitter",
  "intake.requesterFlow.submitNow": "Soumettre maintenant",
  "intake.requesterFlow.stepProgress":
    "Étape {current} sur {total} · {answered} réponses sur {questions}",
  "intake.requesterFlow.answeredProgress": "{answered} réponses sur {questions}",
  "intake.requesterFlow.submitPartialTitle":
    "{count, plural, one {Soumettre avec # question sans réponse ?} other {Soumettre avec # questions sans réponse ?}}",
  "intake.requesterFlow.submitPartialBody":
    "Nous pouvons commencer avec ceci. Chaque réponse ajoutée maintenant est une question de moins à vous reposer.",
  "intake.requesterFlow.submitPartialCancel": "Continuer à remplir",
  "intake.requesterFlow.submitPartialConfirm": "Soumettre quand même",
  "intake.requesterFlow.more": "Plus",
  "intake.requesterFlow.less": "Moins",
  "intake.requesterFlow.reviewersHeading": "Ce qui se passe ensuite",
  "intake.requesterFlow.reviewersDescription": "{names} examinera cette demande.",
  "intake.requesterFlow.nextStepPage": "{names} complète cette étape.",
  "intake.requesterFlow.nextStepReview": "{names} examine cette demande.",
  "intake.requesterFlow.navBack": "Précédent",
  "intake.requesterFlow.navContinue": "Continuer",
  "intake.requesterFlow.navPrevious": "Précédent",
  "intake.requesterFlow.navNext": "Suivant",
  "intake.requesterFlow.navEnd": "Vous avez atteint la fin de ce formulaire.",
  "intake.requesterFlow.navNoPages": "Ce formulaire n'a aucune page à remplir.",
  "intake.requesterFlow.pageIndicator": "Page {current} sur {total}",
  "intake.requesterFlow.validationTitle":
    "Remplissez les champs obligatoires des pages précédentes avant de terminer.",
  "intake.requesterFlow.validationFieldRequired": "{field} est obligatoire",
  "intake.requesterFlow.validationGoToPage": "Aller à la page {page}",
  "intake.requesterFlow.saveDraft": "Enregistrer le brouillon",
  "intake.requesterFlow.savingDraft": "Enregistrement…",
  "intake.requesterFlow.draftSaved": "Brouillon enregistré. Vous seul pouvez le voir.",
  "intake.requesterFlow.draftSaveError": "Échec de l'enregistrement du brouillon.",
  "intake.requesterFlow.draftLoadError": "Échec du chargement de ce brouillon.",
  "intake.requesterFlow.draftDeleteError": "Échec de la suppression du brouillon.",
  "intake.requesterFlow.draftsHeading": "Vos brouillons",
  "intake.requesterFlow.draftUntitled": "Brouillon sans titre",
  "intake.requesterFlow.draftMeta": "{form} · enregistré {updated}",
  "intake.requesterFlow.draftResume": "Reprendre",
  "intake.requesterFlow.draftDelete": "Supprimer le brouillon {name}",

  // Pont intake → projet : liste des projets liés sur le détail de soumission
  "intake.drafts.title": "Projets liés",
  "intake.drafts.createButton": "Convertir en projet",
  "intake.drafts.empty": "Aucun projet pour le moment.",
  "intake.drafts.loading": "Chargement des projets…",
  "intake.drafts.gate.permission":
    "Vous n'avez pas l'autorisation de créer des projets brouillons.",
  "intake.drafts.gate.notCompleted":
    "La soumission doit être à un état terminé avant de pouvoir être convertie.",
  "intake.drafts.status.draft": "Brouillon",
  "intake.drafts.status.published": "Publié",
  "intake.drafts.rowActions.edit": "Modifier",
  "intake.drafts.rowActions.delete": "Supprimer",
  "intake.drafts.delete.title": "Supprimer le projet brouillon ?",
  "intake.drafts.delete.description":
    "Cette action supprimera définitivement le projet brouillon « {name} ».",
  "intake.drafts.delete.confirm": "Supprimer",
  "intake.drafts.delete.success": "Projet brouillon supprimé.",
  "intake.drafts.delete.error": "Échec de la suppression du projet brouillon.",

  // Pont intake → projet : bouton « Créer un projet » réservé au responsable de
  // la demande sur l'onglet Projets liés (NG-701)
  "intake.linkedProjects.createButton": "Créer un projet",
  "intake.linkedProjects.createDisabledUnaccepted":
    "Acceptez d'abord la demande — un projet ne peut être créé qu'à partir d'une demande acceptée.",
  // Pont intake → projet : modale « Lier des projets » (plan-work-rework PR5)
  "intake.linkProjects.openButton": "Lier des projets",
  "intake.linkProjects.title": "Lier des projets existants",
  "intake.linkProjects.description":
    "Sélectionnez un ou plusieurs projets de l'espace de travail à lier à cette demande.",
  "intake.linkProjects.searchPlaceholder": "Rechercher par nom ou identifiant…",
  "intake.linkProjects.empty": "Aucun projet disponible à lier.",
  "intake.linkProjects.loading": "Chargement des projets…",
  "intake.linkProjects.loadMore": "Charger plus",
  "intake.linkProjects.cancel": "Annuler",
  "intake.linkProjects.linkN": "Lier {count} projets",
  "intake.linkProjects.linking": "Liaison en cours…",
  "intake.linkProjects.success": "{count} projets liés.",
  "intake.linkProjects.loadError": "Impossible de charger les projets. Réessayez.",
  "intake.linkProjects.submitError": "Impossible de lier les projets sélectionnés. Réessayez.",
  "intake.linkProjects.requesterWillView": "Le demandeur pourra voir ce projet.",
  "intake.linkProjects.requesterWillViewMany": "Le demandeur pourra voir ces projets.",
  "intake.linkProjects.requesterWillViewDetail": "Restreint aux équipes : {names}",
  "intake.linkProjects.unlink.action": "Délier le projet",
  "intake.linkProjects.unlink.title": "Délier le projet ?",
  "intake.linkProjects.unlink.description":
    "Supprimer le lien entre « {name} » et cette demande ? Le projet lui-même n'est pas supprimé.",
  "intake.linkProjects.unlink.confirm": "Délier",
  "intake.linkProjects.unlink.success": "Projet délié.",
  "intake.linkProjects.unlink.error": "Impossible de délier le projet. Réessayez.",

  // Tableau Projets liés sur l'onglet Projets liés d'une demande.
  "intake.linkedProjects.col.identifier": "ID",
  "intake.linkedProjects.col.name": "Nom du projet",
  "intake.linkedProjects.col.status": "Statut",
  "intake.linkedProjects.col.lead": "Responsable",
  "intake.linkedProjects.col.progress": "Progression",
  "intake.linkedProjects.col.startDate": "Date de début",
  "intake.linkedProjects.col.targetCompletion": "Date de fin cible",
  "intake.linkedProjects.col.actualCompletion": "Date de fin réelle",
  "intake.linkedProjects.rowActions.open": "Ouvrir le projet",
  "intake.linkedProjects.rowActions.menu": "Actions pour {name}",
  "intake.linkedProjects.restricted.tooltip":
    "Ce projet est lié à la demande mais ne vous a pas été partagé.",

  // Pont intake → projet : page de planification (post-brouillon)

  // Pont intake → projet : volet de capacité d'équipe sur la page de planification

  // Paramètres de projet — fonctionnalités
  "project_settings.features.intake.title": "Intake",
  "project_settings.features.intake.description":
    "Autoriser ce projet à être référencé depuis les demandes d'intake.",
  "project_settings.features.intake.toggle": "Activer l'intake pour ce projet",
  "project_settings.features.intake.save_error":
    "Impossible d'enregistrer le paramètre d'intake. Réessayez.",

  // RBAC eligibility
  "rbac.ineligible_assignment":
    "Le rôle de cet utilisateur dans l'espace de travail ne permet pas cette affectation",
  "rbac.role_display.team.lead": "Chef d'équipe",
  "rbac.role_display.team.member": "Membre d'équipe",
  "rbac.role_display.project.lead": "Chef de projet",
  "rbac.role_display.project.member": "Membre du projet",
  "rbac.role_display.workitem.assignee": "Assigné à la tâche",
  "rbac.role_display.request.owner": "Propriétaire de la demande",
  "rbac.role_display.request.reviewer": "Réviseur de la demande",
  "rbac.role_display.request.client": "Client de la demande",
  "rbac.role_display.program.lead": "Responsable de programme",
  "rbac.role_display.goal.lead": "Responsable d'objectif",

  // Team lead badge
  "teams.detail.lead_badge": "Responsable",

  // Capacity v2 (page de capacité refondue)
  "capacity.v2.subline.live_snapshot": "Aperçu en direct",
  "capacity.v2.subline.team_view": "Vue équipe",
  "capacity.v2.action.export": "Exporter",
  "capacity.v2.action.alerts": "Alertes",
  "capacity.v2.action.new_allocation": "Nouvelle allocation",
  "capacity.v2.period.label": "Période",
  "capacity.v2.period.week": "Cette semaine",
  "capacity.v2.period.month": "Mois",
  "capacity.v2.scope.label": "Périmètre",
  "capacity.v2.scope.my_team": "Mon équipe",
  "capacity.v2.scope.all_teams": "Toutes les équipes",
  "capacity.v2.team.all": "Tout",
  "capacity.v2.team.label": "Équipe",
  "capacity.v2.team.pick": "Filtrer par équipe",
  "capacity.v2.team.search": "Rechercher des équipes...",
  "capacity.v2.team.not_found": "Aucune équipe trouvée",
  "capacity.v2.project.all": "Tout",
  "capacity.v2.project.label": "Projet",
  "capacity.v2.project.pick": "Filtrer par projet",
  "capacity.v2.project.search": "Rechercher des projets...",
  "capacity.v2.project.not_found": "Aucun projet trouvé",
  "capacity.v2.filter.exclude_deactivated": "Exclure les utilisateurs désactivés",
  "capacity.v2.kpi.over_allocated": "Sur-alloués",
  "capacity.v2.kpi.over_allocated.caption": ">100 % d'utilisation · à rééquilibrer",
  "capacity.v2.kpi.people": "personnes",
  "capacity.v2.kpi.free_capacity": "Capacité disponible",
  "capacity.v2.kpi.free_capacity.caption": "{count} personnes ont de la marge",
  "capacity.v2.kpi.hours": "heures",
  "capacity.v2.kpi.team_utilization": "Utilisation de l'équipe",
  "capacity.v2.kpi.project_utilization": "Utilisation du projet",
  "capacity.v2.kpi.pts_vs_target": "pts vs cible {target} %",
  "capacity.v2.kpi.trend": "Tendance 8 semaines",
  "capacity.v2.kpi.period_trend": "Tendance de la période",
  "capacity.v2.kpi.trend_tooltip_week": "Semaine du {date}",
  "capacity.v2.kpi.trend_tooltip_hours": "{hours} h / {capacity} h",
  "capacity.v2.wow_short": "SsS",
  "capacity.v2.team_panel.title": "Mon équipe",
  "capacity.v2.team_panel.member_summary": "{total} membres · {over} en sur · {under} en sous",
  "capacity.v2.team_panel.pts_vs_target": "pts vs cible",
  "capacity.v2.team_panel.see_all": "Voir toutes les équipes",
  "capacity.v2.list.title": "Qui est en sur / sous-allocation",
  "capacity.v2.list.of": "sur",
  "capacity.v2.list.empty": "Aucun membre ne correspond au filtre.",
  "capacity.v2.list.loading_more": "Chargement d'autres membres…",
  "capacity.v2.list.scroll_for_more": "Faites défiler pour voir plus",
  "capacity.v2.chip.all": "Tous",
  "capacity.v2.chip.over": "Surchargé",
  "capacity.v2.chip.near_cap": "Proche du seuil",
  "capacity.v2.chip.on_target": "Sur la cible",
  "capacity.v2.chip.under": "Sous la cible",
  "capacity.v2.chip.people": "{count} {count, plural, one {personne} other {personnes}}",
  "capacity.v2.status.over": "Sur",
  "capacity.v2.status.near_cap": "Près du seuil",
  "capacity.v2.status.on_target": "Sur la cible",
  "capacity.v2.status.under": "Sous",
  "capacity.v2.sort.label": "Trier",
  "capacity.v2.sort.utilization_desc": "Utilisation (haut → bas)",
  "capacity.v2.sort.utilization_asc": "Utilisation (bas → haut)",
  "capacity.v2.sort.name_asc": "Nom (A → Z)",
  "capacity.v2.col.member": "Membre",
  "capacity.v2.col.utilization": "Utilisation vs cible {target} %",
  "capacity.v2.col.assigned_avail": "Affecté / Dispo",
  "capacity.v2.col.hours_by_category": "Heures par catégorie",
  "capacity.v2.row.over_by": "+{hours} h dépassement",
  "capacity.v2.row.free": "{hours} h libres",
  "capacity.v2.row.on_target_short": "sur la cible",
  "capacity.v2.category.project": "Projet",
  "capacity.v2.category.event": "Événement",
  "capacity.v2.category.other": "Autre",
  "capacity.v2.category.project_description": "Heures affectées aux tâches d'un projet.",
  "capacity.v2.category.event_description": "Heures affectées aux événements liés à un projet.",
  "capacity.v2.category.other_description":
    "Charge calendaire — réunions, événements applicatifs et événements de calendrier externe non planifiés sur un projet. Les congés et jours fériés sont exclus ; ils réduisent la capacité.",

  // Fil d'Ariane (breadcrumbs)
  // OAuth consent, unavailable and denied pages, and the sign-in brand panel (NG-2581)
  "oauth.consent.loading": "Chargement…",
  "oauth.consent.load_error": "Échec du chargement du contexte de consentement",
  "oauth.consent.no_redirect": "Le serveur n'a pas renvoyé d'URL de redirection.",
  "oauth.consent.network_error": "Erreur réseau",
  "oauth.consent.verified": "Application vérifiée par Cognota",
  "oauth.consent.from_workspace": "De l'espace de travail {workspace}",
  "oauth.consent.requesting": "{app} demande l'accès à votre compte Cognota.",
  "oauth.consent.workspace": "Espace de travail",
  "oauth.consent.choose_workspace": "Choisir un espace de travail",
  "oauth.consent.able_to": "Elle pourra :",
  "oauth.consent.denying": "Refus…",
  "oauth.consent.deny": "Refuser",
  "oauth.consent.approving": "Approbation…",
  "oauth.consent.approve": "Approuver",
  "oauth.unavailable.loading": "Chargement…",
  "oauth.unavailable.invalid_title": "Ce lien n'est plus valide",
  "oauth.unavailable.invalid_description":
    "Essayez de vous reconnecter à l'application depuis sa page principale.",
  "oauth.unavailable.this_app": "cette application",
  "oauth.unavailable.title": "Vous ne pouvez pas utiliser {app} ici",
  "oauth.unavailable.members_only_before": "{app} est réservée aux membres de l'espace de travail ",
  "oauth.unavailable.members_only_after":
    ". Vous n'avez pas accès à cet espace de travail. Si vous pensez qu'il s'agit d'une erreur, demandez à l'administrateur de l'espace de travail de vous ajouter.",
  "oauth.unavailable.no_workspace":
    "{app} n'est disponible pour votre compte dans aucun des espaces de travail dont vous êtes membre.",
  "oauth.unavailable.back": "Retour à {app}",
  "oauth.denied.title": "Accès refusé",
  "oauth.denied.description":
    "Vous avez refusé de partager l'accès avec cette application. Vous pouvez fermer cet onglet et revenir là où vous étiez.",
  "auth.brand.tagline_line1": "Votre plateforme LearnOps®",
  "auth.brand.tagline_line2": "tout-en-un",
  "auth.brand.description":
    "Évaluez la demande, priorisez le bon travail et libérez de la capacité pour exécuter plus efficacement.",
  "auth.signal.region": "À propos de Cognota",
  "auth.signal.headline": "Le {highlight} des équipes d'habilitation des effectifs",
  "auth.signal.headline_highlight": "système d'exploitation",
  "auth.signal.graphic_label":
    "LearnOps® pour la formation, TalentOps pour les talents et HR Ops pour les RH ont chacun leur espace de travail, avec leurs propres flux de travail, gouvernance et coéquipiers numériques, dans un seul écosystème qui donne la visibilité pour diriger et les signaux pour agir.",
  "auth.signal.learnops": "LearnOps®",
  "auth.signal.learnops_for": "Équipes formation",
  "auth.signal.talentops": "TalentOps",
  "auth.signal.talentops_for": "Équipes talents",
  "auth.signal.hrops": "HR Ops",
  "auth.signal.hrops_for": "Équipes RH",
  "auth.signal.ecosystem": "Un seul écosystème",
  "auth.signal.pillar_workflow": "Flux de travail",
  "auth.signal.pillar_workflow_pitch": "Vous dirigez. Cognota fait tourner le processus.",
  "auth.signal.pillar_governance": "Gouvernance",
  "auth.signal.pillar_governance_pitch":
    "La gouvernance des personnes et de l'IA, à toute échelle.",
  "auth.signal.pillar_teammates": "Coéquipiers numériques",
  "auth.signal.pillar_teammates_pitch": "Coéquipiers humains et numériques, une seule équipe.",
  "auth.signal.visibility": "La visibilité pour diriger.",
  "auth.signal.signals": "Les signaux pour agir.",
  "auth.signal.utilization": "Utilisation de l'équipe, 8 dernières semaines",
  "auth.signal.overdue": "Travail en retard et ses responsables",
  "auth.signal.sample_onboarding": "Mise à jour de l'intégration des managers",
  "auth.signal.sample_onboarding_late": "3 jours",
  "auth.signal.sample_compliance": "Cours de conformité T4",
  "auth.signal.sample_compliance_late": "1 jour",
  "auth.continue_with_google": "Continuer avec Google",

  "breadcrumb.teams": "Équipes",
  "breadcrumb.team_settings": "Paramètres",
  "breadcrumb.team_projects": "Projets",
  "breadcrumb.projects": "Projets",
  "breadcrumb.workspace_settings": "Paramètres",
  "breadcrumb.project_settings": "Paramètres",
  "breadcrumb.archived_work_items": "Éléments archivés",
  "breadcrumb.dashboards": "Tableaux de bord",
  "breadcrumb.reports": "Rapports",
  "breadcrumb.reports.teammate": "Reporting Teammate",
  "breadcrumb.dashboards.capacity_report": "Rapport de capacité",
  "breadcrumb.dashboards.capacity_trajectory": "Trajectoire de capacité",
  "breadcrumb.custom_fields": "Champs globaux",
  "breadcrumb.templates": "Modèles de projet",
  "breadcrumb.processes": "Processus",
  "breadcrumb.label": "Fil d'Ariane",
  "breadcrumb.webhooks": "Webhooks",
  "breadcrumb.events": "Évènements",
  "breadcrumb.event_new": "Nouvel évènement",
  "breadcrumb.event_schedule": "Calendrier",
  "breadcrumb.browse": "Tâches",
  "breadcrumb.notifications": "Notifications",
  "breadcrumb.my_work": "Mon travail",
  "breadcrumb.availability": "Disponibilité",
  "breadcrumb.capacity": "Capacité",
  "breadcrumb.project_intake": "Réception",
  "breadcrumb.programs": "Programmes",
  "breadcrumb.program_settings": "Paramètres",
  "timeline.title": "Chronologie",
  "timeline.timezone_label": "Votre fuseau horaire : {timezone}",
  "timeline.action.filter": "Filtrer",
  "timeline.action.export": "Exporter",
  "timeline.action.new_event": "Nouvel événement",
  "timeline.filter.heading": "Filtres",
  "timeline.filter.task_category": "Catégorie de tâche",
  "timeline.filter.event_category": "Catégorie d'événement",
  "timeline.filter.project": "Projet",
  "timeline.filter.all": "Tous",
  "timeline.filter.search_placeholder": "Rechercher…",
  "timeline.filter.empty": "Aucun résultat",
  "timeline.filter.clear": "Effacer",
  "timeline.search_placeholder": "Rechercher des événements et des tâches",
  "timeline.all_day": "Toute la journée",
  // Keep these timeline keys in sync with en.ts; locale-parity.test.ts enforces both directions.
  "timeline.midnight": "Minuit",
  "timeline.archived": "Archivé",
  "timeline.hours_stretched_full_day": "Plage étendue à toute la journée",
  "timeline.outside.before": "{count} avant",
  "timeline.outside.after": "{count} après",
  "timeline.outside.before_hint": "Événements antérieurs aux heures affichées. Les afficher.",
  "timeline.outside.after_hint": "Événements postérieurs aux heures affichées. Les afficher.",
  // NG-2855
  "timeline.edge.range": "{start} au {end}",
  "timeline.edge.before_hint": "Se termine avant cette période. L'afficher.",
  "timeline.edge.after_hint": "Commence après cette période. L'afficher.",
  "timeline.hours_stretched": "Plage étendue à {range}",
  "timeline.hours_reset": "Réinitialiser les heures",
  "timeline.week_ordinal": "Semaine {number}",
  "timeline.group_by": "Grouper par",
  "timeline.group_by.none": "Aucun regroupement",
  "timeline.group_by.user": "Assigné",
  "timeline.group_by.team": "Équipe",
  "timeline.group_by.project": "Projet",
  "timeline.group_by.type": "Type",
  "timeline.group_by.stage": "Étape du processus",
  "timeline.group_by.category": "Catégorie",
  "timeline.bucket.no_category": "Aucune catégorie",
  "timeline.type.events": "Événements",
  "timeline.type.tasks": "Tâches",
  "timeline.type.milestones": "Jalons",
  "timeline.bucket.no_assignee": "Aucun assigné",
  "timeline.bucket.no_team": "Aucune équipe",
  "timeline.bucket.no_project": "Aucun projet",
  "timeline.granularity.day": "Jour",
  "timeline.granularity.week": "Semaine",
  "timeline.granularity.month": "Mois",
  "timeline.today": "Aujourd'hui",
  "timeline.jump_to_date": "Aller à la date",
  "timeline.scroll_back": "Reculer",
  "timeline.scroll_forward": "Avancer",
  "timeline.view_settings": "Paramètres d'affichage",
  "timeline.settings.weekends": "Afficher les week-ends",
  "timeline.settings.weekends_sub": "Afficher les colonnes du samedi et du dimanche",
  "timeline.settings.timeoff": "Afficher les congés",
  "timeline.settings.timeoff_sub": "Indiquer les congés approuvés sur la chronologie",
  "timeline.settings.holidays": "Afficher les jours fériés régionaux",
  "timeline.settings.holidays_sub": "Mettre en évidence les jours fériés observés",
  "timeline.empty.title": "Aucun événement ou tâche planifié dans cette période.",
  "timeline.empty.sub": "Essayez d'effacer votre recherche ou d'ajuster la plage de dates.",
  "timeline.error":
    "Une erreur s'est produite lors du chargement de votre chronologie. Essayez d'actualiser.",
  "timeline.retry": "Réessayer",
  "timeline.panel.event": "Événement",
  "timeline.panel.task": "Tâche",
  "timeline.panel.milestone": "Jalon",
  "timeline.panel.close": "Fermer",
  "timeline.panel.status": "Statut",
  "timeline.panel.status_scheduled": "Planifié",
  "timeline.panel.assignee": "Responsable",
  "timeline.panel.assignees": "Responsables",
  "timeline.panel.project": "Projet",
  "timeline.panel.no_project": "Aucun projet",
  "timeline.panel.start": "Début",
  "timeline.panel.end": "Fin",
  "timeline.panel.description": "Description",
  "timeline.panel.open_event": "Ouvrir l'événement",
  "timeline.panel.open_task": "Ouvrir la tâche",
  "timeline.panel.open_milestone": "Ouvrir le jalon",
  "timeline.panel.edit": "Modifier",
  "timeline.conflict_banner": "Conflit de planification — chevauche un congé approuvé.",
  "timeline.no_permission_tooltip": "Vous n'avez pas la permission de modifier cet élément.",
  "timeline.conflict_dialog.title": "Chevauchement avec un congé",
  "timeline.conflict_dialog.body":
    "Cet élément chevauche le congé de {name} le {dates}. Voulez-vous continuer ?",
  "timeline.conflict_dialog.continue": "Continuer",
  "timeline.conflict_dialog.cancel": "Annuler",
  "timeline.persist_error": "Impossible d'enregistrer les nouvelles dates. Veuillez réessayer.",
  "breadcrumb.new": "Nouveau",
  "breadcrumb.untitled": "Sans titre",

  // App version update
  "version_update.title": "Nouvelle version disponible",
  "version_update.description":
    "Actualisez pour charger la dernière version. Votre session continuera à fonctionner en attendant.",
  "version_update.refresh": "Actualiser",

  // Project template — Workflow tab
  "project_templates.workflow.title": "Flux de travail",
  "project_templates.workflow.description":
    "Les statuts proviennent des statuts de projet de votre espace de travail et sont créés lorsqu’un projet est démarré à partir de ce modèle. Utilisez « Configurer » pour définir vers quels statuts chacun peut passer.",
  "project_templates.workflow.reset_transitions": "Réinitialiser les transitions",
  "project_templates.workflow.default_badge": "Par défaut",
  "project_templates.workflow.empty":
    "Aucun statut de projet configuré pour le moment. Ajoutez-les dans Paramètres → Statuts de projet et ils apparaîtront ici.",
  "project_templates.workflow.reset_confirm_title": "Réinitialiser les transitions ?",
  "project_templates.workflow.reset_confirm_description":
    "Toutes les règles de transition personnalisées seront supprimées. Toutes les transitions de statut deviendront libres.",
  "project_templates.workflow.reset_success": "Transitions réinitialisées.",
  "project_templates.workflow.save_error": "Échec de l’enregistrement du flux de travail.",
  "project_templates.workflow.fetch_error": "Échec du chargement des statuts du projet.",

  // Capacity Planning (People view)
  "capacity_planning.zoom.day": "Jour",
  "capacity_planning.zoom.week": "Semaine",
  "capacity_planning.zoom.month": "Mois",
  "capacity_planning.nav.today": "Aujourd’hui",
  "capacity_planning.nav.earlier": "Avant",
  "capacity_planning.nav.earlier_shortcut": "Avant (Alt+←)",
  "capacity_planning.nav.later": "Après",
  "capacity_planning.nav.later_shortcut": "Après (Alt+→)",
  "capacity_planning.people.column_title": "Personnes",
  "capacity_planning.people.search_placeholder": "Rechercher des personnes…",
  "capacity_planning.people.group_count": "{count} personnes",
  "capacity_planning.filter.label": "Filtrer",
  "capacity_planning.filter.team": "Équipe",
  "capacity_planning.filter.skill": "Qualification",
  "capacity_planning.filter.program": "Programme",
  "capacity_planning.filter.capacity": "Capacité",
  "capacity_planning.filter.bucket_over": "Surchargé",
  "capacity_planning.filter.bucket_near": "Proche de la capacité",
  "capacity_planning.filter.bucket_target": "Dans la cible",
  "capacity_planning.filter.bucket_under": "Sous-utilisé",
  "capacity_planning.filter.job_role": "Rôle métier",
  "capacity_planning.filter.project_status": "Statut du projet",
  "capacity_planning.filter.archived_projects": "Projets archivés",
  "capacity_planning.filter.include_archived": "Inclure les projets archivés",
  "capacity_planning.filter.archived_included": "Archivés inclus",
  "capacity_planning.filter.clear_all": "Tout effacer",
  "capacity_planning.filter.remove": "Retirer le filtre {label}",
  "capacity_planning.sort.label": "Trier par",
  "capacity_planning.sort.name_asc": "Nom (A–Z)",
  "capacity_planning.sort.name_desc": "Nom (Z–A)",
  "capacity_planning.sort.utilization_desc": "Utilisation (la plus élevée)",
  "capacity_planning.sort.room_desc": "Le plus de disponibilité d'abord",
  "capacity_planning.group.label": "Regrouper par",
  "capacity_planning.group.member": "Aucun",
  "capacity_planning.group.team": "Équipe",
  "capacity_planning.group.project": "Projet",
  "capacity_planning.people.project_meta": "{tasks} tâches · {hours}",
  "capacity_planning.people.over_allocated": "Surchargé",
  "capacity_planning.people.toggle_member": "Afficher le travail de {name}",
  "capacity_planning.people.open_task": "Ouvrir {name}",
  "capacity_planning.people.utilization_label": "{pct} % utilisé",
  "capacity_planning.people.loading": "Chargement…",
  "capacity_planning.people.empty": "Aucune personne ne correspond à vos filtres.",
  "capacity_planning.people.empty_no_groups":
    "Aucune \u00e9quipe \u00e0 regrouper pour le moment \u2014 la capacit\u00e9 de cet espace reste disponible.",
  "capacity_planning.people.group_by_person": "Regrouper par personne",
  "capacity_planning.people.load_failed_title": "Impossible de charger la capacité",
  "capacity_planning.people.load_failed_description":
    "La lecture a échoué ou a pris trop de temps, aucun chiffre n'est donc affiché. Réessayez.",
  "capacity_planning.people.load_more": "Charger plus de personnes",
  "capacity_planning.people.legend_hint":
    "Heures engagées par période. Cliquez sur une personne pour voir le travail contributif.",
  "capacity_planning.legend.unconfigured": "Non configuré",
  "capacity_planning.cell.not_applicable": "S/O",
  "capacity_planning.legend.booked": "Heures estimées",
  "capacity_planning.legend.actual": "Heures saisies",
  "capacity_planning.legend.target": "Cible — au-delà de la ligne, la semaine est dans la cible",
  "capacity_planning.legend.free": "Libre, jusqu’aux heures de la semaine",
  "capacity_planning.legend.over": "Dépassement — plafonné, le nombre indique l’écart",
  "capacity_planning.legend.off": "Absence",
  "capacity_planning.insights.utilization": "Utilisation",
  "capacity_planning.insights.utilization_caption": "{planned} h sur {capacity} h de capacité",
  "capacity_planning.insights.no_capacity": "Aucune capacité configurée sur cette période",
  "capacity_planning.insights.trend": "Tendance d’utilisation",
  "capacity_planning.insights.balance": "Équilibre de charge",
  "capacity_planning.insights.balance_even": "Bien répartie",
  "capacity_planning.insights.balance_uneven": "Quelques déséquilibres",
  "capacity_planning.insights.balance_poor": "Répartition inégale",
  "capacity_planning.insights.balance_empty":
    "Nécessite au moins deux personnes avec du travail planifié",
  "capacity_planning.insights.accuracy": "Précision des estimations",
  "capacity_planning.insights.accuracy_caption": "Saisi vs estimé · 30 derniers jours",
  "capacity_planning.insights.accuracy_empty": "Aucune heure saisie au cours des 30 derniers jours",
  "capacity_planning.member_panel.title": "Membre de l’équipe",
  "capacity_planning.member_panel.weekly_cap": "Cap. hebdo",
  "capacity_planning.member_panel.active_items": "Éléments actifs",
  "capacity_planning.member_panel.issues_label":
    "{count, plural, one {# problème de surcharge} other {# problèmes de surcharge}} sur cette période",
  "capacity_planning.member_panel.over_by": "{hours} au-dessus de la capacité par période (pic)",
  "capacity_planning.member_panel.replace_with": "Remplacer par",
  "capacity_planning.member_panel.pick_person": "Choisir une personne…",
  "capacity_planning.member_panel.search_people": "Rechercher des personnes…",
  "capacity_planning.member_panel.no_candidates": "Aucune personne correspondante.",
  "capacity_planning.member_panel.candidate_select_label": "Choisir qui reprend {task}",
  "capacity_planning.member_panel.candidate_free": "{hours} disponibles sur la période de la tâche",
  "capacity_planning.member_panel.candidate_hours_not_set": "Heures non définies",
  "capacity_planning.member_panel.assign": "Assigner",
  "capacity_planning.member_panel.reassigned_to": "Réassigné à {name}",
  "capacity_planning.member_panel.reassigned_toast": "Assignation mise à jour.",
  "capacity_planning.member_panel.reassign_error": "Impossible de mettre à jour l’assignation.",
  "capacity_planning.member_panel.assigned_label": "Travail assigné",
  "capacity_planning.member_panel.assigned_empty": "Aucun travail assigné sur cette période.",
  "capacity_planning.member_panel.col_item": "Élément",
  "capacity_planning.member_panel.col_dates": "Dates",
  "capacity_planning.member_panel.col_estimated": "Est.",
  "capacity_planning.member_panel.col_logged": "Saisi",
  "capacity_planning.member_panel.total_label": "Total",
  "capacity_planning.member_panel.daily_label": "Quotidien",
  "capacity_planning.member_panel.per_day": "{hours}/jour",
  "capacity_planning.actuals.toggle": "Heures affichées",
  "capacity_planning.actuals.estimated": "Estimées",
  "capacity_planning.actuals.actual": "Réelles",
  "capacity_planning.actuals.node_title": "Estimé {estimated} · Saisi {logged}",
  "capacity_planning.bar_drag.rescheduled": "Dates mises à jour.",
  "capacity_planning.bar_drag.undo": "Annuler",
  "capacity_planning.bar_drag.reschedule_error": "Impossible de mettre à jour les dates.",
  "capacity_planning.bar_menu.open_details": "Ouvrir les détails",
  "capacity_planning.bar_menu.unassign": "Désassigner cette personne",
  "capacity_planning.bar_menu.unassigned": "Assignation retirée.",
  "capacity_planning.bar_menu.unassign_error": "Impossible de retirer l'assignation.",
  "capacity_planning.bar_drag.reassigned": "Assignation mise à jour.",
  "capacity_planning.bar_drag.reassign_error": "Impossible de mettre à jour l’assignation.",
  "capacity_planning.risks.badge_label": "{count} risque",
  "capacity_planning.risks.badge_label_plural": "{count} risques",
  "capacity_planning.risks.panel_title": "Risques de capacité",
  "capacity_planning.risks.severity_high": "Élevé",
  "capacity_planning.risks.severity_medium": "Moyen",
  "capacity_planning.risks.type_pto_conflict": "Conflit de congé",
  "capacity_planning.risks.type_over_allocation": "Sur-allocation",
  "capacity_planning.risks.type_capacity_gap": "Manque de capacité",
  "capacity_planning.risks.badge_aria":
    "{count, plural, one {# risque de capacit\u00e9 sur ce projet} other {# risques de capacit\u00e9 sur ce projet}}",
  "capacity_planning.risks.strip_title":
    "{count, plural, one {# risque de capacité dans cette période} other {# risques de capacité dans cette période}}",
  "capacity_planning.risks.new": "nouveau",
  "capacity_planning.risks.more": "+{count} autres",
  "capacity_planning.risks.capped": "Les risques couvrent les 25 plus grands projets affichés",
  "capacity_planning.risks.chip_over_allocation":
    "{name} · {days} jours en dépassement · pointe {pct}",
  "capacity_planning.risks.chip_over_allocation_consecutive":
    "{name} · {days} jours consécutifs en dépassement · pointe {pct}",
  "capacity_planning.risks.chip_capacity_gap":
    "{project} · {left} restantes contre {free} libres sur cette période · échéance le {date}",
  "capacity_planning.risks.chip_pto_conflict":
    "{name} · {blocked} jours bloqués sur {total} ({pct} %)",

  // Scan-first People view (2026-09-03)
  "capacity_planning.scan.legend_room": "{count} en disponibilité · {hours} h libres",
  "capacity_planning.scan.legend_at_capacity": "{count} dans la cible",
  "capacity_planning.scan.legend_over": "{count} en dépassement · {hours} h en trop",
  "capacity_planning.scan.legend_not_configured": "{count} non configurés",
  "capacity_planning.scan.header_person_role_eyebrow": "Personne / rôle",
  "capacity_planning.scan.person_external_assignee": "Ressource externe",
  "capacity_planning.scan.person_weekly_hours": "{hours} h/sem.",
  "capacity_planning.scan.action_set_hours": "Définir les heures",
  "capacity_planning.scan.set_hours_member_error":
    "Cette personne n'est pas encore membre de cet espace de travail ; ses heures ne peuvent pas être définies ici.",
  "capacity_planning.scan.set_hours_lookup_error":
    "Nous n'avons pas pu charger les membres de cet espace de travail ; ses heures ne peuvent pas être ouvertes. Réessayez.",
  "capacity_planning.scan.action_assign": "Assigner",
  "capacity_planning.scan.action_rebalance": "Réaffecter le travail",
  "capacity_planning.scan.team_collapse": "Réduire {name}",
  "capacity_planning.scan.team_expand": "Développer {name}",
  "capacity_planning.scan.member_collapse": "Réduire {name}",
  "capacity_planning.scan.member_expand": "Développer {name}",
  "capacity_planning.scan.team_over_count": "{count} en dépassement",
  "capacity_planning.scan.team_shown_count": "{shown} sur {total}",
  "capacity_planning.scan.team_member_total": "{count}",
  "capacity_planning.scan.team_band_placeholder": "Développer pour voir la répartition par état",
  "capacity_planning.scan.show_more_people": "Afficher {count} personnes de plus",
  "capacity_planning.scan.show_more_groups": "Afficher plus",
  "capacity_planning.scan.show_more_tasks": "Afficher plus de tâches",
  "capacity_planning.scan.cell_not_applicable": "Sans objet",
  "capacity_planning.scan.cell_off": "Absent",
  "capacity_planning.scan.cell_blocked": "{hours} h bloquées",
  "capacity_planning.scan.cell_booked_off": "réservé pendant l’absence",
  "capacity_planning.scan.cell_on_target": "dans la cible",
  "capacity_planning.scan.cell_to_target": "{hours} h avant la cible",
  "capacity_planning.unstaffed.row_label": "Non attribué",
  "capacity_planning.unstaffed.row_subtitle":
    "{count, plural, one {# élément} other {# éléments}} · {hours} h · {roles, plural, one {# rôle} other {# rôles}}",
  "capacity_planning.unstaffed.expand": "Développer le travail non attribué",
  "capacity_planning.unstaffed.collapse": "Réduire le travail non attribué",
  "capacity_planning.unstaffed.short": "{hours} h manquantes",
  "capacity_planning.unstaffed.fits": "Absorbable",
  "capacity_planning.unstaffed.detail": "demande {demand} h · {free} h libres dans les bons rôles",
  "capacity_planning.unstaffed.cell_short": "{hours} h sans personne pour les prendre",
  "capacity_planning.unstaffed.cell_fits": "tient dans les heures libres des bons rôles",
  "capacity_planning.unstaffed.needs_role": "requiert {role}",
  "capacity_planning.unstaffed.no_holders": "Personne n’a ce rôle",
  "capacity_planning.unstaffed.team_short": "{hours} h non attribuées manquantes",
  "capacity_planning.unstaffed.strip_short":
    "{hours} h non attribuées · {short} h sans personne pour les prendre",
  "capacity_planning.unstaffed.strip_fits":
    "{hours} h non attribuées · tout pourrait être attribué aujourd’hui",
  "capacity_planning.scan.no_allocations": "Aucune affectation dans cette période.",
  "capacity_planning.scan.other_project": "Autre",
  "capacity_planning.scan.project_summary":
    "{count, plural, one {# tâche} other {# tâches}} · {hours}",
  "capacity_planning.headroom.header_estimated": "Heures estimées",
  "capacity_planning.headroom.header_actual": "Heures réelles",
  "capacity_planning.headroom.over": "{hours} h en dépassement",
  "capacity_planning.headroom.free": "{hours} h libres",
  "capacity_planning.headroom.of_total": "{used} h sur {total} h",
  "capacity_planning.headroom.target_line": "cible {target} %",
  "capacity_planning.headroom.not_set": "Non défini",
  "capacity_planning.headroom.group_over": "{over} en dépassement · {ok} avec de la capacité",
  "capacity_planning.headroom.group_ok":
    "{count, plural, one {# avec de la capacité} other {# avec de la capacité}}",
  "capacity_planning.headroom.group_not_set": "{count} non configurés",
  "capacity_planning.rebalance.apply_caveat":
    "L’application enregistre chaque affectation comme un changement distinct, annulable tâche par tâche.",
  "capacity_planning.rebalance.title": "Réaffecter le travail de {name} · {range}",
  "capacity_planning.rebalance.title_loading": "Réaffecter le travail",
  "capacity_planning.rebalance.description":
    "Retirer au moins {hours} à cette personne sur la période. Seuls son équipe et cette période sont pris en compte ; rien d’autre ne change.",
  "capacity_planning.rebalance.description_loading": "Recherche de ce qui pourrait bouger.",
  "capacity_planning.rebalance.loading": "Recherche de plans…",
  "capacity_planning.rebalance.strategy_fewest_moves": "Le moins de déplacements",
  "capacity_planning.rebalance.strategy_skill_fit": "Meilleure adéquation des qualifications",
  "capacity_planning.rebalance.strategy_most_even": "Le plus équilibré",
  "capacity_planning.rebalance.strategy_summary":
    "{count, plural, one {# tâche} other {# tâches}} · {hours} déplacées",
  "capacity_planning.rebalance.strategy_same": "Même plan qu’une autre option",
  "capacity_planning.rebalance.moves_heading": "Déplacements",
  "capacity_planning.rebalance.receiver_detail":
    "{free} libres · {matched} qualification(s) sur {required}",
  "capacity_planning.rebalance.before_after_heading": "{range}, avant et après",
  "capacity_planning.rebalance.of_max": "sur {max} · cible {target}",
  "capacity_planning.rebalance.cancel": "Annuler",
  "capacity_planning.rebalance.apply": "Réaffecter {count, plural, one {# tâche} other {# tâches}}",
  "capacity_planning.rebalance.applied":
    "{count, plural, one {# tâche réaffectée} other {# tâches réaffectées}}",
  "capacity_planning.rebalance.apply_error": "Certains déplacements n’ont pas pu être enregistrés",
  "capacity_planning.rebalance.best_effort_title":
    "Une partie de ce travail ne tient dans l’agenda de personne",
  "capacity_planning.rebalance.best_effort_body":
    "Ces déplacements utilisent toutes les heures libres de l’équipe. Les {remaining} restantes demandent une date plus tardive ou une autre équipe.",
  "capacity_planning.rebalance.infeasible_title":
    "Personne dans l’équipe ne peut prendre {hours} sur cette période",
  "capacity_planning.rebalance.infeasible_body":
    "Chaque déplacement possible met quelqu’un en dépassement. Le plan le plus proche laisse encore {remaining} de dépassement.",
  "capacity_planning.rebalance.infeasible_no_tasks":
    "Rien ne peut bouger ici : {shared, plural, =0 {aucune tâche à assigné unique sur la période} one {la seule tâche est partagée} other {les # tâches sont partagées}}.",
  "capacity_planning.rebalance.free_heading": "Libre sur {range}, dans les rôles requis",
  "capacity_planning.rebalance.free_hours": "{hours} libres",
  "capacity_planning.rebalance.infeasible_next":
    "Ce qui fonctionnerait : déplacer une date cible, emprunter à une autre équipe, ou laisser le dépassement volontairement pour que la cellule rouge et l’alerte continuent de le signaler.",
  "capacity_planning.rebalance.unmovable_title":
    "Aucun plan ne peut déplacer {hours} de ce dépassement",
  "capacity_planning.rebalance.unmovable_body":
    "Il s’agit de travail déjà commencé, partagé ou rattaché à une autre équipe, ou d’absences. Pour le résorber, replanifiez ou réaffectez ce travail vous-même.",
  "capacity_planning.cell.aria": "{bucket} : {booked} h réservées sur {capacity} h, {delta}",
  "capacity_planning.week_popover.over": "{hours} h en dépassement",
  "capacity_planning.week_popover.on_target": "dans la cible",
  "capacity_planning.week_popover.to_target": "{hours} h avant la cible",
  "capacity_planning.week_popover.figure_booked": "Réservé",
  "capacity_planning.week_popover.figure_available": "Disponible",
  "capacity_planning.week_popover.figure_target": "Cible",
  "capacity_planning.week_popover.figure_target_value": "{hours} h · {pct} %",
  "capacity_planning.week_popover.figure_blocked": "Bloqué",
  "capacity_planning.week_popover.figure_blocked_reason": "{hours} · {reason}",
  "capacity_planning.week_popover.peak_day":
    "Jour de pointe {day} · {hours} h sur {capacity} h ({pct})",
  "capacity_planning.week_popover.open_week": "Ouvrir la semaine de {firstName}",
  "capacity_planning.week_popover.estimated_split":
    "Répartition estimée des heures de l’élément de travail sur ses dates",
  "capacity_planning.week_popover.restricted_item": "Élément de travail restreint",
  "capacity_planning.week_popover.time_off": "Absence",
  "capacity_planning.week_popover.holiday": "Jour férié",
  "capacity_planning.week_popover.calendar_blocked": "Calendrier bloqué",
  "capacity_planning.week_popover.non_working_day": "Absence",
  "capacity_planning.week_popover.available": "Disponible",
  "capacity_planning.week_popover.fully_utilized": "Dans la cible",
  "capacity_planning.week_popover.over_capacity": "En dépassement",
  "capacity_planning.week_popover.no_configured_capacity": "Non défini",
  "capacity_planning.week_popover.not_in_scope": "Hors périmètre",

  // Job roles (Rôles métier)
  "workspace_settings.tabs.job_roles": "Rôles métier",
  "workspace_settings.members.job_role_label": "Rôle métier",
  "workspace_settings.members.job_role_none": "Aucun",
  "workspace_settings.members.job_role_updated": "Rôle métier du membre mis à jour",
  "workspace_settings.members.job_role_update_error": "Échec de la mise à jour du rôle métier",
  "workspace_settings.job_roles.title": "Rôles métier",
  "workspace_settings.job_roles.description":
    "Définissez les rôles métier disponibles dans votre espace de travail. Les rôles métier dotent les projets et les tâches à la place d'une personne.",
  "workspace_settings.job_roles.create_action": "Ajouter un rôle métier",
  "workspace_settings.job_roles.search_placeholder": "Rechercher des rôles métier…",
  "workspace_settings.job_roles.search_clear": "Effacer la recherche",
  "workspace_settings.job_roles.column_job_role": "Rôle métier",
  "workspace_settings.job_roles.column_members": "Membres",
  "workspace_settings.job_roles.column_status": "Statut",
  "workspace_settings.job_roles.column_actions": "Actions",
  "workspace_settings.job_roles.member_count": "{count, plural, one {# membre} other {# membres}}",
  "workspace_settings.job_roles.name_edit_hint": "Renommer",
  "workspace_settings.job_roles.status_active": "Actif",
  "workspace_settings.job_roles.status_inactive": "Inactif",
  "workspace_settings.job_roles.toggle_status_label": "Modifier le statut de {name}",
  "workspace_settings.job_roles.row_actions_label": "Actions pour {name}",
  "workspace_settings.job_roles.empty": "Aucun rôle métier pour le moment.",
  "workspace_settings.job_roles.edit": "Modifier",
  "workspace_settings.job_roles.delete": "Supprimer",
  "workspace_settings.job_roles.deactivate": "Désactiver",
  "workspace_settings.job_roles.delete_confirm_title": "Supprimer le rôle métier",
  "workspace_settings.job_roles.delete_confirm_description":
    "Supprimer le rôle métier « {name} » ? Toute tâche qui lui est assignée deviendra non assignée.",
  "workspace_settings.job_roles.delete_success": "Rôle métier supprimé",
  "workspace_settings.job_roles.delete_error": "Échec de la suppression du rôle métier",
  "workspace_settings.job_roles.deactivate_confirm_title": "Désactiver le rôle métier",
  "workspace_settings.job_roles.deactivate_confirm_description":
    "Désactiver « {name} » ? Cela retire le rôle métier de tous les utilisateurs et de toutes les tâches.",
  "workspace_settings.job_roles.status_error": "Échec de la modification du statut du rôle métier",
  "workspace_settings.job_roles.editor_create_title": "Ajouter un rôle métier",
  "workspace_settings.job_roles.editor_edit_title": "Modifier le rôle métier",
  "workspace_settings.job_roles.editor_description":
    "Nommez le rôle métier, choisissez une couleur et décrivez son objet.",
  "workspace_settings.job_roles.name_label": "Nom",
  "workspace_settings.job_roles.name_placeholder": "ex. Concepteur pédagogique",
  "workspace_settings.job_roles.color_label": "Couleur",
  "workspace_settings.job_roles.description_label": "Description",
  "workspace_settings.job_roles.members_label": "Membres",
  "workspace_settings.job_roles.members_placeholder": "Assigner des membres…",
  "workspace_settings.job_roles.members_search_placeholder": "Rechercher des membres…",
  "workspace_settings.job_roles.members_empty": "Aucun membre éligible",
  "workspace_settings.job_roles.members_hint":
    "Les invités ne peuvent pas détenir de rôle métier et ne sont pas listés.",
  "workspace_settings.job_roles.members_edit_label": "Modifier les membres de {name}",
  "workspace_settings.job_roles.members_loading": "Chargement des membres…",
  "workspace_settings.job_roles.members_save": "Enregistrer",
  "workspace_settings.job_roles.members_update_success": "Membres mis à jour",
  "workspace_settings.job_roles.members_update_error": "Échec de la mise à jour des membres",
  "workspace_settings.job_roles.cancel": "Annuler",
  "workspace_settings.job_roles.update": "Mettre à jour le rôle métier",
  "workspace_settings.job_roles.create": "Ajouter un rôle métier",
  "workspace_settings.job_roles.saving": "Enregistrement…",
  "workspace_settings.job_roles.update_success": "Rôle métier mis à jour",
  "workspace_settings.job_roles.create_success": "Rôle métier créé",
  "workspace_settings.job_roles.update_error": "Échec de la mise à jour du rôle métier",
  "workspace_settings.job_roles.create_error": "Échec de la création du rôle métier",
  "workspace_settings.job_roles.rates.section_label": "Taux horaire",
  "workspace_settings.job_roles.rates.add_label": "Ajouter un taux",
  "workspace_settings.job_roles.rates.hourly_rate_label": "Taux horaire",
  "workspace_settings.job_roles.rates.add_button": "Ajouter le taux",
  "workspace_settings.job_roles.rates.add_hint":
    "Le nouveau taux prend effet aujourd'hui. Pour définir un taux antérieur, ajoutez-le, puis modifiez la date sur sa ligne ci-dessous. Le taux de ce rôle sert à estimer le coût du travail attribué au rôle.",
  "workspace_settings.job_roles.rates.history_label": "Historique des taux",
  "workspace_settings.job_roles.rates.empty":
    "Aucun taux défini. Le travail attribué à ce rôle est estimé à 0 tant qu'aucun taux n'est ajouté.",
  "workspace_settings.job_roles.rates.per_hour": "{amount} / h",
  "workspace_settings.job_roles.rates.delete_aria": "Supprimer le taux en vigueur le {date}",
  "workspace_settings.job_roles.rates.edit_effective_aria":
    "Modifier la date d'effet (actuellement {date})",
  "workspace_settings.job_roles.rates.loading": "Chargement des taux…",
  "workspace_settings.job_roles.rates.load_error": "Impossible de charger les taux.",
  "workspace_settings.job_roles.rates.invalid_rate": "Saisissez un taux de 0 ou plus.",
  "workspace_settings.job_roles.rates.saved": "Taux enregistré",
  "workspace_settings.job_roles.rates.save_error": "Impossible d'enregistrer le taux.",
  "workspace_settings.job_roles.rates.update_error": "Impossible de mettre à jour le taux.",
  "workspace_settings.job_roles.rates.delete_error": "Impossible de supprimer le taux.",
  "workspace_settings.job_roles.rates.create_hint":
    "Facultatif — prend effet aujourd'hui. Si vous le laissez vide, le travail attribué à ce rôle est estimé à 0 jusqu'à l'ajout d'un taux.",
  "workspace_settings.job_roles.rates.create_save_error":
    "Le rôle métier a été créé, mais son taux n'a pas pu être enregistré. Ajoutez-le depuis l'éditeur du rôle.",
  "profile_settings.preferences.job_role_label": "Rôle métier",
  "profile_settings.preferences.job_role_none": "Aucun",
  "workspace_settings.templates.workitem.job_role_label": "Rôle métier par défaut",
  "workspace_settings.templates.workitem.job_role_none": "Aucun",
  "workspace_settings.templates.workitem.job_role_edit_aria": "Modifier le rôle métier pour {name}",
  "workspace_settings.templates.workitem.stage_edit_aria": "Modifier l'étape pour {name}",
  "workspace_settings.templates.workitem.category_edit_aria": "Modifier la catégorie pour {name}",
  "workspace_settings.templates.workitem.job_role_search_placeholder":
    "Rechercher des rôles métier",
  "workspace_settings.templates.workitem.job_role_empty": "Aucun rôle métier trouvé",
  "issue.job_role_picker.section": "Rôle métier",
  "smart_assignment.title": "Assignation intelligente",
  "smart_assignment.subtitle": "des rôles métier attendent encore une personne assignée",
  "smart_assignment.work_summary": "{count, plural, one {# tâche} other {# tâches}}",
  "smart_assignment.date_range": "{start} – {end}",
  "smart_assignment.using_project_dates": "selon les dates du projet",
  "smart_assignment.other_options": "Autres options",
  "smart_assignment.choose_person": "Choisir une personne",
  "smart_assignment.people_loading": "Chargement des personnes…",
  "smart_assignment.people_error": "Impossible de charger les personnes. Fermez et réessayez.",
  "smart_assignment.no_candidates": "Personne dans l'équipe de livraison ne détient ce rôle.",
  "smart_assignment.assign_action": "Assigner",
  "smart_assignment.assigning": "Assignation…",
  "smart_assignment.assign_success":
    "{name} assigné à {count, plural, one {# tâche} other {# tâches}}",
  "smart_assignment.assign_error": "Échec de l'assignation du travail du rôle métier",
  "smart_assignment.over_alloc_title": "{name} sera en surcapacité",
  "smart_assignment.over_alloc_description":
    "Assigner l'ensemble des {count, plural, one {# tâche} other {# tâches}} à {name} le met en surcapacité pour les dates du travail. Assigner quand même ?",
  "smart_assignment.assign_anyway": "Assigner quand même",

  // CSV importer (NG-645)
  "csv_importer.step.instructions": "Instructions",
  "csv_importer.issue.transform_error": "Impossible de lire « {field} ».",
  "csv_importer.step.upload": "Téléverser",
  "csv_importer.step.mapping": "Associer les colonnes",
  "csv_importer.step.values": "Associer les valeurs",
  // Sous-titre de l'étape « Associer les valeurs » lorsqu'il n'y a rien à associer,
  // afin que l'étape reste dans la barre (numérotation fixe) tout en se lisant comme
  // déjà traitée (NG-2343).
  "csv_importer.step.values_skipped": "Rien à associer",
  "csv_importer.step.review": "Vérifier",
  "csv_importer.cancel": "Annuler",
  "csv_importer.back": "Retour",
  "csv_importer.next": "Suivant",
  // Affiché lorsque fermer la fenêtre d'import jetterait un fichier téléversé et
  // son mappage de colonnes (NG-2339). Rien n'a encore été enregistré, d'où la
  // réassurance dans le corps.
  "csv_importer.discard.title": "Abandonner cet import ?",
  "csv_importer.discard.body":
    "Vous perdrez votre fichier téléversé et tout mappage de colonnes. Rien n'a encore été importé.",
  "csv_importer.discard.keep": "Continuer la modification",
  "csv_importer.discard.confirm": "Abandonner et fermer",
  "csv_importer.upload.title": "Téléverser un fichier CSV ou Excel",
  "csv_importer.upload.subtitle":
    "Jusqu'à {maxMb} Mo. Le fichier est lu dans votre navigateur et n'est jamais téléversé.",
  // La carte du fichier chargé, après un retour à l'étape de téléversement (NG-2344).
  "csv_importer.upload.file_rows": "{count, plural, one {# ligne} other {# lignes}}",
  "csv_importer.upload.file_columns": "{count, plural, one {# colonne} other {# colonnes}}",
  "csv_importer.upload.replace": "Remplacer le fichier",
  "csv_importer.upload.remove": "Retirer",
  "csv_importer.upload.replace_confirm_title": "Remplacer le fichier ?",
  "csv_importer.upload.replace_confirm_body": "Vos associations de colonnes seront réinitialisées.",
  "csv_importer.upload.remove_confirm_title": "Retirer le fichier ?",
  "csv_importer.upload.remove_confirm_body": "Vos associations de colonnes seront réinitialisées.",
  "csv_importer.upload.choose_file": "Choisir un fichier",
  "csv_importer.upload.parsing": "Lecture du fichier…",
  "csv_importer.upload.template_hint": "Format incertain ?",
  "csv_importer.upload.download_template": "Télécharger le modèle",
  "csv_importer.upload.download_template_xlsx": "Télécharger le modèle Excel",
  "csv_importer.upload.error_too_large":
    "Ce fichier dépasse {maxMb} Mo. Choisissez un fichier plus petit.",
  "csv_importer.upload.error_no_headers":
    "Ce fichier n'a pas de ligne d'en-tête. Ajoutez-en une et réessayez.",
  "csv_importer.upload.error_empty": "Ce fichier ne contient aucune ligne de données.",
  "csv_importer.upload.error_parse_failed":
    "Impossible de lire ce fichier. Vérifiez qu'il s'agit d'un CSV valide et réessayez.",
  "csv_importer.upload.error_too_many_rows":
    "Ce fichier contient plus de {maxRows, number} lignes. Divisez-le en fichiers plus petits et importez-les un par un.",
  "csv_importer.upload.error_unsupported_file_type":
    "Ce type de fichier ne peut pas être importé. Téléversez un fichier CSV ou Excel (.xlsx).",
  "csv_importer.mapping.instructions":
    "Associez chaque colonne de votre fichier à un champ. Les colonnes non associées sont ignorées.",
  "csv_importer.mapping.showing_sheet": "Feuille affichée : {name}",
  "csv_importer.mapping.ignore": "Ignorer cette colonne",
  "csv_importer.mapping.map_aria": "Associer la colonne « {header} » à un champ",
  // Barre de résumé + pastilles de statut (NG-2347).
  "csv_importer.mapping.summary": "{count, plural, one {# colonne} other {# colonnes}}",
  "csv_importer.mapping.summary_file":
    "{count, plural, one {# colonne} other {# colonnes}} dans {file}",
  "csv_importer.mapping.count_matched": "{count} associées",
  "csv_importer.mapping.count_ignored": "{count} ignorées",
  "csv_importer.mapping.count_attention": "{count} à corriger",
  // Vérification des champs obligatoires.
  "csv_importer.mapping.required_check_title":
    "Champs obligatoires · {mapped} sur {total} associés",
  "csv_importer.mapping.required_unmapped": "{label} — aucune colonne associée",
  // Onglets de filtre + recherche.
  "csv_importer.mapping.filter_aria": "Filtrer les colonnes par statut",
  "csv_importer.mapping.filter_all": "Toutes",
  "csv_importer.mapping.filter_attention": "À corriger",
  "csv_importer.mapping.filter_ignored": "Ignorées",
  "csv_importer.mapping.filter_matched": "Associées",
  "csv_importer.mapping.search_placeholder": "Rechercher une colonne ou un champ",
  "csv_importer.mapping.no_matches": "Aucune colonne ne correspond.",
  // En-têtes de groupe + pastilles de statut.
  "csv_importer.mapping.group_attention": "À corriger",
  "csv_importer.mapping.group_ignored": "Ignorées",
  "csv_importer.mapping.group_matched": "Associées",
  "csv_importer.mapping.status_matched": "Associée",
  "csv_importer.mapping.status_ignored": "Ignorée",
  "csv_importer.mapping.status_attention": "À corriger",
  // Indices de ligne.
  "csv_importer.mapping.hint_duplicate":
    "{field} est aussi associé depuis « {other} ». Choisissez-en une.",
  "csv_importer.mapping.hint_suggestion": "Ces valeurs ressemblent à {field}.",
  "csv_importer.mapping.suggestion_action": "Associer à {field}",
  "csv_importer.mapping.hint_ignored_by_user": "Ignorée. Ne sera pas importée.",
  "csv_importer.mapping.hint_no_match": "Aucun champ correspondant. Ne sera pas importée.",
  "csv_importer.mapping.sample": "p. ex. {value}",
  "csv_importer.mapping.sample_empty": "Aucune valeur d'exemple",
  "csv_importer.mapping.custom_field_tag": "· champ personnalisé",
  // Sélecteur de champ.
  "csv_importer.mapping.meta_required": "Obligatoire",
  "csv_importer.mapping.meta_custom": "Champ personnalisé",
  "csv_importer.mapping.meta_used_by": "Utilisé par « {header} »",
  "csv_importer.mapping.picker_search": "Rechercher un champ",
  "csv_importer.mapping.picker_empty": "Aucun champ ne correspond.",
  // Raison affichée quand Suivant est bloqué (NG-2347).
  "csv_importer.mapping.fix_to_continue":
    "Corrigez {count, plural, one {# colonne} other {# colonnes}} pour continuer",
  "csv_importer.mapping.map_required_to_continue":
    "Associez tous les champs obligatoires pour continuer",
  "csv_importer.values.instructions":
    "Certaines valeurs de votre fichier ne correspondent à aucune option du formulaire. Associez-les à une option, ou laissez-les non associées pour que la cellule soit signalée.",
  "csv_importer.values.unmapped":
    "{count, plural, one {# valeur n'est associée à aucune option} other {# valeurs ne sont associées à aucune option}}",
  // Combien de lignes les valeurs encore non associées concernent, pour que l'admin
  // mesure le travail (NG-2342). Affiché à côté du nombre de non-associées et mis à
  // jour au fur et à mesure des associations.
  "csv_importer.values.affected":
    "Elles concernent {count, plural, one {# ligne} other {# lignes}}.",
  "csv_importer.values.unmapped_hint":
    "Les valeurs non associées sont importées telles quelles et signalées ligne par ligne à l'étape suivante.",
  // Nombre de lignes par valeur, à côté de chaque valeur non associée, p. ex. « Learning Design · 8 lignes ».
  "csv_importer.values.value_rows": "{count, plural, one {# ligne} other {# lignes}}",
  "csv_importer.values.leave_unmapped": "Laisser non associée",
  "csv_importer.values.no_match": "Aucune option correspondante",
  "csv_importer.values.map_aria": "Associer la valeur « {value} » de {field} à une option",
  "csv_importer.review.summary": "{total, plural, one {# ligne} other {# lignes}}",
  // Le même badge une fois que la limite de lignes a tronqué le fichier (NG-1474).
  "csv_importer.review.summary_truncated":
    "{kept, number} sur {total, plural, one {# ligne} other {# lignes}}",
  "csv_importer.review.valid": "{count, plural, one {# valide} other {# valides}}",
  "csv_importer.review.invalid": "{count, plural, one {# invalide} other {# invalides}}",
  "csv_importer.review.with_warnings":
    "{count, plural, one {# avec avertissements} other {# avec avertissements}}",
  "csv_importer.review.import": "Importer {count, plural, one {# ligne} other {# lignes}}",
  "csv_importer.review.import_pending": "Importer",
  "csv_importer.review.col_row": "Ligne",
  // Le cadre du rapport de l'étape Vérification (NG-1389).
  "csv_importer.review.title": "Vérifiez votre fichier",
  "csv_importer.review.outcome":
    "{valid, plural, one {# ligne sur {total, number} sera importée.} other {# lignes sur {total, number} seront importées.}}",
  // Non préfixé par `.review.` : les étapes de correspondance l'affichent aussi,
  // pour que l'admin sache que le fichier a été tronqué avant de le mapper
  // (NG-1474).
  "csv_importer.over_limit":
    "Votre fichier contient {total, number} lignes, ce qui dépasse la limite de {max, number} lignes. {dropped, plural, one {La dernière ligne ne sera pas importée — placez-la dans un second fichier et importez-le également.} other {Les # dernières lignes ne seront pas importées — placez-les dans un second fichier et importez-le également.}}",
  "csv_importer.over_limit_title": "Votre fichier dépasse la limite de lignes",
  "csv_importer.review.errors_heading": "Lignes qui ne seront pas importées",
  "csv_importer.review.warnings_heading": "Lignes qui seront importées avec des avertissements",
  "csv_importer.review.dataset_heading": "Problèmes dans le fichier",
  "csv_importer.row_line": "Ligne {row} : {message}",
  "csv_importer.review.row_status_error": "Contient des erreurs",
  "csv_importer.review.row_status_warning": "Contient des avertissements",
  "csv_importer.dialog.title": "Importer depuis un CSV",
  // Le cadre du rapport commun à tous les imports (NG-1307).
  "csv_importer.result.title": "Import terminé",
  "csv_importer.result.errors_heading": "Lignes qui n'ont pas pu être importées",
  "csv_importer.result.import_another": "Importer un autre fichier",
  "csv_importer.result.done": "Terminé",
  // Le bandeau lecture seule d'un élément consultable mais non modifiable (NG-1872).
  "read_only_banner.why": "Pourquoi ?",
  "read_only_banner.request.title": "Vous pouvez consulter cette demande, mais pas la modifier.",
  "read_only_banner.request.reason_with_role":
    "Votre rôle, {role}, permet de consulter les demandes, mais pas de les modifier.",
  "read_only_banner.request.reason":
    "Votre rôle permet de consulter les demandes, mais pas de les modifier.",
  "read_only_banner.request.recourse":
    "Pour changer quelque chose, demandez à un responsable de la demande de faire la modification, ou à un administrateur de l'espace de travail de mettre à jour votre rôle.",
  "read_only_banner.project.title": "Vous pouvez consulter ce projet, mais pas le modifier.",
  "read_only_banner.project.reason_with_role":
    "Votre rôle, {role}, permet de consulter les projets, mais pas de les modifier.",
  "read_only_banner.project.reason":
    "Votre rôle permet de consulter les projets, mais pas de les modifier.",
  "read_only_banner.project.recourse":
    "Pour changer quelque chose, demandez à un responsable du projet de faire la modification, ou à un administrateur de l'espace de travail de mettre à jour votre rôle.",
  "read_only_banner.program.title": "Vous pouvez consulter ce programme, mais pas le modifier.",
  "read_only_banner.program.reason_with_role":
    "Votre rôle, {role}, permet de consulter les programmes, mais pas de les modifier.",
  "read_only_banner.program.reason":
    "Votre rôle permet de consulter les programmes, mais pas de les modifier.",
  "read_only_banner.program.recourse":
    "Pour changer quelque chose, demandez à un responsable du programme de faire la modification, ou à un administrateur de l'espace de travail de mettre à jour votre rôle.",
  "read_only_banner.work_item.title":
    "Vous pouvez consulter cet élément de travail, mais pas le modifier.",
  "read_only_banner.work_item.reason_with_role":
    "Votre rôle, {role}, permet de consulter les éléments de travail, mais pas de les modifier.",
  "read_only_banner.work_item.reason":
    "Votre rôle permet de consulter les éléments de travail, mais pas de les modifier.",
  "read_only_banner.work_item.recourse":
    "Pour changer quelque chose, demandez à une personne assignée de faire la modification, ou à un administrateur de l'espace de travail de mettre à jour votre rôle.",

  // Team roster field (NG-2161): a team picker whose selection lists one Home team.
  "team_roster.home_lock_reason":
    "L'équipe principale ne peut pas être retirée. Définissez d'abord une autre équipe principale.",
  "team_roster.footer_note":
    "L'équipe principale est propriétaire de ce projet et ne peut pas être retirée. Définissez d'abord une autre équipe comme principale.",
  "team_roster.footer_note_program":
    "L'équipe principale est propriétaire de ce programme et ne peut pas être retirée. Définissez d'abord une autre équipe comme principale.",
  "team_roster.home_lock_reason_fixed":
    "L'équipe principale ne peut pas être retirée. Seule une équipe dont vous faites partie peut être principale.",
  "team_roster.footer_note_fixed":
    "L'équipe principale est propriétaire de ce projet et ne peut pas être retirée. Seule une équipe dont vous faites partie peut en être l'équipe principale.",
  "team_roster.footer_note_program_fixed":
    "L'équipe principale est propriétaire de ce programme et ne peut pas être retirée. Seule une équipe dont vous faites partie peut en être l'équipe principale.",
  "team_roster.save_error": "Échec de la mise à jour des équipes du projet",
  "team_roster.home_badge": "Principale",
  "team_roster.set_home": "Définir comme principale",
  "team_roster.set_home_aria": "Définir comme principale : {name}",

  // Upload limits (NG-3279)
  "uploads.too_large": "Ce fichier dépasse la limite de {limit}.",
  "uploads.type_not_allowed": "Ce type de fichier n'est pas accepté ici. Autorisés : {types}.",
  "uploads.progress": "{percent} % téléversé",

  // Backoffice admin portal shell (NG-3425, epic NG-252)
  "backoffice.brand": "cognota",
  "backoffice.pill": "Backoffice",
  "backoffice.nav.aria": "Navigation du Backoffice",
  "backoffice.nav.workspaces": "Espaces de travail",
  "backoffice.nav.audit_log": "Journal d'audit",
  "backoffice.nav.staff_and_roles": "Personnel et rôles",
  "backoffice.nav.section.clients": "Clients",
  "backoffice.nav.section.actions": "Actions",
  "backoffice.nav.section.admin": "Administration",
  "backoffice.nav.accounts": "Comptes",
  "backoffice.nav.provision_workspace": "Provisionner un espace de travail",
  "backoffice.nav.temporary_access": "Accès temporaire",
  "backoffice.search.label": "Recherche du Backoffice",
  "backoffice.search.placeholder": "Rechercher des espaces de travail et des utilisateurs",
  "backoffice.search.title": "Recherche",
  "backoffice.search.title_for": 'Résultats pour "{query}"',
  "backoffice.search.prompt":
    "Saisissez un nom ou un identifiant d'espace de travail, ou le nom ou l'e-mail d'un utilisateur, dans la barre de recherche.",
  "backoffice.search.workspaces": "Espaces de travail",
  "backoffice.search.users": "Utilisateurs",
  "backoffice.search.workspaces_empty": "Aucun espace de travail ne correspond.",
  "backoffice.search.users_empty": "Aucun utilisateur ne correspond.",
  "backoffice.search.workspaces_more":
    "Affichage des {count} premiers. Affinez la recherche ou ouvrez la liste des espaces de travail.",
  "backoffice.search.users_more":
    "Affichage des {count} premiers. Affinez la recherche, par exemple avec l'e-mail complet.",
  "backoffice.search.view_all_workspaces": "Ouvrir la liste des espaces de travail",
  "backoffice.search.user_workspaces": "Espaces de travail de {email}",
  "backoffice.search.user_open_person": "Voir la personne et changer le courriel",
  "backoffice.person.not_found": "Personne introuvable.",
  "backoffice.person.load_error": "Impossible de charger cette personne.",
  "backoffice.person.retry": "Réessayer",
  "backoffice.person.verified": "Courriel vérifié",
  "backoffice.person.not_verified": "Courriel non vérifié",
  "backoffice.person.email_heading": "Courriel de connexion",
  "backoffice.person.email_note":
    "Le courriel d'une personne est sa connexion à tous les espaces de travail dont elle fait partie. Un code est envoyé à la nouvelle adresse, et le courriel ne change qu'une fois le code saisi.",
  "backoffice.person.super_admin_only":
    "Seul un super administrateur peut changer le courriel d'une personne.",
  "backoffice.person.workspaces_heading": "Espaces de travail dont la connexion change ({count})",
  "backoffice.person.change_email.button": "Changer le courriel",
  "backoffice.person.change_email.title": "Changer le courriel de {email}",
  "backoffice.person.change_email.description":
    "Change le courriel de connexion du compte de cette personne. Le changement s'applique dans chaque espace de travail ci-dessous, et le journal d'audit de chacun consigne la raison.",
  "backoffice.person.change_email.new_email": "Nouvelle adresse courriel",
  "backoffice.person.change_email.affected":
    "Espaces de travail dont la connexion change ({count})",
  "backoffice.person.change_email.and_more": "et {count} de plus",
  "backoffice.person.change_email.send_code": "Envoyer le code",
  "backoffice.person.change_email.code_title": "Saisissez le code envoyé à {email}",
  "backoffice.person.change_email.code_description":
    "Demandez à la personne de vous lire le code à 6 chiffres reçu à la nouvelle adresse. Il ne sert qu'une fois et expire dans {minutes} minutes. Le courriel change à la saisie, et les deux adresses sont informées.",
  "backoffice.person.change_email.code_label": "Code",
  "backoffice.person.change_email.confirm": "Changer le courriel",
  "backoffice.users.email_super_admin_only":
    "Seul un super administrateur peut changer un courriel.",
  "backoffice.users.email_loading": "Vérification de la possibilité de changer le courriel...",
  "backoffice.users.email_several_workspaces":
    "Cette personne fait partie de {count} espaces de travail, et son courriel est la même connexion dans chacun.",
  "backoffice.users.email_change_for_person": "Changer le courriel de cette personne",
  "backoffice.search.user_no_workspaces": "N'est membre d'aucun espace de travail.",
  "backoffice.search.user_workspaces_show_all": "Afficher les {count} espaces de travail",
  "backoffice.search.user_workspaces_load_more": "{shown} sur {count} affichés. Afficher la suite",
  "backoffice.search.user_workspaces_error": "Impossible de charger les espaces de travail.",
  "backoffice.search.member_deactivated": "Désactivé ici",
  "backoffice.search.error": "La recherche a échoué.",
  "backoffice.search.retry": "Réessayer",
  "backoffice.profile.menu": "Menu du compte de {name}, {role}",
  "backoffice.not_available.title": "Le Backoffice n'est pas disponible",
  "backoffice.not_available.body": "Cette zone n'est pas activée pour cet environnement.",
  "backoffice.sign_in.title": "Se connecter au Backoffice",
  "backoffice.sign_in.google": "Continuer avec Google",
  "backoffice.env_title": "{env} · Backoffice",
  "backoffice.sign_out": "Se déconnecter",
  "backoffice.nav.coming_soon": "Bientôt",

  // Temporary access (NG-3417)
  "backoffice.access.title": "Accès temporaire",
  "backoffice.access.subtitle":
    "Accès limité dans le temps aux espaces de travail des clients. Chaque accès prend fin de lui-même.",
  "backoffice.access.unavailable": "L'accès temporaire n'est pas activé pour vous.",
  "backoffice.access.get": "Obtenir un accès",
  "backoffice.access.get_here": "Obtenir un accès temporaire",
  "backoffice.access.col_workspace": "Espace de travail",
  "backoffice.access.col_staff": "Membre du personnel",
  "backoffice.access.col_level": "Accès",
  "backoffice.access.col_reason": "Motif",
  "backoffice.access.col_ends": "Fin",
  "backoffice.access.col_actions": "Actions",
  "backoffice.access.level_read_only": "Lecture seule",
  "backoffice.access.level_admin": "Administrateur",
  "backoffice.access.level_read_only_description": "Tout voir, ne rien modifier.",
  "backoffice.access.level_admin_description":
    "Faire des modifications comme administrateur de l'espace de travail.",
  "backoffice.access.level_admin_not_allowed":
    "Seuls CS/AM et Super Admin peuvent demander l'accès Administrateur.",
  "backoffice.access.scopes_legend": "Ce que Claude peut configurer",
  "backoffice.access.scopes_hint":
    "Portées de configuration pour la connexion MCP pendant cet accès. Ne cochez rien pour un support ordinaire.",
  "backoffice.access.scopes_needs_admin": "Nécessite un accès Administrateur",
  "backoffice.access.scopes_loading": "Chargement des portées de configuration",
  "backoffice.access.scopes_error":
    "Impossible de charger les portées de configuration. L'accès peut tout de même commencer sans elles.",
  "backoffice.access.ends_at": "{time} · {remaining}",
  "backoffice.access.left_expired": "se termine",
  "backoffice.access.left_under_minute": "moins d'une minute restante",
  "backoffice.access.left_minutes": "{minutes} min restantes",
  "backoffice.access.left_hours": "{hours} h {minutes} min restantes",
  "backoffice.access.enter": "Entrer dans l'espace de travail",
  "backoffice.access.enter_aria": "Entrer dans {name}",
  "backoffice.access.end": "Terminer",
  "backoffice.access.end_aria": "Terminer maintenant l'accès à {name}",
  "backoffice.access.end_dialog_title": "Terminer l'accès à {name}",
  "backoffice.access.end_dialog_body": "{person} perd l'accès immédiatement.",
  "backoffice.access.end_dialog_confirm": "Terminer l'accès",
  "backoffice.access.enter_failed":
    "Impossible d'ouvrir l'espace de travail. Réessayez « Entrer dans l'espace de travail ».",
  "backoffice.access.started_not_entered":
    "L'accès a démarré, mais l'espace de travail ne s'est pas ouvert. Utilisez « Entrer dans l'espace de travail » pour réessayer.",
  "backoffice.access.error": "Impossible de charger l'accès temporaire.",
  "backoffice.access.empty_title": "Personne n'a d'accès temporaire",
  "backoffice.access.empty_body": "Les accès apparaissent ici tant qu'ils sont actifs.",
  "backoffice.access.total": "{count} accès actifs",
  "backoffice.access.dialog_title": "Obtenir un accès temporaire",
  "backoffice.access.dialog_title_for": "Obtenir un accès temporaire à {name}",
  "backoffice.access.dialog_description":
    "Vous entrez en tant que Cognota Support. L'accès prend fin de lui-même.",
  "backoffice.access.dialog_confirm": "Démarrer l'accès",
  "backoffice.access.workspace_search": "Trouver un espace de travail",
  "backoffice.access.workspace_placeholder": "Rechercher par nom ou identifiant",
  "backoffice.access.workspace_results": "Espaces de travail correspondants",
  "backoffice.access.workspace_none": "Aucun espace de travail ne correspond.",
  "backoffice.access.workspace_error": "Impossible de rechercher les espaces de travail.",
  "backoffice.access.workspace_change": "Changer",
  "backoffice.access.duration_legend": "Durée",
  "backoffice.access.duration_1h": "1 heure",
  "backoffice.access.duration_4h": "4 heures",
  "backoffice.access.duration_end_of_day": "Fin de journée",
  "backoffice.access.duration_24h": "24 heures",
  "backoffice.access.duration_hint":
    "24 heures est le maximum. Vous pouvez partir plus tôt à tout moment.",
  "backoffice.access.level_legend": "Niveau d'accès",
  "backoffice.access.summary_before": "Les personnes de l'espace de travail voient une étiquette",
  "backoffice.access.tag": "Cognota Support",
  "backoffice.access.summary_after":
    "à côté de votre nom. Vous ne comptez pas dans les licences, et personne ne peut vous @mentionner ni vous assigner du travail. L'accès est consigné dans les deux journaux d'audit.",
  "backoffice.access.section": "Accès temporaire",
  "backoffice.access.section_body": "Qui a accès à cet espace de travail en ce moment.",
  "backoffice.access.section_empty": "Personne n'a d'accès temporaire en ce moment.",
  "backoffice.audit.action.workspace.support_access.granted": "Accès temporaire accordé",
  "backoffice.audit.action.workspace.support_access.ended": "Accès temporaire terminé",
  "backoffice.audit.action.workspace.support_access.expired": "Accès temporaire expiré",
  "backoffice.audit.action.workspace.support_access.entered": "Accès temporaire utilisé",
  "backoffice.audit.target.support_grant": "Accès temporaire",
  "backoffice.staff.permissions.support_access_read": "Voir les accès temporaires actifs",
  "backoffice.staff.permissions.support_access_request":
    "Demander un accès temporaire en lecture seule",
  "backoffice.staff.permissions.support_access_request_admin":
    "Demander un accès temporaire Administrateur",
  "backoffice.staff.permissions.support_access_end": "Terminer tout accès temporaire",
  "backoffice.role.backoffice_super_admin": "Super administrateur",
  "backoffice.role.backoffice_cs_am": "CS/AM",
  "backoffice.role.backoffice_support": "Support",
  "backoffice.sign_in.retry": "Réessayer",
  "backoffice.sign_in.lost_access": "Accès perdu ? Demandez à un super administrateur.",
  "backoffice.sign_in.error.google_not_configured":
    "La connexion Google n'est pas configurée pour cet environnement.",
  "backoffice.sign_in.error.google_state_invalid":
    "Cette tentative de connexion a expiré. Réessayez.",
  "backoffice.sign_in.error.google_provider_error":
    "Google n'a pas pu terminer la connexion. Réessayez.",
  "backoffice.sign_in.error.email_not_verified": "Votre adresse Google n'est pas vérifiée.",
  "backoffice.sign_in.error.domain_not_allowed": "Utilisez votre compte Google @cognota.com.",
  "backoffice.sign_in.error.not_authorized":
    "Ce compte n'est pas un membre du personnel Backoffice. Demandez à un super administrateur.",
  "backoffice.sign_in.error.mfa_invalid_code":
    "Ce code n'est pas valide. Vérifiez-le et réessayez.",
  "backoffice.sign_in.error.mfa_locked": "Trop de codes erronés. Reconnectez-vous avec Google.",
  "backoffice.sign_in.error.mfa_unavailable":
    "La configuration de l'authentificateur est indisponible pour le moment.",
  "backoffice.sign_in.error.unknown": "Une erreur s'est produite. Réessayez.",
  "backoffice.sign_in.mfa.setup_title": "Configurer votre authentificateur",
  "backoffice.sign_in.mfa.setup_body":
    "Scannez ce code QR avec une application d'authentification, puis saisissez le code à 6 chiffres affiché.",
  "backoffice.sign_in.mfa.qr_alt": "Code QR de l'authentificateur",
  "backoffice.sign_in.mfa.manual_secret":
    "Impossible de scanner ? Saisissez ce secret manuellement :",
  "backoffice.sign_in.mfa.one_password":
    "Enregistrez-le dans 1Password : ajoutez le secret à votre identifiant Cognota Backoffice comme mot de passe à usage unique.",
  "backoffice.sign_in.mfa.confirm_label": "Code à 6 chiffres",
  "backoffice.sign_in.mfa.verify_title": "Saisissez votre code",
  "backoffice.sign_in.mfa.verify_body":
    "Saisissez le code à 6 chiffres de votre application d'authentification.",
  "backoffice.sign_in.mfa.code_label": "Code à 6 chiffres",
  "backoffice.sign_in.mfa.submit": "Vérifier",
  "backoffice.reason_dialog.close": "Fermer",
  "backoffice.reason_dialog.cancel": "Annuler",
  "backoffice.reason_dialog.reason_label": "Motif",
  "backoffice.reason_dialog.reason_placeholder": "Pourquoi faites-vous ce changement ?",
  "backoffice.reason_dialog.reason_hint":
    "Obligatoire. Consigné dans le journal d'audit. {max} caractères au maximum.",
  "backoffice.reason_dialog.error.unknown": "Une erreur s'est produite. Réessayez.",
  "backoffice.staff.removed": "Retiré",
  "backoffice.staff.loading": "Chargement du personnel",
  "backoffice.staff.empty": "Aucun membre du personnel ne correspond à ces filtres.",
  "backoffice.staff.never_signed_in": "Jamais",
  "backoffice.staff.column.name": "Nom",
  "backoffice.staff.column.role": "Rôle Backoffice",
  "backoffice.staff.column.mfa": "Vérification en deux étapes",
  "backoffice.staff.column.last_sign_in": "Dernière connexion",
  "backoffice.staff.column.actions": "Actions",
  "backoffice.staff.search.label": "Rechercher du personnel",
  "backoffice.staff.search.placeholder": "Nom ou courriel",
  "backoffice.staff.search.clear": "Effacer la recherche",
  "backoffice.staff.filter.role": "Rôle Backoffice",
  "backoffice.staff.filter.all_roles": "Tous les rôles",
  "backoffice.staff.filter.mfa": "Vérification en deux étapes",
  "backoffice.staff.filter.all_mfa": "Toutes",
  "backoffice.staff.filter.include_removed": "Inclure le personnel retiré",
  "backoffice.staff.no_access.title": "Vous n'avez pas accès à Personnel et rôles",
  "backoffice.staff.no_access.body":
    "Seul un super administrateur peut gérer le personnel. Adressez-vous à lui pour toute modification.",
  "backoffice.staff.add.button": "Ajouter un membre du personnel",
  "backoffice.staff.add.title": "Ajouter un membre du personnel",
  "backoffice.staff.add.description":
    "La personne se connecte avec Google et configure son authentificateur à la première connexion.",
  "backoffice.staff.add.confirm": "Ajouter",
  "backoffice.staff.add.email": "Courriel",
  "backoffice.staff.add.name": "Nom",
  "backoffice.staff.add.role": "Rôle",
  "backoffice.staff.change_role.title": "Changer le rôle de {name}",
  "backoffice.staff.change_role.role": "Rôle",
  "backoffice.staff.change_role.confirm": "Changer le rôle",
  "backoffice.staff.action.offboard": "Gérer le départ",
  "backoffice.staff.action.offboard_for": "Gérer le départ de {name}",
  "backoffice.staff.workspace_accounts.button": "Personnel Cognota dans les espaces clients",
  "backoffice.offboard.title": "Départ de {name}",
  "backoffice.offboard.description":
    "Retire son accès au Backoffice, réinitialise sa vérification en deux étapes, met fin à tout accès temporaire et désactive les comptes d'espace de travail laissés cochés. Son historique d'audit est conservé.",
  "backoffice.offboard.confirm": "Confirmer le départ",
  "backoffice.offboard.loading": "Recherche de ses comptes d'espace de travail",
  "backoffice.offboard.load_failed": "Impossible de charger ses comptes d'espace de travail.",
  "backoffice.offboard.staff_active":
    "Accès au Backoffice : {role}. Il est retiré et sa vérification en deux étapes est réinitialisée.",
  "backoffice.offboard.staff_none":
    "Cette personne ne figure pas dans Personnel et rôles : il n'y a aucun accès au Backoffice à retirer.",
  "backoffice.offboard.owners_title": "Espaces dont elle est propriétaire ({count})",
  "backoffice.offboard.owners_body":
    "Ces comptes possèdent leur espace de travail. Les désactiver laisse l'espace sans propriétaire tant qu'un nouveau n'est pas ajouté ; ajoutez-en un d'abord si possible (les contrôles du propriétaire de l'espace). Décochez ceux que vous voulez laisser actifs.",
  "backoffice.offboard.workspaces_title": "Comptes d'espace de travail ({count})",
  "backoffice.offboard.workspaces_none":
    "Aucun espace de travail client n'a de compte pour cette personne.",
  "backoffice.offboard.selected": "{selected} sur {total} sélectionnés",
  "backoffice.offboard.select_all": "Sélectionner tous les comptes d'espace de travail",
  "backoffice.offboard.select_row": "Désactiver {email} dans {workspace}",
  "backoffice.offboard.col.workspace": "Espace de travail",
  "backoffice.offboard.col.type": "Type",
  "backoffice.offboard.col.role": "Rôle",
  "backoffice.offboard.col.account": "Courriel du compte",
  "backoffice.offboard.already_deactivated": "Déjà désactivé",
  "backoffice.offboard.owner": "Propriétaire",
  "backoffice.staff.error.cannot_offboard_self":
    "Vous ne pouvez pas gérer votre propre départ. Demandez à un autre Super Admin.",
  "backoffice.staff.error.account_not_matched":
    "Un des comptes sélectionnés n'appartient pas à cette personne. Rechargez et réessayez.",
  "backoffice.staff.error.not_a_cognota_address":
    "Seules les adresses @cognota.com peuvent faire l'objet d'un départ.",
  "backoffice.staff_accounts.title": "Personnel Cognota dans les espaces clients",
  "backoffice.staff_accounts.subtitle":
    "Tous les comptes @cognota.com des espaces de travail clients, avec leur dernière connexion. Retrouvez une personne qui est partie et gérez son départ.",
  "backoffice.staff_accounts.back": "Retour à Personnel et rôles",
  "backoffice.staff_accounts.search_label": "Rechercher des comptes",
  "backoffice.staff_accounts.search_placeholder": "Courriel ou nom",
  "backoffice.staff_accounts.search_clear": "Effacer la recherche",
  "backoffice.staff_accounts.former":
    "Seulement les personnes qui ne sont plus dans Personnel et rôles",
  "backoffice.staff_accounts.col.account": "Compte",
  "backoffice.staff_accounts.col.workspaces": "Espaces de travail",
  "backoffice.staff_accounts.col.last_login": "Dernière connexion",
  "backoffice.staff_accounts.col.staff": "Personnel et rôles",
  "backoffice.staff_accounts.col.actions": "Actions",
  "backoffice.staff_accounts.workspaces_count": "{active} actifs sur {total}",
  "backoffice.staff_accounts.on_staff": "Dans le personnel",
  "backoffice.staff_accounts.not_on_staff": "Hors du personnel",
  "backoffice.staff_accounts.never": "Jamais",
  "backoffice.staff_accounts.person": "Personne : {email}",
  "backoffice.staff_accounts.offboard": "Gérer le départ",
  "backoffice.staff_accounts.offboard_for": "Gérer le départ de {email}",
  "backoffice.staff_accounts.empty_title": "Aucun compte",
  "backoffice.staff_accounts.empty_body": "Aucun compte @cognota.com ne correspond à ces filtres.",
  "backoffice.staff_accounts.error": "Impossible de charger les comptes.",
  "backoffice.staff_accounts.total": "{count} comptes",
  "backoffice.staff_accounts.no_access_title": "Vous n'avez pas accès à cette vue",
  "backoffice.staff_accounts.no_access_body":
    "Seul un Super Admin peut voir le personnel Cognota dans les espaces clients ou gérer son départ.",
  "backoffice.audit.action.workspace.user_offboarded":
    "Compte du personnel désactivé lors d'un départ",
  "backoffice.audit.action.backoffice.staff.offboarded": "Départ d'un membre du personnel",
  "backoffice.staff.action.remove_access": "Retirer l'accès au Backoffice",
  "backoffice.staff.remove_access.explainer":
    "Retire uniquement cette connexion au Backoffice. Ses comptes d'espace de travail client ne changent pas. Pour gérer le départ d'une personne qui quitte Cognota, utilisez Gérer le départ.",
  "backoffice.staff.remove_access.title": "Retirer l'accès au Backoffice de {name}",
  "backoffice.staff.remove_access.description":
    "{email} perd l'accès au Backoffice et sa vérification en deux étapes est réinitialisée. Ses comptes d'espace de travail client et tout autre dossier du personnel ne changent pas.",
  "backoffice.staff.remove_access.confirm": "Retirer l'accès",
  "backoffice.staff.error.cannot_remove_self":
    "Vous ne pouvez pas retirer votre propre accès au Backoffice. Demandez à un autre Super Admin.",
  "backoffice.staff.reset_mfa.title": "Réinitialiser l'AMF de {name}",
  "backoffice.staff.reset_mfa.description":
    "Son authentificateur est effacé et ses sessions prennent fin. Elle en configure un nouveau à sa prochaine connexion.",
  "backoffice.staff.reset_mfa.confirm": "Réinitialiser l'AMF",
  "backoffice.staff.action.change_role": "Changer le rôle",
  "backoffice.staff.action.change_role_for": "Changer le rôle de {name}",
  "backoffice.staff.action.reset_mfa": "Réinitialiser l'AMF",
  "backoffice.staff.action.reset_mfa_for": "Réinitialiser l'AMF de {name}",
  "backoffice.staff.error.load_failed": "Impossible de charger le personnel.",
  "backoffice.staff.error.last_super_admin":
    "Il doit rester au moins un super administrateur actif.",
  "backoffice.staff.error.staff_exists": "Cette personne fait déjà partie du personnel.",
  "backoffice.staff.error.role_unchanged": "C'est déjà son rôle.",
  "backoffice.staff.error.staff_inactive": "Ce membre du personnel a été retiré.",
  "backoffice.staff.error.staff_email_not_allowed":
    "Seules les adresses courriel @cognota.com peuvent être ajoutées.",
  "backoffice.staff.permissions.title": "Ce que chaque rôle peut faire",
  "backoffice.staff.permissions.setup_user":
    "Ajouter et remettre des utilisateurs « Configurés par Cognota »",
  "backoffice.staff.permissions.owner_manage":
    "Changer, retirer ou désactiver le propriétaire d'un espace de travail",
  "backoffice.staff.permissions.email_suppression":
    "Activer ou désactiver les courriels de notification d'un espace de travail",
  "backoffice.staff.permissions.yes": "Oui",
  "backoffice.staff.permissions.no": "Non",
  "backoffice.staff.title_count_one": "{count} membre du personnel",
  "backoffice.staff.title_count_other": "{count} membres du personnel",
  "backoffice.staff.today": "Aujourd'hui, {time}",
  "backoffice.staff.subtitle":
    "Qui peut utiliser le backoffice et ce que chacun peut faire. Les rôles se gèrent ici, pas dans Google.",
  "backoffice.staff.mfa.set_up": "Configurée",
  "backoffice.staff.mfa.waiting": "En attente de configuration",
  "backoffice.staff.mfa.never": "Jamais connecté",
  "backoffice.staff.column.action": "Action",
  "backoffice.staff.action.edit": "Modifier",
  "backoffice.staff.action.edit_for": "Modifier {name}",
  "backoffice.staff.edit.title": "Modifier {name}",
  "backoffice.staff.edit.description":
    "Chaque changement demande une raison et est consigné dans le journal d'audit.",
  "backoffice.staff.edit.close": "Fermer",
  "backoffice.staff.permissions.permission": "Permission",
  "backoffice.staff.permissions.allowed": "Autorisé",
  "backoffice.staff.permissions.not_allowed": "Non autorisé",
  "backoffice.staff.permissions.workspace_read": "Rechercher et consulter les espaces de travail",
  "backoffice.staff.permissions.audit_read": "Lire et exporter le journal d'audit",
  "backoffice.staff.permissions.workspace_type_change": "Changer le type d'espace de travail",
  "backoffice.staff.permissions.staff_manage":
    "Gérer le personnel, les rôles et les réinitialisations d'AMF",
  "backoffice.staff.permissions.staff_offboard":
    "Gérer le départ du personnel et voir ses comptes dans les espaces clients",
  "backoffice.audit.export": "Exporter en CSV",
  "backoffice.audit.export_cap":
    "L'export contient les {count} événements les plus récents qui correspondent aux filtres.",
  "backoffice.audit.export_failed": "Échec de l'export : {error}",
  "backoffice.audit.search": "Rechercher motif, cible, personnel ou espace de travail",
  "backoffice.audit.clear_search": "Effacer la recherche",
  "backoffice.audit.filter.action": "Action",
  "backoffice.audit.filter.all_actions": "Toutes les actions",
  "backoffice.audit.filter.staff": "Membre du personnel",
  "backoffice.audit.filter.all_staff": "Tout le monde",
  "backoffice.audit.filter.from": "Du",
  "backoffice.audit.filter.to": "Au",
  "backoffice.audit.filter.from_typed": "Du (saisir une date)",
  "backoffice.audit.filter.to_typed": "Au (saisir une date)",
  "backoffice.audit.subtitle": "Chaque action du backoffice, qui l'a effectuée et pourquoi.",
  "backoffice.audit.search_placeholder": "Raison, cible, personnel ou espace de travail",
  "backoffice.audit.filter.search": "Rechercher",
  "backoffice.audit.filter.range": "Période",
  "backoffice.audit.filter.range_any": "Toute la période",
  "backoffice.audit.filter.range_last_7": "7 derniers jours",
  "backoffice.audit.filter.range_last_30": "30 derniers jours",
  "backoffice.audit.filter.range_last_90": "90 derniers jours",
  "backoffice.audit.filter.range_custom": "Personnalisée",
  "backoffice.audit.filter.clear": "Effacer les filtres",
  "backoffice.audit.loading": "Chargement du journal d'audit",
  "backoffice.audit.retry": "Réessayer",
  "backoffice.audit.error.load": "Impossible de charger le journal d'audit : {error}",
  "backoffice.audit.error.unknown": "Une erreur s'est produite.",
  "backoffice.audit.empty.title": "Aucun événement d'audit",
  "backoffice.audit.empty.none": "Rien n'a encore été enregistré.",
  "backoffice.audit.empty.filtered": "Aucun événement ne correspond à ces filtres.",
  "backoffice.audit.col.when": "Date",
  "backoffice.audit.col.staff": "Membre du personnel",
  "backoffice.audit.col.action": "Action",
  "backoffice.audit.col.target": "Cible",
  "backoffice.audit.col.workspace": "Espace de travail",
  "backoffice.audit.col.reason": "Motif",
  "backoffice.audit.col.change": "Changement",
  "backoffice.audit.expand": "Afficher l'avant et l'après complets",
  "backoffice.audit.collapse": "Masquer l'avant et l'après complets",
  "backoffice.audit.before": "Avant",
  "backoffice.audit.after": "Après",
  "backoffice.audit.more": "+{count} de plus",
  "backoffice.audit.range": "{first}–{last} sur {total}",
  "backoffice.audit.prev": "Précédent",
  "backoffice.audit.next": "Suivant",
  "backoffice.audit.target.staff_member": "Membre du personnel",
  "backoffice.audit.target.workspace": "Espace de travail",
  "backoffice.audit.action.backoffice.staff.signed_in": "Connexion du personnel",
  "backoffice.audit.action.backoffice.staff.signed_out": "Déconnexion du personnel",
  "backoffice.audit.action.backoffice.staff.test_sign_in": "Connexion de test du personnel",
  "backoffice.audit.action.backoffice.staff.super_admin_bootstrapped":
    "Super administrateur initialisé",
  "backoffice.audit.action.backoffice.staff.added": "Membre du personnel ajouté",
  "backoffice.audit.action.backoffice.staff.role_changed": "Rôle du personnel modifié",
  "backoffice.audit.action.backoffice.staff.removed": "Membre du personnel retiré",
  "backoffice.audit.action.backoffice.staff.mfa_reset": "AMF du personnel réinitialisée",
  "backoffice.audit.action.workspace.type_changed": "Type d'espace de travail modifié",
  "backoffice.audit.action.workspace.email_suppression_changed":
    "Suppression des e-mails de l'espace de travail modifiée",
  "backoffice.audit.action.workspace.ai_features_changed":
    "Fonctionnalités d'IA de l'espace de travail modifiées",
  "backoffice.reason.label": "Motif",
  "backoffice.reason.hint": "Obligatoire. Il est enregistré dans le journal d'audit. {count}/{max}",
  "backoffice.reason.cancel": "Annuler",
  "backoffice.reason.working": "En cours…",
  "backoffice.reason.error_with_code": "{message} ({code})",
  "backoffice.workspace_type.customer_production": "Client : production",
  "backoffice.workspace_type.customer_sandbox": "Client : bac à sable",
  "backoffice.workspace_type.trial": "Essai / POC",
  "backoffice.workspace_type.demo_sales": "Démo (ventes)",
  "backoffice.workspace_type.internal": "Interne / QA",
  "backoffice.workspaces.title": "Espaces de travail",
  "backoffice.workspaces.search_label": "Rechercher des espaces de travail",
  "backoffice.workspaces.search_placeholder": "Rechercher par nom ou identifiant",
  "backoffice.workspaces.search_clear": "Effacer la recherche",
  "backoffice.workspaces.filter_type": "Type",
  "backoffice.workspaces.filter_status": "Statut",
  "backoffice.workspaces.all_types": "Tous les types",
  "backoffice.workspaces.all_statuses": "Tous les statuts",
  "backoffice.workspaces.status_active": "Actif",
  "backoffice.workspaces.status_inactive": "Inactif",
  "backoffice.workspaces.status_suspended": "Suspendu",
  "backoffice.workspaces.status_archived": "Archivé",
  "backoffice.workspaces.col_name": "Nom",
  "backoffice.workspaces.col_slug": "Identifiant",
  "backoffice.workspaces.col_type": "Type",
  "backoffice.workspaces.col_status": "Statut",
  "backoffice.workspaces.all_owners": "Tous les propriétaires",
  "backoffice.workspaces.owner_missing": "Aucun propriétaire actif",
  "backoffice.workspaces.filter_owner": "Propriétaire",
  "backoffice.owner.no_active_owner": "Aucun propriétaire actif",
  "backoffice.owner.below_admin_tier": "Sous le niveau Admin",
  "backoffice.owner.section": "Propriétaire",
  "backoffice.owner.section_body":
    "La personne qui possède cet espace de travail. Un espace de travail a un seul propriétaire, et peut n'en avoir aucun.",
  "backoffice.owner.name": "Nom",
  "backoffice.owner.role": "Rôle",
  "backoffice.owner.role_and_tier": "{role} ({tier})",
  "backoffice.owner.not_a_member": "N'est pas membre de cet espace de travail",
  "backoffice.owner.membership": "Adhésion",
  "backoffice.owner.membership_active": "Active",
  "backoffice.owner.membership_inactive": "Désactivée",
  "backoffice.owner.account": "Compte",
  "backoffice.owner.account_active": "Actif",
  "backoffice.owner.account_inactive": "Désactivé",
  "backoffice.owner.manage": "Gérer le propriétaire",
  "backoffice.owner.dialog_title": "Gérer le propriétaire de {name}",
  "backoffice.owner.current": "Propriétaire actuel : {name} ({email})",
  "backoffice.owner.current_none": "Cet espace de travail n'a pas de propriétaire.",
  "backoffice.owner.action_label": "Action à effectuer",
  "backoffice.owner.action_change": "Changer de propriétaire",
  "backoffice.owner.action_remove": "Retirer comme propriétaire",
  "backoffice.owner.action_deactivate": "Désactiver le propriétaire",
  "backoffice.owner.change_hint":
    "Choisissez un membre actif. Une personne sous le niveau Admin est déplacée vers le rôle indiqué afin de pouvoir posséder l'espace de travail.",
  "backoffice.owner.remove_hint":
    "Elle reste membre avec son rôle. Nommez un nouveau propriétaire, ou laissez l'espace de travail sans propriétaire.",
  "backoffice.owner.deactivate_hint":
    "Elle cesse d'être propriétaire et son adhésion à cet espace de travail est désactivée. Nommez un nouveau propriétaire, ou laissez l'espace de travail sans propriétaire.",
  "backoffice.owner.change_confirm": "Changer de propriétaire",
  "backoffice.owner.remove_confirm": "Retirer le propriétaire",
  "backoffice.owner.deactivate_confirm": "Désactiver le propriétaire",
  "backoffice.owner.search_label": "Trouver un membre",
  "backoffice.owner.search_placeholder": "Nom ou courriel",
  "backoffice.owner.candidates_label": "Membres",
  "backoffice.owner.candidates_error": "Impossible de charger les membres.",
  "backoffice.owner.no_candidates": "Aucun membre actif ne correspond.",
  "backoffice.owner.no_replacement": "Laisser l'espace de travail sans propriétaire",
  "backoffice.owner.candidate_role": "Rôle : {role}",
  "backoffice.owner.admin_move_notice": "Sera déplacé vers {role} pour devenir propriétaire",
  "backoffice.owner.unavailable":
    "Les changements de propriétaire ne sont pas activés pour cet espace de travail.",
  "backoffice.owner.blocked_with": "{message} Encore en cause : {names}.",
  "backoffice.feature_off.title": "Cette fonctionnalité n'est pas encore disponible",
  "backoffice.feature_off.body":
    "Elle est désactivée pour vous. Demandez à un Super Admin si vous en avez besoin.",
  "backoffice.search.placeholder_accounts":
    "Rechercher des comptes, des espaces de travail et des utilisateurs",
  "backoffice.search.accounts": "Comptes",
  "backoffice.search.accounts_empty": "Aucun compte ne correspond",
  "backoffice.search.view_all_accounts": "Voir tous les comptes correspondants",
  "backoffice.workspaces.all_accounts": "Tous les comptes",
  "backoffice.workspaces.col_account": "Compte",
  "backoffice.workspaces.filter_account": "Compte",
  "backoffice.workspaces.selected_account": "Compte sélectionné",
  "backoffice.workspaces.unassigned": "Non attribué",
  "backoffice.accounts.title": "Comptes",
  "backoffice.accounts.subtitle":
    "Chaque client, ses espaces de travail et les places qu'il utilise.",
  "backoffice.accounts.new": "Nouveau compte",
  "backoffice.accounts.provision": "Provisionner un espace de travail",
  "backoffice.accounts.unassigned": "Espaces de travail non attribués ({count})",
  "backoffice.accounts.search_label": "Rechercher des comptes",
  "backoffice.accounts.search_placeholder": "Rechercher par nom de compte",
  "backoffice.accounts.filter_health": "État des places",
  "backoffice.accounts.filter_health_all": "Tous les états",
  "backoffice.accounts.filter_health_under": "Sous-utilisé (moins de 60 %)",
  "backoffice.accounts.filter_health_over": "Sur-utilisé (plus de 100 %)",
  "backoffice.accounts.col_account": "Compte",
  "backoffice.accounts.col_cs_owner": "Succès client",
  "backoffice.accounts.col_workspaces": "Espaces de travail",
  "backoffice.accounts.col_seats": "Places utilisées",
  "backoffice.accounts.col_contract_end": "Fin du contrat",
  "backoffice.accounts.col_status": "Statut",
  "backoffice.accounts.col_workspace": "Espace de travail",
  "backoffice.accounts.col_seats_short": "Places",
  "backoffice.accounts.col_actions": "Actions",
  "backoffice.accounts.no_active_owner_count": "Sans propriétaire actif : {count}",
  "backoffice.accounts.no_active_owner": "Aucun propriétaire actif",
  "backoffice.accounts.below_admin_tier": "Sous le niveau Admin",
  "backoffice.accounts.empty_title": "Aucun compte trouvé",
  "backoffice.accounts.empty_body": "Essayez une autre recherche ou effacez les filtres.",
  "backoffice.accounts.error": "Impossible de charger les comptes.",
  "backoffice.accounts.total": "{count, plural, one {# compte} other {# comptes}}",
  "backoffice.accounts.workspace_count":
    "{count, plural, one {# espace de travail} other {# espaces de travail}}",
  "backoffice.accounts.seats_of": "{used} / {allocated}",
  "backoffice.accounts.seats_used_only": "{used} utilisées",
  "backoffice.accounts.percent": "{percent} %",
  "backoffice.accounts.health_over": "Dépassé",
  "backoffice.accounts.health_under": "Sous-utilisé",
  "backoffice.accounts.health_not_set": "Aucune allocation",
  "backoffice.accounts.health_not_counted": "Non comptés : aucun espace de production",
  "backoffice.accounts.seats_bar": "{used} places sur {allocated} utilisées, {percent} %",
  "backoffice.accounts.seats_bar_no_allocation":
    "{used} places utilisées, aucune allocation définie",
  "backoffice.accounts.back": "Retour aux comptes",
  "backoffice.accounts.edit": "Modifier le compte",
  "backoffice.accounts.edit_title": "Modifier le compte",
  "backoffice.accounts.edit_confirm": "Enregistrer les modifications",
  "backoffice.accounts.new_title": "Nouveau compte",
  "backoffice.accounts.new_confirm": "Créer le compte",
  "backoffice.accounts.form_name": "Nom du compte",
  "backoffice.accounts.form_cs_owner": "Succès client",
  "backoffice.accounts.form_account_manager": "Gestionnaire de compte",
  "backoffice.accounts.form_no_staff": "Personne",
  "backoffice.accounts.form_contract_start": "Début du contrat",
  "backoffice.accounts.form_contract_end": "Fin du contrat",
  "backoffice.accounts.form_dates_invalid":
    "Le contrat ne peut pas se terminer avant de commencer.",
  "backoffice.accounts.form_seats": "Places allouées",
  "backoffice.accounts.form_notes": "Notes",
  "backoffice.accounts.profile": "Profil du compte",
  "backoffice.accounts.region": "Région",
  "backoffice.accounts.contract": "Contrat",
  "backoffice.accounts.contract_range": "Du {start} au {end}",
  "backoffice.accounts.salesforce": "Salesforce",
  "backoffice.accounts.salesforce_connected": "Connecté",
  "backoffice.accounts.salesforce_not_connected": "Non connecté",
  "backoffice.accounts.seats": "Places",
  "backoffice.accounts.seats_scope": "Comptées dans les espaces de production seulement",
  "backoffice.accounts.seats_used_label": "places utilisées",
  "backoffice.accounts.seats_explainer":
    "Une place correspond à une personne ayant une licence Admin ou Standard dans un espace de production. Une personne présente dans deux espaces de production compte une fois. Les invités, le personnel de Cognota et les utilisateurs désactivés ne comptent jamais. Les places ne sont pas imposées : un compte peut les dépasser.",
  "backoffice.accounts.by_licence": "Utilisateurs par type de licence",
  "backoffice.accounts.licence_type": "Type de licence",
  "backoffice.accounts.users": "Utilisateurs",
  "backoffice.accounts.seat": "Place",
  "backoffice.accounts.licence_admin": "Admin",
  "backoffice.accounts.licence_standard": "Standard",
  "backoffice.accounts.licence_guest": "Invité",
  "backoffice.accounts.licence_cognota_staff": "Personnel de Cognota",
  "backoffice.accounts.licence_deactivated": "Désactivés",
  "backoffice.accounts.seat_counts": "Compte",
  "backoffice.accounts.seat_not_counted": "Ne compte pas",
  "backoffice.accounts.by_workspace": "Places par espace de travail",
  "backoffice.accounts.counted_once": "Dans plus d'un espace de production, compté une fois",
  "backoffice.accounts.unique_seats": "Places uniques",
  "backoffice.accounts.workspaces": "Espaces de travail",
  "backoffice.accounts.no_workspaces_title": "Aucun espace de travail pour l'instant",
  "backoffice.accounts.no_workspaces_body":
    "Ajoutez-en un existant, ou provisionnez-en un nouveau.",
  "backoffice.accounts.add_workspace": "Ajouter un espace de travail",
  "backoffice.accounts.not_found_title": "Compte introuvable",
  "backoffice.accounts.not_found_body": "Il a peut-être été supprimé, ou le lien est incorrect.",
  "backoffice.accounts.move": "Déplacer",
  "backoffice.accounts.attach": "Rattacher",
  "backoffice.accounts.move_aria": "Déplacer {name} vers un autre compte",
  "backoffice.accounts.move_title": "Déplacer {name} vers un compte",
  "backoffice.accounts.move_body":
    "Les places de l'espace de travail comptent désormais pour le nouveau compte.",
  "backoffice.accounts.move_confirm": "Déplacer l'espace de travail",
  "backoffice.accounts.move_search": "Trouver un compte",
  "backoffice.accounts.move_pick": "Compte",
  "backoffice.accounts.move_pick_placeholder": "Choisir un compte",
  "backoffice.accounts.move_none": "Aucun compte ne correspond",
  "backoffice.accounts.move_error": "Impossible de charger les comptes",
  "backoffice.accounts.add_none": "Aucun espace de travail ne correspond",
  "backoffice.accounts.add_error": "Impossible de charger les espaces de travail",
  "backoffice.accounts.add_title": "Ajouter un espace de travail à {name}",
  "backoffice.accounts.add_body":
    "Déplacez ici un espace de travail existant. Pour en créer un nouveau, utilisez Provisionner un espace de travail.",
  "backoffice.accounts.add_confirm": "Ajouter l'espace de travail",
  "backoffice.accounts.add_search": "Trouver un espace de travail",
  "backoffice.accounts.add_pick": "Espace de travail",
  "backoffice.accounts.add_pick_placeholder": "Choisir un espace de travail",
  "backoffice.accounts.add_option": "{name} ({slug})",
  "backoffice.accounts.add_option_in": "{name} ({slug}), actuellement dans {account}",
  "backoffice.workspaces.col_owner": "Propriétaire",
  "backoffice.workspaces.col_created": "Créé le",
  "backoffice.workspaces.empty_title": "Aucun espace de travail",
  "backoffice.workspaces.empty_body": "Aucun espace de travail ne correspond à ces filtres.",
  "backoffice.workspaces.error": "Impossible de charger les espaces de travail.",
  "backoffice.workspaces.retry": "Réessayer",
  "backoffice.workspaces.total": "{count} espaces de travail",
  "backoffice.table.loading": "Chargement",
  "backoffice.table.retry": "Réessayer",
  "backoffice.table.empty_title": "Rien à afficher",
  "backoffice.table.previous": "Précédent",
  "backoffice.table.next": "Suivant",
  "backoffice.table.expand": "Afficher les détails",
  "backoffice.table.collapse": "Masquer les détails",
  "backoffice.table.sort_by": "Trier par {column}",
  "backoffice.workspaces.previous": "Précédent",
  "backoffice.workspaces.next": "Suivant",
  "backoffice.workspaces.back": "Retour aux espaces de travail",
  "backoffice.workspaces.not_found_title": "Espace de travail introuvable",
  "backoffice.workspaces.not_found_body": "Aucun espace de travail n'a l'identifiant « {slug} ».",
  "backoffice.workspace.owner": "Propriétaire",
  "backoffice.workspace.no_owner": "Aucun propriétaire",
  "backoffice.workspace.created": "Créé le",
  "backoffice.workspace.type_section": "Type d’espace de travail",
  "backoffice.workspace.type_body":
    "Le type définit le badge affiché dans l’application et détermine si cet espace compte dans les places du compte. Seul Client : Production compte et n’affiche aucun badge.",
  "backoffice.workspace.type_picker_label": "Type d'espace de travail",
  "backoffice.workspace.type_change": "Changer le type",
  "backoffice.workspace.type_read_only":
    "Seul un super administrateur peut changer le type d'un espace de travail.",
  "backoffice.workspace.type_dialog_title": "Changer le type d'espace de travail",
  "backoffice.workspace.type_dialog_summary": "{name} passera de {from} à {to}.",
  "backoffice.workspace.type_dialog_confirm": "Changer le type",
  "backoffice.workspace.type_demo_warning":
    "Un espace de travail Démo (ventes) peut être réinitialisé. Un responsable des ventes qui l'administre pourra le réinitialiser, ce qui efface ses données.",
  "backoffice.workspace.type_unavailable": "Le changement de type n'est pas encore disponible",
  "backoffice.workspace.email_section": "E-mail",
  "backoffice.workspace.email_description":
    "Tant que cette option est activée, aucun e-mail de notification n'est envoyé aux membres de cet espace de travail : affectations, mentions, changements de statut, rappels, résumés et rapports planifiés. Ceux-ci sont toujours envoyés : invitations (y compris un transfert), réinitialisations de mot de passe et confirmations de changement d'adresse e-mail. Les notifications dans l'application s'affichent toujours, et les notifications Microsoft Teams sont toujours envoyées. Les e-mails supprimés sont abandonnés, pas mis en file d'attente : la désactivation n'envoie donc aucun arriéré.",
  "backoffice.workspace.email_switch_label": "Supprimer les e-mails de notification",
  "backoffice.workspace.email_state_on": "Supprimés",
  "backoffice.workspace.email_state_off": "Envoyés",
  "backoffice.workspace.email_read_only":
    "Seuls les rôles CS/AM et Super Admin peuvent modifier ce paramètre.",
  "backoffice.workspace.email_dialog_title_on": "Supprimer les e-mails de notification ?",
  "backoffice.workspace.email_dialog_title_off": "Réactiver les e-mails de notification ?",
  "backoffice.workspace.email_dialog_body_on":
    "Aucun e-mail de notification ne sera envoyé aux membres de cet espace de travail tant que vous ne le désactivez pas. Les e-mails de compte, les notifications dans l'application et les notifications Microsoft Teams ne sont pas touchés, et les administrateurs de l'espace voient une bannière indiquant que les e-mails sont désactivés.",
  "backoffice.workspace.email_dialog_body_off":
    "Les membres reçoivent de nouveau les e-mails de notification à partir de maintenant. Rien de ce qui a été supprimé n'est envoyé plus tard : c'était abandonné.",
  "backoffice.workspace.email_dialog_summary": "E-mails de notification de {name}.",
  "backoffice.workspace.email_dialog_confirm_on": "Supprimer les e-mails",
  "backoffice.workspace.email_dialog_confirm_off": "Réactiver les e-mails",
  "backoffice.workspace.email_unavailable":
    "La suppression des e-mails n'est pas encore disponible",
  "backoffice.workspace.ai_section": "Fonctionnalités d'IA",
  "backoffice.workspace.ai_master_label": "Toutes les fonctionnalités d'IA",
  "backoffice.workspace.ai_master_on":
    "Activé. Choisissez les fonctionnalités d'IA que cet espace de travail peut utiliser.",
  "backoffice.workspace.ai_master_off":
    "Désactivé. Toutes les fonctionnalités d'IA sont désactivées pour tout le monde dans cet espace de travail.",
  "backoffice.workspace.ai_feature_reporting": "Coéquipier numérique pour les rapports",
  "backoffice.workspace.ai_feature_reporting_description":
    "Répond aux questions sur les données de l'espace de travail, et crée des rapports et des tableaux de bord sur demande.",
  "backoffice.workspace.ai_read_only":
    "Seuls le CS/AM et le Super Admin peuvent modifier ces paramètres.",
  "backoffice.workspace.ai_save": "Enregistrer les modifications",
  "backoffice.workspace.ai_status_saved": "Aucune modification non enregistrée",
  "backoffice.workspace.ai_status_unsaved": "Modifications non enregistrées",
  "backoffice.workspace.ai_status_needs_reason": "Ajoutez un motif pour enregistrer",
  "backoffice.workspace.ai_unavailable":
    "La modification des fonctionnalités d'IA n'est pas encore disponible",
  "backoffice.workspace.ai_provider_section": "Fournisseur d'IA",
  "backoffice.workspace.ai_provider_future": "Configuration à venir",
  "backoffice.workspace.ai_provider_managed": "Géré par Cognota",
  "backoffice.workspace.ai_provider_managed_description": "Cognota héberge et paie le modèle d'IA.",
  "backoffice.workspace.ai_provider_own": "Fournisseur du client",
  "backoffice.workspace.ai_provider_own_description":
    "Les fonctionnalités d’IA utilisent les identifiants d’IA du client.",
  "backoffice.staff.permissions.user_invite": "Renvoyer une invitation et copier son lien",
  "backoffice.staff.permissions.user_manage":
    "Vérifier un courriel, désactiver et réactiver un utilisateur",
  "backoffice.audit.target.workspace_invitation": "Invitation",
  "backoffice.audit.target.user": "Utilisateur",
  "backoffice.audit.action.workspace.user_invite_resent": "Invitation d'utilisateur renvoyée",
  "backoffice.audit.action.workspace.user_invite_link_viewed":
    "Lien d'invitation d'utilisateur consulté",
  "backoffice.audit.action.workspace.user_email_verified":
    "Courriel d'utilisateur marqué comme vérifié",
  "backoffice.audit.action.workspace.user_email_change_requested": "Changement de courriel demandé",
  "backoffice.audit.action.workspace.user_email_changed": "Courriel de l'utilisateur modifié",
  "backoffice.audit.action.workspace.user_deactivated": "Utilisateur désactivé",
  "backoffice.audit.action.workspace.user_reactivated": "Utilisateur réactivé",
  "backoffice.teams.new_team": "Nouvelle équipe",
  "backoffice.teams.create_title": "Nouvelle équipe",
  "backoffice.teams.create_description":
    "Crée l’équipe dans cet espace de travail. Ses responsables sont les personnes qui la gèrent. Consigné dans le journal d’audit.",
  "backoffice.teams.create_confirm": "Créer l’équipe",
  "backoffice.teams.add_lead": "Ajouter un responsable",
  "backoffice.teams.remove_lead": "Retirer {name} comme responsable",
  "backoffice.teams.chosen_leads": "Responsables choisis",
  "backoffice.teams.lead_required": "Une équipe doit avoir au moins un responsable.",
  "backoffice.teams.person_search": "Rechercher par nom ou courriel",
  "backoffice.teams.person_none": "Aucun autre membre actif ne correspond.",
  "backoffice.teams.person_error": "Impossible de charger les personnes de cet espace de travail.",
  "backoffice.teams.pick": "Ajouter",
  "backoffice.teams.pick_person": "Ajouter {name}",
  "backoffice.teams.save": "Enregistrer les modifications",
  "backoffice.teams.save_title": "Enregistrer les modifications de {name}",
  "backoffice.teams.save_confirm": "Enregistrer",
  "backoffice.teams.members_add": "Ajouter des membres",
  "backoffice.teams.add_title": "Ajouter des membres à {name}",
  "backoffice.teams.add_confirm": "Ajouter les membres",
  "backoffice.teams.chosen_members": "Personnes à ajouter",
  "backoffice.teams.unchoose": "Ne pas ajouter {name}",
  "backoffice.teams.remove_member": "Retirer",
  "backoffice.teams.remove_member_aria": "Retirer {name} de l’équipe",
  "backoffice.teams.remove_title": "Retirer {name} de {team}",
  "backoffice.teams.remove_confirm": "Retirer",
  "backoffice.teams.move_member": "Déplacer",
  "backoffice.teams.move_member_aria": "Déplacer {name} vers une autre équipe",
  "backoffice.teams.move_title": "Déplacer {name} hors de {team}",
  "backoffice.teams.move_description":
    "La personne garde son rôle dans la nouvelle équipe. Le seul responsable d’une équipe ne peut pas être déplacé.",
  "backoffice.teams.move_target": "Déplacer vers",
  "backoffice.teams.pick_team": "Choisir une équipe",
  "backoffice.teams.move_confirm": "Déplacer",
  "backoffice.teams.read_only": "Le soutien peut consulter les équipes, mais pas les modifier.",
  "backoffice.staff.permissions.teams_manage":
    "Créer et modifier des équipes, et ajouter, retirer et déplacer leurs membres",
  "backoffice.audit.target.team": "Équipe",
  "backoffice.audit.action.workspace.team_created": "Équipe créée",
  "backoffice.audit.action.workspace.team_updated": "Équipe modifiée",
  "backoffice.audit.action.workspace.team_member_added": "Membres ajoutés à l’équipe",
  "backoffice.audit.action.workspace.team_member_removed": "Membre retiré de l’équipe",
  "backoffice.audit.action.workspace.team_member_moved": "Membre déplacé vers une autre équipe",
  "backoffice.audit.action.workspace.user_name_changed": "Nom de l’utilisateur modifié",
  "backoffice.audit.action.workspace.user_role_changed": "Rôle système de l’utilisateur modifié",
  "backoffice.audit.action.workspace.user_teams_changed": "Équipes de l’utilisateur modifiées",
  "backoffice.audit.action.workspace.setup_user_created": "Utilisateur ajouté sans invitation",
  "backoffice.audit.action.workspace.setup_user_password_set": "Mot de passe temporaire défini",
  "backoffice.audit.action.workspace.setup_user_handed_over": "Utilisateur remis",
  "backoffice.workspace.users_section": "Utilisateurs",
  "backoffice.workspace.users_body":
    "Qui fait partie de cet espace de travail, leurs licences et leurs invitations en attente.",
  "backoffice.workspace.users_link": "Ouvrir l'écran Utilisateurs",
  "backoffice.users.back": "Retour à {slug}",
  "backoffice.users.title": "Utilisateurs de {slug}",
  "backoffice.users.tab_users": "Utilisateurs",
  "backoffice.users.tab_invites": "Invitations en attente",
  "backoffice.users.search_label": "Rechercher des utilisateurs",
  "backoffice.users.search_placeholder": "Rechercher par nom ou courriel",
  "backoffice.users.search_clear": "Effacer la recherche",
  "backoffice.users.filter_licence": "Licence",
  "backoffice.users.filter_status": "Statut",
  "backoffice.users.all_licences": "Toutes les licences",
  "backoffice.users.all_statuses": "Tous les statuts",
  "backoffice.users.licence.admin": "Administrateur",
  "backoffice.users.licence.standard": "Standard",
  "backoffice.users.licence.guest": "Invité",
  "backoffice.users.status.active": "Actif",
  "backoffice.users.status.deactivated": "Désactivé",
  "backoffice.users.status.invited": "Invité",
  "backoffice.users.status.set_up": "Configuré par Cognota",
  "backoffice.users.status_note_setup":
    "Configuré par Cognota : ajouté sans invitation ; le personnel peut se connecter à sa place avec un mot de passe temporaire jusqu'à la remise. Invité : remis, et n'a pas encore défini de mot de passe. Les personnes invitées de la façon habituelle qui n'ont pas rejoint sont sous Invitations en attente.",
  "backoffice.users.action.add": "Ajouter un utilisateur (sans invitation)",
  "backoffice.users.action.temp_password": "Définir un mot de passe temporaire",
  "backoffice.users.action.temp_password_for": "Définir un mot de passe temporaire pour {email}",
  "backoffice.users.action.hand_over": "Remettre",
  "backoffice.users.action.hand_over_for": "Remettre {email}",
  "backoffice.users.action.hand_over_all": "Tout remettre",
  "backoffice.users.add.title": "Ajouter un utilisateur sans invitation",
  "backoffice.users.add.description":
    "Crée le compte et l'ajoute à cet espace de travail. Aucun courriel n'est envoyé. Il apparaît comme Configuré par Cognota jusqu'à la remise. Le courriel ne doit pas déjà avoir un compte Cognota.",
  "backoffice.users.add.email": "Courriel",
  "backoffice.users.add.first_name": "Prénom",
  "backoffice.users.add.last_name": "Nom",
  "backoffice.users.add.role": "Rôle système",
  "backoffice.users.add.roles_error": "Les rôles n'ont pas pu être chargés.",
  "backoffice.users.add.role_loading": "Chargement des rôles",
  "backoffice.users.add.password": "Mot de passe temporaire (facultatif)",
  "backoffice.users.add.password_hint":
    "Le personnel peut se connecter à sa place avec ce mot de passe jusqu'à la remise. Il doit respecter les règles de mot de passe de l'espace de travail. Il n'est plus jamais affiché.",
  "backoffice.users.add.confirm": "Ajouter l'utilisateur",
  "backoffice.users.action.invite": "Ajouter un utilisateur",
  "backoffice.users.action.import": "Importer un CSV",
  "backoffice.users.invite.title": "Ajouter un utilisateur",
  "backoffice.users.invite.description":
    "Lui envoie une invitation à rejoindre cet espace de travail avec le rôle et les équipes ci-dessous. Il n'en est membre qu'une fois l'invitation acceptée.",
  "backoffice.users.invite.email": "Courriel",
  "backoffice.users.invite.role": "Rôle système",
  "backoffice.users.invite.teams": "Équipes (facultatif)",
  "backoffice.users.invite.add_team": "Ajouter à une équipe",
  "backoffice.users.invite.remove_team": "Retirer {team}",
  "backoffice.users.invite.confirm": "Envoyer l'invitation",
  "backoffice.users.invite.sent": "Invitation envoyée à {email}.",
  "backoffice.users.invite.refreshed":
    "{email} avait déjà une invitation en attente. Son expiration est relancée et aucun nouveau courriel n'a été envoyé : utilisez Renvoyer l'invitation pour l'envoyer de nouveau.",
  "backoffice.users.import.title": "Importer des utilisateurs depuis un CSV",
  "backoffice.users.import.notice_title": "Ce que fait cet import",
  "backoffice.users.import.notice_create":
    "Une ligne dont le courriel n'a aucun compte Cognota crée ce compte et ajoute la personne à cet espace de travail comme Configurée par Cognota.",
  "backoffice.users.import.notice_existing":
    "Une ligne dont le courriel a déjà un compte l'ajoute seulement à cet espace de travail, ou met à jour son nom et son rôle. Personne qui a déjà un compte ne reçoit de courriel.",
  "backoffice.users.import.notice_refused":
    "Une ligne pour une personne désactivée, le dernier administrateur de l'espace de travail ou son propriétaire (qui doit rester au niveau Administrateur) est refusée, et la ligne en donne la raison. Une cellule vide conserve ce que la personne a déjà.",
  "backoffice.users.import.notice_columns":
    "La capacité et le rôle de poste ne sont pas importés depuis le Backoffice : ces colonnes sont ignorées, avec un avertissement sur la ligne.",
  "backoffice.users.import.notice_mode":
    "À la dernière étape, vous choisissez d'inviter les nouvelles personnes maintenant ou de les laisser configurées par Cognota.",
  "backoffice.users.import.mode_label": "Nouvelles personnes",
  "backoffice.users.import.mode_without": "Configurées par Cognota, sans invitation",
  "backoffice.users.import.mode_without_hint":
    "Aucun courriel n'est envoyé. Elles apparaissent comme Configurées par Cognota jusqu'à la remise.",
  "backoffice.users.import.mode_with": "Configurées, avec l'invitation envoyée maintenant",
  "backoffice.users.import.mode_with_hint":
    "Chaque nouvelle personne est remise aussitôt et reçoit par courriel l'invitation pour choisir son mot de passe, même si les courriels de cet espace de travail sont supprimés.",
  "backoffice.users.import.result_title": "Import terminé",
  "backoffice.users.import.result_set_up":
    "{count, plural, one {# nouvelle personne est configurée par Cognota.} other {# nouvelles personnes sont configurées par Cognota.}}",
  "backoffice.users.import.result_invited":
    "{count, plural, one {# nouvelle personne a été invitée.} other {# nouvelles personnes ont été invitées.}}",
  "backoffice.users.temp.title": "Définir un mot de passe temporaire pour {email}",
  "backoffice.users.temp.description":
    "Remplace tout mot de passe temporaire précédent. Il doit respecter les règles de mot de passe, et cesse de fonctionner à la remise.",
  "backoffice.users.temp.field": "Mot de passe temporaire",
  "backoffice.users.temp.confirm": "Définir le mot de passe",
  "backoffice.users.hand_over.title": "Remettre {email}",
  "backoffice.users.hand_over.description":
    "Son mot de passe temporaire cesse de fonctionner et son invitation lui est envoyée ; elle lui permet de choisir le sien, même si les courriels de cet espace de travail sont supprimés. Il apparaît comme Invité jusqu'à ce qu'il le fasse.",
  "backoffice.users.hand_over.confirm": "Remettre",
  "backoffice.users.hand_over_all.title": "Remettre tous les utilisateurs configurés par Cognota",
  "backoffice.users.hand_over_all.description":
    "Chaque utilisateur de cet espace de travail configuré par Cognota perd son mot de passe temporaire et reçoit son invitation pour choisir le sien, même si les courriels de cet espace de travail sont supprimés.",
  "backoffice.users.hand_over_all.confirm": "Tout remettre",
  "backoffice.workspace.setup_warning":
    "Les notifications par courriel sont activées, mais {count} utilisateur(s) de cet espace de travail sont encore configurés par Cognota et n'ont pas été remis.",
  "backoffice.workspace.setup_warning_link": "Les consulter dans l'écran Utilisateurs",
  "backoffice.workspaces.setup_warning_badge": "Utilisateurs encore configurés",
  "backoffice.users.status_note":
    "« Configuré par Cognota » n'est pas encore affiché : il dépend de données qui n'existent pas encore. Les personnes invitées qui n'ont pas rejoint sont sous Invitations en attente.",
  "backoffice.users.col.name": "Nom",
  "backoffice.users.col.email": "Courriel",
  "backoffice.users.col.licence": "Licence",
  "backoffice.users.col.system_role": "Rôle système",
  "backoffice.users.col.teams": "Équipes",
  "backoffice.users.col.status": "Statut",
  "backoffice.users.col.seat": "Siège",
  "backoffice.users.col.last_login": "Dernière connexion",
  "backoffice.users.col.invited": "Invité le",
  "backoffice.users.col.expires": "Expire le",
  "backoffice.users.col.actions": "Actions",
  "backoffice.users.owner": "Propriétaire",
  "backoffice.users.yes": "Oui",
  "backoffice.users.no": "Non",
  "backoffice.users.never_signed_in": "Jamais",
  "backoffice.users.never_expires": "Jamais",
  "backoffice.users.total": "{count} utilisateurs",
  "backoffice.users.invites_total": "{count} invitations en attente",
  "backoffice.users.error": "Les utilisateurs n'ont pas pu être chargés.",
  "backoffice.users.empty_title": "Aucun utilisateur trouvé",
  "backoffice.users.empty_body":
    "Aucun utilisateur de cet espace de travail ne correspond à ces filtres.",
  "backoffice.users.read_only":
    "Le soutien peut renvoyer une invitation et copier son lien. Vérifier un courriel, désactiver et réactiver relèvent de CS/AM et des Super Admin.",
  "backoffice.users.invites_search_label": "Rechercher des invitations",
  "backoffice.users.invites_search_placeholder": "Rechercher par courriel",
  "backoffice.users.invites_error": "Les invitations en attente n'ont pas pu être chargées.",
  "backoffice.users.invites_empty_title": "Aucune invitation en attente",
  "backoffice.users.invites_empty_body":
    "Toutes les personnes invitées à cet espace de travail l'ont rejoint.",
  "backoffice.users.action.verify": "Vérifier le courriel",
  "backoffice.users.action.verify_for": "Vérifier le courriel de {email}",
  "backoffice.users.action.deactivate": "Désactiver",
  "backoffice.users.action.deactivate_for": "Désactiver {email}",
  "backoffice.users.action.reactivate": "Réactiver",
  "backoffice.users.action.reactivate_for": "Réactiver {email}",
  "backoffice.users.action.resend": "Renvoyer l'invitation",
  "backoffice.users.action.resend_for": "Renvoyer l'invitation à {email}",
  "backoffice.users.action.link": "Copier le lien d'invitation",
  "backoffice.users.action.link_for": "Copier le lien d'invitation de {email}",
  "backoffice.users.verify.title": "Marquer {email} comme vérifié",
  "backoffice.users.verify.description":
    "L'adresse sera marquée comme vérifiée sur son compte, où qu'il se connecte.",
  "backoffice.users.verify.confirm": "Marquer comme vérifié",
  "backoffice.users.deactivate.title": "Désactiver {email}",
  "backoffice.users.deactivate.owner_description":
    "Cette personne est propriétaire de l'espace de travail. La désactiver libère son poste et laisse l'espace sans propriétaire ; il est signalé tant que vous n'en ajoutez pas un. Elle ne pourra plus se connecter à cet espace.",
  "backoffice.users.deactivate.description":
    "Il perd l'accès à cet espace de travail et son siège est libéré. Il reste dans la liste et peut être réactivé.",
  "backoffice.users.deactivate.confirm": "Désactiver",
  "backoffice.users.reactivate.title": "Réactiver {email}",
  "backoffice.users.reactivate.description": "Il retrouve son accès et occupe de nouveau un siège.",
  "backoffice.users.reactivate.confirm": "Réactiver",
  "backoffice.users.resend.title": "Renvoyer l'invitation à {email}",
  "backoffice.users.resend.description":
    "Envoie de nouveau le courriel d'invitation et relance son expiration.",
  "backoffice.users.resend.confirm": "Renvoyer l'invitation",
  "backoffice.users.link.title": "Copier le lien d'invitation de {email}",
  "backoffice.users.link.description":
    "L'affichage du lien est consigné dans le journal d'audit : un motif est requis.",
  "backoffice.users.link.confirm": "Afficher le lien",
  "backoffice.users.link.result_title": "Lien d'invitation de {email}",
  "backoffice.users.link.result_body":
    "Envoyez ce lien à la personne invitée. Elle doit se connecter avec l'adresse invitée.",
  "backoffice.users.link.field_label": "Lien d'invitation",
  "backoffice.users.link.copy": "Copier le lien",
  "backoffice.users.link.copied": "Copié",
  "backoffice.users.link.copy_failed":
    "Le lien n'a pas pu être copié. Sélectionnez-le et copiez-le à la main.",
  "backoffice.users.link.done": "Terminé",
  "support_access.tag": "Soutien Cognota",
  "support_access.level_read_only": "lecture seule",
  "support_access.level_admin": "administrateur",
  "support_access.banner_title":
    "Vous avez un accès temporaire ({level}) à {workspace} en tant que Soutien Cognota.",
  "support_access.banner_description": "Se termine à {time} (encore {remaining}). Motif : {reason}",
  "support_access.remaining_hours": "{hours} h {minutes} min",
  "support_access.remaining_minutes": "{minutes} min",
  "support_access.remaining_seconds": "{seconds} s",
  "support_access.leave": "Quitter l'espace de travail",
  "support_access.leave_failed": "Impossible de quitter l'espace de travail. Réessayez.",
  "support_access.entering": "Ouverture de l'espace de travail…",
  "support_access.enter_failed":
    "Ce lien a expiré. Entrez de nouveau dans l'espace de travail depuis le Backoffice.",
  "support_access.ended_title": "Accès terminé",
  "support_access.ended_body":
    "Votre accès temporaire à cet espace de travail est terminé. Pour continuer, demandez de nouveau l'accès depuis le Backoffice.",
};

export default fr;
